var D2 = Object.defineProperty;
var R2 = (n, e, t) => e in n ? D2(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Tx = (n, e, t) => R2(n, typeof e != "symbol" ? e + "" : e, t);
import { Group as je, ActionIcon as hi, UnstyledButton as Lc, Text as ae, Button as hn, Input as fc, Box as gt, Stack as at, Container as uy, Paper as er, ThemeIcon as d1, Title as Ya, Collapse as k2, Tooltip as ss, Code as M2, LoadingOverlay as Wf, Avatar as dy, Table as Je, Select as fy, Pagination as _2, Modal as f1, Checkbox as Yl, Badge as on, Anchor as Cx, Alert as Us, createTheme as O2, MantineProvider as I2, mergeThemeOverrides as N2, Menu as Tt, Flex as Um, ScrollArea as Bc, NumberInput as h1, Textarea as P2, Divider as L2, rem as zn, ColorSwatch as B2, SimpleGrid as j2 } from "@mantine/core";
export * from "@mantine/core";
import { Button as $Q } from "@mantine/core";
export * from "@mantine/dates";
import { MonthPickerInput as qQ, TimeInput as KQ } from "@mantine/dates";
export * from "@mantine/form";
import { useDisclosure as p1 } from "@mantine/hooks";
export * from "@mantine/hooks";
import { openConfirmModal as F2, ModalsProvider as z2, modals as Ep } from "@mantine/modals";
export * from "@mantine/modals";
import { notifications as Dl, Notifications as V2 } from "@mantine/notifications";
export * from "@mantine/notifications";
import { RichTextEditor as Pt } from "@mantine/tiptap";
export * from "@mantine/tiptap";
import Fe, { Component as hy, createRef as H2, PureComponent as W2, forwardRef as hs, createElement as $m, useRef as vt, useEffect as St, useState as wt, createContext as ps, useLayoutEffect as py, useContext as In, useId as U2, useCallback as fn, useMemo as Vt, Fragment as m1, useInsertionEffect as g1, useImperativeHandle as $2, useDebugValue as y1, memo as jc } from "react";
import { createPageViewParams as my, createClientAnalyticsEvent as G2, sanitizeClientScreen as Y2, useAuth as q2, parseJwt as K2, uploadFile as J2, mapClientError as Q2, logClientWarning as Z2, getJobPositions as X2, queryKeys as eB, findAllWorkShifts as tB } from "@dutyon/apis";
import { useLocation as nB, Outlet as v1, Navigate as rB, useRouteError as iB, useNavigate as sB } from "react-router-dom";
import oB, { flushSync as Dx, createPortal as b1 } from "react-dom";
import { QueryClient as aB, QueryClientProvider as lB, useQuery as x1 } from "@tanstack/react-query";
var Ra = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function S1(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Gm = { exports: {} }, Rl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rx;
function cB() {
  if (Rx) return Rl;
  Rx = 1;
  var n = Fe, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, c, u) {
    var f, h = {}, p = null, g = null;
    u !== void 0 && (p = "" + u), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (g = c.ref);
    for (f in c) r.call(c, f) && !s.hasOwnProperty(f) && (h[f] = c[f]);
    if (a && a.defaultProps) for (f in c = a.defaultProps, c) h[f] === void 0 && (h[f] = c[f]);
    return { $$typeof: e, type: a, key: p, ref: g, props: h, _owner: i.current };
  }
  return Rl.Fragment = t, Rl.jsx = o, Rl.jsxs = o, Rl;
}
var kl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kx;
function uB() {
  return kx || (kx = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Fe, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), y = Symbol.iterator, x = "@@iterator";
    function S(O) {
      if (O === null || typeof O != "object")
        return null;
      var se = y && O[y] || O[x];
      return typeof se == "function" ? se : null;
    }
    var w = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(O) {
      {
        for (var se = arguments.length, be = new Array(se > 1 ? se - 1 : 0), Oe = 1; Oe < se; Oe++)
          be[Oe - 1] = arguments[Oe];
        T("error", O, be);
      }
    }
    function T(O, se, be) {
      {
        var Oe = w.ReactDebugCurrentFrame, rt = Oe.getStackAddendum();
        rt !== "" && (se += "%s", be = be.concat([rt]));
        var st = be.map(function(We) {
          return String(We);
        });
        st.unshift("Warning: " + se), Function.prototype.apply.call(console[O], console, st);
      }
    }
    var k = !1, R = !1, P = !1, L = !1, B = !1, W;
    W = Symbol.for("react.module.reference");
    function X(O) {
      return !!(typeof O == "string" || typeof O == "function" || O === r || O === s || B || O === i || O === u || O === f || L || O === g || k || R || P || typeof O == "object" && O !== null && (O.$$typeof === p || O.$$typeof === h || O.$$typeof === o || O.$$typeof === a || O.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      O.$$typeof === W || O.getModuleId !== void 0));
    }
    function ce(O, se, be) {
      var Oe = O.displayName;
      if (Oe)
        return Oe;
      var rt = se.displayName || se.name || "";
      return rt !== "" ? be + "(" + rt + ")" : be;
    }
    function Re(O) {
      return O.displayName || "Context";
    }
    function ke(O) {
      if (O == null)
        return null;
      if (typeof O.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof O == "function")
        return O.displayName || O.name || null;
      if (typeof O == "string")
        return O;
      switch (O) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof O == "object")
        switch (O.$$typeof) {
          case a:
            var se = O;
            return Re(se) + ".Consumer";
          case o:
            var be = O;
            return Re(be._context) + ".Provider";
          case c:
            return ce(O, O.render, "ForwardRef");
          case h:
            var Oe = O.displayName || null;
            return Oe !== null ? Oe : ke(O.type) || "Memo";
          case p: {
            var rt = O, st = rt._payload, We = rt._init;
            try {
              return ke(We(st));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var J = Object.assign, re = 0, G, $, K, Se, z, Q, ge;
    function me() {
    }
    me.__reactDisabledLog = !0;
    function V() {
      {
        if (re === 0) {
          G = console.log, $ = console.info, K = console.warn, Se = console.error, z = console.group, Q = console.groupCollapsed, ge = console.groupEnd;
          var O = {
            configurable: !0,
            enumerable: !0,
            value: me,
            writable: !0
          };
          Object.defineProperties(console, {
            info: O,
            log: O,
            warn: O,
            error: O,
            group: O,
            groupCollapsed: O,
            groupEnd: O
          });
        }
        re++;
      }
    }
    function ie() {
      {
        if (re--, re === 0) {
          var O = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: J({}, O, {
              value: G
            }),
            info: J({}, O, {
              value: $
            }),
            warn: J({}, O, {
              value: K
            }),
            error: J({}, O, {
              value: Se
            }),
            group: J({}, O, {
              value: z
            }),
            groupCollapsed: J({}, O, {
              value: Q
            }),
            groupEnd: J({}, O, {
              value: ge
            })
          });
        }
        re < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = w.ReactCurrentDispatcher, de;
    function ee(O, se, be) {
      {
        if (de === void 0)
          try {
            throw Error();
          } catch (rt) {
            var Oe = rt.stack.trim().match(/\n( *(at )?)/);
            de = Oe && Oe[1] || "";
          }
        return `
` + de + O;
      }
    }
    var he = !1, pe;
    {
      var Ee = typeof WeakMap == "function" ? WeakMap : Map;
      pe = new Ee();
    }
    function ue(O, se) {
      if (!O || he)
        return "";
      {
        var be = pe.get(O);
        if (be !== void 0)
          return be;
      }
      var Oe;
      he = !0;
      var rt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var st;
      st = q.current, q.current = null, V();
      try {
        if (se) {
          var We = function() {
            throw Error();
          };
          if (Object.defineProperty(We.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(We, []);
            } catch (It) {
              Oe = It;
            }
            Reflect.construct(O, [], We);
          } else {
            try {
              We.call();
            } catch (It) {
              Oe = It;
            }
            O.call(We.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (It) {
            Oe = It;
          }
          O();
        }
      } catch (It) {
        if (It && Oe && typeof It.stack == "string") {
          for (var Be = It.stack.split(`
`), tn = Oe.stack.split(`
`), Et = Be.length - 1, Ot = tn.length - 1; Et >= 1 && Ot >= 0 && Be[Et] !== tn[Ot]; )
            Ot--;
          for (; Et >= 1 && Ot >= 0; Et--, Ot--)
            if (Be[Et] !== tn[Ot]) {
              if (Et !== 1 || Ot !== 1)
                do
                  if (Et--, Ot--, Ot < 0 || Be[Et] !== tn[Ot]) {
                    var Tn = `
` + Be[Et].replace(" at new ", " at ");
                    return O.displayName && Tn.includes("<anonymous>") && (Tn = Tn.replace("<anonymous>", O.displayName)), typeof O == "function" && pe.set(O, Tn), Tn;
                  }
                while (Et >= 1 && Ot >= 0);
              break;
            }
        }
      } finally {
        he = !1, q.current = st, ie(), Error.prepareStackTrace = rt;
      }
      var ar = O ? O.displayName || O.name : "", br = ar ? ee(ar) : "";
      return typeof O == "function" && pe.set(O, br), br;
    }
    function et(O, se, be) {
      return ue(O, !1);
    }
    function mt(O) {
      var se = O.prototype;
      return !!(se && se.isReactComponent);
    }
    function Kt(O, se, be) {
      if (O == null)
        return "";
      if (typeof O == "function")
        return ue(O, mt(O));
      if (typeof O == "string")
        return ee(O);
      switch (O) {
        case u:
          return ee("Suspense");
        case f:
          return ee("SuspenseList");
      }
      if (typeof O == "object")
        switch (O.$$typeof) {
          case c:
            return et(O.render);
          case h:
            return Kt(O.type, se, be);
          case p: {
            var Oe = O, rt = Oe._payload, st = Oe._init;
            try {
              return Kt(st(rt), se, be);
            } catch {
            }
          }
        }
      return "";
    }
    var Wt = Object.prototype.hasOwnProperty, en = {}, $n = w.ReactDebugCurrentFrame;
    function _r(O) {
      if (O) {
        var se = O._owner, be = Kt(O.type, O._source, se ? se.type : null);
        $n.setExtraStackFrame(be);
      } else
        $n.setExtraStackFrame(null);
    }
    function ir(O, se, be, Oe, rt) {
      {
        var st = Function.call.bind(Wt);
        for (var We in O)
          if (st(O, We)) {
            var Be = void 0;
            try {
              if (typeof O[We] != "function") {
                var tn = Error((Oe || "React class") + ": " + be + " type `" + We + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof O[We] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw tn.name = "Invariant Violation", tn;
              }
              Be = O[We](se, We, Oe, be, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Et) {
              Be = Et;
            }
            Be && !(Be instanceof Error) && (_r(rt), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Oe || "React class", be, We, typeof Be), _r(null)), Be instanceof Error && !(Be.message in en) && (en[Be.message] = !0, _r(rt), C("Failed %s type: %s", be, Be.message), _r(null));
          }
      }
    }
    var Jt = Array.isArray;
    function Pn(O) {
      return Jt(O);
    }
    function sr(O) {
      {
        var se = typeof Symbol == "function" && Symbol.toStringTag, be = se && O[Symbol.toStringTag] || O.constructor.name || "Object";
        return be;
      }
    }
    function Ge(O) {
      try {
        return lt(O), !1;
      } catch {
        return !0;
      }
    }
    function lt(O) {
      return "" + O;
    }
    function vr(O) {
      if (Ge(O))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", sr(O)), lt(O);
    }
    var _t = w.ReactCurrentOwner, An = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Gn, cn;
    function ei(O) {
      if (Wt.call(O, "ref")) {
        var se = Object.getOwnPropertyDescriptor(O, "ref").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return O.ref !== void 0;
    }
    function or(O) {
      if (Wt.call(O, "key")) {
        var se = Object.getOwnPropertyDescriptor(O, "key").get;
        if (se && se.isReactWarning)
          return !1;
      }
      return O.key !== void 0;
    }
    function Or(O, se) {
      typeof O.ref == "string" && _t.current;
    }
    function ti(O, se) {
      {
        var be = function() {
          Gn || (Gn = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        be.isReactWarning = !0, Object.defineProperty(O, "key", {
          get: be,
          configurable: !0
        });
      }
    }
    function gs(O, se) {
      {
        var be = function() {
          cn || (cn = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", se));
        };
        be.isReactWarning = !0, Object.defineProperty(O, "ref", {
          get: be,
          configurable: !0
        });
      }
    }
    var gi = function(O, se, be, Oe, rt, st, We) {
      var Be = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: O,
        key: se,
        ref: be,
        props: We,
        // Record the component responsible for creating this element.
        _owner: st
      };
      return Be._store = {}, Object.defineProperty(Be._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Be, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Oe
      }), Object.defineProperty(Be, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: rt
      }), Object.freeze && (Object.freeze(Be.props), Object.freeze(Be)), Be;
    };
    function yi(O, se, be, Oe, rt) {
      {
        var st, We = {}, Be = null, tn = null;
        be !== void 0 && (vr(be), Be = "" + be), or(se) && (vr(se.key), Be = "" + se.key), ei(se) && (tn = se.ref, Or(se, rt));
        for (st in se)
          Wt.call(se, st) && !An.hasOwnProperty(st) && (We[st] = se[st]);
        if (O && O.defaultProps) {
          var Et = O.defaultProps;
          for (st in Et)
            We[st] === void 0 && (We[st] = Et[st]);
        }
        if (Be || tn) {
          var Ot = typeof O == "function" ? O.displayName || O.name || "Unknown" : O;
          Be && ti(We, Ot), tn && gs(We, Ot);
        }
        return gi(O, Be, tn, rt, Oe, _t.current, We);
      }
    }
    var Ln = w.ReactCurrentOwner, ni = w.ReactDebugCurrentFrame;
    function Ir(O) {
      if (O) {
        var se = O._owner, be = Kt(O.type, O._source, se ? se.type : null);
        ni.setExtraStackFrame(be);
      } else
        ni.setExtraStackFrame(null);
    }
    var vi;
    vi = !1;
    function ys(O) {
      return typeof O == "object" && O !== null && O.$$typeof === e;
    }
    function vs() {
      {
        if (Ln.current) {
          var O = ke(Ln.current.type);
          if (O)
            return `

Check the render method of \`` + O + "`.";
        }
        return "";
      }
    }
    function ao(O) {
      return "";
    }
    var ta = {};
    function Bi(O) {
      {
        var se = vs();
        if (!se) {
          var be = typeof O == "string" ? O : O.displayName || O.name;
          be && (se = `

Check the top-level render call using <` + be + ">.");
        }
        return se;
      }
    }
    function lo(O, se) {
      {
        if (!O._store || O._store.validated || O.key != null)
          return;
        O._store.validated = !0;
        var be = Bi(se);
        if (ta[be])
          return;
        ta[be] = !0;
        var Oe = "";
        O && O._owner && O._owner !== Ln.current && (Oe = " It was passed a child from " + ke(O._owner.type) + "."), Ir(O), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', be, Oe), Ir(null);
      }
    }
    function na(O, se) {
      {
        if (typeof O != "object")
          return;
        if (Pn(O))
          for (var be = 0; be < O.length; be++) {
            var Oe = O[be];
            ys(Oe) && lo(Oe, se);
          }
        else if (ys(O))
          O._store && (O._store.validated = !0);
        else if (O) {
          var rt = S(O);
          if (typeof rt == "function" && rt !== O.entries)
            for (var st = rt.call(O), We; !(We = st.next()).done; )
              ys(We.value) && lo(We.value, se);
        }
      }
    }
    function Bt(O) {
      {
        var se = O.type;
        if (se == null || typeof se == "string")
          return;
        var be;
        if (typeof se == "function")
          be = se.propTypes;
        else if (typeof se == "object" && (se.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        se.$$typeof === h))
          be = se.propTypes;
        else
          return;
        if (be) {
          var Oe = ke(se);
          ir(be, O.props, "prop", Oe, O);
        } else if (se.PropTypes !== void 0 && !vi) {
          vi = !0;
          var rt = ke(se);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", rt || "Unknown");
        }
        typeof se.getDefaultProps == "function" && !se.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function bi(O) {
      {
        for (var se = Object.keys(O.props), be = 0; be < se.length; be++) {
          var Oe = se[be];
          if (Oe !== "children" && Oe !== "key") {
            Ir(O), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Oe), Ir(null);
            break;
          }
        }
        O.ref !== null && (Ir(O), C("Invalid attribute `ref` supplied to `React.Fragment`."), Ir(null));
      }
    }
    var bs = {};
    function co(O, se, be, Oe, rt, st) {
      {
        var We = X(O);
        if (!We) {
          var Be = "";
          (O === void 0 || typeof O == "object" && O !== null && Object.keys(O).length === 0) && (Be += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var tn = ao();
          tn ? Be += tn : Be += vs();
          var Et;
          O === null ? Et = "null" : Pn(O) ? Et = "array" : O !== void 0 && O.$$typeof === e ? (Et = "<" + (ke(O.type) || "Unknown") + " />", Be = " Did you accidentally export a JSX literal instead of a component?") : Et = typeof O, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Et, Be);
        }
        var Ot = yi(O, se, be, rt, st);
        if (Ot == null)
          return Ot;
        if (We) {
          var Tn = se.children;
          if (Tn !== void 0)
            if (Oe)
              if (Pn(Tn)) {
                for (var ar = 0; ar < Tn.length; ar++)
                  na(Tn[ar], O);
                Object.freeze && Object.freeze(Tn);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              na(Tn, O);
        }
        if (Wt.call(se, "key")) {
          var br = ke(O), It = Object.keys(se).filter(function(ne) {
            return ne !== "key";
          }), Ce = It.length > 0 ? "{key: someKey, " + It.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bs[br + Ce]) {
            var _ = It.length > 0 ? "{" + It.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ce, br, _, br), bs[br + Ce] = !0;
          }
        }
        return O === r ? bi(Ot) : Bt(Ot), Ot;
      }
    }
    function ji(O, se, be) {
      return co(O, se, be, !0);
    }
    function ra(O, se, be) {
      return co(O, se, be, !1);
    }
    var ia = ra, ul = ji;
    kl.Fragment = r, kl.jsx = ia, kl.jsxs = ul;
  }()), kl;
}
process.env.NODE_ENV === "production" ? Gm.exports = cB() : Gm.exports = uB();
var b = Gm.exports, dB = {
  code: "ko",
  buttonText: {
    prev: "이전달",
    next: "다음달",
    today: "오늘",
    year: "년도",
    month: "월",
    week: "주",
    day: "일",
    list: "일정목록"
  },
  weekText: "주",
  allDayText: "종일",
  moreLinkText: "개",
  noEventsText: "일정이 없습니다"
}, Uf, _e, w1, E1, qa, Do, Mx, A1, T1, Rd = {}, C1 = [], fB = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Bs(n, e) {
  for (var t in e) n[t] = e[t];
  return n;
}
function D1(n) {
  var e = n.parentNode;
  e && e.removeChild(n);
}
function I(n, e, t) {
  var r, i, s, o = {};
  for (s in e) s == "key" ? r = e[s] : s == "ref" ? i = e[s] : o[s] = e[s];
  if (arguments.length > 2 && (o.children = arguments.length > 3 ? Uf.call(arguments, 2) : t), typeof n == "function" && n.defaultProps != null) for (s in n.defaultProps) o[s] === void 0 && (o[s] = n.defaultProps[s]);
  return fd(n, o, r, i, null);
}
function fd(n, e, t, r, i) {
  var s = { type: n, props: e, key: t, ref: r, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: i ?? ++w1 };
  return i == null && _e.vnode != null && _e.vnode(s), s;
}
function Xn() {
  return { current: null };
}
function Ct(n) {
  return n.children;
}
function hB(n, e, t, r, i) {
  var s;
  for (s in t) s === "children" || s === "key" || s in e || kd(n, s, null, t[s], r);
  for (s in e) i && typeof e[s] != "function" || s === "children" || s === "key" || s === "value" || s === "checked" || t[s] === e[s] || kd(n, s, e[s], t[s], r);
}
function _x(n, e, t) {
  e[0] === "-" ? n.setProperty(e, t ?? "") : n[e] = t == null ? "" : typeof t != "number" || fB.test(e) ? t : t + "px";
}
function kd(n, e, t, r, i) {
  var s;
  e: if (e === "style") if (typeof t == "string") n.style.cssText = t;
  else {
    if (typeof r == "string" && (n.style.cssText = r = ""), r) for (e in r) t && e in t || _x(n.style, e, "");
    if (t) for (e in t) r && t[e] === r[e] || _x(n.style, e, t[e]);
  }
  else if (e[0] === "o" && e[1] === "n") s = e !== (e = e.replace(/Capture$/, "")), e = e.toLowerCase() in n ? e.toLowerCase().slice(2) : e.slice(2), n.l || (n.l = {}), n.l[e + s] = t, t ? r || n.addEventListener(e, s ? Ix : Ox, s) : n.removeEventListener(e, s ? Ix : Ox, s);
  else if (e !== "dangerouslySetInnerHTML") {
    if (i) e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (e !== "width" && e !== "height" && e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e in n) try {
      n[e] = t ?? "";
      break e;
    } catch {
    }
    typeof t == "function" || (t == null || t === !1 && e.indexOf("-") == -1 ? n.removeAttribute(e) : n.setAttribute(e, t));
  }
}
function Ox(n) {
  qa = !0;
  try {
    return this.l[n.type + !1](_e.event ? _e.event(n) : n);
  } finally {
    qa = !1;
  }
}
function Ix(n) {
  qa = !0;
  try {
    return this.l[n.type + !0](_e.event ? _e.event(n) : n);
  } finally {
    qa = !1;
  }
}
function Rr(n, e) {
  this.props = n, this.context = e;
}
function hc(n, e) {
  if (e == null) return n.__ ? hc(n.__, n.__.__k.indexOf(n) + 1) : null;
  for (var t; e < n.__k.length; e++) if ((t = n.__k[e]) != null && t.__e != null) return t.__e;
  return typeof n.type == "function" ? hc(n) : null;
}
function R1(n) {
  var e, t;
  if ((n = n.__) != null && n.__c != null) {
    for (n.__e = n.__c.base = null, e = 0; e < n.__k.length; e++) if ((t = n.__k[e]) != null && t.__e != null) {
      n.__e = n.__c.base = t.__e;
      break;
    }
    return R1(n);
  }
}
function pB(n) {
  qa ? setTimeout(n) : A1(n);
}
function Ym(n) {
  (!n.__d && (n.__d = !0) && Do.push(n) && !Md.__r++ || Mx !== _e.debounceRendering) && ((Mx = _e.debounceRendering) || pB)(Md);
}
function Md() {
  var n, e, t, r, i, s, o, a;
  for (Do.sort(function(c, u) {
    return c.__v.__b - u.__v.__b;
  }); n = Do.shift(); ) n.__d && (e = Do.length, r = void 0, i = void 0, o = (s = (t = n).__v).__e, (a = t.__P) && (r = [], (i = Bs({}, s)).__v = s.__v + 1, gy(a, s, i, t.__n, a.ownerSVGElement !== void 0, s.__h != null ? [o] : null, r, o ?? hc(s), s.__h), I1(r, s), s.__e != o && R1(s)), Do.length > e && Do.sort(function(c, u) {
    return c.__v.__b - u.__v.__b;
  }));
  Md.__r = 0;
}
function k1(n, e, t, r, i, s, o, a, c, u) {
  var f, h, p, g, y, x, S, w = r && r.__k || C1, C = w.length;
  for (t.__k = [], f = 0; f < e.length; f++) if ((g = t.__k[f] = (g = e[f]) == null || typeof g == "boolean" ? null : typeof g == "string" || typeof g == "number" || typeof g == "bigint" ? fd(null, g, null, null, g) : Array.isArray(g) ? fd(Ct, { children: g }, null, null, null) : g.__b > 0 ? fd(g.type, g.props, g.key, g.ref ? g.ref : null, g.__v) : g) != null) {
    if (g.__ = t, g.__b = t.__b + 1, (p = w[f]) === null || p && g.key == p.key && g.type === p.type) w[f] = void 0;
    else for (h = 0; h < C; h++) {
      if ((p = w[h]) && g.key == p.key && g.type === p.type) {
        w[h] = void 0;
        break;
      }
      p = null;
    }
    gy(n, g, p = p || Rd, i, s, o, a, c, u), y = g.__e, (h = g.ref) && p.ref != h && (S || (S = []), p.ref && S.push(p.ref, null, g), S.push(h, g.__c || y, g)), y != null ? (x == null && (x = y), typeof g.type == "function" && g.__k === p.__k ? g.__d = c = M1(g, c, n) : c = _1(n, g, p, w, y, c), typeof t.type == "function" && (t.__d = c)) : c && p.__e == c && c.parentNode != n && (c = hc(p));
  }
  for (t.__e = x, f = C; f--; ) w[f] != null && (typeof t.type == "function" && w[f].__e != null && w[f].__e == t.__d && (t.__d = O1(r).nextSibling), P1(w[f], w[f]));
  if (S) for (f = 0; f < S.length; f++) N1(S[f], S[++f], S[++f]);
}
function M1(n, e, t) {
  for (var r, i = n.__k, s = 0; i && s < i.length; s++) (r = i[s]) && (r.__ = n, e = typeof r.type == "function" ? M1(r, e, t) : _1(t, r, r, i, r.__e, e));
  return e;
}
function _d(n, e) {
  return e = e || [], n == null || typeof n == "boolean" || (Array.isArray(n) ? n.some(function(t) {
    _d(t, e);
  }) : e.push(n)), e;
}
function _1(n, e, t, r, i, s) {
  var o, a, c;
  if (e.__d !== void 0) o = e.__d, e.__d = void 0;
  else if (t == null || i != s || i.parentNode == null) e: if (s == null || s.parentNode !== n) n.appendChild(i), o = null;
  else {
    for (a = s, c = 0; (a = a.nextSibling) && c < r.length; c += 1) if (a == i) break e;
    n.insertBefore(i, s), o = s;
  }
  return o !== void 0 ? o : i.nextSibling;
}
function O1(n) {
  var e, t, r;
  if (n.type == null || typeof n.type == "string") return n.__e;
  if (n.__k) {
    for (e = n.__k.length - 1; e >= 0; e--) if ((t = n.__k[e]) && (r = O1(t))) return r;
  }
  return null;
}
function gy(n, e, t, r, i, s, o, a, c) {
  var u, f, h, p, g, y, x, S, w, C, T, k, R, P, L, B = e.type;
  if (e.constructor !== void 0) return null;
  t.__h != null && (c = t.__h, a = e.__e = t.__e, e.__h = null, s = [a]), (u = _e.__b) && u(e);
  try {
    e: if (typeof B == "function") {
      if (S = e.props, w = (u = B.contextType) && r[u.__c], C = u ? w ? w.props.value : u.__ : r, t.__c ? x = (f = e.__c = t.__c).__ = f.__E : ("prototype" in B && B.prototype.render ? e.__c = f = new B(S, C) : (e.__c = f = new Rr(S, C), f.constructor = B, f.render = gB), w && w.sub(f), f.props = S, f.state || (f.state = {}), f.context = C, f.__n = r, h = f.__d = !0, f.__h = [], f._sb = []), f.__s == null && (f.__s = f.state), B.getDerivedStateFromProps != null && (f.__s == f.state && (f.__s = Bs({}, f.__s)), Bs(f.__s, B.getDerivedStateFromProps(S, f.__s))), p = f.props, g = f.state, f.__v = e, h) B.getDerivedStateFromProps == null && f.componentWillMount != null && f.componentWillMount(), f.componentDidMount != null && f.__h.push(f.componentDidMount);
      else {
        if (B.getDerivedStateFromProps == null && S !== p && f.componentWillReceiveProps != null && f.componentWillReceiveProps(S, C), !f.__e && f.shouldComponentUpdate != null && f.shouldComponentUpdate(S, f.__s, C) === !1 || e.__v === t.__v) {
          for (e.__v !== t.__v && (f.props = S, f.state = f.__s, f.__d = !1), e.__e = t.__e, e.__k = t.__k, e.__k.forEach(function(W) {
            W && (W.__ = e);
          }), T = 0; T < f._sb.length; T++) f.__h.push(f._sb[T]);
          f._sb = [], f.__h.length && o.push(f);
          break e;
        }
        f.componentWillUpdate != null && f.componentWillUpdate(S, f.__s, C), f.componentDidUpdate != null && f.__h.push(function() {
          f.componentDidUpdate(p, g, y);
        });
      }
      if (f.context = C, f.props = S, f.__P = n, k = _e.__r, R = 0, "prototype" in B && B.prototype.render) {
        for (f.state = f.__s, f.__d = !1, k && k(e), u = f.render(f.props, f.state, f.context), P = 0; P < f._sb.length; P++) f.__h.push(f._sb[P]);
        f._sb = [];
      } else do
        f.__d = !1, k && k(e), u = f.render(f.props, f.state, f.context), f.state = f.__s;
      while (f.__d && ++R < 25);
      f.state = f.__s, f.getChildContext != null && (r = Bs(Bs({}, r), f.getChildContext())), h || f.getSnapshotBeforeUpdate == null || (y = f.getSnapshotBeforeUpdate(p, g)), L = u != null && u.type === Ct && u.key == null ? u.props.children : u, k1(n, Array.isArray(L) ? L : [L], e, t, r, i, s, o, a, c), f.base = e.__e, e.__h = null, f.__h.length && o.push(f), x && (f.__E = f.__ = null), f.__e = !1;
    } else s == null && e.__v === t.__v ? (e.__k = t.__k, e.__e = t.__e) : e.__e = mB(t.__e, e, t, r, i, s, o, c);
    (u = _e.diffed) && u(e);
  } catch (W) {
    e.__v = null, (c || s != null) && (e.__e = a, e.__h = !!c, s[s.indexOf(a)] = null), _e.__e(W, e, t);
  }
}
function I1(n, e) {
  _e.__c && _e.__c(e, n), n.some(function(t) {
    try {
      n = t.__h, t.__h = [], n.some(function(r) {
        r.call(t);
      });
    } catch (r) {
      _e.__e(r, t.__v);
    }
  });
}
function mB(n, e, t, r, i, s, o, a) {
  var c, u, f, h = t.props, p = e.props, g = e.type, y = 0;
  if (g === "svg" && (i = !0), s != null) {
    for (; y < s.length; y++) if ((c = s[y]) && "setAttribute" in c == !!g && (g ? c.localName === g : c.nodeType === 3)) {
      n = c, s[y] = null;
      break;
    }
  }
  if (n == null) {
    if (g === null) return document.createTextNode(p);
    n = i ? document.createElementNS("http://www.w3.org/2000/svg", g) : document.createElement(g, p.is && p), s = null, a = !1;
  }
  if (g === null) h === p || a && n.data === p || (n.data = p);
  else {
    if (s = s && Uf.call(n.childNodes), u = (h = t.props || Rd).dangerouslySetInnerHTML, f = p.dangerouslySetInnerHTML, !a) {
      if (s != null) for (h = {}, y = 0; y < n.attributes.length; y++) h[n.attributes[y].name] = n.attributes[y].value;
      (f || u) && (f && (u && f.__html == u.__html || f.__html === n.innerHTML) || (n.innerHTML = f && f.__html || ""));
    }
    if (hB(n, p, h, i, a), f) e.__k = [];
    else if (y = e.props.children, k1(n, Array.isArray(y) ? y : [y], e, t, r, i && g !== "foreignObject", s, o, s ? s[0] : t.__k && hc(t, 0), a), s != null) for (y = s.length; y--; ) s[y] != null && D1(s[y]);
    a || ("value" in p && (y = p.value) !== void 0 && (y !== n.value || g === "progress" && !y || g === "option" && y !== h.value) && kd(n, "value", y, h.value, !1), "checked" in p && (y = p.checked) !== void 0 && y !== n.checked && kd(n, "checked", y, h.checked, !1));
  }
  return n;
}
function N1(n, e, t) {
  try {
    typeof n == "function" ? n(e) : n.current = e;
  } catch (r) {
    _e.__e(r, t);
  }
}
function P1(n, e, t) {
  var r, i;
  if (_e.unmount && _e.unmount(n), (r = n.ref) && (r.current && r.current !== n.__e || N1(r, null, e)), (r = n.__c) != null) {
    if (r.componentWillUnmount) try {
      r.componentWillUnmount();
    } catch (s) {
      _e.__e(s, e);
    }
    r.base = r.__P = null, n.__c = void 0;
  }
  if (r = n.__k) for (i = 0; i < r.length; i++) r[i] && P1(r[i], e, t || typeof n.type != "function");
  t || n.__e == null || D1(n.__e), n.__ = n.__e = n.__d = void 0;
}
function gB(n, e, t) {
  return this.constructor(n, t);
}
function pc(n, e, t) {
  var r, i, s;
  _e.__ && _e.__(n, e), i = (r = !1) ? null : e.__k, s = [], gy(e, n = e.__k = I(Ct, null, [n]), i || Rd, Rd, e.ownerSVGElement !== void 0, i ? null : e.firstChild ? Uf.call(e.childNodes) : null, s, i ? i.__e : e.firstChild, r), I1(s, n);
}
function yB(n, e) {
  var t = { __c: e = "__cC" + T1++, __: n, Consumer: function(r, i) {
    return r.children(i);
  }, Provider: function(r) {
    var i, s;
    return this.getChildContext || (i = [], (s = {})[e] = this, this.getChildContext = function() {
      return s;
    }, this.shouldComponentUpdate = function(o) {
      this.props.value !== o.value && i.some(function(a) {
        a.__e = !0, Ym(a);
      });
    }, this.sub = function(o) {
      i.push(o);
      var a = o.componentWillUnmount;
      o.componentWillUnmount = function() {
        i.splice(i.indexOf(o), 1), a && a.call(o);
      };
    }), r.children;
  } };
  return t.Provider.__ = t.Consumer.contextType = t;
}
Uf = C1.slice, _e = { __e: function(n, e, t, r) {
  for (var i, s, o; e = e.__; ) if ((i = e.__c) && !i.__) try {
    if ((s = i.constructor) && s.getDerivedStateFromError != null && (i.setState(s.getDerivedStateFromError(n)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(n, r || {}), o = i.__d), o) return i.__E = i;
  } catch (a) {
    n = a;
  }
  throw n;
} }, w1 = 0, E1 = function(n) {
  return n != null && n.constructor === void 0;
}, qa = !1, Rr.prototype.setState = function(n, e) {
  var t;
  t = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Bs({}, this.state), typeof n == "function" && (n = n(Bs({}, t), this.props)), n && Bs(t, n), n != null && this.__v && (e && this._sb.push(e), Ym(this));
}, Rr.prototype.forceUpdate = function(n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), Ym(this));
}, Rr.prototype.render = Ct, Do = [], A1 = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Md.__r = 0, T1 = 0;
var Di, Ap, Nx, L1 = [], Tp = [], Px = _e.__b, Lx = _e.__r, Bx = _e.diffed, jx = _e.__c, Fx = _e.unmount;
function vB() {
  for (var n; n = L1.shift(); ) if (n.__P && n.__H) try {
    n.__H.__h.forEach(hd), n.__H.__h.forEach(qm), n.__H.__h = [];
  } catch (e) {
    n.__H.__h = [], _e.__e(e, n.__v);
  }
}
_e.__b = function(n) {
  Di = null, Px && Px(n);
}, _e.__r = function(n) {
  Lx && Lx(n);
  var e = (Di = n.__c).__H;
  e && (Ap === Di ? (e.__h = [], Di.__h = [], e.__.forEach(function(t) {
    t.__N && (t.__ = t.__N), t.__V = Tp, t.__N = t.i = void 0;
  })) : (e.__h.forEach(hd), e.__h.forEach(qm), e.__h = [])), Ap = Di;
}, _e.diffed = function(n) {
  Bx && Bx(n);
  var e = n.__c;
  e && e.__H && (e.__H.__h.length && (L1.push(e) !== 1 && Nx === _e.requestAnimationFrame || ((Nx = _e.requestAnimationFrame) || bB)(vB)), e.__H.__.forEach(function(t) {
    t.i && (t.__H = t.i), t.__V !== Tp && (t.__ = t.__V), t.i = void 0, t.__V = Tp;
  })), Ap = Di = null;
}, _e.__c = function(n, e) {
  e.some(function(t) {
    try {
      t.__h.forEach(hd), t.__h = t.__h.filter(function(r) {
        return !r.__ || qm(r);
      });
    } catch (r) {
      e.some(function(i) {
        i.__h && (i.__h = []);
      }), e = [], _e.__e(r, t.__v);
    }
  }), jx && jx(n, e);
}, _e.unmount = function(n) {
  Fx && Fx(n);
  var e, t = n.__c;
  t && t.__H && (t.__H.__.forEach(function(r) {
    try {
      hd(r);
    } catch (i) {
      e = i;
    }
  }), t.__H = void 0, e && _e.__e(e, t.__v));
};
var zx = typeof requestAnimationFrame == "function";
function bB(n) {
  var e, t = function() {
    clearTimeout(r), zx && cancelAnimationFrame(e), setTimeout(n);
  }, r = setTimeout(t, 100);
  zx && (e = requestAnimationFrame(t));
}
function hd(n) {
  var e = Di, t = n.__c;
  typeof t == "function" && (n.__c = void 0, t()), Di = e;
}
function qm(n) {
  var e = Di;
  n.__c = n.__(), Di = e;
}
function xB(n, e) {
  for (var t in e) n[t] = e[t];
  return n;
}
function Vx(n, e) {
  for (var t in n) if (t !== "__source" && !(t in e)) return !0;
  for (var r in e) if (r !== "__source" && n[r] !== e[r]) return !0;
  return !1;
}
function Hx(n) {
  this.props = n;
}
(Hx.prototype = new Rr()).isPureReactComponent = !0, Hx.prototype.shouldComponentUpdate = function(n, e) {
  return Vx(this.props, n) || Vx(this.state, e);
};
var Wx = _e.__b;
_e.__b = function(n) {
  n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), Wx && Wx(n);
};
var SB = _e.__e;
_e.__e = function(n, e, t, r) {
  if (n.then) {
    for (var i, s = e; s = s.__; ) if ((i = s.__c) && i.__c) return e.__e == null && (e.__e = t.__e, e.__k = t.__k), i.__c(n, e);
  }
  SB(n, e, t, r);
};
var Ux = _e.unmount;
function B1(n, e, t) {
  return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(r) {
    typeof r.__c == "function" && r.__c();
  }), n.__c.__H = null), (n = xB({}, n)).__c != null && (n.__c.__P === t && (n.__c.__P = e), n.__c = null), n.__k = n.__k && n.__k.map(function(r) {
    return B1(r, e, t);
  })), n;
}
function j1(n, e, t) {
  return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(r) {
    return j1(r, e, t);
  }), n.__c && n.__c.__P === e && (n.__e && t.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = t)), n;
}
function Cp() {
  this.__u = 0, this.t = null, this.__b = null;
}
function F1(n) {
  var e = n.__.__c;
  return e && e.__a && e.__a(n);
}
function Lu() {
  this.u = null, this.o = null;
}
_e.unmount = function(n) {
  var e = n.__c;
  e && e.__R && e.__R(), e && n.__h === !0 && (n.type = null), Ux && Ux(n);
}, (Cp.prototype = new Rr()).__c = function(n, e) {
  var t = e.__c, r = this;
  r.t == null && (r.t = []), r.t.push(t);
  var i = F1(r.__v), s = !1, o = function() {
    s || (s = !0, t.__R = null, i ? i(a) : a());
  };
  t.__R = o;
  var a = function() {
    if (!--r.__u) {
      if (r.state.__a) {
        var u = r.state.__a;
        r.__v.__k[0] = j1(u, u.__c.__P, u.__c.__O);
      }
      var f;
      for (r.setState({ __a: r.__b = null }); f = r.t.pop(); ) f.forceUpdate();
    }
  }, c = e.__h === !0;
  r.__u++ || c || r.setState({ __a: r.__b = r.__v.__k[0] }), n.then(o, o);
}, Cp.prototype.componentWillUnmount = function() {
  this.t = [];
}, Cp.prototype.render = function(n, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var t = document.createElement("div"), r = this.__v.__k[0].__c;
      this.__v.__k[0] = B1(this.__b, t, r.__O = r.__P);
    }
    this.__b = null;
  }
  var i = e.__a && I(Ct, null, n.fallback);
  return i && (i.__h = null), [I(Ct, null, e.__a ? null : n.children), i];
};
var $x = function(n, e, t) {
  if (++t[1] === t[0] && n.o.delete(e), n.props.revealOrder && (n.props.revealOrder[0] !== "t" || !n.o.size)) for (t = n.u; t; ) {
    for (; t.length > 3; ) t.pop()();
    if (t[1] < t[0]) break;
    n.u = t = t[2];
  }
};
function wB(n) {
  return this.getChildContext = function() {
    return n.context;
  }, n.children;
}
function EB(n) {
  var e = this, t = n.i;
  e.componentWillUnmount = function() {
    pc(null, e.l), e.l = null, e.i = null;
  }, e.i && e.i !== t && e.componentWillUnmount(), n.__v ? (e.l || (e.i = t, e.l = { nodeType: 1, parentNode: t, childNodes: [], appendChild: function(r) {
    this.childNodes.push(r), e.i.appendChild(r);
  }, insertBefore: function(r, i) {
    this.childNodes.push(r), e.i.appendChild(r);
  }, removeChild: function(r) {
    this.childNodes.splice(this.childNodes.indexOf(r) >>> 1, 1), e.i.removeChild(r);
  } }), pc(I(wB, { context: e.context }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function AB(n, e) {
  var t = I(EB, { __v: n, i: e });
  return t.containerInfo = e, t;
}
(Lu.prototype = new Rr()).__a = function(n) {
  var e = this, t = F1(e.__v), r = e.o.get(n);
  return r[0]++, function(i) {
    var s = function() {
      e.props.revealOrder ? (r.push(i), $x(e, n, r)) : i();
    };
    t ? t(s) : s();
  };
}, Lu.prototype.render = function(n) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var e = _d(n.children);
  n.revealOrder && n.revealOrder[0] === "b" && e.reverse();
  for (var t = e.length; t--; ) this.o.set(e[t], this.u = [1, 0, this.u]);
  return n.children;
}, Lu.prototype.componentDidUpdate = Lu.prototype.componentDidMount = function() {
  var n = this;
  this.o.forEach(function(e, t) {
    $x(n, t, e);
  });
};
var TB = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, CB = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, DB = typeof document < "u", RB = function(n) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
Rr.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(n) {
  Object.defineProperty(Rr.prototype, n, { configurable: !0, get: function() {
    return this["UNSAFE_" + n];
  }, set: function(e) {
    Object.defineProperty(this, n, { configurable: !0, writable: !0, value: e });
  } });
});
var Gx = _e.event;
function kB() {
}
function MB() {
  return this.cancelBubble;
}
function _B() {
  return this.defaultPrevented;
}
_e.event = function(n) {
  return Gx && (n = Gx(n)), n.persist = kB, n.isPropagationStopped = MB, n.isDefaultPrevented = _B, n.nativeEvent = n;
};
var Yx = { configurable: !0, get: function() {
  return this.class;
} }, qx = _e.vnode;
_e.vnode = function(n) {
  var e = n.type, t = n.props, r = t;
  if (typeof e == "string") {
    var i = e.indexOf("-") === -1;
    for (var s in r = {}, t) {
      var o = t[s];
      DB && s === "children" && e === "noscript" || s === "value" && "defaultValue" in t && o == null || (s === "defaultValue" && "value" in t && t.value == null ? s = "value" : s === "download" && o === !0 ? o = "" : /ondoubleclick/i.test(s) ? s = "ondblclick" : /^onchange(textarea|input)/i.test(s + e) && !RB(t.type) ? s = "oninput" : /^onfocus$/i.test(s) ? s = "onfocusin" : /^onblur$/i.test(s) ? s = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(s) ? s = s.toLowerCase() : i && CB.test(s) ? s = s.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : o === null && (o = void 0), /^oninput$/i.test(s) && (s = s.toLowerCase(), r[s] && (s = "oninputCapture")), r[s] = o);
    }
    e == "select" && r.multiple && Array.isArray(r.value) && (r.value = _d(t.children).forEach(function(a) {
      a.props.selected = r.value.indexOf(a.props.value) != -1;
    })), e == "select" && r.defaultValue != null && (r.value = _d(t.children).forEach(function(a) {
      a.props.selected = r.multiple ? r.defaultValue.indexOf(a.props.value) != -1 : r.defaultValue == a.props.value;
    })), n.props = r, t.class != t.className && (Yx.enumerable = "className" in t, t.className != null && (r.class = t.className), Object.defineProperty(r, "className", Yx));
  }
  n.$$typeof = TB, qx && qx(n);
};
var Kx = _e.__r;
_e.__r = function(n) {
  Kx && Kx(n), n.__c;
};
const z1 = [], Km = /* @__PURE__ */ new Map();
function yy(n) {
  z1.push(n), Km.forEach((e) => {
    H1(e, n);
  });
}
function OB(n) {
  n.isConnected && // sometimes true if SSR system simulates DOM
  n.getRootNode && V1(n.getRootNode());
}
function V1(n) {
  let e = Km.get(n);
  if (!e || !e.isConnected) {
    if (e = n.querySelector("style[data-fullcalendar]"), !e) {
      e = document.createElement("style"), e.setAttribute("data-fullcalendar", "");
      const t = NB();
      t && (e.nonce = t);
      const r = n === document ? document.head : n, i = n === document ? r.querySelector("script,link[rel=stylesheet],link[as=style],style") : r.firstChild;
      r.insertBefore(e, i);
    }
    Km.set(n, e), IB(e);
  }
}
function IB(n) {
  for (const e of z1)
    H1(n, e);
}
function H1(n, e) {
  const { sheet: t } = n, r = t.cssRules.length;
  e.split("}").forEach((i, s) => {
    i = i.trim(), i && t.insertRule(i + "}", r + s);
  });
}
let Dp;
function NB() {
  return Dp === void 0 && (Dp = PB()), Dp;
}
function PB() {
  const n = document.querySelector('meta[name="csp-nonce"]');
  if (n && n.hasAttribute("content"))
    return n.getAttribute("content");
  const e = document.querySelector("script[nonce]");
  return e && e.nonce || "";
}
typeof document < "u" && V1(document);
var LB = ':root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:"\\e900"}.fc-icon-chevron-right:before{content:"\\e901"}.fc-icon-chevrons-left:before{content:"\\e902"}.fc-icon-chevrons-right:before{content:"\\e903"}.fc-icon-minus-square:before{content:"\\e904"}.fc-icon-plus-square:before{content:"\\e905"}.fc-icon-x:before{content:"\\e906"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:"";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:"";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}';
yy(LB);
class vy {
  constructor(e) {
    this.drainedOption = e, this.isRunning = !1, this.isDirty = !1, this.pauseDepths = {}, this.timeoutId = 0;
  }
  request(e) {
    this.isDirty = !0, this.isPaused() || (this.clearTimeout(), e == null ? this.tryDrain() : this.timeoutId = setTimeout(
      // NOT OPTIMAL! TODO: look at debounce
      this.tryDrain.bind(this),
      e
    ));
  }
  pause(e = "") {
    let { pauseDepths: t } = this;
    t[e] = (t[e] || 0) + 1, this.clearTimeout();
  }
  resume(e = "", t) {
    let { pauseDepths: r } = this;
    e in r && (t ? delete r[e] : (r[e] -= 1, r[e] <= 0 && delete r[e]), this.tryDrain());
  }
  isPaused() {
    return Object.keys(this.pauseDepths).length;
  }
  tryDrain() {
    if (!this.isRunning && !this.isPaused()) {
      for (this.isRunning = !0; this.isDirty; )
        this.isDirty = !1, this.drained();
      this.isRunning = !1;
    }
  }
  clear() {
    this.clearTimeout(), this.isDirty = !1, this.pauseDepths = {};
  }
  clearTimeout() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = 0);
  }
  drained() {
    this.drainedOption && this.drainedOption();
  }
}
function BB(n) {
  n.parentNode && n.parentNode.removeChild(n);
}
function Xi(n, e) {
  if (n.closest)
    return n.closest(e);
  if (!document.documentElement.contains(n))
    return null;
  do {
    if (jB(n, e))
      return n;
    n = n.parentElement || n.parentNode;
  } while (n !== null && n.nodeType === 1);
  return null;
}
function jB(n, e) {
  return (n.matches || n.matchesSelector || n.msMatchesSelector).call(n, e);
}
function FB(n, e) {
  let t = n instanceof HTMLElement ? [n] : n, r = [];
  for (let i = 0; i < t.length; i += 1) {
    let s = t[i].querySelectorAll(e);
    for (let o = 0; o < s.length; o += 1)
      r.push(s[o]);
  }
  return r;
}
const zB = /(top|left|right|bottom|width|height)$/i;
function VB(n, e) {
  for (let t in e)
    W1(n, t, e[t]);
}
function W1(n, e, t) {
  t == null ? n.style[e] = "" : typeof t == "number" && zB.test(e) ? n.style[e] = `${t}px` : n.style[e] = t;
}
function HB(n) {
  var e, t;
  return (t = (e = n.composedPath) === null || e === void 0 ? void 0 : e.call(n)[0]) !== null && t !== void 0 ? t : n.target;
}
let Jx = 0;
function $f() {
  return Jx += 1, "fc-dom-" + Jx;
}
function WB(n, e) {
  return (t) => {
    let r = Xi(t.target, n);
    r && e.call(r, t, r);
  };
}
function U1(n, e, t, r) {
  let i = WB(t, r);
  return n.addEventListener(e, i), () => {
    n.removeEventListener(e, i);
  };
}
function UB(n, e, t, r) {
  let i;
  return U1(n, "mouseover", e, (s, o) => {
    if (o !== i) {
      i = o, t(s, o);
      let a = (c) => {
        i = null, r(c, o), o.removeEventListener("mouseleave", a);
      };
      o.addEventListener("mouseleave", a);
    }
  });
}
function $1(n) {
  return Object.assign({ onClick: n }, G1(n));
}
function G1(n) {
  return {
    tabIndex: 0,
    onKeyDown(e) {
      (e.key === "Enter" || e.key === " ") && (n(e), e.preventDefault());
    }
  };
}
let Qx = 0;
function Qo() {
  return Qx += 1, String(Qx);
}
function $B(n) {
  let e = [], t = [], r, i;
  for (typeof n == "string" ? t = n.split(/\s*,\s*/) : typeof n == "function" ? t = [n] : Array.isArray(n) && (t = n), r = 0; r < t.length; r += 1)
    i = t[r], typeof i == "string" ? e.push(i.charAt(0) === "-" ? { field: i.substring(1), order: -1 } : { field: i, order: 1 }) : typeof i == "function" && e.push({ func: i });
  return e;
}
function GB(n, e, t) {
  let r, i;
  for (r = 0; r < t.length; r += 1)
    if (i = YB(n, e, t[r]), i)
      return i;
  return 0;
}
function YB(n, e, t) {
  return t.func ? t.func(n, e) : qB(n[t.field], e[t.field]) * (t.order || 1);
}
function qB(n, e) {
  return !n && !e ? 0 : e == null ? -1 : n == null ? 1 : typeof n == "string" || typeof e == "string" ? String(n).localeCompare(String(e)) : n - e;
}
function Va(n, e) {
  let t = String(n);
  return "000".substr(0, e - t.length) + t;
}
function ql(n, e, t) {
  return typeof n == "function" ? n(...e) : typeof n == "string" ? e.reduce((r, i, s) => r.replace("$" + s, i || ""), n) : t;
}
function pd(n) {
  return n % 1 === 0;
}
function KB(n) {
  let e = n.querySelector(".fc-scrollgrid-shrink-frame"), t = n.querySelector(".fc-scrollgrid-shrink-cushion");
  if (!e)
    throw new Error("needs fc-scrollgrid-shrink-frame className");
  if (!t)
    throw new Error("needs fc-scrollgrid-shrink-cushion className");
  return n.getBoundingClientRect().width - e.getBoundingClientRect().width + // the cell padding+border
  t.getBoundingClientRect().width;
}
const Zx = ["years", "months", "days", "milliseconds"], JB = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
function ot(n, e) {
  return typeof n == "string" ? QB(n) : typeof n == "object" && n ? Xx(n) : typeof n == "number" ? Xx({ [e || "milliseconds"]: n }) : null;
}
function QB(n) {
  let e = JB.exec(n);
  if (e) {
    let t = e[1] ? -1 : 1;
    return {
      years: 0,
      months: 0,
      days: t * (e[2] ? parseInt(e[2], 10) : 0),
      milliseconds: t * ((e[3] ? parseInt(e[3], 10) : 0) * 60 * 60 * 1e3 + // hours
      (e[4] ? parseInt(e[4], 10) : 0) * 60 * 1e3 + // minutes
      (e[5] ? parseInt(e[5], 10) : 0) * 1e3 + // seconds
      (e[6] ? parseInt(e[6], 10) : 0))
    };
  }
  return null;
}
function Xx(n) {
  let e = {
    years: n.years || n.year || 0,
    months: n.months || n.month || 0,
    days: n.days || n.day || 0,
    milliseconds: (n.hours || n.hour || 0) * 60 * 60 * 1e3 + // hours
    (n.minutes || n.minute || 0) * 60 * 1e3 + // minutes
    (n.seconds || n.second || 0) * 1e3 + // seconds
    (n.milliseconds || n.millisecond || n.ms || 0)
    // ms
  }, t = n.weeks || n.week;
  return t && (e.days += t * 7, e.specifiedWeeks = !0), e;
}
function ZB(n, e) {
  return n.years === e.years && n.months === e.months && n.days === e.days && n.milliseconds === e.milliseconds;
}
function Jm(n, e) {
  return {
    years: n.years + e.years,
    months: n.months + e.months,
    days: n.days + e.days,
    milliseconds: n.milliseconds + e.milliseconds
  };
}
function XB(n, e) {
  return {
    years: n.years - e.years,
    months: n.months - e.months,
    days: n.days - e.days,
    milliseconds: n.milliseconds - e.milliseconds
  };
}
function ej(n, e) {
  return {
    years: n.years * e,
    months: n.months * e,
    days: n.days * e,
    milliseconds: n.milliseconds * e
  };
}
function tj(n) {
  return Ha(n) / 365;
}
function nj(n) {
  return Ha(n) / 30;
}
function Ha(n) {
  return di(n) / 864e5;
}
function di(n) {
  return n.years * (365 * 864e5) + n.months * (30 * 864e5) + n.days * 864e5 + n.milliseconds;
}
function by(n, e) {
  let t = null;
  for (let r = 0; r < Zx.length; r += 1) {
    let i = Zx[r];
    if (e[i]) {
      let s = n[i] / e[i];
      if (!pd(s) || t !== null && t !== s)
        return null;
      t = s;
    } else if (n[i])
      return null;
  }
  return t;
}
function Qm(n) {
  let e = n.milliseconds;
  if (e) {
    if (e % 1e3 !== 0)
      return { unit: "millisecond", value: e };
    if (e % (1e3 * 60) !== 0)
      return { unit: "second", value: e / 1e3 };
    if (e % (1e3 * 60 * 60) !== 0)
      return { unit: "minute", value: e / (1e3 * 60) };
    if (e)
      return { unit: "hour", value: e / (1e3 * 60 * 60) };
  }
  return n.days ? n.specifiedWeeks && n.days % 7 === 0 ? { unit: "week", value: n.days / 7 } : { unit: "day", value: n.days } : n.months ? { unit: "month", value: n.months } : n.years ? { unit: "year", value: n.years } : { unit: "millisecond", value: 0 };
}
function Qs(n, e, t) {
  if (n === e)
    return !0;
  let r = n.length, i;
  if (r !== e.length)
    return !1;
  for (i = 0; i < r; i += 1)
    if (!(t ? t(n[i], e[i]) : n[i] === e[i]))
      return !1;
  return !0;
}
const rj = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
function eS(n, e) {
  let t = js(n);
  return t[2] += e * 7, pr(t);
}
function vn(n, e) {
  let t = js(n);
  return t[2] += e, pr(t);
}
function Zs(n, e) {
  let t = js(n);
  return t[6] += e, pr(t);
}
function ij(n, e) {
  return Zo(n, e) / 7;
}
function Zo(n, e) {
  return (e.valueOf() - n.valueOf()) / (1e3 * 60 * 60 * 24);
}
function sj(n, e) {
  return (e.valueOf() - n.valueOf()) / (1e3 * 60 * 60);
}
function oj(n, e) {
  return (e.valueOf() - n.valueOf()) / (1e3 * 60);
}
function aj(n, e) {
  return (e.valueOf() - n.valueOf()) / 1e3;
}
function lj(n, e) {
  let t = Mt(n), r = Mt(e);
  return {
    years: 0,
    months: 0,
    days: Math.round(Zo(t, r)),
    milliseconds: e.valueOf() - r.valueOf() - (n.valueOf() - t.valueOf())
  };
}
function cj(n, e) {
  let t = Od(n, e);
  return t !== null && t % 7 === 0 ? t / 7 : null;
}
function Od(n, e) {
  return Fs(n) === Fs(e) ? Math.round(Zo(n, e)) : null;
}
function Mt(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate()
  ]);
}
function uj(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours()
  ]);
}
function dj(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours(),
    n.getUTCMinutes()
  ]);
}
function fj(n) {
  return pr([
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours(),
    n.getUTCMinutes(),
    n.getUTCSeconds()
  ]);
}
function hj(n, e, t) {
  let r = n.getUTCFullYear(), i = Rp(n, r, e, t);
  if (i < 1)
    return Rp(n, r - 1, e, t);
  let s = Rp(n, r + 1, e, t);
  return s >= 1 ? Math.min(i, s) : i;
}
function Rp(n, e, t, r) {
  let i = pr([e, 0, 1 + pj(e, t, r)]), s = Mt(n), o = Math.round(Zo(i, s));
  return Math.floor(o / 7) + 1;
}
function pj(n, e, t) {
  let r = 7 + e - t;
  return -((7 + pr([n, 0, r]).getUTCDay() - e) % 7) + r - 1;
}
function tS(n) {
  return [
    n.getFullYear(),
    n.getMonth(),
    n.getDate(),
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ];
}
function nS(n) {
  return new Date(
    n[0],
    n[1] || 0,
    n[2] == null ? 1 : n[2],
    // day of month
    n[3] || 0,
    n[4] || 0,
    n[5] || 0
  );
}
function js(n) {
  return [
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours(),
    n.getUTCMinutes(),
    n.getUTCSeconds(),
    n.getUTCMilliseconds()
  ];
}
function pr(n) {
  return n.length === 1 && (n = n.concat([0])), new Date(Date.UTC(...n));
}
function Y1(n) {
  return !isNaN(n.valueOf());
}
function Fs(n) {
  return n.getUTCHours() * 1e3 * 60 * 60 + n.getUTCMinutes() * 1e3 * 60 + n.getUTCSeconds() * 1e3 + n.getUTCMilliseconds();
}
function q1(n, e, t = !1) {
  let r = n.toISOString();
  return r = r.replace(".000", ""), t && (r = r.replace("T00:00:00Z", "")), r.length > 10 && (e == null ? r = r.replace("Z", "") : e !== 0 && (r = r.replace("Z", Sy(e, !0)))), r;
}
function xy(n) {
  return n.toISOString().replace(/T.*$/, "");
}
function mj(n) {
  return n.toISOString().match(/^\d{4}-\d{2}/)[0];
}
function gj(n) {
  return Va(n.getUTCHours(), 2) + ":" + Va(n.getUTCMinutes(), 2) + ":" + Va(n.getUTCSeconds(), 2);
}
function Sy(n, e = !1) {
  let t = n < 0 ? "-" : "+", r = Math.abs(n), i = Math.floor(r / 60), s = Math.round(r % 60);
  return e ? `${t + Va(i, 2)}:${Va(s, 2)}` : `GMT${t}${i}${s ? `:${Va(s, 2)}` : ""}`;
}
function Ne(n, e, t) {
  let r, i;
  return function(...s) {
    if (!r)
      i = n.apply(this, s);
    else if (!Qs(r, s)) {
      let o = n.apply(this, s);
      (!e || !e(o, i)) && (i = o);
    }
    return r = s, i;
  };
}
function md(n, e, t) {
  let r, i;
  return (s) => (r ? pi(r, s) || (i = n.call(this, s)) : i = n.call(this, s), r = s, i);
}
const kp = {
  week: 3,
  separator: 9,
  omitZeroMinute: 9,
  meridiem: 9,
  omitCommas: 9
}, Id = {
  timeZoneName: 7,
  era: 6,
  year: 5,
  month: 4,
  day: 2,
  weekday: 2,
  hour: 1,
  minute: 1,
  second: 1
}, Bu = /\s*([ap])\.?m\.?/i, yj = /,/g, vj = /\s+/g, bj = /\u200e/g, xj = /UTC|GMT/;
class Sj {
  constructor(e) {
    let t = {}, r = {}, i = 9;
    for (let s in e)
      s in kp ? (r[s] = e[s], kp[s] < 9 && (i = Math.min(kp[s], i))) : (t[s] = e[s], s in Id && (i = Math.min(Id[s], i)));
    this.standardDateProps = t, this.extendedSettings = r, this.smallestUnitNum = i, this.buildFormattingFunc = Ne(rS);
  }
  format(e, t) {
    return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, t)(e);
  }
  formatRange(e, t, r, i) {
    let { standardDateProps: s, extendedSettings: o } = this, a = Dj(e.marker, t.marker, r.calendarSystem);
    if (!a)
      return this.format(e, r);
    let c = a;
    c > 1 && // the two dates are different in a way that's larger scale than time
    (s.year === "numeric" || s.year === "2-digit") && (s.month === "numeric" || s.month === "2-digit") && (s.day === "numeric" || s.day === "2-digit") && (c = 1);
    let u = this.format(e, r), f = this.format(t, r);
    if (u === f)
      return u;
    let h = Rj(s, c), p = rS(h, o, r), g = p(e), y = p(t), x = kj(u, g, f, y), S = o.separator || i || r.defaultSeparator || "";
    return x ? x.before + g + S + y + x.after : u + S + f;
  }
  getSmallestUnit() {
    switch (this.smallestUnitNum) {
      case 7:
      case 6:
      case 5:
        return "year";
      case 4:
        return "month";
      case 3:
        return "week";
      case 2:
        return "day";
      default:
        return "time";
    }
  }
}
function rS(n, e, t) {
  let r = Object.keys(n).length;
  return r === 1 && n.timeZoneName === "short" ? (i) => Sy(i.timeZoneOffset) : r === 0 && e.week ? (i) => Cj(t.computeWeekNumber(i.marker), t.weekText, t.weekTextLong, t.locale, e.week) : wj(n, e, t);
}
function wj(n, e, t) {
  n = Object.assign({}, n), e = Object.assign({}, e), Ej(n, e), n.timeZone = "UTC";
  let r = new Intl.DateTimeFormat(t.locale.codes, n), i;
  if (e.omitZeroMinute) {
    let s = Object.assign({}, n);
    delete s.minute, i = new Intl.DateTimeFormat(t.locale.codes, s);
  }
  return (s) => {
    let { marker: o } = s, a;
    i && !o.getUTCMinutes() ? a = i : a = r;
    let c = a.format(o);
    return Aj(c, s, n, e, t);
  };
}
function Ej(n, e) {
  n.timeZoneName && (n.hour || (n.hour = "2-digit"), n.minute || (n.minute = "2-digit")), n.timeZoneName === "long" && (n.timeZoneName = "short"), e.omitZeroMinute && (n.second || n.millisecond) && delete e.omitZeroMinute;
}
function Aj(n, e, t, r, i) {
  return n = n.replace(bj, ""), t.timeZoneName === "short" && (n = Tj(n, i.timeZone === "UTC" || e.timeZoneOffset == null ? "UTC" : (
    // important to normalize for IE, which does "GMT"
    Sy(e.timeZoneOffset)
  ))), r.omitCommas && (n = n.replace(yj, "").trim()), r.omitZeroMinute && (n = n.replace(":00", "")), r.meridiem === !1 ? n = n.replace(Bu, "").trim() : r.meridiem === "narrow" ? n = n.replace(Bu, (s, o) => o.toLocaleLowerCase()) : r.meridiem === "short" ? n = n.replace(Bu, (s, o) => `${o.toLocaleLowerCase()}m`) : r.meridiem === "lowercase" && (n = n.replace(Bu, (s) => s.toLocaleLowerCase())), n = n.replace(vj, " "), n = n.trim(), n;
}
function Tj(n, e) {
  let t = !1;
  return n = n.replace(xj, () => (t = !0, e)), t || (n += ` ${e}`), n;
}
function Cj(n, e, t, r, i) {
  let s = [];
  return i === "long" ? s.push(t) : (i === "short" || i === "narrow") && s.push(e), (i === "long" || i === "short") && s.push(" "), s.push(r.simpleNumberFormat.format(n)), r.options.direction === "rtl" && s.reverse(), s.join("");
}
function Dj(n, e, t) {
  return t.getMarkerYear(n) !== t.getMarkerYear(e) ? 5 : t.getMarkerMonth(n) !== t.getMarkerMonth(e) ? 4 : t.getMarkerDay(n) !== t.getMarkerDay(e) ? 2 : Fs(n) !== Fs(e) ? 1 : 0;
}
function Rj(n, e) {
  let t = {};
  for (let r in n)
    (!(r in Id) || // not a date part prop (like timeZone)
    Id[r] <= e) && (t[r] = n[r]);
  return t;
}
function kj(n, e, t, r) {
  let i = 0;
  for (; i < n.length; ) {
    let s = n.indexOf(e, i);
    if (s === -1)
      break;
    let o = n.substr(0, s);
    i = s + e.length;
    let a = n.substr(i), c = 0;
    for (; c < t.length; ) {
      let u = t.indexOf(r, c);
      if (u === -1)
        break;
      let f = t.substr(0, u);
      c = u + r.length;
      let h = t.substr(c);
      if (o === f && a === h)
        return {
          before: o,
          after: a
        };
    }
  }
  return null;
}
function iS(n, e) {
  let t = e.markerToArray(n.marker);
  return {
    marker: n.marker,
    timeZoneOffset: n.timeZoneOffset,
    array: t,
    year: t[0],
    month: t[1],
    day: t[2],
    hour: t[3],
    minute: t[4],
    second: t[5],
    millisecond: t[6]
  };
}
function Nd(n, e, t, r) {
  let i = iS(n, t.calendarSystem), s = e ? iS(e, t.calendarSystem) : null;
  return {
    date: i,
    start: i,
    end: s,
    timeZone: t.timeZone,
    localeCodes: t.locale.codes,
    defaultSeparator: r || t.defaultSeparator
  };
}
class Mj {
  constructor(e) {
    this.cmdStr = e;
  }
  format(e, t, r) {
    return t.cmdFormatter(this.cmdStr, Nd(e, null, t, r));
  }
  formatRange(e, t, r, i) {
    return r.cmdFormatter(this.cmdStr, Nd(e, t, r, i));
  }
}
class _j {
  constructor(e) {
    this.func = e;
  }
  format(e, t, r) {
    return this.func(Nd(e, null, t, r));
  }
  formatRange(e, t, r, i) {
    return this.func(Nd(e, t, r, i));
  }
}
function Ht(n) {
  return typeof n == "object" && n ? new Sj(n) : typeof n == "string" ? new Mj(n) : typeof n == "function" ? new _j(n) : null;
}
const sS = {
  navLinkDayClick: U,
  navLinkWeekClick: U,
  duration: ot,
  bootstrapFontAwesome: U,
  buttonIcons: U,
  customButtons: U,
  defaultAllDayEventDuration: ot,
  defaultTimedEventDuration: ot,
  nextDayThreshold: ot,
  scrollTime: ot,
  scrollTimeReset: Boolean,
  slotMinTime: ot,
  slotMaxTime: ot,
  dayPopoverFormat: Ht,
  slotDuration: ot,
  snapDuration: ot,
  headerToolbar: U,
  footerToolbar: U,
  defaultRangeSeparator: String,
  titleRangeSeparator: String,
  forceEventDuration: Boolean,
  dayHeaders: Boolean,
  dayHeaderFormat: Ht,
  dayHeaderClassNames: U,
  dayHeaderContent: U,
  dayHeaderDidMount: U,
  dayHeaderWillUnmount: U,
  dayCellClassNames: U,
  dayCellContent: U,
  dayCellDidMount: U,
  dayCellWillUnmount: U,
  initialView: String,
  aspectRatio: Number,
  weekends: Boolean,
  weekNumberCalculation: U,
  weekNumbers: Boolean,
  weekNumberClassNames: U,
  weekNumberContent: U,
  weekNumberDidMount: U,
  weekNumberWillUnmount: U,
  editable: Boolean,
  viewClassNames: U,
  viewDidMount: U,
  viewWillUnmount: U,
  nowIndicator: Boolean,
  nowIndicatorSnap: U,
  nowIndicatorClassNames: U,
  nowIndicatorContent: U,
  nowIndicatorDidMount: U,
  nowIndicatorWillUnmount: U,
  showNonCurrentDates: Boolean,
  lazyFetching: Boolean,
  startParam: String,
  endParam: String,
  timeZoneParam: String,
  timeZone: String,
  locales: U,
  locale: U,
  themeSystem: String,
  dragRevertDuration: Number,
  dragScroll: Boolean,
  allDayMaintainDuration: Boolean,
  unselectAuto: Boolean,
  dropAccept: U,
  eventOrder: $B,
  eventOrderStrict: Boolean,
  handleWindowResize: Boolean,
  windowResizeDelay: Number,
  longPressDelay: Number,
  eventDragMinDistance: Number,
  expandRows: Boolean,
  height: U,
  contentHeight: U,
  direction: String,
  weekNumberFormat: Ht,
  eventResizableFromStart: Boolean,
  displayEventTime: Boolean,
  displayEventEnd: Boolean,
  weekText: String,
  weekTextLong: String,
  progressiveEventRendering: Boolean,
  businessHours: U,
  initialDate: U,
  now: U,
  eventDataTransform: U,
  stickyHeaderDates: U,
  stickyFooterScrollbar: U,
  viewHeight: U,
  defaultAllDay: Boolean,
  eventSourceFailure: U,
  eventSourceSuccess: U,
  eventDisplay: String,
  eventStartEditable: Boolean,
  eventDurationEditable: Boolean,
  eventOverlap: U,
  eventConstraint: U,
  eventAllow: U,
  eventBackgroundColor: String,
  eventBorderColor: String,
  eventTextColor: String,
  eventColor: String,
  eventClassNames: U,
  eventContent: U,
  eventDidMount: U,
  eventWillUnmount: U,
  selectConstraint: U,
  selectOverlap: U,
  selectAllow: U,
  droppable: Boolean,
  unselectCancel: String,
  slotLabelFormat: U,
  slotLaneClassNames: U,
  slotLaneContent: U,
  slotLaneDidMount: U,
  slotLaneWillUnmount: U,
  slotLabelClassNames: U,
  slotLabelContent: U,
  slotLabelDidMount: U,
  slotLabelWillUnmount: U,
  dayMaxEvents: U,
  dayMaxEventRows: U,
  dayMinWidth: Number,
  slotLabelInterval: ot,
  allDayText: String,
  allDayClassNames: U,
  allDayContent: U,
  allDayDidMount: U,
  allDayWillUnmount: U,
  slotMinWidth: Number,
  navLinks: Boolean,
  eventTimeFormat: Ht,
  rerenderDelay: Number,
  moreLinkText: U,
  moreLinkHint: U,
  selectMinDistance: Number,
  selectable: Boolean,
  selectLongPressDelay: Number,
  eventLongPressDelay: Number,
  selectMirror: Boolean,
  eventMaxStack: Number,
  eventMinHeight: Number,
  eventMinWidth: Number,
  eventShortHeight: Number,
  slotEventOverlap: Boolean,
  plugins: U,
  firstDay: Number,
  dayCount: Number,
  dateAlignment: String,
  dateIncrement: ot,
  hiddenDays: U,
  fixedWeekCount: Boolean,
  validRange: U,
  visibleRange: U,
  titleFormat: U,
  eventInteractive: Boolean,
  // only used by list-view, but languages define the value, so we need it in base options
  noEventsText: String,
  viewHint: U,
  navLinkHint: U,
  closeHint: String,
  timeHint: String,
  eventHint: String,
  moreLinkClick: U,
  moreLinkClassNames: U,
  moreLinkContent: U,
  moreLinkDidMount: U,
  moreLinkWillUnmount: U,
  monthStartFormat: Ht,
  // for connectors
  // (can't be part of plugin system b/c must be provided at runtime)
  handleCustomRendering: U,
  customRenderingMetaMap: U,
  customRenderingReplaces: Boolean
}, Kl = {
  eventDisplay: "auto",
  defaultRangeSeparator: " - ",
  titleRangeSeparator: " – ",
  defaultTimedEventDuration: "01:00:00",
  defaultAllDayEventDuration: { day: 1 },
  forceEventDuration: !1,
  nextDayThreshold: "00:00:00",
  dayHeaders: !0,
  initialView: "",
  aspectRatio: 1.35,
  headerToolbar: {
    start: "title",
    center: "",
    end: "today prev,next"
  },
  weekends: !0,
  weekNumbers: !1,
  weekNumberCalculation: "local",
  editable: !1,
  nowIndicator: !1,
  scrollTime: "06:00:00",
  scrollTimeReset: !0,
  slotMinTime: "00:00:00",
  slotMaxTime: "24:00:00",
  showNonCurrentDates: !0,
  lazyFetching: !0,
  startParam: "start",
  endParam: "end",
  timeZoneParam: "timeZone",
  timeZone: "local",
  locales: [],
  locale: "",
  themeSystem: "standard",
  dragRevertDuration: 500,
  dragScroll: !0,
  allDayMaintainDuration: !1,
  unselectAuto: !0,
  dropAccept: "*",
  eventOrder: "start,-duration,allDay,title",
  dayPopoverFormat: { month: "long", day: "numeric", year: "numeric" },
  handleWindowResize: !0,
  windowResizeDelay: 100,
  longPressDelay: 1e3,
  eventDragMinDistance: 5,
  expandRows: !1,
  navLinks: !1,
  selectable: !1,
  eventMinHeight: 15,
  eventMinWidth: 30,
  eventShortHeight: 30,
  monthStartFormat: { month: "long", day: "numeric" },
  nowIndicatorSnap: "auto"
}, oS = {
  datesSet: U,
  eventsSet: U,
  eventAdd: U,
  eventChange: U,
  eventRemove: U,
  windowResize: U,
  eventClick: U,
  eventMouseEnter: U,
  eventMouseLeave: U,
  select: U,
  unselect: U,
  loading: U,
  // internal
  _unmount: U,
  _beforeprint: U,
  _afterprint: U,
  _noEventDrop: U,
  _noEventResize: U,
  _resize: U,
  _scrollRequest: U
}, aS = {
  buttonText: U,
  buttonHints: U,
  views: U,
  plugins: U,
  initialEvents: U,
  events: U,
  eventSources: U
}, Eo = {
  headerToolbar: Ao,
  footerToolbar: Ao,
  buttonText: Ao,
  buttonHints: Ao,
  buttonIcons: Ao,
  dateIncrement: Ao,
  plugins: ju,
  events: ju,
  eventSources: ju,
  resources: ju
};
function Ao(n, e) {
  return typeof n == "object" && typeof e == "object" && n && e ? pi(n, e) : n === e;
}
function ju(n, e) {
  return Array.isArray(n) && Array.isArray(e) ? Qs(n, e) : n === e;
}
const Oj = {
  type: String,
  component: U,
  buttonText: String,
  buttonTextKey: String,
  dateProfileGeneratorClass: U,
  usesMinMaxTime: Boolean,
  classNames: U,
  content: U,
  didMount: U,
  willUnmount: U
};
function Mp(n) {
  return Ey(n, Eo);
}
function wy(n, e) {
  let t = {}, r = {};
  for (let i in e)
    i in n && (t[i] = e[i](n[i]));
  for (let i in n)
    i in e || (r[i] = n[i]);
  return { refined: t, extra: r };
}
function U(n) {
  return n;
}
const { hasOwnProperty: Pd } = Object.prototype;
function Ey(n, e) {
  let t = {};
  if (e) {
    for (let r in e)
      if (e[r] === Ao) {
        let i = [];
        for (let s = n.length - 1; s >= 0; s -= 1) {
          let o = n[s][r];
          if (typeof o == "object" && o)
            i.unshift(o);
          else if (o !== void 0) {
            t[r] = o;
            break;
          }
        }
        i.length && (t[r] = Ey(i));
      }
  }
  for (let r = n.length - 1; r >= 0; r -= 1) {
    let i = n[r];
    for (let s in i)
      s in t || (t[s] = i[s]);
  }
  return t;
}
function Ka(n, e) {
  let t = {};
  for (let r in n)
    e(n[r], r) && (t[r] = n[r]);
  return t;
}
function Wo(n, e) {
  let t = {};
  for (let r in n)
    t[r] = e(n[r], r);
  return t;
}
function K1(n) {
  let e = {};
  for (let t of n)
    e[t] = !0;
  return e;
}
function Ay(n) {
  let e = [];
  for (let t in n)
    e.push(n[t]);
  return e;
}
function pi(n, e) {
  if (n === e)
    return !0;
  for (let t in n)
    if (Pd.call(n, t) && !(t in e))
      return !1;
  for (let t in e)
    if (Pd.call(e, t) && n[t] !== e[t])
      return !1;
  return !0;
}
const Ij = /^on[A-Z]/;
function Nj(n, e) {
  const t = Pj(n, e);
  for (let r of t)
    if (!Ij.test(r))
      return !1;
  return !0;
}
function Pj(n, e) {
  let t = [];
  for (let r in n)
    Pd.call(n, r) && (r in e || t.push(r));
  for (let r in e)
    Pd.call(e, r) && n[r] !== e[r] && t.push(r);
  return t;
}
function _p(n, e, t = {}) {
  if (n === e)
    return !0;
  for (let r in e)
    if (!(r in n && Lj(n[r], e[r], t[r]))) return !1;
  for (let r in n)
    if (!(r in e))
      return !1;
  return !0;
}
function Lj(n, e, t) {
  return n === e || t === !0 ? !0 : t ? t(n, e) : !1;
}
function Bj(n, e = 0, t, r = 1) {
  let i = [];
  t == null && (t = Object.keys(n).length);
  for (let s = e; s < t; s += r) {
    let o = n[s];
    o !== void 0 && i.push(o);
  }
  return i;
}
let J1 = {};
function jj(n, e) {
  J1[n] = e;
}
function Fj(n) {
  return new J1[n]();
}
class zj {
  getMarkerYear(e) {
    return e.getUTCFullYear();
  }
  getMarkerMonth(e) {
    return e.getUTCMonth();
  }
  getMarkerDay(e) {
    return e.getUTCDate();
  }
  arrayToMarker(e) {
    return pr(e);
  }
  markerToArray(e) {
    return js(e);
  }
}
jj("gregory", zj);
const Vj = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function Hj(n) {
  let e = Vj.exec(n);
  if (e) {
    let t = new Date(Date.UTC(Number(e[1]), e[3] ? Number(e[3]) - 1 : 0, Number(e[5] || 1), Number(e[7] || 0), Number(e[8] || 0), Number(e[10] || 0), e[12] ? +`0.${e[12]}` * 1e3 : 0));
    if (Y1(t)) {
      let r = null;
      return e[13] && (r = (e[15] === "-" ? -1 : 1) * (Number(e[16] || 0) * 60 + Number(e[18] || 0))), {
        marker: t,
        isTimeUnspecified: !e[6],
        timeZoneOffset: r
      };
    }
  }
  return null;
}
class Wj {
  constructor(e) {
    let t = this.timeZone = e.timeZone, r = t !== "local" && t !== "UTC";
    e.namedTimeZoneImpl && r && (this.namedTimeZoneImpl = new e.namedTimeZoneImpl(t)), this.canComputeOffset = !!(!r || this.namedTimeZoneImpl), this.calendarSystem = Fj(e.calendarSystem), this.locale = e.locale, this.weekDow = e.locale.week.dow, this.weekDoy = e.locale.week.doy, e.weekNumberCalculation === "ISO" && (this.weekDow = 1, this.weekDoy = 4), typeof e.firstDay == "number" && (this.weekDow = e.firstDay), typeof e.weekNumberCalculation == "function" && (this.weekNumberFunc = e.weekNumberCalculation), this.weekText = e.weekText != null ? e.weekText : e.locale.options.weekText, this.weekTextLong = (e.weekTextLong != null ? e.weekTextLong : e.locale.options.weekTextLong) || this.weekText, this.cmdFormatter = e.cmdFormatter, this.defaultSeparator = e.defaultSeparator;
  }
  // Creating / Parsing
  createMarker(e) {
    let t = this.createMarkerMeta(e);
    return t === null ? null : t.marker;
  }
  createNowMarker() {
    return this.canComputeOffset ? this.timestampToMarker((/* @__PURE__ */ new Date()).valueOf()) : pr(tS(/* @__PURE__ */ new Date()));
  }
  createMarkerMeta(e) {
    if (typeof e == "string")
      return this.parse(e);
    let t = null;
    return typeof e == "number" ? t = this.timestampToMarker(e) : e instanceof Date ? (e = e.valueOf(), isNaN(e) || (t = this.timestampToMarker(e))) : Array.isArray(e) && (t = pr(e)), t === null || !Y1(t) ? null : { marker: t, isTimeUnspecified: !1, forcedTzo: null };
  }
  parse(e) {
    let t = Hj(e);
    if (t === null)
      return null;
    let { marker: r } = t, i = null;
    return t.timeZoneOffset !== null && (this.canComputeOffset ? r = this.timestampToMarker(r.valueOf() - t.timeZoneOffset * 60 * 1e3) : i = t.timeZoneOffset), { marker: r, isTimeUnspecified: t.isTimeUnspecified, forcedTzo: i };
  }
  // Accessors
  getYear(e) {
    return this.calendarSystem.getMarkerYear(e);
  }
  getMonth(e) {
    return this.calendarSystem.getMarkerMonth(e);
  }
  getDay(e) {
    return this.calendarSystem.getMarkerDay(e);
  }
  // Adding / Subtracting
  add(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[0] += t.years, r[1] += t.months, r[2] += t.days, r[6] += t.milliseconds, this.calendarSystem.arrayToMarker(r);
  }
  subtract(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[0] -= t.years, r[1] -= t.months, r[2] -= t.days, r[6] -= t.milliseconds, this.calendarSystem.arrayToMarker(r);
  }
  addYears(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[0] += t, this.calendarSystem.arrayToMarker(r);
  }
  addMonths(e, t) {
    let r = this.calendarSystem.markerToArray(e);
    return r[1] += t, this.calendarSystem.arrayToMarker(r);
  }
  // Diffing Whole Units
  diffWholeYears(e, t) {
    let { calendarSystem: r } = this;
    return Fs(e) === Fs(t) && r.getMarkerDay(e) === r.getMarkerDay(t) && r.getMarkerMonth(e) === r.getMarkerMonth(t) ? r.getMarkerYear(t) - r.getMarkerYear(e) : null;
  }
  diffWholeMonths(e, t) {
    let { calendarSystem: r } = this;
    return Fs(e) === Fs(t) && r.getMarkerDay(e) === r.getMarkerDay(t) ? r.getMarkerMonth(t) - r.getMarkerMonth(e) + (r.getMarkerYear(t) - r.getMarkerYear(e)) * 12 : null;
  }
  // Range / Duration
  greatestWholeUnit(e, t) {
    let r = this.diffWholeYears(e, t);
    return r !== null ? { unit: "year", value: r } : (r = this.diffWholeMonths(e, t), r !== null ? { unit: "month", value: r } : (r = cj(e, t), r !== null ? { unit: "week", value: r } : (r = Od(e, t), r !== null ? { unit: "day", value: r } : (r = sj(e, t), pd(r) ? { unit: "hour", value: r } : (r = oj(e, t), pd(r) ? { unit: "minute", value: r } : (r = aj(e, t), pd(r) ? { unit: "second", value: r } : { unit: "millisecond", value: t.valueOf() - e.valueOf() }))))));
  }
  countDurationsBetween(e, t, r) {
    let i;
    return r.years && (i = this.diffWholeYears(e, t), i !== null) ? i / tj(r) : r.months && (i = this.diffWholeMonths(e, t), i !== null) ? i / nj(r) : r.days && (i = Od(e, t), i !== null) ? i / Ha(r) : (t.valueOf() - e.valueOf()) / di(r);
  }
  // Start-Of
  // these DON'T return zoned-dates. only UTC start-of dates
  startOf(e, t) {
    return t === "year" ? this.startOfYear(e) : t === "month" ? this.startOfMonth(e) : t === "week" ? this.startOfWeek(e) : t === "day" ? Mt(e) : t === "hour" ? uj(e) : t === "minute" ? dj(e) : t === "second" ? fj(e) : null;
  }
  startOfYear(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e)
    ]);
  }
  startOfMonth(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e),
      this.calendarSystem.getMarkerMonth(e)
    ]);
  }
  startOfWeek(e) {
    return this.calendarSystem.arrayToMarker([
      this.calendarSystem.getMarkerYear(e),
      this.calendarSystem.getMarkerMonth(e),
      e.getUTCDate() - (e.getUTCDay() - this.weekDow + 7) % 7
    ]);
  }
  // Week Number
  computeWeekNumber(e) {
    return this.weekNumberFunc ? this.weekNumberFunc(this.toDate(e)) : hj(e, this.weekDow, this.weekDoy);
  }
  // TODO: choke on timeZoneName: long
  format(e, t, r = {}) {
    return t.format({
      marker: e,
      timeZoneOffset: r.forcedTzo != null ? r.forcedTzo : this.offsetForMarker(e)
    }, this);
  }
  formatRange(e, t, r, i = {}) {
    return i.isEndExclusive && (t = Zs(t, -1)), r.formatRange({
      marker: e,
      timeZoneOffset: i.forcedStartTzo != null ? i.forcedStartTzo : this.offsetForMarker(e)
    }, {
      marker: t,
      timeZoneOffset: i.forcedEndTzo != null ? i.forcedEndTzo : this.offsetForMarker(t)
    }, this, i.defaultSeparator);
  }
  /*
  DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
  might as well use buildIsoString or some other util directly
  */
  formatIso(e, t = {}) {
    let r = null;
    return t.omitTimeZoneOffset || (t.forcedTzo != null ? r = t.forcedTzo : r = this.offsetForMarker(e)), q1(e, r, t.omitTime);
  }
  // TimeZone
  timestampToMarker(e) {
    return this.timeZone === "local" ? pr(tS(new Date(e))) : this.timeZone === "UTC" || !this.namedTimeZoneImpl ? new Date(e) : pr(this.namedTimeZoneImpl.timestampToArray(e));
  }
  offsetForMarker(e) {
    return this.timeZone === "local" ? -nS(js(e)).getTimezoneOffset() : this.timeZone === "UTC" ? 0 : this.namedTimeZoneImpl ? this.namedTimeZoneImpl.offsetForArray(js(e)) : null;
  }
  // Conversion
  toDate(e, t) {
    return this.timeZone === "local" ? nS(js(e)) : this.timeZone === "UTC" ? new Date(e.valueOf()) : this.namedTimeZoneImpl ? new Date(e.valueOf() - this.namedTimeZoneImpl.offsetForArray(js(e)) * 1e3 * 60) : new Date(e.valueOf() - (t || 0));
  }
}
class Fc {
  constructor(e) {
    this.iconOverrideOption && this.setIconOverride(e[this.iconOverrideOption]);
  }
  setIconOverride(e) {
    let t, r;
    if (typeof e == "object" && e) {
      t = Object.assign({}, this.iconClasses);
      for (r in e)
        t[r] = this.applyIconOverridePrefix(e[r]);
      this.iconClasses = t;
    } else e === !1 && (this.iconClasses = {});
  }
  applyIconOverridePrefix(e) {
    let t = this.iconOverridePrefix;
    return t && e.indexOf(t) !== 0 && (e = t + e), e;
  }
  getClass(e) {
    return this.classes[e] || "";
  }
  getIconClass(e, t) {
    let r;
    return t && this.rtlIconClasses ? r = this.rtlIconClasses[e] || this.iconClasses[e] : r = this.iconClasses[e], r ? `${this.baseIconClass} ${r}` : "";
  }
  getCustomButtonIconClass(e) {
    let t;
    return this.iconOverrideCustomButtonOption && (t = e[this.iconOverrideCustomButtonOption], t) ? `${this.baseIconClass} ${this.applyIconOverridePrefix(t)}` : "";
  }
}
Fc.prototype.classes = {};
Fc.prototype.iconClasses = {};
Fc.prototype.baseIconClass = "";
Fc.prototype.iconOverridePrefix = "";
function Ld(n) {
  n();
  let e = _e.debounceRendering, t = [];
  function r(i) {
    t.push(i);
  }
  for (_e.debounceRendering = r, pc(I(Uj, {}), document.createElement("div")); t.length; )
    t.shift()();
  _e.debounceRendering = e;
}
class Uj extends Rr {
  render() {
    return I("div", {});
  }
  componentDidMount() {
    this.setState({});
  }
}
function Q1(n) {
  let e = yB(n), t = e.Provider;
  return e.Provider = function() {
    let r = !this.getChildContext, i = t.apply(this, arguments);
    if (r) {
      let s = [];
      this.shouldComponentUpdate = (o) => {
        this.props.value !== o.value && s.forEach((a) => {
          a.context = o.value, a.forceUpdate();
        });
      }, this.sub = (o) => {
        s.push(o);
        let a = o.componentWillUnmount;
        o.componentWillUnmount = () => {
          s.splice(s.indexOf(o), 1), a && a.call(o);
        };
      };
    }
    return i;
  }, e;
}
class $j {
  constructor(e, t, r, i) {
    this.execFunc = e, this.emitter = t, this.scrollTime = r, this.scrollTimeReset = i, this.handleScrollRequest = (s) => {
      this.queuedRequest = Object.assign({}, this.queuedRequest || {}, s), this.drain();
    }, t.on("_scrollRequest", this.handleScrollRequest), this.fireInitialScroll();
  }
  detach() {
    this.emitter.off("_scrollRequest", this.handleScrollRequest);
  }
  update(e) {
    e && this.scrollTimeReset ? this.fireInitialScroll() : this.drain();
  }
  fireInitialScroll() {
    this.handleScrollRequest({
      time: this.scrollTime
    });
  }
  drain() {
    this.queuedRequest && this.execFunc(this.queuedRequest) && (this.queuedRequest = null);
  }
}
const ms = Q1({});
function Gj(n, e, t, r, i, s, o, a, c, u, f, h, p, g) {
  return {
    dateEnv: i,
    nowManager: s,
    options: t,
    pluginHooks: a,
    emitter: f,
    dispatch: c,
    getCurrentData: u,
    calendarApi: h,
    viewSpec: n,
    viewApi: e,
    dateProfileGenerator: r,
    theme: o,
    isRtl: t.direction === "rtl",
    addResizeHandler(y) {
      f.on("_resize", y);
    },
    removeResizeHandler(y) {
      f.off("_resize", y);
    },
    createScrollResponder(y) {
      return new $j(y, f, ot(t.scrollTime), t.scrollTimeReset);
    },
    registerInteractiveComponent: p,
    unregisterInteractiveComponent: g
  };
}
class Xo extends Rr {
  // debug: boolean
  shouldComponentUpdate(e, t) {
    return !_p(
      this.props,
      e,
      this.propEquality
      /*, this.debug */
    ) || !_p(
      this.state,
      t,
      this.stateEquality
      /*, this.debug */
    );
  }
  // HACK for freakin' React StrictMode
  safeSetState(e) {
    _p(this.state, Object.assign(Object.assign({}, this.state), e), this.stateEquality) || this.setState(e);
  }
}
Xo.addPropsEquality = Yj;
Xo.addStateEquality = qj;
Xo.contextType = ms;
Xo.prototype.propEquality = {};
Xo.prototype.stateEquality = {};
class pt extends Xo {
}
pt.contextType = ms;
function Yj(n) {
  let e = Object.create(this.prototype.propEquality);
  Object.assign(e, n), this.prototype.propEquality = e;
}
function qj(n) {
  let e = Object.create(this.prototype.stateEquality);
  Object.assign(e, n), this.prototype.stateEquality = e;
}
function _i(n, e) {
  typeof n == "function" ? n(e) : n && (n.current = e);
}
class Ty extends pt {
  constructor() {
    super(...arguments), this.id = Qo(), this.queuedDomNodes = [], this.currentDomNodes = [], this.handleEl = (e) => {
      const { options: t } = this.context, { generatorName: r } = this.props;
      (!t.customRenderingReplaces || !Zm(r, t)) && this.updateElRef(e);
    }, this.updateElRef = (e) => {
      this.props.elRef && _i(this.props.elRef, e);
    };
  }
  render() {
    const { props: e, context: t } = this, { options: r } = t, { customGenerator: i, defaultGenerator: s, renderProps: o } = e, a = Z1(e, [], this.handleEl);
    let c = !1, u, f = [], h;
    if (i != null) {
      const p = typeof i == "function" ? i(o, I) : i;
      if (p === !0)
        c = !0;
      else {
        const g = p && typeof p == "object";
        g && "html" in p ? a.dangerouslySetInnerHTML = { __html: p.html } : g && "domNodes" in p ? f = Array.prototype.slice.call(p.domNodes) : (g ? E1(p) : typeof p != "function") ? u = p : h = p;
      }
    } else
      c = !Zm(e.generatorName, r);
    return c && s && (u = s(o)), this.queuedDomNodes = f, this.currentGeneratorMeta = h, I(e.elTag, a, u);
  }
  componentDidMount() {
    this.applyQueueudDomNodes(), this.triggerCustomRendering(!0);
  }
  componentDidUpdate() {
    this.applyQueueudDomNodes(), this.triggerCustomRendering(!0);
  }
  componentWillUnmount() {
    this.triggerCustomRendering(!1);
  }
  triggerCustomRendering(e) {
    var t;
    const { props: r, context: i } = this, { handleCustomRendering: s, customRenderingMetaMap: o } = i.options;
    if (s) {
      const a = (t = this.currentGeneratorMeta) !== null && t !== void 0 ? t : o == null ? void 0 : o[r.generatorName];
      a && s(Object.assign(Object.assign({
        id: this.id,
        isActive: e,
        containerEl: this.base,
        reportNewContainerEl: this.updateElRef,
        // front-end framework tells us about new container els
        generatorMeta: a
      }, r), { elClasses: (r.elClasses || []).filter(Kj) }));
    }
  }
  applyQueueudDomNodes() {
    const { queuedDomNodes: e, currentDomNodes: t } = this, r = this.base;
    if (!Qs(e, t)) {
      t.forEach(BB);
      for (let i of e)
        r.appendChild(i);
      this.currentDomNodes = e;
    }
  }
}
Ty.addPropsEquality({
  elClasses: Qs,
  elStyle: pi,
  elAttrs: Nj,
  renderProps: pi
});
function Zm(n, e) {
  var t;
  return !!(e.handleCustomRendering && n && (!((t = e.customRenderingMetaMap) === null || t === void 0) && t[n]));
}
function Z1(n, e, t) {
  const r = Object.assign(Object.assign({}, n.elAttrs), { ref: t });
  return (n.elClasses || e) && (r.className = (n.elClasses || []).concat(e || []).concat(r.className || []).filter(Boolean).join(" ")), n.elStyle && (r.style = n.elStyle), r;
}
function Kj(n) {
  return !!n;
}
const X1 = Q1(0);
class Mr extends Rr {
  constructor() {
    super(...arguments), this.InnerContent = Jj.bind(void 0, this), this.handleEl = (e) => {
      this.el = e, this.props.elRef && (_i(this.props.elRef, e), e && this.didMountMisfire && this.componentDidMount());
    };
  }
  render() {
    const { props: e } = this, t = Qj(e.classNameGenerator, e.renderProps);
    if (e.children) {
      const r = Z1(e, t, this.handleEl), i = e.children(this.InnerContent, e.renderProps, r);
      return e.elTag ? I(e.elTag, r, i) : i;
    } else
      return I(Ty, Object.assign(Object.assign({}, e), { elRef: this.handleEl, elTag: e.elTag || "div", elClasses: (e.elClasses || []).concat(t), renderId: this.context }));
  }
  componentDidMount() {
    var e, t;
    this.el ? (t = (e = this.props).didMount) === null || t === void 0 || t.call(e, Object.assign(Object.assign({}, this.props.renderProps), { el: this.el })) : this.didMountMisfire = !0;
  }
  componentWillUnmount() {
    var e, t;
    (t = (e = this.props).willUnmount) === null || t === void 0 || t.call(e, Object.assign(Object.assign({}, this.props.renderProps), { el: this.el }));
  }
}
Mr.contextType = X1;
function Jj(n, e) {
  const t = n.props;
  return I(Ty, Object.assign({ renderProps: t.renderProps, generatorName: t.generatorName, customGenerator: t.customGenerator, defaultGenerator: t.defaultGenerator, renderId: n.context }, e));
}
function Qj(n, e) {
  const t = typeof n == "function" ? n(e) : n || [];
  return typeof t == "string" ? [t] : t;
}
class Bd extends pt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, i = { view: t.viewApi };
    return I(Mr, { elRef: e.elRef, elTag: e.elTag || "div", elAttrs: e.elAttrs, elClasses: [
      ...eT(e.viewSpec),
      ...e.elClasses || []
    ], elStyle: e.elStyle, renderProps: i, classNameGenerator: r.viewClassNames, generatorName: void 0, didMount: r.viewDidMount, willUnmount: r.viewWillUnmount }, () => e.children);
  }
}
function eT(n) {
  return [
    `fc-${n.type}-view`,
    "fc-view"
  ];
}
function Zj(n, e) {
  let t = null, r = null;
  return n.start && (t = e.createMarker(n.start)), n.end && (r = e.createMarker(n.end)), !t && !r || t && r && r < t ? null : { start: t, end: r };
}
function lS(n, e) {
  let t = [], { start: r } = e, i, s;
  for (n.sort(Xj), i = 0; i < n.length; i += 1)
    s = n[i], s.start > r && t.push({ start: r, end: s.start }), s.end > r && (r = s.end);
  return r < e.end && t.push({ start: r, end: e.end }), t;
}
function Xj(n, e) {
  return n.start.valueOf() - e.start.valueOf();
}
function Uo(n, e) {
  let { start: t, end: r } = n, i = null;
  return e.start !== null && (t === null ? t = e.start : t = new Date(Math.max(t.valueOf(), e.start.valueOf()))), e.end != null && (r === null ? r = e.end : r = new Date(Math.min(r.valueOf(), e.end.valueOf()))), (t === null || r === null || t < r) && (i = { start: t, end: r }), i;
}
function eF(n, e) {
  return (n.end === null || e.start === null || n.end > e.start) && (n.start === null || e.end === null || n.start < e.end);
}
function ns(n, e) {
  return (n.start === null || e >= n.start) && (n.end === null || e < n.end);
}
function tF(n, e) {
  return e.start != null && n < e.start ? e.start : e.end != null && n >= e.end ? new Date(e.end.valueOf() - 1) : n;
}
function tT(n) {
  let e = Math.floor(Zo(n.start, n.end)) || 1, t = Mt(n.start), r = vn(t, e);
  return { start: t, end: r };
}
function nT(n, e = ot(0)) {
  let t = null, r = null;
  if (n.end) {
    r = Mt(n.end);
    let i = n.end.valueOf() - r.valueOf();
    i && i >= di(e) && (r = vn(r, 1));
  }
  return n.start && (t = Mt(n.start), r && r <= t && (r = vn(t, 1))), { start: t, end: r };
}
function Fu(n, e, t, r) {
  return r === "year" ? ot(t.diffWholeYears(n, e), "year") : r === "month" ? ot(t.diffWholeMonths(n, e), "month") : lj(n, e);
}
class rT {
  constructor(e) {
    this.props = e, this.initHiddenDays();
  }
  /* Date Range Computation
  ------------------------------------------------------------------------------------------------------------------*/
  // Builds a structure with info about what the dates/ranges will be for the "prev" view.
  buildPrev(e, t, r) {
    let { dateEnv: i } = this.props, s = i.subtract(
      i.startOf(t, e.currentRangeUnit),
      // important for start-of-month
      e.dateIncrement
    );
    return this.build(s, -1, r);
  }
  // Builds a structure with info about what the dates/ranges will be for the "next" view.
  buildNext(e, t, r) {
    let { dateEnv: i } = this.props, s = i.add(
      i.startOf(t, e.currentRangeUnit),
      // important for start-of-month
      e.dateIncrement
    );
    return this.build(s, 1, r);
  }
  // Builds a structure holding dates/ranges for rendering around the given date.
  // Optional direction param indicates whether the date is being incremented/decremented
  // from its previous value. decremented = -1, incremented = 1 (default).
  build(e, t, r = !0) {
    let { props: i } = this, s, o, a, c, u, f;
    return s = this.buildValidRange(), s = this.trimHiddenDays(s), r && (e = tF(e, s)), o = this.buildCurrentRangeInfo(e, t), a = /^(year|month|week|day)$/.test(o.unit), c = this.buildRenderRange(this.trimHiddenDays(o.range), o.unit, a), c = this.trimHiddenDays(c), u = c, i.showNonCurrentDates || (u = Uo(u, o.range)), u = this.adjustActiveRange(u), u = Uo(u, s), f = eF(o.range, s), ns(c, e) || (e = c.start), {
      currentDate: e,
      // constraint for where prev/next operations can go and where events can be dragged/resized to.
      // an object with optional start and end properties.
      validRange: s,
      // range the view is formally responsible for.
      // for example, a month view might have 1st-31st, excluding padded dates
      currentRange: o.range,
      // name of largest unit being displayed, like "month" or "week"
      currentRangeUnit: o.unit,
      isRangeAllDay: a,
      // dates that display events and accept drag-n-drop
      // will be `null` if no dates accept events
      activeRange: u,
      // date range with a rendered skeleton
      // includes not-active days that need some sort of DOM
      renderRange: c,
      // Duration object that denotes the first visible time of any given day
      slotMinTime: i.slotMinTime,
      // Duration object that denotes the exclusive visible end time of any given day
      slotMaxTime: i.slotMaxTime,
      isValid: f,
      // how far the current date will move for a prev/next operation
      dateIncrement: this.buildDateIncrement(o.duration)
      // pass a fallback (might be null) ^
    };
  }
  // Builds an object with optional start/end properties.
  // Indicates the minimum/maximum dates to display.
  // not responsible for trimming hidden days.
  buildValidRange() {
    let e = this.props.validRangeInput, t = typeof e == "function" ? e.call(this.props.calendarApi, this.props.dateEnv.toDate(this.props.nowManager.getDateMarker())) : e;
    return this.refineRange(t) || { start: null, end: null };
  }
  // Builds a structure with info about the "current" range, the range that is
  // highlighted as being the current month for example.
  // See build() for a description of `direction`.
  // Guaranteed to have `range` and `unit` properties. `duration` is optional.
  buildCurrentRangeInfo(e, t) {
    let { props: r } = this, i = null, s = null, o = null, a;
    return r.duration ? (i = r.duration, s = r.durationUnit, o = this.buildRangeFromDuration(e, t, i, s)) : (a = this.props.dayCount) ? (s = "day", o = this.buildRangeFromDayCount(e, t, a)) : (o = this.buildCustomVisibleRange(e)) ? s = r.dateEnv.greatestWholeUnit(o.start, o.end).unit : (i = this.getFallbackDuration(), s = Qm(i).unit, o = this.buildRangeFromDuration(e, t, i, s)), { duration: i, unit: s, range: o };
  }
  getFallbackDuration() {
    return ot({ day: 1 });
  }
  // Returns a new activeRange to have time values (un-ambiguate)
  // slotMinTime or slotMaxTime causes the range to expand.
  adjustActiveRange(e) {
    let { dateEnv: t, usesMinMaxTime: r, slotMinTime: i, slotMaxTime: s } = this.props, { start: o, end: a } = e;
    return r && (Ha(i) < 0 && (o = Mt(o), o = t.add(o, i)), Ha(s) > 1 && (a = Mt(a), a = vn(a, -1), a = t.add(a, s))), { start: o, end: a };
  }
  // Builds the "current" range when it is specified as an explicit duration.
  // `unit` is the already-computed greatestDurationDenominator unit of duration.
  buildRangeFromDuration(e, t, r, i) {
    let { dateEnv: s, dateAlignment: o } = this.props, a, c, u;
    if (!o) {
      let { dateIncrement: h } = this.props;
      h && di(h) < di(r) ? o = Qm(h).unit : o = i;
    }
    Ha(r) <= 1 && this.isHiddenDay(a) && (a = this.skipHiddenDays(a, t), a = Mt(a));
    function f() {
      a = s.startOf(e, o), c = s.add(a, r), u = { start: a, end: c };
    }
    return f(), this.trimHiddenDays(u) || (e = this.skipHiddenDays(e, t), f()), u;
  }
  // Builds the "current" range when a dayCount is specified.
  buildRangeFromDayCount(e, t, r) {
    let { dateEnv: i, dateAlignment: s } = this.props, o = 0, a = e, c;
    s && (a = i.startOf(a, s)), a = Mt(a), a = this.skipHiddenDays(a, t), c = a;
    do
      c = vn(c, 1), this.isHiddenDay(c) || (o += 1);
    while (o < r);
    return { start: a, end: c };
  }
  // Builds a normalized range object for the "visible" range,
  // which is a way to define the currentRange and activeRange at the same time.
  buildCustomVisibleRange(e) {
    let { props: t } = this, r = t.visibleRangeInput, i = typeof r == "function" ? r.call(t.calendarApi, t.dateEnv.toDate(e)) : r, s = this.refineRange(i);
    return s && (s.start == null || s.end == null) ? null : s;
  }
  // Computes the range that will represent the element/cells for *rendering*,
  // but which may have voided days/times.
  // not responsible for trimming hidden days.
  buildRenderRange(e, t, r) {
    return e;
  }
  // Compute the duration value that should be added/substracted to the current date
  // when a prev/next operation happens.
  buildDateIncrement(e) {
    let { dateIncrement: t } = this.props, r;
    return t || ((r = this.props.dateAlignment) ? ot(1, r) : e || ot({ days: 1 }));
  }
  refineRange(e) {
    if (e) {
      let t = Zj(e, this.props.dateEnv);
      return t && (t = nT(t)), t;
    }
    return null;
  }
  /* Hidden Days
  ------------------------------------------------------------------------------------------------------------------*/
  // Initializes internal variables related to calculating hidden days-of-week
  initHiddenDays() {
    let e = this.props.hiddenDays || [], t = [], r = 0, i;
    for (this.props.weekends === !1 && e.push(0, 6), i = 0; i < 7; i += 1)
      (t[i] = e.indexOf(i) !== -1) || (r += 1);
    if (!r)
      throw new Error("invalid hiddenDays");
    this.isHiddenDayHash = t;
  }
  // Remove days from the beginning and end of the range that are computed as hidden.
  // If the whole range is trimmed off, returns null
  trimHiddenDays(e) {
    let { start: t, end: r } = e;
    return t && (t = this.skipHiddenDays(t)), r && (r = this.skipHiddenDays(r, -1, !0)), t == null || r == null || t < r ? { start: t, end: r } : null;
  }
  // Is the current day hidden?
  // `day` is a day-of-week index (0-6), or a Date (used for UTC)
  isHiddenDay(e) {
    return e instanceof Date && (e = e.getUTCDay()), this.isHiddenDayHash[e];
  }
  // Incrementing the current day until it is no longer a hidden day, returning a copy.
  // DOES NOT CONSIDER validRange!
  // If the initial value of `date` is not a hidden day, don't do anything.
  // Pass `isExclusive` as `true` if you are dealing with an end date.
  // `inc` defaults to `1` (increment one day forward each time)
  skipHiddenDays(e, t = 1, r = !1) {
    for (; this.isHiddenDayHash[(e.getUTCDay() + (r ? t : 0) + 7) % 7]; )
      e = vn(e, t);
    return e;
  }
}
function Cy(n, e, t, r) {
  return {
    instanceId: Qo(),
    defId: n,
    range: e,
    forcedStartTzo: t ?? null,
    forcedEndTzo: r ?? null
  };
}
function nF(n, e, t, r) {
  for (let i = 0; i < r.length; i += 1) {
    let s = r[i].parse(n, t);
    if (s) {
      let { allDay: o } = n;
      return o == null && (o = e, o == null && (o = s.allDayGuess, o == null && (o = !1))), {
        allDay: o,
        duration: s.duration,
        typeData: s.typeData,
        typeId: i
      };
    }
  }
  return null;
}
function zc(n, e, t) {
  let { dateEnv: r, pluginHooks: i, options: s } = t, { defs: o, instances: a } = n;
  a = Ka(a, (c) => !o[c.defId].recurringDef);
  for (let c in o) {
    let u = o[c];
    if (u.recurringDef) {
      let { duration: f } = u.recurringDef;
      f || (f = u.allDay ? s.defaultAllDayEventDuration : s.defaultTimedEventDuration);
      let h = rF(u, f, e, r, i.recurringTypes);
      for (let p of h) {
        let g = Cy(c, {
          start: p,
          end: r.add(p, f)
        });
        a[g.instanceId] = g;
      }
    }
  }
  return { defs: o, instances: a };
}
function rF(n, e, t, r, i) {
  let o = i[n.recurringDef.typeId].expand(n.recurringDef.typeData, {
    start: r.subtract(t.start, e),
    end: t.end
  }, r);
  return n.allDay && (o = o.map(Mt)), o;
}
const gd = {
  id: String,
  groupId: String,
  title: String,
  url: String,
  interactive: Boolean
}, iT = {
  start: U,
  end: U,
  date: U,
  allDay: Boolean
}, iF = Object.assign(Object.assign(Object.assign({}, gd), iT), { extendedProps: U });
function sT(n, e, t, r, i = Dy(t), s, o) {
  let { refined: a, extra: c } = oT(n, t, i), u = oF(e, t), f = nF(a, u, t.dateEnv, t.pluginHooks.recurringTypes);
  if (f) {
    let p = Xm(a, c, e ? e.sourceId : "", f.allDay, !!f.duration, t, s);
    return p.recurringDef = {
      typeId: f.typeId,
      typeData: f.typeData,
      duration: f.duration
    }, { def: p, instance: null };
  }
  let h = sF(a, u, t, r);
  if (h) {
    let p = Xm(a, c, e ? e.sourceId : "", h.allDay, h.hasEnd, t, s), g = Cy(p.defId, h.range, h.forcedStartTzo, h.forcedEndTzo);
    return o && p.publicId && o[p.publicId] && (g.instanceId = o[p.publicId]), { def: p, instance: g };
  }
  return null;
}
function oT(n, e, t = Dy(e)) {
  return wy(n, t);
}
function Dy(n) {
  return Object.assign(Object.assign(Object.assign({}, jd), iF), n.pluginHooks.eventRefiners);
}
function Xm(n, e, t, r, i, s, o) {
  let a = {
    title: n.title || "",
    groupId: n.groupId || "",
    publicId: n.id || "",
    url: n.url || "",
    recurringDef: null,
    defId: (o && n.id ? o[n.id] : "") || Qo(),
    sourceId: t,
    allDay: r,
    hasEnd: i,
    interactive: n.interactive,
    ui: Fd(n, s),
    extendedProps: Object.assign(Object.assign({}, n.extendedProps || {}), e)
  };
  for (let c of s.pluginHooks.eventDefMemberAdders)
    Object.assign(a, c(n));
  return Object.freeze(a.ui.classNames), Object.freeze(a.extendedProps), a;
}
function sF(n, e, t, r) {
  let { allDay: i } = n, s, o = null, a = !1, c, u = null, f = n.start != null ? n.start : n.date;
  if (s = t.dateEnv.createMarkerMeta(f), s)
    o = s.marker;
  else if (!r)
    return null;
  return n.end != null && (c = t.dateEnv.createMarkerMeta(n.end)), i == null && (e != null ? i = e : i = (!s || s.isTimeUnspecified) && (!c || c.isTimeUnspecified)), i && o && (o = Mt(o)), c && (u = c.marker, i && (u = Mt(u)), o && u <= o && (u = null)), u ? a = !0 : r || (a = t.options.forceEventDuration || !1, u = t.dateEnv.add(o, i ? t.options.defaultAllDayEventDuration : t.options.defaultTimedEventDuration)), {
    allDay: i,
    hasEnd: a,
    range: { start: o, end: u },
    forcedStartTzo: s ? s.forcedTzo : null,
    forcedEndTzo: c ? c.forcedTzo : null
  };
}
function oF(n, e) {
  let t = null;
  return n && (t = n.defaultAllDay), t == null && (t = e.options.defaultAllDay), t;
}
function mc(n, e, t, r, i, s) {
  let o = as(), a = Dy(t);
  for (let c of n) {
    let u = sT(c, e, t, r, a, i, s);
    u && eg(u, o);
  }
  return o;
}
function eg(n, e = as()) {
  return e.defs[n.def.defId] = n.def, n.instance && (e.instances[n.instance.instanceId] = n.instance), e;
}
function aF(n, e) {
  let t = n.instances[e];
  if (t) {
    let r = n.defs[t.defId], i = ky(n, (s) => lF(r, s));
    return i.defs[r.defId] = r, i.instances[t.instanceId] = t, i;
  }
  return as();
}
function lF(n, e) {
  return !!(n.groupId && n.groupId === e.groupId);
}
function as() {
  return { defs: {}, instances: {} };
}
function Ry(n, e) {
  return {
    defs: Object.assign(Object.assign({}, n.defs), e.defs),
    instances: Object.assign(Object.assign({}, n.instances), e.instances)
  };
}
function ky(n, e) {
  let t = Ka(n.defs, e), r = Ka(n.instances, (i) => t[i.defId]);
  return { defs: t, instances: r };
}
function cF(n, e) {
  let { defs: t, instances: r } = n, i = {}, s = {};
  for (let o in t)
    e.defs[o] || (i[o] = t[o]);
  for (let o in r)
    !e.instances[o] && // not explicitly excluded
    i[r[o].defId] && (s[o] = r[o]);
  return {
    defs: i,
    instances: s
  };
}
function uF(n, e) {
  return Array.isArray(n) ? mc(n, null, e, !0) : typeof n == "object" && n ? mc([n], null, e, !0) : n != null ? String(n) : null;
}
function cS(n) {
  return Array.isArray(n) ? n : typeof n == "string" ? n.split(/\s+/) : [];
}
const jd = {
  display: String,
  editable: Boolean,
  startEditable: Boolean,
  durationEditable: Boolean,
  constraint: U,
  overlap: U,
  allow: U,
  className: cS,
  classNames: cS,
  color: String,
  backgroundColor: String,
  borderColor: String,
  textColor: String
}, dF = {
  display: null,
  startEditable: null,
  durationEditable: null,
  constraints: [],
  overlap: null,
  allows: [],
  backgroundColor: "",
  borderColor: "",
  textColor: "",
  classNames: []
};
function Fd(n, e) {
  let t = uF(n.constraint, e);
  return {
    display: n.display || null,
    startEditable: n.startEditable != null ? n.startEditable : n.editable,
    durationEditable: n.durationEditable != null ? n.durationEditable : n.editable,
    constraints: t != null ? [t] : [],
    overlap: n.overlap != null ? n.overlap : null,
    allows: n.allow != null ? [n.allow] : [],
    backgroundColor: n.backgroundColor || n.color || "",
    borderColor: n.borderColor || n.color || "",
    textColor: n.textColor || "",
    classNames: (n.className || []).concat(n.classNames || [])
    // join singular and plural
  };
}
function aT(n) {
  return n.reduce(fF, dF);
}
function fF(n, e) {
  return {
    display: e.display != null ? e.display : n.display,
    startEditable: e.startEditable != null ? e.startEditable : n.startEditable,
    durationEditable: e.durationEditable != null ? e.durationEditable : n.durationEditable,
    constraints: n.constraints.concat(e.constraints),
    overlap: typeof e.overlap == "boolean" ? e.overlap : n.overlap,
    allows: n.allows.concat(e.allows),
    backgroundColor: e.backgroundColor || n.backgroundColor,
    borderColor: e.borderColor || n.borderColor,
    textColor: e.textColor || n.textColor,
    classNames: n.classNames.concat(e.classNames)
  };
}
const hF = {
  id: String,
  defaultAllDay: Boolean,
  url: String,
  format: String,
  events: U,
  eventDataTransform: U,
  // for any network-related sources
  success: U,
  failure: U
};
function lT(n, e, t = cT(e)) {
  let r;
  if (typeof n == "string" ? r = { url: n } : typeof n == "function" || Array.isArray(n) ? r = { events: n } : typeof n == "object" && n && (r = n), r) {
    let { refined: i, extra: s } = wy(r, t), o = pF(i, e);
    if (o)
      return {
        _raw: n,
        isFetching: !1,
        latestFetchId: "",
        fetchRange: null,
        defaultAllDay: i.defaultAllDay,
        eventDataTransform: i.eventDataTransform,
        success: i.success,
        failure: i.failure,
        publicId: i.id || "",
        sourceId: Qo(),
        sourceDefId: o.sourceDefId,
        meta: o.meta,
        ui: Fd(i, e),
        extendedProps: s
      };
  }
  return null;
}
function cT(n) {
  return Object.assign(Object.assign(Object.assign({}, jd), hF), n.pluginHooks.eventSourceRefiners);
}
function pF(n, e) {
  let t = e.pluginHooks.eventSourceDefs;
  for (let r = t.length - 1; r >= 0; r -= 1) {
    let s = t[r].parseMeta(n);
    if (s)
      return { sourceDefId: r, meta: s };
  }
  return null;
}
function mF(n, e, t, r, i) {
  switch (e.type) {
    case "RECEIVE_EVENTS":
      return gF(n, t[e.sourceId], e.fetchId, e.fetchRange, e.rawEvents, i);
    case "RESET_RAW_EVENTS":
      return yF(n, t[e.sourceId], e.rawEvents, r.activeRange, i);
    case "ADD_EVENTS":
      return vF(
        n,
        e.eventStore,
        // new ones
        r ? r.activeRange : null,
        i
      );
    case "RESET_EVENTS":
      return e.eventStore;
    case "MERGE_EVENTS":
      return Ry(n, e.eventStore);
    case "PREV":
    case "NEXT":
    case "CHANGE_DATE":
    case "CHANGE_VIEW_TYPE":
      return r ? zc(n, r.activeRange, i) : n;
    case "REMOVE_EVENTS":
      return cF(n, e.eventStore);
    case "REMOVE_EVENT_SOURCE":
      return dT(n, e.sourceId);
    case "REMOVE_ALL_EVENT_SOURCES":
      return ky(n, (s) => !s.sourceId);
    case "REMOVE_ALL_EVENTS":
      return as();
    default:
      return n;
  }
}
function gF(n, e, t, r, i, s) {
  if (e && // not already removed
  t === e.latestFetchId) {
    let o = mc(uT(i, e, s), e, s);
    return r && (o = zc(o, r, s)), Ry(dT(n, e.sourceId), o);
  }
  return n;
}
function yF(n, e, t, r, i) {
  const { defIdMap: s, instanceIdMap: o } = bF(n);
  let a = mc(uT(t, e, i), e, i, !1, s, o);
  return zc(a, r, i);
}
function uT(n, e, t) {
  let r = t.options.eventDataTransform, i = e ? e.eventDataTransform : null;
  return i && (n = uS(n, i)), r && (n = uS(n, r)), n;
}
function uS(n, e) {
  let t;
  if (!e)
    t = n;
  else {
    t = [];
    for (let r of n) {
      let i = e(r);
      i ? t.push(i) : i == null && t.push(r);
    }
  }
  return t;
}
function vF(n, e, t, r) {
  return t && (e = zc(e, t, r)), Ry(n, e);
}
function dS(n, e, t) {
  let { defs: r } = n, i = Wo(n.instances, (s) => r[s.defId].allDay ? s : Object.assign(Object.assign({}, s), { range: {
    start: t.createMarker(e.toDate(s.range.start, s.forcedStartTzo)),
    end: t.createMarker(e.toDate(s.range.end, s.forcedEndTzo))
  }, forcedStartTzo: t.canComputeOffset ? null : s.forcedStartTzo, forcedEndTzo: t.canComputeOffset ? null : s.forcedEndTzo }));
  return { defs: r, instances: i };
}
function dT(n, e) {
  return ky(n, (t) => t.sourceId !== e);
}
function bF(n) {
  const { defs: e, instances: t } = n, r = {}, i = {};
  for (let s in e) {
    const o = e[s], { publicId: a } = o;
    a && (r[a] = s);
  }
  for (let s in t) {
    const o = t[s], a = e[o.defId], { publicId: c } = a;
    c && (i[c] = s);
  }
  return { defIdMap: r, instanceIdMap: i };
}
class xF {
  constructor() {
    this.handlers = {}, this.thisContext = null;
  }
  setThisContext(e) {
    this.thisContext = e;
  }
  setOptions(e) {
    this.options = e;
  }
  on(e, t) {
    SF(this.handlers, e, t);
  }
  off(e, t) {
    wF(this.handlers, e, t);
  }
  trigger(e, ...t) {
    let r = this.handlers[e] || [], i = this.options && this.options[e], s = [].concat(i || [], r);
    for (let o of s)
      o.apply(this.thisContext, t);
  }
  hasHandlers(e) {
    return !!(this.handlers[e] && this.handlers[e].length || this.options && this.options[e]);
  }
}
function SF(n, e, t) {
  (n[e] || (n[e] = [])).push(t);
}
function wF(n, e, t) {
  t ? n[e] && (n[e] = n[e].filter((r) => r !== t)) : delete n[e];
}
const EF = {
  startTime: "09:00",
  endTime: "17:00",
  daysOfWeek: [1, 2, 3, 4, 5],
  display: "inverse-background",
  classNames: "fc-non-business",
  groupId: "_businessHours"
  // so multiple defs get grouped
};
function AF(n, e) {
  return mc(TF(n), null, e);
}
function TF(n) {
  let e;
  return n === !0 ? e = [{}] : Array.isArray(n) ? e = n.filter((t) => t.daysOfWeek) : typeof n == "object" && n ? e = [n] : e = [], e = e.map((t) => Object.assign(Object.assign({}, EF), t)), e;
}
function CF(n, e, t) {
  t.emitter.trigger("select", Object.assign(Object.assign({}, RF(n, t)), { jsEvent: null, view: t.viewApi || t.calendarApi.view }));
}
function DF(n, e) {
  e.emitter.trigger("unselect", {
    jsEvent: n ? n.origEvent : null,
    view: e.viewApi || e.calendarApi.view
  });
}
function RF(n, e) {
  let t = {};
  for (let r of e.pluginHooks.dateSpanTransforms)
    Object.assign(t, r(n, e));
  return Object.assign(t, VF(n, e.dateEnv)), t;
}
function fS(n, e, t) {
  let { dateEnv: r, options: i } = t, s = e;
  return n ? (s = Mt(s), s = r.add(s, i.defaultAllDayEventDuration)) : s = r.add(s, i.defaultTimedEventDuration), s;
}
function kF(n, e, t, r) {
  let i = hT(n.defs, e), s = as();
  for (let o in n.defs) {
    let a = n.defs[o];
    s.defs[o] = MF(a, i[o], t, r);
  }
  for (let o in n.instances) {
    let a = n.instances[o], c = s.defs[a.defId];
    s.instances[o] = _F(a, c, i[a.defId], t, r);
  }
  return s;
}
function MF(n, e, t, r) {
  let i = t.standardProps || {};
  i.hasEnd == null && e.durationEditable && (t.startDelta || t.endDelta) && (i.hasEnd = !0);
  let s = Object.assign(Object.assign(Object.assign({}, n), i), { ui: Object.assign(Object.assign({}, n.ui), i.ui) });
  t.extendedProps && (s.extendedProps = Object.assign(Object.assign({}, s.extendedProps), t.extendedProps));
  for (let o of r.pluginHooks.eventDefMutationAppliers)
    o(s, t, r);
  return !s.hasEnd && r.options.forceEventDuration && (s.hasEnd = !0), s;
}
function _F(n, e, t, r, i) {
  let { dateEnv: s } = i, o = r.standardProps && r.standardProps.allDay === !0, a = r.standardProps && r.standardProps.hasEnd === !1, c = Object.assign({}, n);
  return o && (c.range = tT(c.range)), r.datesDelta && t.startEditable && (c.range = {
    start: s.add(c.range.start, r.datesDelta),
    end: s.add(c.range.end, r.datesDelta)
  }), r.startDelta && t.durationEditable && (c.range = {
    start: s.add(c.range.start, r.startDelta),
    end: c.range.end
  }), r.endDelta && t.durationEditable && (c.range = {
    start: c.range.start,
    end: s.add(c.range.end, r.endDelta)
  }), a && (c.range = {
    start: c.range.start,
    end: fS(e.allDay, c.range.start, i)
  }), e.allDay && (c.range = {
    start: Mt(c.range.start),
    end: Mt(c.range.end)
  }), c.range.end < c.range.start && (c.range.end = fS(e.allDay, c.range.start, i)), c;
}
class ka {
  constructor(e, t) {
    this.context = e, this.internalEventSource = t;
  }
  remove() {
    this.context.dispatch({
      type: "REMOVE_EVENT_SOURCE",
      sourceId: this.internalEventSource.sourceId
    });
  }
  refetch() {
    this.context.dispatch({
      type: "FETCH_EVENT_SOURCES",
      sourceIds: [this.internalEventSource.sourceId],
      isRefetch: !0
    });
  }
  get id() {
    return this.internalEventSource.publicId;
  }
  get url() {
    return this.internalEventSource.meta.url;
  }
  get format() {
    return this.internalEventSource.meta.format;
  }
}
class qr {
  // instance will be null if expressing a recurring event that has no current instances,
  // OR if trying to validate an incoming external event that has no dates assigned
  constructor(e, t, r) {
    this._context = e, this._def = t, this._instance = r || null;
  }
  /*
  TODO: make event struct more responsible for this
  */
  setProp(e, t) {
    if (e in iT)
      console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
    else if (e === "id")
      t = gd[e](t), this.mutate({
        standardProps: { publicId: t }
        // hardcoded internal name
      });
    else if (e in gd)
      t = gd[e](t), this.mutate({
        standardProps: { [e]: t }
      });
    else if (e in jd) {
      let r = jd[e](t);
      e === "color" ? r = { backgroundColor: t, borderColor: t } : e === "editable" ? r = { startEditable: t, durationEditable: t } : r = { [e]: t }, this.mutate({
        standardProps: { ui: r }
      });
    } else
      console.warn(`Could not set prop '${e}'. Use setExtendedProp instead.`);
  }
  setExtendedProp(e, t) {
    this.mutate({
      extendedProps: { [e]: t }
    });
  }
  setStart(e, t = {}) {
    let { dateEnv: r } = this._context, i = r.createMarker(e);
    if (i && this._instance) {
      let s = this._instance.range, o = Fu(s.start, i, r, t.granularity);
      t.maintainDuration ? this.mutate({ datesDelta: o }) : this.mutate({ startDelta: o });
    }
  }
  setEnd(e, t = {}) {
    let { dateEnv: r } = this._context, i;
    if (!(e != null && (i = r.createMarker(e), !i)) && this._instance)
      if (i) {
        let s = Fu(this._instance.range.end, i, r, t.granularity);
        this.mutate({ endDelta: s });
      } else
        this.mutate({ standardProps: { hasEnd: !1 } });
  }
  setDates(e, t, r = {}) {
    let { dateEnv: i } = this._context, s = { allDay: r.allDay }, o = i.createMarker(e), a;
    if (o && !(t != null && (a = i.createMarker(t), !a)) && this._instance) {
      let c = this._instance.range;
      r.allDay === !0 && (c = tT(c));
      let u = Fu(c.start, o, i, r.granularity);
      if (a) {
        let f = Fu(c.end, a, i, r.granularity);
        ZB(u, f) ? this.mutate({ datesDelta: u, standardProps: s }) : this.mutate({ startDelta: u, endDelta: f, standardProps: s });
      } else
        s.hasEnd = !1, this.mutate({ datesDelta: u, standardProps: s });
    }
  }
  moveStart(e) {
    let t = ot(e);
    t && this.mutate({ startDelta: t });
  }
  moveEnd(e) {
    let t = ot(e);
    t && this.mutate({ endDelta: t });
  }
  moveDates(e) {
    let t = ot(e);
    t && this.mutate({ datesDelta: t });
  }
  setAllDay(e, t = {}) {
    let r = { allDay: e }, { maintainDuration: i } = t;
    i == null && (i = this._context.options.allDayMaintainDuration), this._def.allDay !== e && (r.hasEnd = i), this.mutate({ standardProps: r });
  }
  formatRange(e) {
    let { dateEnv: t } = this._context, r = this._instance, i = Ht(e);
    return this._def.hasEnd ? t.formatRange(r.range.start, r.range.end, i, {
      forcedStartTzo: r.forcedStartTzo,
      forcedEndTzo: r.forcedEndTzo
    }) : t.format(r.range.start, i, {
      forcedTzo: r.forcedStartTzo
    });
  }
  mutate(e) {
    let t = this._instance;
    if (t) {
      let r = this._def, i = this._context, { eventStore: s } = i.getCurrentData(), o = aF(s, t.instanceId);
      o = kF(o, {
        "": {
          display: "",
          startEditable: !0,
          durationEditable: !0,
          constraints: [],
          overlap: null,
          allows: [],
          backgroundColor: "",
          borderColor: "",
          textColor: "",
          classNames: []
        }
      }, e, i);
      let c = new qr(i, r, t);
      this._def = o.defs[r.defId], this._instance = o.instances[t.instanceId], i.dispatch({
        type: "MERGE_EVENTS",
        eventStore: o
      }), i.emitter.trigger("eventChange", {
        oldEvent: c,
        event: this,
        relatedEvents: My(o, i, t),
        revert() {
          i.dispatch({
            type: "RESET_EVENTS",
            eventStore: s
            // the ORIGINAL store
          });
        }
      });
    }
  }
  remove() {
    let e = this._context, t = fT(this);
    e.dispatch({
      type: "REMOVE_EVENTS",
      eventStore: t
    }), e.emitter.trigger("eventRemove", {
      event: this,
      relatedEvents: [],
      revert() {
        e.dispatch({
          type: "MERGE_EVENTS",
          eventStore: t
        });
      }
    });
  }
  get source() {
    let { sourceId: e } = this._def;
    return e ? new ka(this._context, this._context.getCurrentData().eventSources[e]) : null;
  }
  get start() {
    return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
  }
  get end() {
    return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
  }
  get startStr() {
    let e = this._instance;
    return e ? this._context.dateEnv.formatIso(e.range.start, {
      omitTime: this._def.allDay,
      forcedTzo: e.forcedStartTzo
    }) : "";
  }
  get endStr() {
    let e = this._instance;
    return e && this._def.hasEnd ? this._context.dateEnv.formatIso(e.range.end, {
      omitTime: this._def.allDay,
      forcedTzo: e.forcedEndTzo
    }) : "";
  }
  // computable props that all access the def
  // TODO: find a TypeScript-compatible way to do this at scale
  get id() {
    return this._def.publicId;
  }
  get groupId() {
    return this._def.groupId;
  }
  get allDay() {
    return this._def.allDay;
  }
  get title() {
    return this._def.title;
  }
  get url() {
    return this._def.url;
  }
  get display() {
    return this._def.ui.display || "auto";
  }
  // bad. just normalize the type earlier
  get startEditable() {
    return this._def.ui.startEditable;
  }
  get durationEditable() {
    return this._def.ui.durationEditable;
  }
  get constraint() {
    return this._def.ui.constraints[0] || null;
  }
  get overlap() {
    return this._def.ui.overlap;
  }
  get allow() {
    return this._def.ui.allows[0] || null;
  }
  get backgroundColor() {
    return this._def.ui.backgroundColor;
  }
  get borderColor() {
    return this._def.ui.borderColor;
  }
  get textColor() {
    return this._def.ui.textColor;
  }
  // NOTE: user can't modify these because Object.freeze was called in event-def parsing
  get classNames() {
    return this._def.ui.classNames;
  }
  get extendedProps() {
    return this._def.extendedProps;
  }
  toPlainObject(e = {}) {
    let t = this._def, { ui: r } = t, { startStr: i, endStr: s } = this, o = {
      allDay: t.allDay
    };
    return t.title && (o.title = t.title), i && (o.start = i), s && (o.end = s), t.publicId && (o.id = t.publicId), t.groupId && (o.groupId = t.groupId), t.url && (o.url = t.url), r.display && r.display !== "auto" && (o.display = r.display), e.collapseColor && r.backgroundColor && r.backgroundColor === r.borderColor ? o.color = r.backgroundColor : (r.backgroundColor && (o.backgroundColor = r.backgroundColor), r.borderColor && (o.borderColor = r.borderColor)), r.textColor && (o.textColor = r.textColor), r.classNames.length && (o.classNames = r.classNames), Object.keys(t.extendedProps).length && (e.collapseExtendedProps ? Object.assign(o, t.extendedProps) : o.extendedProps = t.extendedProps), o;
  }
  toJSON() {
    return this.toPlainObject();
  }
}
function fT(n) {
  let e = n._def, t = n._instance;
  return {
    defs: { [e.defId]: e },
    instances: t ? { [t.instanceId]: t } : {}
  };
}
function My(n, e, t) {
  let { defs: r, instances: i } = n, s = [], o = t ? t.instanceId : "";
  for (let a in i) {
    let c = i[a], u = r[c.defId];
    c.instanceId !== o && s.push(new qr(e, u, c));
  }
  return s;
}
function hS(n, e, t, r) {
  let i = {}, s = {}, o = {}, a = [], c = [], u = hT(n.defs, e);
  for (let f in n.defs) {
    let h = n.defs[f];
    u[h.defId].display === "inverse-background" && (h.groupId ? (i[h.groupId] = [], o[h.groupId] || (o[h.groupId] = h)) : s[f] = []);
  }
  for (let f in n.instances) {
    let h = n.instances[f], p = n.defs[h.defId], g = u[p.defId], y = h.range, x = !p.allDay && r ? nT(y, r) : y, S = Uo(x, t);
    S && (g.display === "inverse-background" ? p.groupId ? i[p.groupId].push(S) : s[h.defId].push(S) : g.display !== "none" && (g.display === "background" ? a : c).push({
      def: p,
      ui: g,
      instance: h,
      range: S,
      isStart: x.start && x.start.valueOf() === S.start.valueOf(),
      isEnd: x.end && x.end.valueOf() === S.end.valueOf()
    }));
  }
  for (let f in i) {
    let h = i[f], p = lS(h, t);
    for (let g of p) {
      let y = o[f], x = u[y.defId];
      a.push({
        def: y,
        ui: x,
        instance: null,
        range: g,
        isStart: !1,
        isEnd: !1
      });
    }
  }
  for (let f in s) {
    let h = s[f], p = lS(h, t);
    for (let g of p)
      a.push({
        def: n.defs[f],
        ui: u[f],
        instance: null,
        range: g,
        isStart: !1,
        isEnd: !1
      });
  }
  return { bg: a, fg: c };
}
function OF(n) {
  return n.ui.display === "background" || n.ui.display === "inverse-background";
}
function pS(n, e) {
  n.fcSeg = e;
}
function tg(n) {
  return n.fcSeg || n.parentNode.fcSeg || // for the harness
  null;
}
function hT(n, e) {
  return Wo(n, (t) => pT(t, e));
}
function pT(n, e) {
  let t = [];
  return e[""] && t.push(e[""]), e[n.defId] && t.push(e[n.defId]), t.push(n.ui), aT(t);
}
function mT(n, e) {
  let t = n.map(IF);
  return t.sort((r, i) => GB(r, i, e)), t.map((r) => r._seg);
}
function IF(n) {
  let { eventRange: e } = n, t = e.def, r = e.instance ? e.instance.range : e.range, i = r.start ? r.start.valueOf() : 0, s = r.end ? r.end.valueOf() : 0;
  return Object.assign(Object.assign(Object.assign({}, t.extendedProps), t), {
    id: t.publicId,
    start: i,
    end: s,
    duration: s - i,
    allDay: Number(t.allDay),
    _seg: n
  });
}
function NF(n, e) {
  let { pluginHooks: t } = e, r = t.isDraggableTransformers, { def: i, ui: s } = n.eventRange, o = s.startEditable;
  for (let a of r)
    o = a(o, i, s, e);
  return o;
}
function PF(n, e) {
  return n.isStart && n.eventRange.ui.durationEditable && e.options.eventResizableFromStart;
}
function LF(n, e) {
  return n.isEnd && n.eventRange.ui.durationEditable;
}
function gT(n, e, t, r, i, s, o) {
  let { dateEnv: a, options: c } = t, { displayEventTime: u, displayEventEnd: f } = c, h = n.eventRange.def, p = n.eventRange.instance;
  u == null && (u = r !== !1), f == null && (f = i !== !1);
  let g = p.range.start, y = p.range.end, x = n.start || n.eventRange.range.start, S = n.end || n.eventRange.range.end, w = Mt(g).valueOf() === Mt(x).valueOf(), C = Mt(Zs(y, -1)).valueOf() === Mt(Zs(S, -1)).valueOf();
  return u && !h.allDay && (w || C) ? (x = w ? g : x, S = C ? y : S, f && h.hasEnd ? a.formatRange(x, S, e, {
    forcedStartTzo: p.forcedStartTzo,
    forcedEndTzo: p.forcedEndTzo
  }) : a.format(x, e, {
    forcedTzo: p.forcedStartTzo
    // nooooo, same
  })) : "";
}
function $s(n, e, t) {
  let r = n.eventRange.range;
  return {
    isPast: r.end <= (t || e.start),
    isFuture: r.start >= (t || e.end),
    isToday: e && ns(e, r.start)
  };
}
function BF(n) {
  let e = ["fc-event"];
  return n.isMirror && e.push("fc-event-mirror"), n.isDraggable && e.push("fc-event-draggable"), (n.isStartResizable || n.isEndResizable) && e.push("fc-event-resizable"), n.isDragging && e.push("fc-event-dragging"), n.isResizing && e.push("fc-event-resizing"), n.isSelected && e.push("fc-event-selected"), n.isStart && e.push("fc-event-start"), n.isEnd && e.push("fc-event-end"), n.isPast && e.push("fc-event-past"), n.isToday && e.push("fc-event-today"), n.isFuture && e.push("fc-event-future"), e;
}
function yT(n) {
  return n.instance ? n.instance.instanceId : `${n.def.defId}:${n.range.start.toISOString()}`;
}
function vT(n, e) {
  let { def: t, instance: r } = n.eventRange, { url: i } = t;
  if (i)
    return { href: i };
  let { emitter: s, options: o } = e, { eventInteractive: a } = o;
  return a == null && (a = t.interactive, a == null && (a = !!s.hasHandlers("eventClick"))), a ? G1((c) => {
    s.trigger("eventClick", {
      el: c.target,
      event: new qr(e, t, r),
      jsEvent: c,
      view: e.viewApi
    });
  }) : {};
}
const jF = {
  start: U,
  end: U,
  allDay: Boolean
};
function FF(n, e, t) {
  let r = zF(n, e), { range: i } = r;
  if (!i.start)
    return null;
  if (!i.end) {
    if (t == null)
      return null;
    i.end = e.add(i.start, t);
  }
  return r;
}
function zF(n, e) {
  let { refined: t, extra: r } = wy(n, jF), i = t.start ? e.createMarkerMeta(t.start) : null, s = t.end ? e.createMarkerMeta(t.end) : null, { allDay: o } = t;
  return o == null && (o = i && i.isTimeUnspecified && (!s || s.isTimeUnspecified)), Object.assign({ range: {
    start: i ? i.marker : null,
    end: s ? s.marker : null
  }, allDay: o }, r);
}
function VF(n, e) {
  return Object.assign(Object.assign({}, xT(n.range, e, n.allDay)), { allDay: n.allDay });
}
function bT(n, e, t) {
  return Object.assign(Object.assign({}, xT(n, e, t)), { timeZone: e.timeZone });
}
function xT(n, e, t) {
  return {
    start: e.toDate(n.start),
    end: e.toDate(n.end),
    startStr: e.formatIso(n.start, { omitTime: t }),
    endStr: e.formatIso(n.end, { omitTime: t })
  };
}
function HF(n, e, t) {
  let r = oT({ editable: !1 }, t), i = Xm(
    r.refined,
    r.extra,
    "",
    // sourceId
    n.allDay,
    !0,
    // hasEnd
    t
  );
  return {
    def: i,
    ui: pT(i, e),
    instance: Cy(i.defId, n.range),
    range: n.range,
    isStart: !0,
    isEnd: !0
  };
}
function WF(n, e, t) {
  let r = !1, i = function(a) {
    r || (r = !0, e(a));
  }, s = function(a) {
    r || (r = !0, t(a));
  }, o = n(i, s);
  o && typeof o.then == "function" && o.then(i, s);
}
class mS extends Error {
  constructor(e, t) {
    super(e), this.response = t;
  }
}
function UF(n, e, t) {
  n = n.toUpperCase();
  const r = {
    method: n
  };
  return n === "GET" ? e += (e.indexOf("?") === -1 ? "?" : "&") + new URLSearchParams(t) : (r.body = new URLSearchParams(t), r.headers = {
    "Content-Type": "application/x-www-form-urlencoded"
  }), fetch(e, r).then((i) => {
    if (i.ok)
      return i.json().then((s) => [s, i], () => {
        throw new mS("Failure parsing JSON", i);
      });
    throw new mS("Request failed", i);
  });
}
let Op;
function ST() {
  return Op == null && (Op = $F()), Op;
}
function $F() {
  if (typeof document > "u")
    return !0;
  let n = document.createElement("div");
  n.style.position = "absolute", n.style.top = "0px", n.style.left = "0px", n.innerHTML = "<table><tr><td><div></div></td></tr></table>", n.querySelector("table").style.height = "100px", n.querySelector("div").style.height = "100%", document.body.appendChild(n);
  let t = n.querySelector("div").offsetHeight > 0;
  return document.body.removeChild(n), t;
}
class GF extends pt {
  constructor() {
    super(...arguments), this.state = {
      forPrint: !1
    }, this.handleBeforePrint = () => {
      Ld(() => {
        this.setState({ forPrint: !0 });
      });
    }, this.handleAfterPrint = () => {
      Ld(() => {
        this.setState({ forPrint: !1 });
      });
    };
  }
  render() {
    let { props: e } = this, { options: t } = e, { forPrint: r } = this.state, i = r || t.height === "auto" || t.contentHeight === "auto", s = !i && t.height != null ? t.height : "", o = [
      "fc",
      r ? "fc-media-print" : "fc-media-screen",
      `fc-direction-${t.direction}`,
      e.theme.getClass("root")
    ];
    return ST() || o.push("fc-liquid-hack"), e.children(o, s, i, r);
  }
  componentDidMount() {
    let { emitter: e } = this.props;
    e.on("_beforeprint", this.handleBeforePrint), e.on("_afterprint", this.handleAfterPrint);
  }
  componentWillUnmount() {
    let { emitter: e } = this.props;
    e.off("_beforeprint", this.handleBeforePrint), e.off("_afterprint", this.handleAfterPrint);
  }
}
class wT {
  constructor(e) {
    this.component = e.component, this.isHitComboAllowed = e.isHitComboAllowed || null;
  }
  destroy() {
  }
}
function YF(n, e) {
  return {
    component: n,
    el: e.el,
    useEventCenter: e.useEventCenter != null ? e.useEventCenter : !0,
    isHitComboAllowed: e.isHitComboAllowed || null
  };
}
const gS = {};
class rl extends Rr {
  constructor(e, t) {
    super(e, t), this.handleRefresh = () => {
      let r = this.computeTiming();
      r.state.nowDate.valueOf() !== this.state.nowDate.valueOf() && this.setState(r.state), this.clearTimeout(), this.setTimeout(r.waitMs);
    }, this.handleVisibilityChange = () => {
      document.hidden || this.handleRefresh();
    }, this.state = this.computeTiming().state;
  }
  render() {
    let { props: e, state: t } = this;
    return e.children(t.nowDate, t.todayRange);
  }
  componentDidMount() {
    this.setTimeout(), this.context.nowManager.addResetListener(this.handleRefresh), document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }
  componentDidUpdate(e) {
    e.unit !== this.props.unit && (this.clearTimeout(), this.setTimeout());
  }
  componentWillUnmount() {
    this.clearTimeout(), this.context.nowManager.removeResetListener(this.handleRefresh), document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
  computeTiming() {
    let { props: e, context: t } = this, r = t.nowManager.getDateMarker(), { nowIndicatorSnap: i } = t.options;
    i === "auto" && (i = // large unit?
    /year|month|week|day/.test(e.unit) || // if slotDuration 30 mins for example, would NOT appear to snap (legacy behavior)
    (e.unitValue || 1) === 1);
    let s, o;
    return i ? (s = t.dateEnv.startOf(r, e.unit), o = t.dateEnv.add(s, ot(1, e.unit)).valueOf() - r.valueOf()) : (s = r, o = 1e3 * 60), o = Math.min(1e3 * 60 * 60 * 24, o), {
      state: { nowDate: s, todayRange: qF(s) },
      waitMs: o
    };
  }
  setTimeout(e = this.computeTiming().waitMs) {
    this.timeoutId = setTimeout(() => {
      const t = this.computeTiming();
      this.setState(t.state, () => {
        this.setTimeout(t.waitMs);
      });
    }, e);
  }
  clearTimeout() {
    this.timeoutId && clearTimeout(this.timeoutId);
  }
}
rl.contextType = ms;
function qF(n) {
  let e = Mt(n), t = vn(e, 1);
  return { start: e, end: t };
}
class KF {
  getCurrentData() {
    return this.currentDataManager.getCurrentData();
  }
  dispatch(e) {
    this.currentDataManager.dispatch(e);
  }
  get view() {
    return this.getCurrentData().viewApi;
  }
  batchRendering(e) {
    e();
  }
  updateSize() {
    this.trigger("_resize", !0);
  }
  // Options
  // -----------------------------------------------------------------------------------------------------------------
  setOption(e, t) {
    this.dispatch({
      type: "SET_OPTION",
      optionName: e,
      rawOptionValue: t
    });
  }
  getOption(e) {
    return this.currentDataManager.currentCalendarOptionsInput[e];
  }
  getAvailableLocaleCodes() {
    return Object.keys(this.getCurrentData().availableRawLocales);
  }
  // Trigger
  // -----------------------------------------------------------------------------------------------------------------
  on(e, t) {
    let { currentDataManager: r } = this;
    r.currentCalendarOptionsRefiners[e] ? r.emitter.on(e, t) : console.warn(`Unknown listener name '${e}'`);
  }
  off(e, t) {
    this.currentDataManager.emitter.off(e, t);
  }
  // not meant for public use
  trigger(e, ...t) {
    this.currentDataManager.emitter.trigger(e, ...t);
  }
  // View
  // -----------------------------------------------------------------------------------------------------------------
  changeView(e, t) {
    this.batchRendering(() => {
      if (this.unselect(), t)
        if (t.start && t.end)
          this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: e
          }), this.dispatch({
            type: "SET_OPTION",
            optionName: "visibleRange",
            rawOptionValue: t
          });
        else {
          let { dateEnv: r } = this.getCurrentData();
          this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: e,
            dateMarker: r.createMarker(t)
          });
        }
      else
        this.dispatch({
          type: "CHANGE_VIEW_TYPE",
          viewType: e
        });
    });
  }
  // Forces navigation to a view for the given date.
  // `viewType` can be a specific view name or a generic one like "week" or "day".
  // needs to change
  zoomTo(e, t) {
    let r = this.getCurrentData(), i;
    t = t || "day", i = r.viewSpecs[t] || this.getUnitViewSpec(t), this.unselect(), i ? this.dispatch({
      type: "CHANGE_VIEW_TYPE",
      viewType: i.type,
      dateMarker: e
    }) : this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e
    });
  }
  // Given a duration singular unit, like "week" or "day", finds a matching view spec.
  // Preference is given to views that have corresponding buttons.
  getUnitViewSpec(e) {
    let { viewSpecs: t, toolbarConfig: r } = this.getCurrentData(), i = [].concat(r.header ? r.header.viewsWithButtons : [], r.footer ? r.footer.viewsWithButtons : []), s, o;
    for (let a in t)
      i.push(a);
    for (s = 0; s < i.length; s += 1)
      if (o = t[i[s]], o && o.singleUnit === e)
        return o;
    return null;
  }
  // Current Date
  // -----------------------------------------------------------------------------------------------------------------
  prev() {
    this.unselect(), this.dispatch({ type: "PREV" });
  }
  next() {
    this.unselect(), this.dispatch({ type: "NEXT" });
  }
  prevYear() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.dateEnv.addYears(e.currentDate, -1)
    });
  }
  nextYear() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.dateEnv.addYears(e.currentDate, 1)
    });
  }
  today() {
    let e = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: e.nowManager.getDateMarker()
    });
  }
  gotoDate(e) {
    let t = this.getCurrentData();
    this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: t.dateEnv.createMarker(e)
    });
  }
  incrementDate(e) {
    let t = this.getCurrentData(), r = ot(e);
    r && (this.unselect(), this.dispatch({
      type: "CHANGE_DATE",
      dateMarker: t.dateEnv.add(t.currentDate, r)
    }));
  }
  getDate() {
    let e = this.getCurrentData();
    return e.dateEnv.toDate(e.currentDate);
  }
  // Date Formatting Utils
  // -----------------------------------------------------------------------------------------------------------------
  formatDate(e, t) {
    let { dateEnv: r } = this.getCurrentData();
    return r.format(r.createMarker(e), Ht(t));
  }
  // `settings` is for formatter AND isEndExclusive
  formatRange(e, t, r) {
    let { dateEnv: i } = this.getCurrentData();
    return i.formatRange(i.createMarker(e), i.createMarker(t), Ht(r), r);
  }
  formatIso(e, t) {
    let { dateEnv: r } = this.getCurrentData();
    return r.formatIso(r.createMarker(e), { omitTime: t });
  }
  // Date Selection / Event Selection / DayClick
  // -----------------------------------------------------------------------------------------------------------------
  select(e, t) {
    let r;
    t == null ? e.start != null ? r = e : r = {
      start: e,
      end: null
    } : r = {
      start: e,
      end: t
    };
    let i = this.getCurrentData(), s = FF(r, i.dateEnv, ot({ days: 1 }));
    s && (this.dispatch({ type: "SELECT_DATES", selection: s }), CF(s, null, i));
  }
  unselect(e) {
    let t = this.getCurrentData();
    t.dateSelection && (this.dispatch({ type: "UNSELECT_DATES" }), DF(e, t));
  }
  // Public Events API
  // -----------------------------------------------------------------------------------------------------------------
  addEvent(e, t) {
    if (e instanceof qr) {
      let o = e._def, a = e._instance;
      return this.getCurrentData().eventStore.defs[o.defId] || (this.dispatch({
        type: "ADD_EVENTS",
        eventStore: eg({ def: o, instance: a })
        // TODO: better util for two args?
      }), this.triggerEventAdd(e)), e;
    }
    let r = this.getCurrentData(), i;
    if (t instanceof ka)
      i = t.internalEventSource;
    else if (typeof t == "boolean")
      t && ([i] = Ay(r.eventSources));
    else if (t != null) {
      let o = this.getEventSourceById(t);
      if (!o)
        return console.warn(`Could not find an event source with ID "${t}"`), null;
      i = o.internalEventSource;
    }
    let s = sT(e, i, r, !1);
    if (s) {
      let o = new qr(r, s.def, s.def.recurringDef ? null : s.instance);
      return this.dispatch({
        type: "ADD_EVENTS",
        eventStore: eg(s)
      }), this.triggerEventAdd(o), o;
    }
    return null;
  }
  triggerEventAdd(e) {
    let { emitter: t } = this.getCurrentData();
    t.trigger("eventAdd", {
      event: e,
      relatedEvents: [],
      revert: () => {
        this.dispatch({
          type: "REMOVE_EVENTS",
          eventStore: fT(e)
        });
      }
    });
  }
  // TODO: optimize
  getEventById(e) {
    let t = this.getCurrentData(), { defs: r, instances: i } = t.eventStore;
    e = String(e);
    for (let s in r) {
      let o = r[s];
      if (o.publicId === e) {
        if (o.recurringDef)
          return new qr(t, o, null);
        for (let a in i) {
          let c = i[a];
          if (c.defId === o.defId)
            return new qr(t, o, c);
        }
      }
    }
    return null;
  }
  getEvents() {
    let e = this.getCurrentData();
    return My(e.eventStore, e);
  }
  removeAllEvents() {
    this.dispatch({ type: "REMOVE_ALL_EVENTS" });
  }
  // Public Event Sources API
  // -----------------------------------------------------------------------------------------------------------------
  getEventSources() {
    let e = this.getCurrentData(), t = e.eventSources, r = [];
    for (let i in t)
      r.push(new ka(e, t[i]));
    return r;
  }
  getEventSourceById(e) {
    let t = this.getCurrentData(), r = t.eventSources;
    e = String(e);
    for (let i in r)
      if (r[i].publicId === e)
        return new ka(t, r[i]);
    return null;
  }
  addEventSource(e) {
    let t = this.getCurrentData();
    if (e instanceof ka)
      return t.eventSources[e.internalEventSource.sourceId] || this.dispatch({
        type: "ADD_EVENT_SOURCES",
        sources: [e.internalEventSource]
      }), e;
    let r = lT(e, t);
    return r ? (this.dispatch({ type: "ADD_EVENT_SOURCES", sources: [r] }), new ka(t, r)) : null;
  }
  removeAllEventSources() {
    this.dispatch({ type: "REMOVE_ALL_EVENT_SOURCES" });
  }
  refetchEvents() {
    this.dispatch({ type: "FETCH_EVENT_SOURCES", isRefetch: !0 });
  }
  // Scroll
  // -----------------------------------------------------------------------------------------------------------------
  scrollToTime(e) {
    let t = ot(e);
    t && this.trigger("_scrollRequest", { time: t });
  }
}
function JF(n, e) {
  let t = {
    left: Math.max(n.left, e.left),
    right: Math.min(n.right, e.right),
    top: Math.max(n.top, e.top),
    bottom: Math.min(n.bottom, e.bottom)
  };
  return t.left < t.right && t.top < t.bottom ? t : !1;
}
const Ip = as();
class QF {
  constructor() {
    this.getKeysForEventDefs = Ne(this._getKeysForEventDefs), this.splitDateSelection = Ne(this._splitDateSpan), this.splitEventStore = Ne(this._splitEventStore), this.splitIndividualUi = Ne(this._splitIndividualUi), this.splitEventDrag = Ne(this._splitInteraction), this.splitEventResize = Ne(this._splitInteraction), this.eventUiBuilders = {};
  }
  splitProps(e) {
    let t = this.getKeyInfo(e), r = this.getKeysForEventDefs(e.eventStore), i = this.splitDateSelection(e.dateSelection), s = this.splitIndividualUi(e.eventUiBases, r), o = this.splitEventStore(e.eventStore, r), a = this.splitEventDrag(e.eventDrag), c = this.splitEventResize(e.eventResize), u = {};
    this.eventUiBuilders = Wo(t, (f, h) => this.eventUiBuilders[h] || Ne(ZF));
    for (let f in t) {
      let h = t[f], p = o[f] || Ip, g = this.eventUiBuilders[f];
      u[f] = {
        businessHours: h.businessHours || e.businessHours,
        dateSelection: i[f] || null,
        eventStore: p,
        eventUiBases: g(e.eventUiBases[""], h.ui, s[f]),
        eventSelection: p.instances[e.eventSelection] ? e.eventSelection : "",
        eventDrag: a[f] || null,
        eventResize: c[f] || null
      };
    }
    return u;
  }
  _splitDateSpan(e) {
    let t = {};
    if (e) {
      let r = this.getKeysForDateSpan(e);
      for (let i of r)
        t[i] = e;
    }
    return t;
  }
  _getKeysForEventDefs(e) {
    return Wo(e.defs, (t) => this.getKeysForEventDef(t));
  }
  _splitEventStore(e, t) {
    let { defs: r, instances: i } = e, s = {};
    for (let o in r)
      for (let a of t[o])
        s[a] || (s[a] = as()), s[a].defs[o] = r[o];
    for (let o in i) {
      let a = i[o];
      for (let c of t[a.defId])
        s[c] && (s[c].instances[o] = a);
    }
    return s;
  }
  _splitIndividualUi(e, t) {
    let r = {};
    for (let i in e)
      if (i)
        for (let s of t[i])
          r[s] || (r[s] = {}), r[s][i] = e[i];
    return r;
  }
  _splitInteraction(e) {
    let t = {};
    if (e) {
      let r = this._splitEventStore(e.affectedEvents, this._getKeysForEventDefs(e.affectedEvents)), i = this._getKeysForEventDefs(e.mutatedEvents), s = this._splitEventStore(e.mutatedEvents, i), o = (a) => {
        t[a] || (t[a] = {
          affectedEvents: r[a] || Ip,
          mutatedEvents: s[a] || Ip,
          isEvent: e.isEvent
        });
      };
      for (let a in r)
        o(a);
      for (let a in s)
        o(a);
    }
    return t;
  }
}
function ZF(n, e, t) {
  let r = [];
  n && r.push(n), e && r.push(e);
  let i = {
    "": aT(r)
  };
  return t && Object.assign(i, t), i;
}
function ET(n, e, t, r) {
  return {
    dow: n.getUTCDay(),
    isDisabled: !!(r && (!r.activeRange || !ns(r.activeRange, n))),
    isOther: !!(r && !ns(r.currentRange, n)),
    isToday: !!(e && ns(e, n)),
    isPast: !!(e && n < e.start),
    isFuture: !!(e && n >= e.end)
  };
}
function _y(n, e) {
  let t = [
    "fc-day",
    `fc-day-${rj[n.dow]}`
  ];
  return n.isDisabled ? t.push("fc-day-disabled") : (n.isToday && (t.push("fc-day-today"), t.push(e.getClass("today"))), n.isPast && t.push("fc-day-past"), n.isFuture && t.push("fc-day-future"), n.isOther && t.push("fc-day-other")), t;
}
const XF = Ht({ year: "numeric", month: "long", day: "numeric" }), ez = Ht({ week: "long" });
function zd(n, e, t = "day", r = !0) {
  const { dateEnv: i, options: s, calendarApi: o } = n;
  let a = i.format(e, t === "week" ? ez : XF);
  if (s.navLinks) {
    let c = i.toDate(e);
    const u = (f) => {
      let h = t === "day" ? s.navLinkDayClick : t === "week" ? s.navLinkWeekClick : null;
      typeof h == "function" ? h.call(o, i.toDate(e), f) : (typeof h == "string" && (t = h), o.zoomTo(e, t));
    };
    return Object.assign({ title: ql(s.navLinkHint, [a, c], a), "data-navlink": "" }, r ? $1(u) : { onClick: u });
  }
  return { "aria-label": a };
}
let Np;
function tz() {
  return Np || (Np = nz()), Np;
}
function nz() {
  let n = document.createElement("div");
  n.style.overflow = "scroll", n.style.position = "absolute", n.style.top = "-9999px", n.style.left = "-9999px", document.body.appendChild(n);
  let e = rz(n);
  return document.body.removeChild(n), e;
}
function rz(n) {
  return {
    x: n.offsetHeight - n.clientHeight,
    y: n.offsetWidth - n.clientWidth
  };
}
function iz(n) {
  let e = sz(n), t = n.getBoundingClientRect();
  for (let r of e) {
    let i = JF(t, r.getBoundingClientRect());
    if (i)
      t = i;
    else
      return null;
  }
  return t;
}
function sz(n) {
  let e = [];
  for (; n instanceof HTMLElement; ) {
    let t = window.getComputedStyle(n);
    if (t.position === "fixed")
      break;
    /(auto|scroll)/.test(t.overflow + t.overflowY + t.overflowX) && e.push(n), n = n.parentNode;
  }
  return e;
}
class Ja {
  constructor(e, t, r, i) {
    this.els = t;
    let s = this.originClientRect = e.getBoundingClientRect();
    r && this.buildElHorizontals(s.left), i && this.buildElVerticals(s.top);
  }
  // Populates the left/right internal coordinate arrays
  buildElHorizontals(e) {
    let t = [], r = [];
    for (let i of this.els) {
      let s = i.getBoundingClientRect();
      t.push(s.left - e), r.push(s.right - e);
    }
    this.lefts = t, this.rights = r;
  }
  // Populates the top/bottom internal coordinate arrays
  buildElVerticals(e) {
    let t = [], r = [];
    for (let i of this.els) {
      let s = i.getBoundingClientRect();
      t.push(s.top - e), r.push(s.bottom - e);
    }
    this.tops = t, this.bottoms = r;
  }
  // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
  // If no intersection is made, returns undefined.
  leftToIndex(e) {
    let { lefts: t, rights: r } = this, i = t.length, s;
    for (s = 0; s < i; s += 1)
      if (e >= t[s] && e < r[s])
        return s;
  }
  // Given a top offset (from document top), returns the index of the el that it vertically intersects.
  // If no intersection is made, returns undefined.
  topToIndex(e) {
    let { tops: t, bottoms: r } = this, i = t.length, s;
    for (s = 0; s < i; s += 1)
      if (e >= t[s] && e < r[s])
        return s;
  }
  // Gets the width of the element at the given index
  getWidth(e) {
    return this.rights[e] - this.lefts[e];
  }
  // Gets the height of the element at the given index
  getHeight(e) {
    return this.bottoms[e] - this.tops[e];
  }
  similarTo(e) {
    return zu(this.tops || [], e.tops || []) && zu(this.bottoms || [], e.bottoms || []) && zu(this.lefts || [], e.lefts || []) && zu(this.rights || [], e.rights || []);
  }
}
function zu(n, e) {
  const t = n.length;
  if (t !== e.length)
    return !1;
  for (let r = 0; r < t; r++)
    if (Math.round(n[r]) !== Math.round(e[r]))
      return !1;
  return !0;
}
class Li extends pt {
  constructor() {
    super(...arguments), this.uid = Qo();
  }
  // Hit System
  // -----------------------------------------------------------------------------------------------------------------
  prepareHits() {
  }
  queryHit(e, t, r, i) {
    return null;
  }
  // Pointer Interaction Utils
  // -----------------------------------------------------------------------------------------------------------------
  isValidSegDownEl(e) {
    return !this.props.eventDrag && // HACK
    !this.props.eventResize && // HACK
    !Xi(e, ".fc-event-mirror");
  }
  isValidDateDownEl(e) {
    return !Xi(e, ".fc-event:not(.fc-bg-event)") && !Xi(e, ".fc-more-link") && // a "more.." link
    !Xi(e, "a[data-navlink]") && // a clickable nav link
    !Xi(e, ".fc-popover");
  }
}
class AT {
  constructor(e = (t) => t.thickness || 1) {
    this.getEntryThickness = e, this.strictOrder = !1, this.allowReslicing = !1, this.maxCoord = -1, this.maxStackCnt = -1, this.levelCoords = [], this.entriesByLevel = [], this.stackCnts = {};
  }
  addSegs(e) {
    let t = [];
    for (let r of e)
      this.insertEntry(r, t);
    return t;
  }
  insertEntry(e, t) {
    let r = this.findInsertion(e);
    this.isInsertionValid(r, e) ? this.insertEntryAt(e, r) : this.handleInvalidInsertion(r, e, t);
  }
  isInsertionValid(e, t) {
    return (this.maxCoord === -1 || e.levelCoord + this.getEntryThickness(t) <= this.maxCoord) && (this.maxStackCnt === -1 || e.stackCnt < this.maxStackCnt);
  }
  handleInvalidInsertion(e, t, r) {
    if (this.allowReslicing && e.touchingEntry) {
      const i = Object.assign(Object.assign({}, t), { span: Oy(t.span, e.touchingEntry.span) });
      r.push(i), this.splitEntry(t, e.touchingEntry, r);
    } else
      r.push(t);
  }
  /*
  Does NOT add what hit the `barrier` into hiddenEntries. Should already be done.
  */
  splitEntry(e, t, r) {
    let i = e.span, s = t.span;
    i.start < s.start && this.insertEntry({
      index: e.index,
      thickness: e.thickness,
      span: { start: i.start, end: s.start }
    }, r), i.end > s.end && this.insertEntry({
      index: e.index,
      thickness: e.thickness,
      span: { start: s.end, end: i.end }
    }, r);
  }
  insertEntryAt(e, t) {
    let { entriesByLevel: r, levelCoords: i } = this;
    t.lateral === -1 ? (Pp(i, t.level, t.levelCoord), Pp(r, t.level, [e])) : Pp(r[t.level], t.lateral, e), this.stackCnts[Lo(e)] = t.stackCnt;
  }
  /*
  does not care about limits
  */
  findInsertion(e) {
    let { levelCoords: t, entriesByLevel: r, strictOrder: i, stackCnts: s } = this, o = t.length, a = 0, c = -1, u = -1, f = null, h = 0;
    for (let y = 0; y < o; y += 1) {
      const x = t[y];
      if (!i && x >= a + this.getEntryThickness(e))
        break;
      let S = r[y], w, C = rg(S, e.span.start, ng), T = C[0] + C[1];
      for (
        ;
        // loop through entries that horizontally intersect
        (w = S[T]) && // but not past the whole entry list
        w.span.start < e.span.end;
      ) {
        let k = x + this.getEntryThickness(w);
        k > a && (a = k, f = w, c = y, u = T), k === a && (h = Math.max(h, s[Lo(w)] + 1)), T += 1;
      }
    }
    let p = 0;
    if (f)
      for (p = c + 1; p < o && t[p] < a; )
        p += 1;
    let g = -1;
    return p < o && t[p] === a && (g = rg(r[p], e.span.end, ng)[0]), {
      touchingLevel: c,
      touchingLateral: u,
      touchingEntry: f,
      stackCnt: h,
      levelCoord: a,
      level: p,
      lateral: g
    };
  }
  // sorted by levelCoord (lowest to highest)
  toRects() {
    let { entriesByLevel: e, levelCoords: t } = this, r = e.length, i = [];
    for (let s = 0; s < r; s += 1) {
      let o = e[s], a = t[s];
      for (let c of o)
        i.push(Object.assign(Object.assign({}, c), { thickness: this.getEntryThickness(c), levelCoord: a }));
    }
    return i;
  }
}
function ng(n) {
  return n.span.end;
}
function Lo(n) {
  return n.index + ":" + n.span.start;
}
function oz(n) {
  let e = [];
  for (let t of n) {
    let r = [], i = {
      span: t.span,
      entries: [t]
    };
    for (let s of e)
      Oy(s.span, i.span) ? i = {
        entries: s.entries.concat(i.entries),
        span: az(s.span, i.span)
      } : r.push(s);
    r.push(i), e = r;
  }
  return e;
}
function az(n, e) {
  return {
    start: Math.min(n.start, e.start),
    end: Math.max(n.end, e.end)
  };
}
function Oy(n, e) {
  let t = Math.max(n.start, e.start), r = Math.min(n.end, e.end);
  return t < r ? { start: t, end: r } : null;
}
function Pp(n, e, t) {
  n.splice(e, 0, t);
}
function rg(n, e, t) {
  let r = 0, i = n.length;
  if (!i || e < t(n[r]))
    return [0, 0];
  if (e > t(n[i - 1]))
    return [i, 0];
  for (; r < i; ) {
    let s = Math.floor(r + (i - r) / 2), o = t(n[s]);
    if (e < o)
      i = s;
    else if (e > o)
      r = s + 1;
    else
      return [s, 1];
  }
  return [r, 0];
}
function lz(n, e) {
  return !n || e > 10 ? Ht({ weekday: "short" }) : e > 1 ? Ht({ weekday: "short", month: "numeric", day: "numeric", omitCommas: !0 }) : Ht({ weekday: "long" });
}
const TT = "fc-col-header-cell";
function CT(n) {
  return n.text;
}
class cz extends pt {
  render() {
    let { dateEnv: e, options: t, theme: r, viewApi: i } = this.context, { props: s } = this, { date: o, dateProfile: a } = s, c = ET(o, s.todayRange, null, a), u = [TT].concat(_y(c, r)), f = e.format(o, s.dayHeaderFormat), h = !c.isDisabled && s.colCnt > 1 ? zd(this.context, o) : {}, p = e.toDate(o);
    e.namedTimeZoneImpl && (p = Zs(p, 36e5));
    let g = Object.assign(Object.assign(Object.assign({ date: p, view: i }, s.extraRenderProps), { text: f }), c);
    return I(Mr, { elTag: "th", elClasses: u, elAttrs: Object.assign({ role: "columnheader", colSpan: s.colSpan, "data-date": c.isDisabled ? void 0 : xy(o) }, s.extraDataAttrs), renderProps: g, generatorName: "dayHeaderContent", customGenerator: t.dayHeaderContent, defaultGenerator: CT, classNameGenerator: t.dayHeaderClassNames, didMount: t.dayHeaderDidMount, willUnmount: t.dayHeaderWillUnmount }, (y) => I("div", { className: "fc-scrollgrid-sync-inner" }, !c.isDisabled && I(y, { elTag: "a", elAttrs: h, elClasses: [
      "fc-col-header-cell-cushion",
      s.isSticky && "fc-sticky"
    ] })));
  }
}
const uz = Ht({ weekday: "long" });
class dz extends pt {
  render() {
    let { props: e } = this, { dateEnv: t, theme: r, viewApi: i, options: s } = this.context, o = vn(/* @__PURE__ */ new Date(2592e5), e.dow), a = {
      dow: e.dow,
      isDisabled: !1,
      isFuture: !1,
      isPast: !1,
      isToday: !1,
      isOther: !1
    }, c = t.format(o, e.dayHeaderFormat), u = Object.assign(Object.assign(Object.assign(Object.assign({
      // TODO: make this public?
      date: o
    }, a), { view: i }), e.extraRenderProps), { text: c });
    return I(Mr, { elTag: "th", elClasses: [
      TT,
      ..._y(a, r),
      ...e.extraClassNames || []
    ], elAttrs: Object.assign({ role: "columnheader", colSpan: e.colSpan }, e.extraDataAttrs), renderProps: u, generatorName: "dayHeaderContent", customGenerator: s.dayHeaderContent, defaultGenerator: CT, classNameGenerator: s.dayHeaderClassNames, didMount: s.dayHeaderDidMount, willUnmount: s.dayHeaderWillUnmount }, (f) => I(
      "div",
      { className: "fc-scrollgrid-sync-inner" },
      I(f, { elTag: "a", elClasses: [
        "fc-col-header-cell-cushion",
        e.isSticky && "fc-sticky"
      ], elAttrs: {
        "aria-label": t.format(o, uz)
      } })
    ));
  }
}
class DT extends pt {
  constructor() {
    super(...arguments), this.createDayHeaderFormatter = Ne(fz);
  }
  render() {
    let { context: e } = this, { dates: t, dateProfile: r, datesRepDistinctDays: i, renderIntro: s } = this.props, o = this.createDayHeaderFormatter(e.options.dayHeaderFormat, i, t.length);
    return I(rl, { unit: "day" }, (a, c) => I(
      "tr",
      { role: "row" },
      s && s("day"),
      t.map((u) => i ? I(cz, { key: u.toISOString(), date: u, dateProfile: r, todayRange: c, colCnt: t.length, dayHeaderFormat: o }) : I(dz, { key: u.getUTCDay(), dow: u.getUTCDay(), dayHeaderFormat: o }))
    ));
  }
}
function fz(n, e, t) {
  return n || lz(e, t);
}
class RT {
  constructor(e, t) {
    let r = e.start, { end: i } = e, s = [], o = [], a = -1;
    for (; r < i; )
      t.isHiddenDay(r) ? s.push(a + 0.5) : (a += 1, s.push(a), o.push(r)), r = vn(r, 1);
    this.dates = o, this.indices = s, this.cnt = o.length;
  }
  sliceRange(e) {
    let t = this.getDateDayIndex(e.start), r = this.getDateDayIndex(vn(e.end, -1)), i = Math.max(0, t), s = Math.min(this.cnt - 1, r);
    return i = Math.ceil(i), s = Math.floor(s), i <= s ? {
      firstIndex: i,
      lastIndex: s,
      isStart: t === i,
      isEnd: r === s
    } : null;
  }
  // Given a date, returns its chronolocial cell-index from the first cell of the grid.
  // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
  // If before the first offset, returns a negative number.
  // If after the last offset, returns an offset past the last cell offset.
  // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
  getDateDayIndex(e) {
    let { indices: t } = this, r = Math.floor(Zo(this.dates[0], e));
    return r < 0 ? t[0] - 1 : r >= t.length ? t[t.length - 1] + 1 : t[r];
  }
}
class kT {
  constructor(e, t) {
    let { dates: r } = e, i, s, o;
    if (t) {
      for (s = r[0].getUTCDay(), i = 1; i < r.length && r[i].getUTCDay() !== s; i += 1)
        ;
      o = Math.ceil(r.length / i);
    } else
      o = 1, i = r.length;
    this.rowCnt = o, this.colCnt = i, this.daySeries = e, this.cells = this.buildCells(), this.headerDates = this.buildHeaderDates();
  }
  buildCells() {
    let e = [];
    for (let t = 0; t < this.rowCnt; t += 1) {
      let r = [];
      for (let i = 0; i < this.colCnt; i += 1)
        r.push(this.buildCell(t, i));
      e.push(r);
    }
    return e;
  }
  buildCell(e, t) {
    let r = this.daySeries.dates[e * this.colCnt + t];
    return {
      key: r.toISOString(),
      date: r
    };
  }
  buildHeaderDates() {
    let e = [];
    for (let t = 0; t < this.colCnt; t += 1)
      e.push(this.cells[0][t].date);
    return e;
  }
  sliceRange(e) {
    let { colCnt: t } = this, r = this.daySeries.sliceRange(e), i = [];
    if (r) {
      let { firstIndex: s, lastIndex: o } = r, a = s;
      for (; a <= o; ) {
        let c = Math.floor(a / t), u = Math.min((c + 1) * t, o + 1);
        i.push({
          row: c,
          firstCol: a % t,
          lastCol: (u - 1) % t,
          isStart: r.isStart && a === s,
          isEnd: r.isEnd && u - 1 === o
        }), a = u;
      }
    }
    return i;
  }
}
class MT {
  constructor() {
    this.sliceBusinessHours = Ne(this._sliceBusinessHours), this.sliceDateSelection = Ne(this._sliceDateSpan), this.sliceEventStore = Ne(this._sliceEventStore), this.sliceEventDrag = Ne(this._sliceInteraction), this.sliceEventResize = Ne(this._sliceInteraction), this.forceDayIfListItem = !1;
  }
  sliceProps(e, t, r, i, ...s) {
    let { eventUiBases: o } = e, a = this.sliceEventStore(e.eventStore, o, t, r, ...s);
    return {
      dateSelectionSegs: this.sliceDateSelection(e.dateSelection, t, r, o, i, ...s),
      businessHourSegs: this.sliceBusinessHours(e.businessHours, t, r, i, ...s),
      fgEventSegs: a.fg,
      bgEventSegs: a.bg,
      eventDrag: this.sliceEventDrag(e.eventDrag, o, t, r, ...s),
      eventResize: this.sliceEventResize(e.eventResize, o, t, r, ...s),
      eventSelection: e.eventSelection
    };
  }
  sliceNowDate(e, t, r, i, ...s) {
    return this._sliceDateSpan(
      { range: { start: e, end: Zs(e, 1) }, allDay: !1 },
      // add 1 ms, protect against null range
      t,
      r,
      {},
      i,
      ...s
    );
  }
  _sliceBusinessHours(e, t, r, i, ...s) {
    return e ? this._sliceEventStore(zc(e, Vu(t, !!r), i), {}, t, r, ...s).bg : [];
  }
  _sliceEventStore(e, t, r, i, ...s) {
    if (e) {
      let o = hS(e, t, Vu(r, !!i), i);
      return {
        bg: this.sliceEventRanges(o.bg, s),
        fg: this.sliceEventRanges(o.fg, s)
      };
    }
    return { bg: [], fg: [] };
  }
  _sliceInteraction(e, t, r, i, ...s) {
    if (!e)
      return null;
    let o = hS(e.mutatedEvents, t, Vu(r, !!i), i);
    return {
      segs: this.sliceEventRanges(o.fg, s),
      affectedInstances: e.affectedEvents.instances,
      isEvent: e.isEvent
    };
  }
  _sliceDateSpan(e, t, r, i, s, ...o) {
    if (!e)
      return [];
    let a = Vu(t, !!r), c = Uo(e.range, a);
    if (c) {
      e = Object.assign(Object.assign({}, e), { range: c });
      let u = HF(e, i, s), f = this.sliceRange(e.range, ...o);
      for (let h of f)
        h.eventRange = u;
      return f;
    }
    return [];
  }
  /*
  "complete" seg means it has component and eventRange
  */
  sliceEventRanges(e, t) {
    let r = [];
    for (let i of e)
      r.push(...this.sliceEventRange(i, t));
    return r;
  }
  /*
  "complete" seg means it has component and eventRange
  */
  sliceEventRange(e, t) {
    let r = e.range;
    this.forceDayIfListItem && e.ui.display === "list-item" && (r = {
      start: r.start,
      end: vn(r.start, 1)
    });
    let i = this.sliceRange(r, ...t);
    for (let s of i)
      s.eventRange = e, s.isStart = e.isStart && s.isStart, s.isEnd = e.isEnd && s.isEnd;
    return i;
  }
}
function Vu(n, e) {
  let t = n.activeRange;
  return e ? t : {
    start: Zs(t.start, n.slotMinTime.milliseconds),
    end: Zs(t.end, n.slotMaxTime.milliseconds - 864e5)
    // 864e5 = ms in a day
  };
}
const Hu = /^(visible|hidden)$/;
class hz extends pt {
  constructor() {
    super(...arguments), this.handleEl = (e) => {
      this.el = e, _i(this.props.elRef, e);
    };
  }
  render() {
    let { props: e } = this, { liquid: t, liquidIsAbsolute: r } = e, i = t && r, s = ["fc-scroller"];
    return t && (r ? s.push("fc-scroller-liquid-absolute") : s.push("fc-scroller-liquid")), I("div", { ref: this.handleEl, className: s.join(" "), style: {
      overflowX: e.overflowX,
      overflowY: e.overflowY,
      left: i && -(e.overcomeLeft || 0) || "",
      right: i && -(e.overcomeRight || 0) || "",
      bottom: i && -(e.overcomeBottom || 0) || "",
      marginLeft: !i && -(e.overcomeLeft || 0) || "",
      marginRight: !i && -(e.overcomeRight || 0) || "",
      marginBottom: !i && -(e.overcomeBottom || 0) || "",
      maxHeight: e.maxHeight || ""
    } }, e.children);
  }
  needsXScrolling() {
    if (Hu.test(this.props.overflowX))
      return !1;
    let { el: e } = this, t = this.el.getBoundingClientRect().width - this.getYScrollbarWidth(), { children: r } = e;
    for (let i = 0; i < r.length; i += 1)
      if (r[i].getBoundingClientRect().width > t)
        return !0;
    return !1;
  }
  needsYScrolling() {
    if (Hu.test(this.props.overflowY))
      return !1;
    let { el: e } = this, t = this.el.getBoundingClientRect().height - this.getXScrollbarWidth(), { children: r } = e;
    for (let i = 0; i < r.length; i += 1)
      if (r[i].getBoundingClientRect().height > t)
        return !0;
    return !1;
  }
  getXScrollbarWidth() {
    return Hu.test(this.props.overflowX) ? 0 : this.el.offsetHeight - this.el.clientHeight;
  }
  getYScrollbarWidth() {
    return Hu.test(this.props.overflowY) ? 0 : this.el.offsetWidth - this.el.clientWidth;
  }
}
class es {
  constructor(e) {
    this.masterCallback = e, this.currentMap = {}, this.depths = {}, this.callbackMap = {}, this.handleValue = (t, r) => {
      let { depths: i, currentMap: s } = this, o = !1, a = !1;
      t !== null ? (o = r in s, s[r] = t, i[r] = (i[r] || 0) + 1, a = !0) : (i[r] -= 1, i[r] || (delete s[r], delete this.callbackMap[r], o = !0)), this.masterCallback && (o && this.masterCallback(null, String(r)), a && this.masterCallback(t, String(r)));
    };
  }
  createRef(e) {
    let t = this.callbackMap[e];
    return t || (t = this.callbackMap[e] = (r) => {
      this.handleValue(r, String(e));
    }), t;
  }
  // TODO: check callers that don't care about order. should use getAll instead
  // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
  // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
  collect(e, t, r) {
    return Bj(this.currentMap, e, t, r);
  }
  getAll() {
    return Ay(this.currentMap);
  }
}
function pz(n) {
  let e = FB(n, ".fc-scrollgrid-shrink"), t = 0;
  for (let r of e)
    t = Math.max(t, KB(r));
  return Math.ceil(t);
}
function _T(n, e) {
  return n.liquid && e.liquid;
}
function mz(n, e) {
  return e.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
  _T(n, e);
}
function gz(n, e, t, r) {
  let { expandRows: i } = t;
  return typeof e.content == "function" ? e.content(t) : I("table", {
    role: "presentation",
    className: [
      e.tableClassName,
      n.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
    ].join(" "),
    style: {
      minWidth: t.tableMinWidth,
      width: t.clientWidth,
      height: i ? t.clientHeight : ""
      // css `height` on a <table> serves as a min-height
    }
  }, t.tableColGroupNode, I(r ? "thead" : "tbody", {
    role: "presentation"
  }, typeof e.rowContent == "function" ? e.rowContent(t) : e.rowContent));
}
function yz(n, e) {
  return Qs(n, e, pi);
}
function vz(n, e) {
  let t = [];
  for (let r of n) {
    let i = r.span || 1;
    for (let s = 0; s < i; s += 1)
      t.push(I("col", { style: {
        width: r.width === "shrink" ? bz(e) : r.width || "",
        minWidth: r.minWidth || ""
      } }));
  }
  return I("colgroup", {}, ...t);
}
function bz(n) {
  return n ?? 4;
}
function xz(n) {
  for (let e of n)
    if (e.width === "shrink")
      return !0;
  return !1;
}
function Sz(n, e) {
  let t = [
    "fc-scrollgrid",
    e.theme.getClass("table")
  ];
  return n && t.push("fc-scrollgrid-liquid"), t;
}
function wz(n, e) {
  let t = [
    "fc-scrollgrid-section",
    `fc-scrollgrid-section-${n.type}`,
    n.className
    // used?
  ];
  return e && n.liquid && n.maxHeight == null && t.push("fc-scrollgrid-section-liquid"), n.isSticky && t.push("fc-scrollgrid-section-sticky"), t;
}
function ig(n) {
  return I("div", { className: "fc-scrollgrid-sticky-shim", style: {
    width: n.clientWidth,
    minWidth: n.tableMinWidth
  } });
}
function Vd(n) {
  let { stickyHeaderDates: e } = n;
  return (e == null || e === "auto") && (e = n.height === "auto" || n.viewHeight === "auto"), e;
}
function OT(n) {
  let { stickyFooterScrollbar: e } = n;
  return (e == null || e === "auto") && (e = n.height === "auto" || n.viewHeight === "auto"), e;
}
class Iy extends pt {
  constructor() {
    super(...arguments), this.processCols = Ne((e) => e, yz), this.renderMicroColGroup = Ne(vz), this.scrollerRefs = new es(), this.scrollerElRefs = new es(this._handleScrollerEl.bind(this)), this.state = {
      shrinkWidth: null,
      forceYScrollbars: !1,
      scrollerClientWidths: {},
      scrollerClientHeights: {}
    }, this.handleSizing = () => {
      this.safeSetState(Object.assign({ shrinkWidth: this.computeShrinkWidth() }, this.computeScrollerDims()));
    };
  }
  render() {
    let { props: e, state: t, context: r } = this, i = e.sections || [], s = this.processCols(e.cols), o = this.renderMicroColGroup(s, t.shrinkWidth), a = Sz(e.liquid, r);
    e.collapsibleWidth && a.push("fc-scrollgrid-collapsible");
    let c = i.length, u = 0, f, h = [], p = [], g = [];
    for (; u < c && (f = i[u]).type === "header"; )
      h.push(this.renderSection(f, o, !0)), u += 1;
    for (; u < c && (f = i[u]).type === "body"; )
      p.push(this.renderSection(f, o, !1)), u += 1;
    for (; u < c && (f = i[u]).type === "footer"; )
      g.push(this.renderSection(f, o, !0)), u += 1;
    let y = !ST();
    const x = { role: "rowgroup" };
    return I("table", {
      role: "grid",
      className: a.join(" "),
      style: { height: e.height }
    }, !!(!y && h.length) && I("thead", x, ...h), !!(!y && p.length) && I("tbody", x, ...p), !!(!y && g.length) && I("tfoot", x, ...g), y && I("tbody", x, ...h, ...p, ...g));
  }
  renderSection(e, t, r) {
    return "outerContent" in e ? I(Ct, { key: e.key }, e.outerContent) : I("tr", { key: e.key, role: "presentation", className: wz(e, this.props.liquid).join(" ") }, this.renderChunkTd(e, t, e.chunk, r));
  }
  renderChunkTd(e, t, r, i) {
    if ("outerContent" in r)
      return r.outerContent;
    let { props: s } = this, { forceYScrollbars: o, scrollerClientWidths: a, scrollerClientHeights: c } = this.state, u = mz(s, e), f = _T(s, e), h = s.liquid ? o ? "scroll" : u ? "auto" : "hidden" : "visible", p = e.key, g = gz(e, r, {
      tableColGroupNode: t,
      tableMinWidth: "",
      clientWidth: !s.collapsibleWidth && a[p] !== void 0 ? a[p] : null,
      clientHeight: c[p] !== void 0 ? c[p] : null,
      expandRows: e.expandRows,
      syncRowHeights: !1,
      rowSyncHeights: [],
      reportRowHeightChange: () => {
      }
    }, i);
    return I(i ? "th" : "td", {
      ref: r.elRef,
      role: "presentation"
    }, I(
      "div",
      { className: `fc-scroller-harness${f ? " fc-scroller-harness-liquid" : ""}` },
      I(hz, { ref: this.scrollerRefs.createRef(p), elRef: this.scrollerElRefs.createRef(p), overflowY: h, overflowX: s.liquid ? "hidden" : "visible", maxHeight: e.maxHeight, liquid: f, liquidIsAbsolute: !0 }, g)
    ));
  }
  _handleScrollerEl(e, t) {
    let r = Ez(this.props.sections, t);
    r && _i(r.chunk.scrollerElRef, e);
  }
  componentDidMount() {
    this.handleSizing(), this.context.addResizeHandler(this.handleSizing);
  }
  componentDidUpdate() {
    this.handleSizing();
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleSizing);
  }
  computeShrinkWidth() {
    return xz(this.props.cols) ? pz(this.scrollerElRefs.getAll()) : 0;
  }
  computeScrollerDims() {
    let e = tz(), { scrollerRefs: t, scrollerElRefs: r } = this, i = !1, s = {}, o = {};
    for (let a in t.currentMap) {
      let c = t.currentMap[a];
      if (c && c.needsYScrolling()) {
        i = !0;
        break;
      }
    }
    for (let a of this.props.sections) {
      let c = a.key, u = r.currentMap[c];
      if (u) {
        let f = u.parentNode;
        s[c] = Math.floor(f.getBoundingClientRect().width - (i ? e.y : 0)), o[c] = Math.floor(f.getBoundingClientRect().height);
      }
    }
    return { forceYScrollbars: i, scrollerClientWidths: s, scrollerClientHeights: o };
  }
}
Iy.addStateEquality({
  scrollerClientWidths: pi,
  scrollerClientHeights: pi
});
function Ez(n, e) {
  for (let t of n)
    if (t.key === e)
      return t;
  return null;
}
class Ny extends pt {
  constructor() {
    super(...arguments), this.buildPublicEvent = Ne((e, t, r) => new qr(e, t, r)), this.handleEl = (e) => {
      this.el = e, _i(this.props.elRef, e), e && pS(e, this.props.seg);
    };
  }
  render() {
    const { props: e, context: t } = this, { options: r } = t, { seg: i } = e, { eventRange: s } = i, { ui: o } = s, a = {
      event: this.buildPublicEvent(t, s.def, s.instance),
      view: t.viewApi,
      timeText: e.timeText,
      textColor: o.textColor,
      backgroundColor: o.backgroundColor,
      borderColor: o.borderColor,
      isDraggable: !e.disableDragging && NF(i, t),
      isStartResizable: !e.disableResizing && PF(i, t),
      isEndResizable: !e.disableResizing && LF(i),
      isMirror: !!(e.isDragging || e.isResizing || e.isDateSelecting),
      isStart: !!i.isStart,
      isEnd: !!i.isEnd,
      isPast: !!e.isPast,
      isFuture: !!e.isFuture,
      isToday: !!e.isToday,
      isSelected: !!e.isSelected,
      isDragging: !!e.isDragging,
      isResizing: !!e.isResizing
    };
    return I(Mr, { elRef: this.handleEl, elTag: e.elTag, elAttrs: e.elAttrs, elClasses: [
      ...BF(a),
      ...i.eventRange.ui.classNames,
      ...e.elClasses || []
    ], elStyle: e.elStyle, renderProps: a, generatorName: "eventContent", customGenerator: r.eventContent, defaultGenerator: e.defaultGenerator, classNameGenerator: r.eventClassNames, didMount: r.eventDidMount, willUnmount: r.eventWillUnmount }, e.children);
  }
  componentDidUpdate(e) {
    this.el && this.props.seg !== e.seg && pS(this.el, this.props.seg);
  }
}
class Py extends pt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, { seg: i } = e, { ui: s } = i.eventRange, o = r.eventTimeFormat || e.defaultTimeFormat, a = gT(i, o, t, e.defaultDisplayEventTime, e.defaultDisplayEventEnd);
    return I(Ny, Object.assign({}, e, { elTag: "a", elStyle: {
      borderColor: s.borderColor,
      backgroundColor: s.backgroundColor
    }, elAttrs: vT(i, t), defaultGenerator: Az, timeText: a }), (c, u) => I(
      Ct,
      null,
      I(c, { elTag: "div", elClasses: ["fc-event-main"], elStyle: { color: u.textColor } }),
      !!u.isStartResizable && I("div", { className: "fc-event-resizer fc-event-resizer-start" }),
      !!u.isEndResizable && I("div", { className: "fc-event-resizer fc-event-resizer-end" })
    ));
  }
}
Py.addPropsEquality({
  seg: pi
});
function Az(n) {
  return I(
    "div",
    { className: "fc-event-main-frame" },
    n.timeText && I("div", { className: "fc-event-time" }, n.timeText),
    I(
      "div",
      { className: "fc-event-title-container" },
      I("div", { className: "fc-event-title fc-sticky" }, n.event.title || I(Ct, null, " "))
    )
  );
}
const Ly = (n) => I(ms.Consumer, null, (e) => {
  let { options: t } = e, r = {
    isAxis: n.isAxis,
    date: e.dateEnv.toDate(n.date),
    view: e.viewApi
  };
  return I(Mr, { elRef: n.elRef, elTag: n.elTag || "div", elAttrs: n.elAttrs, elClasses: n.elClasses, elStyle: n.elStyle, renderProps: r, generatorName: "nowIndicatorContent", customGenerator: t.nowIndicatorContent, classNameGenerator: t.nowIndicatorClassNames, didMount: t.nowIndicatorDidMount, willUnmount: t.nowIndicatorWillUnmount }, n.children);
}), Tz = Ht({ day: "numeric" });
class By extends pt {
  constructor() {
    super(...arguments), this.refineRenderProps = md(Cz);
  }
  render() {
    let { props: e, context: t } = this, { options: r } = t, i = this.refineRenderProps({
      date: e.date,
      dateProfile: e.dateProfile,
      todayRange: e.todayRange,
      isMonthStart: e.isMonthStart || !1,
      showDayNumber: e.showDayNumber,
      extraRenderProps: e.extraRenderProps,
      viewApi: t.viewApi,
      dateEnv: t.dateEnv,
      monthStartFormat: r.monthStartFormat
    });
    return I(Mr, { elRef: e.elRef, elTag: e.elTag, elAttrs: Object.assign(Object.assign({}, e.elAttrs), i.isDisabled ? {} : { "data-date": xy(e.date) }), elClasses: [
      ..._y(i, t.theme),
      ...e.elClasses || []
    ], elStyle: e.elStyle, renderProps: i, generatorName: "dayCellContent", customGenerator: r.dayCellContent, defaultGenerator: e.defaultGenerator, classNameGenerator: (
      // don't use custom classNames if disabled
      i.isDisabled ? void 0 : r.dayCellClassNames
    ), didMount: r.dayCellDidMount, willUnmount: r.dayCellWillUnmount }, e.children);
  }
}
function jy(n) {
  return !!(n.dayCellContent || Zm("dayCellContent", n));
}
function Cz(n) {
  let { date: e, dateEnv: t, dateProfile: r, isMonthStart: i } = n, s = ET(e, n.todayRange, null, r), o = n.showDayNumber ? t.format(e, i ? n.monthStartFormat : Tz) : "";
  return Object.assign(Object.assign(Object.assign({ date: t.toDate(e), view: n.viewApi }, s), {
    isMonthStart: i,
    dayNumberText: o
  }), n.extraRenderProps);
}
class IT extends pt {
  render() {
    let { props: e } = this, { seg: t } = e;
    return I(Ny, { elTag: "div", elClasses: ["fc-bg-event"], elStyle: { backgroundColor: t.eventRange.ui.backgroundColor }, defaultGenerator: Dz, seg: t, timeText: "", isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: !1, isPast: e.isPast, isFuture: e.isFuture, isToday: e.isToday, disableDragging: !0, disableResizing: !0 });
  }
}
function Dz(n) {
  let { title: e } = n.event;
  return e && I("div", { className: "fc-event-title" }, n.event.title);
}
function NT(n) {
  return I("div", { className: `fc-${n}` });
}
const PT = (n) => I(ms.Consumer, null, (e) => {
  let { dateEnv: t, options: r } = e, { date: i } = n, s = r.weekNumberFormat || n.defaultFormat, o = t.computeWeekNumber(i), a = t.format(i, s), c = { num: o, text: a, date: i };
  return I(
    Mr,
    { elRef: n.elRef, elTag: n.elTag, elAttrs: n.elAttrs, elClasses: n.elClasses, elStyle: n.elStyle, renderProps: c, generatorName: "weekNumberContent", customGenerator: r.weekNumberContent, defaultGenerator: Rz, classNameGenerator: r.weekNumberClassNames, didMount: r.weekNumberDidMount, willUnmount: r.weekNumberWillUnmount },
    n.children
  );
});
function Rz(n) {
  return n.text;
}
const Lp = 10;
class kz extends pt {
  constructor() {
    super(...arguments), this.state = {
      titleId: $f()
    }, this.handleRootEl = (e) => {
      this.rootEl = e, this.props.elRef && _i(this.props.elRef, e);
    }, this.handleDocumentMouseDown = (e) => {
      const t = HB(e);
      this.rootEl.contains(t) || this.handleCloseClick();
    }, this.handleDocumentKeyDown = (e) => {
      e.key === "Escape" && this.handleCloseClick();
    }, this.handleCloseClick = () => {
      let { onClose: e } = this.props;
      e && e();
    };
  }
  render() {
    let { theme: e, options: t } = this.context, { props: r, state: i } = this, s = [
      "fc-popover",
      e.getClass("popover")
    ].concat(r.extraClassNames || []);
    return AB(I(
      "div",
      Object.assign({}, r.extraAttrs, { id: r.id, className: s.join(" "), "aria-labelledby": i.titleId, ref: this.handleRootEl }),
      I(
        "div",
        { className: "fc-popover-header " + e.getClass("popoverHeader") },
        I("span", { className: "fc-popover-title", id: i.titleId }, r.title),
        I("span", { className: "fc-popover-close " + e.getIconClass("close"), title: t.closeHint, onClick: this.handleCloseClick })
      ),
      I("div", { className: "fc-popover-body " + e.getClass("popoverContent") }, r.children)
    ), r.parentEl);
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleDocumentMouseDown), document.addEventListener("keydown", this.handleDocumentKeyDown), this.updateSize();
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDocumentMouseDown), document.removeEventListener("keydown", this.handleDocumentKeyDown);
  }
  updateSize() {
    let { isRtl: e } = this.context, { alignmentEl: t, alignGridTop: r } = this.props, { rootEl: i } = this, s = iz(t);
    if (s) {
      let o = i.getBoundingClientRect(), a = r ? Xi(t, ".fc-scrollgrid").getBoundingClientRect().top : s.top, c = e ? s.right - o.width : s.left;
      a = Math.max(a, Lp), c = Math.min(c, document.documentElement.clientWidth - Lp - o.width), c = Math.max(c, Lp);
      let u = i.offsetParent.getBoundingClientRect();
      VB(i, {
        top: a - u.top,
        left: c - u.left
      });
    }
  }
}
class Mz extends Li {
  constructor() {
    super(...arguments), this.handleRootEl = (e) => {
      this.rootEl = e, e ? this.context.registerInteractiveComponent(this, {
        el: e,
        useEventCenter: !1
      }) : this.context.unregisterInteractiveComponent(this);
    };
  }
  render() {
    let { options: e, dateEnv: t } = this.context, { props: r } = this, { startDate: i, todayRange: s, dateProfile: o } = r, a = t.format(i, e.dayPopoverFormat);
    return I(By, { elRef: this.handleRootEl, date: i, dateProfile: o, todayRange: s }, (c, u, f) => I(
      kz,
      { elRef: f.ref, id: r.id, title: a, extraClassNames: ["fc-more-popover"].concat(f.className || []), extraAttrs: f, parentEl: r.parentEl, alignmentEl: r.alignmentEl, alignGridTop: r.alignGridTop, onClose: r.onClose },
      jy(e) && I(c, { elTag: "div", elClasses: ["fc-more-popover-misc"] }),
      r.children
    ));
  }
  queryHit(e, t, r, i) {
    let { rootEl: s, props: o } = this;
    return e >= 0 && e < r && t >= 0 && t < i ? {
      dateProfile: o.dateProfile,
      dateSpan: Object.assign({ allDay: !o.forceTimed, range: {
        start: o.startDate,
        end: o.endDate
      } }, o.extraDateSpan),
      dayEl: s,
      rect: {
        left: 0,
        top: 0,
        right: r,
        bottom: i
      },
      layer: 1
      // important when comparing with hits from other components
    } : null;
  }
}
class LT extends pt {
  constructor() {
    super(...arguments), this.state = {
      isPopoverOpen: !1,
      popoverId: $f()
    }, this.handleLinkEl = (e) => {
      this.linkEl = e, this.props.elRef && _i(this.props.elRef, e);
    }, this.handleClick = (e) => {
      let { props: t, context: r } = this, { moreLinkClick: i } = r.options, s = yS(t).start;
      function o(a) {
        let { def: c, instance: u, range: f } = a.eventRange;
        return {
          event: new qr(r, c, u),
          start: r.dateEnv.toDate(f.start),
          end: r.dateEnv.toDate(f.end),
          isStart: a.isStart,
          isEnd: a.isEnd
        };
      }
      typeof i == "function" && (i = i({
        date: s,
        allDay: !!t.allDayDate,
        allSegs: t.allSegs.map(o),
        hiddenSegs: t.hiddenSegs.map(o),
        jsEvent: e,
        view: r.viewApi
      })), !i || i === "popover" ? this.setState({ isPopoverOpen: !0 }) : typeof i == "string" && r.calendarApi.zoomTo(s, i);
    }, this.handlePopoverClose = () => {
      this.setState({ isPopoverOpen: !1 });
    };
  }
  render() {
    let { props: e, state: t } = this;
    return I(ms.Consumer, null, (r) => {
      let { viewApi: i, options: s, calendarApi: o } = r, { moreLinkText: a } = s, { moreCnt: c } = e, u = yS(e), f = typeof a == "function" ? a.call(o, c) : `+${c} ${a}`, h = ql(s.moreLinkHint, [c], f), p = {
        num: c,
        shortText: `+${c}`,
        text: f,
        view: i
      };
      return I(
        Ct,
        null,
        !!e.moreCnt && I(Mr, { elTag: e.elTag || "a", elRef: this.handleLinkEl, elClasses: [
          ...e.elClasses || [],
          "fc-more-link"
        ], elStyle: e.elStyle, elAttrs: Object.assign(Object.assign(Object.assign({}, e.elAttrs), $1(this.handleClick)), { title: h, "aria-expanded": t.isPopoverOpen, "aria-controls": t.isPopoverOpen ? t.popoverId : "" }), renderProps: p, generatorName: "moreLinkContent", customGenerator: s.moreLinkContent, defaultGenerator: e.defaultGenerator || _z, classNameGenerator: s.moreLinkClassNames, didMount: s.moreLinkDidMount, willUnmount: s.moreLinkWillUnmount }, e.children),
        t.isPopoverOpen && I(Mz, { id: t.popoverId, startDate: u.start, endDate: u.end, dateProfile: e.dateProfile, todayRange: e.todayRange, extraDateSpan: e.extraDateSpan, parentEl: this.parentEl, alignmentEl: e.alignmentElRef ? e.alignmentElRef.current : this.linkEl, alignGridTop: e.alignGridTop, forceTimed: e.forceTimed, onClose: this.handlePopoverClose }, e.popoverContent())
      );
    });
  }
  componentDidMount() {
    this.updateParentEl();
  }
  componentDidUpdate() {
    this.updateParentEl();
  }
  updateParentEl() {
    this.linkEl && (this.parentEl = Xi(this.linkEl, ".fc-view-harness"));
  }
}
function _z(n) {
  return n.text;
}
function yS(n) {
  if (n.allDayDate)
    return {
      start: n.allDayDate,
      end: vn(n.allDayDate, 1)
    };
  let { hiddenSegs: e } = n;
  return {
    start: BT(e),
    end: Iz(e)
  };
}
function BT(n) {
  return n.reduce(Oz).eventRange.range.start;
}
function Oz(n, e) {
  return n.eventRange.range.start < e.eventRange.range.start ? n : e;
}
function Iz(n) {
  return n.reduce(Nz).eventRange.range.end;
}
function Nz(n, e) {
  return n.eventRange.range.end > e.eventRange.range.end ? n : e;
}
class Pz {
  constructor() {
    this.handlers = [];
  }
  set(e) {
    this.currentValue = e;
    for (let t of this.handlers)
      t(e);
  }
  subscribe(e) {
    this.handlers.push(e), this.currentValue !== void 0 && e(this.currentValue);
  }
}
class Lz extends Pz {
  constructor() {
    super(...arguments), this.map = /* @__PURE__ */ new Map();
  }
  // for consistent order
  handle(e) {
    const { map: t } = this;
    let r = !1;
    e.isActive ? (t.set(e.id, e), r = !0) : t.has(e.id) && (t.delete(e.id), r = !0), r && this.set(t);
  }
}
const Bz = [], jT = {
  code: "en",
  week: {
    dow: 0,
    doy: 4
    // 4 days need to be within the year to be considered the first week
  },
  direction: "ltr",
  buttonText: {
    prev: "prev",
    next: "next",
    prevYear: "prev year",
    nextYear: "next year",
    year: "year",
    today: "today",
    month: "month",
    week: "week",
    day: "day",
    list: "list"
  },
  weekText: "W",
  weekTextLong: "Week",
  closeHint: "Close",
  timeHint: "Time",
  eventHint: "Event",
  allDayText: "all-day",
  moreLinkText: "more",
  noEventsText: "No events to display"
}, FT = Object.assign(Object.assign({}, jT), {
  // Includes things we don't want other locales to inherit,
  // things that derive from other translatable strings.
  buttonHints: {
    prev: "Previous $0",
    next: "Next $0",
    today(n, e) {
      return e === "day" ? "Today" : `This ${n}`;
    }
  },
  viewHint: "$0 view",
  navLinkHint: "Go to $0",
  moreLinkHint(n) {
    return `Show ${n} more event${n === 1 ? "" : "s"}`;
  }
});
function jz(n) {
  let e = n.length > 0 ? n[0].code : "en", t = Bz.concat(n), r = {
    en: FT
  };
  for (let i of t)
    r[i.code] = i;
  return {
    map: r,
    defaultCode: e
  };
}
function zT(n, e) {
  return typeof n == "object" && !Array.isArray(n) ? VT(n.code, [n.code], n) : Fz(n, e);
}
function Fz(n, e) {
  let t = [].concat(n || []), r = zz(t, e) || FT;
  return VT(n, t, r);
}
function zz(n, e) {
  for (let t = 0; t < n.length; t += 1) {
    let r = n[t].toLocaleLowerCase().split("-");
    for (let i = r.length; i > 0; i -= 1) {
      let s = r.slice(0, i).join("-");
      if (e[s])
        return e[s];
    }
  }
  return null;
}
function VT(n, e, t) {
  let r = Ey([jT, t], ["buttonText"]);
  delete r.code;
  let { week: i } = r;
  return delete r.week, {
    codeArg: n,
    codes: e,
    week: i,
    simpleNumberFormat: new Intl.NumberFormat(n),
    options: r
  };
}
function to(n) {
  return {
    id: Qo(),
    name: n.name,
    premiumReleaseDate: n.premiumReleaseDate ? new Date(n.premiumReleaseDate) : void 0,
    deps: n.deps || [],
    reducers: n.reducers || [],
    isLoadingFuncs: n.isLoadingFuncs || [],
    contextInit: [].concat(n.contextInit || []),
    eventRefiners: n.eventRefiners || {},
    eventDefMemberAdders: n.eventDefMemberAdders || [],
    eventSourceRefiners: n.eventSourceRefiners || {},
    isDraggableTransformers: n.isDraggableTransformers || [],
    eventDragMutationMassagers: n.eventDragMutationMassagers || [],
    eventDefMutationAppliers: n.eventDefMutationAppliers || [],
    dateSelectionTransformers: n.dateSelectionTransformers || [],
    datePointTransforms: n.datePointTransforms || [],
    dateSpanTransforms: n.dateSpanTransforms || [],
    views: n.views || {},
    viewPropsTransformers: n.viewPropsTransformers || [],
    isPropsValid: n.isPropsValid || null,
    externalDefTransforms: n.externalDefTransforms || [],
    viewContainerAppends: n.viewContainerAppends || [],
    eventDropTransformers: n.eventDropTransformers || [],
    componentInteractions: n.componentInteractions || [],
    calendarInteractions: n.calendarInteractions || [],
    themeClasses: n.themeClasses || {},
    eventSourceDefs: n.eventSourceDefs || [],
    cmdFormatter: n.cmdFormatter,
    recurringTypes: n.recurringTypes || [],
    namedTimeZonedImpl: n.namedTimeZonedImpl,
    initialView: n.initialView || "",
    elementDraggingImpl: n.elementDraggingImpl,
    optionChangeHandlers: n.optionChangeHandlers || {},
    scrollGridImpl: n.scrollGridImpl || null,
    listenerRefiners: n.listenerRefiners || {},
    optionRefiners: n.optionRefiners || {},
    propSetHandlers: n.propSetHandlers || {}
  };
}
function Vz(n, e) {
  let t = {}, r = {
    premiumReleaseDate: void 0,
    reducers: [],
    isLoadingFuncs: [],
    contextInit: [],
    eventRefiners: {},
    eventDefMemberAdders: [],
    eventSourceRefiners: {},
    isDraggableTransformers: [],
    eventDragMutationMassagers: [],
    eventDefMutationAppliers: [],
    dateSelectionTransformers: [],
    datePointTransforms: [],
    dateSpanTransforms: [],
    views: {},
    viewPropsTransformers: [],
    isPropsValid: null,
    externalDefTransforms: [],
    viewContainerAppends: [],
    eventDropTransformers: [],
    componentInteractions: [],
    calendarInteractions: [],
    themeClasses: {},
    eventSourceDefs: [],
    cmdFormatter: null,
    recurringTypes: [],
    namedTimeZonedImpl: null,
    initialView: "",
    elementDraggingImpl: null,
    optionChangeHandlers: {},
    scrollGridImpl: null,
    listenerRefiners: {},
    optionRefiners: {},
    propSetHandlers: {}
  };
  function i(s) {
    for (let o of s) {
      const a = o.name, c = t[a];
      c === void 0 ? (t[a] = o.id, i(o.deps), r = Wz(r, o)) : c !== o.id && console.warn(`Duplicate plugin '${a}'`);
    }
  }
  return n && i(n), i(e), r;
}
function Hz() {
  let n = [], e = [], t;
  return (r, i) => ((!t || !Qs(r, n) || !Qs(i, e)) && (t = Vz(r, i)), n = r, e = i, t);
}
function Wz(n, e) {
  return {
    premiumReleaseDate: Uz(n.premiumReleaseDate, e.premiumReleaseDate),
    reducers: n.reducers.concat(e.reducers),
    isLoadingFuncs: n.isLoadingFuncs.concat(e.isLoadingFuncs),
    contextInit: n.contextInit.concat(e.contextInit),
    eventRefiners: Object.assign(Object.assign({}, n.eventRefiners), e.eventRefiners),
    eventDefMemberAdders: n.eventDefMemberAdders.concat(e.eventDefMemberAdders),
    eventSourceRefiners: Object.assign(Object.assign({}, n.eventSourceRefiners), e.eventSourceRefiners),
    isDraggableTransformers: n.isDraggableTransformers.concat(e.isDraggableTransformers),
    eventDragMutationMassagers: n.eventDragMutationMassagers.concat(e.eventDragMutationMassagers),
    eventDefMutationAppliers: n.eventDefMutationAppliers.concat(e.eventDefMutationAppliers),
    dateSelectionTransformers: n.dateSelectionTransformers.concat(e.dateSelectionTransformers),
    datePointTransforms: n.datePointTransforms.concat(e.datePointTransforms),
    dateSpanTransforms: n.dateSpanTransforms.concat(e.dateSpanTransforms),
    views: Object.assign(Object.assign({}, n.views), e.views),
    viewPropsTransformers: n.viewPropsTransformers.concat(e.viewPropsTransformers),
    isPropsValid: e.isPropsValid || n.isPropsValid,
    externalDefTransforms: n.externalDefTransforms.concat(e.externalDefTransforms),
    viewContainerAppends: n.viewContainerAppends.concat(e.viewContainerAppends),
    eventDropTransformers: n.eventDropTransformers.concat(e.eventDropTransformers),
    calendarInteractions: n.calendarInteractions.concat(e.calendarInteractions),
    componentInteractions: n.componentInteractions.concat(e.componentInteractions),
    themeClasses: Object.assign(Object.assign({}, n.themeClasses), e.themeClasses),
    eventSourceDefs: n.eventSourceDefs.concat(e.eventSourceDefs),
    cmdFormatter: e.cmdFormatter || n.cmdFormatter,
    recurringTypes: n.recurringTypes.concat(e.recurringTypes),
    namedTimeZonedImpl: e.namedTimeZonedImpl || n.namedTimeZonedImpl,
    initialView: n.initialView || e.initialView,
    elementDraggingImpl: n.elementDraggingImpl || e.elementDraggingImpl,
    optionChangeHandlers: Object.assign(Object.assign({}, n.optionChangeHandlers), e.optionChangeHandlers),
    scrollGridImpl: e.scrollGridImpl || n.scrollGridImpl,
    listenerRefiners: Object.assign(Object.assign({}, n.listenerRefiners), e.listenerRefiners),
    optionRefiners: Object.assign(Object.assign({}, n.optionRefiners), e.optionRefiners),
    propSetHandlers: Object.assign(Object.assign({}, n.propSetHandlers), e.propSetHandlers)
  };
}
function Uz(n, e) {
  return n === void 0 ? e : e === void 0 ? n : new Date(Math.max(n.valueOf(), e.valueOf()));
}
class no extends Fc {
}
no.prototype.classes = {
  root: "fc-theme-standard",
  tableCellShaded: "fc-cell-shaded",
  buttonGroup: "fc-button-group",
  button: "fc-button fc-button-primary",
  buttonActive: "fc-button-active"
};
no.prototype.baseIconClass = "fc-icon";
no.prototype.iconClasses = {
  close: "fc-icon-x",
  prev: "fc-icon-chevron-left",
  next: "fc-icon-chevron-right",
  prevYear: "fc-icon-chevrons-left",
  nextYear: "fc-icon-chevrons-right"
};
no.prototype.rtlIconClasses = {
  prev: "fc-icon-chevron-right",
  next: "fc-icon-chevron-left",
  prevYear: "fc-icon-chevrons-right",
  nextYear: "fc-icon-chevrons-left"
};
no.prototype.iconOverrideOption = "buttonIcons";
no.prototype.iconOverrideCustomButtonOption = "icon";
no.prototype.iconOverridePrefix = "fc-icon-";
function $z(n, e) {
  let t = {}, r;
  for (r in n)
    sg(r, t, n, e);
  for (r in e)
    sg(r, t, n, e);
  return t;
}
function sg(n, e, t, r) {
  if (e[n])
    return e[n];
  let i = Gz(n, e, t, r);
  return i && (e[n] = i), i;
}
function Gz(n, e, t, r) {
  let i = t[n], s = r[n], o = (f) => i && i[f] !== null ? i[f] : s && s[f] !== null ? s[f] : null, a = o("component"), c = o("superType"), u = null;
  if (c) {
    if (c === n)
      throw new Error("Can't have a custom view type that references itself");
    u = sg(c, e, t, r);
  }
  return !a && u && (a = u.component), a ? {
    type: n,
    component: a,
    defaults: Object.assign(Object.assign({}, u ? u.defaults : {}), i ? i.rawOptions : {}),
    overrides: Object.assign(Object.assign({}, u ? u.overrides : {}), s ? s.rawOptions : {})
  } : null;
}
function vS(n) {
  return Wo(n, Yz);
}
function Yz(n) {
  let e = typeof n == "function" ? { component: n } : n, { component: t } = e;
  return e.content ? t = bS(e) : t && !(t.prototype instanceof pt) && (t = bS(Object.assign(Object.assign({}, e), { content: t }))), {
    superType: e.type,
    component: t,
    rawOptions: e
    // includes type and component too :(
  };
}
function bS(n) {
  return (e) => I(ms.Consumer, null, (t) => I(Mr, { elTag: "div", elClasses: eT(t.viewSpec), renderProps: Object.assign(Object.assign({}, e), { nextDayThreshold: t.options.nextDayThreshold }), generatorName: void 0, customGenerator: n.content, classNameGenerator: n.classNames, didMount: n.didMount, willUnmount: n.willUnmount }));
}
function qz(n, e, t, r) {
  let i = vS(n), s = vS(e.views), o = $z(i, s);
  return Wo(o, (a) => Kz(a, s, e, t, r));
}
function Kz(n, e, t, r, i) {
  let s = n.overrides.duration || n.defaults.duration || r.duration || t.duration, o = null, a = "", c = "", u = {};
  if (s && (o = Jz(s), o)) {
    let p = Qm(o);
    a = p.unit, p.value === 1 && (c = a, u = e[a] ? e[a].rawOptions : {});
  }
  let f = (p) => {
    let g = p.buttonText || {}, y = n.defaults.buttonTextKey;
    return y != null && g[y] != null ? g[y] : g[n.type] != null ? g[n.type] : g[c] != null ? g[c] : null;
  }, h = (p) => {
    let g = p.buttonHints || {}, y = n.defaults.buttonTextKey;
    return y != null && g[y] != null ? g[y] : g[n.type] != null ? g[n.type] : g[c] != null ? g[c] : null;
  };
  return {
    type: n.type,
    component: n.component,
    duration: o,
    durationUnit: a,
    singleUnit: c,
    optionDefaults: n.defaults,
    optionOverrides: Object.assign(Object.assign({}, u), n.overrides),
    buttonTextOverride: f(r) || f(t) || // constructor-specified buttonText lookup hash takes precedence
    n.overrides.buttonText,
    buttonTextDefault: f(i) || n.defaults.buttonText || f(Kl) || n.type,
    // not DRY
    buttonTitleOverride: h(r) || h(t) || n.overrides.buttonHint,
    buttonTitleDefault: h(i) || n.defaults.buttonHint || h(Kl)
    // will eventually fall back to buttonText
  };
}
let xS = {};
function Jz(n) {
  let e = JSON.stringify(n), t = xS[e];
  return t === void 0 && (t = ot(n), xS[e] = t), t;
}
function Qz(n, e) {
  switch (e.type) {
    case "CHANGE_VIEW_TYPE":
      n = e.viewType;
  }
  return n;
}
function Zz(n, e) {
  switch (e.type) {
    case "CHANGE_DATE":
      return e.dateMarker;
    default:
      return n;
  }
}
function Xz(n, e, t) {
  let r = n.initialDate;
  return r != null ? e.createMarker(r) : t.getDateMarker();
}
function eV(n, e) {
  switch (e.type) {
    case "SET_OPTION":
      return Object.assign(Object.assign({}, n), { [e.optionName]: e.rawOptionValue });
    default:
      return n;
  }
}
function tV(n, e, t, r) {
  let i;
  switch (e.type) {
    case "CHANGE_VIEW_TYPE":
      return r.build(e.dateMarker || t);
    case "CHANGE_DATE":
      return r.build(e.dateMarker);
    case "PREV":
      if (i = r.buildPrev(n, t), i.isValid)
        return i;
      break;
    case "NEXT":
      if (i = r.buildNext(n, t), i.isValid)
        return i;
      break;
  }
  return n;
}
function nV(n, e, t) {
  let r = e ? e.activeRange : null;
  return WT({}, cV(n, t), r, t);
}
function rV(n, e, t, r) {
  let i = t ? t.activeRange : null;
  switch (e.type) {
    case "ADD_EVENT_SOURCES":
      return WT(n, e.sources, i, r);
    case "REMOVE_EVENT_SOURCE":
      return sV(n, e.sourceId);
    case "PREV":
    case "NEXT":
    case "CHANGE_DATE":
    case "CHANGE_VIEW_TYPE":
      return t ? UT(n, i, r) : n;
    case "FETCH_EVENT_SOURCES":
      return Fy(n, e.sourceIds ? (
        // why no type?
        K1(e.sourceIds)
      ) : $T(n, r), i, e.isRefetch || !1, r);
    case "RECEIVE_EVENTS":
    case "RECEIVE_EVENT_ERROR":
      return lV(n, e.sourceId, e.fetchId, e.fetchRange);
    case "REMOVE_ALL_EVENT_SOURCES":
      return {};
    default:
      return n;
  }
}
function iV(n, e, t) {
  let r = e ? e.activeRange : null;
  return Fy(n, $T(n, t), r, !0, t);
}
function HT(n) {
  for (let e in n)
    if (n[e].isFetching)
      return !0;
  return !1;
}
function WT(n, e, t, r) {
  let i = {};
  for (let s of e)
    i[s.sourceId] = s;
  return t && (i = UT(i, t, r)), Object.assign(Object.assign({}, n), i);
}
function sV(n, e) {
  return Ka(n, (t) => t.sourceId !== e);
}
function UT(n, e, t) {
  return Fy(n, Ka(n, (r) => oV(r, e, t)), e, !1, t);
}
function oV(n, e, t) {
  return GT(n, t) ? !t.options.lazyFetching || !n.fetchRange || n.isFetching || // always cancel outdated in-progress fetches
  e.start < n.fetchRange.start || e.end > n.fetchRange.end : !n.latestFetchId;
}
function Fy(n, e, t, r, i) {
  let s = {};
  for (let o in n) {
    let a = n[o];
    e[o] ? s[o] = aV(a, t, r, i) : s[o] = a;
  }
  return s;
}
function aV(n, e, t, r) {
  let { options: i, calendarApi: s } = r, o = r.pluginHooks.eventSourceDefs[n.sourceDefId], a = Qo();
  return o.fetch({
    eventSource: n,
    range: e,
    isRefetch: t,
    context: r
  }, (c) => {
    let { rawEvents: u } = c;
    i.eventSourceSuccess && (u = i.eventSourceSuccess.call(s, u, c.response) || u), n.success && (u = n.success.call(s, u, c.response) || u), r.dispatch({
      type: "RECEIVE_EVENTS",
      sourceId: n.sourceId,
      fetchId: a,
      fetchRange: e,
      rawEvents: u
    });
  }, (c) => {
    let u = !1;
    i.eventSourceFailure && (i.eventSourceFailure.call(s, c), u = !0), n.failure && (n.failure(c), u = !0), u || console.warn(c.message, c), r.dispatch({
      type: "RECEIVE_EVENT_ERROR",
      sourceId: n.sourceId,
      fetchId: a,
      fetchRange: e,
      error: c
    });
  }), Object.assign(Object.assign({}, n), { isFetching: !0, latestFetchId: a });
}
function lV(n, e, t, r) {
  let i = n[e];
  return i && // not already removed
  t === i.latestFetchId ? Object.assign(Object.assign({}, n), { [e]: Object.assign(Object.assign({}, i), { isFetching: !1, fetchRange: r }) }) : n;
}
function $T(n, e) {
  return Ka(n, (t) => GT(t, e));
}
function cV(n, e) {
  let t = cT(e), r = [].concat(n.eventSources || []), i = [];
  n.initialEvents && r.unshift(n.initialEvents), n.events && r.unshift(n.events);
  for (let s of r) {
    let o = lT(s, e, t);
    o && i.push(o);
  }
  return i;
}
function GT(n, e) {
  return !e.pluginHooks.eventSourceDefs[n.sourceDefId].ignoreRange;
}
function uV(n, e) {
  switch (e.type) {
    case "UNSELECT_DATES":
      return null;
    case "SELECT_DATES":
      return e.selection;
    default:
      return n;
  }
}
function dV(n, e) {
  switch (e.type) {
    case "UNSELECT_EVENT":
      return "";
    case "SELECT_EVENT":
      return e.eventInstanceId;
    default:
      return n;
  }
}
function fV(n, e) {
  let t;
  switch (e.type) {
    case "UNSET_EVENT_DRAG":
      return null;
    case "SET_EVENT_DRAG":
      return t = e.state, {
        affectedEvents: t.affectedEvents,
        mutatedEvents: t.mutatedEvents,
        isEvent: t.isEvent
      };
    default:
      return n;
  }
}
function hV(n, e) {
  let t;
  switch (e.type) {
    case "UNSET_EVENT_RESIZE":
      return null;
    case "SET_EVENT_RESIZE":
      return t = e.state, {
        affectedEvents: t.affectedEvents,
        mutatedEvents: t.mutatedEvents,
        isEvent: t.isEvent
      };
    default:
      return n;
  }
}
function pV(n, e, t, r, i) {
  let s = n.headerToolbar ? SS(n.headerToolbar, n, e, t, r, i) : null, o = n.footerToolbar ? SS(n.footerToolbar, n, e, t, r, i) : null;
  return { header: s, footer: o };
}
function SS(n, e, t, r, i, s) {
  let o = {}, a = [], c = !1;
  for (let u in n) {
    let f = n[u], h = mV(f, e, t, r, i, s);
    o[u] = h.widgets, a.push(...h.viewsWithButtons), c = c || h.hasTitle;
  }
  return { sectionWidgets: o, viewsWithButtons: a, hasTitle: c };
}
function mV(n, e, t, r, i, s) {
  let o = e.direction === "rtl", a = e.customButtons || {}, c = t.buttonText || {}, u = e.buttonText || {}, f = t.buttonHints || {}, h = e.buttonHints || {}, p = n ? n.split(" ") : [], g = [], y = !1;
  return { widgets: p.map((S) => S.split(",").map((w) => {
    if (w === "title")
      return y = !0, { buttonName: w };
    let C, T, k, R, P, L;
    if (C = a[w])
      k = (B) => {
        C.click && C.click.call(B.target, B, B.target);
      }, (R = r.getCustomButtonIconClass(C)) || (R = r.getIconClass(w, o)) || (P = C.text), L = C.hint || C.text;
    else if (T = i[w]) {
      g.push(w), k = () => {
        s.changeView(w);
      }, (P = T.buttonTextOverride) || (R = r.getIconClass(w, o)) || (P = T.buttonTextDefault);
      let B = T.buttonTextOverride || T.buttonTextDefault;
      L = ql(
        T.buttonTitleOverride || T.buttonTitleDefault || e.viewHint,
        [B, w],
        // view-name = buttonName
        B
      );
    } else if (s[w])
      if (k = () => {
        s[w]();
      }, (P = c[w]) || (R = r.getIconClass(w, o)) || (P = u[w]), w === "prevYear" || w === "nextYear") {
        let B = w === "prevYear" ? "prev" : "next";
        L = ql(f[B] || h[B], [
          u.year || "year",
          "year"
        ], u[w]);
      } else
        L = (B) => ql(f[w] || h[w], [
          u[B] || B,
          B
        ], u[w]);
    return { buttonName: w, buttonClick: k, buttonIcon: R, buttonText: P, buttonHint: L };
  })), viewsWithButtons: g, hasTitle: y };
}
class gV {
  constructor(e, t, r) {
    this.type = e, this.getCurrentData = t, this.dateEnv = r;
  }
  get calendar() {
    return this.getCurrentData().calendarApi;
  }
  get title() {
    return this.getCurrentData().viewTitle;
  }
  get activeStart() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
  }
  get activeEnd() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
  }
  get currentStart() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
  }
  get currentEnd() {
    return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
  }
  getOption(e) {
    return this.getCurrentData().options[e];
  }
}
let yV = {
  ignoreRange: !0,
  parseMeta(n) {
    return Array.isArray(n.events) ? n.events : null;
  },
  fetch(n, e) {
    e({
      rawEvents: n.eventSource.meta
    });
  }
};
const vV = to({
  name: "array-event-source",
  eventSourceDefs: [yV]
});
let bV = {
  parseMeta(n) {
    return typeof n.events == "function" ? n.events : null;
  },
  fetch(n, e, t) {
    const { dateEnv: r } = n.context, i = n.eventSource.meta;
    WF(i.bind(null, bT(n.range, r)), (s) => e({ rawEvents: s }), t);
  }
};
const xV = to({
  name: "func-event-source",
  eventSourceDefs: [bV]
}), SV = {
  method: String,
  extraParams: U,
  startParam: String,
  endParam: String,
  timeZoneParam: String
};
let wV = {
  parseMeta(n) {
    return n.url && (n.format === "json" || !n.format) ? {
      url: n.url,
      format: "json",
      method: (n.method || "GET").toUpperCase(),
      extraParams: n.extraParams,
      startParam: n.startParam,
      endParam: n.endParam,
      timeZoneParam: n.timeZoneParam
    } : null;
  },
  fetch(n, e, t) {
    const { meta: r } = n.eventSource, i = AV(r, n.range, n.context);
    UF(r.method, r.url, i).then(([s, o]) => {
      e({ rawEvents: s, response: o });
    }, t);
  }
};
const EV = to({
  name: "json-event-source",
  eventSourceRefiners: SV,
  eventSourceDefs: [wV]
});
function AV(n, e, t) {
  let { dateEnv: r, options: i } = t, s, o, a, c, u = {};
  return s = n.startParam, s == null && (s = i.startParam), o = n.endParam, o == null && (o = i.endParam), a = n.timeZoneParam, a == null && (a = i.timeZoneParam), typeof n.extraParams == "function" ? c = n.extraParams() : c = n.extraParams || {}, Object.assign(u, c), u[s] = r.formatIso(e.start), u[o] = r.formatIso(e.end), r.timeZone !== "local" && (u[a] = r.timeZone), u;
}
const TV = {
  daysOfWeek: U,
  startTime: ot,
  endTime: ot,
  duration: ot,
  startRecur: U,
  endRecur: U
};
let CV = {
  parse(n, e) {
    if (n.daysOfWeek || n.startTime || n.endTime || n.startRecur || n.endRecur) {
      let t = {
        daysOfWeek: n.daysOfWeek || null,
        startTime: n.startTime || null,
        endTime: n.endTime || null,
        startRecur: n.startRecur ? e.createMarker(n.startRecur) : null,
        endRecur: n.endRecur ? e.createMarker(n.endRecur) : null,
        dateEnv: e
      }, r;
      return n.duration && (r = n.duration), !r && n.startTime && n.endTime && (r = XB(n.endTime, n.startTime)), {
        allDayGuess: !n.startTime && !n.endTime,
        duration: r,
        typeData: t
        // doesn't need endTime anymore but oh well
      };
    }
    return null;
  },
  expand(n, e, t) {
    let r = Uo(e, { start: n.startRecur, end: n.endRecur });
    return r ? RV(n.daysOfWeek, n.startTime, n.dateEnv, t, r) : [];
  }
};
const DV = to({
  name: "simple-recurring-event",
  recurringTypes: [CV],
  eventRefiners: TV
});
function RV(n, e, t, r, i) {
  let s = n ? K1(n) : null, o = Mt(i.start), a = i.end, c = [];
  for (e && (e.milliseconds < 0 ? a = vn(a, 1) : e.milliseconds >= 1e3 * 60 * 60 * 24 && (o = vn(o, -1))); o < a; ) {
    let u;
    (!s || s[o.getUTCDay()]) && (e ? u = r.add(o, e) : u = o, c.push(r.createMarker(t.toDate(u)))), o = vn(o, 1);
  }
  return c;
}
const kV = to({
  name: "change-handler",
  optionChangeHandlers: {
    events(n, e) {
      wS([n], e);
    },
    eventSources: wS
  }
});
function wS(n, e) {
  let t = Ay(e.getCurrentData().eventSources);
  if (t.length === 1 && n.length === 1 && Array.isArray(t[0]._raw) && Array.isArray(n[0])) {
    e.dispatch({
      type: "RESET_RAW_EVENTS",
      sourceId: t[0].sourceId,
      rawEvents: n[0]
    });
    return;
  }
  let r = [];
  for (let i of n) {
    let s = !1;
    for (let o = 0; o < t.length; o += 1)
      if (t[o]._raw === i) {
        t.splice(o, 1), s = !0;
        break;
      }
    s || r.push(i);
  }
  for (let i of t)
    e.dispatch({
      type: "REMOVE_EVENT_SOURCE",
      sourceId: i.sourceId
    });
  for (let i of r)
    e.calendarApi.addEventSource(i);
}
function MV(n, e) {
  e.emitter.trigger("datesSet", Object.assign(Object.assign({}, bT(n.activeRange, e.dateEnv)), { view: e.viewApi }));
}
function _V(n, e) {
  let { emitter: t } = e;
  t.hasHandlers("eventsSet") && t.trigger("eventsSet", My(n, e));
}
const OV = [
  vV,
  xV,
  EV,
  DV,
  kV,
  to({
    name: "misc",
    isLoadingFuncs: [
      (n) => HT(n.eventSources)
    ],
    propSetHandlers: {
      dateProfile: MV,
      eventStore: _V
    }
  })
];
class IV {
  constructor(e, t) {
    this.runTaskOption = e, this.drainedOption = t, this.queue = [], this.delayedRunner = new vy(this.drain.bind(this));
  }
  request(e, t) {
    this.queue.push(e), this.delayedRunner.request(t);
  }
  pause(e) {
    this.delayedRunner.pause(e);
  }
  resume(e, t) {
    this.delayedRunner.resume(e, t);
  }
  drain() {
    let { queue: e } = this;
    for (; e.length; ) {
      let t = [], r;
      for (; r = e.shift(); )
        this.runTask(r), t.push(r);
      this.drained(t);
    }
  }
  runTask(e) {
    this.runTaskOption && this.runTaskOption(e);
  }
  drained(e) {
    this.drainedOption && this.drainedOption(e);
  }
}
function NV(n, e, t) {
  let r;
  return /^(year|month)$/.test(n.currentRangeUnit) ? r = n.currentRange : r = n.activeRange, t.formatRange(r.start, r.end, Ht(e.titleFormat || PV(n)), {
    isEndExclusive: n.isRangeAllDay,
    defaultSeparator: e.titleRangeSeparator
  });
}
function PV(n) {
  let { currentRangeUnit: e } = n;
  if (e === "year")
    return { year: "numeric" };
  if (e === "month")
    return { year: "numeric", month: "long" };
  let t = Od(n.currentRange.start, n.currentRange.end);
  return t !== null && t > 1 ? { year: "numeric", month: "short", day: "numeric" } : { year: "numeric", month: "long", day: "numeric" };
}
class ES {
  constructor() {
    this.resetListeners = /* @__PURE__ */ new Set();
  }
  handleInput(e, t) {
    const r = this.dateEnv;
    if (e !== r && (typeof t == "function" ? this.nowFn = t : r || (this.nowAnchorDate = e.toDate(t ? e.createMarker(t) : e.createNowMarker()), this.nowAnchorQueried = Date.now()), this.dateEnv = e, r))
      for (const i of this.resetListeners.values())
        i();
  }
  getDateMarker() {
    return this.nowAnchorDate ? this.dateEnv.timestampToMarker(this.nowAnchorDate.valueOf() + (Date.now() - this.nowAnchorQueried)) : this.dateEnv.createMarker(this.nowFn());
  }
  addResetListener(e) {
    this.resetListeners.add(e);
  }
  removeResetListener(e) {
    this.resetListeners.delete(e);
  }
}
class LV {
  constructor(e) {
    this.computeCurrentViewData = Ne(this._computeCurrentViewData), this.organizeRawLocales = Ne(jz), this.buildLocale = Ne(zT), this.buildPluginHooks = Hz(), this.buildDateEnv = Ne(BV), this.buildTheme = Ne(jV), this.parseToolbars = Ne(pV), this.buildViewSpecs = Ne(qz), this.buildDateProfileGenerator = md(FV), this.buildViewApi = Ne(zV), this.buildViewUiProps = md(WV), this.buildEventUiBySource = Ne(VV, pi), this.buildEventUiBases = Ne(HV), this.parseContextBusinessHours = md(UV), this.buildTitle = Ne(NV), this.nowManager = new ES(), this.emitter = new xF(), this.actionRunner = new IV(this._handleAction.bind(this), this.updateData.bind(this)), this.currentCalendarOptionsInput = {}, this.currentCalendarOptionsRefined = {}, this.currentViewOptionsInput = {}, this.currentViewOptionsRefined = {}, this.currentCalendarOptionsRefiners = {}, this.optionsForRefining = [], this.optionsForHandling = [], this.getCurrentData = () => this.data, this.dispatch = (p) => {
      this.actionRunner.request(p);
    }, this.props = e, this.actionRunner.pause(), this.nowManager = new ES();
    let t = {}, r = this.computeOptionsData(e.optionOverrides, t, e.calendarApi), i = r.calendarOptions.initialView || r.pluginHooks.initialView, s = this.computeCurrentViewData(i, r, e.optionOverrides, t);
    e.calendarApi.currentDataManager = this, this.emitter.setThisContext(e.calendarApi), this.emitter.setOptions(s.options);
    let o = {
      nowManager: this.nowManager,
      dateEnv: r.dateEnv,
      options: r.calendarOptions,
      pluginHooks: r.pluginHooks,
      calendarApi: e.calendarApi,
      dispatch: this.dispatch,
      emitter: this.emitter,
      getCurrentData: this.getCurrentData
    }, a = Xz(r.calendarOptions, r.dateEnv, this.nowManager), c = s.dateProfileGenerator.build(a);
    ns(c.activeRange, a) || (a = c.currentRange.start);
    for (let p of r.pluginHooks.contextInit)
      p(o);
    let u = nV(r.calendarOptions, c, o), f = {
      dynamicOptionOverrides: t,
      currentViewType: i,
      currentDate: a,
      dateProfile: c,
      businessHours: this.parseContextBusinessHours(o),
      eventSources: u,
      eventUiBases: {},
      eventStore: as(),
      renderableEventStore: as(),
      dateSelection: null,
      eventSelection: "",
      eventDrag: null,
      eventResize: null,
      selectionConfig: this.buildViewUiProps(o).selectionConfig
    }, h = Object.assign(Object.assign({}, o), f);
    for (let p of r.pluginHooks.reducers)
      Object.assign(f, p(null, null, h));
    Bp(f, o) && this.emitter.trigger("loading", !0), this.state = f, this.updateData(), this.actionRunner.resume();
  }
  resetOptions(e, t) {
    let { props: r } = this;
    t === void 0 ? r.optionOverrides = e : (r.optionOverrides = Object.assign(Object.assign({}, r.optionOverrides || {}), e), this.optionsForRefining.push(...t)), (t === void 0 || t.length) && this.actionRunner.request({
      type: "NOTHING"
    });
  }
  _handleAction(e) {
    let { props: t, state: r, emitter: i } = this, s = eV(r.dynamicOptionOverrides, e), o = this.computeOptionsData(t.optionOverrides, s, t.calendarApi), a = Qz(r.currentViewType, e), c = this.computeCurrentViewData(a, o, t.optionOverrides, s);
    t.calendarApi.currentDataManager = this, i.setThisContext(t.calendarApi), i.setOptions(c.options);
    let u = {
      nowManager: this.nowManager,
      dateEnv: o.dateEnv,
      options: o.calendarOptions,
      pluginHooks: o.pluginHooks,
      calendarApi: t.calendarApi,
      dispatch: this.dispatch,
      emitter: i,
      getCurrentData: this.getCurrentData
    }, { currentDate: f, dateProfile: h } = r;
    this.data && this.data.dateProfileGenerator !== c.dateProfileGenerator && (h = c.dateProfileGenerator.build(f)), f = Zz(f, e), h = tV(h, e, f, c.dateProfileGenerator), (e.type === "PREV" || // TODO: move this logic into DateProfileGenerator
    e.type === "NEXT" || // "
    !ns(h.currentRange, f)) && (f = h.currentRange.start);
    let p = rV(r.eventSources, e, h, u), g = mF(r.eventStore, e, p, h, u), x = HT(p) && !c.options.progressiveEventRendering && r.renderableEventStore || g, { eventUiSingleBase: S, selectionConfig: w } = this.buildViewUiProps(u), C = this.buildEventUiBySource(p), T = this.buildEventUiBases(x.defs, S, C), k = {
      dynamicOptionOverrides: s,
      currentViewType: a,
      currentDate: f,
      dateProfile: h,
      eventSources: p,
      eventStore: g,
      renderableEventStore: x,
      selectionConfig: w,
      eventUiBases: T,
      businessHours: this.parseContextBusinessHours(u),
      dateSelection: uV(r.dateSelection, e),
      eventSelection: dV(r.eventSelection, e),
      eventDrag: fV(r.eventDrag, e),
      eventResize: hV(r.eventResize, e)
    }, R = Object.assign(Object.assign({}, u), k);
    for (let B of o.pluginHooks.reducers)
      Object.assign(k, B(r, e, R));
    let P = Bp(r, u), L = Bp(k, u);
    !P && L ? i.trigger("loading", !0) : P && !L && i.trigger("loading", !1), this.state = k, t.onAction && t.onAction(e);
  }
  updateData() {
    let { props: e, state: t } = this, r = this.data, i = this.computeOptionsData(e.optionOverrides, t.dynamicOptionOverrides, e.calendarApi), s = this.computeCurrentViewData(t.currentViewType, i, e.optionOverrides, t.dynamicOptionOverrides), o = this.data = Object.assign(Object.assign(Object.assign({ nowManager: this.nowManager, viewTitle: this.buildTitle(t.dateProfile, s.options, i.dateEnv), calendarApi: e.calendarApi, dispatch: this.dispatch, emitter: this.emitter, getCurrentData: this.getCurrentData }, i), s), t), a = i.pluginHooks.optionChangeHandlers, c = r && r.calendarOptions, u = i.calendarOptions;
    if (c && c !== u) {
      c.timeZone !== u.timeZone && (t.eventSources = o.eventSources = iV(o.eventSources, t.dateProfile, o), t.eventStore = o.eventStore = dS(o.eventStore, r.dateEnv, o.dateEnv), t.renderableEventStore = o.renderableEventStore = dS(o.renderableEventStore, r.dateEnv, o.dateEnv));
      for (let f in a)
        (this.optionsForHandling.indexOf(f) !== -1 || c[f] !== u[f]) && a[f](u[f], o);
    }
    this.optionsForHandling = [], e.onData && e.onData(o);
  }
  computeOptionsData(e, t, r) {
    if (!this.optionsForRefining.length && e === this.stableOptionOverrides && t === this.stableDynamicOptionOverrides)
      return this.stableCalendarOptionsData;
    let { refinedOptions: i, pluginHooks: s, localeDefaults: o, availableLocaleData: a, extra: c } = this.processRawCalendarOptions(e, t);
    AS(c);
    let u = this.buildDateEnv(i.timeZone, i.locale, i.weekNumberCalculation, i.firstDay, i.weekText, s, a, i.defaultRangeSeparator), f = this.buildViewSpecs(s.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, o), h = this.buildTheme(i, s), p = this.parseToolbars(i, this.stableOptionOverrides, h, f, r);
    return this.stableCalendarOptionsData = {
      calendarOptions: i,
      pluginHooks: s,
      dateEnv: u,
      viewSpecs: f,
      theme: h,
      toolbarConfig: p,
      localeDefaults: o,
      availableRawLocales: a.map
    };
  }
  // always called from behind a memoizer
  processRawCalendarOptions(e, t) {
    let { locales: r, locale: i } = Mp([
      Kl,
      e,
      t
    ]), s = this.organizeRawLocales(r), o = s.map, a = this.buildLocale(i || s.defaultCode, o).options, c = this.buildPluginHooks(e.plugins || [], OV), u = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, sS), oS), aS), c.listenerRefiners), c.optionRefiners), f = {}, h = Mp([
      Kl,
      a,
      e,
      t
    ]), p = {}, g = this.currentCalendarOptionsInput, y = this.currentCalendarOptionsRefined, x = !1;
    for (let S in h)
      this.optionsForRefining.indexOf(S) === -1 && (h[S] === g[S] || Eo[S] && S in g && Eo[S](g[S], h[S])) ? p[S] = y[S] : u[S] ? (p[S] = u[S](h[S]), x = !0) : f[S] = g[S];
    return x && (this.currentCalendarOptionsInput = h, this.currentCalendarOptionsRefined = p, this.stableOptionOverrides = e, this.stableDynamicOptionOverrides = t), this.optionsForHandling.push(...this.optionsForRefining), this.optionsForRefining = [], {
      rawOptions: this.currentCalendarOptionsInput,
      refinedOptions: this.currentCalendarOptionsRefined,
      pluginHooks: c,
      availableLocaleData: s,
      localeDefaults: a,
      extra: f
    };
  }
  _computeCurrentViewData(e, t, r, i) {
    let s = t.viewSpecs[e];
    if (!s)
      throw new Error(`viewType "${e}" is not available. Please make sure you've loaded all neccessary plugins`);
    let { refinedOptions: o, extra: a } = this.processRawViewOptions(s, t.pluginHooks, t.localeDefaults, r, i);
    AS(a), this.nowManager.handleInput(t.dateEnv, o.now);
    let c = this.buildDateProfileGenerator({
      dateProfileGeneratorClass: s.optionDefaults.dateProfileGeneratorClass,
      nowManager: this.nowManager,
      duration: s.duration,
      durationUnit: s.durationUnit,
      usesMinMaxTime: s.optionDefaults.usesMinMaxTime,
      dateEnv: t.dateEnv,
      calendarApi: this.props.calendarApi,
      slotMinTime: o.slotMinTime,
      slotMaxTime: o.slotMaxTime,
      showNonCurrentDates: o.showNonCurrentDates,
      dayCount: o.dayCount,
      dateAlignment: o.dateAlignment,
      dateIncrement: o.dateIncrement,
      hiddenDays: o.hiddenDays,
      weekends: o.weekends,
      validRangeInput: o.validRange,
      visibleRangeInput: o.visibleRange,
      fixedWeekCount: o.fixedWeekCount
    }), u = this.buildViewApi(e, this.getCurrentData, t.dateEnv);
    return { viewSpec: s, options: o, dateProfileGenerator: c, viewApi: u };
  }
  processRawViewOptions(e, t, r, i, s) {
    let o = Mp([
      Kl,
      e.optionDefaults,
      r,
      i,
      e.optionOverrides,
      s
    ]), a = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, sS), oS), aS), Oj), t.listenerRefiners), t.optionRefiners), c = {}, u = this.currentViewOptionsInput, f = this.currentViewOptionsRefined, h = !1, p = {};
    for (let g in o)
      o[g] === u[g] || Eo[g] && Eo[g](o[g], u[g]) ? c[g] = f[g] : (o[g] === this.currentCalendarOptionsInput[g] || Eo[g] && Eo[g](o[g], this.currentCalendarOptionsInput[g]) ? g in this.currentCalendarOptionsRefined && (c[g] = this.currentCalendarOptionsRefined[g]) : a[g] ? c[g] = a[g](o[g]) : p[g] = o[g], h = !0);
    return h && (this.currentViewOptionsInput = o, this.currentViewOptionsRefined = c), {
      rawOptions: this.currentViewOptionsInput,
      refinedOptions: this.currentViewOptionsRefined,
      extra: p
    };
  }
}
function BV(n, e, t, r, i, s, o, a) {
  let c = zT(e || o.defaultCode, o.map);
  return new Wj({
    calendarSystem: "gregory",
    timeZone: n,
    namedTimeZoneImpl: s.namedTimeZonedImpl,
    locale: c,
    weekNumberCalculation: t,
    firstDay: r,
    weekText: i,
    cmdFormatter: s.cmdFormatter,
    defaultSeparator: a
  });
}
function jV(n, e) {
  let t = e.themeClasses[n.themeSystem] || no;
  return new t(n);
}
function FV(n) {
  let e = n.dateProfileGeneratorClass || rT;
  return new e(n);
}
function zV(n, e, t) {
  return new gV(n, e, t);
}
function VV(n) {
  return Wo(n, (e) => e.ui);
}
function HV(n, e, t) {
  let r = { "": e };
  for (let i in n) {
    let s = n[i];
    s.sourceId && t[s.sourceId] && (r[i] = t[s.sourceId]);
  }
  return r;
}
function WV(n) {
  let { options: e } = n;
  return {
    eventUiSingleBase: Fd({
      display: e.eventDisplay,
      editable: e.editable,
      startEditable: e.eventStartEditable,
      durationEditable: e.eventDurationEditable,
      constraint: e.eventConstraint,
      overlap: typeof e.eventOverlap == "boolean" ? e.eventOverlap : void 0,
      allow: e.eventAllow,
      backgroundColor: e.eventBackgroundColor,
      borderColor: e.eventBorderColor,
      textColor: e.eventTextColor,
      color: e.eventColor
      // classNames: options.eventClassNames // render hook will handle this
    }, n),
    selectionConfig: Fd({
      constraint: e.selectConstraint,
      overlap: typeof e.selectOverlap == "boolean" ? e.selectOverlap : void 0,
      allow: e.selectAllow
    }, n)
  };
}
function Bp(n, e) {
  for (let t of e.pluginHooks.isLoadingFuncs)
    if (t(n))
      return !0;
  return !1;
}
function UV(n) {
  return AF(n.options.businessHours, n);
}
function AS(n, e) {
  for (let t in n)
    console.warn(`Unknown option '${t}'`);
}
class $V extends pt {
  render() {
    let e = this.props.widgetGroups.map((t) => this.renderWidgetGroup(t));
    return I("div", { className: "fc-toolbar-chunk" }, ...e);
  }
  renderWidgetGroup(e) {
    let { props: t } = this, { theme: r } = this.context, i = [], s = !0;
    for (let o of e) {
      let { buttonName: a, buttonClick: c, buttonText: u, buttonIcon: f, buttonHint: h } = o;
      if (a === "title")
        s = !1, i.push(I("h2", { className: "fc-toolbar-title", id: t.titleId }, t.title));
      else {
        let p = a === t.activeButton, g = !t.isTodayEnabled && a === "today" || !t.isPrevEnabled && a === "prev" || !t.isNextEnabled && a === "next", y = [`fc-${a}-button`, r.getClass("button")];
        p && y.push(r.getClass("buttonActive")), i.push(I("button", { type: "button", title: typeof h == "function" ? h(t.navUnit) : h, disabled: g, "aria-pressed": p, className: y.join(" "), onClick: c }, u || (f ? I("span", { className: f, role: "img" }) : "")));
      }
    }
    if (i.length > 1) {
      let o = s && r.getClass("buttonGroup") || "";
      return I("div", { className: o }, ...i);
    }
    return i[0];
  }
}
class TS extends pt {
  render() {
    let { model: e, extraClassName: t } = this.props, r = !1, i, s, o = e.sectionWidgets, a = o.center;
    return o.left ? (r = !0, i = o.left) : i = o.start, o.right ? (r = !0, s = o.right) : s = o.end, I(
      "div",
      { className: [
        t || "",
        "fc-toolbar",
        r ? "fc-toolbar-ltr" : ""
      ].join(" ") },
      this.renderSection("start", i || []),
      this.renderSection("center", a || []),
      this.renderSection("end", s || [])
    );
  }
  renderSection(e, t) {
    let { props: r } = this;
    return I($V, { key: e, widgetGroups: t, title: r.title, navUnit: r.navUnit, activeButton: r.activeButton, isTodayEnabled: r.isTodayEnabled, isPrevEnabled: r.isPrevEnabled, isNextEnabled: r.isNextEnabled, titleId: r.titleId });
  }
}
class GV extends pt {
  constructor() {
    super(...arguments), this.state = {
      availableWidth: null
    }, this.handleEl = (e) => {
      this.el = e, _i(this.props.elRef, e), this.updateAvailableWidth();
    }, this.handleResize = () => {
      this.updateAvailableWidth();
    };
  }
  render() {
    let { props: e, state: t } = this, { aspectRatio: r } = e, i = [
      "fc-view-harness",
      r || e.liquid || e.height ? "fc-view-harness-active" : "fc-view-harness-passive"
      // let the view do the height
    ], s = "", o = "";
    return r ? t.availableWidth !== null ? s = t.availableWidth / r : o = `${1 / r * 100}%` : s = e.height || "", I("div", { "aria-labelledby": e.labeledById, ref: this.handleEl, className: i.join(" "), style: { height: s, paddingBottom: o } }, e.children);
  }
  componentDidMount() {
    this.context.addResizeHandler(this.handleResize);
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleResize);
  }
  updateAvailableWidth() {
    this.el && // needed. but why?
    this.props.aspectRatio && this.setState({ availableWidth: this.el.offsetWidth });
  }
}
class YV extends wT {
  constructor(e) {
    super(e), this.handleSegClick = (t, r) => {
      let { component: i } = this, { context: s } = i, o = tg(r);
      if (o && // might be the <div> surrounding the more link
      i.isValidSegDownEl(t.target)) {
        let a = Xi(t.target, ".fc-event-forced-url"), c = a ? a.querySelector("a[href]").href : "";
        s.emitter.trigger("eventClick", {
          el: r,
          event: new qr(i.context, o.eventRange.def, o.eventRange.instance),
          jsEvent: t,
          view: s.viewApi
        }), c && !t.defaultPrevented && (window.location.href = c);
      }
    }, this.destroy = U1(
      e.el,
      "click",
      ".fc-event",
      // on both fg and bg events
      this.handleSegClick
    );
  }
}
class qV extends wT {
  constructor(e) {
    super(e), this.handleEventElRemove = (t) => {
      t === this.currentSegEl && this.handleSegLeave(null, this.currentSegEl);
    }, this.handleSegEnter = (t, r) => {
      tg(r) && (this.currentSegEl = r, this.triggerEvent("eventMouseEnter", t, r));
    }, this.handleSegLeave = (t, r) => {
      this.currentSegEl && (this.currentSegEl = null, this.triggerEvent("eventMouseLeave", t, r));
    }, this.removeHoverListeners = UB(
      e.el,
      ".fc-event",
      // on both fg and bg events
      this.handleSegEnter,
      this.handleSegLeave
    );
  }
  destroy() {
    this.removeHoverListeners();
  }
  triggerEvent(e, t, r) {
    let { component: i } = this, { context: s } = i, o = tg(r);
    (!t || i.isValidSegDownEl(t.target)) && s.emitter.trigger(e, {
      el: r,
      event: new qr(s, o.eventRange.def, o.eventRange.instance),
      jsEvent: t,
      view: s.viewApi
    });
  }
}
class KV extends Xo {
  constructor() {
    super(...arguments), this.buildViewContext = Ne(Gj), this.buildViewPropTransformers = Ne(QV), this.buildToolbarProps = Ne(JV), this.headerRef = Xn(), this.footerRef = Xn(), this.interactionsStore = {}, this.state = {
      viewLabelId: $f()
    }, this.registerInteractiveComponent = (e, t) => {
      let r = YF(e, t), o = [
        YV,
        qV
      ].concat(this.props.pluginHooks.componentInteractions).map((a) => new a(r));
      this.interactionsStore[e.uid] = o, gS[e.uid] = r;
    }, this.unregisterInteractiveComponent = (e) => {
      let t = this.interactionsStore[e.uid];
      if (t) {
        for (let r of t)
          r.destroy();
        delete this.interactionsStore[e.uid];
      }
      delete gS[e.uid];
    }, this.resizeRunner = new vy(() => {
      this.props.emitter.trigger("_resize", !0), this.props.emitter.trigger("windowResize", { view: this.props.viewApi });
    }), this.handleWindowResize = (e) => {
      let { options: t } = this.props;
      t.handleWindowResize && e.target === window && this.resizeRunner.request(t.windowResizeDelay);
    };
  }
  /*
  renders INSIDE of an outer div
  */
  render() {
    let { props: e } = this, { toolbarConfig: t, options: r } = e, i = !1, s = "", o;
    e.isHeightAuto || e.forPrint ? s = "" : r.height != null ? i = !0 : r.contentHeight != null ? s = r.contentHeight : o = Math.max(r.aspectRatio, 0.5);
    let a = this.buildViewContext(e.viewSpec, e.viewApi, e.options, e.dateProfileGenerator, e.dateEnv, e.nowManager, e.theme, e.pluginHooks, e.dispatch, e.getCurrentData, e.emitter, e.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent), c = t.header && t.header.hasTitle ? this.state.viewLabelId : void 0;
    return I(
      ms.Provider,
      { value: a },
      I(rl, { unit: "day" }, (u) => {
        let f = this.buildToolbarProps(e.viewSpec, e.dateProfile, e.dateProfileGenerator, e.currentDate, u, e.viewTitle);
        return I(
          Ct,
          null,
          t.header && I(TS, Object.assign({ ref: this.headerRef, extraClassName: "fc-header-toolbar", model: t.header, titleId: c }, f)),
          I(
            GV,
            { liquid: i, height: s, aspectRatio: o, labeledById: c },
            this.renderView(e),
            this.buildAppendContent()
          ),
          t.footer && I(TS, Object.assign({ ref: this.footerRef, extraClassName: "fc-footer-toolbar", model: t.footer, titleId: "" }, f))
        );
      })
    );
  }
  componentDidMount() {
    let { props: e } = this;
    this.calendarInteractions = e.pluginHooks.calendarInteractions.map((r) => new r(e)), window.addEventListener("resize", this.handleWindowResize);
    let { propSetHandlers: t } = e.pluginHooks;
    for (let r in t)
      t[r](e[r], e);
  }
  componentDidUpdate(e) {
    let { props: t } = this, { propSetHandlers: r } = t.pluginHooks;
    for (let i in r)
      t[i] !== e[i] && r[i](t[i], t);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize), this.resizeRunner.clear();
    for (let e of this.calendarInteractions)
      e.destroy();
    this.props.emitter.trigger("_unmount");
  }
  buildAppendContent() {
    let { props: e } = this, t = e.pluginHooks.viewContainerAppends.map((r) => r(e));
    return I(Ct, {}, ...t);
  }
  renderView(e) {
    let { pluginHooks: t } = e, { viewSpec: r } = e, i = {
      dateProfile: e.dateProfile,
      businessHours: e.businessHours,
      eventStore: e.renderableEventStore,
      eventUiBases: e.eventUiBases,
      dateSelection: e.dateSelection,
      eventSelection: e.eventSelection,
      eventDrag: e.eventDrag,
      eventResize: e.eventResize,
      isHeightAuto: e.isHeightAuto,
      forPrint: e.forPrint
    }, s = this.buildViewPropTransformers(t.viewPropsTransformers);
    for (let a of s)
      Object.assign(i, a.transform(i, e));
    let o = r.component;
    return I(o, Object.assign({}, i));
  }
}
function JV(n, e, t, r, i, s) {
  let o = t.build(i, void 0, !1), a = t.buildPrev(e, r, !1), c = t.buildNext(e, r, !1);
  return {
    title: s,
    activeButton: n.type,
    navUnit: n.singleUnit,
    isTodayEnabled: o.isValid && !ns(e.currentRange, i),
    isPrevEnabled: a.isValid,
    isNextEnabled: c.isValid
  };
}
function QV(n) {
  return n.map((e) => new e());
}
class ZV extends KF {
  constructor(e, t = {}) {
    super(), this.isRendering = !1, this.isRendered = !1, this.currentClassNames = [], this.customContentRenderId = 0, this.handleAction = (r) => {
      switch (r.type) {
        case "SET_EVENT_DRAG":
        case "SET_EVENT_RESIZE":
          this.renderRunner.tryDrain();
      }
    }, this.handleData = (r) => {
      this.currentData = r, this.renderRunner.request(r.calendarOptions.rerenderDelay);
    }, this.handleRenderRequest = () => {
      if (this.isRendering) {
        this.isRendered = !0;
        let { currentData: r } = this;
        Ld(() => {
          pc(I(GF, { options: r.calendarOptions, theme: r.theme, emitter: r.emitter }, (i, s, o, a) => (this.setClassNames(i), this.setHeight(s), I(
            X1.Provider,
            { value: this.customContentRenderId },
            I(KV, Object.assign({ isHeightAuto: o, forPrint: a }, r))
          ))), this.el);
        });
      } else this.isRendered && (this.isRendered = !1, pc(null, this.el), this.setClassNames([]), this.setHeight(""));
    }, OB(e), this.el = e, this.renderRunner = new vy(this.handleRenderRequest), new LV({
      optionOverrides: t,
      calendarApi: this,
      onAction: this.handleAction,
      onData: this.handleData
    });
  }
  render() {
    let e = this.isRendering;
    e ? this.customContentRenderId += 1 : this.isRendering = !0, this.renderRunner.request(), e && this.updateSize();
  }
  destroy() {
    this.isRendering && (this.isRendering = !1, this.renderRunner.request());
  }
  updateSize() {
    Ld(() => {
      super.updateSize();
    });
  }
  batchRendering(e) {
    this.renderRunner.pause("batchRendering"), e(), this.renderRunner.resume("batchRendering");
  }
  pauseRendering() {
    this.renderRunner.pause("pauseRendering");
  }
  resumeRendering() {
    this.renderRunner.resume("pauseRendering", !0);
  }
  resetOptions(e, t) {
    this.currentDataManager.resetOptions(e, t);
  }
  setClassNames(e) {
    if (!Qs(e, this.currentClassNames)) {
      let { classList: t } = this.el;
      for (let r of this.currentClassNames)
        t.remove(r);
      for (let r of e)
        t.add(r);
      this.currentClassNames = e;
    }
  }
  setHeight(e) {
    W1(this.el, "height", e);
  }
}
class XV extends Li {
  constructor() {
    super(...arguments), this.headerElRef = Xn();
  }
  renderSimpleLayout(e, t) {
    let { props: r, context: i } = this, s = [], o = Vd(i.options);
    return e && s.push({
      type: "header",
      key: "header",
      isSticky: o,
      chunk: {
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }
    }), s.push({
      type: "body",
      key: "body",
      liquid: !0,
      chunk: { content: t }
    }), I(
      Bd,
      { elClasses: ["fc-daygrid"], viewSpec: i.viewSpec },
      I(Iy, { liquid: !r.isHeightAuto && !r.forPrint, collapsibleWidth: r.forPrint, cols: [], sections: s })
    );
  }
  renderHScrollLayout(e, t, r, i) {
    let s = this.context.pluginHooks.scrollGridImpl;
    if (!s)
      throw new Error("No ScrollGrid implementation");
    let { props: o, context: a } = this, c = !o.forPrint && Vd(a.options), u = !o.forPrint && OT(a.options), f = [];
    return e && f.push({
      type: "header",
      key: "header",
      isSticky: c,
      chunks: [{
        key: "main",
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }]
    }), f.push({
      type: "body",
      key: "body",
      liquid: !0,
      chunks: [{
        key: "main",
        content: t
      }]
    }), u && f.push({
      type: "footer",
      key: "footer",
      isSticky: !0,
      chunks: [{
        key: "main",
        content: ig
      }]
    }), I(
      Bd,
      { elClasses: ["fc-daygrid"], viewSpec: a.viewSpec },
      I(s, { liquid: !o.isHeightAuto && !o.forPrint, forPrint: o.forPrint, collapsibleWidth: o.forPrint, colGroups: [{ cols: [{ span: r, minWidth: i }] }], sections: f })
    );
  }
}
function yd(n, e) {
  let t = [];
  for (let r = 0; r < e; r += 1)
    t[r] = [];
  for (let r of n)
    t[r.row].push(r);
  return t;
}
function Wu(n, e) {
  let t = [];
  for (let r = 0; r < e; r += 1)
    t[r] = [];
  for (let r of n)
    t[r.firstCol].push(r);
  return t;
}
function CS(n, e) {
  let t = [];
  if (n) {
    for (let r = 0; r < e; r += 1)
      t[r] = {
        affectedInstances: n.affectedInstances,
        isEvent: n.isEvent,
        segs: []
      };
    for (let r of n.segs)
      t[r.row].segs.push(r);
  } else
    for (let r = 0; r < e; r += 1)
      t[r] = null;
  return t;
}
const YT = Ht({
  hour: "numeric",
  minute: "2-digit",
  omitZeroMinute: !0,
  meridiem: "narrow"
});
function qT(n) {
  let { display: e } = n.eventRange.ui;
  return e === "list-item" || e === "auto" && !n.eventRange.def.allDay && n.firstCol === n.lastCol && // can't be multi-day
  n.isStart && // "
  n.isEnd;
}
class KT extends pt {
  render() {
    let { props: e } = this;
    return I(Py, Object.assign({}, e, { elClasses: ["fc-daygrid-event", "fc-daygrid-block-event", "fc-h-event"], defaultTimeFormat: YT, defaultDisplayEventEnd: e.defaultDisplayEventEnd, disableResizing: !e.seg.eventRange.def.allDay }));
  }
}
class JT extends pt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, { seg: i } = e, s = r.eventTimeFormat || YT, o = gT(i, s, t, !0, e.defaultDisplayEventEnd);
    return I(Ny, Object.assign({}, e, { elTag: "a", elClasses: ["fc-daygrid-event", "fc-daygrid-dot-event"], elAttrs: vT(e.seg, t), defaultGenerator: eH, timeText: o, isResizing: !1, isDateSelecting: !1 }));
  }
}
function eH(n) {
  return I(
    Ct,
    null,
    I("div", { className: "fc-daygrid-event-dot", style: { borderColor: n.borderColor || n.backgroundColor } }),
    n.timeText && I("div", { className: "fc-event-time" }, n.timeText),
    I("div", { className: "fc-event-title" }, n.event.title || I(Ct, null, " "))
  );
}
class tH extends pt {
  constructor() {
    super(...arguments), this.compileSegs = Ne(nH);
  }
  render() {
    let { props: e } = this, { allSegs: t, invisibleSegs: r } = this.compileSegs(e.singlePlacements);
    return I(LT, { elClasses: ["fc-daygrid-more-link"], dateProfile: e.dateProfile, todayRange: e.todayRange, allDayDate: e.allDayDate, moreCnt: e.moreCnt, allSegs: t, hiddenSegs: r, alignmentElRef: e.alignmentElRef, alignGridTop: e.alignGridTop, extraDateSpan: e.extraDateSpan, popoverContent: () => {
      let i = (e.eventDrag ? e.eventDrag.affectedInstances : null) || (e.eventResize ? e.eventResize.affectedInstances : null) || {};
      return I(Ct, null, t.map((s) => {
        let o = s.eventRange.instance.instanceId;
        return I("div", { className: "fc-daygrid-event-harness", key: o, style: {
          visibility: i[o] ? "hidden" : ""
        } }, qT(s) ? I(JT, Object.assign({ seg: s, isDragging: !1, isSelected: o === e.eventSelection, defaultDisplayEventEnd: !1 }, $s(s, e.todayRange))) : I(KT, Object.assign({ seg: s, isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: o === e.eventSelection, defaultDisplayEventEnd: !1 }, $s(s, e.todayRange))));
      }));
    } });
  }
}
function nH(n) {
  let e = [], t = [];
  for (let r of n)
    e.push(r.seg), r.isVisible || t.push(r.seg);
  return { allSegs: e, invisibleSegs: t };
}
const rH = Ht({ week: "narrow" });
class iH extends Li {
  constructor() {
    super(...arguments), this.rootElRef = Xn(), this.state = {
      dayNumberId: $f()
    }, this.handleRootEl = (e) => {
      _i(this.rootElRef, e), _i(this.props.elRef, e);
    };
  }
  render() {
    let { context: e, props: t, state: r, rootElRef: i } = this, { options: s, dateEnv: o } = e, { date: a, dateProfile: c } = t;
    const u = t.showDayNumber && oH(a, c.currentRange, o);
    return I(By, { elTag: "td", elRef: this.handleRootEl, elClasses: [
      "fc-daygrid-day",
      ...t.extraClassNames || []
    ], elAttrs: Object.assign(Object.assign(Object.assign({}, t.extraDataAttrs), t.showDayNumber ? { "aria-labelledby": r.dayNumberId } : {}), { role: "gridcell" }), defaultGenerator: sH, date: a, dateProfile: c, todayRange: t.todayRange, showDayNumber: t.showDayNumber, isMonthStart: u, extraRenderProps: t.extraRenderProps }, (f, h) => I(
      "div",
      { ref: t.innerElRef, className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner", style: { minHeight: t.minHeight } },
      t.showWeekNumber && I(PT, { elTag: "a", elClasses: ["fc-daygrid-week-number"], elAttrs: zd(e, a, "week"), date: a, defaultFormat: rH }),
      !h.isDisabled && (t.showDayNumber || jy(s) || t.forceDayTop) ? I(
        "div",
        { className: "fc-daygrid-day-top" },
        I(f, { elTag: "a", elClasses: [
          "fc-daygrid-day-number",
          u && "fc-daygrid-month-start"
        ], elAttrs: Object.assign(Object.assign({}, zd(e, a)), { id: r.dayNumberId }) })
      ) : t.showDayNumber ? (
        // for creating correct amount of space (see issue #7162)
        I(
          "div",
          { className: "fc-daygrid-day-top", style: { visibility: "hidden" } },
          I("a", { className: "fc-daygrid-day-number" }, " ")
        )
      ) : void 0,
      I(
        "div",
        { className: "fc-daygrid-day-events", ref: t.fgContentElRef },
        t.fgContent,
        I(
          "div",
          { className: "fc-daygrid-day-bottom", style: { marginTop: t.moreMarginTop } },
          I(tH, { allDayDate: a, singlePlacements: t.singlePlacements, moreCnt: t.moreCnt, alignmentElRef: i, alignGridTop: !t.showDayNumber, extraDateSpan: t.extraDateSpan, dateProfile: t.dateProfile, eventSelection: t.eventSelection, eventDrag: t.eventDrag, eventResize: t.eventResize, todayRange: t.todayRange })
        )
      ),
      I("div", { className: "fc-daygrid-day-bg" }, t.bgContent)
    ));
  }
}
function sH(n) {
  return n.dayNumberText || I(Ct, null, " ");
}
function oH(n, e, t) {
  const { start: r, end: i } = e, s = Zs(i, -1), o = t.getYear(r), a = t.getMonth(r), c = t.getYear(s), u = t.getMonth(s);
  return !(o === c && a === u) && // first date in current view?
  (n.valueOf() === r.valueOf() || // a month-start that's within the current range?
  t.getDay(n) === 1 && n.valueOf() < i.valueOf());
}
function QT(n) {
  return n.eventRange.instance.instanceId + ":" + n.firstCol;
}
function ZT(n) {
  return QT(n) + ":" + n.lastCol;
}
function aH(n, e, t, r, i, s, o) {
  let a = new uH((w) => {
    let C = n[w.index].eventRange.instance.instanceId + ":" + w.span.start + ":" + (w.span.end - 1);
    return i[C] || 1;
  });
  a.allowReslicing = !0, a.strictOrder = r, e === !0 || t === !0 ? (a.maxCoord = s, a.hiddenConsumes = !0) : typeof e == "number" ? a.maxStackCnt = e : typeof t == "number" && (a.maxStackCnt = t, a.hiddenConsumes = !0);
  let c = [], u = [];
  for (let w = 0; w < n.length; w += 1) {
    let C = n[w], T = ZT(C);
    i[T] != null ? c.push({
      index: w,
      span: {
        start: C.firstCol,
        end: C.lastCol + 1
      }
    }) : u.push(C);
  }
  let f = a.addSegs(c), h = a.toRects(), { singleColPlacements: p, multiColPlacements: g, leftoverMargins: y } = lH(h, n, o), x = [], S = [];
  for (let w of u) {
    g[w.firstCol].push({
      seg: w,
      isVisible: !1,
      isAbsolute: !0,
      absoluteTop: 0,
      marginTop: 0
    });
    for (let C = w.firstCol; C <= w.lastCol; C += 1)
      p[C].push({
        seg: Wa(w, C, C + 1, o),
        isVisible: !1,
        isAbsolute: !1,
        absoluteTop: 0,
        marginTop: 0
      });
  }
  for (let w = 0; w < o.length; w += 1)
    x.push(0);
  for (let w of f) {
    let C = n[w.index], T = w.span;
    g[T.start].push({
      seg: Wa(C, T.start, T.end, o),
      isVisible: !1,
      isAbsolute: !0,
      absoluteTop: 0,
      marginTop: 0
    });
    for (let k = T.start; k < T.end; k += 1)
      x[k] += 1, p[k].push({
        seg: Wa(C, k, k + 1, o),
        isVisible: !1,
        isAbsolute: !1,
        absoluteTop: 0,
        marginTop: 0
      });
  }
  for (let w = 0; w < o.length; w += 1)
    S.push(y[w]);
  return { singleColPlacements: p, multiColPlacements: g, moreCnts: x, moreMarginTops: S };
}
function lH(n, e, t) {
  let r = cH(n, t.length), i = [], s = [], o = [];
  for (let a = 0; a < t.length; a += 1) {
    let c = r[a], u = [], f = 0, h = 0;
    for (let g of c) {
      let y = e[g.index];
      u.push({
        seg: Wa(y, a, a + 1, t),
        isVisible: !0,
        isAbsolute: !1,
        absoluteTop: g.levelCoord,
        marginTop: g.levelCoord - f
      }), f = g.levelCoord + g.thickness;
    }
    let p = [];
    f = 0, h = 0;
    for (let g of c) {
      let y = e[g.index], x = g.span.end - g.span.start > 1, S = g.span.start === a;
      h += g.levelCoord - f, f = g.levelCoord + g.thickness, x ? (h += g.thickness, S && p.push({
        seg: Wa(y, g.span.start, g.span.end, t),
        isVisible: !0,
        isAbsolute: !0,
        absoluteTop: g.levelCoord,
        marginTop: 0
      })) : S && (p.push({
        seg: Wa(y, g.span.start, g.span.end, t),
        isVisible: !0,
        isAbsolute: !1,
        absoluteTop: g.levelCoord,
        marginTop: h
        // claim the margin
      }), h = 0);
    }
    i.push(u), s.push(p), o.push(h);
  }
  return { singleColPlacements: i, multiColPlacements: s, leftoverMargins: o };
}
function cH(n, e) {
  let t = [];
  for (let r = 0; r < e; r += 1)
    t.push([]);
  for (let r of n)
    for (let i = r.span.start; i < r.span.end; i += 1)
      t[i].push(r);
  return t;
}
function Wa(n, e, t, r) {
  if (n.firstCol === e && n.lastCol === t - 1)
    return n;
  let i = n.eventRange, s = i.range, o = Uo(s, {
    start: r[e].date,
    end: vn(r[t - 1].date, 1)
  });
  return Object.assign(Object.assign({}, n), { firstCol: e, lastCol: t - 1, eventRange: {
    def: i.def,
    ui: Object.assign(Object.assign({}, i.ui), { durationEditable: !1 }),
    instance: i.instance,
    range: o
  }, isStart: n.isStart && o.start.valueOf() === s.start.valueOf(), isEnd: n.isEnd && o.end.valueOf() === s.end.valueOf() });
}
class uH extends AT {
  constructor() {
    super(...arguments), this.hiddenConsumes = !1, this.forceHidden = {};
  }
  addSegs(e) {
    const t = super.addSegs(e), { entriesByLevel: r } = this, i = (s) => !this.forceHidden[Lo(s)];
    for (let s = 0; s < r.length; s += 1)
      r[s] = r[s].filter(i);
    return t;
  }
  handleInvalidInsertion(e, t, r) {
    const { entriesByLevel: i, forceHidden: s } = this, { touchingEntry: o, touchingLevel: a, touchingLateral: c } = e;
    if (this.hiddenConsumes && o) {
      const u = Lo(o);
      if (!s[u])
        if (this.allowReslicing) {
          const f = Object.assign(Object.assign({}, o), { span: Oy(o.span, t.span) }), h = Lo(f);
          s[h] = !0, i[a][c] = f, r.push(f), this.splitEntry(o, t, r);
        } else
          s[u] = !0, r.push(o);
    }
    super.handleInvalidInsertion(e, t, r);
  }
}
class XT extends Li {
  constructor() {
    super(...arguments), this.cellElRefs = new es(), this.frameElRefs = new es(), this.fgElRefs = new es(), this.segHarnessRefs = new es(), this.rootElRef = Xn(), this.state = {
      framePositions: null,
      maxContentHeight: null,
      segHeights: {}
    }, this.handleResize = (e) => {
      e && this.updateSizing(!0);
    };
  }
  render() {
    let { props: e, state: t, context: r } = this, { options: i } = r, s = e.cells.length, o = Wu(e.businessHourSegs, s), a = Wu(e.bgEventSegs, s), c = Wu(this.getHighlightSegs(), s), u = Wu(this.getMirrorSegs(), s), { singleColPlacements: f, multiColPlacements: h, moreCnts: p, moreMarginTops: g } = aH(mT(e.fgEventSegs, i.eventOrder), e.dayMaxEvents, e.dayMaxEventRows, i.eventOrderStrict, t.segHeights, t.maxContentHeight, e.cells), y = (
      // TODO: messy way to compute this
      e.eventDrag && e.eventDrag.affectedInstances || e.eventResize && e.eventResize.affectedInstances || {}
    );
    return I(
      "tr",
      { ref: this.rootElRef, role: "row" },
      e.renderIntro && e.renderIntro(),
      e.cells.map((x, S) => {
        let w = this.renderFgSegs(S, e.forPrint ? f[S] : h[S], e.todayRange, y), C = this.renderFgSegs(S, dH(u[S], h), e.todayRange, {}, !!e.eventDrag, !!e.eventResize, !1);
        return I(iH, { key: x.key, elRef: this.cellElRefs.createRef(x.key), innerElRef: this.frameElRefs.createRef(x.key), dateProfile: e.dateProfile, date: x.date, showDayNumber: e.showDayNumbers, showWeekNumber: e.showWeekNumbers && S === 0, forceDayTop: e.showWeekNumbers, todayRange: e.todayRange, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, extraRenderProps: x.extraRenderProps, extraDataAttrs: x.extraDataAttrs, extraClassNames: x.extraClassNames, extraDateSpan: x.extraDateSpan, moreCnt: p[S], moreMarginTop: g[S], singlePlacements: f[S], fgContentElRef: this.fgElRefs.createRef(x.key), fgContent: (
          // Fragment scopes the keys
          I(
            Ct,
            null,
            I(Ct, null, w),
            I(Ct, null, C)
          )
        ), bgContent: (
          // Fragment scopes the keys
          I(
            Ct,
            null,
            this.renderFillSegs(c[S], "highlight"),
            this.renderFillSegs(o[S], "non-business"),
            this.renderFillSegs(a[S], "bg-event")
          )
        ), minHeight: e.cellMinHeight });
      })
    );
  }
  componentDidMount() {
    this.updateSizing(!0), this.context.addResizeHandler(this.handleResize);
  }
  componentDidUpdate(e, t) {
    let r = this.props;
    this.updateSizing(!pi(e, r));
  }
  componentWillUnmount() {
    this.context.removeResizeHandler(this.handleResize);
  }
  getHighlightSegs() {
    let { props: e } = this;
    return e.eventDrag && e.eventDrag.segs.length ? e.eventDrag.segs : e.eventResize && e.eventResize.segs.length ? e.eventResize.segs : e.dateSelectionSegs;
  }
  getMirrorSegs() {
    let { props: e } = this;
    return e.eventResize && e.eventResize.segs.length ? e.eventResize.segs : [];
  }
  renderFgSegs(e, t, r, i, s, o, a) {
    let { context: c } = this, { eventSelection: u } = this.props, { framePositions: f } = this.state, h = this.props.cells.length === 1, p = s || o || a, g = [];
    if (f)
      for (let y of t) {
        let { seg: x } = y, { instanceId: S } = x.eventRange.instance, w = y.isVisible && !i[S], C = y.isAbsolute, T = "", k = "";
        C && (c.isRtl ? (k = 0, T = f.lefts[x.lastCol] - f.lefts[x.firstCol]) : (T = 0, k = f.rights[x.firstCol] - f.rights[x.lastCol])), g.push(I("div", { className: "fc-daygrid-event-harness" + (C ? " fc-daygrid-event-harness-abs" : ""), key: QT(x), ref: p ? null : this.segHarnessRefs.createRef(ZT(x)), style: {
          visibility: w ? "" : "hidden",
          marginTop: C ? "" : y.marginTop,
          top: C ? y.absoluteTop : "",
          left: T,
          right: k
        } }, qT(x) ? I(JT, Object.assign({ seg: x, isDragging: s, isSelected: S === u, defaultDisplayEventEnd: h }, $s(x, r))) : I(KT, Object.assign({ seg: x, isDragging: s, isResizing: o, isDateSelecting: a, isSelected: S === u, defaultDisplayEventEnd: h }, $s(x, r)))));
      }
    return g;
  }
  renderFillSegs(e, t) {
    let { isRtl: r } = this.context, { todayRange: i } = this.props, { framePositions: s } = this.state, o = [];
    if (s)
      for (let a of e) {
        let c = r ? {
          right: 0,
          left: s.lefts[a.lastCol] - s.lefts[a.firstCol]
        } : {
          left: 0,
          right: s.rights[a.firstCol] - s.rights[a.lastCol]
        };
        o.push(I("div", { key: yT(a.eventRange), className: "fc-daygrid-bg-harness", style: c }, t === "bg-event" ? I(IT, Object.assign({ seg: a }, $s(a, i))) : NT(t)));
      }
    return I(Ct, {}, ...o);
  }
  updateSizing(e) {
    let { props: t, state: r, frameElRefs: i } = this;
    if (!t.forPrint && t.clientWidth !== null) {
      if (e) {
        let c = t.cells.map((u) => i.currentMap[u.key]);
        if (c.length) {
          let u = this.rootElRef.current, f = new Ja(
            u,
            c,
            !0,
            // isHorizontal
            !1
          );
          (!r.framePositions || !r.framePositions.similarTo(f)) && this.setState({
            framePositions: new Ja(
              u,
              c,
              !0,
              // isHorizontal
              !1
            )
          });
        }
      }
      const s = this.state.segHeights, o = this.querySegHeights(), a = t.dayMaxEvents === !0 || t.dayMaxEventRows === !0;
      this.safeSetState({
        // HACK to prevent oscillations of events being shown/hidden from max-event-rows
        // Essentially, once you compute an element's height, never null-out.
        // TODO: always display all events, as visibility:hidden?
        segHeights: Object.assign(Object.assign({}, s), o),
        maxContentHeight: a ? this.computeMaxContentHeight() : null
      });
    }
  }
  querySegHeights() {
    let e = this.segHarnessRefs.currentMap, t = {};
    for (let r in e) {
      let i = Math.round(e[r].getBoundingClientRect().height);
      t[r] = Math.max(t[r] || 0, i);
    }
    return t;
  }
  computeMaxContentHeight() {
    let e = this.props.cells[0].key, t = this.cellElRefs.currentMap[e], r = this.fgElRefs.currentMap[e];
    return t.getBoundingClientRect().bottom - r.getBoundingClientRect().top;
  }
  getCellEls() {
    let e = this.cellElRefs.currentMap;
    return this.props.cells.map((t) => e[t.key]);
  }
}
XT.addStateEquality({
  segHeights: pi
});
function dH(n, e) {
  if (!n.length)
    return [];
  let t = fH(e);
  return n.map((r) => ({
    seg: r,
    isVisible: !0,
    isAbsolute: !0,
    absoluteTop: t[r.eventRange.instance.instanceId],
    marginTop: 0
  }));
}
function fH(n) {
  let e = {};
  for (let t of n)
    for (let r of t)
      e[r.seg.eventRange.instance.instanceId] = r.absoluteTop;
  return e;
}
class hH extends Li {
  constructor() {
    super(...arguments), this.splitBusinessHourSegs = Ne(yd), this.splitBgEventSegs = Ne(pH), this.splitFgEventSegs = Ne(yd), this.splitDateSelectionSegs = Ne(yd), this.splitEventDrag = Ne(CS), this.splitEventResize = Ne(CS), this.rowRefs = new es();
  }
  render() {
    let { props: e, context: t } = this, r = e.cells.length, i = this.splitBusinessHourSegs(e.businessHourSegs, r), s = this.splitBgEventSegs(e.bgEventSegs, r), o = this.splitFgEventSegs(e.fgEventSegs, r), a = this.splitDateSelectionSegs(e.dateSelectionSegs, r), c = this.splitEventDrag(e.eventDrag, r), u = this.splitEventResize(e.eventResize, r), f = r >= 7 && e.clientWidth ? e.clientWidth / t.options.aspectRatio / 6 : null;
    return I(rl, { unit: "day" }, (h, p) => I(Ct, null, e.cells.map((g, y) => I(XT, {
      ref: this.rowRefs.createRef(y),
      key: g.length ? g[0].date.toISOString() : y,
      showDayNumbers: r > 1,
      showWeekNumbers: e.showWeekNumbers,
      todayRange: p,
      dateProfile: e.dateProfile,
      cells: g,
      renderIntro: e.renderRowIntro,
      businessHourSegs: i[y],
      eventSelection: e.eventSelection,
      bgEventSegs: s[y],
      fgEventSegs: o[y],
      dateSelectionSegs: a[y],
      eventDrag: c[y],
      eventResize: u[y],
      dayMaxEvents: e.dayMaxEvents,
      dayMaxEventRows: e.dayMaxEventRows,
      clientWidth: e.clientWidth,
      clientHeight: e.clientHeight,
      cellMinHeight: f,
      forPrint: e.forPrint
    }))));
  }
  componentDidMount() {
    this.registerInteractiveComponent();
  }
  componentDidUpdate() {
    this.registerInteractiveComponent();
  }
  registerInteractiveComponent() {
    if (!this.rootEl) {
      const e = this.rowRefs.currentMap[0].getCellEls()[0], t = e ? e.closest(".fc-daygrid-body") : null;
      t && (this.rootEl = t, this.context.registerInteractiveComponent(this, {
        el: t,
        isHitComboAllowed: this.props.isHitComboAllowed
      }));
    }
  }
  componentWillUnmount() {
    this.rootEl && (this.context.unregisterInteractiveComponent(this), this.rootEl = null);
  }
  // Hit System
  // ----------------------------------------------------------------------------------------------------
  prepareHits() {
    this.rowPositions = new Ja(
      this.rootEl,
      this.rowRefs.collect().map((e) => e.getCellEls()[0]),
      // first cell el in each row. TODO: not optimal
      !1,
      !0
    ), this.colPositions = new Ja(
      this.rootEl,
      this.rowRefs.currentMap[0].getCellEls(),
      // cell els in first row
      !0,
      // horizontal
      !1
    );
  }
  queryHit(e, t) {
    let { colPositions: r, rowPositions: i } = this, s = r.leftToIndex(e), o = i.topToIndex(t);
    if (o != null && s != null) {
      let a = this.props.cells[o][s];
      return {
        dateProfile: this.props.dateProfile,
        dateSpan: Object.assign({ range: this.getCellRange(o, s), allDay: !0 }, a.extraDateSpan),
        dayEl: this.getCellEl(o, s),
        rect: {
          left: r.lefts[s],
          right: r.rights[s],
          top: i.tops[o],
          bottom: i.bottoms[o]
        },
        layer: 0
      };
    }
    return null;
  }
  getCellEl(e, t) {
    return this.rowRefs.currentMap[e].getCellEls()[t];
  }
  getCellRange(e, t) {
    let r = this.props.cells[e][t].date, i = vn(r, 1);
    return { start: r, end: i };
  }
}
function pH(n, e) {
  return yd(n.filter(mH), e);
}
function mH(n) {
  return n.eventRange.def.allDay;
}
class gH extends Li {
  constructor() {
    super(...arguments), this.elRef = Xn(), this.needsScrollReset = !1;
  }
  render() {
    let { props: e } = this, { dayMaxEventRows: t, dayMaxEvents: r, expandRows: i } = e, s = r === !0 || t === !0;
    s && !i && (s = !1, t = null, r = null);
    let o = [
      "fc-daygrid-body",
      s ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
      i ? "" : "fc-daygrid-body-natural"
      // will height of one row depend on the others?
    ];
    return I(
      "div",
      { ref: this.elRef, className: o.join(" "), style: {
        // these props are important to give this wrapper correct dimensions for interactions
        // TODO: if we set it here, can we avoid giving to inner tables?
        width: e.clientWidth,
        minWidth: e.tableMinWidth
      } },
      I(
        "table",
        { role: "presentation", className: "fc-scrollgrid-sync-table", style: {
          width: e.clientWidth,
          minWidth: e.tableMinWidth,
          height: i ? e.clientHeight : ""
        } },
        e.colGroupNode,
        I(
          "tbody",
          { role: "presentation" },
          I(hH, { dateProfile: e.dateProfile, cells: e.cells, renderRowIntro: e.renderRowIntro, showWeekNumbers: e.showWeekNumbers, clientWidth: e.clientWidth, clientHeight: e.clientHeight, businessHourSegs: e.businessHourSegs, bgEventSegs: e.bgEventSegs, fgEventSegs: e.fgEventSegs, dateSelectionSegs: e.dateSelectionSegs, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, dayMaxEvents: r, dayMaxEventRows: t, forPrint: e.forPrint, isHitComboAllowed: e.isHitComboAllowed })
        )
      )
    );
  }
  componentDidMount() {
    this.requestScrollReset();
  }
  componentDidUpdate(e) {
    e.dateProfile !== this.props.dateProfile ? this.requestScrollReset() : this.flushScrollReset();
  }
  requestScrollReset() {
    this.needsScrollReset = !0, this.flushScrollReset();
  }
  flushScrollReset() {
    if (this.needsScrollReset && this.props.clientWidth) {
      const e = yH(this.elRef.current, this.props.dateProfile);
      if (e) {
        const t = e.closest(".fc-daygrid-body"), r = t.closest(".fc-scroller"), i = e.getBoundingClientRect().top - t.getBoundingClientRect().top;
        r.scrollTop = i ? i + 1 : 0;
      }
      this.needsScrollReset = !1;
    }
  }
}
function yH(n, e) {
  let t;
  return e.currentRangeUnit.match(/year|month/) && (t = n.querySelector(`[data-date="${mj(e.currentDate)}-01"]`)), t || (t = n.querySelector(`[data-date="${xy(e.currentDate)}"]`)), t;
}
class vH extends MT {
  constructor() {
    super(...arguments), this.forceDayIfListItem = !0;
  }
  sliceRange(e, t) {
    return t.sliceRange(e);
  }
}
class eC extends Li {
  constructor() {
    super(...arguments), this.slicer = new vH(), this.tableRef = Xn();
  }
  render() {
    let { props: e, context: t } = this;
    return I(gH, Object.assign({ ref: this.tableRef }, this.slicer.sliceProps(e, e.dateProfile, e.nextDayThreshold, t, e.dayTableModel), { dateProfile: e.dateProfile, cells: e.dayTableModel.cells, colGroupNode: e.colGroupNode, tableMinWidth: e.tableMinWidth, renderRowIntro: e.renderRowIntro, dayMaxEvents: e.dayMaxEvents, dayMaxEventRows: e.dayMaxEventRows, showWeekNumbers: e.showWeekNumbers, expandRows: e.expandRows, headerAlignElRef: e.headerAlignElRef, clientWidth: e.clientWidth, clientHeight: e.clientHeight, forPrint: e.forPrint }));
  }
}
class bH extends XV {
  constructor() {
    super(...arguments), this.buildDayTableModel = Ne(xH), this.headerRef = Xn(), this.tableRef = Xn();
  }
  render() {
    let { options: e, dateProfileGenerator: t } = this.context, { props: r } = this, i = this.buildDayTableModel(r.dateProfile, t), s = e.dayHeaders && I(DT, { ref: this.headerRef, dateProfile: r.dateProfile, dates: i.headerDates, datesRepDistinctDays: i.rowCnt === 1 }), o = (a) => I(eC, { ref: this.tableRef, dateProfile: r.dateProfile, dayTableModel: i, businessHours: r.businessHours, dateSelection: r.dateSelection, eventStore: r.eventStore, eventUiBases: r.eventUiBases, eventSelection: r.eventSelection, eventDrag: r.eventDrag, eventResize: r.eventResize, nextDayThreshold: e.nextDayThreshold, colGroupNode: a.tableColGroupNode, tableMinWidth: a.tableMinWidth, dayMaxEvents: e.dayMaxEvents, dayMaxEventRows: e.dayMaxEventRows, showWeekNumbers: e.weekNumbers, expandRows: !r.isHeightAuto, headerAlignElRef: this.headerElRef, clientWidth: a.clientWidth, clientHeight: a.clientHeight, forPrint: r.forPrint });
    return e.dayMinWidth ? this.renderHScrollLayout(s, o, i.colCnt, e.dayMinWidth) : this.renderSimpleLayout(s, o);
  }
}
function xH(n, e) {
  let t = new RT(n.renderRange, e);
  return new kT(t, /year|month|week/.test(n.currentRangeUnit));
}
class SH extends rT {
  // Computes the date range that will be rendered
  buildRenderRange(e, t, r) {
    let i = super.buildRenderRange(e, t, r), { props: s } = this;
    return wH({
      currentRange: i,
      snapToWeek: /^(year|month)$/.test(t),
      fixedWeekCount: s.fixedWeekCount,
      dateEnv: s.dateEnv
    });
  }
}
function wH(n) {
  let { dateEnv: e, currentRange: t } = n, { start: r, end: i } = t, s;
  if (n.snapToWeek && (r = e.startOfWeek(r), s = e.startOfWeek(i), s.valueOf() !== i.valueOf() && (i = eS(s, 1))), n.fixedWeekCount) {
    let o = e.startOfWeek(e.startOfMonth(vn(t.end, -1))), a = Math.ceil(
      // could be partial weeks due to hiddenDays
      ij(o, i)
    );
    i = eS(i, 6 - a);
  }
  return { start: r, end: i };
}
var EH = ':root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:"";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:"";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}';
yy(EH);
var AH = to({
  name: "@fullcalendar/daygrid",
  initialView: "dayGridMonth",
  views: {
    dayGrid: {
      component: bH,
      dateProfileGeneratorClass: SH
    },
    dayGridDay: {
      type: "dayGrid",
      duration: { days: 1 }
    },
    dayGridWeek: {
      type: "dayGrid",
      duration: { weeks: 1 }
    },
    dayGridMonth: {
      type: "dayGrid",
      duration: { months: 1 },
      fixedWeekCount: !0
    },
    dayGridYear: {
      type: "dayGrid",
      duration: { years: 1 }
    }
  }
});
const TH = parseInt(String(Fe.version).split(".")[0]), CH = TH < 18;
class tC extends hy {
  constructor() {
    super(...arguments), this.elRef = H2(), this.isUpdating = !1, this.isUnmounting = !1, this.state = {
      customRenderingMap: /* @__PURE__ */ new Map()
    }, this.requestResize = () => {
      this.isUnmounting || (this.cancelResize(), this.resizeId = requestAnimationFrame(() => {
        this.doResize();
      }));
    };
  }
  render() {
    const e = [];
    for (const t of this.state.customRenderingMap.values())
      e.push(Fe.createElement(DH, { key: t.id, customRendering: t }));
    return Fe.createElement("div", { ref: this.elRef }, e);
  }
  componentDidMount() {
    this.isUnmounting = !1;
    const e = new Lz();
    this.handleCustomRendering = e.handle.bind(e), this.calendar = new ZV(this.elRef.current, Object.assign(Object.assign({}, this.props), { handleCustomRendering: this.handleCustomRendering })), this.calendar.render(), this.calendar.on("_beforeprint", () => {
      Dx(() => {
      });
    });
    let t;
    e.subscribe((r) => {
      const i = Date.now(), s = !t;
      // don't call flushSync if React version already does sync rendering by default
      // guards against fatal errors:
      // https://github.com/fullcalendar/fullcalendar/issues/7448
      (CH || //
      s || this.isUpdating || this.isUnmounting || i - t < 100 ? nC : Dx)(() => {
        this.setState({ customRenderingMap: r }, () => {
          t = i, s ? this.doResize() : this.requestResize();
        });
      });
    });
  }
  componentDidUpdate() {
    this.isUpdating = !0, this.calendar.resetOptions(Object.assign(Object.assign({}, this.props), { handleCustomRendering: this.handleCustomRendering })), this.isUpdating = !1;
  }
  componentWillUnmount() {
    this.isUnmounting = !0, this.cancelResize(), this.calendar.destroy();
  }
  doResize() {
    this.calendar.updateSize();
  }
  cancelResize() {
    this.resizeId !== void 0 && (cancelAnimationFrame(this.resizeId), this.resizeId = void 0);
  }
  getApi() {
    return this.calendar;
  }
}
tC.act = nC;
class DH extends W2 {
  render() {
    const { customRendering: e } = this.props, { generatorMeta: t } = e, r = typeof t == "function" ? t(e.renderProps) : t;
    return b1(r, e.containerEl);
  }
}
function nC(n) {
  n();
}
class RH extends QF {
  getKeyInfo() {
    return {
      allDay: {},
      timed: {}
    };
  }
  getKeysForDateSpan(e) {
    return e.allDay ? ["allDay"] : ["timed"];
  }
  getKeysForEventDef(e) {
    return e.allDay ? OF(e) ? ["timed", "allDay"] : ["allDay"] : ["timed"];
  }
}
const kH = Ht({
  hour: "numeric",
  minute: "2-digit",
  omitZeroMinute: !0,
  meridiem: "short"
});
function rC(n) {
  let e = [
    "fc-timegrid-slot",
    "fc-timegrid-slot-label",
    n.isLabeled ? "fc-scrollgrid-shrink" : "fc-timegrid-slot-minor"
  ];
  return I(ms.Consumer, null, (t) => {
    if (!n.isLabeled)
      return I("td", { className: e.join(" "), "data-time": n.isoTimeStr });
    let { dateEnv: r, options: i, viewApi: s } = t, o = (
      // TODO: fully pre-parse
      i.slotLabelFormat == null ? kH : Array.isArray(i.slotLabelFormat) ? Ht(i.slotLabelFormat[0]) : Ht(i.slotLabelFormat)
    ), a = {
      level: 0,
      time: n.time,
      date: r.toDate(n.date),
      view: s,
      text: r.format(n.date, o)
    };
    return I(Mr, { elTag: "td", elClasses: e, elAttrs: {
      "data-time": n.isoTimeStr
    }, renderProps: a, generatorName: "slotLabelContent", customGenerator: i.slotLabelContent, defaultGenerator: MH, classNameGenerator: i.slotLabelClassNames, didMount: i.slotLabelDidMount, willUnmount: i.slotLabelWillUnmount }, (c) => I(
      "div",
      { className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame" },
      I(c, { elTag: "div", elClasses: [
        "fc-timegrid-slot-label-cushion",
        "fc-scrollgrid-shrink-cushion"
      ] })
    ));
  });
}
function MH(n) {
  return n.text;
}
class _H extends pt {
  render() {
    return this.props.slatMetas.map((e) => I(
      "tr",
      { key: e.key },
      I(rC, Object.assign({}, e))
    ));
  }
}
const OH = Ht({ week: "short" }), IH = 5;
class NH extends Li {
  constructor() {
    super(...arguments), this.allDaySplitter = new RH(), this.headerElRef = Xn(), this.rootElRef = Xn(), this.scrollerElRef = Xn(), this.state = {
      slatCoords: null
    }, this.handleScrollTopRequest = (e) => {
      let t = this.scrollerElRef.current;
      t && (t.scrollTop = e);
    }, this.renderHeadAxis = (e, t = "") => {
      let { options: r } = this.context, { dateProfile: i } = this.props, s = i.renderRange, a = Zo(s.start, s.end) === 1 ? zd(this.context, s.start, "week") : {};
      return r.weekNumbers && e === "day" ? I(PT, { elTag: "th", elClasses: [
        "fc-timegrid-axis",
        "fc-scrollgrid-shrink"
      ], elAttrs: {
        "aria-hidden": !0
      }, date: s.start, defaultFormat: OH }, (c) => I(
        "div",
        { className: [
          "fc-timegrid-axis-frame",
          "fc-scrollgrid-shrink-frame",
          "fc-timegrid-axis-frame-liquid"
        ].join(" "), style: { height: t } },
        I(c, { elTag: "a", elClasses: [
          "fc-timegrid-axis-cushion",
          "fc-scrollgrid-shrink-cushion",
          "fc-scrollgrid-sync-inner"
        ], elAttrs: a })
      )) : I(
        "th",
        { "aria-hidden": !0, className: "fc-timegrid-axis" },
        I("div", { className: "fc-timegrid-axis-frame", style: { height: t } })
      );
    }, this.renderTableRowAxis = (e) => {
      let { options: t, viewApi: r } = this.context, i = {
        text: t.allDayText,
        view: r
      };
      return (
        // TODO: make reusable hook. used in list view too
        I(Mr, { elTag: "td", elClasses: [
          "fc-timegrid-axis",
          "fc-scrollgrid-shrink"
        ], elAttrs: {
          "aria-hidden": !0
        }, renderProps: i, generatorName: "allDayContent", customGenerator: t.allDayContent, defaultGenerator: PH, classNameGenerator: t.allDayClassNames, didMount: t.allDayDidMount, willUnmount: t.allDayWillUnmount }, (s) => I(
          "div",
          { className: [
            "fc-timegrid-axis-frame",
            "fc-scrollgrid-shrink-frame",
            e == null ? " fc-timegrid-axis-frame-liquid" : ""
          ].join(" "), style: { height: e } },
          I(s, { elTag: "span", elClasses: [
            "fc-timegrid-axis-cushion",
            "fc-scrollgrid-shrink-cushion",
            "fc-scrollgrid-sync-inner"
          ] })
        ))
      );
    }, this.handleSlatCoords = (e) => {
      this.setState({ slatCoords: e });
    };
  }
  // rendering
  // ----------------------------------------------------------------------------------------------------
  renderSimpleLayout(e, t, r) {
    let { context: i, props: s } = this, o = [], a = Vd(i.options);
    return e && o.push({
      type: "header",
      key: "header",
      isSticky: a,
      chunk: {
        elRef: this.headerElRef,
        tableClassName: "fc-col-header",
        rowContent: e
      }
    }), t && (o.push({
      type: "body",
      key: "all-day",
      chunk: { content: t }
    }), o.push({
      type: "body",
      key: "all-day-divider",
      outerContent: (
        // TODO: rename to cellContent so don't need to define <tr>?
        I(
          "tr",
          { role: "presentation", className: "fc-scrollgrid-section" },
          I("td", { className: "fc-timegrid-divider " + i.theme.getClass("tableCellShaded") })
        )
      )
    })), o.push({
      type: "body",
      key: "body",
      liquid: !0,
      expandRows: !!i.options.expandRows,
      chunk: {
        scrollerElRef: this.scrollerElRef,
        content: r
      }
    }), I(
      Bd,
      { elRef: this.rootElRef, elClasses: ["fc-timegrid"], viewSpec: i.viewSpec },
      I(Iy, { liquid: !s.isHeightAuto && !s.forPrint, collapsibleWidth: s.forPrint, cols: [{ width: "shrink" }], sections: o })
    );
  }
  renderHScrollLayout(e, t, r, i, s, o, a) {
    let c = this.context.pluginHooks.scrollGridImpl;
    if (!c)
      throw new Error("No ScrollGrid implementation");
    let { context: u, props: f } = this, h = !f.forPrint && Vd(u.options), p = !f.forPrint && OT(u.options), g = [];
    e && g.push({
      type: "header",
      key: "header",
      isSticky: h,
      syncRowHeights: !0,
      chunks: [
        {
          key: "axis",
          rowContent: (x) => I("tr", { role: "presentation" }, this.renderHeadAxis("day", x.rowSyncHeights[0]))
        },
        {
          key: "cols",
          elRef: this.headerElRef,
          tableClassName: "fc-col-header",
          rowContent: e
        }
      ]
    }), t && (g.push({
      type: "body",
      key: "all-day",
      syncRowHeights: !0,
      chunks: [
        {
          key: "axis",
          rowContent: (x) => I("tr", { role: "presentation" }, this.renderTableRowAxis(x.rowSyncHeights[0]))
        },
        {
          key: "cols",
          content: t
        }
      ]
    }), g.push({
      key: "all-day-divider",
      type: "body",
      outerContent: (
        // TODO: rename to cellContent so don't need to define <tr>?
        I(
          "tr",
          { role: "presentation", className: "fc-scrollgrid-section" },
          I("td", { colSpan: 2, className: "fc-timegrid-divider " + u.theme.getClass("tableCellShaded") })
        )
      )
    }));
    let y = u.options.nowIndicator;
    return g.push({
      type: "body",
      key: "body",
      liquid: !0,
      expandRows: !!u.options.expandRows,
      chunks: [
        {
          key: "axis",
          content: (x) => (
            // TODO: make this now-indicator arrow more DRY with TimeColsContent
            I(
              "div",
              { className: "fc-timegrid-axis-chunk" },
              I(
                "table",
                { "aria-hidden": !0, style: { height: x.expandRows ? x.clientHeight : "" } },
                x.tableColGroupNode,
                I(
                  "tbody",
                  null,
                  I(_H, { slatMetas: o })
                )
              ),
              I(
                "div",
                { className: "fc-timegrid-now-indicator-container" },
                I(rl, {
                  unit: y ? "minute" : "day"
                  /* hacky */
                }, (S) => {
                  let w = y && a && a.safeComputeTop(S);
                  return typeof w == "number" ? I(Ly, { elClasses: ["fc-timegrid-now-indicator-arrow"], elStyle: { top: w }, isAxis: !0, date: S }) : null;
                })
              )
            )
          )
        },
        {
          key: "cols",
          scrollerElRef: this.scrollerElRef,
          content: r
        }
      ]
    }), p && g.push({
      key: "footer",
      type: "footer",
      isSticky: !0,
      chunks: [
        {
          key: "axis",
          content: ig
        },
        {
          key: "cols",
          content: ig
        }
      ]
    }), I(
      Bd,
      { elRef: this.rootElRef, elClasses: ["fc-timegrid"], viewSpec: u.viewSpec },
      I(c, { liquid: !f.isHeightAuto && !f.forPrint, forPrint: f.forPrint, collapsibleWidth: !1, colGroups: [
        { width: "shrink", cols: [{ width: "shrink" }] },
        { cols: [{ span: i, minWidth: s }] }
      ], sections: g })
    );
  }
  /* Dimensions
  ------------------------------------------------------------------------------------------------------------------*/
  getAllDayMaxEventProps() {
    let { dayMaxEvents: e, dayMaxEventRows: t } = this.context.options;
    return (e === !0 || t === !0) && (e = void 0, t = IH), { dayMaxEvents: e, dayMaxEventRows: t };
  }
}
function PH(n) {
  return n.text;
}
class LH {
  constructor(e, t, r) {
    this.positions = e, this.dateProfile = t, this.slotDuration = r;
  }
  safeComputeTop(e) {
    let { dateProfile: t } = this;
    if (ns(t.currentRange, e)) {
      let r = Mt(e), i = e.valueOf() - r.valueOf();
      if (i >= di(t.slotMinTime) && i < di(t.slotMaxTime))
        return this.computeTimeTop(ot(i));
    }
    return null;
  }
  // Computes the top coordinate, relative to the bounds of the grid, of the given date.
  // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
  computeDateTop(e, t) {
    return t || (t = Mt(e)), this.computeTimeTop(ot(e.valueOf() - t.valueOf()));
  }
  // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
  // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
  // Eventually allow computation with arbirary slat dates.
  computeTimeTop(e) {
    let { positions: t, dateProfile: r } = this, i = t.els.length, s = (e.milliseconds - di(r.slotMinTime)) / di(this.slotDuration), o, a;
    return s = Math.max(0, s), s = Math.min(i, s), o = Math.floor(s), o = Math.min(o, i - 1), a = s - o, t.tops[o] + t.getHeight(o) * a;
  }
}
class BH extends pt {
  render() {
    let { props: e, context: t } = this, { options: r } = t, { slatElRefs: i } = e;
    return I("tbody", null, e.slatMetas.map((s, o) => {
      let a = {
        time: s.time,
        date: t.dateEnv.toDate(s.date),
        view: t.viewApi
      };
      return I(
        "tr",
        { key: s.key, ref: i.createRef(s.key) },
        e.axis && I(rC, Object.assign({}, s)),
        I(Mr, { elTag: "td", elClasses: [
          "fc-timegrid-slot",
          "fc-timegrid-slot-lane",
          !s.isLabeled && "fc-timegrid-slot-minor"
        ], elAttrs: {
          "data-time": s.isoTimeStr
        }, renderProps: a, generatorName: "slotLaneContent", customGenerator: r.slotLaneContent, classNameGenerator: r.slotLaneClassNames, didMount: r.slotLaneDidMount, willUnmount: r.slotLaneWillUnmount })
      );
    }));
  }
}
class jH extends pt {
  constructor() {
    super(...arguments), this.rootElRef = Xn(), this.slatElRefs = new es();
  }
  render() {
    let { props: e, context: t } = this;
    return I(
      "div",
      { ref: this.rootElRef, className: "fc-timegrid-slots" },
      I(
        "table",
        { "aria-hidden": !0, className: t.theme.getClass("table"), style: {
          minWidth: e.tableMinWidth,
          width: e.clientWidth,
          height: e.minHeight
        } },
        e.tableColGroupNode,
        I(BH, { slatElRefs: this.slatElRefs, axis: e.axis, slatMetas: e.slatMetas })
      )
    );
  }
  componentDidMount() {
    this.updateSizing();
  }
  componentDidUpdate() {
    this.updateSizing();
  }
  componentWillUnmount() {
    this.props.onCoords && this.props.onCoords(null);
  }
  updateSizing() {
    let { context: e, props: t } = this;
    t.onCoords && t.clientWidth !== null && this.rootElRef.current.offsetHeight && t.onCoords(new LH(new Ja(this.rootElRef.current, FH(this.slatElRefs.currentMap, t.slatMetas), !1, !0), this.props.dateProfile, e.options.slotDuration));
  }
}
function FH(n, e) {
  return e.map((t) => n[t.key]);
}
function Ml(n, e) {
  let t = [], r;
  for (r = 0; r < e; r += 1)
    t.push([]);
  if (n)
    for (r = 0; r < n.length; r += 1)
      t[n[r].col].push(n[r]);
  return t;
}
function DS(n, e) {
  let t = [];
  if (n) {
    for (let r = 0; r < e; r += 1)
      t[r] = {
        affectedInstances: n.affectedInstances,
        isEvent: n.isEvent,
        segs: []
      };
    for (let r of n.segs)
      t[r.col].segs.push(r);
  } else
    for (let r = 0; r < e; r += 1)
      t[r] = null;
  return t;
}
class zH extends pt {
  render() {
    let { props: e } = this;
    return I(LT, { elClasses: ["fc-timegrid-more-link"], elStyle: {
      top: e.top,
      bottom: e.bottom
    }, allDayDate: null, moreCnt: e.hiddenSegs.length, allSegs: e.hiddenSegs, hiddenSegs: e.hiddenSegs, extraDateSpan: e.extraDateSpan, dateProfile: e.dateProfile, todayRange: e.todayRange, popoverContent: () => sC(e.hiddenSegs, e), defaultGenerator: VH, forceTimed: !0 }, (t) => I(t, { elTag: "div", elClasses: ["fc-timegrid-more-link-inner", "fc-sticky"] }));
  }
}
function VH(n) {
  return n.shortText;
}
function HH(n, e, t) {
  let r = new AT();
  e != null && (r.strictOrder = e), t != null && (r.maxStackCnt = t);
  let i = r.addSegs(n), s = oz(i), o = WH(r);
  return o = YH(o, 1), { segRects: qH(o), hiddenGroups: s };
}
function WH(n) {
  const { entriesByLevel: e } = n, t = zy((r, i) => r + ":" + i, (r, i) => {
    let s = GH(n, r, i), o = RS(s, t), a = e[r][i];
    return [
      Object.assign(Object.assign({}, a), { nextLevelNodes: o[0] }),
      a.thickness + o[1]
      // the pressure builds
    ];
  });
  return RS(e.length ? { level: 0, lateralStart: 0, lateralEnd: e[0].length } : null, t)[0];
}
function RS(n, e) {
  if (!n)
    return [[], 0];
  let { level: t, lateralStart: r, lateralEnd: i } = n, s = r, o = [];
  for (; s < i; )
    o.push(e(t, s)), s += 1;
  return o.sort(UH), [
    o.map($H),
    o[0][1]
    // first item's pressure
  ];
}
function UH(n, e) {
  return e[1] - n[1];
}
function $H(n) {
  return n[0];
}
function GH(n, e, t) {
  let { levelCoords: r, entriesByLevel: i } = n, s = i[e][t], o = r[e] + s.thickness, a = r.length, c = e;
  for (; c < a && r[c] < o; c += 1)
    ;
  for (; c < a; c += 1) {
    let u = i[c], f, h = rg(u, s.span.start, ng), p = h[0] + h[1], g = p;
    for (
      ;
      // loop through entries that horizontally intersect
      (f = u[g]) && // but not past the whole seg list
      f.span.start < s.span.end;
    )
      g += 1;
    if (p < g)
      return { level: c, lateralStart: p, lateralEnd: g };
  }
  return null;
}
function YH(n, e) {
  const t = zy((r, i, s) => Lo(r), (r, i, s) => {
    let { nextLevelNodes: o, thickness: a } = r, c = a + s, u = a / c, f, h = [];
    if (!o.length)
      f = e;
    else
      for (let g of o)
        if (f === void 0) {
          let y = t(g, i, c);
          f = y[0], h.push(y[1]);
        } else {
          let y = t(g, f, 0);
          h.push(y[1]);
        }
    let p = (f - i) * u;
    return [f - p, Object.assign(Object.assign({}, r), { thickness: p, nextLevelNodes: h })];
  });
  return n.map((r) => t(r, 0, 0)[1]);
}
function qH(n) {
  let e = [];
  const t = zy((i, s, o) => Lo(i), (i, s, o) => {
    let a = Object.assign(Object.assign({}, i), {
      levelCoord: s,
      stackDepth: o,
      stackForward: 0
    });
    return e.push(a), a.stackForward = r(i.nextLevelNodes, s + i.thickness, o + 1) + 1;
  });
  function r(i, s, o) {
    let a = 0;
    for (let c of i)
      a = Math.max(t(c, s, o), a);
    return a;
  }
  return r(n, 0, 0), e;
}
function zy(n, e) {
  const t = {};
  return (...r) => {
    let i = n(...r);
    return i in t ? t[i] : t[i] = e(...r);
  };
}
function kS(n, e, t = null, r = 0) {
  let i = [];
  if (t)
    for (let s = 0; s < n.length; s += 1) {
      let o = n[s], a = t.computeDateTop(o.start, e), c = Math.max(
        a + (r || 0),
        // :(
        t.computeDateTop(o.end, e)
      );
      i.push({
        start: Math.round(a),
        end: Math.round(c)
        //
      });
    }
  return i;
}
function KH(n, e, t, r) {
  let i = [], s = [];
  for (let u = 0; u < n.length; u += 1) {
    let f = e[u];
    f ? i.push({
      index: u,
      thickness: 1,
      span: f
    }) : s.push(n[u]);
  }
  let { segRects: o, hiddenGroups: a } = HH(i, t, r), c = [];
  for (let u of o)
    c.push({
      seg: n[u.index],
      rect: u
    });
  for (let u of s)
    c.push({ seg: u, rect: null });
  return { segPlacements: c, hiddenGroups: a };
}
const JH = Ht({
  hour: "numeric",
  minute: "2-digit",
  meridiem: !1
});
class iC extends pt {
  render() {
    return I(Py, Object.assign({}, this.props, { elClasses: [
      "fc-timegrid-event",
      "fc-v-event",
      this.props.isShort && "fc-timegrid-event-short"
    ], defaultTimeFormat: JH }));
  }
}
class QH extends pt {
  constructor() {
    super(...arguments), this.sortEventSegs = Ne(mT);
  }
  // TODO: memoize event-placement?
  render() {
    let { props: e, context: t } = this, { options: r } = t, i = r.selectMirror, s = (
      // yuck
      e.eventDrag && e.eventDrag.segs || e.eventResize && e.eventResize.segs || i && e.dateSelectionSegs || []
    ), o = (
      // TODO: messy way to compute this
      e.eventDrag && e.eventDrag.affectedInstances || e.eventResize && e.eventResize.affectedInstances || {}
    ), a = this.sortEventSegs(e.fgEventSegs, r.eventOrder);
    return I(By, { elTag: "td", elRef: e.elRef, elClasses: [
      "fc-timegrid-col",
      ...e.extraClassNames || []
    ], elAttrs: Object.assign({ role: "gridcell" }, e.extraDataAttrs), date: e.date, dateProfile: e.dateProfile, todayRange: e.todayRange, extraRenderProps: e.extraRenderProps }, (c) => I(
      "div",
      { className: "fc-timegrid-col-frame" },
      I(
        "div",
        { className: "fc-timegrid-col-bg" },
        this.renderFillSegs(e.businessHourSegs, "non-business"),
        this.renderFillSegs(e.bgEventSegs, "bg-event"),
        this.renderFillSegs(e.dateSelectionSegs, "highlight")
      ),
      I("div", { className: "fc-timegrid-col-events" }, this.renderFgSegs(a, o, !1, !1, !1)),
      I("div", { className: "fc-timegrid-col-events" }, this.renderFgSegs(s, {}, !!e.eventDrag, !!e.eventResize, !!i, "mirror")),
      I("div", { className: "fc-timegrid-now-indicator-container" }, this.renderNowIndicator(e.nowIndicatorSegs)),
      jy(r) && I(c, { elTag: "div", elClasses: ["fc-timegrid-col-misc"] })
    ));
  }
  renderFgSegs(e, t, r, i, s, o) {
    let { props: a } = this;
    return a.forPrint ? sC(e, a) : this.renderPositionedFgSegs(e, t, r, i, s, o);
  }
  renderPositionedFgSegs(e, t, r, i, s, o) {
    let { eventMaxStack: a, eventShortHeight: c, eventOrderStrict: u, eventMinHeight: f } = this.context.options, { date: h, slatCoords: p, eventSelection: g, todayRange: y, nowDate: x } = this.props, S = r || i || s, w = kS(e, h, p, f), { segPlacements: C, hiddenGroups: T } = KH(e, w, u, a);
    return I(
      Ct,
      null,
      this.renderHiddenGroups(T, e),
      C.map((k) => {
        let { seg: R, rect: P } = k, L = R.eventRange.instance.instanceId, B = S || !!(!t[L] && P), W = jp(P && P.span), X = !S && P ? this.computeSegHStyle(P) : { left: 0, right: 0 }, ce = !!P && P.stackForward > 0, Re = !!P && P.span.end - P.span.start < c;
        return I(
          "div",
          { className: "fc-timegrid-event-harness" + (ce ? " fc-timegrid-event-harness-inset" : ""), key: o || L, style: Object.assign(Object.assign({ visibility: B ? "" : "hidden" }, W), X) },
          I(iC, Object.assign({ seg: R, isDragging: r, isResizing: i, isDateSelecting: s, isSelected: L === g, isShort: Re }, $s(R, y, x)))
        );
      })
    );
  }
  // will already have eventMinHeight applied because segInputs already had it
  renderHiddenGroups(e, t) {
    let { extraDateSpan: r, dateProfile: i, todayRange: s, nowDate: o, eventSelection: a, eventDrag: c, eventResize: u } = this.props;
    return I(Ct, null, e.map((f) => {
      let h = jp(f.span), p = ZH(f.entries, t);
      return I(zH, { key: q1(BT(p)), hiddenSegs: p, top: h.top, bottom: h.bottom, extraDateSpan: r, dateProfile: i, todayRange: s, nowDate: o, eventSelection: a, eventDrag: c, eventResize: u });
    }));
  }
  renderFillSegs(e, t) {
    let { props: r, context: i } = this, o = kS(e, r.date, r.slatCoords, i.options.eventMinHeight).map((a, c) => {
      let u = e[c];
      return I("div", { key: yT(u.eventRange), className: "fc-timegrid-bg-harness", style: jp(a) }, t === "bg-event" ? I(IT, Object.assign({ seg: u }, $s(u, r.todayRange, r.nowDate))) : NT(t));
    });
    return I(Ct, null, o);
  }
  renderNowIndicator(e) {
    let { slatCoords: t, date: r } = this.props;
    return t ? e.map((i, s) => I(
      Ly,
      {
        // key doesn't matter. will only ever be one
        key: s,
        elClasses: ["fc-timegrid-now-indicator-line"],
        elStyle: {
          top: t.computeDateTop(i.start, r)
        },
        isAxis: !1,
        date: r
      }
    )) : null;
  }
  computeSegHStyle(e) {
    let { isRtl: t, options: r } = this.context, i = r.slotEventOverlap, s = e.levelCoord, o = e.levelCoord + e.thickness, a, c;
    i && (o = Math.min(1, s + (o - s) * 2)), t ? (a = 1 - o, c = s) : (a = s, c = 1 - o);
    let u = {
      zIndex: e.stackDepth + 1,
      left: a * 100 + "%",
      right: c * 100 + "%"
    };
    return i && !e.stackForward && (u[t ? "marginLeft" : "marginRight"] = 10 * 2), u;
  }
}
function sC(n, { todayRange: e, nowDate: t, eventSelection: r, eventDrag: i, eventResize: s }) {
  let o = (i ? i.affectedInstances : null) || (s ? s.affectedInstances : null) || {};
  return I(Ct, null, n.map((a) => {
    let c = a.eventRange.instance.instanceId;
    return I(
      "div",
      { key: c, style: { visibility: o[c] ? "hidden" : "" } },
      I(iC, Object.assign({ seg: a, isDragging: !1, isResizing: !1, isDateSelecting: !1, isSelected: c === r, isShort: !1 }, $s(a, e, t)))
    );
  }));
}
function jp(n) {
  return n ? {
    top: n.start,
    bottom: -n.end
  } : { top: "", bottom: "" };
}
function ZH(n, e) {
  return n.map((t) => e[t.index]);
}
class XH extends pt {
  constructor() {
    super(...arguments), this.splitFgEventSegs = Ne(Ml), this.splitBgEventSegs = Ne(Ml), this.splitBusinessHourSegs = Ne(Ml), this.splitNowIndicatorSegs = Ne(Ml), this.splitDateSelectionSegs = Ne(Ml), this.splitEventDrag = Ne(DS), this.splitEventResize = Ne(DS), this.rootElRef = Xn(), this.cellElRefs = new es();
  }
  render() {
    let { props: e, context: t } = this, r = t.options.nowIndicator && e.slatCoords && e.slatCoords.safeComputeTop(e.nowDate), i = e.cells.length, s = this.splitFgEventSegs(e.fgEventSegs, i), o = this.splitBgEventSegs(e.bgEventSegs, i), a = this.splitBusinessHourSegs(e.businessHourSegs, i), c = this.splitNowIndicatorSegs(e.nowIndicatorSegs, i), u = this.splitDateSelectionSegs(e.dateSelectionSegs, i), f = this.splitEventDrag(e.eventDrag, i), h = this.splitEventResize(e.eventResize, i);
    return I(
      "div",
      { className: "fc-timegrid-cols", ref: this.rootElRef },
      I(
        "table",
        { role: "presentation", style: {
          minWidth: e.tableMinWidth,
          width: e.clientWidth
        } },
        e.tableColGroupNode,
        I(
          "tbody",
          { role: "presentation" },
          I(
            "tr",
            { role: "row" },
            e.axis && I(
              "td",
              { "aria-hidden": !0, className: "fc-timegrid-col fc-timegrid-axis" },
              I(
                "div",
                { className: "fc-timegrid-col-frame" },
                I("div", { className: "fc-timegrid-now-indicator-container" }, typeof r == "number" && I(Ly, { elClasses: ["fc-timegrid-now-indicator-arrow"], elStyle: { top: r }, isAxis: !0, date: e.nowDate }))
              )
            ),
            e.cells.map((p, g) => I(QH, { key: p.key, elRef: this.cellElRefs.createRef(p.key), dateProfile: e.dateProfile, date: p.date, nowDate: e.nowDate, todayRange: e.todayRange, extraRenderProps: p.extraRenderProps, extraDataAttrs: p.extraDataAttrs, extraClassNames: p.extraClassNames, extraDateSpan: p.extraDateSpan, fgEventSegs: s[g], bgEventSegs: o[g], businessHourSegs: a[g], nowIndicatorSegs: c[g], dateSelectionSegs: u[g], eventDrag: f[g], eventResize: h[g], slatCoords: e.slatCoords, eventSelection: e.eventSelection, forPrint: e.forPrint }))
          )
        )
      )
    );
  }
  componentDidMount() {
    this.updateCoords();
  }
  componentDidUpdate() {
    this.updateCoords();
  }
  updateCoords() {
    let { props: e } = this;
    e.onColCoords && e.clientWidth !== null && e.onColCoords(new Ja(
      this.rootElRef.current,
      eW(this.cellElRefs.currentMap, e.cells),
      !0,
      // horizontal
      !1
    ));
  }
}
function eW(n, e) {
  return e.map((t) => n[t.key]);
}
class tW extends Li {
  constructor() {
    super(...arguments), this.processSlotOptions = Ne(nW), this.state = {
      slatCoords: null
    }, this.handleRootEl = (e) => {
      e ? this.context.registerInteractiveComponent(this, {
        el: e,
        isHitComboAllowed: this.props.isHitComboAllowed
      }) : this.context.unregisterInteractiveComponent(this);
    }, this.handleScrollRequest = (e) => {
      let { onScrollTopRequest: t } = this.props, { slatCoords: r } = this.state;
      if (t && r) {
        if (e.time) {
          let i = r.computeTimeTop(e.time);
          i = Math.ceil(i), i && (i += 1), t(i);
        }
        return !0;
      }
      return !1;
    }, this.handleColCoords = (e) => {
      this.colCoords = e;
    }, this.handleSlatCoords = (e) => {
      this.setState({ slatCoords: e }), this.props.onSlatCoords && this.props.onSlatCoords(e);
    };
  }
  render() {
    let { props: e, state: t } = this;
    return I(
      "div",
      { className: "fc-timegrid-body", ref: this.handleRootEl, style: {
        // these props are important to give this wrapper correct dimensions for interactions
        // TODO: if we set it here, can we avoid giving to inner tables?
        width: e.clientWidth,
        minWidth: e.tableMinWidth
      } },
      I(jH, { axis: e.axis, dateProfile: e.dateProfile, slatMetas: e.slatMetas, clientWidth: e.clientWidth, minHeight: e.expandRows ? e.clientHeight : "", tableMinWidth: e.tableMinWidth, tableColGroupNode: e.axis ? e.tableColGroupNode : null, onCoords: this.handleSlatCoords }),
      I(XH, { cells: e.cells, axis: e.axis, dateProfile: e.dateProfile, businessHourSegs: e.businessHourSegs, bgEventSegs: e.bgEventSegs, fgEventSegs: e.fgEventSegs, dateSelectionSegs: e.dateSelectionSegs, eventSelection: e.eventSelection, eventDrag: e.eventDrag, eventResize: e.eventResize, todayRange: e.todayRange, nowDate: e.nowDate, nowIndicatorSegs: e.nowIndicatorSegs, clientWidth: e.clientWidth, tableMinWidth: e.tableMinWidth, tableColGroupNode: e.tableColGroupNode, slatCoords: t.slatCoords, onColCoords: this.handleColCoords, forPrint: e.forPrint })
    );
  }
  componentDidMount() {
    this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
  }
  componentDidUpdate(e) {
    this.scrollResponder.update(e.dateProfile !== this.props.dateProfile);
  }
  componentWillUnmount() {
    this.scrollResponder.detach();
  }
  queryHit(e, t) {
    let { dateEnv: r, options: i } = this.context, { colCoords: s } = this, { dateProfile: o } = this.props, { slatCoords: a } = this.state, { snapDuration: c, snapsPerSlot: u } = this.processSlotOptions(this.props.slotDuration, i.snapDuration), f = s.leftToIndex(e), h = a.positions.topToIndex(t);
    if (f != null && h != null) {
      let p = this.props.cells[f], g = a.positions.tops[h], y = a.positions.getHeight(h), x = (t - g) / y, S = Math.floor(x * u), w = h * u + S, C = this.props.cells[f].date, T = Jm(o.slotMinTime, ej(c, w)), k = r.add(C, T), R = r.add(k, c);
      return {
        dateProfile: o,
        dateSpan: Object.assign({ range: { start: k, end: R }, allDay: !1 }, p.extraDateSpan),
        dayEl: s.els[f],
        rect: {
          left: s.lefts[f],
          right: s.rights[f],
          top: g,
          bottom: g + y
        },
        layer: 0
      };
    }
    return null;
  }
}
function nW(n, e) {
  let t = e || n, r = by(n, t);
  return r === null && (t = n, r = 1), { snapDuration: t, snapsPerSlot: r };
}
class rW extends MT {
  sliceRange(e, t) {
    let r = [];
    for (let i = 0; i < t.length; i += 1) {
      let s = Uo(e, t[i]);
      s && r.push({
        start: s.start,
        end: s.end,
        isStart: s.start.valueOf() === e.start.valueOf(),
        isEnd: s.end.valueOf() === e.end.valueOf(),
        col: i
      });
    }
    return r;
  }
}
class iW extends Li {
  constructor() {
    super(...arguments), this.buildDayRanges = Ne(sW), this.slicer = new rW(), this.timeColsRef = Xn();
  }
  render() {
    let { props: e, context: t } = this, { dateProfile: r, dayTableModel: i } = e, { nowIndicator: s, nextDayThreshold: o } = t.options, a = this.buildDayRanges(i, r, t.dateEnv);
    return I(rl, { unit: s ? "minute" : "day" }, (c, u) => I(tW, Object.assign({ ref: this.timeColsRef }, this.slicer.sliceProps(e, r, null, t, a), { forPrint: e.forPrint, axis: e.axis, dateProfile: r, slatMetas: e.slatMetas, slotDuration: e.slotDuration, cells: i.cells[0], tableColGroupNode: e.tableColGroupNode, tableMinWidth: e.tableMinWidth, clientWidth: e.clientWidth, clientHeight: e.clientHeight, expandRows: e.expandRows, nowDate: c, nowIndicatorSegs: s && this.slicer.sliceNowDate(c, r, o, t, a), todayRange: u, onScrollTopRequest: e.onScrollTopRequest, onSlatCoords: e.onSlatCoords })));
  }
}
function sW(n, e, t) {
  let r = [];
  for (let i of n.headerDates)
    r.push({
      start: t.add(i, e.slotMinTime),
      end: t.add(i, e.slotMaxTime)
    });
  return r;
}
const MS = [
  { hours: 1 },
  { minutes: 30 },
  { minutes: 15 },
  { seconds: 30 },
  { seconds: 15 }
];
function oW(n, e, t, r, i) {
  let s = /* @__PURE__ */ new Date(0), o = n, a = ot(0), c = t || aW(r), u = [];
  for (; di(o) < di(e); ) {
    let f = i.add(s, o), h = by(a, c) !== null;
    u.push({
      date: f,
      time: o,
      key: f.toISOString(),
      isoTimeStr: gj(f),
      isLabeled: h
    }), o = Jm(o, r), a = Jm(a, r);
  }
  return u;
}
function aW(n) {
  let e, t, r;
  for (e = MS.length - 1; e >= 0; e -= 1)
    if (t = ot(MS[e]), r = by(t, n), r !== null && r > 1)
      return t;
  return n;
}
class lW extends NH {
  constructor() {
    super(...arguments), this.buildTimeColsModel = Ne(cW), this.buildSlatMetas = Ne(oW);
  }
  render() {
    let { options: e, dateEnv: t, dateProfileGenerator: r } = this.context, { props: i } = this, { dateProfile: s } = i, o = this.buildTimeColsModel(s, r), a = this.allDaySplitter.splitProps(i), c = this.buildSlatMetas(s.slotMinTime, s.slotMaxTime, e.slotLabelInterval, e.slotDuration, t), { dayMinWidth: u } = e, f = !u, h = u, p = e.dayHeaders && I(DT, { dates: o.headerDates, dateProfile: s, datesRepDistinctDays: !0, renderIntro: f ? this.renderHeadAxis : null }), g = e.allDaySlot !== !1 && ((x) => I(eC, Object.assign({}, a.allDay, { dateProfile: s, dayTableModel: o, nextDayThreshold: e.nextDayThreshold, tableMinWidth: x.tableMinWidth, colGroupNode: x.tableColGroupNode, renderRowIntro: f ? this.renderTableRowAxis : null, showWeekNumbers: !1, expandRows: !1, headerAlignElRef: this.headerElRef, clientWidth: x.clientWidth, clientHeight: x.clientHeight, forPrint: i.forPrint }, this.getAllDayMaxEventProps()))), y = (x) => I(iW, Object.assign({}, a.timed, { dayTableModel: o, dateProfile: s, axis: f, slotDuration: e.slotDuration, slatMetas: c, forPrint: i.forPrint, tableColGroupNode: x.tableColGroupNode, tableMinWidth: x.tableMinWidth, clientWidth: x.clientWidth, clientHeight: x.clientHeight, onSlatCoords: this.handleSlatCoords, expandRows: x.expandRows, onScrollTopRequest: this.handleScrollTopRequest }));
    return h ? this.renderHScrollLayout(p, g, y, o.colCnt, u, c, this.state.slatCoords) : this.renderSimpleLayout(p, g, y);
  }
}
function cW(n, e) {
  let t = new RT(n.renderRange, e);
  return new kT(t, !1);
}
var uW = '.fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:"\\00a0"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:"\\00a0-\\00a0"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-arrow,.fc .fc-timegrid-now-indicator-line{pointer-events:none}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}';
yy(uW);
const dW = {
  allDaySlot: Boolean
};
var fW = to({
  name: "@fullcalendar/timegrid",
  initialView: "timeGridWeek",
  optionRefiners: dW,
  views: {
    timeGrid: {
      component: lW,
      usesMinMaxTime: !0,
      allDaySlot: !0,
      slotDuration: "00:30:00",
      slotEventOverlap: !0
      // a bad name. confused with overlap/constraint system
    },
    timeGridDay: {
      type: "timeGrid",
      duration: { days: 1 }
    },
    timeGridWeek: {
      type: "timeGrid",
      duration: { weeks: 1 }
    }
  }
}), og = { exports: {} }, Uu = { exports: {} }, ft = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _S;
function hW() {
  if (_S) return ft;
  _S = 1;
  var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, o = n ? Symbol.for("react.provider") : 60109, a = n ? Symbol.for("react.context") : 60110, c = n ? Symbol.for("react.async_mode") : 60111, u = n ? Symbol.for("react.concurrent_mode") : 60111, f = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, g = n ? Symbol.for("react.memo") : 60115, y = n ? Symbol.for("react.lazy") : 60116, x = n ? Symbol.for("react.block") : 60121, S = n ? Symbol.for("react.fundamental") : 60117, w = n ? Symbol.for("react.responder") : 60118, C = n ? Symbol.for("react.scope") : 60119;
  function T(R) {
    if (typeof R == "object" && R !== null) {
      var P = R.$$typeof;
      switch (P) {
        case e:
          switch (R = R.type, R) {
            case c:
            case u:
            case r:
            case s:
            case i:
            case h:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case a:
                case f:
                case y:
                case g:
                case o:
                  return R;
                default:
                  return P;
              }
          }
        case t:
          return P;
      }
    }
  }
  function k(R) {
    return T(R) === u;
  }
  return ft.AsyncMode = c, ft.ConcurrentMode = u, ft.ContextConsumer = a, ft.ContextProvider = o, ft.Element = e, ft.ForwardRef = f, ft.Fragment = r, ft.Lazy = y, ft.Memo = g, ft.Portal = t, ft.Profiler = s, ft.StrictMode = i, ft.Suspense = h, ft.isAsyncMode = function(R) {
    return k(R) || T(R) === c;
  }, ft.isConcurrentMode = k, ft.isContextConsumer = function(R) {
    return T(R) === a;
  }, ft.isContextProvider = function(R) {
    return T(R) === o;
  }, ft.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === e;
  }, ft.isForwardRef = function(R) {
    return T(R) === f;
  }, ft.isFragment = function(R) {
    return T(R) === r;
  }, ft.isLazy = function(R) {
    return T(R) === y;
  }, ft.isMemo = function(R) {
    return T(R) === g;
  }, ft.isPortal = function(R) {
    return T(R) === t;
  }, ft.isProfiler = function(R) {
    return T(R) === s;
  }, ft.isStrictMode = function(R) {
    return T(R) === i;
  }, ft.isSuspense = function(R) {
    return T(R) === h;
  }, ft.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === r || R === u || R === s || R === i || R === h || R === p || typeof R == "object" && R !== null && (R.$$typeof === y || R.$$typeof === g || R.$$typeof === o || R.$$typeof === a || R.$$typeof === f || R.$$typeof === S || R.$$typeof === w || R.$$typeof === C || R.$$typeof === x);
  }, ft.typeOf = T, ft;
}
var ht = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var OS;
function pW() {
  return OS || (OS = 1, process.env.NODE_ENV !== "production" && function() {
    var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, o = n ? Symbol.for("react.provider") : 60109, a = n ? Symbol.for("react.context") : 60110, c = n ? Symbol.for("react.async_mode") : 60111, u = n ? Symbol.for("react.concurrent_mode") : 60111, f = n ? Symbol.for("react.forward_ref") : 60112, h = n ? Symbol.for("react.suspense") : 60113, p = n ? Symbol.for("react.suspense_list") : 60120, g = n ? Symbol.for("react.memo") : 60115, y = n ? Symbol.for("react.lazy") : 60116, x = n ? Symbol.for("react.block") : 60121, S = n ? Symbol.for("react.fundamental") : 60117, w = n ? Symbol.for("react.responder") : 60118, C = n ? Symbol.for("react.scope") : 60119;
    function T(ue) {
      return typeof ue == "string" || typeof ue == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ue === r || ue === u || ue === s || ue === i || ue === h || ue === p || typeof ue == "object" && ue !== null && (ue.$$typeof === y || ue.$$typeof === g || ue.$$typeof === o || ue.$$typeof === a || ue.$$typeof === f || ue.$$typeof === S || ue.$$typeof === w || ue.$$typeof === C || ue.$$typeof === x);
    }
    function k(ue) {
      if (typeof ue == "object" && ue !== null) {
        var et = ue.$$typeof;
        switch (et) {
          case e:
            var mt = ue.type;
            switch (mt) {
              case c:
              case u:
              case r:
              case s:
              case i:
              case h:
                return mt;
              default:
                var Kt = mt && mt.$$typeof;
                switch (Kt) {
                  case a:
                  case f:
                  case y:
                  case g:
                  case o:
                    return Kt;
                  default:
                    return et;
                }
            }
          case t:
            return et;
        }
      }
    }
    var R = c, P = u, L = a, B = o, W = e, X = f, ce = r, Re = y, ke = g, J = t, re = s, G = i, $ = h, K = !1;
    function Se(ue) {
      return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), z(ue) || k(ue) === c;
    }
    function z(ue) {
      return k(ue) === u;
    }
    function Q(ue) {
      return k(ue) === a;
    }
    function ge(ue) {
      return k(ue) === o;
    }
    function me(ue) {
      return typeof ue == "object" && ue !== null && ue.$$typeof === e;
    }
    function V(ue) {
      return k(ue) === f;
    }
    function ie(ue) {
      return k(ue) === r;
    }
    function q(ue) {
      return k(ue) === y;
    }
    function de(ue) {
      return k(ue) === g;
    }
    function ee(ue) {
      return k(ue) === t;
    }
    function he(ue) {
      return k(ue) === s;
    }
    function pe(ue) {
      return k(ue) === i;
    }
    function Ee(ue) {
      return k(ue) === h;
    }
    ht.AsyncMode = R, ht.ConcurrentMode = P, ht.ContextConsumer = L, ht.ContextProvider = B, ht.Element = W, ht.ForwardRef = X, ht.Fragment = ce, ht.Lazy = Re, ht.Memo = ke, ht.Portal = J, ht.Profiler = re, ht.StrictMode = G, ht.Suspense = $, ht.isAsyncMode = Se, ht.isConcurrentMode = z, ht.isContextConsumer = Q, ht.isContextProvider = ge, ht.isElement = me, ht.isForwardRef = V, ht.isFragment = ie, ht.isLazy = q, ht.isMemo = de, ht.isPortal = ee, ht.isProfiler = he, ht.isStrictMode = pe, ht.isSuspense = Ee, ht.isValidElementType = T, ht.typeOf = k;
  }()), ht;
}
var IS;
function oC() {
  return IS || (IS = 1, process.env.NODE_ENV === "production" ? Uu.exports = hW() : Uu.exports = pW()), Uu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Fp, NS;
function mW() {
  if (NS) return Fp;
  NS = 1;
  var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(o).map(function(f) {
        return o[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Fp = i() ? Object.assign : function(s, o) {
    for (var a, c = r(s), u, f = 1; f < arguments.length; f++) {
      a = Object(arguments[f]);
      for (var h in a)
        e.call(a, h) && (c[h] = a[h]);
      if (n) {
        u = n(a);
        for (var p = 0; p < u.length; p++)
          t.call(a, u[p]) && (c[u[p]] = a[u[p]]);
      }
    }
    return c;
  }, Fp;
}
var zp, PS;
function Vy() {
  if (PS) return zp;
  PS = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return zp = n, zp;
}
var Vp, LS;
function aC() {
  return LS || (LS = 1, Vp = Function.call.bind(Object.prototype.hasOwnProperty)), Vp;
}
var Hp, BS;
function gW() {
  if (BS) return Hp;
  BS = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Vy(), t = {}, r = aC();
    n = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(s, o, a, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in s)
        if (r(s, f)) {
          var h;
          try {
            if (typeof s[f] != "function") {
              var p = Error(
                (c || "React class") + ": " + a + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            h = s[f](o, f, c, a, null, e);
          } catch (y) {
            h = y;
          }
          if (h && !(h instanceof Error) && n(
            (c || "React class") + ": type specification of " + a + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in t)) {
            t[h.message] = !0;
            var g = u ? u() : "";
            n(
              "Failed " + a + " type: " + h.message + (g ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Hp = i, Hp;
}
var Wp, jS;
function yW() {
  if (jS) return Wp;
  jS = 1;
  var n = oC(), e = mW(), t = Vy(), r = aC(), i = gW(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Wp = function(a, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(z) {
      var Q = z && (u && z[u] || z[f]);
      if (typeof Q == "function")
        return Q;
    }
    var p = "<<anonymous>>", g = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: C(),
      arrayOf: T,
      element: k(),
      elementType: R(),
      instanceOf: P,
      node: X(),
      objectOf: B,
      oneOf: L,
      oneOfType: W,
      shape: Re,
      exact: ke
    };
    function y(z, Q) {
      return z === Q ? z !== 0 || 1 / z === 1 / Q : z !== z && Q !== Q;
    }
    function x(z, Q) {
      this.message = z, this.data = Q && typeof Q == "object" ? Q : {}, this.stack = "";
    }
    x.prototype = Error.prototype;
    function S(z) {
      if (process.env.NODE_ENV !== "production")
        var Q = {}, ge = 0;
      function me(ie, q, de, ee, he, pe, Ee) {
        if (ee = ee || p, pe = pe || de, Ee !== t) {
          if (c) {
            var ue = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ue.name = "Invariant Violation", ue;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var et = ee + ":" + de;
            !Q[et] && // Avoid spamming the console because they are often not actionable except for lib authors
            ge < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + pe + "` prop on `" + ee + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Q[et] = !0, ge++);
          }
        }
        return q[de] == null ? ie ? q[de] === null ? new x("The " + he + " `" + pe + "` is marked as required " + ("in `" + ee + "`, but its value is `null`.")) : new x("The " + he + " `" + pe + "` is marked as required in " + ("`" + ee + "`, but its value is `undefined`.")) : null : z(q, de, ee, he, pe);
      }
      var V = me.bind(null, !1);
      return V.isRequired = me.bind(null, !0), V;
    }
    function w(z) {
      function Q(ge, me, V, ie, q, de) {
        var ee = ge[me], he = G(ee);
        if (he !== z) {
          var pe = $(ee);
          return new x(
            "Invalid " + ie + " `" + q + "` of type " + ("`" + pe + "` supplied to `" + V + "`, expected ") + ("`" + z + "`."),
            { expectedType: z }
          );
        }
        return null;
      }
      return S(Q);
    }
    function C() {
      return S(o);
    }
    function T(z) {
      function Q(ge, me, V, ie, q) {
        if (typeof z != "function")
          return new x("Property `" + q + "` of component `" + V + "` has invalid PropType notation inside arrayOf.");
        var de = ge[me];
        if (!Array.isArray(de)) {
          var ee = G(de);
          return new x("Invalid " + ie + " `" + q + "` of type " + ("`" + ee + "` supplied to `" + V + "`, expected an array."));
        }
        for (var he = 0; he < de.length; he++) {
          var pe = z(de, he, V, ie, q + "[" + he + "]", t);
          if (pe instanceof Error)
            return pe;
        }
        return null;
      }
      return S(Q);
    }
    function k() {
      function z(Q, ge, me, V, ie) {
        var q = Q[ge];
        if (!a(q)) {
          var de = G(q);
          return new x("Invalid " + V + " `" + ie + "` of type " + ("`" + de + "` supplied to `" + me + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S(z);
    }
    function R() {
      function z(Q, ge, me, V, ie) {
        var q = Q[ge];
        if (!n.isValidElementType(q)) {
          var de = G(q);
          return new x("Invalid " + V + " `" + ie + "` of type " + ("`" + de + "` supplied to `" + me + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S(z);
    }
    function P(z) {
      function Q(ge, me, V, ie, q) {
        if (!(ge[me] instanceof z)) {
          var de = z.name || p, ee = Se(ge[me]);
          return new x("Invalid " + ie + " `" + q + "` of type " + ("`" + ee + "` supplied to `" + V + "`, expected ") + ("instance of `" + de + "`."));
        }
        return null;
      }
      return S(Q);
    }
    function L(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function Q(ge, me, V, ie, q) {
        for (var de = ge[me], ee = 0; ee < z.length; ee++)
          if (y(de, z[ee]))
            return null;
        var he = JSON.stringify(z, function(Ee, ue) {
          var et = $(ue);
          return et === "symbol" ? String(ue) : ue;
        });
        return new x("Invalid " + ie + " `" + q + "` of value `" + String(de) + "` " + ("supplied to `" + V + "`, expected one of " + he + "."));
      }
      return S(Q);
    }
    function B(z) {
      function Q(ge, me, V, ie, q) {
        if (typeof z != "function")
          return new x("Property `" + q + "` of component `" + V + "` has invalid PropType notation inside objectOf.");
        var de = ge[me], ee = G(de);
        if (ee !== "object")
          return new x("Invalid " + ie + " `" + q + "` of type " + ("`" + ee + "` supplied to `" + V + "`, expected an object."));
        for (var he in de)
          if (r(de, he)) {
            var pe = z(de, he, V, ie, q + "." + he, t);
            if (pe instanceof Error)
              return pe;
          }
        return null;
      }
      return S(Q);
    }
    function W(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var Q = 0; Q < z.length; Q++) {
        var ge = z[Q];
        if (typeof ge != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + K(ge) + " at index " + Q + "."
          ), o;
      }
      function me(V, ie, q, de, ee) {
        for (var he = [], pe = 0; pe < z.length; pe++) {
          var Ee = z[pe], ue = Ee(V, ie, q, de, ee, t);
          if (ue == null)
            return null;
          ue.data && r(ue.data, "expectedType") && he.push(ue.data.expectedType);
        }
        var et = he.length > 0 ? ", expected one of type [" + he.join(", ") + "]" : "";
        return new x("Invalid " + de + " `" + ee + "` supplied to " + ("`" + q + "`" + et + "."));
      }
      return S(me);
    }
    function X() {
      function z(Q, ge, me, V, ie) {
        return J(Q[ge]) ? null : new x("Invalid " + V + " `" + ie + "` supplied to " + ("`" + me + "`, expected a ReactNode."));
      }
      return S(z);
    }
    function ce(z, Q, ge, me, V) {
      return new x(
        (z || "React class") + ": " + Q + " type `" + ge + "." + me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + V + "`."
      );
    }
    function Re(z) {
      function Q(ge, me, V, ie, q) {
        var de = ge[me], ee = G(de);
        if (ee !== "object")
          return new x("Invalid " + ie + " `" + q + "` of type `" + ee + "` " + ("supplied to `" + V + "`, expected `object`."));
        for (var he in z) {
          var pe = z[he];
          if (typeof pe != "function")
            return ce(V, ie, q, he, $(pe));
          var Ee = pe(de, he, V, ie, q + "." + he, t);
          if (Ee)
            return Ee;
        }
        return null;
      }
      return S(Q);
    }
    function ke(z) {
      function Q(ge, me, V, ie, q) {
        var de = ge[me], ee = G(de);
        if (ee !== "object")
          return new x("Invalid " + ie + " `" + q + "` of type `" + ee + "` " + ("supplied to `" + V + "`, expected `object`."));
        var he = e({}, ge[me], z);
        for (var pe in he) {
          var Ee = z[pe];
          if (r(z, pe) && typeof Ee != "function")
            return ce(V, ie, q, pe, $(Ee));
          if (!Ee)
            return new x(
              "Invalid " + ie + " `" + q + "` key `" + pe + "` supplied to `" + V + "`.\nBad object: " + JSON.stringify(ge[me], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(z), null, "  ")
            );
          var ue = Ee(de, pe, V, ie, q + "." + pe, t);
          if (ue)
            return ue;
        }
        return null;
      }
      return S(Q);
    }
    function J(z) {
      switch (typeof z) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !z;
        case "object":
          if (Array.isArray(z))
            return z.every(J);
          if (z === null || a(z))
            return !0;
          var Q = h(z);
          if (Q) {
            var ge = Q.call(z), me;
            if (Q !== z.entries) {
              for (; !(me = ge.next()).done; )
                if (!J(me.value))
                  return !1;
            } else
              for (; !(me = ge.next()).done; ) {
                var V = me.value;
                if (V && !J(V[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re(z, Q) {
      return z === "symbol" ? !0 : Q ? Q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Q instanceof Symbol : !1;
    }
    function G(z) {
      var Q = typeof z;
      return Array.isArray(z) ? "array" : z instanceof RegExp ? "object" : re(Q, z) ? "symbol" : Q;
    }
    function $(z) {
      if (typeof z > "u" || z === null)
        return "" + z;
      var Q = G(z);
      if (Q === "object") {
        if (z instanceof Date)
          return "date";
        if (z instanceof RegExp)
          return "regexp";
      }
      return Q;
    }
    function K(z) {
      var Q = $(z);
      switch (Q) {
        case "array":
        case "object":
          return "an " + Q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Q;
        default:
          return Q;
      }
    }
    function Se(z) {
      return !z.constructor || !z.constructor.name ? p : z.constructor.name;
    }
    return g.checkPropTypes = i, g.resetWarningCache = i.resetWarningCache, g.PropTypes = g, g;
  }, Wp;
}
var Up, FS;
function vW() {
  if (FS) return Up;
  FS = 1;
  var n = Vy();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, Up = function() {
    function r(o, a, c, u, f, h) {
      if (h !== n) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, Up;
}
if (process.env.NODE_ENV !== "production") {
  var bW = oC(), xW = !0;
  og.exports = yW()(bW.isElement, xW);
} else
  og.exports = vW()();
var SW = og.exports;
const xo = /* @__PURE__ */ S1(SW);
var wW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, EW = Object.defineProperty, AW = Object.defineProperties, TW = Object.getOwnPropertyDescriptors, Hd = Object.getOwnPropertySymbols, lC = Object.prototype.hasOwnProperty, cC = Object.prototype.propertyIsEnumerable, zS = (n, e, t) => e in n ? EW(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, VS = (n, e) => {
  for (var t in e || (e = {}))
    lC.call(e, t) && zS(n, t, e[t]);
  if (Hd)
    for (var t of Hd(e))
      cC.call(e, t) && zS(n, t, e[t]);
  return n;
}, CW = (n, e) => AW(n, TW(e)), DW = (n, e) => {
  var t = {};
  for (var r in n)
    lC.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && Hd)
    for (var r of Hd(n))
      e.indexOf(r) < 0 && cC.call(n, r) && (t[r] = n[r]);
  return t;
}, Wn = (n, e, t) => {
  const r = hs(
    (i, s) => {
      var o = i, { color: a = "currentColor", size: c = 24, stroke: u = 2, children: f } = o, h = DW(o, ["color", "size", "stroke", "children"]);
      return $m(
        "svg",
        VS(CW(VS({
          ref: s
        }, wW), {
          width: c,
          height: c,
          stroke: a,
          strokeWidth: u,
          className: `tabler-icon tabler-icon-${n}`
        }), h),
        [...t.map(([p, g]) => $m(p, g)), ...f || []]
      );
    }
  );
  return r.propTypes = {
    color: xo.string,
    size: xo.oneOfType([xo.string, xo.number]),
    stroke: xo.oneOfType([xo.string, xo.number])
  }, r.displayName = `${e}`, r;
}, RW = Wn("alert-circle", "IconAlertCircle", [
  ["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 8v4", key: "svg-1" }],
  ["path", { d: "M12 16h.01", key: "svg-2" }]
]), kW = Wn("alert-triangle", "IconAlertTriangle", [
  ["path", { d: "M12 9v4", key: "svg-0" }],
  [
    "path",
    {
      d: "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M12 16h.01", key: "svg-2" }]
]), MW = Wn("arrow-left", "IconArrowLeft", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }],
  ["path", { d: "M5 12l6 6", key: "svg-1" }],
  ["path", { d: "M5 12l6 -6", key: "svg-2" }]
]), HS = Wn("arrow-right", "IconArrowRight", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }],
  ["path", { d: "M13 18l6 -6", key: "svg-1" }],
  ["path", { d: "M13 6l6 6", key: "svg-2" }]
]), Hy = Wn("check", "IconCheck", [
  ["path", { d: "M5 12l5 5l10 -10", key: "svg-0" }]
]), Wy = Wn("chevron-down", "IconChevronDown", [
  ["path", { d: "M6 9l6 6l6 -6", key: "svg-0" }]
]), _W = Wn("chevron-left", "IconChevronLeft", [
  ["path", { d: "M15 6l-6 6l6 6", key: "svg-0" }]
]), OW = Wn("chevron-right", "IconChevronRight", [
  ["path", { d: "M9 6l6 6l-6 6", key: "svg-0" }]
]), uC = Wn("chevron-up", "IconChevronUp", [
  ["path", { d: "M6 15l6 -6l6 6", key: "svg-0" }]
]), dC = Wn("copy", "IconCopy", [
  [
    "path",
    {
      d: "M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1",
      key: "svg-1"
    }
  ]
]), IW = Wn("dots-vertical", "IconDotsVertical", [
  ["path", { d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-0" }],
  ["path", { d: "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-1" }],
  ["path", { d: "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }]
]), NW = Wn("home", "IconHome", [
  ["path", { d: "M5 12l-2 0l9 -9l9 9l-2 0", key: "svg-0" }],
  ["path", { d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", key: "svg-1" }],
  ["path", { d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6", key: "svg-2" }]
]), PW = Wn("pencil", "IconPencil", [
  [
    "path",
    {
      d: "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M13.5 6.5l4 4", key: "svg-1" }]
]), LW = Wn("refresh", "IconRefresh", [
  ["path", { d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", key: "svg-0" }],
  ["path", { d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", key: "svg-1" }]
]), BW = Wn("shield-check", "IconShieldCheck", [
  [
    "path",
    {
      d: "M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06",
      key: "svg-0"
    }
  ],
  ["path", { d: "M15 19l2 2l4 -4", key: "svg-1" }]
]), jW = Wn("trash", "IconTrash", [
  ["path", { d: "M4 7l16 0", key: "svg-0" }],
  ["path", { d: "M10 11l0 6", key: "svg-1" }],
  ["path", { d: "M14 11l0 6", key: "svg-2" }],
  [
    "path",
    { d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12", key: "svg-3" }
  ],
  ["path", { d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3", key: "svg-4" }]
]), fC = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r();
  })(Ra, function() {
    var t = 1e3, r = 6e4, i = 36e5, s = "millisecond", o = "second", a = "minute", c = "hour", u = "day", f = "week", h = "month", p = "quarter", g = "year", y = "date", x = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, w = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, C = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(J) {
      var re = ["th", "st", "nd", "rd"], G = J % 100;
      return "[" + J + (re[(G - 20) % 10] || re[G] || re[0]) + "]";
    } }, T = function(J, re, G) {
      var $ = String(J);
      return !$ || $.length >= re ? J : "" + Array(re + 1 - $.length).join(G) + J;
    }, k = { s: T, z: function(J) {
      var re = -J.utcOffset(), G = Math.abs(re), $ = Math.floor(G / 60), K = G % 60;
      return (re <= 0 ? "+" : "-") + T($, 2, "0") + ":" + T(K, 2, "0");
    }, m: function J(re, G) {
      if (re.date() < G.date()) return -J(G, re);
      var $ = 12 * (G.year() - re.year()) + (G.month() - re.month()), K = re.clone().add($, h), Se = G - K < 0, z = re.clone().add($ + (Se ? -1 : 1), h);
      return +(-($ + (G - K) / (Se ? K - z : z - K)) || 0);
    }, a: function(J) {
      return J < 0 ? Math.ceil(J) || 0 : Math.floor(J);
    }, p: function(J) {
      return { M: h, y: g, w: f, d: u, D: y, h: c, m: a, s: o, ms: s, Q: p }[J] || String(J || "").toLowerCase().replace(/s$/, "");
    }, u: function(J) {
      return J === void 0;
    } }, R = "en", P = {};
    P[R] = C;
    var L = "$isDayjsObject", B = function(J) {
      return J instanceof Re || !(!J || !J[L]);
    }, W = function J(re, G, $) {
      var K;
      if (!re) return R;
      if (typeof re == "string") {
        var Se = re.toLowerCase();
        P[Se] && (K = Se), G && (P[Se] = G, K = Se);
        var z = re.split("-");
        if (!K && z.length > 1) return J(z[0]);
      } else {
        var Q = re.name;
        P[Q] = re, K = Q;
      }
      return !$ && K && (R = K), K || !$ && R;
    }, X = function(J, re) {
      if (B(J)) return J.clone();
      var G = typeof re == "object" ? re : {};
      return G.date = J, G.args = arguments, new Re(G);
    }, ce = k;
    ce.l = W, ce.i = B, ce.w = function(J, re) {
      return X(J, { locale: re.$L, utc: re.$u, x: re.$x, $offset: re.$offset });
    };
    var Re = function() {
      function J(G) {
        this.$L = W(G.locale, null, !0), this.parse(G), this.$x = this.$x || G.x || {}, this[L] = !0;
      }
      var re = J.prototype;
      return re.parse = function(G) {
        this.$d = function($) {
          var K = $.date, Se = $.utc;
          if (K === null) return /* @__PURE__ */ new Date(NaN);
          if (ce.u(K)) return /* @__PURE__ */ new Date();
          if (K instanceof Date) return new Date(K);
          if (typeof K == "string" && !/Z$/i.test(K)) {
            var z = K.match(S);
            if (z) {
              var Q = z[2] - 1 || 0, ge = (z[7] || "0").substring(0, 3);
              return Se ? new Date(Date.UTC(z[1], Q, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, ge)) : new Date(z[1], Q, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, ge);
            }
          }
          return new Date(K);
        }(G), this.init();
      }, re.init = function() {
        var G = this.$d;
        this.$y = G.getFullYear(), this.$M = G.getMonth(), this.$D = G.getDate(), this.$W = G.getDay(), this.$H = G.getHours(), this.$m = G.getMinutes(), this.$s = G.getSeconds(), this.$ms = G.getMilliseconds();
      }, re.$utils = function() {
        return ce;
      }, re.isValid = function() {
        return this.$d.toString() !== x;
      }, re.isSame = function(G, $) {
        var K = X(G);
        return this.startOf($) <= K && K <= this.endOf($);
      }, re.isAfter = function(G, $) {
        return X(G) < this.startOf($);
      }, re.isBefore = function(G, $) {
        return this.endOf($) < X(G);
      }, re.$g = function(G, $, K) {
        return ce.u(G) ? this[$] : this.set(K, G);
      }, re.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, re.valueOf = function() {
        return this.$d.getTime();
      }, re.startOf = function(G, $) {
        var K = this, Se = !!ce.u($) || $, z = ce.p(G), Q = function(he, pe) {
          var Ee = ce.w(K.$u ? Date.UTC(K.$y, pe, he) : new Date(K.$y, pe, he), K);
          return Se ? Ee : Ee.endOf(u);
        }, ge = function(he, pe) {
          return ce.w(K.toDate()[he].apply(K.toDate("s"), (Se ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(pe)), K);
        }, me = this.$W, V = this.$M, ie = this.$D, q = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case g:
            return Se ? Q(1, 0) : Q(31, 11);
          case h:
            return Se ? Q(1, V) : Q(0, V + 1);
          case f:
            var de = this.$locale().weekStart || 0, ee = (me < de ? me + 7 : me) - de;
            return Q(Se ? ie - ee : ie + (6 - ee), V);
          case u:
          case y:
            return ge(q + "Hours", 0);
          case c:
            return ge(q + "Minutes", 1);
          case a:
            return ge(q + "Seconds", 2);
          case o:
            return ge(q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, re.endOf = function(G) {
        return this.startOf(G, !1);
      }, re.$set = function(G, $) {
        var K, Se = ce.p(G), z = "set" + (this.$u ? "UTC" : ""), Q = (K = {}, K[u] = z + "Date", K[y] = z + "Date", K[h] = z + "Month", K[g] = z + "FullYear", K[c] = z + "Hours", K[a] = z + "Minutes", K[o] = z + "Seconds", K[s] = z + "Milliseconds", K)[Se], ge = Se === u ? this.$D + ($ - this.$W) : $;
        if (Se === h || Se === g) {
          var me = this.clone().set(y, 1);
          me.$d[Q](ge), me.init(), this.$d = me.set(y, Math.min(this.$D, me.daysInMonth())).$d;
        } else Q && this.$d[Q](ge);
        return this.init(), this;
      }, re.set = function(G, $) {
        return this.clone().$set(G, $);
      }, re.get = function(G) {
        return this[ce.p(G)]();
      }, re.add = function(G, $) {
        var K, Se = this;
        G = Number(G);
        var z = ce.p($), Q = function(V) {
          var ie = X(Se);
          return ce.w(ie.date(ie.date() + Math.round(V * G)), Se);
        };
        if (z === h) return this.set(h, this.$M + G);
        if (z === g) return this.set(g, this.$y + G);
        if (z === u) return Q(1);
        if (z === f) return Q(7);
        var ge = (K = {}, K[a] = r, K[c] = i, K[o] = t, K)[z] || 1, me = this.$d.getTime() + G * ge;
        return ce.w(me, this);
      }, re.subtract = function(G, $) {
        return this.add(-1 * G, $);
      }, re.format = function(G) {
        var $ = this, K = this.$locale();
        if (!this.isValid()) return K.invalidDate || x;
        var Se = G || "YYYY-MM-DDTHH:mm:ssZ", z = ce.z(this), Q = this.$H, ge = this.$m, me = this.$M, V = K.weekdays, ie = K.months, q = K.meridiem, de = function(pe, Ee, ue, et) {
          return pe && (pe[Ee] || pe($, Se)) || ue[Ee].slice(0, et);
        }, ee = function(pe) {
          return ce.s(Q % 12 || 12, pe, "0");
        }, he = q || function(pe, Ee, ue) {
          var et = pe < 12 ? "AM" : "PM";
          return ue ? et.toLowerCase() : et;
        };
        return Se.replace(w, function(pe, Ee) {
          return Ee || function(ue) {
            switch (ue) {
              case "YY":
                return String($.$y).slice(-2);
              case "YYYY":
                return ce.s($.$y, 4, "0");
              case "M":
                return me + 1;
              case "MM":
                return ce.s(me + 1, 2, "0");
              case "MMM":
                return de(K.monthsShort, me, ie, 3);
              case "MMMM":
                return de(ie, me);
              case "D":
                return $.$D;
              case "DD":
                return ce.s($.$D, 2, "0");
              case "d":
                return String($.$W);
              case "dd":
                return de(K.weekdaysMin, $.$W, V, 2);
              case "ddd":
                return de(K.weekdaysShort, $.$W, V, 3);
              case "dddd":
                return V[$.$W];
              case "H":
                return String(Q);
              case "HH":
                return ce.s(Q, 2, "0");
              case "h":
                return ee(1);
              case "hh":
                return ee(2);
              case "a":
                return he(Q, ge, !0);
              case "A":
                return he(Q, ge, !1);
              case "m":
                return String(ge);
              case "mm":
                return ce.s(ge, 2, "0");
              case "s":
                return String($.$s);
              case "ss":
                return ce.s($.$s, 2, "0");
              case "SSS":
                return ce.s($.$ms, 3, "0");
              case "Z":
                return z;
            }
            return null;
          }(pe) || z.replace(":", "");
        });
      }, re.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, re.diff = function(G, $, K) {
        var Se, z = this, Q = ce.p($), ge = X(G), me = (ge.utcOffset() - this.utcOffset()) * r, V = this - ge, ie = function() {
          return ce.m(z, ge);
        };
        switch (Q) {
          case g:
            Se = ie() / 12;
            break;
          case h:
            Se = ie();
            break;
          case p:
            Se = ie() / 3;
            break;
          case f:
            Se = (V - me) / 6048e5;
            break;
          case u:
            Se = (V - me) / 864e5;
            break;
          case c:
            Se = V / i;
            break;
          case a:
            Se = V / r;
            break;
          case o:
            Se = V / t;
            break;
          default:
            Se = V;
        }
        return K ? Se : ce.a(Se);
      }, re.daysInMonth = function() {
        return this.endOf(h).$D;
      }, re.$locale = function() {
        return P[this.$L];
      }, re.locale = function(G, $) {
        if (!G) return this.$L;
        var K = this.clone(), Se = W(G, $, !0);
        return Se && (K.$L = Se), K;
      }, re.clone = function() {
        return ce.w(this.$d, this);
      }, re.toDate = function() {
        return new Date(this.valueOf());
      }, re.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, re.toISOString = function() {
        return this.$d.toISOString();
      }, re.toString = function() {
        return this.$d.toUTCString();
      }, J;
    }(), ke = Re.prototype;
    return X.prototype = ke, [["$ms", s], ["$s", o], ["$m", a], ["$H", c], ["$W", u], ["$M", h], ["$y", g], ["$D", y]].forEach(function(J) {
      ke[J[1]] = function(re) {
        return this.$g(re, J[0], J[1]);
      };
    }), X.extend = function(J, re) {
      return J.$i || (J(re, Re, X), J.$i = !0), X;
    }, X.locale = W, X.isDayjs = B, X.unix = function(J) {
      return X(1e3 * J);
    }, X.en = P[R], X.Ls = P, X.p = {}, X;
  });
})(fC);
var FW = fC.exports;
const bt = /* @__PURE__ */ S1(FW), zW = "_calendarWrapper_vg3lz_1", VW = "_eventContent_vg3lz_53", WS = {
  calendarWrapper: zW,
  eventContent: VW
};
function JJ({
  events: n,
  currentDate: e,
  onPrev: t,
  onNext: r,
  onToday: i,
  onTitleClick: s,
  onDatesSet: o,
  onDateClick: a
}) {
  const c = vt(null);
  St(() => {
    if (c.current && e) {
      const f = c.current.getApi();
      bt(f.getDate()).format("YYYY-MM") !== bt(e).format("YYYY-MM") && f.gotoDate(e);
    }
  }, [e]);
  const u = (f) => /* @__PURE__ */ b.jsx(
    "div",
    {
      className: WS.eventContent,
      style: {
        backgroundColor: f.event.backgroundColor,
        color: f.event.textColor
      },
      children: f.event.title
    }
  );
  return /* @__PURE__ */ b.jsxs("div", { className: WS.calendarWrapper, children: [
    /* @__PURE__ */ b.jsxs(je, { justify: "center", align: "center", mb: "md", gap: "xs", children: [
      /* @__PURE__ */ b.jsx(
        hi,
        {
          variant: "subtle",
          color: "gray",
          "aria-label": "이전 달",
          onClick: t,
          disabled: !t,
          children: /* @__PURE__ */ b.jsx(_W, { size: 20 })
        }
      ),
      /* @__PURE__ */ b.jsx(
        Lc,
        {
          "aria-label": "표시 월 선택",
          disabled: !s,
          style: {
            minWidth: 80,
            textAlign: "center"
          },
          onClick: s,
          children: /* @__PURE__ */ b.jsx(ae, { fw: 500, size: "lg", children: bt(e || /* @__PURE__ */ new Date()).format("YYYY. MM") })
        }
      ),
      /* @__PURE__ */ b.jsx(
        hi,
        {
          variant: "subtle",
          color: "gray",
          "aria-label": "다음 달",
          onClick: r,
          disabled: !r,
          children: /* @__PURE__ */ b.jsx(OW, { size: 20 })
        }
      ),
      i && /* @__PURE__ */ b.jsx(
        hn,
        {
          size: "xs",
          variant: "light",
          color: "blue",
          onClick: i,
          ml: "xs",
          children: "오늘"
        }
      )
    ] }),
    /* @__PURE__ */ b.jsx(
      tC,
      {
        ref: c,
        plugins: [AH, fW],
        initialView: "dayGridMonth",
        locale: dB,
        events: n,
        height: "auto",
        headerToolbar: !1,
        initialDate: e,
        datesSet: o,
        dayCellContent: (f) => f.date.getDate().toString(),
        dayHeaderDidMount: (f) => {
          const h = f.date.getDay(), p = f.el.querySelector(".fc-col-header-cell-cushion");
          p && (h === 0 ? p.style.color = "var(--mantine-color-red-6)" : h === 6 && (p.style.color = "var(--mantine-color-blue-6)"));
        },
        dayCellDidMount: (f) => {
          const h = f.date.getDay(), p = f.el.querySelector(".fc-daygrid-day-number");
          p && (h === 0 ? p.style.color = "var(--mantine-color-red-6)" : h === 6 && (p.style.color = "var(--mantine-color-blue-6)")), a && (f.el.style.cursor = "pointer", f.el.addEventListener("click", () => {
            a(f.date);
          }));
        },
        eventContent: u
      }
    )
  ] });
}
const Gf = typeof window < "u", QJ = (n) => {
  if (!Gf) return;
  if (!n) {
    console.warn("[분석 로깅] 측정 ID가 없어 기존 GA 수집을 시작하지 않았습니다.");
    return;
  }
  const e = "google-analytics-script";
  if (!document.getElementById(e)) {
    const t = document.createElement("script");
    t.id = e, t.async = !0, t.src = `https://www.googletagmanager.com/gtag/js?id=${n}`, document.head.appendChild(t);
  }
  window.dataLayer = window.dataLayer || [], window.gtag || (window.gtag = (...t) => {
    var r;
    (r = window.dataLayer) == null || r.push(t);
  }), window.gtag("js", /* @__PURE__ */ new Date()), window.gtag("config", n, {
    ...my(window.location.pathname, window.location.origin, "DutyOn"),
    send_page_view: !1
  }), console.info("[분석 로깅] 기존 GA 수집을 시작했습니다.");
}, HW = (n, e) => {
  if (!Gf) return;
  const t = G2(n, e);
  t && window.gtag && window.gtag("event", t.name, {
    ...t.params,
    ...my(window.location.pathname, window.location.origin, "DutyOn")
  });
}, WW = (n, e) => {
  if (!Gf) return;
  const t = Y2(n);
  !!window.dispatchEvent(
    new CustomEvent("dutyon:page-view", {
      cancelable: !0,
      detail: { path: t }
    })
  ) && window.gtag && window.gtag("event", "page_view", {
    ...my(t, window.location.origin, "DutyOn")
  });
}, ZJ = (n) => {
  Gf && HW("duty_auto_generated", {
    duty_count: n.dutyCount,
    mode: n.mode,
    source: n.source
  });
};
function XJ() {
  const n = nB();
  return St(() => {
    WW(n.pathname);
  }, [n.pathname]), /* @__PURE__ */ b.jsx(v1, {});
}
function eQ({
  allowedRoles: n,
  fallbackPath: e = "/login",
  onUnauthorized: t,
  fallbackElement: r = null
}) {
  const { token: i, clearToken: s, logout: o } = q2(), [a, c] = wt(null);
  return St(() => {
    if (!i) {
      o({ reason: "session-expired" }), c(!1);
      return;
    }
    const u = K2(i), f = u != null && u.exp ? u.exp * 1e3 <= Date.now() : !0;
    if (!u || f || u.tokenType !== "access") {
      o({ reason: "session-expired" }), c(!1);
      return;
    }
    if (!n || n.length === 0) {
      c(!0);
      return;
    }
    const h = u == null ? void 0 : u.role;
    u && h && n.includes(h) ? c(!0) : t ? t(u, {
      clearToken: s,
      reject: () => {
        c(!1);
      }
    }) : c(!1);
  }, [i, n, s, o, t]), a === null ? r : a ? /* @__PURE__ */ b.jsx(v1, {}) : /* @__PURE__ */ b.jsx(rB, { to: e, replace: !0 });
}
const hC = ps({});
function Uy(n) {
  const e = vt(null);
  return e.current === null && (e.current = n()), e.current;
}
const pC = typeof window < "u", mC = pC ? py : St, $y = /* @__PURE__ */ ps(null);
function Gy(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function Vc(n, e) {
  const t = n.indexOf(e);
  t > -1 && n.splice(t, 1);
}
const Oi = (n, e, t) => t > e ? e : t < n ? n : t;
function ag(n, e) {
  return e ? `${n}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : n;
}
let il = () => {
}, mi = () => {
};
var u1;
typeof process < "u" && ((u1 = process.env) == null ? void 0 : u1.NODE_ENV) !== "production" && (il = (n, e, t) => {
  !n && typeof console < "u" && console.warn(ag(e, t));
}, mi = (n, e, t) => {
  if (!n)
    throw new Error(ag(e, t));
});
const ls = {}, gC = (n) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(n);
function yC(n) {
  return typeof n == "object" && n !== null;
}
const vC = (n) => /^0[^.\s]+$/u.test(n);
// @__NO_SIDE_EFFECTS__
function Yy(n) {
  let e;
  return () => (e === void 0 && (e = n()), e);
}
const Jr = /* @__NO_SIDE_EFFECTS__ */ (n) => n, UW = (n, e) => (t) => e(n(t)), Hc = (...n) => n.reduce(UW), Qa = /* @__NO_SIDE_EFFECTS__ */ (n, e, t) => {
  const r = e - n;
  return r === 0 ? 1 : (t - n) / r;
};
class qy {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Gy(this.subscriptions, e), () => Vc(this.subscriptions, e);
  }
  notify(e, t, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, t, r);
      else
        for (let s = 0; s < i; s++) {
          const o = this.subscriptions[s];
          o && o(e, t, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const fi = /* @__NO_SIDE_EFFECTS__ */ (n) => n * 1e3, Kr = /* @__NO_SIDE_EFFECTS__ */ (n) => n / 1e3;
function bC(n, e) {
  return e ? n * (1e3 / e) : 0;
}
const US = /* @__PURE__ */ new Set();
function Yf(n, e, t) {
  n || US.has(e) || (console.warn(ag(e, t)), US.add(e));
}
const $W = (n, e, t) => {
  const r = e - n;
  return ((t - n) % r + r) % r + n;
}, xC = (n, e, t) => (((1 - 3 * t + 3 * e) * n + (3 * t - 6 * e)) * n + 3 * e) * n, GW = 1e-7, YW = 12;
function qW(n, e, t, r, i) {
  let s, o, a = 0;
  do
    o = e + (t - e) / 2, s = xC(o, r, i) - n, s > 0 ? t = o : e = o;
  while (Math.abs(s) > GW && ++a < YW);
  return o;
}
function Wc(n, e, t, r) {
  if (n === e && t === r)
    return Jr;
  const i = (s) => qW(s, 0, 1, n, t);
  return (s) => s === 0 || s === 1 ? s : xC(i(s), e, r);
}
const SC = (n) => (e) => e <= 0.5 ? n(2 * e) / 2 : (2 - n(2 * (1 - e))) / 2, wC = (n) => (e) => 1 - n(1 - e), EC = /* @__PURE__ */ Wc(0.33, 1.53, 0.69, 0.99), Ky = /* @__PURE__ */ wC(EC), AC = /* @__PURE__ */ SC(Ky), TC = (n) => (n *= 2) < 1 ? 0.5 * Ky(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1))), Jy = (n) => 1 - Math.sin(Math.acos(n)), CC = wC(Jy), DC = SC(Jy), KW = /* @__PURE__ */ Wc(0.42, 0, 1, 1), JW = /* @__PURE__ */ Wc(0, 0, 0.58, 1), RC = /* @__PURE__ */ Wc(0.42, 0, 0.58, 1), kC = (n) => Array.isArray(n) && typeof n[0] != "number";
function MC(n, e) {
  return kC(n) ? n[$W(0, n.length, e)] : n;
}
const _C = (n) => Array.isArray(n) && typeof n[0] == "number", $S = {
  linear: Jr,
  easeIn: KW,
  easeInOut: RC,
  easeOut: JW,
  circIn: Jy,
  circInOut: DC,
  circOut: CC,
  backIn: Ky,
  backInOut: AC,
  backOut: EC,
  anticipate: TC
}, QW = (n) => typeof n == "string", GS = (n) => {
  if (_C(n)) {
    mi(n.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, t, r, i] = n;
    return Wc(e, t, r, i);
  } else if (QW(n))
    return mi($S[n] !== void 0, `Invalid easing type '${n}'`, "invalid-easing-type"), $S[n];
  return n;
}, $u = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function ZW(n, e) {
  let t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, s = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function c(f) {
    o.has(f) && (u.schedule(f), n()), f(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, h = !1, p = !1) => {
      const y = p && i ? t : r;
      return h && o.add(f), y.has(f) || y.add(f), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      r.delete(f), o.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (a = f, i) {
        s = !0;
        return;
      }
      i = !0, [t, r] = [r, t], t.forEach(c), t.clear(), i = !1, s && (s = !1, u.process(f));
    }
  };
  return u;
}
const XW = 40;
function OC(n, e) {
  let t = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = () => t = !0, o = $u.reduce((T, k) => (T[k] = ZW(s), T), {}), { setup: a, read: c, resolveKeyframes: u, preUpdate: f, update: h, preRender: p, render: g, postRender: y } = o, x = () => {
    const T = ls.useManualTiming ? i.timestamp : performance.now();
    t = !1, ls.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(T - i.timestamp, XW), 1)), i.timestamp = T, i.isProcessing = !0, a.process(i), c.process(i), u.process(i), f.process(i), h.process(i), p.process(i), g.process(i), y.process(i), i.isProcessing = !1, t && e && (r = !1, n(x));
  }, S = () => {
    t = !0, r = !0, i.isProcessing || n(x);
  };
  return { schedule: $u.reduce((T, k) => {
    const R = o[k];
    return T[k] = (P, L = !1, B = !1) => (t || S(), R.schedule(P, L, B)), T;
  }, {}), cancel: (T) => {
    for (let k = 0; k < $u.length; k++)
      o[$u[k]].cancel(T);
  }, state: i, steps: o };
}
const { schedule: Dt, cancel: cs, state: Mn, steps: $p } = /* @__PURE__ */ OC(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Jr, !0);
let vd;
function eU() {
  vd = void 0;
}
const Qn = {
  now: () => (vd === void 0 && Qn.set(Mn.isProcessing || ls.useManualTiming ? Mn.timestamp : performance.now()), vd),
  set: (n) => {
    vd = n, queueMicrotask(eU);
  }
}, IC = (n) => (e) => typeof e == "string" && e.startsWith(n), NC = /* @__PURE__ */ IC("--"), tU = /* @__PURE__ */ IC("var(--"), Qy = (n) => tU(n) ? nU.test(n.split("/*")[0].trim()) : !1, nU = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function YS(n) {
  return typeof n != "string" ? !1 : n.split("/*")[0].includes("var(--");
}
const sl = {
  test: (n) => typeof n == "number",
  parse: parseFloat,
  transform: (n) => n
}, gc = {
  ...sl,
  transform: (n) => Oi(0, 1, n)
}, Gu = {
  ...sl,
  default: 1
}, Jl = (n) => Math.round(n * 1e5) / 1e5, Zy = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function rU(n) {
  return n == null;
}
const iU = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Xy = (n, e) => (t) => !!(typeof t == "string" && iU.test(t) && t.startsWith(n) || e && !rU(t) && Object.prototype.hasOwnProperty.call(t, e)), PC = (n, e, t) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, s, o, a] = r.match(Zy);
  return {
    [n]: parseFloat(i),
    [e]: parseFloat(s),
    [t]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, sU = (n) => Oi(0, 255, n), Gp = {
  ...sl,
  transform: (n) => Math.round(sU(n))
}, Mo = {
  test: /* @__PURE__ */ Xy("rgb", "red"),
  parse: /* @__PURE__ */ PC("red", "green", "blue"),
  transform: ({ red: n, green: e, blue: t, alpha: r = 1 }) => "rgba(" + Gp.transform(n) + ", " + Gp.transform(e) + ", " + Gp.transform(t) + ", " + Jl(gc.transform(r)) + ")"
};
function oU(n) {
  let e = "", t = "", r = "", i = "";
  return n.length > 5 ? (e = n.substring(1, 3), t = n.substring(3, 5), r = n.substring(5, 7), i = n.substring(7, 9)) : (e = n.substring(1, 2), t = n.substring(2, 3), r = n.substring(3, 4), i = n.substring(4, 5), e += e, t += t, r += r, i += i), {
    red: parseInt(e, 16),
    green: parseInt(t, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const lg = {
  test: /* @__PURE__ */ Xy("#"),
  parse: oU,
  transform: Mo.transform
}, Uc = /* @__NO_SIDE_EFFECTS__ */ (n) => ({
  test: (e) => typeof e == "string" && e.endsWith(n) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${n}`
}), Ms = /* @__PURE__ */ Uc("deg"), Mi = /* @__PURE__ */ Uc("%"), Ae = /* @__PURE__ */ Uc("px"), aU = /* @__PURE__ */ Uc("vh"), lU = /* @__PURE__ */ Uc("vw"), qS = {
  ...Mi,
  parse: (n) => Mi.parse(n) / 100,
  transform: (n) => Mi.transform(n * 100)
}, Na = {
  test: /* @__PURE__ */ Xy("hsl", "hue"),
  parse: /* @__PURE__ */ PC("hue", "saturation", "lightness"),
  transform: ({ hue: n, saturation: e, lightness: t, alpha: r = 1 }) => "hsla(" + Math.round(n) + ", " + Mi.transform(Jl(e)) + ", " + Mi.transform(Jl(t)) + ", " + Jl(gc.transform(r)) + ")"
}, rn = {
  test: (n) => Mo.test(n) || lg.test(n) || Na.test(n),
  parse: (n) => Mo.test(n) ? Mo.parse(n) : Na.test(n) ? Na.parse(n) : lg.parse(n),
  transform: (n) => typeof n == "string" ? n : n.hasOwnProperty("red") ? Mo.transform(n) : Na.transform(n),
  getAnimatableNone: (n) => {
    const e = rn.parse(n);
    return e.alpha = 0, rn.transform(e);
  }
}, cU = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function uU(n) {
  var e, t;
  return isNaN(n) && typeof n == "string" && (((e = n.match(Zy)) == null ? void 0 : e.length) || 0) + (((t = n.match(cU)) == null ? void 0 : t.length) || 0) > 0;
}
const LC = "number", BC = "color", dU = "var", fU = "var(", KS = "${}", hU = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function yc(n) {
  const e = n.toString(), t = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let s = 0;
  const a = e.replace(hU, (c) => (rn.test(c) ? (r.color.push(s), i.push(BC), t.push(rn.parse(c))) : c.startsWith(fU) ? (r.var.push(s), i.push(dU), t.push(c)) : (r.number.push(s), i.push(LC), t.push(parseFloat(c))), ++s, KS)).split(KS);
  return { values: t, split: a, indexes: r, types: i };
}
function jC(n) {
  return yc(n).values;
}
function FC(n) {
  const { split: e, types: t } = yc(n), r = e.length;
  return (i) => {
    let s = "";
    for (let o = 0; o < r; o++)
      if (s += e[o], i[o] !== void 0) {
        const a = t[o];
        a === LC ? s += Jl(i[o]) : a === BC ? s += rn.transform(i[o]) : s += i[o];
      }
    return s;
  };
}
const pU = (n) => typeof n == "number" ? 0 : rn.test(n) ? rn.getAnimatableNone(n) : n;
function mU(n) {
  const e = jC(n);
  return FC(n)(e.map(pU));
}
const Xs = {
  test: uU,
  parse: jC,
  createTransformer: FC,
  getAnimatableNone: mU
};
function Yp(n, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? n + (e - n) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? n + (e - n) * (2 / 3 - t) * 6 : n;
}
function gU({ hue: n, saturation: e, lightness: t, alpha: r }) {
  n /= 360, e /= 100, t /= 100;
  let i = 0, s = 0, o = 0;
  if (!e)
    i = s = o = t;
  else {
    const a = t < 0.5 ? t * (1 + e) : t + e - t * e, c = 2 * t - a;
    i = Yp(c, a, n + 1 / 3), s = Yp(c, a, n), o = Yp(c, a, n - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function Wd(n, e) {
  return (t) => t > 0 ? e : n;
}
const Lt = (n, e, t) => n + (e - n) * t, qp = (n, e, t) => {
  const r = n * n, i = t * (e * e - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, yU = [lg, Mo, Na], vU = (n) => yU.find((e) => e.test(n));
function JS(n) {
  const e = vU(n);
  if (il(!!e, `'${n}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let t = e.parse(n);
  return e === Na && (t = gU(t)), t;
}
const QS = (n, e) => {
  const t = JS(n), r = JS(e);
  if (!t || !r)
    return Wd(n, e);
  const i = { ...t };
  return (s) => (i.red = qp(t.red, r.red, s), i.green = qp(t.green, r.green, s), i.blue = qp(t.blue, r.blue, s), i.alpha = Lt(t.alpha, r.alpha, s), Mo.transform(i));
}, cg = /* @__PURE__ */ new Set(["none", "hidden"]);
function bU(n, e) {
  return cg.has(n) ? (t) => t <= 0 ? n : e : (t) => t >= 1 ? e : n;
}
function xU(n, e) {
  return (t) => Lt(n, e, t);
}
function ev(n) {
  return typeof n == "number" ? xU : typeof n == "string" ? Qy(n) ? Wd : rn.test(n) ? QS : EU : Array.isArray(n) ? zC : typeof n == "object" ? rn.test(n) ? QS : SU : Wd;
}
function zC(n, e) {
  const t = [...n], r = t.length, i = n.map((s, o) => ev(s)(s, e[o]));
  return (s) => {
    for (let o = 0; o < r; o++)
      t[o] = i[o](s);
    return t;
  };
}
function SU(n, e) {
  const t = { ...n, ...e }, r = {};
  for (const i in t)
    n[i] !== void 0 && e[i] !== void 0 && (r[i] = ev(n[i])(n[i], e[i]));
  return (i) => {
    for (const s in r)
      t[s] = r[s](i);
    return t;
  };
}
function wU(n, e) {
  const t = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const s = e.types[i], o = n.indexes[s][r[s]], a = n.values[o] ?? 0;
    t[i] = a, r[s]++;
  }
  return t;
}
const EU = (n, e) => {
  const t = Xs.createTransformer(e), r = yc(n), i = yc(e);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? cg.has(n) && !i.values.length || cg.has(e) && !r.values.length ? bU(n, e) : Hc(zC(wU(r, i), i.values), t) : (il(!0, `Complex values '${n}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Wd(n, e));
};
function VC(n, e, t) {
  return typeof n == "number" && typeof e == "number" && typeof t == "number" ? Lt(n, e, t) : ev(n)(n, e);
}
const AU = (n) => {
  const e = ({ timestamp: t }) => n(t);
  return {
    start: (t = !0) => Dt.update(e, t),
    stop: () => cs(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Mn.isProcessing ? Mn.timestamp : Qn.now()
  };
}, HC = (n, e, t = 10) => {
  let r = "";
  const i = Math.max(Math.round(e / t), 2);
  for (let s = 0; s < i; s++)
    r += Math.round(n(s / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Ud = 2e4;
function tv(n) {
  let e = 0;
  const t = 50;
  let r = n.next(e);
  for (; !r.done && e < Ud; )
    e += t, r = n.next(e);
  return e >= Ud ? 1 / 0 : e;
}
function WC(n, e = 100, t) {
  const r = t({ ...n, keyframes: [0, e] }), i = Math.min(tv(r), Ud);
  return {
    type: "keyframes",
    ease: (s) => r.next(i * s).value / e,
    duration: /* @__PURE__ */ Kr(i)
  };
}
const TU = 5;
function UC(n, e, t) {
  const r = Math.max(e - TU, 0);
  return bC(t - n(r), e - r);
}
const zt = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Kp = 1e-3;
function CU({ duration: n = zt.duration, bounce: e = zt.bounce, velocity: t = zt.velocity, mass: r = zt.mass }) {
  let i, s;
  il(n <= /* @__PURE__ */ fi(zt.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - e;
  o = Oi(zt.minDamping, zt.maxDamping, o), n = Oi(zt.minDuration, zt.maxDuration, /* @__PURE__ */ Kr(n)), o < 1 ? (i = (u) => {
    const f = u * o, h = f * n, p = f - t, g = ug(u, o), y = Math.exp(-h);
    return Kp - p / g * y;
  }, s = (u) => {
    const h = u * o * n, p = h * t + t, g = Math.pow(o, 2) * Math.pow(u, 2) * n, y = Math.exp(-h), x = ug(Math.pow(u, 2), o);
    return (-i(u) + Kp > 0 ? -1 : 1) * ((p - g) * y) / x;
  }) : (i = (u) => {
    const f = Math.exp(-u * n), h = (u - t) * n + 1;
    return -Kp + f * h;
  }, s = (u) => {
    const f = Math.exp(-u * n), h = (t - u) * (n * n);
    return f * h;
  });
  const a = 5 / n, c = RU(i, s, a);
  if (n = /* @__PURE__ */ fi(n), isNaN(c))
    return {
      stiffness: zt.stiffness,
      damping: zt.damping,
      duration: n
    };
  {
    const u = Math.pow(c, 2) * r;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(r * u),
      duration: n
    };
  }
}
const DU = 12;
function RU(n, e, t) {
  let r = t;
  for (let i = 1; i < DU; i++)
    r = r - n(r) / e(r);
  return r;
}
function ug(n, e) {
  return n * Math.sqrt(1 - e * e);
}
const kU = ["duration", "bounce"], MU = ["stiffness", "damping", "mass"];
function ZS(n, e) {
  return e.some((t) => n[t] !== void 0);
}
function _U(n) {
  let e = {
    velocity: zt.velocity,
    stiffness: zt.stiffness,
    damping: zt.damping,
    mass: zt.mass,
    isResolvedFromDuration: !1,
    ...n
  };
  if (!ZS(n, MU) && ZS(n, kU))
    if (n.visualDuration) {
      const t = n.visualDuration, r = 2 * Math.PI / (t * 1.2), i = r * r, s = 2 * Oi(0.05, 1, 1 - (n.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: zt.mass,
        stiffness: i,
        damping: s
      };
    } else {
      const t = CU(n);
      e = {
        ...e,
        ...t,
        mass: zt.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function vc(n = zt.visualDuration, e = zt.bounce) {
  const t = typeof n != "object" ? {
    visualDuration: n,
    keyframes: [0, 1],
    bounce: e
  } : n;
  let { restSpeed: r, restDelta: i } = t;
  const s = t.keyframes[0], o = t.keyframes[t.keyframes.length - 1], a = { done: !1, value: s }, { stiffness: c, damping: u, mass: f, duration: h, velocity: p, isResolvedFromDuration: g } = _U({
    ...t,
    velocity: -/* @__PURE__ */ Kr(t.velocity || 0)
  }), y = p || 0, x = u / (2 * Math.sqrt(c * f)), S = o - s, w = /* @__PURE__ */ Kr(Math.sqrt(c / f)), C = Math.abs(S) < 5;
  r || (r = C ? zt.restSpeed.granular : zt.restSpeed.default), i || (i = C ? zt.restDelta.granular : zt.restDelta.default);
  let T;
  if (x < 1) {
    const R = ug(w, x);
    T = (P) => {
      const L = Math.exp(-x * w * P);
      return o - L * ((y + x * w * S) / R * Math.sin(R * P) + S * Math.cos(R * P));
    };
  } else if (x === 1)
    T = (R) => o - Math.exp(-w * R) * (S + (y + w * S) * R);
  else {
    const R = w * Math.sqrt(x * x - 1);
    T = (P) => {
      const L = Math.exp(-x * w * P), B = Math.min(R * P, 300);
      return o - L * ((y + x * w * S) * Math.sinh(B) + R * S * Math.cosh(B)) / R;
    };
  }
  const k = {
    calculatedDuration: g && h || null,
    next: (R) => {
      const P = T(R);
      if (g)
        a.done = R >= h;
      else {
        let L = R === 0 ? y : 0;
        x < 1 && (L = R === 0 ? /* @__PURE__ */ fi(y) : UC(T, R, P));
        const B = Math.abs(L) <= r, W = Math.abs(o - P) <= i;
        a.done = B && W;
      }
      return a.value = a.done ? o : P, a;
    },
    toString: () => {
      const R = Math.min(tv(k), Ud), P = HC((L) => k.next(R * L).value, R, 30);
      return R + "ms " + P;
    },
    toTransition: () => {
    }
  };
  return k;
}
vc.applyToOptions = (n) => {
  const e = WC(n, 100, vc);
  return n.ease = e.ease, n.duration = /* @__PURE__ */ fi(e.duration), n.type = "keyframes", n;
};
function dg({ keyframes: n, velocity: e = 0, power: t = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: s = 500, modifyTarget: o, min: a, max: c, restDelta: u = 0.5, restSpeed: f }) {
  const h = n[0], p = {
    done: !1,
    value: h
  }, g = (B) => a !== void 0 && B < a || c !== void 0 && B > c, y = (B) => a === void 0 ? c : c === void 0 || Math.abs(a - B) < Math.abs(c - B) ? a : c;
  let x = t * e;
  const S = h + x, w = o === void 0 ? S : o(S);
  w !== S && (x = w - h);
  const C = (B) => -x * Math.exp(-B / r), T = (B) => w + C(B), k = (B) => {
    const W = C(B), X = T(B);
    p.done = Math.abs(W) <= u, p.value = p.done ? w : X;
  };
  let R, P;
  const L = (B) => {
    g(p.value) && (R = B, P = vc({
      keyframes: [p.value, y(p.value)],
      velocity: UC(T, B, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: s,
      restDelta: u,
      restSpeed: f
    }));
  };
  return L(0), {
    calculatedDuration: null,
    next: (B) => {
      let W = !1;
      return !P && R === void 0 && (W = !0, k(B), L(B)), R !== void 0 && B >= R ? P.next(B - R) : (!W && k(B), p);
    }
  };
}
function OU(n, e, t) {
  const r = [], i = t || ls.mix || VC, s = n.length - 1;
  for (let o = 0; o < s; o++) {
    let a = i(n[o], n[o + 1]);
    if (e) {
      const c = Array.isArray(e) ? e[o] || Jr : e;
      a = Hc(c, a);
    }
    r.push(a);
  }
  return r;
}
function $C(n, e, { clamp: t = !0, ease: r, mixer: i } = {}) {
  const s = n.length;
  if (mi(s === e.length, "Both input and output ranges must be the same length", "range-length"), s === 1)
    return () => e[0];
  if (s === 2 && e[0] === e[1])
    return () => e[1];
  const o = n[0] === n[1];
  n[0] > n[s - 1] && (n = [...n].reverse(), e = [...e].reverse());
  const a = OU(e, r, i), c = a.length, u = (f) => {
    if (o && f < n[0])
      return e[0];
    let h = 0;
    if (c > 1)
      for (; h < n.length - 2 && !(f < n[h + 1]); h++)
        ;
    const p = /* @__PURE__ */ Qa(n[h], n[h + 1], f);
    return a[h](p);
  };
  return t ? (f) => u(Oi(n[0], n[s - 1], f)) : u;
}
function GC(n, e) {
  const t = n[n.length - 1];
  for (let r = 1; r <= e; r++) {
    const i = /* @__PURE__ */ Qa(0, e, r);
    n.push(Lt(t, 1, i));
  }
}
function YC(n) {
  const e = [0];
  return GC(e, n.length - 1), e;
}
function IU(n, e) {
  return n.map((t) => t * e);
}
function NU(n, e) {
  return n.map(() => e || RC).splice(0, n.length - 1);
}
function Pa({ duration: n = 300, keyframes: e, times: t, ease: r = "easeInOut" }) {
  const i = kC(r) ? r.map(GS) : GS(r), s = {
    done: !1,
    value: e[0]
  }, o = IU(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    t && t.length === e.length ? t : YC(e),
    n
  ), a = $C(o, e, {
    ease: Array.isArray(i) ? i : NU(e, i)
  });
  return {
    calculatedDuration: n,
    next: (c) => (s.value = a(c), s.done = c >= n, s)
  };
}
const PU = (n) => n !== null;
function nv(n, { repeat: e, repeatType: t = "loop" }, r, i = 1) {
  const s = n.filter(PU), a = i < 0 || e && t !== "loop" && e % 2 === 1 ? 0 : s.length - 1;
  return !a || r === void 0 ? s[a] : r;
}
const LU = {
  decay: dg,
  inertia: dg,
  tween: Pa,
  keyframes: Pa,
  spring: vc
};
function qC(n) {
  typeof n.type == "string" && (n.type = LU[n.type]);
}
class rv {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, t) {
    return this.finished.then(e, t);
  }
}
const BU = (n) => n / 100;
class iv extends rv {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, i;
      const { motionValue: t } = this.options;
      t && t.updatedAt !== Qn.now() && this.tick(Qn.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (i = (r = this.options).onStop) == null || i.call(r));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    qC(e);
    const { type: t = Pa, repeat: r = 0, repeatDelay: i = 0, repeatType: s, velocity: o = 0 } = e;
    let { keyframes: a } = e;
    const c = t || Pa;
    process.env.NODE_ENV !== "production" && c !== Pa && mi(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), c !== Pa && typeof a[0] != "number" && (this.mixKeyframes = Hc(BU, VC(a[0], a[1])), a = [0, 100]);
    const u = c({ ...e, keyframes: a });
    s === "mirror" && (this.mirroredGenerator = c({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = tv(u));
    const { calculatedDuration: f } = u;
    this.calculatedDuration = f, this.resolvedDuration = f + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = u;
  }
  updateTime(e) {
    const t = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = t;
  }
  tick(e, t = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: s, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: c } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: f, repeat: h, repeatType: p, repeatDelay: g, type: y, onUpdate: x, finalKeyframe: S } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - i / this.speed, this.startTime)), t ? this.currentTime = e : this.updateTime(e);
    const w = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), C = this.playbackSpeed >= 0 ? w < 0 : w > i;
    this.currentTime = Math.max(w, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let T = this.currentTime, k = r;
    if (h) {
      const B = Math.min(this.currentTime, i) / a;
      let W = Math.floor(B), X = B % 1;
      !X && B >= 1 && (X = 1), X === 1 && W--, W = Math.min(W, h + 1), !!(W % 2) && (p === "reverse" ? (X = 1 - X, g && (X -= g / a)) : p === "mirror" && (k = o)), T = Oi(0, 1, X) * a;
    }
    const R = C ? { done: !1, value: f[0] } : k.next(T);
    s && (R.value = s(R.value));
    let { done: P } = R;
    !C && c !== null && (P = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const L = this.holdTime === null && (this.state === "finished" || this.state === "running" && P);
    return L && y !== dg && (R.value = nv(f, this.options, S, this.speed)), x && x(R.value), L && this.finish(), R;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, t) {
    return this.finished.then(e, t);
  }
  get duration() {
    return /* @__PURE__ */ Kr(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Kr(e);
  }
  get time() {
    return /* @__PURE__ */ Kr(this.currentTime);
  }
  set time(e) {
    var t;
    e = /* @__PURE__ */ fi(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (t = this.driver) == null || t.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(Qn.now());
    const t = this.playbackSpeed !== e;
    this.playbackSpeed = e, t && (this.time = /* @__PURE__ */ Kr(this.currentTime));
  }
  play() {
    var i, s;
    if (this.isStopped)
      return;
    const { driver: e = AU, startTime: t } = this.options;
    this.driver || (this.driver = e((o) => this.tick(o))), (s = (i = this.options).onPlay) == null || s.call(i);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = t ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Qn.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, t;
    this.notifyFinished(), this.teardown(), this.state = "finished", (t = (e = this.options).onComplete) == null || t.call(e);
  }
  cancel() {
    var e, t;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (t = (e = this.options).onCancel) == null || t.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var t;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (t = this.driver) == null || t.stop(), e.observe(this);
  }
}
function jU(n) {
  for (let e = 1; e < n.length; e++)
    n[e] ?? (n[e] = n[e - 1]);
}
const _o = (n) => n * 180 / Math.PI, fg = (n) => {
  const e = _o(Math.atan2(n[1], n[0]));
  return hg(e);
}, FU = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (n) => (Math.abs(n[0]) + Math.abs(n[3])) / 2,
  rotate: fg,
  rotateZ: fg,
  skewX: (n) => _o(Math.atan(n[1])),
  skewY: (n) => _o(Math.atan(n[2])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[2])) / 2
}, hg = (n) => (n = n % 360, n < 0 && (n += 360), n), XS = fg, ew = (n) => Math.sqrt(n[0] * n[0] + n[1] * n[1]), tw = (n) => Math.sqrt(n[4] * n[4] + n[5] * n[5]), zU = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: ew,
  scaleY: tw,
  scale: (n) => (ew(n) + tw(n)) / 2,
  rotateX: (n) => hg(_o(Math.atan2(n[6], n[5]))),
  rotateY: (n) => hg(_o(Math.atan2(-n[2], n[0]))),
  rotateZ: XS,
  rotate: XS,
  skewX: (n) => _o(Math.atan(n[4])),
  skewY: (n) => _o(Math.atan(n[1])),
  skew: (n) => (Math.abs(n[1]) + Math.abs(n[4])) / 2
};
function pg(n) {
  return n.includes("scale") ? 1 : 0;
}
function mg(n, e) {
  if (!n || n === "none")
    return pg(e);
  const t = n.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (t)
    r = zU, i = t;
  else {
    const a = n.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = FU, i = a;
  }
  if (!i)
    return pg(e);
  const s = r[e], o = i[1].split(",").map(HU);
  return typeof s == "function" ? s(o) : o[s];
}
const VU = (n, e) => {
  const { transform: t = "none" } = getComputedStyle(n);
  return mg(t, e);
};
function HU(n) {
  return parseFloat(n.trim());
}
const ol = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], al = new Set(ol), nw = (n) => n === sl || n === Ae, WU = /* @__PURE__ */ new Set(["x", "y", "z"]), UU = ol.filter((n) => !WU.has(n));
function $U(n) {
  const e = [];
  return UU.forEach((t) => {
    const r = n.getValue(t);
    r !== void 0 && (e.push([t, r.get()]), r.set(t.startsWith("scale") ? 1 : 0));
  }), e;
}
const zs = {
  // Dimensions
  width: ({ x: n }, { paddingLeft: e = "0", paddingRight: t = "0" }) => n.max - n.min - parseFloat(e) - parseFloat(t),
  height: ({ y: n }, { paddingTop: e = "0", paddingBottom: t = "0" }) => n.max - n.min - parseFloat(e) - parseFloat(t),
  top: (n, { top: e }) => parseFloat(e),
  left: (n, { left: e }) => parseFloat(e),
  bottom: ({ y: n }, { top: e }) => parseFloat(e) + (n.max - n.min),
  right: ({ x: n }, { left: e }) => parseFloat(e) + (n.max - n.min),
  // Transform
  x: (n, { transform: e }) => mg(e, "x"),
  y: (n, { transform: e }) => mg(e, "y")
};
zs.translateX = zs.x;
zs.translateY = zs.y;
const Bo = /* @__PURE__ */ new Set();
let gg = !1, yg = !1, vg = !1;
function KC() {
  if (yg) {
    const n = Array.from(Bo).filter((r) => r.needsMeasurement), e = new Set(n.map((r) => r.element)), t = /* @__PURE__ */ new Map();
    e.forEach((r) => {
      const i = $U(r);
      i.length && (t.set(r, i), r.render());
    }), n.forEach((r) => r.measureInitialState()), e.forEach((r) => {
      r.render();
      const i = t.get(r);
      i && i.forEach(([s, o]) => {
        var a;
        (a = r.getValue(s)) == null || a.set(o);
      });
    }), n.forEach((r) => r.measureEndState()), n.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  yg = !1, gg = !1, Bo.forEach((n) => n.complete(vg)), Bo.clear();
}
function JC() {
  Bo.forEach((n) => {
    n.readKeyframes(), n.needsMeasurement && (yg = !0);
  });
}
function GU() {
  vg = !0, JC(), KC(), vg = !1;
}
class sv {
  constructor(e, t, r, i, s, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = t, this.name = r, this.motionValue = i, this.element = s, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Bo.add(this), gg || (gg = !0, Dt.read(JC), Dt.resolveKeyframes(KC))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: t, element: r, motionValue: i } = this;
    if (e[0] === null) {
      const s = i == null ? void 0 : i.get(), o = e[e.length - 1];
      if (s !== void 0)
        e[0] = s;
      else if (r && t) {
        const a = r.readValue(t, o);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = o), i && s === void 0 && i.set(e[0]);
    }
    jU(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Bo.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Bo.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const YU = (n) => n.startsWith("--");
function qU(n, e, t) {
  YU(e) ? n.style.setProperty(e, t) : n.style[e] = t;
}
const KU = /* @__PURE__ */ Yy(() => window.ScrollTimeline !== void 0), JU = {};
function QU(n, e) {
  const t = /* @__PURE__ */ Yy(n);
  return () => JU[e] ?? t();
}
const QC = /* @__PURE__ */ QU(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), zl = ([n, e, t, r]) => `cubic-bezier(${n}, ${e}, ${t}, ${r})`, rw = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ zl([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ zl([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ zl([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ zl([0.33, 1.53, 0.69, 0.99])
};
function ZC(n, e) {
  if (n)
    return typeof n == "function" ? QC() ? HC(n, e) : "ease-out" : _C(n) ? zl(n) : Array.isArray(n) ? n.map((t) => ZC(t, e) || rw.easeOut) : rw[n];
}
function ZU(n, e, t, { delay: r = 0, duration: i = 300, repeat: s = 0, repeatType: o = "loop", ease: a = "easeOut", times: c } = {}, u = void 0) {
  const f = {
    [e]: t
  };
  c && (f.offset = c);
  const h = ZC(a, i);
  Array.isArray(h) && (f.easing = h);
  const p = {
    delay: r,
    duration: i,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: s + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (p.pseudoElement = u), n.animate(f, p);
}
function ov(n) {
  return typeof n == "function" && "applyToOptions" in n;
}
function XU({ type: n, ...e }) {
  return ov(n) && QC() ? n.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class e3 extends rv {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !e)
      return;
    const { element: t, name: r, keyframes: i, pseudoElement: s, allowFlatten: o = !1, finalKeyframe: a, onComplete: c } = e;
    this.isPseudoElement = !!s, this.allowFlatten = o, this.options = e, mi(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = XU(e);
    this.animation = ZU(t, r, i, u, s), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !s) {
        const f = nv(i, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(f) : qU(t, r, f), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, t;
    (t = (e = this.animation).finish) == null || t.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, t;
    this.isPseudoElement || (t = (e = this.animation).commitStyles) == null || t.call(e);
  }
  get duration() {
    var t, r;
    const e = ((r = (t = this.animation.effect) == null ? void 0 : t.getComputedTiming) == null ? void 0 : r.call(t).duration) || 0;
    return /* @__PURE__ */ Kr(Number(e));
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ Kr(e);
  }
  get time() {
    return /* @__PURE__ */ Kr(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ fi(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(e) {
    this.manualStartTime = this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, observe: t }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && KU() ? (this.animation.timeline = e, Jr) : t(this);
  }
}
const XC = {
  anticipate: TC,
  backInOut: AC,
  circInOut: DC
};
function t3(n) {
  return n in XC;
}
function n3(n) {
  typeof n.ease == "string" && t3(n.ease) && (n.ease = XC[n.ease]);
}
const Jp = 10;
class r3 extends e3 {
  constructor(e) {
    n3(e), qC(e), super(e), e.startTime !== void 0 && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: t, onUpdate: r, onComplete: i, element: s, ...o } = this.options;
    if (!t)
      return;
    if (e !== void 0) {
      t.set(e);
      return;
    }
    const a = new iv({
      ...o,
      autoplay: !1
    }), c = Math.max(Jp, Qn.now() - this.startTime), u = Oi(0, Jp, c - Jp);
    t.setWithVelocity(a.sample(Math.max(0, c - u)).value, a.sample(c).value, u), a.stop();
  }
}
const iw = (n, e) => e === "zIndex" ? !1 : !!(typeof n == "number" || Array.isArray(n) || typeof n == "string" && // It's animatable if we have a string
(Xs.test(n) || n === "0") && // And it contains numbers and/or colors
!n.startsWith("url("));
function i3(n) {
  const e = n[0];
  if (n.length === 1)
    return !0;
  for (let t = 0; t < n.length; t++)
    if (n[t] !== e)
      return !0;
}
function s3(n, e, t, r) {
  const i = n[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const s = n[n.length - 1], o = iw(i, e), a = iw(s, e);
  return il(o === a, `You are trying to animate ${e} from "${i}" to "${s}". "${o ? s : i}" is not an animatable value.`, "value-not-animatable"), !o || !a ? !1 : i3(n) || (t === "spring" || ov(t)) && r;
}
function bg(n) {
  n.duration = 0, n.type = "keyframes";
}
const o3 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), a3 = /* @__PURE__ */ Yy(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function l3(n) {
  var f;
  const { motionValue: e, name: t, repeatDelay: r, repeatType: i, damping: s, type: o } = n;
  if (!(((f = e == null ? void 0 : e.owner) == null ? void 0 : f.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: c, transformTemplate: u } = e.owner.getProps();
  return a3() && t && o3.has(t) && (t !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !r && i !== "mirror" && s !== 0 && o !== "inertia";
}
const c3 = 40;
class u3 extends rv {
  constructor({ autoplay: e = !0, delay: t = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: s = 0, repeatType: o = "loop", keyframes: a, name: c, motionValue: u, element: f, ...h }) {
    var y;
    super(), this.stop = () => {
      var x, S;
      this._animation && (this._animation.stop(), (x = this.stopTimeline) == null || x.call(this)), (S = this.keyframeResolver) == null || S.cancel();
    }, this.createdAt = Qn.now();
    const p = {
      autoplay: e,
      delay: t,
      type: r,
      repeat: i,
      repeatDelay: s,
      repeatType: o,
      name: c,
      motionValue: u,
      element: f,
      ...h
    }, g = (f == null ? void 0 : f.KeyframeResolver) || sv;
    this.keyframeResolver = new g(a, (x, S, w) => this.onKeyframesResolved(x, S, p, !w), c, u, f), (y = this.keyframeResolver) == null || y.scheduleResolve();
  }
  onKeyframesResolved(e, t, r, i) {
    var S, w;
    this.keyframeResolver = void 0;
    const { name: s, type: o, velocity: a, delay: c, isHandoff: u, onUpdate: f } = r;
    this.resolvedAt = Qn.now(), s3(e, s, o, a) || ((ls.instantAnimations || !c) && (f == null || f(nv(e, r, t))), e[0] = e[e.length - 1], bg(r), r.repeat = 0);
    const p = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > c3 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: t,
      ...r,
      keyframes: e
    }, g = !u && l3(p), y = (w = (S = p.motionValue) == null ? void 0 : S.owner) == null ? void 0 : w.current, x = g ? new r3({
      ...p,
      element: y
    }) : new iv(p);
    x.finished.then(() => {
      this.notifyFinished();
    }).catch(Jr), this.pendingTimeline && (this.stopTimeline = x.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = x;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, t) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), GU()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
class d3 {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => e.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, t) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][e] = t;
  }
  attachTimeline(e) {
    const t = this.animations.map((r) => r.attachTimeline(e));
    return () => {
      t.forEach((r, i) => {
        r && r(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    return sw(this.animations, "duration");
  }
  get iterationDuration() {
    return sw(this.animations, "iterationDuration");
  }
  runAll(e) {
    this.animations.forEach((t) => t[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function sw(n, e) {
  let t = 0;
  for (let r = 0; r < n.length; r++) {
    const i = n[r][e];
    i !== null && i > t && (t = i);
  }
  return t;
}
class f3 extends d3 {
  then(e, t) {
    return this.finished.finally(e).then(() => {
    });
  }
}
function eD(n, e, t, r = 0, i = 1) {
  const s = Array.from(n).sort((u, f) => u.sortNodePosition(f)).indexOf(e), o = n.size, a = (o - 1) * r;
  return typeof t == "function" ? t(s, o) : i === 1 ? s * r : a - s * r;
}
const h3 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function p3(n) {
  const e = h3.exec(n);
  if (!e)
    return [,];
  const [, t, r, i] = e;
  return [`--${t ?? r}`, i];
}
const m3 = 4;
function tD(n, e, t = 1) {
  mi(t <= m3, `Max CSS variable fallback depth detected in property "${n}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, i] = p3(n);
  if (!r)
    return;
  const s = window.getComputedStyle(e).getPropertyValue(r);
  if (s) {
    const o = s.trim();
    return gC(o) ? parseFloat(o) : o;
  }
  return Qy(i) ? tD(i, e, t + 1) : i;
}
const g3 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, y3 = (n) => ({
  type: "spring",
  stiffness: 550,
  damping: n === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), v3 = {
  type: "keyframes",
  duration: 0.8
}, b3 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, x3 = (n, { keyframes: e }) => e.length > 2 ? v3 : al.has(n) ? n.startsWith("scale") ? y3(e[1]) : g3 : b3, S3 = (n) => n !== null;
function w3(n, { repeat: e, repeatType: t = "loop" }, r) {
  const i = n.filter(S3), s = e && t !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return i[s];
}
function av(n, e) {
  return (n == null ? void 0 : n[e]) ?? (n == null ? void 0 : n.default) ?? n;
}
function E3({ when: n, delay: e, delayChildren: t, staggerChildren: r, staggerDirection: i, repeat: s, repeatType: o, repeatDelay: a, from: c, elapsed: u, ...f }) {
  return !!Object.keys(f).length;
}
const lv = (n, e, t, r = {}, i, s) => (o) => {
  const a = av(r, n) || {}, c = a.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ fi(c);
  const f = {
    keyframes: Array.isArray(t) ? t : [null, t],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (p) => {
      e.set(p), a.onUpdate && a.onUpdate(p);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: n,
    motionValue: e,
    element: s ? void 0 : i
  };
  E3(a) || Object.assign(f, x3(n, f)), f.duration && (f.duration = /* @__PURE__ */ fi(f.duration)), f.repeatDelay && (f.repeatDelay = /* @__PURE__ */ fi(f.repeatDelay)), f.from !== void 0 && (f.keyframes[0] = f.from);
  let h = !1;
  if ((f.type === !1 || f.duration === 0 && !f.repeatDelay) && (bg(f), f.delay === 0 && (h = !0)), (ls.instantAnimations || ls.skipAnimations) && (h = !0, bg(f), f.delay = 0), f.allowFlatten = !a.type && !a.ease, h && !s && e.get() !== void 0) {
    const p = w3(f.keyframes, a);
    if (p !== void 0) {
      Dt.update(() => {
        f.onUpdate(p), f.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new iv(f) : new u3(f);
};
function ow(n) {
  const e = [{}, {}];
  return n == null || n.values.forEach((t, r) => {
    e[0][r] = t.get(), e[1][r] = t.getVelocity();
  }), e;
}
function cv(n, e, t, r) {
  if (typeof e == "function") {
    const [i, s] = ow(r);
    e = e(t !== void 0 ? t : n.custom, i, s);
  }
  if (typeof e == "string" && (e = n.variants && n.variants[e]), typeof e == "function") {
    const [i, s] = ow(r);
    e = e(t !== void 0 ? t : n.custom, i, s);
  }
  return e;
}
function Ua(n, e, t) {
  const r = n.getProps();
  return cv(r, e, t !== void 0 ? t : r.custom, n);
}
const nD = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...ol
]), aw = 30, A3 = (n) => !isNaN(parseFloat(n)), Ql = {
  current: void 0
};
class T3 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, t = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var s;
      const i = Qn.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((s = this.events.change) == null || s.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = t.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = Qn.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = A3(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && Yf(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, t) {
    this.events[e] || (this.events[e] = new qy());
    const r = this.events[e].add(t);
    return e === "change" ? () => {
      r(), Dt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, t) {
    this.passiveEffect = e, this.stopPassiveEffect = t;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, t, r) {
    this.set(t), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, t = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, t && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return Ql.current && Ql.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = Qn.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > aw)
      return 0;
    const t = Math.min(this.updatedAt - this.prevUpdatedAt, aw);
    return bC(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((t) => {
      this.hasAnimated = !0, this.animation = e(t), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, t;
    (e = this.dependents) == null || e.clear(), (t = this.events.destroy) == null || t.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function $o(n, e) {
  return new T3(n, e);
}
const xg = (n) => Array.isArray(n);
function C3(n, e, t) {
  n.hasValue(e) ? n.getValue(e).set(t) : n.addValue(e, $o(t));
}
function D3(n) {
  return xg(n) ? n[n.length - 1] || 0 : n;
}
function R3(n, e) {
  const t = Ua(n, e);
  let { transitionEnd: r = {}, transition: i = {}, ...s } = t || {};
  s = { ...s, ...r };
  for (const o in s) {
    const a = D3(s[o]);
    C3(n, o, a);
  }
}
const gn = (n) => !!(n && n.getVelocity);
function k3(n) {
  return !!(gn(n) && n.add);
}
function Sg(n, e) {
  const t = n.getValue("willChange");
  if (k3(t))
    return t.add(e);
  if (!t && ls.WillChange) {
    const r = new ls.WillChange("auto");
    n.addValue("willChange", r), r.add(e);
  }
}
function uv(n) {
  return n.replace(/([A-Z])/g, (e) => `-${e.toLowerCase()}`);
}
const M3 = "framerAppearId", rD = "data-" + uv(M3);
function iD(n) {
  return n.props[rD];
}
function _3({ protectedKeys: n, needsAnimating: e }, t) {
  const r = n.hasOwnProperty(t) && e[t] !== !0;
  return e[t] = !1, r;
}
function dv(n, e, { delay: t = 0, transitionOverride: r, type: i } = {}) {
  let { transition: s = n.getDefaultTransition(), transitionEnd: o, ...a } = e;
  const c = s == null ? void 0 : s.reduceMotion;
  r && (s = r);
  const u = [], f = i && n.animationState && n.animationState.getState()[i];
  for (const h in a) {
    const p = n.getValue(h, n.latestValues[h] ?? null), g = a[h];
    if (g === void 0 || f && _3(f, h))
      continue;
    const y = {
      delay: t,
      ...av(s || {}, h)
    }, x = p.get();
    if (x !== void 0 && !p.isAnimating && !Array.isArray(g) && g === x && !y.velocity)
      continue;
    let S = !1;
    if (window.MotionHandoffAnimation) {
      const T = iD(n);
      if (T) {
        const k = window.MotionHandoffAnimation(T, h, Dt);
        k !== null && (y.startTime = k, S = !0);
      }
    }
    Sg(n, h);
    const w = c ?? n.shouldReduceMotion;
    p.start(lv(h, p, g, w && nD.has(h) ? { type: !1 } : y, n, S));
    const C = p.animation;
    C && u.push(C);
  }
  return o && Promise.all(u).then(() => {
    Dt.update(() => {
      o && R3(n, o);
    });
  }), u;
}
function wg(n, e, t = {}) {
  var c;
  const r = Ua(n, e, t.type === "exit" ? (c = n.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: i = n.getDefaultTransition() || {} } = r || {};
  t.transitionOverride && (i = t.transitionOverride);
  const s = r ? () => Promise.all(dv(n, r, t)) : () => Promise.resolve(), o = n.variantChildren && n.variantChildren.size ? (u = 0) => {
    const { delayChildren: f = 0, staggerChildren: h, staggerDirection: p } = i;
    return O3(n, e, u, f, h, p, t);
  } : () => Promise.resolve(), { when: a } = i;
  if (a) {
    const [u, f] = a === "beforeChildren" ? [s, o] : [o, s];
    return u().then(() => f());
  } else
    return Promise.all([s(), o(t.delay)]);
}
function O3(n, e, t = 0, r = 0, i = 0, s = 1, o) {
  const a = [];
  for (const c of n.variantChildren)
    c.notify("AnimationStart", e), a.push(wg(c, e, {
      ...o,
      delay: t + (typeof r == "function" ? 0 : r) + eD(n.variantChildren, c, r, i, s)
    }).then(() => c.notify("AnimationComplete", e)));
  return Promise.all(a);
}
function I3(n, e, t = {}) {
  n.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const i = e.map((s) => wg(n, s, t));
    r = Promise.all(i);
  } else if (typeof e == "string")
    r = wg(n, e, t);
  else {
    const i = typeof e == "function" ? Ua(n, e, t.custom) : e;
    r = Promise.all(dv(n, i, t));
  }
  return r.then(() => {
    n.notify("AnimationComplete", e);
  });
}
const N3 = {
  test: (n) => n === "auto",
  parse: (n) => n
}, sD = (n) => (e) => e.test(n), oD = [sl, Ae, Mi, Ms, lU, aU, N3], lw = (n) => oD.find(sD(n));
function P3(n) {
  return typeof n == "number" ? n === 0 : n !== null ? n === "none" || n === "0" || vC(n) : !0;
}
const L3 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function B3(n) {
  const [e, t] = n.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return n;
  const [r] = t.match(Zy) || [];
  if (!r)
    return n;
  const i = t.replace(r, "");
  let s = L3.has(e) ? 1 : 0;
  return r !== t && (s *= 100), e + "(" + s + i + ")";
}
const j3 = /\b([a-z-]*)\(.*?\)/gu, Eg = {
  ...Xs,
  getAnimatableNone: (n) => {
    const e = n.match(j3);
    return e ? e.map(B3).join(" ") : n;
  }
}, cw = {
  ...sl,
  transform: Math.round
}, F3 = {
  rotate: Ms,
  rotateX: Ms,
  rotateY: Ms,
  rotateZ: Ms,
  scale: Gu,
  scaleX: Gu,
  scaleY: Gu,
  scaleZ: Gu,
  skew: Ms,
  skewX: Ms,
  skewY: Ms,
  distance: Ae,
  translateX: Ae,
  translateY: Ae,
  translateZ: Ae,
  x: Ae,
  y: Ae,
  z: Ae,
  perspective: Ae,
  transformPerspective: Ae,
  opacity: gc,
  originX: qS,
  originY: qS,
  originZ: Ae
}, fv = {
  // Border props
  borderWidth: Ae,
  borderTopWidth: Ae,
  borderRightWidth: Ae,
  borderBottomWidth: Ae,
  borderLeftWidth: Ae,
  borderRadius: Ae,
  borderTopLeftRadius: Ae,
  borderTopRightRadius: Ae,
  borderBottomRightRadius: Ae,
  borderBottomLeftRadius: Ae,
  // Positioning props
  width: Ae,
  maxWidth: Ae,
  height: Ae,
  maxHeight: Ae,
  top: Ae,
  right: Ae,
  bottom: Ae,
  left: Ae,
  inset: Ae,
  insetBlock: Ae,
  insetBlockStart: Ae,
  insetBlockEnd: Ae,
  insetInline: Ae,
  insetInlineStart: Ae,
  insetInlineEnd: Ae,
  // Spacing props
  padding: Ae,
  paddingTop: Ae,
  paddingRight: Ae,
  paddingBottom: Ae,
  paddingLeft: Ae,
  paddingBlock: Ae,
  paddingBlockStart: Ae,
  paddingBlockEnd: Ae,
  paddingInline: Ae,
  paddingInlineStart: Ae,
  paddingInlineEnd: Ae,
  margin: Ae,
  marginTop: Ae,
  marginRight: Ae,
  marginBottom: Ae,
  marginLeft: Ae,
  marginBlock: Ae,
  marginBlockStart: Ae,
  marginBlockEnd: Ae,
  marginInline: Ae,
  marginInlineStart: Ae,
  marginInlineEnd: Ae,
  // Typography
  fontSize: Ae,
  // Misc
  backgroundPositionX: Ae,
  backgroundPositionY: Ae,
  ...F3,
  zIndex: cw,
  // SVG
  fillOpacity: gc,
  strokeOpacity: gc,
  numOctaves: cw
}, z3 = {
  ...fv,
  // Color props
  color: rn,
  backgroundColor: rn,
  outlineColor: rn,
  fill: rn,
  stroke: rn,
  // Border props
  borderColor: rn,
  borderTopColor: rn,
  borderRightColor: rn,
  borderBottomColor: rn,
  borderLeftColor: rn,
  filter: Eg,
  WebkitFilter: Eg
}, aD = (n) => z3[n];
function lD(n, e) {
  let t = aD(n);
  return t !== Eg && (t = Xs), t.getAnimatableNone ? t.getAnimatableNone(e) : void 0;
}
const V3 = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function H3(n, e, t) {
  let r = 0, i;
  for (; r < n.length && !i; ) {
    const s = n[r];
    typeof s == "string" && !V3.has(s) && yc(s).values.length && (i = n[r]), r++;
  }
  if (i && t)
    for (const s of e)
      n[s] = lD(t, i);
}
class W3 extends sv {
  constructor(e, t, r, i, s) {
    super(e, t, r, i, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: t, name: r } = this;
    if (!t || !t.current)
      return;
    super.readKeyframes();
    for (let f = 0; f < e.length; f++) {
      let h = e[f];
      if (typeof h == "string" && (h = h.trim(), Qy(h))) {
        const p = tD(h, t.current);
        p !== void 0 && (e[f] = p), f === e.length - 1 && (this.finalKeyframe = h);
      }
    }
    if (this.resolveNoneKeyframes(), !nD.has(r) || e.length !== 2)
      return;
    const [i, s] = e, o = lw(i), a = lw(s), c = YS(i), u = YS(s);
    if (c !== u && zs[r]) {
      this.needsMeasurement = !0;
      return;
    }
    if (o !== a)
      if (nw(o) && nw(a))
        for (let f = 0; f < e.length; f++) {
          const h = e[f];
          typeof h == "string" && (e[f] = parseFloat(h));
        }
      else zs[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: t } = this, r = [];
    for (let i = 0; i < e.length; i++)
      (e[i] === null || P3(e[i])) && r.push(i);
    r.length && H3(e, r, t);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: t, name: r } = this;
    if (!e || !e.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = zs[r](e.measureViewportBox(), window.getComputedStyle(e.current)), t[0] = this.measuredOrigin;
    const i = t[t.length - 1];
    i !== void 0 && e.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var a;
    const { element: e, name: t, unresolvedKeyframes: r } = this;
    if (!e || !e.current)
      return;
    const i = e.getValue(t);
    i && i.jump(this.measuredOrigin, !1);
    const s = r.length - 1, o = r[s];
    r[s] = zs[t](e.measureViewportBox(), window.getComputedStyle(e.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([c, u]) => {
      e.getValue(c).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function cD(n, e, t) {
  if (n == null)
    return [];
  if (n instanceof EventTarget)
    return [n];
  if (typeof n == "string") {
    let r = document;
    e && (r = e.current);
    const i = (t == null ? void 0 : t[n]) ?? r.querySelectorAll(n);
    return i ? Array.from(i) : [];
  }
  return Array.from(n).filter((r) => r != null);
}
const uD = (n, e) => e && typeof n == "number" ? e.transform(n) : n;
function U3(n) {
  return yC(n) && "offsetHeight" in n;
}
const { schedule: hv } = /* @__PURE__ */ OC(queueMicrotask, !1), ci = {
  x: !1,
  y: !1
};
function dD() {
  return ci.x || ci.y;
}
function $3(n) {
  return n === "x" || n === "y" ? ci[n] ? null : (ci[n] = !0, () => {
    ci[n] = !1;
  }) : ci.x || ci.y ? null : (ci.x = ci.y = !0, () => {
    ci.x = ci.y = !1;
  });
}
function fD(n, e) {
  const t = cD(n), r = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: r.signal
  };
  return [t, i, () => r.abort()];
}
function uw(n) {
  return !(n.pointerType === "touch" || dD());
}
function G3(n, e, t = {}) {
  const [r, i, s] = fD(n, t), o = (a) => {
    if (!uw(a))
      return;
    const { target: c } = a, u = e(c, a);
    if (typeof u != "function" || !c)
      return;
    const f = (h) => {
      uw(h) && (u(h), c.removeEventListener("pointerleave", f));
    };
    c.addEventListener("pointerleave", f, i);
  };
  return r.forEach((a) => {
    a.addEventListener("pointerenter", o, i);
  }), s;
}
const hD = (n, e) => e ? n === e ? !0 : hD(n, e.parentElement) : !1, pv = (n) => n.pointerType === "mouse" ? typeof n.button != "number" || n.button <= 0 : n.isPrimary !== !1, Y3 = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function pD(n) {
  return Y3.has(n.tagName) || n.isContentEditable === !0;
}
const bd = /* @__PURE__ */ new WeakSet();
function dw(n) {
  return (e) => {
    e.key === "Enter" && n(e);
  };
}
function Qp(n, e) {
  n.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const q3 = (n, e) => {
  const t = n.currentTarget;
  if (!t)
    return;
  const r = dw(() => {
    if (bd.has(t))
      return;
    Qp(t, "down");
    const i = dw(() => {
      Qp(t, "up");
    }), s = () => Qp(t, "cancel");
    t.addEventListener("keyup", i, e), t.addEventListener("blur", s, e);
  });
  t.addEventListener("keydown", r, e), t.addEventListener("blur", () => t.removeEventListener("keydown", r), e);
};
function fw(n) {
  return pv(n) && !dD();
}
function K3(n, e, t = {}) {
  const [r, i, s] = fD(n, t), o = (a) => {
    const c = a.currentTarget;
    if (!fw(a))
      return;
    bd.add(c);
    const u = e(c, a), f = (g, y) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", p), bd.has(c) && bd.delete(c), fw(g) && typeof u == "function" && u(g, { success: y });
    }, h = (g) => {
      f(g, c === window || c === document || t.useGlobalTarget || hD(c, g.target));
    }, p = (g) => {
      f(g, !1);
    };
    window.addEventListener("pointerup", h, i), window.addEventListener("pointercancel", p, i);
  };
  return r.forEach((a) => {
    (t.useGlobalTarget ? window : a).addEventListener("pointerdown", o, i), U3(a) && (a.addEventListener("focus", (u) => q3(u, i)), !pD(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), s;
}
function mv(n) {
  return yC(n) && "ownerSVGElement" in n;
}
function mD(n) {
  return mv(n) && n.tagName === "svg";
}
function xd(...n) {
  const e = !Array.isArray(n[0]), t = e ? 0 : -1, r = n[0 + t], i = n[1 + t], s = n[2 + t], o = n[3 + t], a = $C(i, s, o);
  return e ? a(r) : a;
}
const J3 = [...oD, rn, Xs], Q3 = (n) => J3.find(sD(n)), hw = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), La = () => ({
  x: hw(),
  y: hw()
}), pw = () => ({ min: 0, max: 0 }), nn = () => ({
  x: pw(),
  y: pw()
}), $d = { current: null }, gv = { current: !1 }, Z3 = typeof window < "u";
function gD() {
  if (gv.current = !0, !!Z3)
    if (window.matchMedia) {
      const n = window.matchMedia("(prefers-reduced-motion)"), e = () => $d.current = n.matches;
      n.addEventListener("change", e), e();
    } else
      $d.current = !1;
}
const bc = /* @__PURE__ */ new WeakMap();
function qf(n) {
  return n !== null && typeof n == "object" && typeof n.start == "function";
}
function xc(n) {
  return typeof n == "string" || Array.isArray(n);
}
const yv = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], vv = ["initial", ...yv];
function Kf(n) {
  return qf(n.animate) || vv.some((e) => xc(n[e]));
}
function yD(n) {
  return !!(Kf(n) || n.variants);
}
function X3(n, e, t) {
  for (const r in e) {
    const i = e[r], s = t[r];
    if (gn(i))
      n.addValue(r, i);
    else if (gn(s))
      n.addValue(r, $o(i, { owner: n }));
    else if (s !== i)
      if (n.hasValue(r)) {
        const o = n.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = n.getStaticValue(r);
        n.addValue(r, $o(o !== void 0 ? o : i, { owner: n }));
      }
  }
  for (const r in t)
    e[r] === void 0 && n.removeValue(r);
  return e;
}
const mw = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Gd = {};
function vD(n) {
  Gd = n;
}
function e$() {
  return Gd;
}
class bD {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, t, r) {
    return {};
  }
  constructor({ parent: e, props: t, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: s, visualState: o }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = sv, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = Qn.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, Dt.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: u } = o;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = t.initial ? { ...c } : {}, this.renderState = u, this.parent = e, this.props = t, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!s, this.isControllingVariants = Kf(t), this.isVariantNode = yD(t), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: f, ...h } = this.scrapeMotionValuesFromProps(t, {}, this);
    for (const p in h) {
      const g = h[p];
      c[p] !== void 0 && gn(g) && g.set(c[p]);
    }
  }
  mount(e) {
    var t;
    this.current = e, bc.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, i) => this.bindToMotionValue(i, r)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (gv.current || gD(), this.shouldReduceMotion = $d.current), process.env.NODE_ENV !== "production" && Yf(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (t = this.parent) == null || t.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var e;
    this.projection && this.projection.unmount(), cs(this.notifyUpdate), cs(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (e = this.parent) == null || e.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const r = this.features[t];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, t) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const r = al.has(e);
    r && this.onBindTransform && this.onBindTransform();
    const i = t.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && Dt.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let s;
    typeof window < "u" && window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, e, t)), this.valueSubscriptions.set(e, () => {
      i(), s && s(), t.owner && t.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in Gd) {
      const t = Gd[e];
      if (!t)
        continue;
      const { isEnabled: r, Feature: i } = t;
      if (!this.features[e] && i && r(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const s = this.features[e];
        s.isMounted ? s.update() : (s.mount(), s.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : nn();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, t) {
    this.latestValues[e] = t;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, t) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
    for (let r = 0; r < mw.length; r++) {
      const i = mw[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const s = "on" + i, o = e[s];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = X3(this, this.scrapeMotionValuesFromProps(e, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const t = this.getClosestVariantNode();
    if (t)
      return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, t) {
    const r = this.values.get(e);
    t !== r && (r && this.removeValue(e), this.bindToMotionValue(e, t), this.values.set(e, t), this.latestValues[e] = t.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const t = this.valueSubscriptions.get(e);
    t && (t(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, t) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && t !== void 0 && (r = $o(t === null ? void 0 : t, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, t) {
    let r = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return r != null && (typeof r == "string" && (gC(r) || vC(r)) ? r = parseFloat(r) : !Q3(r) && Xs.test(t) && (r = lD(e, t)), this.setBaseTarget(e, gn(r) ? r.get() : r)), gn(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, t) {
    this.baseTarget[e] = t;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var s;
    const { initial: t } = this.props;
    let r;
    if (typeof t == "string" || typeof t == "object") {
      const o = cv(this.props, t, (s = this.presenceContext) == null ? void 0 : s.custom);
      o && (r = o[e]);
    }
    if (t && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !gn(i) ? i : this.initialValues[e] !== void 0 && r === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, t) {
    return this.events[e] || (this.events[e] = new qy()), this.events[e].add(t);
  }
  notify(e, ...t) {
    this.events[e] && this.events[e].notify(...t);
  }
  scheduleRenderMicrotask() {
    hv.render(this.render);
  }
}
class xD extends bD {
  constructor() {
    super(...arguments), this.KeyframeResolver = W3;
  }
  sortInstanceNodePosition(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, t) {
    const r = e.style;
    return r ? r[t] : void 0;
  }
  removeValueFromRenderState(e, { vars: t, style: r }) {
    delete t[e], delete r[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    gn(e) && (this.childSubscription = e.on("change", (t) => {
      this.current && (this.current.textContent = `${t}`);
    }));
  }
}
class ro {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function SD({ top: n, left: e, right: t, bottom: r }) {
  return {
    x: { min: e, max: t },
    y: { min: n, max: r }
  };
}
function t$({ x: n, y: e }) {
  return { top: e.min, right: n.max, bottom: e.max, left: n.min };
}
function n$(n, e) {
  if (!e)
    return n;
  const t = e({ x: n.left, y: n.top }), r = e({ x: n.right, y: n.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: r.y,
    right: r.x
  };
}
function Zp(n) {
  return n === void 0 || n === 1;
}
function Ag({ scale: n, scaleX: e, scaleY: t }) {
  return !Zp(n) || !Zp(e) || !Zp(t);
}
function To(n) {
  return Ag(n) || wD(n) || n.z || n.rotate || n.rotateX || n.rotateY || n.skewX || n.skewY;
}
function wD(n) {
  return gw(n.x) || gw(n.y);
}
function gw(n) {
  return n && n !== "0%";
}
function Yd(n, e, t) {
  const r = n - t, i = e * r;
  return t + i;
}
function yw(n, e, t, r, i) {
  return i !== void 0 && (n = Yd(n, i, r)), Yd(n, t, r) + e;
}
function Tg(n, e = 0, t = 1, r, i) {
  n.min = yw(n.min, e, t, r, i), n.max = yw(n.max, e, t, r, i);
}
function ED(n, { x: e, y: t }) {
  Tg(n.x, e.translate, e.scale, e.originPoint), Tg(n.y, t.translate, t.scale, t.originPoint);
}
const vw = 0.999999999999, bw = 1.0000000000001;
function r$(n, e, t, r = !1) {
  const i = t.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let s, o;
  for (let a = 0; a < i; a++) {
    s = t[a], o = s.projectionDelta;
    const { visualElement: c } = s.options;
    c && c.props.style && c.props.style.display === "contents" || (r && s.options.layoutScroll && s.scroll && s !== s.root && ja(n, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, ED(n, o)), r && To(s.latestValues) && ja(n, s.latestValues));
  }
  e.x < bw && e.x > vw && (e.x = 1), e.y < bw && e.y > vw && (e.y = 1);
}
function Ba(n, e) {
  n.min = n.min + e, n.max = n.max + e;
}
function xw(n, e, t, r, i = 0.5) {
  const s = Lt(n.min, n.max, i);
  Tg(n, e, t, s, r);
}
function ja(n, e) {
  xw(n.x, e.x, e.scaleX, e.scale, e.originX), xw(n.y, e.y, e.scaleY, e.scale, e.originY);
}
function AD(n, e) {
  return SD(n$(n.getBoundingClientRect(), e));
}
function i$(n, e, t) {
  const r = AD(n, t), { scroll: i } = e;
  return i && (Ba(r.x, i.offset.x), Ba(r.y, i.offset.y)), r;
}
const s$ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, o$ = ol.length;
function a$(n, e, t) {
  let r = "", i = !0;
  for (let s = 0; s < o$; s++) {
    const o = ol[s], a = n[o];
    if (a === void 0)
      continue;
    let c = !0;
    if (typeof a == "number")
      c = a === (o.startsWith("scale") ? 1 : 0);
    else {
      const u = parseFloat(a);
      c = o.startsWith("scale") ? u === 1 : u === 0;
    }
    if (!c || t) {
      const u = uD(a, fv[o]);
      if (!c) {
        i = !1;
        const f = s$[o] || o;
        r += `${f}(${u}) `;
      }
      t && (e[o] = u);
    }
  }
  return r = r.trim(), t ? r = t(e, i ? "" : r) : i && (r = "none"), r;
}
function bv(n, e, t) {
  const { style: r, vars: i, transformOrigin: s } = n;
  let o = !1, a = !1;
  for (const c in e) {
    const u = e[c];
    if (al.has(c)) {
      o = !0;
      continue;
    } else if (NC(c)) {
      i[c] = u;
      continue;
    } else {
      const f = uD(u, fv[c]);
      c.startsWith("origin") ? (a = !0, s[c] = f) : r[c] = f;
    }
  }
  if (e.transform || (o || t ? r.transform = a$(e, n.transform, t) : r.transform && (r.transform = "none")), a) {
    const { originX: c = "50%", originY: u = "50%", originZ: f = 0 } = s;
    r.transformOrigin = `${c} ${u} ${f}`;
  }
}
function TD(n, { style: e, vars: t }, r, i) {
  const s = n.style;
  let o;
  for (o in e)
    s[o] = e[o];
  i == null || i.applyProjectionStyles(s, r);
  for (o in t)
    s.setProperty(o, t[o]);
}
function Sw(n, e) {
  return e.max === e.min ? 0 : n / (e.max - e.min) * 100;
}
const _l = {
  correct: (n, e) => {
    if (!e.target)
      return n;
    if (typeof n == "string")
      if (Ae.test(n))
        n = parseFloat(n);
      else
        return n;
    const t = Sw(n, e.target.x), r = Sw(n, e.target.y);
    return `${t}% ${r}%`;
  }
}, l$ = {
  correct: (n, { treeScale: e, projectionDelta: t }) => {
    const r = n, i = Xs.parse(n);
    if (i.length > 5)
      return r;
    const s = Xs.createTransformer(n), o = typeof i[0] != "number" ? 1 : 0, a = t.x.scale * e.x, c = t.y.scale * e.y;
    i[0 + o] /= a, i[1 + o] /= c;
    const u = Lt(a, c, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= u), typeof i[3 + o] == "number" && (i[3 + o] /= u), s(i);
  }
}, Cg = {
  borderRadius: {
    ..._l,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: _l,
  borderTopRightRadius: _l,
  borderBottomLeftRadius: _l,
  borderBottomRightRadius: _l,
  boxShadow: l$
};
function CD(n, { layout: e, layoutId: t }) {
  return al.has(n) || n.startsWith("origin") || (e || t !== void 0) && (!!Cg[n] || n === "opacity");
}
function xv(n, e, t) {
  var o;
  const r = n.style, i = e == null ? void 0 : e.style, s = {};
  if (!r)
    return s;
  for (const a in r)
    (gn(r[a]) || i && gn(i[a]) || CD(a, n) || ((o = t == null ? void 0 : t.getValue(a)) == null ? void 0 : o.liveStyle) !== void 0) && (s[a] = r[a]);
  return s;
}
function c$(n) {
  return window.getComputedStyle(n);
}
class DD extends xD {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = TD;
  }
  readValueFromInstance(e, t) {
    var r;
    if (al.has(t))
      return (r = this.projection) != null && r.isProjecting ? pg(t) : VU(e, t);
    {
      const i = c$(e), s = (NC(t) ? i.getPropertyValue(t) : i[t]) || 0;
      return typeof s == "string" ? s.trim() : s;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: t }) {
    return AD(e, t);
  }
  build(e, t, r) {
    bv(e, t, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, t, r) {
    return xv(e, t, r);
  }
}
function u$(n, e) {
  return n in e;
}
class d$ extends bD {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(e, t) {
    if (u$(t, e)) {
      const r = e[t];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(e, t) {
    delete t.output[e];
  }
  measureInstanceViewportBox() {
    return nn();
  }
  build(e, t) {
    Object.assign(e.output, t);
  }
  renderInstance(e, { output: t }) {
    Object.assign(e, t);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
const f$ = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, h$ = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function p$(n, e, t = 1, r = 0, i = !0) {
  n.pathLength = 1;
  const s = i ? f$ : h$;
  n[s.offset] = `${-r}`, n[s.array] = `${e} ${t}`;
}
const m$ = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function RD(n, {
  attrX: e,
  attrY: t,
  attrScale: r,
  pathLength: i,
  pathSpacing: s = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, c, u, f) {
  if (bv(n, a, u), c) {
    n.style.viewBox && (n.attrs.viewBox = n.style.viewBox);
    return;
  }
  n.attrs = n.style, n.style = {};
  const { attrs: h, style: p } = n;
  h.transform && (p.transform = h.transform, delete h.transform), (p.transform || h.transformOrigin) && (p.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), p.transform && (p.transformBox = (f == null ? void 0 : f.transformBox) ?? "fill-box", delete h.transformBox);
  for (const g of m$)
    h[g] !== void 0 && (p[g] = h[g], delete h[g]);
  e !== void 0 && (h.x = e), t !== void 0 && (h.y = t), r !== void 0 && (h.scale = r), i !== void 0 && p$(h, i, s, o, !1);
}
const kD = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), MD = (n) => typeof n == "string" && n.toLowerCase() === "svg";
function g$(n, e, t, r) {
  TD(n, e, void 0, r);
  for (const i in e.attrs)
    n.setAttribute(kD.has(i) ? i : uv(i), e.attrs[i]);
}
function _D(n, e, t) {
  const r = xv(n, e, t);
  for (const i in n)
    if (gn(n[i]) || gn(e[i])) {
      const s = ol.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[s] = n[i];
    }
  return r;
}
class OD extends xD {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = nn;
  }
  getBaseTargetFromProps(e, t) {
    return e[t];
  }
  readValueFromInstance(e, t) {
    if (al.has(t)) {
      const r = aD(t);
      return r && r.default || 0;
    }
    return t = kD.has(t) ? t : uv(t), e.getAttribute(t);
  }
  scrapeMotionValuesFromProps(e, t, r) {
    return _D(e, t, r);
  }
  build(e, t, r) {
    RD(e, t, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(e, t, r, i) {
    g$(e, t, r, i);
  }
  mount(e) {
    this.isSVGTag = MD(e.tagName), super.mount(e);
  }
}
const y$ = vv.length;
function ID(n) {
  if (!n)
    return;
  if (!n.isControllingVariants) {
    const t = n.parent ? ID(n.parent) || {} : {};
    return n.props.initial !== void 0 && (t.initial = n.props.initial), t;
  }
  const e = {};
  for (let t = 0; t < y$; t++) {
    const r = vv[t], i = n.props[r];
    (xc(i) || i === !1) && (e[r] = i);
  }
  return e;
}
function ND(n, e) {
  if (!Array.isArray(e))
    return !1;
  const t = e.length;
  if (t !== n.length)
    return !1;
  for (let r = 0; r < t; r++)
    if (e[r] !== n[r])
      return !1;
  return !0;
}
const v$ = [...yv].reverse(), b$ = yv.length;
function x$(n) {
  return (e) => Promise.all(e.map(({ animation: t, options: r }) => I3(n, t, r)));
}
function S$(n) {
  let e = x$(n), t = ww(), r = !0;
  const i = (c) => (u, f) => {
    var p;
    const h = Ua(n, f, c === "exit" ? (p = n.presenceContext) == null ? void 0 : p.custom : void 0);
    if (h) {
      const { transition: g, transitionEnd: y, ...x } = h;
      u = { ...u, ...x, ...y };
    }
    return u;
  };
  function s(c) {
    e = c(n);
  }
  function o(c) {
    const { props: u } = n, f = ID(n.parent) || {}, h = [], p = /* @__PURE__ */ new Set();
    let g = {}, y = 1 / 0;
    for (let S = 0; S < b$; S++) {
      const w = v$[S], C = t[w], T = u[w] !== void 0 ? u[w] : f[w], k = xc(T), R = w === c ? C.isActive : null;
      R === !1 && (y = S);
      let P = T === f[w] && T !== u[w] && k;
      if (P && r && n.manuallyAnimateOnMount && (P = !1), C.protectedKeys = { ...g }, // If it isn't active and hasn't *just* been set as inactive
      !C.isActive && R === null || // If we didn't and don't have any defined prop for this animation type
      !T && !C.prevProp || // Or if the prop doesn't define an animation
      qf(T) || typeof T == "boolean")
        continue;
      const L = w$(C.prevProp, T);
      let B = L || // If we're making this variant active, we want to always make it active
      w === c && C.isActive && !P && k || // If we removed a higher-priority variant (i is in reverse order)
      S > y && k, W = !1;
      const X = Array.isArray(T) ? T : [T];
      let ce = X.reduce(i(w), {});
      R === !1 && (ce = {});
      const { prevResolvedValues: Re = {} } = C, ke = {
        ...Re,
        ...ce
      }, J = ($) => {
        B = !0, p.has($) && (W = !0, p.delete($)), C.needsAnimating[$] = !0;
        const K = n.getValue($);
        K && (K.liveStyle = !1);
      };
      for (const $ in ke) {
        const K = ce[$], Se = Re[$];
        if (g.hasOwnProperty($))
          continue;
        let z = !1;
        xg(K) && xg(Se) ? z = !ND(K, Se) : z = K !== Se, z ? K != null ? J($) : p.add($) : K !== void 0 && p.has($) ? J($) : C.protectedKeys[$] = !0;
      }
      C.prevProp = T, C.prevResolvedValues = ce, C.isActive && (g = { ...g, ...ce }), r && n.blockInitialAnimation && (B = !1);
      const re = P && L;
      B && (!re || W) && h.push(...X.map(($) => {
        const K = { type: w };
        if (typeof $ == "string" && r && !re && n.manuallyAnimateOnMount && n.parent) {
          const { parent: Se } = n, z = Ua(Se, $);
          if (Se.enteringChildren && z) {
            const { delayChildren: Q } = z.transition || {};
            K.delay = eD(Se.enteringChildren, n, Q);
          }
        }
        return {
          animation: $,
          options: K
        };
      }));
    }
    if (p.size) {
      const S = {};
      if (typeof u.initial != "boolean") {
        const w = Ua(n, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        w && w.transition && (S.transition = w.transition);
      }
      p.forEach((w) => {
        const C = n.getBaseTarget(w), T = n.getValue(w);
        T && (T.liveStyle = !0), S[w] = C ?? null;
      }), h.push({ animation: S });
    }
    let x = !!h.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !n.manuallyAnimateOnMount && (x = !1), r = !1, x ? e(h) : Promise.resolve();
  }
  function a(c, u) {
    var h;
    if (t[c].isActive === u)
      return Promise.resolve();
    (h = n.variantChildren) == null || h.forEach((p) => {
      var g;
      return (g = p.animationState) == null ? void 0 : g.setActive(c, u);
    }), t[c].isActive = u;
    const f = o(c);
    for (const p in t)
      t[p].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: o,
    setActive: a,
    setAnimateFunction: s,
    getState: () => t,
    reset: () => {
      t = ww();
    }
  };
}
function w$(n, e) {
  return typeof e == "string" ? e !== n : Array.isArray(e) ? !ND(e, n) : !1;
}
function So(n = !1) {
  return {
    isActive: n,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function ww() {
  return {
    animate: So(!0),
    whileInView: So(),
    whileHover: So(),
    whileTap: So(),
    whileDrag: So(),
    whileFocus: So(),
    exit: So()
  };
}
function Ew(n, e) {
  n.min = e.min, n.max = e.max;
}
function li(n, e) {
  Ew(n.x, e.x), Ew(n.y, e.y);
}
function Aw(n, e) {
  n.translate = e.translate, n.scale = e.scale, n.originPoint = e.originPoint, n.origin = e.origin;
}
const PD = 1e-4, E$ = 1 - PD, A$ = 1 + PD, LD = 0.01, T$ = 0 - LD, C$ = 0 + LD;
function Zn(n) {
  return n.max - n.min;
}
function D$(n, e, t) {
  return Math.abs(n - e) <= t;
}
function Tw(n, e, t, r = 0.5) {
  n.origin = r, n.originPoint = Lt(e.min, e.max, n.origin), n.scale = Zn(t) / Zn(e), n.translate = Lt(t.min, t.max, n.origin) - n.originPoint, (n.scale >= E$ && n.scale <= A$ || isNaN(n.scale)) && (n.scale = 1), (n.translate >= T$ && n.translate <= C$ || isNaN(n.translate)) && (n.translate = 0);
}
function Zl(n, e, t, r) {
  Tw(n.x, e.x, t.x, r ? r.originX : void 0), Tw(n.y, e.y, t.y, r ? r.originY : void 0);
}
function Cw(n, e, t) {
  n.min = t.min + e.min, n.max = n.min + Zn(e);
}
function R$(n, e, t) {
  Cw(n.x, e.x, t.x), Cw(n.y, e.y, t.y);
}
function Dw(n, e, t) {
  n.min = e.min - t.min, n.max = n.min + Zn(e);
}
function qd(n, e, t) {
  Dw(n.x, e.x, t.x), Dw(n.y, e.y, t.y);
}
function Rw(n, e, t, r, i) {
  return n -= e, n = Yd(n, 1 / t, r), i !== void 0 && (n = Yd(n, 1 / i, r)), n;
}
function k$(n, e = 0, t = 1, r = 0.5, i, s = n, o = n) {
  if (Mi.test(e) && (e = parseFloat(e), e = Lt(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let a = Lt(s.min, s.max, r);
  n === s && (a -= e), n.min = Rw(n.min, e, t, a, i), n.max = Rw(n.max, e, t, a, i);
}
function kw(n, e, [t, r, i], s, o) {
  k$(n, e[t], e[r], e[i], e.scale, s, o);
}
const M$ = ["x", "scaleX", "originX"], _$ = ["y", "scaleY", "originY"];
function Mw(n, e, t, r) {
  kw(n.x, e, M$, t ? t.x : void 0, r ? r.x : void 0), kw(n.y, e, _$, t ? t.y : void 0, r ? r.y : void 0);
}
function _w(n) {
  return n.translate === 0 && n.scale === 1;
}
function BD(n) {
  return _w(n.x) && _w(n.y);
}
function Ow(n, e) {
  return n.min === e.min && n.max === e.max;
}
function O$(n, e) {
  return Ow(n.x, e.x) && Ow(n.y, e.y);
}
function Iw(n, e) {
  return Math.round(n.min) === Math.round(e.min) && Math.round(n.max) === Math.round(e.max);
}
function jD(n, e) {
  return Iw(n.x, e.x) && Iw(n.y, e.y);
}
function Nw(n) {
  return Zn(n.x) / Zn(n.y);
}
function Pw(n, e) {
  return n.translate === e.translate && n.scale === e.scale && n.originPoint === e.originPoint;
}
function Wr(n) {
  return [n("x"), n("y")];
}
function I$(n, e, t) {
  let r = "";
  const i = n.x.translate / e.x, s = n.y.translate / e.y, o = (t == null ? void 0 : t.z) || 0;
  if ((i || s || o) && (r = `translate3d(${i}px, ${s}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), t) {
    const { transformPerspective: u, rotate: f, rotateX: h, rotateY: p, skewX: g, skewY: y } = t;
    u && (r = `perspective(${u}px) ${r}`), f && (r += `rotate(${f}deg) `), h && (r += `rotateX(${h}deg) `), p && (r += `rotateY(${p}deg) `), g && (r += `skewX(${g}deg) `), y && (r += `skewY(${y}deg) `);
  }
  const a = n.x.scale * e.x, c = n.y.scale * e.y;
  return (a !== 1 || c !== 1) && (r += `scale(${a}, ${c})`), r || "none";
}
const FD = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], N$ = FD.length, Lw = (n) => typeof n == "string" ? parseFloat(n) : n, Bw = (n) => typeof n == "number" || Ae.test(n);
function P$(n, e, t, r, i, s) {
  i ? (n.opacity = Lt(0, t.opacity ?? 1, L$(r)), n.opacityExit = Lt(e.opacity ?? 1, 0, B$(r))) : s && (n.opacity = Lt(e.opacity ?? 1, t.opacity ?? 1, r));
  for (let o = 0; o < N$; o++) {
    const a = `border${FD[o]}Radius`;
    let c = jw(e, a), u = jw(t, a);
    if (c === void 0 && u === void 0)
      continue;
    c || (c = 0), u || (u = 0), c === 0 || u === 0 || Bw(c) === Bw(u) ? (n[a] = Math.max(Lt(Lw(c), Lw(u), r), 0), (Mi.test(u) || Mi.test(c)) && (n[a] += "%")) : n[a] = u;
  }
  (e.rotate || t.rotate) && (n.rotate = Lt(e.rotate || 0, t.rotate || 0, r));
}
function jw(n, e) {
  return n[e] !== void 0 ? n[e] : n.borderRadius;
}
const L$ = /* @__PURE__ */ zD(0, 0.5, CC), B$ = /* @__PURE__ */ zD(0.5, 0.95, Jr);
function zD(n, e, t) {
  return (r) => r < n ? 0 : r > e ? 1 : t(/* @__PURE__ */ Qa(n, e, r));
}
function VD(n, e, t) {
  const r = gn(n) ? n : $o(n);
  return r.start(lv("", r, e, t)), r.animation;
}
function Sc(n, e, t, r = { passive: !0 }) {
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t);
}
const j$ = (n, e) => n.depth - e.depth;
class F$ {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    Gy(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Vc(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(j$), this.isDirty = !1, this.children.forEach(e);
  }
}
function z$(n, e) {
  const t = Qn.now(), r = ({ timestamp: i }) => {
    const s = i - t;
    s >= e && (cs(r), n(s - e));
  };
  return Dt.setup(r, !0), () => cs(r);
}
function Sd(n) {
  return gn(n) ? n.get() : n;
}
class V$ {
  constructor() {
    this.members = [];
  }
  add(e) {
    Gy(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Vc(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const t = this.members[this.members.length - 1];
      t && this.promote(t);
    }
  }
  relegate(e) {
    const t = this.members.findIndex((i) => e === i);
    if (t === 0)
      return !1;
    let r;
    for (let i = t; i >= 0; i--) {
      const s = this.members[i];
      if (s.isPresent !== !1) {
        r = s;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, t) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender();
      const i = r.options.layoutDependency, s = e.options.layoutDependency;
      i !== void 0 && s !== void 0 && i === s || (e.resumeFrom = r, t && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0));
      const { crossfade: a } = e.options;
      a === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: t, resumingFrom: r } = e;
      t.onExitComplete && t.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
const wd = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, Xp = ["", "X", "Y", "Z"], H$ = 1e3;
let W$ = 0;
function em(n, e, t, r) {
  const { latestValues: i } = e;
  i[n] && (t[n] = i[n], e.setStaticValue(n, 0), r && (r[n] = 0));
}
function HD(n) {
  if (n.hasCheckedOptimisedAppear = !0, n.root === n)
    return;
  const { visualElement: e } = n.options;
  if (!e)
    return;
  const t = iD(e);
  if (window.MotionHasOptimisedAnimation(t, "transform")) {
    const { layout: i, layoutId: s } = n.options;
    window.MotionCancelOptimisedAnimation(t, "transform", Dt, !(i || s));
  }
  const { parent: r } = n;
  r && !r.hasCheckedOptimisedAppear && HD(r);
}
function WD({ attachResizeListener: n, defaultParent: e, measureScroll: t, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(o = {}, a = e == null ? void 0 : e()) {
      this.id = W$++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(G$), this.nodes.forEach(J$), this.nodes.forEach(Q$), this.nodes.forEach(Y$);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new F$());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new qy()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const c = this.eventHandlers.get(o);
      c && c.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = mv(o) && !mD(o), this.instance = o;
      const { layoutId: a, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (c || a) && (this.isLayoutDirty = !0), n) {
        let f, h = 0;
        const p = () => this.root.updateBlockedByResize = !1;
        Dt.read(() => {
          h = window.innerWidth;
        }), n(o, () => {
          const g = window.innerWidth;
          g !== h && (h = g, this.root.updateBlockedByResize = !0, f && f(), f = z$(p, 250), wd.hasAnimatedSinceResize && (wd.hasAnimatedSinceResize = !1, this.nodes.forEach(Vw)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || c) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: h, hasRelativeLayoutChanged: p, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || u.getDefaultTransition() || n5, { onLayoutAnimationStart: x, onLayoutAnimationComplete: S } = u.getProps(), w = !this.targetLayout || !jD(this.targetLayout, g), C = !h && p;
        if (this.options.layoutRoot || this.resumeFrom || C || h && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const T = {
            ...av(y, "layout"),
            onPlay: x,
            onComplete: S
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (T.delay = 0, T.type = !1), this.startAnimation(T), this.setAnimationOrigin(f, C);
        } else
          h || Vw(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), cs(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Z$), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && HD(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const h = this.path[f];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: a, layout: c } = this.options;
      if (a === void 0 && !c)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Fw);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(zw);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(K$), this.nodes.forEach(U$), this.nodes.forEach($$)) : this.nodes.forEach(zw), this.clearAllSnapshots();
      const a = Qn.now();
      Mn.delta = Oi(0, 1e3 / 60, a - Mn.timestamp), Mn.timestamp = a, Mn.isProcessing = !0, $p.update.process(Mn), $p.preRender.process(Mn), $p.render.process(Mn), Mn.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, hv.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(q$), this.sharedNodes.forEach(X$);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Dt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Dt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Zn(this.snapshot.measuredBox.x) && !Zn(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected = nn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && this.instance) {
        const c = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: c,
          offset: t(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : c
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !BD(this.projectionDelta), c = this.getTransformTemplate(), u = c ? c(this.latestValues, "") : void 0, f = u !== this.prevTransformTemplateValue;
      o && this.instance && (a || To(this.latestValues) || f) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let c = this.removeElementScroll(a);
      return o && (c = this.removeTransform(c)), r5(c), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: o } = this.options;
      if (!o)
        return nn();
      const a = o.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(i5))) {
        const { scroll: f } = this.root;
        f && (Ba(a.x, f.offset.x), Ba(a.y, f.offset.y));
      }
      return a;
    }
    removeElementScroll(o) {
      var c;
      const a = nn();
      if (li(a, o), (c = this.scroll) != null && c.wasRoot)
        return a;
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u], { scroll: h, options: p } = f;
        f !== this.root && h && p.layoutScroll && (h.wasRoot && li(a, o), Ba(a.x, h.offset.x), Ba(a.y, h.offset.y));
      }
      return a;
    }
    applyTransform(o, a = !1) {
      const c = nn();
      li(c, o);
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u];
        !a && f.options.layoutScroll && f.scroll && f !== f.root && ja(c, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), To(f.latestValues) && ja(c, f.latestValues);
      }
      return To(this.latestValues) && ja(c, this.latestValues), c;
    }
    removeTransform(o) {
      const a = nn();
      li(a, o);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        if (!u.instance || !To(u.latestValues))
          continue;
        Ag(u.latestValues) && u.updateSnapshot();
        const f = nn(), h = u.measurePageBox();
        li(f, h), Mw(a, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, f);
      }
      return To(this.latestValues) && Mw(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Mn.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var g;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== a;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || (g = this.parent) != null && g.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: f, layoutId: h } = this.options;
      if (!this.layout || !(f || h))
        return;
      this.resolvedRelativeTargetAt = Mn.timestamp;
      const p = this.getClosestProjectingParent();
      p && this.linkedParentVersion !== p.layoutVersion && !p.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (p && p.layout ? this.createRelativeTarget(p, this.layout.layoutBox, p.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = nn(), this.targetWithTransforms = nn()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), R$(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : li(this.target, this.layout.layoutBox), ED(this.target, this.targetDelta)) : li(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? this.createRelativeTarget(p, this.target, p.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Ag(this.parent.latestValues) || wD(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(o, a, c) {
      this.relativeParent = o, this.linkedParentVersion = o.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = nn(), this.relativeTargetOrigin = nn(), qd(this.relativeTargetOrigin, a, c), li(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var y;
      const o = this.getLead(), a = !!this.resumingFrom || this !== o;
      let c = !0;
      if ((this.isProjectionDirty || (y = this.parent) != null && y.isProjectionDirty) && (c = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === Mn.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: f } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || f))
        return;
      li(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, p = this.treeScale.y;
      r$(this.layoutCorrected, this.treeScale, this.path, a), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = nn());
      const { target: g } = o;
      if (!g) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Aw(this.prevProjectionDelta.x, this.projectionDelta.x), Aw(this.prevProjectionDelta.y, this.projectionDelta.y)), Zl(this.projectionDelta, this.layoutCorrected, g, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== p || !Pw(this.projectionDelta.x, this.prevProjectionDelta.x) || !Pw(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), o) {
        const c = this.getStack();
        c && c.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = La(), this.projectionDelta = La(), this.projectionDeltaWithTransform = La();
    }
    setAnimationOrigin(o, a = !1) {
      const c = this.snapshot, u = c ? c.latestValues : {}, f = { ...this.latestValues }, h = La();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const p = nn(), g = c ? c.source : void 0, y = this.layout ? this.layout.source : void 0, x = g !== y, S = this.getStack(), w = !S || S.members.length <= 1, C = !!(x && !w && this.options.crossfade === !0 && !this.path.some(t5));
      this.animationProgress = 0;
      let T;
      this.mixTargetDelta = (k) => {
        const R = k / 1e3;
        Hw(h.x, o.x, R), Hw(h.y, o.y, R), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (qd(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), e5(this.relativeTarget, this.relativeTargetOrigin, p, R), T && O$(this.relativeTarget, T) && (this.isProjectionDirty = !1), T || (T = nn()), li(T, this.relativeTarget)), x && (this.animationValues = f, P$(f, u, this.latestValues, R, C, w)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = R;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var a, c, u;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (u = (c = this.resumingFrom) == null ? void 0 : c.currentAnimation) == null || u.stop(), this.pendingAnimation && (cs(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Dt.update(() => {
        wd.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = $o(0)), this.currentAnimation = VD(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (f) => {
            this.mixTargetDelta(f), o.onUpdate && o.onUpdate(f);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(H$), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: c, layout: u, latestValues: f } = o;
      if (!(!a || !c || !u)) {
        if (this !== o && this.layout && u && UD(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          c = this.target || nn();
          const h = Zn(this.layout.layoutBox.x);
          c.x.min = o.target.x.min, c.x.max = c.x.min + h;
          const p = Zn(this.layout.layoutBox.y);
          c.y.min = o.target.y.min, c.y.max = c.y.min + p;
        }
        li(a, c), ja(a, f), Zl(this.projectionDeltaWithTransform, this.layoutCorrected, a, f);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new V$()), this.sharedNodes.get(o).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: c } = {}) {
      const u = this.getStack();
      u && u.promote(this, c), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: c } = o;
      if ((c.z || c.rotate || c.rotateX || c.rotateY || c.rotateZ || c.skewX || c.skewY) && (a = !0), !a)
        return;
      const u = {};
      c.z && em("z", o, u, this.animationValues);
      for (let f = 0; f < Xp.length; f++)
        em(`rotate${Xp[f]}`, o, u, this.animationValues), em(`skew${Xp[f]}`, o, u, this.animationValues);
      o.render();
      for (const f in u)
        o.setStaticValue(f, u[f]), this.animationValues && (this.animationValues[f] = u[f]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const c = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = Sd(a == null ? void 0 : a.pointerEvents) || "", o.transform = c ? c(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = Sd(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !To(this.latestValues) && (o.transform = c ? c({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const f = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let h = I$(this.projectionDeltaWithTransform, this.treeScale, f);
      c && (h = c(f, h)), o.transform = h;
      const { x: p, y: g } = this.projectionDelta;
      o.transformOrigin = `${p.origin * 100}% ${g.origin * 100}% 0`, u.animationValues ? o.opacity = u === this ? f.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : f.opacityExit : o.opacity = u === this ? f.opacity !== void 0 ? f.opacity : "" : f.opacityExit !== void 0 ? f.opacityExit : 0;
      for (const y in Cg) {
        if (f[y] === void 0)
          continue;
        const { correct: x, applyTo: S, isCSSVariable: w } = Cg[y], C = h === "none" ? f[y] : x(f[y], u);
        if (S) {
          const T = S.length;
          for (let k = 0; k < T; k++)
            o[S[k]] = C;
        } else
          w ? this.options.visualElement.renderState.vars[y] = C : o[y] = C;
      }
      this.options.layoutId && (o.pointerEvents = u === this ? Sd(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(Fw), this.root.sharedNodes.clear();
    }
  };
}
function U$(n) {
  n.updateLayout();
}
function $$(n) {
  var t;
  const e = ((t = n.resumeFrom) == null ? void 0 : t.snapshot) || n.snapshot;
  if (n.isLead() && n.layout && e && n.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = n.layout, { animationType: s } = n.options, o = e.source !== n.layout.source;
    s === "size" ? Wr((h) => {
      const p = o ? e.measuredBox[h] : e.layoutBox[h], g = Zn(p);
      p.min = r[h].min, p.max = p.min + g;
    }) : UD(s, e.layoutBox, r) && Wr((h) => {
      const p = o ? e.measuredBox[h] : e.layoutBox[h], g = Zn(r[h]);
      p.max = p.min + g, n.relativeTarget && !n.currentAnimation && (n.isProjectionDirty = !0, n.relativeTarget[h].max = n.relativeTarget[h].min + g);
    });
    const a = La();
    Zl(a, r, e.layoutBox);
    const c = La();
    o ? Zl(c, n.applyTransform(i, !0), e.measuredBox) : Zl(c, r, e.layoutBox);
    const u = !BD(a);
    let f = !1;
    if (!n.resumeFrom) {
      const h = n.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: p, layout: g } = h;
        if (p && g) {
          const y = nn();
          qd(y, e.layoutBox, p.layoutBox);
          const x = nn();
          qd(x, r, g.layoutBox), jD(y, x) || (f = !0), h.options.layoutRoot && (n.relativeTarget = x, n.relativeTargetOrigin = y, n.relativeParent = h);
        }
      }
    }
    n.notifyListeners("didUpdate", {
      layout: r,
      snapshot: e,
      delta: c,
      layoutDelta: a,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: f
    });
  } else if (n.isLead()) {
    const { onExitComplete: r } = n.options;
    r && r();
  }
  n.options.transition = void 0;
}
function G$(n) {
  n.parent && (n.isProjecting() || (n.isProjectionDirty = n.parent.isProjectionDirty), n.isSharedProjectionDirty || (n.isSharedProjectionDirty = !!(n.isProjectionDirty || n.parent.isProjectionDirty || n.parent.isSharedProjectionDirty)), n.isTransformDirty || (n.isTransformDirty = n.parent.isTransformDirty));
}
function Y$(n) {
  n.isProjectionDirty = n.isSharedProjectionDirty = n.isTransformDirty = !1;
}
function q$(n) {
  n.clearSnapshot();
}
function Fw(n) {
  n.clearMeasurements();
}
function zw(n) {
  n.isLayoutDirty = !1;
}
function K$(n) {
  const { visualElement: e } = n.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), n.resetTransform();
}
function Vw(n) {
  n.finishAnimation(), n.targetDelta = n.relativeTarget = n.target = void 0, n.isProjectionDirty = !0;
}
function J$(n) {
  n.resolveTargetDelta();
}
function Q$(n) {
  n.calcProjection();
}
function Z$(n) {
  n.resetSkewAndRotation();
}
function X$(n) {
  n.removeLeadSnapshot();
}
function Hw(n, e, t) {
  n.translate = Lt(e.translate, 0, t), n.scale = Lt(e.scale, 1, t), n.origin = e.origin, n.originPoint = e.originPoint;
}
function Ww(n, e, t, r) {
  n.min = Lt(e.min, t.min, r), n.max = Lt(e.max, t.max, r);
}
function e5(n, e, t, r) {
  Ww(n.x, e.x, t.x, r), Ww(n.y, e.y, t.y, r);
}
function t5(n) {
  return n.animationValues && n.animationValues.opacityExit !== void 0;
}
const n5 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Uw = (n) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(n), $w = Uw("applewebkit/") && !Uw("chrome/") ? Math.round : Jr;
function Gw(n) {
  n.min = $w(n.min), n.max = $w(n.max);
}
function r5(n) {
  Gw(n.x), Gw(n.y);
}
function UD(n, e, t) {
  return n === "position" || n === "preserve-aspect" && !D$(Nw(e), Nw(t), 0.2);
}
function i5(n) {
  var e;
  return n !== n.root && ((e = n.scroll) == null ? void 0 : e.wasRoot);
}
const s5 = WD({
  attachResizeListener: (n, e) => Sc(n, "resize", e),
  measureScroll: () => {
    var n, e;
    return {
      x: document.documentElement.scrollLeft || ((n = document.body) == null ? void 0 : n.scrollLeft) || 0,
      y: document.documentElement.scrollTop || ((e = document.body) == null ? void 0 : e.scrollTop) || 0
    };
  },
  checkIsScrollRoot: () => !0
}), tm = {
  current: void 0
}, $D = WD({
  measureScroll: (n) => ({
    x: n.scrollLeft,
    y: n.scrollTop
  }),
  defaultParent: () => {
    if (!tm.current) {
      const n = new s5({});
      n.mount(window), n.setOptions({ layoutScroll: !0 }), tm.current = n;
    }
    return tm.current;
  },
  resetTransform: (n, e) => {
    n.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (n) => window.getComputedStyle(n).position === "fixed"
}), Sv = ps({
  transformPagePoint: (n) => n,
  isStatic: !1,
  reducedMotion: "never"
});
function o5(n = !0) {
  const e = In($y);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: r, register: i } = e, s = U2();
  St(() => {
    if (n)
      return i(s);
  }, [n]);
  const o = fn(() => n && r && r(s), [s, r, n]);
  return !t && r ? [!1, o] : [!0];
}
const GD = ps({ strict: !1 }), Yw = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let qw = !1;
function a5() {
  if (qw)
    return;
  const n = {};
  for (const e in Yw)
    n[e] = {
      isEnabled: (t) => Yw[e].some((r) => !!t[r])
    };
  vD(n), qw = !0;
}
function YD() {
  return a5(), e$();
}
function l5(n) {
  const e = YD();
  for (const t in n)
    e[t] = {
      ...e[t],
      ...n[t]
    };
  vD(e);
}
const c5 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Kd(n) {
  return n.startsWith("while") || n.startsWith("drag") && n !== "draggable" || n.startsWith("layout") || n.startsWith("onTap") || n.startsWith("onPan") || n.startsWith("onLayout") || c5.has(n);
}
let qD = (n) => !Kd(n);
function u5(n) {
  typeof n == "function" && (qD = (e) => e.startsWith("on") ? !Kd(e) : n(e));
}
try {
  u5(require("@emotion/is-prop-valid").default);
} catch {
}
function d5(n, e, t) {
  const r = {};
  for (const i in n)
    i === "values" && typeof n.values == "object" || (qD(i) || t === !0 && Kd(i) || !e && !Kd(i) || // If trying to use native HTML drag events, forward drag listeners
    n.draggable && i.startsWith("onDrag")) && (r[i] = n[i]);
  return r;
}
const Jf = /* @__PURE__ */ ps({});
function f5(n, e) {
  if (Kf(n)) {
    const { initial: t, animate: r } = n;
    return {
      initial: t === !1 || xc(t) ? t : void 0,
      animate: xc(r) ? r : void 0
    };
  }
  return n.inherit !== !1 ? e : {};
}
function h5(n) {
  const { initial: e, animate: t } = f5(n, In(Jf));
  return Vt(() => ({ initial: e, animate: t }), [Kw(e), Kw(t)]);
}
function Kw(n) {
  return Array.isArray(n) ? n.join(" ") : n;
}
const wv = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function KD(n, e, t) {
  for (const r in e)
    !gn(e[r]) && !CD(r, t) && (n[r] = e[r]);
}
function p5({ transformTemplate: n }, e) {
  return Vt(() => {
    const t = wv();
    return bv(t, e, n), Object.assign({}, t.vars, t.style);
  }, [e]);
}
function m5(n, e) {
  const t = n.style || {}, r = {};
  return KD(r, t, n), Object.assign(r, p5(n, e)), r;
}
function g5(n, e) {
  const t = {}, r = m5(n, e);
  return n.drag && n.dragListener !== !1 && (t.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = n.drag === !0 ? "none" : `pan-${n.drag === "x" ? "y" : "x"}`), n.tabIndex === void 0 && (n.onTap || n.onTapStart || n.whileTap) && (t.tabIndex = 0), t.style = r, t;
}
const JD = () => ({
  ...wv(),
  attrs: {}
});
function y5(n, e, t, r) {
  const i = Vt(() => {
    const s = JD();
    return RD(s, e, MD(r), n.transformTemplate, n.style), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [e]);
  if (n.style) {
    const s = {};
    KD(s, n.style, n), i.style = { ...s, ...i.style };
  }
  return i;
}
const v5 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ev(n) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof n != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    n.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(v5.indexOf(n) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(n))
    )
  );
}
function b5(n, e, t, { latestValues: r }, i, s = !1, o) {
  const c = (o ?? Ev(n) ? y5 : g5)(e, r, i, n), u = d5(e, typeof n == "string", s), f = n !== m1 ? { ...u, ...c, ref: t } : {}, { children: h } = e, p = Vt(() => gn(h) ? h.get() : h, [h]);
  return $m(n, {
    ...f,
    children: p
  });
}
function x5({ scrapeMotionValuesFromProps: n, createRenderState: e }, t, r, i) {
  return {
    latestValues: S5(t, r, i, n),
    renderState: e()
  };
}
function S5(n, e, t, r) {
  const i = {}, s = r(n, {});
  for (const p in s)
    i[p] = Sd(s[p]);
  let { initial: o, animate: a } = n;
  const c = Kf(n), u = yD(n);
  e && u && !c && n.inherit !== !1 && (o === void 0 && (o = e.initial), a === void 0 && (a = e.animate));
  let f = t ? t.initial === !1 : !1;
  f = f || o === !1;
  const h = f ? a : o;
  if (h && typeof h != "boolean" && !qf(h)) {
    const p = Array.isArray(h) ? h : [h];
    for (let g = 0; g < p.length; g++) {
      const y = cv(n, p[g]);
      if (y) {
        const { transitionEnd: x, transition: S, ...w } = y;
        for (const C in w) {
          let T = w[C];
          if (Array.isArray(T)) {
            const k = f ? T.length - 1 : 0;
            T = T[k];
          }
          T !== null && (i[C] = T);
        }
        for (const C in x)
          i[C] = x[C];
      }
    }
  }
  return i;
}
const QD = (n) => (e, t) => {
  const r = In(Jf), i = In($y), s = () => x5(n, e, r, i);
  return t ? s() : Uy(s);
}, w5 = /* @__PURE__ */ QD({
  scrapeMotionValuesFromProps: xv,
  createRenderState: wv
}), E5 = /* @__PURE__ */ QD({
  scrapeMotionValuesFromProps: _D,
  createRenderState: JD
}), A5 = Symbol.for("motionComponentSymbol");
function T5(n, e, t) {
  const r = vt(t);
  g1(() => {
    r.current = t;
  });
  const i = vt(null);
  return fn((s) => {
    var a;
    s && ((a = n.onMount) == null || a.call(n, s)), e && (s ? e.mount(s) : e.unmount());
    const o = r.current;
    if (typeof o == "function")
      if (s) {
        const c = o(s);
        typeof c == "function" && (i.current = c);
      } else i.current ? (i.current(), i.current = null) : o(s);
    else o && (o.current = s);
  }, [e]);
}
const ZD = ps({});
function Vl(n) {
  return n && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, "current");
}
function C5(n, e, t, r, i, s) {
  var w, C;
  const { visualElement: o } = In(Jf), a = In(GD), c = In($y), u = In(Sv).reducedMotion, f = vt(null), h = vt(!1);
  r = r || a.renderer, !f.current && r && (f.current = r(n, {
    visualState: e,
    parent: o,
    props: t,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u,
    isSVG: s
  }), h.current && f.current && (f.current.manuallyAnimateOnMount = !0));
  const p = f.current, g = In(ZD);
  p && !p.projection && i && (p.type === "html" || p.type === "svg") && D5(f.current, t, i, g);
  const y = vt(!1);
  g1(() => {
    p && y.current && p.update(t, c);
  });
  const x = t[rD], S = vt(!!x && !((w = window.MotionHandoffIsComplete) != null && w.call(window, x)) && ((C = window.MotionHasOptimisedAnimation) == null ? void 0 : C.call(window, x)));
  return mC(() => {
    h.current = !0, p && (y.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), p.scheduleRenderMicrotask(), S.current && p.animationState && p.animationState.animateChanges());
  }), St(() => {
    p && (!S.current && p.animationState && p.animationState.animateChanges(), S.current && (queueMicrotask(() => {
      var T;
      (T = window.MotionHandoffMarkAsComplete) == null || T.call(window, x);
    }), S.current = !1), p.enteringChildren = void 0);
  }), p;
}
function D5(n, e, t, r) {
  const { layoutId: i, layout: s, drag: o, dragConstraints: a, layoutScroll: c, layoutRoot: u, layoutCrossfade: f } = e;
  n.projection = new t(n.latestValues, e["data-framer-portal-id"] ? void 0 : XD(n.parent)), n.projection.setOptions({
    layoutId: i,
    layout: s,
    alwaysMeasureLayout: !!o || a && Vl(a),
    visualElement: n,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: r,
    crossfade: f,
    layoutScroll: c,
    layoutRoot: u
  });
}
function XD(n) {
  if (n)
    return n.options.allowProjection !== !1 ? n.projection : XD(n.parent);
}
function nm(n, { forwardMotionProps: e = !1, type: t } = {}, r, i) {
  r && l5(r);
  const s = t ? t === "svg" : Ev(n), o = s ? E5 : w5;
  function a(u, f) {
    let h;
    const p = {
      ...In(Sv),
      ...u,
      layoutId: R5(u)
    }, { isStatic: g } = p, y = h5(u), x = o(u, g);
    if (!g && pC) {
      k5(p, r);
      const S = M5(p);
      h = S.MeasureLayout, y.visualElement = C5(n, x, p, i, S.ProjectionNode, s);
    }
    return b.jsxs(Jf.Provider, { value: y, children: [h && y.visualElement ? b.jsx(h, { visualElement: y.visualElement, ...p }) : null, b5(n, u, T5(x, y.visualElement, f), x, g, e, s)] });
  }
  a.displayName = `motion.${typeof n == "string" ? n : `create(${n.displayName ?? n.name ?? ""})`}`;
  const c = hs(a);
  return c[A5] = n, c;
}
function R5({ layoutId: n }) {
  const e = In(hC).id;
  return e && n !== void 0 ? e + "-" + n : n;
}
function k5(n, e) {
  const t = In(GD).strict;
  if (process.env.NODE_ENV !== "production" && e && t) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    n.ignoreStrict ? il(!1, r, "lazy-strict-mode") : mi(!1, r, "lazy-strict-mode");
  }
}
function M5(n) {
  const e = YD(), { drag: t, layout: r } = e;
  if (!t && !r)
    return {};
  const i = { ...t, ...r };
  return {
    MeasureLayout: t != null && t.isEnabled(n) || r != null && r.isEnabled(n) ? i.MeasureLayout : void 0,
    ProjectionNode: i.ProjectionNode
  };
}
function _5(n, e) {
  if (typeof Proxy > "u")
    return nm;
  const t = /* @__PURE__ */ new Map(), r = (s, o) => nm(s, o, n, e), i = (s, o) => (process.env.NODE_ENV !== "production" && Yf(!1, "motion() is deprecated. Use motion.create() instead."), r(s, o));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (s, o) => o === "create" ? r : (t.has(o) || t.set(o, nm(o, void 0, n, e)), t.get(o))
  });
}
const O5 = (n, e) => e.isSVG ?? Ev(n) ? new OD(e) : new DD(e, {
  allowProjection: n !== m1
});
class I5 extends ro {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = S$(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    qf(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: t } = this.node.prevProps || {};
    e !== t && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let N5 = 0;
class P5 extends ro {
  constructor() {
    super(...arguments), this.id = N5++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: t } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    t && !e && i.then(() => {
      t(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: t } = this.node.presenceContext || {};
    t && t(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const L5 = {
  animation: {
    Feature: I5
  },
  exit: {
    Feature: P5
  }
};
function $c(n) {
  return {
    point: {
      x: n.pageX,
      y: n.pageY
    }
  };
}
const B5 = (n) => (e) => pv(e) && n(e, $c(e));
function Xl(n, e, t, r) {
  return Sc(n, e, B5(t), r);
}
const eR = ({ current: n }) => n ? n.ownerDocument.defaultView : null, Jw = (n, e) => Math.abs(n - e);
function j5(n, e) {
  const t = Jw(n.x, e.x), r = Jw(n.y, e.y);
  return Math.sqrt(t ** 2 + r ** 2);
}
const Qw = /* @__PURE__ */ new Set(["auto", "scroll"]);
class tR {
  constructor(e, t, { transformPagePoint: r, contextWindow: i = window, dragSnapToOrigin: s = !1, distanceThreshold: o = 3, element: a } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (g) => {
      this.handleScroll(g.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = im(this.lastMoveEventInfo, this.history), y = this.startEvent !== null, x = j5(g.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!y && !x)
        return;
      const { point: S } = g, { timestamp: w } = Mn;
      this.history.push({ ...S, timestamp: w });
      const { onStart: C, onMove: T } = this.handlers;
      y || (C && C(this.lastMoveEvent, g), this.startEvent = this.lastMoveEvent), T && T(this.lastMoveEvent, g);
    }, this.handlePointerMove = (g, y) => {
      this.lastMoveEvent = g, this.lastMoveEventInfo = rm(y, this.transformPagePoint), Dt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (g, y) => {
      this.end();
      const { onEnd: x, onSessionEnd: S, resumeAnimation: w } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && w && w(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const C = im(g.type === "pointercancel" ? this.lastMoveEventInfo : rm(y, this.transformPagePoint), this.history);
      this.startEvent && x && x(g, C), S && S(g, C);
    }, !pv(e))
      return;
    this.dragSnapToOrigin = s, this.handlers = t, this.transformPagePoint = r, this.distanceThreshold = o, this.contextWindow = i || window;
    const c = $c(e), u = rm(c, this.transformPagePoint), { point: f } = u, { timestamp: h } = Mn;
    this.history = [{ ...f, timestamp: h }];
    const { onSessionStart: p } = t;
    p && p(e, im(u, this.history)), this.removeListeners = Hc(Xl(this.contextWindow, "pointermove", this.handlePointerMove), Xl(this.contextWindow, "pointerup", this.handlePointerUp), Xl(this.contextWindow, "pointercancel", this.handlePointerUp)), a && this.startScrollTracking(a);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(e) {
    let t = e.parentElement;
    for (; t; ) {
      const r = getComputedStyle(t);
      (Qw.has(r.overflowX) || Qw.has(r.overflowY)) && this.scrollPositions.set(t, {
        x: t.scrollLeft,
        y: t.scrollTop
      }), t = t.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0,
      passive: !0
    }), window.addEventListener("scroll", this.onWindowScroll, {
      passive: !0
    }), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(e) {
    const t = this.scrollPositions.get(e);
    if (!t)
      return;
    const r = e === window, i = r ? { x: window.scrollX, y: window.scrollY } : {
      x: e.scrollLeft,
      y: e.scrollTop
    }, s = { x: i.x - t.x, y: i.y - t.y };
    s.x === 0 && s.y === 0 || (r ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += s.x, this.lastMoveEventInfo.point.y += s.y) : this.history.length > 0 && (this.history[0].x -= s.x, this.history[0].y -= s.y), this.scrollPositions.set(e, i), Dt.update(this.updatePoint, !0));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), cs(this.updatePoint);
  }
}
function rm(n, e) {
  return e ? { point: e(n.point) } : n;
}
function Zw(n, e) {
  return { x: n.x - e.x, y: n.y - e.y };
}
function im({ point: n }, e) {
  return {
    point: n,
    delta: Zw(n, nR(e)),
    offset: Zw(n, F5(e)),
    velocity: z5(e, 0.1)
  };
}
function F5(n) {
  return n[0];
}
function nR(n) {
  return n[n.length - 1];
}
function z5(n, e) {
  if (n.length < 2)
    return { x: 0, y: 0 };
  let t = n.length - 1, r = null;
  const i = nR(n);
  for (; t >= 0 && (r = n[t], !(i.timestamp - r.timestamp > /* @__PURE__ */ fi(e))); )
    t--;
  if (!r)
    return { x: 0, y: 0 };
  const s = /* @__PURE__ */ Kr(i.timestamp - r.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - r.x) / s,
    y: (i.y - r.y) / s
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function V5(n, { min: e, max: t }, r) {
  return e !== void 0 && n < e ? n = r ? Lt(e, n, r.min) : Math.max(n, e) : t !== void 0 && n > t && (n = r ? Lt(t, n, r.max) : Math.min(n, t)), n;
}
function Xw(n, e, t) {
  return {
    min: e !== void 0 ? n.min + e : void 0,
    max: t !== void 0 ? n.max + t - (n.max - n.min) : void 0
  };
}
function H5(n, { top: e, left: t, bottom: r, right: i }) {
  return {
    x: Xw(n.x, t, i),
    y: Xw(n.y, e, r)
  };
}
function eE(n, e) {
  let t = e.min - n.min, r = e.max - n.max;
  return e.max - e.min < n.max - n.min && ([t, r] = [r, t]), { min: t, max: r };
}
function W5(n, e) {
  return {
    x: eE(n.x, e.x),
    y: eE(n.y, e.y)
  };
}
function U5(n, e) {
  let t = 0.5;
  const r = Zn(n), i = Zn(e);
  return i > r ? t = /* @__PURE__ */ Qa(e.min, e.max - r, n.min) : r > i && (t = /* @__PURE__ */ Qa(n.min, n.max - i, e.min)), Oi(0, 1, t);
}
function $5(n, e) {
  const t = {};
  return e.min !== void 0 && (t.min = e.min - n.min), e.max !== void 0 && (t.max = e.max - n.min), t;
}
const Dg = 0.35;
function G5(n = Dg) {
  return n === !1 ? n = 0 : n === !0 && (n = Dg), {
    x: tE(n, "left", "right"),
    y: tE(n, "top", "bottom")
  };
}
function tE(n, e, t) {
  return {
    min: nE(n, e),
    max: nE(n, t)
  };
}
function nE(n, e) {
  return typeof n == "number" ? n : n[e] || 0;
}
const Y5 = /* @__PURE__ */ new WeakMap();
class q5 {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = nn(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, { snapToCursor: t = !1, distanceThreshold: r } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const s = (h) => {
      t ? (this.stopAnimation(), this.snapToCursor($c(h).point)) : this.pauseAnimation();
    }, o = (h, p) => {
      this.stopAnimation();
      const { drag: g, dragPropagation: y, onDragStart: x } = this.getProps();
      if (g && !y && (this.openDragLock && this.openDragLock(), this.openDragLock = $3(g), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = p, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Wr((w) => {
        let C = this.getAxisMotionValue(w).get() || 0;
        if (Mi.test(C)) {
          const { projection: T } = this.visualElement;
          if (T && T.layout) {
            const k = T.layout.layoutBox[w];
            k && (C = Zn(k) * (parseFloat(C) / 100));
          }
        }
        this.originPoint[w] = C;
      }), x && Dt.postRender(() => x(h, p)), Sg(this.visualElement, "transform");
      const { animationState: S } = this.visualElement;
      S && S.setActive("whileDrag", !0);
    }, a = (h, p) => {
      this.latestPointerEvent = h, this.latestPanInfo = p;
      const { dragPropagation: g, dragDirectionLock: y, onDirectionLock: x, onDrag: S } = this.getProps();
      if (!g && !this.openDragLock)
        return;
      const { offset: w } = p;
      if (y && this.currentDirection === null) {
        this.currentDirection = K5(w), this.currentDirection !== null && x && x(this.currentDirection);
        return;
      }
      this.updateAxis("x", p.point, w), this.updateAxis("y", p.point, w), this.visualElement.render(), S && S(h, p);
    }, c = (h, p) => {
      this.latestPointerEvent = h, this.latestPanInfo = p, this.stop(h, p), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => Wr((h) => {
      var p;
      return this.getAnimationState(h) === "paused" && ((p = this.getAxisMotionValue(h).animation) == null ? void 0 : p.play());
    }), { dragSnapToOrigin: f } = this.getProps();
    this.panSession = new tR(e, {
      onSessionStart: s,
      onStart: o,
      onMove: a,
      onSessionEnd: c,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: f,
      distanceThreshold: r,
      contextWindow: eR(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(e, t) {
    const r = e || this.latestPointerEvent, i = t || this.latestPanInfo, s = this.isDragging;
    if (this.cancel(), !s || !i || !r)
      return;
    const { velocity: o } = i;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && Dt.postRender(() => a(r, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: t } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), t && t.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(e, t, r) {
    const { drag: i } = this.getProps();
    if (!r || !Yu(e, i, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (o = V5(o, this.constraints[e], this.elastic[e])), s.set(o);
  }
  resolveConstraints() {
    var s;
    const { dragConstraints: e, dragElastic: t } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (s = this.visualElement.projection) == null ? void 0 : s.layout, i = this.constraints;
    e && Vl(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && r ? this.constraints = H5(r.layoutBox, e) : this.constraints = !1, this.elastic = G5(t), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && Wr((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = $5(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: t } = this.getProps();
    if (!e || !Vl(e))
      return !1;
    const r = e.current;
    mi(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const s = i$(r, i.root, this.visualElement.getTransformPagePoint());
    let o = W5(i.layout.layoutBox, s);
    if (t) {
      const a = t(t$(o));
      this.hasMutatedConstraints = !!a, a && (o = SD(a));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: t, dragMomentum: r, dragElastic: i, dragTransition: s, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), c = this.constraints || {}, u = Wr((f) => {
      if (!Yu(f, t, this.currentDirection))
        return;
      let h = c && c[f] || {};
      o && (h = { min: 0, max: 0 });
      const p = i ? 200 : 1e6, g = i ? 40 : 1e7, y = {
        type: "inertia",
        velocity: r ? e[f] : 0,
        bounceStiffness: p,
        bounceDamping: g,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...h
      };
      return this.startAxisValueAnimation(f, y);
    });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(e, t) {
    const r = this.getAxisMotionValue(e);
    return Sg(this.visualElement, e), r.start(lv(e, r, 0, t, this.visualElement, !1));
  }
  stopAnimation() {
    Wr((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    Wr((e) => {
      var t;
      return (t = this.getAxisMotionValue(e).animation) == null ? void 0 : t.pause();
    });
  }
  getAnimationState(e) {
    var t;
    return (t = this.getAxisMotionValue(e).animation) == null ? void 0 : t.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const t = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps(), i = r[t];
    return i || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    Wr((t) => {
      const { drag: r } = this.getProps();
      if (!Yu(t, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, s = this.getAxisMotionValue(t);
      if (i && i.layout) {
        const { min: o, max: a } = i.layout.layoutBox[t], c = s.get() || 0;
        s.set(e[t] - Lt(o, a, 0.5) + c);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: t } = this.getProps(), { projection: r } = this.visualElement;
    if (!Vl(t) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Wr((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const c = a.get();
        i[o] = U5({ min: c, max: c }, this.constraints[o]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Wr((o) => {
      if (!Yu(o, e, null))
        return;
      const a = this.getAxisMotionValue(o), { min: c, max: u } = this.constraints[o];
      a.set(Lt(c, u, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Y5.set(this.visualElement, this);
    const e = this.visualElement.current, t = Xl(e, "pointerdown", (c) => {
      const { drag: u, dragListener: f = !0 } = this.getProps(), h = c.target, p = h !== e && pD(h);
      u && f && !p && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      Vl(c) && c.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, s = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), Dt.read(r);
    const o = Sc(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: u }) => {
      this.isDragging && u && (Wr((f) => {
        const h = this.getAxisMotionValue(f);
        h && (this.originPoint[f] += c[f].translate, h.set(h.get() + c[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), t(), s(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: t = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: s = !1, dragElastic: o = Dg, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: t,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: s,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function Yu(n, e, t) {
  return (e === !0 || e === n) && (t === null || t === n);
}
function K5(n, e = 10) {
  let t = null;
  return Math.abs(n.y) > e ? t = "y" : Math.abs(n.x) > e && (t = "x"), t;
}
class J5 extends ro {
  constructor(e) {
    super(e), this.removeGroupControls = Jr, this.removeListeners = Jr, this.controls = new q5(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Jr;
  }
  update() {
    const { dragControls: e } = this.node.getProps(), { dragControls: t } = this.node.prevProps || {};
    e !== t && (this.removeGroupControls(), e && (this.removeGroupControls = e.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const rE = (n) => (e, t) => {
  n && Dt.postRender(() => n(e, t));
};
class Q5 extends ro {
  constructor() {
    super(...arguments), this.removePointerDownListener = Jr;
  }
  onPointerDown(e) {
    this.session = new tR(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: eR(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: t, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: rE(e),
      onStart: rE(t),
      onMove: r,
      onEnd: (s, o) => {
        delete this.session, i && Dt.postRender(() => i(s, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Xl(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let sm = !1;
class Z5 extends hy {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: t, switchLayoutGroup: r, layoutId: i } = this.props, { projection: s } = e;
    s && (t.group && t.group.add(s), r && r.register && i && r.register(s), sm && s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), wd.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: t, visualElement: r, drag: i, isPresent: s } = this.props, { projection: o } = r;
    return o && (o.isPresent = s, e.layoutDependency !== t && o.setOptions({
      ...o.options,
      layoutDependency: t
    }), sm = !0, i || e.layoutDependency !== t || t === void 0 || e.isPresent !== s ? o.willUpdate() : this.safeToRemove(), e.isPresent !== s && (s ? o.promote() : o.relegate() || Dt.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), hv.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: t, switchLayoutGroup: r } = this.props, { projection: i } = e;
    sm = !0, i && (i.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function rR(n) {
  const [e, t] = o5(), r = In(hC);
  return b.jsx(Z5, { ...n, layoutGroup: r, switchLayoutGroup: In(ZD), isPresent: e, safeToRemove: t });
}
const X5 = {
  pan: {
    Feature: Q5
  },
  drag: {
    Feature: J5,
    ProjectionNode: $D,
    MeasureLayout: rR
  }
};
function iE(n, e, t) {
  const { props: r } = n;
  n.animationState && r.whileHover && n.animationState.setActive("whileHover", t === "Start");
  const i = "onHover" + t, s = r[i];
  s && Dt.postRender(() => s(e, $c(e)));
}
class e4 extends ro {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = G3(e, (t, r) => (iE(this.node, r, "Start"), (i) => iE(this.node, i, "End"))));
  }
  unmount() {
  }
}
class t4 extends ro {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Hc(Sc(this.node.current, "focus", () => this.onFocus()), Sc(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function sE(n, e, t) {
  const { props: r } = n;
  if (n.current instanceof HTMLButtonElement && n.current.disabled)
    return;
  n.animationState && r.whileTap && n.animationState.setActive("whileTap", t === "Start");
  const i = "onTap" + (t === "End" ? "" : t), s = r[i];
  s && Dt.postRender(() => s(e, $c(e)));
}
class n4 extends ro {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = K3(e, (t, r) => (sE(this.node, r, "Start"), (i, { success: s }) => sE(this.node, i, s ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Rg = /* @__PURE__ */ new WeakMap(), om = /* @__PURE__ */ new WeakMap(), r4 = (n) => {
  const e = Rg.get(n.target);
  e && e(n);
}, i4 = (n) => {
  n.forEach(r4);
};
function s4({ root: n, ...e }) {
  const t = n || document;
  om.has(t) || om.set(t, {});
  const r = om.get(t), i = JSON.stringify(e);
  return r[i] || (r[i] = new IntersectionObserver(i4, { root: n, ...e })), r[i];
}
function o4(n, e, t) {
  const r = s4(e);
  return Rg.set(n, t), r.observe(n), () => {
    Rg.delete(n), r.unobserve(n);
  };
}
const a4 = {
  some: 0,
  all: 1
};
class l4 extends ro {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: t, margin: r, amount: i = "some", once: s } = e, o = {
      root: t ? t.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : a4[i]
    }, a = (c) => {
      const { isIntersecting: u } = c;
      if (this.isInView === u || (this.isInView = u, s && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: f, onViewportLeave: h } = this.node.getProps(), p = u ? f : h;
      p && p(c);
    };
    return o4(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: t } = this.node;
    ["amount", "margin", "root"].some(c4(e, t)) && this.startObserver();
  }
  unmount() {
  }
}
function c4({ viewport: n = {} }, { viewport: e = {} } = {}) {
  return (t) => n[t] !== e[t];
}
const u4 = {
  inView: {
    Feature: l4
  },
  tap: {
    Feature: n4
  },
  focus: {
    Feature: t4
  },
  hover: {
    Feature: e4
  }
}, d4 = {
  layout: {
    ProjectionNode: $D,
    MeasureLayout: rR
  }
}, f4 = {
  ...L5,
  ...u4,
  ...X5,
  ...d4
}, us = /* @__PURE__ */ _5(f4, O5);
function kg(n) {
  const e = Uy(() => $o(n)), { isStatic: t } = In(Sv);
  if (t) {
    const [, r] = wt(n);
    St(() => e.on("change", r), []);
  }
  return e;
}
function iR(n, e) {
  const t = kg(e()), r = () => t.set(e());
  return r(), mC(() => {
    const i = () => Dt.preRender(r, !1, !0), s = n.map((o) => o.on("change", i));
    return () => {
      s.forEach((o) => o()), cs(r);
    };
  }), t;
}
function h4(n) {
  Ql.current = [], n();
  const e = iR(Ql.current, n);
  return Ql.current = void 0, e;
}
function ec(n, e, t, r) {
  if (typeof n == "function")
    return h4(n);
  const s = typeof e == "function" ? e : xd(e, t, r);
  return Array.isArray(n) ? oE(n, s) : oE([n], ([o]) => s(o));
}
function oE(n, e) {
  const t = Uy(() => []);
  return iR(n, () => {
    t.length = 0;
    const r = n.length;
    for (let i = 0; i < r; i++)
      t[i] = n[i].get();
    return e(t);
  });
}
function p4() {
  !gv.current && gD();
  const [n] = wt($d.current);
  return process.env.NODE_ENV !== "production" && Yf(n !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), n;
}
function Av(n) {
  return typeof n == "object" && !Array.isArray(n);
}
function sR(n, e, t, r) {
  return n == null ? [] : typeof n == "string" && Av(e) ? cD(n, t, r) : n instanceof NodeList ? Array.from(n) : Array.isArray(n) ? n.filter((i) => i != null) : [n];
}
function m4(n, e, t) {
  return n * (e + 1);
}
function aE(n, e, t, r) {
  return typeof e == "number" ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, n + parseFloat(e)) : e === "<" ? t : e.startsWith("<") ? Math.max(0, t + parseFloat(e.slice(1))) : r.get(e) ?? n;
}
function g4(n, e, t) {
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    i.at > e && i.at < t && (Vc(n, i), r--);
  }
}
function y4(n, e, t, r, i, s) {
  g4(n, i, s);
  for (let o = 0; o < e.length; o++)
    n.push({
      value: e[o],
      at: Lt(i, s, r[o]),
      easing: MC(t, o)
    });
}
function v4(n, e) {
  for (let t = 0; t < n.length; t++)
    n[t] = n[t] / (e + 1);
}
function b4(n, e) {
  return n.at === e.at ? n.value === null ? 1 : e.value === null ? -1 : 0 : n.at - e.at;
}
const x4 = "easeInOut", S4 = 20;
function w4(n, { defaultTransition: e = {}, ...t } = {}, r, i) {
  const s = e.duration || 0.3, o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), c = {}, u = /* @__PURE__ */ new Map();
  let f = 0, h = 0, p = 0;
  for (let g = 0; g < n.length; g++) {
    const y = n[g];
    if (typeof y == "string") {
      u.set(y, h);
      continue;
    } else if (!Array.isArray(y)) {
      u.set(y.name, aE(h, y.at, f, u));
      continue;
    }
    let [x, S, w = {}] = y;
    w.at !== void 0 && (h = aE(h, w.at, f, u));
    let C = 0;
    const T = (k, R, P, L = 0, B = 0) => {
      const W = E4(k), { delay: X = 0, times: ce = YC(W), type: Re = e.type || "keyframes", repeat: ke, repeatType: J, repeatDelay: re = 0, ...G } = R;
      let { ease: $ = e.ease || "easeOut", duration: K } = R;
      const Se = typeof X == "function" ? X(L, B) : X, z = W.length, Q = ov(Re) ? Re : i == null ? void 0 : i[Re || "keyframes"];
      if (z <= 2 && Q) {
        let ie = 100;
        if (z === 2 && C4(W)) {
          const ee = W[1] - W[0];
          ie = Math.abs(ee);
        }
        const q = {
          ...e,
          ...G
        };
        K !== void 0 && (q.duration = /* @__PURE__ */ fi(K));
        const de = WC(q, ie, Q);
        $ = de.ease, K = de.duration;
      }
      K ?? (K = s);
      const ge = h + Se;
      ce.length === 1 && ce[0] === 0 && (ce[1] = 1);
      const me = ce.length - W.length;
      if (me > 0 && GC(ce, me), W.length === 1 && W.unshift(null), ke) {
        mi(ke < S4, "Repeat count too high, must be less than 20", "repeat-count-high"), K = m4(K, ke);
        const ie = [...W], q = [...ce];
        $ = Array.isArray($) ? [...$] : [$];
        const de = [...$];
        for (let ee = 0; ee < ke; ee++) {
          W.push(...ie);
          for (let he = 0; he < ie.length; he++)
            ce.push(q[he] + (ee + 1)), $.push(he === 0 ? "linear" : MC(de, he - 1));
        }
        v4(ce, ke);
      }
      const V = ge + K;
      y4(P, W, $, ce, ge, V), C = Math.max(Se + K, C), p = Math.max(V, p);
    };
    if (gn(x)) {
      const k = lE(x, a);
      T(S, w, cE("default", k));
    } else {
      const k = sR(x, S, r, c), R = k.length;
      for (let P = 0; P < R; P++) {
        S = S, w = w;
        const L = k[P], B = lE(L, a);
        for (const W in S)
          T(S[W], A4(w, W), cE(W, B), P, R);
      }
    }
    f = h, h += C;
  }
  return a.forEach((g, y) => {
    for (const x in g) {
      const S = g[x];
      S.sort(b4);
      const w = [], C = [], T = [];
      for (let L = 0; L < S.length; L++) {
        const { at: B, value: W, easing: X } = S[L];
        w.push(W), C.push(/* @__PURE__ */ Qa(0, p, B)), T.push(X || "easeOut");
      }
      C[0] !== 0 && (C.unshift(0), w.unshift(w[0]), T.unshift(x4)), C[C.length - 1] !== 1 && (C.push(1), w.push(null)), o.has(y) || o.set(y, {
        keyframes: {},
        transition: {}
      });
      const k = o.get(y);
      k.keyframes[x] = w;
      const { type: R, ...P } = e;
      k.transition[x] = {
        ...P,
        duration: p,
        ease: T,
        times: C,
        ...t
      };
    }
  }), o;
}
function lE(n, e) {
  return !e.has(n) && e.set(n, {}), e.get(n);
}
function cE(n, e) {
  return e[n] || (e[n] = []), e[n];
}
function E4(n) {
  return Array.isArray(n) ? n : [n];
}
function A4(n, e) {
  return n && n[e] ? {
    ...n,
    ...n[e]
  } : { ...n };
}
const T4 = (n) => typeof n == "number", C4 = (n) => n.every(T4);
function D4(n) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, t = mv(n) && !mD(n) ? new OD(e) : new DD(e);
  t.mount(n), bc.set(n, t);
}
function R4(n) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, t = new d$(e);
  t.mount(n), bc.set(n, t);
}
function k4(n, e) {
  return gn(n) || typeof n == "number" || typeof n == "string" && !Av(e);
}
function oR(n, e, t, r) {
  const i = [];
  if (k4(n, e))
    i.push(VD(n, Av(e) && e.default || e, t && (t.default || t)));
  else {
    if (n == null)
      return i;
    const s = sR(n, e, r), o = s.length;
    mi(!!o, "No valid elements provided.", "no-valid-elements");
    for (let a = 0; a < o; a++) {
      const c = s[a], u = c instanceof Element ? D4 : R4;
      bc.has(c) || u(c);
      const f = bc.get(c), h = { ...t };
      "delay" in h && typeof h.delay == "function" && (h.delay = h.delay(a, o)), i.push(...dv(f, { ...e, transition: h }, {}));
    }
  }
  return i;
}
function M4(n, e, t) {
  const r = [];
  return w4(n, e, t, { spring: vc }).forEach(({ keyframes: s, transition: o }, a) => {
    r.push(...oR(a, s, o));
  }), r;
}
function _4(n) {
  return Array.isArray(n) && n.some(Array.isArray);
}
function O4(n = {}) {
  const { scope: e, reduceMotion: t } = n;
  function r(i, s, o) {
    let a = [], c;
    if (_4(i))
      a = M4(i, t !== void 0 ? { reduceMotion: t, ...s } : s, e);
    else {
      const { onComplete: f, ...h } = o || {};
      typeof f == "function" && (c = f), a = oR(i, s, t !== void 0 ? { reduceMotion: t, ...h } : h, e);
    }
    const u = new f3(a);
    return c && u.finished.then(c), e && (e.animations.push(u), u.finished.then(() => {
      Vc(e.animations, u);
    })), u;
  }
  return r;
}
const qu = O4();
function uE(n, e) {
  let t;
  return (...r) => {
    window.clearTimeout(t), t = window.setTimeout(() => n(...r), e);
  };
}
function I4({ debounce: n, scroll: e, polyfill: t, offsetSize: r } = { debounce: 0, scroll: !1, offsetSize: !1 }) {
  const i = t || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!i) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [s, o] = wt({ left: 0, top: 0, width: 0, height: 0, bottom: 0, right: 0, x: 0, y: 0 }), a = vt({ element: null, scrollContainers: null, resizeObserver: null, lastBounds: s, orientationHandler: null }), c = n ? typeof n == "number" ? n : n.scroll : null, u = n ? typeof n == "number" ? n : n.resize : null, f = vt(!1);
  St(() => (f.current = !0, () => void (f.current = !1)));
  const [h, p, g] = Vt(() => {
    const w = () => {
      if (!a.current.element) return;
      const { left: C, top: T, width: k, height: R, bottom: P, right: L, x: B, y: W } = a.current.element.getBoundingClientRect(), X = { left: C, top: T, width: k, height: R, bottom: P, right: L, x: B, y: W };
      a.current.element instanceof HTMLElement && r && (X.height = a.current.element.offsetHeight, X.width = a.current.element.offsetWidth), Object.freeze(X), f.current && !B4(a.current.lastBounds, X) && o(a.current.lastBounds = X);
    };
    return [w, u ? uE(w, u) : w, c ? uE(w, c) : w];
  }, [o, r, c, u]);
  function y() {
    a.current.scrollContainers && (a.current.scrollContainers.forEach((w) => w.removeEventListener("scroll", g, !0)), a.current.scrollContainers = null), a.current.resizeObserver && (a.current.resizeObserver.disconnect(), a.current.resizeObserver = null), a.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", a.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", a.current.orientationHandler));
  }
  function x() {
    a.current.element && (a.current.resizeObserver = new i(g), a.current.resizeObserver.observe(a.current.element), e && a.current.scrollContainers && a.current.scrollContainers.forEach((w) => w.addEventListener("scroll", g, { capture: !0, passive: !0 })), a.current.orientationHandler = () => {
      g();
    }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", a.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", a.current.orientationHandler));
  }
  const S = (w) => {
    !w || w === a.current.element || (y(), a.current.element = w, a.current.scrollContainers = aR(w), x());
  };
  return P4(g, !!e), N4(p), St(() => {
    y(), x();
  }, [e, g, p]), St(() => y, []), [S, s, h];
}
function N4(n) {
  St(() => {
    const e = n;
    return window.addEventListener("resize", e), () => void window.removeEventListener("resize", e);
  }, [n]);
}
function P4(n, e) {
  St(() => {
    if (e) {
      const t = n;
      return window.addEventListener("scroll", t, { capture: !0, passive: !0 }), () => void window.removeEventListener("scroll", t, !0);
    }
  }, [n, e]);
}
function aR(n) {
  const e = [];
  if (!n || n === document.body) return e;
  const { overflow: t, overflowX: r, overflowY: i } = window.getComputedStyle(n);
  return [t, r, i].some((s) => s === "auto" || s === "scroll") && e.push(n), [...e, ...aR(n.parentElement)];
}
const L4 = ["x", "y", "top", "bottom", "left", "right", "width", "height"], B4 = (n, e) => L4.every((t) => n[t] === e[t]);
var lR = ps(
  void 0
);
function Gc() {
  const n = In(lR);
  if (!n) throw new Error("Sheet context error");
  return n;
}
var ds = {
  root: {
    base: {
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      overflow: "hidden",
      pointerEvents: "none"
    },
    decorative: {}
  },
  backdrop: {
    base: {
      zIndex: 1,
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      touchAction: "none",
      userSelect: "none"
    },
    decorative: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      border: "none",
      WebkitTapHighlightColor: "transparent"
    }
  },
  container: {
    base: {
      zIndex: 2,
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "100%",
      pointerEvents: "auto",
      display: "flex",
      flexDirection: "column"
    },
    decorative: {
      backgroundColor: "#fff",
      borderTopRightRadius: "8px",
      borderTopLeftRadius: "8px",
      boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)"
    }
  },
  headerWrapper: {
    base: {
      width: "100%"
    },
    decorative: {}
  },
  header: {
    base: {
      width: "100%",
      position: "relative"
    },
    decorative: {
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  },
  indicatorWrapper: {
    base: {
      display: "flex"
    },
    decorative: {}
  },
  indicator: {
    base: {
      display: "inline-block"
    },
    decorative: {
      width: "18px",
      height: "4px",
      borderRadius: "99px",
      backgroundColor: "#ddd"
    }
  },
  content: {
    base: {
      minHeight: "0px",
      position: "relative",
      flexGrow: 1,
      display: "flex",
      flexDirection: "column"
    },
    decorative: {}
  },
  scroller: {
    base: {
      height: "100%",
      overflowY: "auto",
      overscrollBehaviorY: "none"
    },
    decorative: {}
  }
}, dE = "calc(100% - env(safe-area-inset-top) - 34px)", wc = typeof window > "u", j4 = {
  ease: "easeOut",
  duration: 0.2
}, F4 = {
  ease: "linear",
  duration: 0.01
}, z4 = 0.6, V4 = 500;
function fs(n, e) {
  return e ? n.base : { ...n.base, ...n.decorative };
}
function H4(n) {
  for (let e = 0; e < n.length; e++)
    if (n[e + 1] < n[e]) return !1;
  return !0;
}
function Jd(n) {
  return (e) => {
    n.forEach((t) => {
      typeof t == "function" ? t(e) : t && (t.current = e);
    });
  };
}
function Tv(n) {
  var e;
  return typeof window < "u" && window.navigator != null ? n.test(
    // @ts-expect-error
    ((e = window.navigator.userAgentData) == null ? void 0 : e.platform) || window.navigator.platform
  ) : !1;
}
function Qf(n) {
  let e = null;
  return () => (e == null && (e = n()), e);
}
var W4 = Qf(function() {
  return Tv(/^Mac/i);
}), U4 = Qf(function() {
  return Tv(/^iPhone/i);
}), $4 = Qf(function() {
  return Tv(/^iPad/i) || W4() && navigator.maxTouchPoints > 1;
}), G4 = Qf(function() {
  return U4() || $4();
});
function Y4(n, e = 50, t = 20) {
  return new Promise((r) => {
    let i = 0;
    const s = setInterval(() => {
      const o = document.getElementsByClassName(
        n
      )[0];
      i++, (o || i >= t) && (clearInterval(s), r(o));
    }, e);
  });
}
var q4 = (n) => !!n.onClick || !!n.onTap, cR = hs(
  ({ style: n, className: e = "", unstyled: t, ...r }, i) => {
    const s = Gc(), o = q4(r), a = o ? us.button : us.div, c = o ? "auto" : "none", u = t ?? s.unstyled, f = {
      ...fs(ds.backdrop, u),
      ...n,
      pointerEvents: c
    };
    return /* @__PURE__ */ Fe.createElement(
      a,
      {
        ...r,
        ref: i,
        className: `react-modal-sheet-backdrop ${e}`,
        style: f,
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 1 }
      }
    );
  }
);
cR.displayName = "SheetBackdrop";
var uR = hs(
  ({ children: n, style: e, className: t = "", unstyled: r, ...i }, s) => {
    const o = Gc(), a = r ?? o.unstyled, c = {
      ...fs(ds.container, a),
      ...e,
      y: o.y
    };
    return o.detent === "default" && (c.height = dE), o.detent === "full" && (c.height = "100%", c.maxHeight = "100%"), o.detent === "content" && (c.height = "auto", c.maxHeight = dE), /* @__PURE__ */ Fe.createElement(
      us.div,
      {
        ...i,
        ref: Jd([
          s,
          o.sheetRef,
          o.sheetBoundsRef
        ]),
        className: `react-modal-sheet-container ${t}`,
        style: c
      },
      n
    );
  }
);
uR.displayName = "SheetContainer";
var K4 = { bottom: 0, top: 0, left: 0, right: 0 };
function dR() {
  const n = vt(null), e = fn(() => K4, []);
  return { ref: n, onMeasure: e };
}
function J4(n = {}) {
  const { debounceDelay: e = 32, isEnabled: t = !0 } = n, [r, i] = wt(null), [s, o] = wt(void 0);
  return St(() => {
    if (!r || !t) return;
    let a = null;
    function c(h) {
      const { scrollTop: p, scrollHeight: g, clientHeight: y } = h;
      if (!(g > y)) {
        s && o(void 0);
        return;
      }
      const S = p <= 0, w = Math.ceil(g) - Math.ceil(p) === Math.ceil(y);
      let C;
      S ? C = "top" : w ? C = "bottom" : C = "middle", C !== s && o(C);
    }
    function u(h) {
      if (h.currentTarget instanceof HTMLElement) {
        const p = h.currentTarget;
        a && clearTimeout(a), e === 0 ? c(p) : a = setTimeout(
          () => c(p),
          e
        );
      }
    }
    function f(h) {
      h.currentTarget instanceof HTMLElement && c(h.currentTarget);
    }
    return c(r), r.addEventListener("scroll", u), r.addEventListener("touchstart", f), () => {
      a && clearTimeout(a), r.removeEventListener("scroll", u), r.removeEventListener("touchstart", f);
    };
  }, [r, t]), {
    scrollRef: (a) => i(a),
    scrollPosition: s
  };
}
var fR = hs(
  ({
    disableScroll: n,
    disableDrag: e,
    children: t,
    style: r,
    className: i = "",
    scrollClassName: s = "",
    scrollStyle: o,
    scrollRef: a = null,
    unstyled: c,
    ...u
  }, f) => {
    const h = Gc(), p = dR(), g = J4(), y = typeof n == "function" ? n({
      scrollPosition: g.scrollPosition,
      currentSnap: h.currentSnap
    }) : !!n, x = !y && g.scrollPosition && g.scrollPosition !== "top", C = (typeof e == "function" ? e({
      scrollPosition: g.scrollPosition,
      currentSnap: h.currentSnap
    }) : !!e) || x || h.disableDrag || h.disableDrag ? void 0 : h.dragProps, T = c ?? h.unstyled, k = {
      ...fs(ds.content, T),
      ...r
    }, R = fs(ds.scroller, T);
    return h.avoidKeyboard && (R.paddingBottom = "env(keyboard-inset-height, var(--keyboard-inset-height, 0px))"), y && (R.overflowY = "hidden"), /* @__PURE__ */ Fe.createElement(
      us.div,
      {
        ...u,
        ref: Jd([f, p.ref]),
        className: `react-modal-sheet-content ${i}`,
        style: k,
        ...C,
        dragConstraints: p.ref,
        onMeasureDragConstraints: p.onMeasure
      },
      /* @__PURE__ */ Fe.createElement(
        us.div,
        {
          ref: Jd([g.scrollRef, a]),
          style: { ...R, ...o },
          className: `react-modal-sheet-content-scroller ${s}`
        },
        t
      )
    );
  }
);
fR.displayName = "SheetContent";
function hR({
  style: n,
  className: e = "",
  unstyled: t,
  ...r
}) {
  const i = Gc(), s = ec(
    i.indicatorRotation,
    (f) => `translateX(2px) rotate(${f}deg)`
  ), o = ec(
    i.indicatorRotation,
    (f) => `translateX(-2px) rotate(${-1 * f}deg)`
  ), a = t ?? i.unstyled, c = {
    ...fs(ds.indicatorWrapper, a),
    ...n
  }, u = fs(ds.indicator, a);
  return /* @__PURE__ */ Fe.createElement(
    "div",
    {
      className: `react-modal-sheet-drag-indicator-container ${e}`,
      style: c,
      ...r
    },
    /* @__PURE__ */ Fe.createElement(
      us.span,
      {
        className: "react-modal-sheet-drag-indicator",
        style: { ...u, transform: s }
      }
    ),
    /* @__PURE__ */ Fe.createElement(
      us.span,
      {
        className: "react-modal-sheet-drag-indicator",
        style: { ...u, transform: o }
      }
    )
  );
}
var pR = hs(
  ({ children: n, style: e, disableDrag: t, unstyled: r, className: i = "", ...s }, o) => {
    const a = Gc(), c = dR(), u = t || a.disableDrag ? void 0 : a.dragProps, f = r ?? a.unstyled, h = {
      ...fs(ds.headerWrapper, f),
      ...e
    }, p = fs(ds.header, f);
    return /* @__PURE__ */ Fe.createElement(
      us.div,
      {
        ...s,
        ref: Jd([o, c.ref]),
        style: h,
        className: `react-modal-sheet-header-container ${i}`,
        ...u,
        dragConstraints: c.ref,
        onMeasureDragConstraints: c.onMeasure
      },
      n || /* @__PURE__ */ Fe.createElement("div", { className: "react-modal-sheet-header", style: p }, /* @__PURE__ */ Fe.createElement(hR, null))
    );
  }
);
pR.displayName = "SheetHeader";
var Ec = wc ? St : py;
function Q4() {
  const [n, e] = wt(() => ({
    windowHeight: wc ? 0 : window.innerHeight,
    windowWidth: wc ? 0 : window.innerWidth
  }));
  return Ec(() => {
    function t() {
      e({
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
      });
    }
    return t(), window.addEventListener("resize", t), () => {
      window.removeEventListener("resize", t);
    };
  }, []), n;
}
function Z4() {
  const [n] = wt(() => {
    const e = { top: 0, left: 0, right: 0, bottom: 0 };
    if (wc) return e;
    const t = document.querySelector(":root");
    if (!t) return e;
    t.style.setProperty("--rms-sat", "env(safe-area-inset-top)"), t.style.setProperty("--rms-sal", "env(safe-area-inset-left)"), t.style.setProperty("--rms-sar", "env(safe-area-inset-right)"), t.style.setProperty("--rms-sab", "env(safe-area-inset-bottom)");
    const r = getComputedStyle(t), i = Ku(r, "--rms-sat"), s = Ku(r, "--rms-sal"), o = Ku(r, "--rms-sar"), a = Ku(r, "--rms-sab");
    return t.style.removeProperty("--rms-sat"), t.style.removeProperty("--rms-sal"), t.style.removeProperty("--rms-sar"), t.style.removeProperty("--rms-sab"), { top: i, left: s, right: o, bottom: a };
  });
  return n;
}
function Ku(n, e) {
  const t = n.getPropertyValue(e).replace("px", "").trim();
  return parseInt(t, 10) || 0;
}
function X4({
  y: n,
  detent: e,
  rootId: t,
  sheetHeight: r,
  snapPoints: i,
  startThreshold: s
}) {
  const o = Z4().top;
  let a = t;
  a && e === "full" && (console.warn('Using "full" detent with modal effect is not supported.'), a = void 0), Ec(() => () => {
    a && fE(a);
  }, []), Ec(() => {
    if (!a) return;
    const c = document.querySelector(`#${a}`);
    if (!c) return;
    const u = n.on("animationStart", () => {
      e6(a);
    }), f = n.on("change", (y) => {
      if (!c) return;
      let x = Math.max(0, 1 - y / r);
      const S = i.length > 1 ? i[i.length - 2] : void 0;
      if (S !== void 0) {
        const R = S.snapValueY;
        y <= R ? x = (R - y) / R : x = 0;
      }
      if (s !== void 0) {
        const R = r - Math.min(Math.floor(s * r), r);
        y <= R ? x = (R - y) / R : x = 0;
      }
      x = Math.max(0, Math.min(1, x));
      const w = window.innerWidth, C = xd(x, [0, 1], [0, 24 + o]), T = xd(x, [0, 1], [1, (w - 16) / w]), k = xd(x, [0, 1], [0, 10]);
      c.style.transform = `scale(${T}) translate3d(0, ${C}px, 0)`, c.style.borderTopRightRadius = `${k}px`, c.style.borderTopLeftRadius = `${k}px`;
    });
    function h() {
      n.get() - 5 >= r && fE(a);
    }
    const p = n.on("animationComplete", h), g = n.on("animationCancel", h);
    return () => {
      u(), f(), p(), g();
    };
  }, [n, a, o, s, r]);
}
function e6(n) {
  const e = document.querySelector(`#${n}`), t = document.querySelector("body");
  e && (t.style.backgroundColor = "#000", e.style.overflow = "hidden", e.style.transitionTimingFunction = "cubic-bezier(0.32, 0.72, 0, 1)", e.style.transitionProperty = "transform, border-radius", e.style.transitionDuration = "0.5s", e.style.transformOrigin = "center top");
}
function fE(n) {
  const e = document.querySelector(`#${n}`), t = document.querySelector("body");
  e && (t.style.removeProperty("background-color"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-timing-function"), e.style.removeProperty("transition-property"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transform-origin"), e.style.removeProperty("transform"), e.style.removeProperty("border-top-right-radius"), e.style.removeProperty("border-top-left-radius"));
}
var t6 = 24;
function Mg(...n) {
  return (...e) => {
    for (const t of n)
      typeof t == "function" && t(...e);
  };
}
var am = typeof document < "u" && window.visualViewport;
function hE(n, e) {
  if (!n)
    return !1;
  const t = window.getComputedStyle(n);
  let r = /(auto|scroll)/.test(
    t.overflow + t.overflowX + t.overflowY
  );
  return r && e && (r = n.scrollHeight !== n.clientHeight || n.scrollWidth !== n.clientWidth), r;
}
function mR(n, e) {
  let t = n;
  for (hE(t, e) && (t = t.parentElement); t && !hE(t, e); )
    t = t.parentElement;
  return t || document.scrollingElement || document.documentElement;
}
var n6 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), Ju = 0, Qu;
function r6(n = {}) {
  const { isDisabled: e } = n;
  Ec(() => {
    if (!e)
      return Ju++, Ju === 1 && (G4() ? Qu = s6() : Qu = i6()), () => {
        Ju--, Ju === 0 && (Qu == null || Qu());
      };
  }, [e]);
}
function i6() {
  return Mg(
    tc(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    tc(document.documentElement, "overflow", "hidden")
  );
}
function s6() {
  let n, e = 0;
  const t = (h) => {
    var p;
    const g = (p = h.composedPath()) == null ? void 0 : p[0];
    n = mR(g, !0), !(n === document.documentElement && n === document.body) && (e = h.changedTouches[0].pageY);
  }, r = (h) => {
    if (n === void 0)
      return;
    if (!n || n === document.documentElement || n === document.body) {
      h.preventDefault();
      return;
    }
    const p = h.changedTouches[0].pageY, g = n.scrollTop, y = n.scrollHeight - n.clientHeight;
    y !== 0 && ((g <= 0 && p > e || g >= y && p < e) && h.preventDefault(), e = p);
  }, i = (h) => {
    var p;
    const g = (p = h.composedPath()) == null ? void 0 : p[0];
    mE(g) && g !== document.activeElement && (h.preventDefault(), g.style.transform = "translateY(-2000px)", g.focus(), requestAnimationFrame(() => {
      g.style.transform = "";
    }));
  }, s = (h) => {
    var p;
    const g = (p = h.composedPath()) == null ? void 0 : p[0];
    mE(g) && (g.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      g.style.transform = "", am && (am.height < window.innerHeight ? requestAnimationFrame(() => {
        pE(g);
      }) : am.addEventListener(
        "resize",
        () => pE(g),
        { once: !0 }
      ));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, c = window.pageYOffset, u = Mg(
    tc(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    tc(document.documentElement, "overflow", "hidden"),
    tc(document.body, "marginTop", `-${c}px`)
  );
  window.scrollTo(0, 0);
  const f = Mg(
    Ol(document, "touchstart", t, {
      passive: !1,
      capture: !0
    }),
    Ol(document, "touchmove", r, {
      passive: !1,
      capture: !0
    }),
    Ol(document, "touchend", i, {
      passive: !1,
      capture: !0
    }),
    Ol(document, "focus", s, !0),
    Ol(window, "scroll", o)
  );
  return () => {
    u(), f(), window.scrollTo(a, c);
  };
}
function tc(n, e, t) {
  const r = n.style[e];
  return n.style[e] = t, () => {
    n.style[e] = r;
  };
}
function Ol(n, e, t, r) {
  return n.addEventListener(e, t, r), () => {
    n.removeEventListener(e, t, r);
  };
}
function pE(n) {
  const e = document.scrollingElement || document.documentElement;
  for (; n && n !== e; ) {
    const t = mR(n);
    if (t !== document.documentElement && t !== document.body && t !== n) {
      const r = t.getBoundingClientRect().top, i = n.getBoundingClientRect().top, s = n.getBoundingClientRect().bottom, o = t.getBoundingClientRect().bottom + t6;
      s > o && (t.scrollTop += i - r);
    }
    n = t.parentElement;
  }
}
function mE(n) {
  return n instanceof HTMLInputElement && !n6.has(n.type) || n instanceof HTMLTextAreaElement || n instanceof HTMLElement && n.isContentEditable;
}
function $r(n) {
  const e = vt(void 0);
  return Ec(() => {
    e.current = n;
  }), fn((...t) => {
    const r = e.current;
    return r == null ? void 0 : r(...t);
  }, []);
}
function o6({
  isOpen: n,
  onClosed: e,
  onOpening: t,
  onOpen: r,
  onClosing: i
}) {
  const [s, o] = wt(n ? "opening" : "closed"), a = $r(() => e == null ? void 0 : e()), c = $r(() => t == null ? void 0 : t()), u = $r(() => r == null ? void 0 : r()), f = $r(() => i == null ? void 0 : i());
  return St(() => {
    n && s === "closed" ? o("opening") : !n && (s === "open" || s === "opening") && o("closing");
  }, [n, s]), St(() => {
    async function h() {
      switch (s) {
        case "closed":
          await (a == null ? void 0 : a());
          break;
        case "opening":
          await (c == null ? void 0 : c()), o("open");
          break;
        case "open":
          await (u == null ? void 0 : u());
          break;
        case "closing":
          await (f == null ? void 0 : f()), o("closed");
          break;
      }
    }
    h().catch((p) => {
      console.error("Internal sheet state error:", p);
    });
  }, [s]), s;
}
function a6(n = {}) {
  const {
    containerRef: e,
    isEnabled: t = !0,
    debounceDelay: r = 100,
    includeContentEditable: i = !0,
    visualViewportThreshold: s = 100
  } = n, [o, a] = wt({
    isVisible: !1,
    height: 0
  }), c = vt(null), u = vt(null), f = $r((h) => (h == null ? void 0 : h.tagName) === "INPUT" || (h == null ? void 0 : h.tagName) === "TEXTAREA" || i && h instanceof HTMLElement && h.isContentEditable);
  return St(() => {
    if (!t) return;
    const h = window.visualViewport, p = navigator.virtualKeyboard;
    function g(C) {
      const T = (e == null ? void 0 : e.current) || document.documentElement;
      window.isSecureContext ? T.style.setProperty(
        "--keyboard-inset-height",
        `env(keyboard-inset-height, ${C}px)`
      ) : T.style.setProperty("--keyboard-inset-height", `${C}px`);
    }
    function y(C) {
      C.target instanceof HTMLElement && f(C.target) && (c.current = C.target, S());
    }
    function x() {
      c.current = null, S();
    }
    function S() {
      u.current && clearTimeout(u.current), u.current = setTimeout(() => {
        const C = c.current;
        if (!f(C)) {
          g(0), a({ isVisible: !1, height: 0 });
          return;
        }
        if (h) {
          const k = window.innerHeight - h.height;
          k > s ? (g(k), a({ isVisible: !0, height: k })) : (g(0), a({ isVisible: !1, height: 0 }));
        }
      }, r);
    }
    window.addEventListener("focusin", y), window.addEventListener("focusout", x), h && (h.addEventListener("resize", S), h.addEventListener("scroll", S));
    let w = !1;
    return p && (w = p.overlaysContent, p.overlaysContent = !0), () => {
      window.removeEventListener("focusin", y), window.removeEventListener("focusout", x), h && (h.removeEventListener("resize", S), h.removeEventListener("scroll", S)), p && (p.overlaysContent = w), u.current && clearTimeout(u.current);
    };
  }, [
    r,
    i,
    t,
    s
  ]), {
    keyboardHeight: o.height,
    isKeyboardOpen: o.isVisible
  };
}
function l6({
  snapPointsProp: n,
  sheetHeight: e
}) {
  if (n[0] !== 0 && (console.error(
    `First snap point should be 0 to ensure the sheet can be fully closed. Got: [${n.join(", ")}]`
  ), n.unshift(0)), n[n.length - 1] !== 1 && (console.error(
    `Last snap point should be 1 to ensure the sheet can be fully opened. Got: [${n.join(", ")}]`
  ), n.push(1)), e <= 0)
    return console.error(
      `Sheet height is ${e}, cannot compute snap points. Make sure the sheet is mounted and has a valid height.`
    ), [];
  const t = n.map((r) => r > 0 && r <= 1 ? Math.round(r * e) : r < 0 ? e + r : r);
  return console.assert(
    H4(t),
    `Snap points need to be in ascending order got: [${n.join(", ")}]`
  ), t.forEach((r) => {
    (r < 0 || r > e) && console.warn(
      `Snap point ${r} is outside of the sheet height ${e}. This can cause unexpected behavior. Consider adjusting your snap points.`
    );
  }), t.includes(e) || (console.warn(
    "Snap points do not include the sheet height.Please include `1` as the last snap point or it will be included automatically.This is to ensure the sheet can be fully opened."
  ), t.push(e)), t.map((r, i) => ({
    snapIndex: i,
    snapValue: r,
    // Absolute value from the bottom of the sheet
    snapValueY: e - r
    // Y value is inverted as `y = 0` means sheet is at the top
  }));
}
function c6({
  snapPoints: n,
  currentY: e
}) {
  return n.reduce(
    (t, r) => Math.abs(r.snapValueY - e) < Math.abs(t.snapValueY - e) ? r : t
  );
}
function u6({
  y: n,
  snapPoints: e,
  dragDirection: t
}) {
  return t === "down" ? e.slice().reverse().find((r) => r.snapValueY > n) : e.find((r) => r.snapValueY < n);
}
function d6({
  dragDirection: n,
  snapPoints: e
}) {
  const t = e[0], r = e[e.length - 1];
  return n === "down" ? {
    yTo: t.snapValueY,
    snapIndex: t.snapIndex
  } : {
    yTo: r.snapValueY,
    snapIndex: r.snapIndex
  };
}
function f6({
  currentSnapPoint: n,
  currentY: e,
  dragDirection: t,
  snapPoints: r,
  velocity: i
}) {
  const s = c6({
    snapPoints: r,
    currentY: e
  });
  if (Math.abs(i) < 20)
    return {
      yTo: s.snapValueY,
      snapIndex: s.snapIndex
    };
  const o = u6({
    y: e,
    snapPoints: r,
    dragDirection: t
  });
  return o ? {
    yTo: o.snapValueY,
    snapIndex: o.snapIndex
  } : {
    yTo: n.snapValueY,
    snapIndex: n.snapIndex
  };
}
var gR = hs(
  ({
    avoidKeyboard: n = !0,
    children: e,
    className: t = "",
    detent: r = "default",
    disableDismiss: i = !1,
    disableDrag: s = !1,
    disableScrollLocking: o = !1,
    dragCloseThreshold: a = z4,
    dragVelocityThreshold: c = V4,
    initialSnap: u,
    isOpen: f,
    modalEffectRootId: h,
    modalEffectThreshold: p,
    mountPoint: g,
    prefersReducedMotion: y = !1,
    snapPoints: x,
    style: S,
    tweenConfig: w = j4,
    unstyled: C = !1,
    onOpenStart: T,
    onOpenEnd: k,
    onClose: R,
    onCloseStart: P,
    onCloseEnd: L,
    onSnap: B,
    onDrag: W,
    onDragStart: X,
    onDragEnd: ce,
    ...Re
  }, ke) => {
    const [J, re] = I4(), G = vt(null), $ = Math.round(re.height), [K, Se] = wt(u), z = x && $ > 0 ? l6({ sheetHeight: $, snapPointsProp: x }) : [], { windowHeight: Q } = Q4(), ge = $ > 0 ? $ : Q, me = kg(ge), V = ec(me, (Ge) => Math.max($ - Ge, 0)), ie = kg(0), q = p4(), ee = {
      type: "tween",
      ...!!(y || q) ? F4 : w
    }, pe = a6({
      isEnabled: f && n,
      containerRef: G
    }).isKeyboardOpen || s, Ee = ec(
      me,
      (Ge) => Ge + 2 >= ge ? -1 : (S == null ? void 0 : S.zIndex) ?? 9999
    ), ue = ec(
      me,
      (Ge) => Ge + 2 >= ge ? "hidden" : "visible"
    ), et = $r((Ge) => {
      Se(Ge), B == null || B(Ge);
    }), mt = $r((Ge) => x && z ? Ge < 0 || Ge >= z.length ? (console.warn(
      `Invalid snap index ${Ge}. Snap points are: [${x.join(", ")}] and their computed values are: [${z.map((lt) => lt.snapValue).join(", ")}]`
    ), null) : z[Ge] : null), Kt = $r(async (Ge) => {
      if (!x) {
        console.warn("Snapping is not possible without `snapPoints` prop.");
        return;
      }
      const lt = mt(Ge);
      if (lt === null) {
        console.warn(`Invalid snap index ${Ge}.`);
        return;
      }
      if (Ge === 0) {
        R();
        return;
      }
      await qu(me, lt.snapValueY, {
        ...ee,
        onComplete: () => et(Ge)
      });
    }), Wt = $r(() => {
      const Ge = document.activeElement;
      if (!Ge || !G.current) return;
      (Ge.tagName === "INPUT" || Ge.tagName === "TEXTAREA") && G.current.contains(Ge) && Ge.blur();
    }), en = $r((Ge, lt) => {
      W == null || W(Ge, lt);
      const vr = me.get(), _t = me.getVelocity();
      _t > 0 && ie.set(10), _t < 0 && ie.set(-10), me.set(Math.max(vr + lt.delta.y, 0));
    }), $n = $r((Ge, lt) => {
      Wt(), X == null || X(Ge, lt);
    }), _r = $r((Ge, lt) => {
      Wt(), ce == null || ce(Ge, lt);
      const vr = me.get();
      let _t = 0;
      const An = K !== void 0 ? mt(K) : null;
      if (An) {
        const Gn = lt.offset.y > 0 ? "down" : "up", cn = lt.velocity.y > 0 ? "down" : "up", ei = Math.abs(lt.velocity.y) > c;
        let or;
        if (ei ? or = d6({
          snapPoints: z,
          dragDirection: cn
        }) : or = f6({
          currentSnapPoint: An,
          currentY: vr,
          dragDirection: Gn,
          snapPoints: z,
          velocity: lt.velocity.y
        }), _t = or.yTo, i && _t + 1 >= $) {
          const Or = z.find((ti) => ti.snapValue > 0);
          Or ? (_t = Or.snapValueY, et(Or.snapIndex)) : _t = vr;
        } else or.snapIndex !== void 0 && et(or.snapIndex);
      } else (lt.velocity.y > c || vr > $ * a) && (i ? _t = 0 : _t = ge);
      qu(me, _t, ee), _t + 1 >= $ && !i && R(), ie.set(0);
    });
    $2(ke, () => ({
      y: me,
      yInverted: V,
      height: $,
      snapTo: Kt
    })), X4({
      y: me,
      detent: r,
      sheetHeight: $,
      snapPoints: z,
      rootId: h,
      startThreshold: p
    }), r6({
      isDisabled: o || !f
    });
    const ir = o6({
      isOpen: f,
      onOpen: async () => {
        T == null || T(), await Y4("react-modal-sheet-container");
        const Ge = u !== void 0 ? mt(u) : null, lt = (Ge == null ? void 0 : Ge.snapValueY) ?? 0;
        await qu(me, lt, ee), u !== void 0 && et(u), k == null || k();
      },
      onClosing: async () => {
        P == null || P(), await qu(me, ge, ee), L == null || L();
      }
    }), Pn = {
      currentSnap: K,
      detent: r,
      disableDrag: pe,
      dragProps: {
        drag: "y",
        dragElastic: 0,
        dragMomentum: !1,
        dragPropagation: !1,
        onDrag: en,
        onDragStart: $n,
        onDragEnd: _r
      },
      indicatorRotation: ie,
      avoidKeyboard: n,
      sheetBoundsRef: J,
      sheetRef: G,
      unstyled: C,
      y: me
    }, sr = /* @__PURE__ */ Fe.createElement(lR.Provider, { value: Pn }, /* @__PURE__ */ Fe.createElement(
      us.div,
      {
        ...Re,
        ref: ke,
        "data-sheet-state": ir,
        className: `react-modal-sheet-root ${t}`,
        style: {
          ...fs(ds.root, C),
          zIndex: Ee,
          visibility: ue,
          ...S
        }
      },
      ir !== "closed" ? e : null
    ));
    return wc ? sr : b1(sr, g ?? document.body);
  }
);
gR.displayName = "Sheet";
var Il = Object.assign(gR, {
  Container: uR,
  Header: pR,
  DragIndicator: hR,
  Content: fR,
  Backdrop: cR
});
const h6 = "_option_1n7so_1", p6 = "_sheetContainer_1n7so_21", m6 = "_sheetHeader_1n7so_31", g6 = "_sheetBody_1n7so_39", Zu = {
  option: h6,
  sheetContainer: p6,
  sheetHeader: m6,
  sheetBody: g6
}, y6 = hs(
  ({
    label: n,
    description: e,
    error: t,
    required: r,
    withAsterisk: i,
    data: s,
    value: o,
    onChange: a,
    placeholder: c,
    disabled: u,
    renderItem: f,
    ...h
  }, p) => {
    const [g, { open: y, close: x }] = p1(!1), S = s.map(
      (T) => typeof T == "string" ? { value: T, label: T } : T
    ), w = S.find((T) => T.value === o), C = (T) => {
      a == null || a(T), x();
    };
    return /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
      /* @__PURE__ */ b.jsx(
        fc.Wrapper,
        {
          label: n,
          description: e,
          error: t,
          required: r,
          withAsterisk: i,
          ...h,
          children: /* @__PURE__ */ b.jsx(
            fc,
            {
              component: "button",
              type: "button",
              pointer: !0,
              rightSection: /* @__PURE__ */ b.jsx(Wy, { size: 16 }),
              onClick: () => !u && y(),
              disabled: u,
              ref: p,
              multiline: !0,
              children: w ? /* @__PURE__ */ b.jsx(ae, { size: "sm", children: w.label }) : /* @__PURE__ */ b.jsx(ae, { size: "sm", c: "dimmed", children: c })
            }
          )
        }
      ),
      /* @__PURE__ */ b.jsxs(Il, { isOpen: g, onClose: x, detent: "content", className: Zu.sheetContainer, children: [
        /* @__PURE__ */ b.jsxs(Il.Container, { children: [
          /* @__PURE__ */ b.jsx(Il.Header, {}),
          /* @__PURE__ */ b.jsxs(Il.Content, { children: [
            /* @__PURE__ */ b.jsx(gt, { className: Zu.sheetHeader, px: 16, children: /* @__PURE__ */ b.jsx(ae, { fw: 600, size: "lg", children: n || "Select Option" }) }),
            /* @__PURE__ */ b.jsx(gt, { className: Zu.sheetBody, my: 16, px: 16, children: /* @__PURE__ */ b.jsx(at, { gap: 4, children: S.map((T) => /* @__PURE__ */ b.jsx(
              Lc,
              {
                className: Zu.option,
                py: 8,
                "data-selected": T.value === o || void 0,
                onClick: () => C(T.value),
                children: f ? f(T, T.value === o) : /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
                  /* @__PURE__ */ b.jsx(ae, { size: "md", fw: T.value === o ? 600 : 400, children: T.label }),
                  T.value === o && /* @__PURE__ */ b.jsx(Hy, { size: 18, style: { color: "var(--mantine-color-blue-7)" } })
                ] })
              },
              T.value
            )) }) })
          ] })
        ] }),
        /* @__PURE__ */ b.jsx(Il.Backdrop, { onTap: x })
      ] })
    ] });
  }
);
y6.displayName = "DtSelect";
function yR({
  title: n = "서비스 이용에 불편을 드려 죄송합니다",
  message: e = `예기치 못한 문제가 발생하여 페이지를 표시할 수 없습니다.
잠시 후 다시 시도해 주시거나 아래 버튼을 통해 이동해 주세요.`,
  error: t,
  onReload: r,
  onGoHome: i,
  onGoBack: s,
  homePath: o = "/",
  showDetails: a = !0,
  serviceName: c = "DutyOn",
  logoSrc: u,
  homeLabel: f = "홈으로 이동"
}) {
  const [h, { toggle: p }] = p1(!1), [g, y] = wt(!1), x = () => {
    r ? r() : window.location.reload();
  }, S = () => {
    i ? i() : window.location.href = o;
  }, w = () => {
    s ? s() : typeof window < "u" && window.history.length > 1 ? window.history.back() : S();
  }, C = t instanceof Error ? t.message : typeof t == "string" ? t : "Unknown error", T = t instanceof Error ? t.stack : null, k = () => {
    var P;
    const R = `Error: ${C}

Stack:
${T || "No stack trace available"}`;
    (P = navigator == null ? void 0 : navigator.clipboard) != null && P.writeText && (navigator.clipboard.writeText(R), y(!0), setTimeout(() => y(!1), 2e3));
  };
  return /* @__PURE__ */ b.jsx(
    "div",
    {
      style: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #f8fafc 0%, #f3f6fb 100%)",
        padding: "clamp(1rem, 4vw, 3rem)"
      },
      children: /* @__PURE__ */ b.jsx(uy, { size: "sm", px: 0, style: { width: "100%" }, children: /* @__PURE__ */ b.jsx(
        er,
        {
          p: { base: "xl", sm: 40 },
          radius: "xl",
          style: {
            width: "100%",
            background: "rgba(255, 255, 255, 0.96)",
            borderColor: "rgba(226, 232, 240, 0.95)",
            boxShadow: "0 24px 70px rgba(15, 23, 42, 0.1)"
          },
          children: /* @__PURE__ */ b.jsxs(at, { align: "center", gap: "xl", children: [
            /* @__PURE__ */ b.jsxs(je, { gap: "sm", wrap: "nowrap", children: [
              u && /* @__PURE__ */ b.jsx(
                "img",
                {
                  src: u,
                  alt: "",
                  "aria-hidden": "true",
                  width: 40,
                  height: 40,
                  style: { display: "block", objectFit: "contain" }
                }
              ),
              /* @__PURE__ */ b.jsx(ae, { fw: 900, size: "lg", c: "blue", children: c })
            ] }),
            /* @__PURE__ */ b.jsx(
              d1,
              {
                size: 76,
                radius: "xl",
                variant: "light",
                color: "blue",
                style: { boxShadow: "0 12px 28px rgba(34, 139, 230, 0.16)" },
                children: /* @__PURE__ */ b.jsx(kW, { size: 38, stroke: 1.8 })
              }
            ),
            /* @__PURE__ */ b.jsxs(at, { align: "center", gap: "xs", style: { textAlign: "center" }, children: [
              /* @__PURE__ */ b.jsx(
                Ya,
                {
                  order: 2,
                  style: { fontSize: "clamp(1.45rem, 4vw, 1.85rem)", wordBreak: "keep-all" },
                  children: n
                }
              ),
              /* @__PURE__ */ b.jsx(
                ae,
                {
                  c: "dimmed",
                  size: "md",
                  maw: 480,
                  style: { whiteSpace: "pre-line", wordBreak: "keep-all", lineHeight: 1.7 },
                  children: e
                }
              )
            ] }),
            /* @__PURE__ */ b.jsxs(je, { justify: "center", gap: "sm", wrap: "wrap", style: { width: "100%" }, children: [
              /* @__PURE__ */ b.jsx(
                hn,
                {
                  size: "md",
                  color: "blue",
                  leftSection: /* @__PURE__ */ b.jsx(LW, { size: 18 }),
                  onClick: x,
                  style: { boxShadow: "0 10px 22px rgba(34, 139, 230, 0.2)" },
                  children: "다시 불러오기"
                }
              ),
              /* @__PURE__ */ b.jsx(
                hn,
                {
                  size: "md",
                  variant: "default",
                  leftSection: /* @__PURE__ */ b.jsx(NW, { size: 18 }),
                  onClick: S,
                  children: f
                }
              ),
              s !== null && /* @__PURE__ */ b.jsx(
                hn,
                {
                  size: "md",
                  variant: "subtle",
                  color: "gray",
                  leftSection: /* @__PURE__ */ b.jsx(MW, { size: 18 }),
                  onClick: w,
                  children: "이전 페이지"
                }
              )
            ] }),
            a && !!t && /* @__PURE__ */ b.jsx(
              er,
              {
                withBorder: !0,
                radius: "lg",
                p: "sm",
                style: { width: "100%", boxShadow: "none" },
                bg: "var(--mantine-color-gray-0)",
                children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
                  /* @__PURE__ */ b.jsxs(je, { justify: "space-between", wrap: "nowrap", children: [
                    /* @__PURE__ */ b.jsxs(
                      je,
                      {
                        gap: "xs",
                        wrap: "nowrap",
                        style: { cursor: "pointer", minWidth: 0, flex: 1 },
                        onClick: p,
                        children: [
                          /* @__PURE__ */ b.jsx(ae, { size: "xs", fw: 700, c: "dimmed", style: { whiteSpace: "nowrap" }, children: "오류 세부 정보" }),
                          /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "gray", fw: 500, style: { minWidth: 0 }, truncate: !0, children: C })
                        ]
                      }
                    ),
                    /* @__PURE__ */ b.jsx(
                      hi,
                      {
                        variant: "subtle",
                        color: "gray",
                        size: "sm",
                        "aria-label": h ? "오류 세부 정보 닫기" : "오류 세부 정보 열기",
                        onClick: p,
                        children: h ? /* @__PURE__ */ b.jsx(uC, { size: 16 }) : /* @__PURE__ */ b.jsx(Wy, { size: 16 })
                      }
                    )
                  ] }),
                  /* @__PURE__ */ b.jsx(k2, { in: h, children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", mt: "xs", children: [
                    /* @__PURE__ */ b.jsxs(je, { justify: "space-between", align: "center", wrap: "nowrap", children: [
                      /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "dimmed", children: "문제가 지속되면 아래 내용을 복사하여 기술 지원팀에 문의해 주세요." }),
                      /* @__PURE__ */ b.jsx(ss, { label: g ? "복사되었습니다!" : "오류 내용 복사", children: /* @__PURE__ */ b.jsx(
                        hi,
                        {
                          variant: "light",
                          color: g ? "teal" : "blue",
                          size: "sm",
                          onClick: k,
                          children: g ? /* @__PURE__ */ b.jsx(Hy, { size: 14 }) : /* @__PURE__ */ b.jsx(dC, { size: 14 })
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ b.jsx(
                      M2,
                      {
                        block: !0,
                        style: {
                          maxHeight: 180,
                          overflowY: "auto",
                          fontSize: "0.75rem",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-all"
                        },
                        children: T || C
                      }
                    )
                  ] }) })
                ] })
              }
            )
          ] })
        }
      ) })
    }
  );
}
class nQ extends hy {
  constructor(t) {
    super(t);
    Tx(this, "reset", () => {
      this.setState({ hasError: !1, error: null });
    });
    this.state = { hasError: !1, error: null };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0, error: t };
  }
  componentDidCatch(t, r) {
    this.props.onError && this.props.onError(t, r);
  }
  render() {
    return this.state.hasError && this.state.error ? typeof this.props.fallback == "function" ? this.props.fallback(this.state.error, this.reset) : this.props.fallback ? this.props.fallback : /* @__PURE__ */ b.jsx(
      yR,
      {
        error: this.state.error,
        homePath: this.props.homePath || "/",
        serviceName: this.props.serviceName,
        logoSrc: this.props.logoSrc,
        homeLabel: this.props.homeLabel,
        onReload: () => window.location.reload()
      }
    ) : this.props.children;
  }
}
function rQ({
  homePath: n = "/",
  title: e,
  message: t,
  serviceName: r,
  logoSrc: i,
  homeLabel: s
}) {
  const o = iB(), a = sB();
  return /* @__PURE__ */ b.jsx(
    yR,
    {
      title: e,
      message: t,
      error: o,
      homePath: n,
      serviceName: r,
      logoSrc: i,
      homeLabel: s,
      onGoHome: () => a(n),
      onGoBack: () => {
        window.history.length > 1 ? a(-1) : a(n);
      }
    }
  );
}
function iQ({
  src: n,
  alt: e,
  size: t = 100,
  onChange: r,
  accept: i = "image/png,image/jpeg,image/webp,image/gif",
  disabled: s = !1,
  style: o
}) {
  const [a, c] = wt(!1), u = vt(null), f = fn(
    async (y) => {
      if (!(/* @__PURE__ */ new Set(["image/png", "image/jpeg", "image/webp", "image/gif"])).has(y.type)) {
        Dl.show({
          title: "지원하지 않는 이미지",
          message: "JPEG, PNG, WebP, GIF 이미지만 선택할 수 있습니다.",
          color: "red"
        });
        return;
      }
      if (y.size <= 0 || y.size > 5 * 1024 * 1024) {
        Dl.show({
          title: "이미지 크기 초과",
          message: "5MB 이하의 이미지를 선택해 주세요.",
          color: "red"
        });
        return;
      }
      c(!0);
      try {
        const S = await J2(y);
        r(S.url), Dl.show({
          title: "성공",
          message: "프로필 이미지가 업로드되었습니다.",
          color: "green"
        });
      } catch (S) {
        const w = Q2(S, {
          fallback: "이미지 업로드 중 오류가 발생했습니다."
        });
        Z2("프로필 이미지를 업로드하지 못했습니다.", {
          action: "프로필 이미지 업로드",
          errorCode: w.errorCode
        }), Dl.show({
          title: "오류",
          message: w.message,
          color: "red"
        });
      } finally {
        c(!1);
      }
    },
    [r]
  ), h = fn(
    (y) => {
      var S;
      const x = (S = y.target.files) == null ? void 0 : S[0];
      x && f(x), y.target.value = "";
    },
    [f]
  ), p = fn(() => {
    var y;
    s || a || (y = u.current) == null || y.click();
  }, [s, a]), g = fn(() => {
    s || a || !n || F2({
      title: "프로필 이미지 초기화",
      centered: !0,
      children: /* @__PURE__ */ b.jsx(ae, { size: "sm", children: "현재 프로필 이미지를 초기화하시겠습니까?" }),
      labels: { confirm: "초기화", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        r(null), Dl.show({
          title: "초기화 완료",
          message: "프로필 이미지가 초기화되었습니다.",
          color: "blue"
        });
      }
    });
  }, [s, a, r, n]);
  return /* @__PURE__ */ b.jsxs(
    at,
    {
      align: "center",
      gap: "md",
      style: {
        position: "relative",
        width: "100%",
        ...o
      },
      children: [
        /* @__PURE__ */ b.jsx(
          "input",
          {
            ref: u,
            type: "file",
            accept: i,
            onChange: h,
            style: { display: "none" }
          }
        ),
        /* @__PURE__ */ b.jsxs(
          Lc,
          {
            type: "button",
            "aria-label": "프로필 이미지 변경",
            disabled: s || a,
            onClick: p,
            style: {
              position: "relative",
              cursor: s || a ? "not-allowed" : "pointer",
              display: "inline-block"
            },
            children: [
              /* @__PURE__ */ b.jsx(
                Wf,
                {
                  visible: a,
                  overlayProps: { radius: "100%", blur: 2 },
                  loaderProps: { size: "sm" }
                }
              ),
              /* @__PURE__ */ b.jsx(
                dy,
                {
                  src: n,
                  alt: e,
                  size: "xl",
                  style: {
                    width: t,
                    height: t,
                    borderRadius: "100%"
                  }
                }
              ),
              /* @__PURE__ */ b.jsx(
                hi,
                {
                  component: "span",
                  "aria-hidden": "true",
                  variant: "filled",
                  size: "sm",
                  radius: "xl",
                  color: "blue",
                  style: {
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    pointerEvents: "none"
                  },
                  children: /* @__PURE__ */ b.jsx(PW, { size: 12, "aria-hidden": "true" })
                }
              )
            ]
          }
        ),
        n && /* @__PURE__ */ b.jsx(
          hn,
          {
            type: "button",
            size: "xs",
            variant: "subtle",
            color: "red",
            leftSection: /* @__PURE__ */ b.jsx(jW, { size: 14, "aria-hidden": "true" }),
            disabled: s || a,
            onClick: g,
            children: "이미지 초기화"
          }
        )
      ]
    }
  );
}
function kn(n) {
  this.content = n;
}
kn.prototype = {
  constructor: kn,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, i = r.find(n), s = r.content.slice();
    return i == -1 ? s.push(t || n, e) : (s[i + 1] = e, t && (s[i] = t)), new kn(s);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new kn(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new kn([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new kn(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var r = this.remove(e), i = r.content.slice(), s = r.find(n);
    return i.splice(s == -1 ? i.length : s, 0, e, t), new kn(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = kn.from(n), n.size ? new kn(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = kn.from(n), n.size ? new kn(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = kn.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
kn.from = function(n) {
  if (n instanceof kn) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new kn(e);
};
function vR(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let i = n.child(r), s = e.child(r);
    if (i == s) {
      t += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(s))
      return t;
    if (i.isText && i.text != s.text) {
      for (let o = 0; i.text[o] == s.text[o]; o++)
        t++;
      return t;
    }
    if (i.content.size || s.content.size) {
      let o = vR(i.content, s.content, t + 1);
      if (o != null)
        return o;
    }
    t += i.nodeSize;
  }
}
function bR(n, e, t, r) {
  for (let i = n.childCount, s = e.childCount; ; ) {
    if (i == 0 || s == 0)
      return i == s ? null : { a: t, b: r };
    let o = n.child(--i), a = e.child(--s), c = o.nodeSize;
    if (o == a) {
      t -= c, r -= c;
      continue;
    }
    if (!o.sameMarkup(a))
      return { a: t, b: r };
    if (o.isText && o.text != a.text) {
      let u = 0, f = Math.min(o.text.length, a.text.length);
      for (; u < f && o.text[o.text.length - u - 1] == a.text[a.text.length - u - 1]; )
        u++, t--, r--;
      return { a: t, b: r };
    }
    if (o.content.size || a.content.size) {
      let u = bR(o.content, a.content, t - 1, r - 1);
      if (u)
        return u;
    }
    t -= c, r -= c;
  }
}
class le {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, r, i = 0, s) {
    for (let o = 0, a = 0; a < t; o++) {
      let c = this.content[o], u = a + c.nodeSize;
      if (u > e && r(c, i + a, s || null, o) !== !1 && c.content.size) {
        let f = a + 1;
        c.nodesBetween(Math.max(0, e - f), Math.min(c.content.size, t - f), r, i + f);
      }
      a = u;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, r, i) {
    let s = "", o = !0;
    return this.nodesBetween(e, t, (a, c) => {
      let u = a.isText ? a.text.slice(Math.max(e, c) - c, t - c) : a.isLeaf ? i ? typeof i == "function" ? i(a) : i : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && u || a.isTextblock) && r && (o ? o = !1 : s += r), s += u;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, i = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(r) && (i[i.length - 1] = t.withText(t.text + r.text), s = 1); s < e.content.length; s++)
      i.push(e.content[s]);
    return new le(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], i = 0;
    if (t > e)
      for (let s = 0, o = 0; o < t; s++) {
        let a = this.content[s], c = o + a.nodeSize;
        c > e && ((o < e || c > t) && (a.isText ? a = a.cut(Math.max(0, e - o), Math.min(a.text.length, t - o)) : a = a.cut(Math.max(0, e - o - 1), Math.min(a.content.size, t - o - 1))), r.push(a), i += a.nodeSize), o = c;
      }
    return new le(r, i);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? le.empty : e == 0 && t == this.content.length ? this : new le(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let i = this.content.slice(), s = this.size + t.nodeSize - r.nodeSize;
    return i[e] = t, new le(i, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new le([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new le(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let i = this.content[t];
      e(i, r, t), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return vR(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, r = e.size) {
    return bR(this, e, t, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return Xu(0, e);
    if (e == this.size)
      return Xu(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, r = 0; ; t++) {
      let i = this.child(t), s = r + i.nodeSize;
      if (s >= e)
        return s == e ? Xu(t + 1, s) : Xu(t, r);
      r = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return le.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new le(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return le.empty;
    let t, r = 0;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      r += s.nodeSize, i && s.isText && e[i - 1].sameMarkup(s) ? (t || (t = e.slice(0, i)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new le(t || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return le.empty;
    if (e instanceof le)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new le([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
le.empty = new le([], 0);
const lm = { index: 0, offset: 0 };
function Xu(n, e) {
  return lm.index = n, lm.offset = e, lm;
}
function Qd(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Qd(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Qd(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
let xt = class _g {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, r = !1;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        t || (t = e.slice(0, i));
      else {
        if (s.type.excludes(this.type))
          return e;
        !r && s.type.rank > this.type.rank && (t || (t = e.slice(0, i)), t.push(this), r = !0), t && t.push(s);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Qd(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let i = r.create(t.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return _g.none;
    if (e instanceof _g)
      return [e];
    let t = e.slice();
    return t.sort((r, i) => r.type.rank - i.type.rank), t;
  }
};
xt.none = [];
class Zd extends Error {
}
class xe {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let r = SR(this.content, e + this.openStart, t);
    return r && new xe(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new xe(xR(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return xe.empty;
    let r = t.openStart || 0, i = t.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new xe(le.fromJSON(e, t.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let r = 0, i = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      r++;
    for (let s = e.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      i++;
    return new xe(e, r, i);
  }
}
xe.empty = new xe(le.empty, 0, 0);
function xR(n, e, t) {
  let { index: r, offset: i } = n.findIndex(e), s = n.maybeChild(r), { index: o, offset: a } = n.findIndex(t);
  if (i == e || s.isText) {
    if (a != t && !n.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, s.copy(xR(s.content, e - i - 1, t - i - 1)));
}
function SR(n, e, t, r) {
  let { index: i, offset: s } = n.findIndex(e), o = n.maybeChild(i);
  if (s == e || o.isText)
    return r && !r.canReplace(i, i, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let a = SR(o.content, e - s - 1, t, o);
  return a && n.replaceChild(i, o.copy(a));
}
function v6(n, e, t) {
  if (t.openStart > n.depth)
    throw new Zd("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Zd("Inconsistent open depths");
  return wR(n, e, t, 0);
}
function wR(n, e, t, r) {
  let i = n.index(r), s = n.node(r);
  if (i == e.index(r) && r < n.depth - t.openStart) {
    let o = wR(n, e, t, r + 1);
    return s.copy(s.content.replaceChild(i, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let o = n.parent, a = o.content;
      return Fo(o, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: o, end: a } = b6(t, n);
      return Fo(s, AR(n, o, a, e, r));
    }
  else return Fo(s, Xd(n, e, r));
}
function ER(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Zd("Cannot join " + e.type.name + " onto " + n.type.name);
}
function Og(n, e, t) {
  let r = n.node(t);
  return ER(r, e.node(t)), r;
}
function jo(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function nc(n, e, t, r) {
  let i = (e || n).node(t), s = 0, o = e ? e.index(t) : i.childCount;
  n && (s = n.index(t), n.depth > t ? s++ : n.textOffset && (jo(n.nodeAfter, r), s++));
  for (let a = s; a < o; a++)
    jo(i.child(a), r);
  e && e.depth == t && e.textOffset && jo(e.nodeBefore, r);
}
function Fo(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function AR(n, e, t, r, i) {
  let s = n.depth > i && Og(n, e, i + 1), o = r.depth > i && Og(t, r, i + 1), a = [];
  return nc(null, n, i, a), s && o && e.index(i) == t.index(i) ? (ER(s, o), jo(Fo(s, AR(n, e, t, r, i + 1)), a)) : (s && jo(Fo(s, Xd(n, e, i + 1)), a), nc(e, t, i, a), o && jo(Fo(o, Xd(t, r, i + 1)), a)), nc(r, null, i, a), new le(a);
}
function Xd(n, e, t) {
  let r = [];
  if (nc(null, n, t, r), n.depth > t) {
    let i = Og(n, e, t + 1);
    jo(Fo(i, Xd(n, e, t + 1)), r);
  }
  return nc(e, null, t, r), new le(r);
}
function b6(n, e) {
  let t = e.depth - n.openStart, i = e.node(t).copy(n.content);
  for (let s = t - 1; s >= 0; s--)
    i = e.node(s).copy(le.from(i));
  return {
    start: i.resolveNoCache(n.openStart + t),
    end: i.resolveNoCache(i.content.size - n.openEnd - t)
  };
}
class Ac {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(t);
    return r ? e.child(t).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], i = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let s = 0; s < e; s++)
      i += r.child(s).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return xt.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), i = e.maybeChild(t);
    if (!r) {
      let a = r;
      r = i, i = a;
    }
    let s = r.marks;
    for (var o = 0; o < s.length; o++)
      s[o].type.spec.inclusive === !1 && (!i || !s[o].isInSet(i.marks)) && (s = s[o--].removeFromSet(s));
    return s;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, i = e.parent.maybeChild(e.index());
    for (var s = 0; s < r.length; s++)
      r[s].type.spec.inclusive === !1 && (!i || !r[s].isInSet(i.marks)) && (r = r[s--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new ef(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], i = 0, s = t;
    for (let o = e; ; ) {
      let { index: a, offset: c } = o.content.findIndex(s), u = s - c;
      if (r.push(o, a, i + c), !u || (o = o.child(a), o.isText))
        break;
      s = u - 1, i += c + 1;
    }
    return new Ac(t, r, s);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let r = gE.get(e);
    if (r)
      for (let s = 0; s < r.elts.length; s++) {
        let o = r.elts[s];
        if (o.pos == t)
          return o;
      }
    else
      gE.set(e, r = new x6());
    let i = r.elts[r.i] = Ac.resolve(e, t);
    return r.i = (r.i + 1) % S6, i;
  }
}
class x6 {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const S6 = 12, gE = /* @__PURE__ */ new WeakMap();
class ef {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const w6 = /* @__PURE__ */ Object.create(null);
let Gs = class Ig {
  /**
  @internal
  */
  constructor(e, t, r, i = xt.none) {
    this.type = e, this.attrs = t, this.marks = i, this.content = r || le.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, r, i = 0) {
    this.content.nodesBetween(e, t, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, t, r, i) {
    return this.content.textBetween(e, t, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, r) {
    return this.type == e && Qd(this.attrs, t || e.defaultAttrs || w6) && xt.sameSet(this.marks, r || xt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Ig(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Ig(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return xe.empty;
    let i = this.resolve(e), s = this.resolve(t), o = r ? 0 : i.sharedDepth(t), a = i.start(o), u = i.node(o).content.cut(i.pos - a, s.pos - a);
    return new xe(u, i.depth - o, s.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, r) {
    return v6(this.resolve(e), this.resolve(t), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: i } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (i == e || t.isText)
        return t;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let i = this.content.child(t - 1);
    return { node: i, index: t - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return Ac.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return Ac.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, r) {
    let i = !1;
    return t > e && this.nodesBetween(e, t, (s) => (r.isInSet(s.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), TR(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, r = le.empty, i = 0, s = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, i, s), a = o && o.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let c = i; c < s; c++)
      if (!this.type.allowsMarks(r.child(c).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let s = this.contentMatchAt(e).matchType(r), o = s && s.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = xt.none;
    for (let t = 0; t < this.marks.length; t++) {
      let r = this.marks[t];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!xt.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let i = le.fromJSON(e, t.content), s = e.nodeType(t.type).create(t.attrs, i, r);
    return s.type.checkAttrs(s.attrs), s;
  }
};
Gs.prototype.text = void 0;
class tf extends Gs {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    if (super(e, t, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : TR(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new tf(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new tf(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function TR(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class Go {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let r = new E6(e, t);
    if (r.next == null)
      return Go.empty;
    let i = CR(r);
    r.next && r.err("Unexpected trailing text");
    let s = M6(k6(i));
    return _6(s, r), s;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, r = e.childCount) {
    let i = this;
    for (let s = t; i && s < r; s++)
      i = i.matchType(e.child(s).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, r = 0) {
    let i = [this];
    function s(o, a) {
      let c = o.matchFragment(e, r);
      if (c && (!t || c.validEnd))
        return le.from(a.map((u) => u.createAndFill()));
      for (let u = 0; u < o.next.length; u++) {
        let { type: f, next: h } = o.next[u];
        if (!(f.isText || f.hasRequiredAttrs()) && i.indexOf(h) == -1) {
          i.push(h);
          let p = s(h, a.concat(f));
          if (p)
            return p;
        }
      }
      return null;
    }
    return s(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), s = i.match;
      if (s.matchType(e)) {
        let o = [];
        for (let a = i; a.type; a = a.via)
          o.push(a.type);
        return o.reverse();
      }
      for (let o = 0; o < s.next.length; o++) {
        let { type: a, next: c } = s.next[o];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!i.type || c.validEnd) && (r.push({ match: a.contentMatch, type: a, via: i }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && t(r.next[i].next);
    }
    return t(this), e.map((r, i) => {
      let s = i + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        s += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return s;
    }).join(`
`);
  }
}
Go.empty = new Go(!0);
class E6 {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function CR(n) {
  let e = [];
  do
    e.push(A6(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function A6(n) {
  let e = [];
  do
    e.push(T6(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function T6(n) {
  let e = R6(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = C6(n, e);
    else
      break;
  return e;
}
function yE(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function C6(n, e) {
  let t = yE(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = yE(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function D6(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let i = [];
  for (let s in t) {
    let o = t[s];
    o.isInGroup(e) && i.push(o);
  }
  return i.length == 0 && n.err("No node type or group '" + e + "' found"), i;
}
function R6(n) {
  if (n.eat("(")) {
    let e = CR(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = D6(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function k6(n) {
  let e = [[]];
  return i(s(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(o, a, c) {
    let u = { term: c, to: a };
    return e[o].push(u), u;
  }
  function i(o, a) {
    o.forEach((c) => c.to = a);
  }
  function s(o, a) {
    if (o.type == "choice")
      return o.exprs.reduce((c, u) => c.concat(s(u, a)), []);
    if (o.type == "seq")
      for (let c = 0; ; c++) {
        let u = s(o.exprs[c], a);
        if (c == o.exprs.length - 1)
          return u;
        i(u, a = t());
      }
    else if (o.type == "star") {
      let c = t();
      return r(a, c), i(s(o.expr, c), c), [r(c)];
    } else if (o.type == "plus") {
      let c = t();
      return i(s(o.expr, a), c), i(s(o.expr, c), c), [r(c)];
    } else {
      if (o.type == "opt")
        return [r(a)].concat(s(o.expr, a));
      if (o.type == "range") {
        let c = a;
        for (let u = 0; u < o.min; u++) {
          let f = t();
          i(s(o.expr, c), f), c = f;
        }
        if (o.max == -1)
          i(s(o.expr, c), c);
        else
          for (let u = o.min; u < o.max; u++) {
            let f = t();
            r(c, f), i(s(o.expr, c), f), c = f;
          }
        return [r(c)];
      } else {
        if (o.type == "name")
          return [r(a, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function DR(n, e) {
  return e - n;
}
function vE(n, e) {
  let t = [];
  return r(e), t.sort(DR);
  function r(i) {
    let s = n[i];
    if (s.length == 1 && !s[0].term)
      return r(s[0].to);
    t.push(i);
    for (let o = 0; o < s.length; o++) {
      let { term: a, to: c } = s[o];
      !a && t.indexOf(c) == -1 && r(c);
    }
  }
}
function M6(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(vE(n, 0));
  function t(r) {
    let i = [];
    r.forEach((o) => {
      n[o].forEach(({ term: a, to: c }) => {
        if (!a)
          return;
        let u;
        for (let f = 0; f < i.length; f++)
          i[f][0] == a && (u = i[f][1]);
        vE(n, c).forEach((f) => {
          u || i.push([a, u = []]), u.indexOf(f) == -1 && u.push(f);
        });
      });
    });
    let s = e[r.join(",")] = new Go(r.indexOf(n.length - 1) > -1);
    for (let o = 0; o < i.length; o++) {
      let a = i[o][1].sort(DR);
      s.next.push({ type: i[o][0], next: e[a.join(",")] || t(a) });
    }
    return s;
  }
}
function _6(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let i = r[t], s = !i.validEnd, o = [];
    for (let a = 0; a < i.next.length; a++) {
      let { type: c, next: u } = i.next[a];
      o.push(c.name), s && !(c.isText || c.hasRequiredAttrs()) && (s = !1), r.indexOf(u) == -1 && r.push(u);
    }
    s && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function RR(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function kR(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let i = e && e[r];
    if (i === void 0) {
      let s = n[r];
      if (s.hasDefault)
        i = s.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = i;
  }
  return t;
}
function MR(n, e, t, r) {
  for (let i in e)
    if (!(i in n))
      throw new RangeError(`Unsupported attribute ${i} for ${t} of type ${i}`);
  for (let i in n) {
    let s = n[i];
    s.validate && s.validate(e[i]);
  }
}
function _R(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new I6(n, r, e[r]);
  return t;
}
let bE = class OR {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = _R(e, r.attrs), this.defaultAttrs = RR(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Go.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : kR(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Gs(this, this.computeAttrs(e), le.from(t), xt.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, r) {
    return t = le.from(t), this.checkContent(t), new Gs(this, this.computeAttrs(e), t, xt.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = le.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let i = this.contentMatch.matchFragment(t), s = i && i.fillBefore(le.empty, !0);
    return s ? new Gs(this, e, t.append(s), xt.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    MR(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : xt.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((s, o) => r[s] = new OR(s, t, o));
    let i = t.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function O6(n, e, t) {
  let r = t.split("|");
  return (i) => {
    let s = i === null ? "null" : typeof i;
    if (r.indexOf(s) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${n}, got ${s}`);
  };
}
class I6 {
  constructor(e, t, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? O6(e, t, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Zf {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    this.name = e, this.rank = t, this.schema = r, this.spec = i, this.attrs = _R(e, i.attrs), this.excluded = null;
    let s = RR(this.attrs);
    this.instance = s ? new xt(this, s) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new xt(this, kR(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((s, o) => r[s] = new Zf(s, i++, t, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    MR(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class IR {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let i in e)
      t[i] = e[i];
    t.nodes = kn.from(e.nodes), t.marks = kn.from(e.marks || {}), this.nodes = bE.compile(this.spec.nodes, this), this.marks = Zf.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let s = this.nodes[i], o = s.spec.content || "", a = s.spec.marks;
      if (s.contentMatch = r[o] || (r[o] = Go.parse(o, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!s.isInline || !s.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = s;
      }
      s.markSet = a == "_" ? null : a ? xE(this, a.split(" ")) : a == "" || !s.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let s = this.marks[i], o = s.spec.excludes;
      s.excluded = o == null ? [s] : o == "" ? [] : xE(this, o.split(" "));
    }
    this.nodeFromJSON = (i) => Gs.fromJSON(this, i), this.markFromJSON = (i) => xt.fromJSON(this, i), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof bE) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let r = this.nodes.text;
    return new tf(r, r.defaultAttrs, e, xt.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function xE(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], s = n.marks[i], o = s;
    if (s)
      t.push(s);
    else
      for (let a in n.marks) {
        let c = n.marks[a];
        (i == "_" || c.spec.group && c.spec.group.split(" ").indexOf(i) > -1) && t.push(o = c);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
function N6(n) {
  return n.tag != null;
}
function P6(n) {
  return n.style != null;
}
class Ys {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    t.forEach((i) => {
      if (N6(i))
        this.tags.push(i);
      else if (P6(i)) {
        let s = /[^=]*/.exec(i.style)[0];
        r.indexOf(s) < 0 && r.push(s), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let s = e.nodes[i.node];
      return s.contentMatch.matchType(s);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let r = new wE(this, t, !1);
    return r.addAll(e, xt.none, t.from, t.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let r = new wE(this, t, !0);
    return r.addAll(e, xt.none, t.from, t.to), xe.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let s = this.tags[i];
      if (j6(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, r, i) {
    for (let s = i ? this.styles.indexOf(i) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], a = o.style;
      if (!(a.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let c = o.getAttrs(t);
          if (c === !1)
            continue;
          o.attrs = c || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function r(i) {
      let s = i.priority == null ? 50 : i.priority, o = 0;
      for (; o < t.length; o++) {
        let a = t[o];
        if ((a.priority == null ? 50 : a.priority) < s)
          break;
      }
      t.splice(o, 0, i);
    }
    for (let i in e.marks) {
      let s = e.marks[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = EE(o)), o.mark || o.ignore || o.clearMark || (o.mark = i);
      });
    }
    for (let i in e.nodes) {
      let s = e.nodes[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = EE(o)), o.node || o.ignore || o.mark || (o.node = i);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Ys(e, Ys.schemaRules(e)));
  }
}
const NR = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, L6 = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, PR = { ol: !0, ul: !0 }, Tc = 1, Ng = 2, rc = 4;
function SE(n, e, t) {
  return e != null ? (e ? Tc : 0) | (e === "full" ? Ng : 0) : n && n.whitespace == "pre" ? Tc | Ng : t & ~rc;
}
class ed {
  constructor(e, t, r, i, s, o) {
    this.type = e, this.attrs = t, this.marks = r, this.solid = i, this.options = o, this.content = [], this.activeMarks = xt.none, this.match = s || (o & rc ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(le.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Tc)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let s = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - i[0].length));
      }
    }
    let t = le.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(le.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !NR.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class wE {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = t.topNode, s, o = SE(null, t.preserveWhitespace, 0) | (r ? rc : 0);
    i ? s = new ed(i.type, i.attrs, xt.none, !0, t.topMatch || i.type.contentMatch, o) : r ? s = new ed(null, null, xt.none, !0, null, o) : s = new ed(e.schema.topNodeType, null, xt.none, !0, null, o), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let r = e.nodeValue, i = this.top, s = i.options & Ng ? "full" : this.localPreserveWS || (i.options & Tc) > 0, { schema: o } = this.parser;
    if (s === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (s)
        if (s === "full")
          r = r.replace(/\r\n?/g, `
`);
        else if (o.linebreakReplacement && /[\r\n]/.test(r) && this.top.findWrapping(o.linebreakReplacement.create())) {
          let a = r.split(/\r?\n|\r/);
          for (let c = 0; c < a.length; c++)
            c && this.insertNode(o.linebreakReplacement.create(), t, !0), a[c] && this.insertNode(o.text(a[c]), t, !/\S/.test(a[c]));
          r = "";
        } else
          r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let a = i.content[i.content.length - 1], c = e.previousSibling;
        (!a || c && c.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (r = r.slice(1));
      }
      r && this.insertNode(o.text(r), t, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, r) {
    let i = this.localPreserveWS, s = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), a;
    PR.hasOwnProperty(o) && this.parser.normalizeLists && B6(e);
    let c = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, r));
    e: if (c ? c.ignore : L6.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!c || c.skip || c.closeParent) {
      c && c.closeParent ? this.open = Math.max(0, this.open - 1) : c && c.skip.nodeType && (e = c.skip);
      let u, f = this.needsBlock;
      if (NR.hasOwnProperty(o))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), u = !0, s.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let h = c && c.skip ? t : this.readStyles(e, t);
      h && this.addAll(e, h), u && this.sync(s), this.needsBlock = f;
    } else {
      let u = this.readStyles(e, t);
      u && this.addElementByRule(e, c, u, c.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let r = e.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let s = this.parser.matchedStyles[i], o = r.getPropertyValue(s);
        if (o)
          for (let a = void 0; ; ) {
            let c = this.parser.matchStyle(s, o, this, a);
            if (!c)
              break;
            if (c.ignore)
              return null;
            if (c.clearMark ? t = t.filter((u) => !c.clearMark(u)) : t = t.concat(this.parser.schema.marks[c.mark].create(c.attrs)), c.consuming === !1)
              a = c;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, r, i) {
    let s, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let c = this.enter(o, t.attrs || null, r, t.preserveWhitespace);
        c && (s = !0, r = c);
      }
    else {
      let c = this.parser.schema.marks[t.mark];
      r = r.concat(c.create(t.attrs));
    }
    let a = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, r, i);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((c) => this.insertNode(c, r, !1));
    else {
      let c = e;
      typeof t.contentElement == "string" ? c = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? c = t.contentElement(e) : t.contentElement && (c = t.contentElement), this.findAround(e, c, !0), this.addAll(c, r), this.findAround(e, c, !1);
    }
    s && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, r, i) {
    let s = r || 0;
    for (let o = r ? e.childNodes[r] : e.firstChild, a = i == null ? null : e.childNodes[i]; o != a; o = o.nextSibling, ++s)
      this.findAtPoint(e, s), this.addDOM(o, t);
    this.findAtPoint(e, s);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, r) {
    let i, s;
    for (let o = this.open, a = 0; o >= 0; o--) {
      let c = this.nodes[o], u = c.findWrapping(e);
      if (u && (!i || i.length > u.length + a) && (i = u, s = c, !u.length))
        break;
      if (c.solid) {
        if (r)
          break;
        a += 2;
      }
    }
    if (!i)
      return null;
    this.sync(s);
    for (let o = 0; o < i.length; o++)
      t = this.enterInner(i[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let s = this.textblockFromContext();
      s && (t = this.enterInner(s, null, t));
    }
    let i = this.findPlace(e, t, r);
    if (i) {
      this.closeExtra();
      let s = this.top;
      s.match && (s.match = s.match.matchType(e.type));
      let o = xt.none;
      for (let a of i.concat(e.marks))
        (s.type ? s.type.allowsMarkType(a.type) : AE(a.type, e.type)) && (o = a.addToSet(o));
      return s.content.push(e.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, r, i) {
    let s = this.findPlace(e.create(t), r, !1);
    return s && (s = this.enterInner(e, t, r, !0, i)), s;
  }
  // Open a node of the given type
  enterInner(e, t, r, i = !1, s) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let a = SE(e, s, o.options);
    o.options & rc && o.content.length == 0 && (a |= rc);
    let c = xt.none;
    return r = r.filter((u) => (o.type ? o.type.allowsMarkType(u.type) : AE(u.type, e)) ? (c = u.addToSet(c), !1) : !0), this.nodes.push(new ed(e, t, c, i, null, a)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= Tc);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && t.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), s = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), o = (a, c) => {
      for (; a >= 0; a--) {
        let u = t[a];
        if (u == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; c >= s; c--)
            if (o(a - 1, c))
              return !0;
          return !1;
        } else {
          let f = c > 0 || c == 0 && i ? this.nodes[c].type : r && c >= s ? r.node(c - s).type : null;
          if (!f || f.name != u && !f.isInGroup(u))
            return !1;
          c--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function B6(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && PR.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function j6(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function EE(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function AE(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let i = t[r];
    if (!i.allowsMarkType(n))
      continue;
    let s = [], o = (a) => {
      s.push(a);
      for (let c = 0; c < a.edgeCount; c++) {
        let { type: u, next: f } = a.edge(c);
        if (u == e || s.indexOf(f) < 0 && o(f))
          return !0;
      }
    };
    if (o(i.contentMatch))
      return !0;
  }
}
class ea {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, r) {
    r || (r = cm(t).createDocumentFragment());
    let i = r, s = [];
    return e.forEach((o) => {
      if (s.length || o.marks.length) {
        let a = 0, c = 0;
        for (; a < s.length && c < o.marks.length; ) {
          let u = o.marks[c];
          if (!this.marks[u.type.name]) {
            c++;
            continue;
          }
          if (!u.eq(s[a][0]) || u.type.spec.spanning === !1)
            break;
          a++, c++;
        }
        for (; a < s.length; )
          i = s.pop()[1];
        for (; c < o.marks.length; ) {
          let u = o.marks[c++], f = this.serializeMark(u, o.isInline, t);
          f && (s.push([u, i]), i.appendChild(f.dom), i = f.contentDOM || f.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(o, t));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: i } = Ed(cm(t), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let s = this.serializeMark(e.marks[i], e.isInline, t);
      s && ((s.contentDOM || s.dom).appendChild(r), r = s.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, t, r = {}) {
    let i = this.marks[e.type.name];
    return i && Ed(cm(r), i(e, t), null, e.attrs);
  }
  static renderSpec(e, t, r = null, i) {
    return Ed(e, t, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new ea(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = TE(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return TE(e.marks);
  }
}
function TE(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function cm(n) {
  return n.document || window.document;
}
const CE = /* @__PURE__ */ new WeakMap();
function F6(n) {
  let e = CE.get(n);
  return e === void 0 && CE.set(n, e = z6(n)), e;
}
function z6(n) {
  let e = null;
  function t(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let i = 0; i < r.length; i++)
            t(r[i]);
      else
        for (let i in r)
          t(r[i]);
  }
  return t(n), e;
}
function Ed(n, e, t, r) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let i = e[0], s;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (s = F6(r)) && s.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = i.indexOf(" ");
  o > 0 && (t = i.slice(0, o), i = i.slice(o + 1));
  let a, c = t ? n.createElementNS(t, i) : n.createElement(i), u = e[1], f = 1;
  if (u && typeof u == "object" && u.nodeType == null && !Array.isArray(u)) {
    f = 2;
    for (let h in u)
      if (u[h] != null) {
        let p = h.indexOf(" ");
        p > 0 ? c.setAttributeNS(h.slice(0, p), h.slice(p + 1), u[h]) : h == "style" && c.style ? c.style.cssText = u[h] : c.setAttribute(h, u[h]);
      }
  }
  for (let h = f; h < e.length; h++) {
    let p = e[h];
    if (p === 0) {
      if (h < e.length - 1 || h > f)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: c, contentDOM: c };
    } else {
      let { dom: g, contentDOM: y } = Ed(n, p, t, r);
      if (c.appendChild(g), y) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = y;
      }
    }
  }
  return { dom: c, contentDOM: a };
}
const LR = 65535, BR = Math.pow(2, 16);
function V6(n, e) {
  return n + e * BR;
}
function DE(n) {
  return n & LR;
}
function H6(n) {
  return (n - (n & LR)) / BR;
}
const jR = 1, FR = 2, Ad = 4, zR = 8;
class Pg {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & zR) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (jR | Ad)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (FR | Ad)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Ad) > 0;
  }
}
class Cr {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && Cr.empty)
      return Cr.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = DE(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        t += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + t + H6(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let c = this.ranges[a] - (this.inverted ? i : 0);
      if (c > e)
        break;
      let u = this.ranges[a + s], f = this.ranges[a + o], h = c + u;
      if (e <= h) {
        let p = u ? e == c ? -1 : e == h ? 1 : t : t, g = c + i + (p < 0 ? 0 : f);
        if (r)
          return g;
        let y = e == (t < 0 ? c : h) ? null : V6(a / 3, e - c), x = e == c ? FR : e == h ? jR : Ad;
        return (t < 0 ? e != c : e != h) && (x |= zR), new Pg(g, x, y);
      }
      i += f - u;
    }
    return r ? e + i : new Pg(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, i = DE(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let c = this.ranges[a] - (this.inverted ? r : 0);
      if (c > e)
        break;
      let u = this.ranges[a + s], f = c + u;
      if (e <= f && a == i * 3)
        return !0;
      r += this.ranges[a + o] - u;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, s = 0; i < this.ranges.length; i += 3) {
      let o = this.ranges[i], a = o - (this.inverted ? s : 0), c = o + (this.inverted ? 0 : s), u = this.ranges[i + t], f = this.ranges[i + r];
      e(a, a + u, c, c + f), s += f - u;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Cr(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? Cr.empty : new Cr(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
Cr.empty = new Cr([]);
class Cc {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, r = 0, i = e ? e.length : 0) {
    this.mirror = t, this.from = r, this.to = i, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new Cc(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this._maps.length; t < e._maps.length; t++) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t], i != null && i < t ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this._maps.length + e._maps.length; t >= 0; t--) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), i != null && i > t ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new Cc();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0;
    for (let s = this.from; s < this.to; s++) {
      let o = this._maps[s], a = o.mapResult(e, t);
      if (a.recover != null) {
        let c = this.getMirror(s);
        if (c != null && c > s && c < this.to) {
          s = c, e = this._maps[c].recover(a.recover);
          continue;
        }
      }
      i |= a.delInfo, e = a.pos;
    }
    return r ? e : new Pg(e, i, null);
  }
}
const um = /* @__PURE__ */ Object.create(null);
class Un {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Cr.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = um[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in um)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return um[e] = t, t.prototype.jsonID = e, t;
  }
}
class an {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new an(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new an(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, i) {
    try {
      return an.ok(e.replace(t, r, i));
    } catch (s) {
      if (s instanceof Zd)
        return an.fail(s.message);
      throw s;
    }
  }
}
function Cv(n, e, t) {
  let r = [];
  for (let i = 0; i < n.childCount; i++) {
    let s = n.child(i);
    s.content.size && (s = s.copy(Cv(s.content, e, s))), s.isInline && (s = e(s, t, i)), r.push(s);
  }
  return le.fromArray(r);
}
class Vs extends Un {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), s = new xe(Cv(t.content, (o, a) => !o.isAtom || !a.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), i), t.openStart, t.openEnd);
    return an.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new ki(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Vs(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Vs && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Vs(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Vs(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Un.jsonID("addMark", Vs);
class ki extends Un {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new xe(Cv(t.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), t.openStart, t.openEnd);
    return an.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Vs(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new ki(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof ki && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new ki(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new ki(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Un.jsonID("removeMark", ki);
class Hs extends Un {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return an.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return an.fromReplace(e, this.pos, this.pos + 1, new xe(le.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let i = 0; i < t.marks.length; i++)
          if (!t.marks[i].isInSet(r))
            return new Hs(this.pos, t.marks[i]);
        return new Hs(this.pos, this.mark);
      }
    }
    return new Yo(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Hs(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Hs(t.pos, e.markFromJSON(t.mark));
  }
}
Un.jsonID("addNodeMark", Hs);
class Yo extends Un {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return an.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return an.fromReplace(e, this.pos, this.pos + 1, new xe(le.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Hs(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Yo(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Yo(t.pos, e.markFromJSON(t.mark));
  }
}
Un.jsonID("removeNodeMark", Yo);
class mn extends Un {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, i = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && Lg(e, this.from, this.to) ? an.fail("Structure replace would overwrite content") : an.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Cr([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new mn(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new mn(t.pos, Math.max(t.pos, r.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof mn) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? xe.empty : new xe(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new mn(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? xe.empty : new xe(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new mn(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new mn(t.from, t.to, xe.fromJSON(e, t.slice), !!t.structure);
  }
}
Un.jsonID("replace", mn);
class bn extends Un {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, i, s, o, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = i, this.slice = s, this.insert = o, this.structure = a;
  }
  apply(e) {
    if (this.structure && (Lg(e, this.from, this.gapFrom) || Lg(e, this.gapTo, this.to)))
      return an.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return an.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? an.fromReplace(e, this.from, this.to, r) : an.fail("Content does not fit in gap");
  }
  getMap() {
    return new Cr([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new bn(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), s = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || i < t.pos || s > r.pos ? null : new bn(t.pos, r.pos, i, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new bn(t.from, t.to, t.gapFrom, t.gapTo, xe.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
Un.jsonID("replaceAround", bn);
function Lg(n, e, t) {
  let r = n.resolve(e), i = t - e, s = r.depth;
  for (; i > 0 && s > 0 && r.indexAfter(s) == r.node(s).childCount; )
    s--, i--;
  if (i > 0) {
    let o = r.node(s).maybeChild(r.indexAfter(s));
    for (; i > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, i--;
    }
  }
  return !1;
}
function W6(n, e, t, r) {
  let i = [], s = [], o, a;
  n.doc.nodesBetween(e, t, (c, u, f) => {
    if (!c.isInline)
      return;
    let h = c.marks;
    if (!r.isInSet(h) && f.type.allowsMarkType(r.type)) {
      let p = Math.max(u, e), g = Math.min(u + c.nodeSize, t), y = r.addToSet(h);
      for (let x = 0; x < h.length; x++)
        h[x].isInSet(y) || (o && o.to == p && o.mark.eq(h[x]) ? o.to = g : i.push(o = new ki(p, g, h[x])));
      a && a.to == p ? a.to = g : s.push(a = new Vs(p, g, r));
    }
  }), i.forEach((c) => n.step(c)), s.forEach((c) => n.step(c));
}
function U6(n, e, t, r) {
  let i = [], s = 0;
  n.doc.nodesBetween(e, t, (o, a) => {
    if (!o.isInline)
      return;
    s++;
    let c = null;
    if (r instanceof Zf) {
      let u = o.marks, f;
      for (; f = r.isInSet(u); )
        (c || (c = [])).push(f), u = f.removeFromSet(u);
    } else r ? r.isInSet(o.marks) && (c = [r]) : c = o.marks;
    if (c && c.length) {
      let u = Math.min(a + o.nodeSize, t);
      for (let f = 0; f < c.length; f++) {
        let h = c[f], p;
        for (let g = 0; g < i.length; g++) {
          let y = i[g];
          y.step == s - 1 && h.eq(i[g].style) && (p = y);
        }
        p ? (p.to = u, p.step = s) : i.push({ style: h, from: Math.max(a, e), to: u, step: s });
      }
    }
  }), i.forEach((o) => n.step(new ki(o.from, o.to, o.style)));
}
function Dv(n, e, t, r = t.contentMatch, i = !0) {
  let s = n.doc.nodeAt(e), o = [], a = e + 1;
  for (let c = 0; c < s.childCount; c++) {
    let u = s.child(c), f = a + u.nodeSize, h = r.matchType(u.type);
    if (!h)
      o.push(new mn(a, f, xe.empty));
    else {
      r = h;
      for (let p = 0; p < u.marks.length; p++)
        t.allowsMarkType(u.marks[p].type) || n.step(new ki(a, f, u.marks[p]));
      if (i && u.isText && t.whitespace != "pre") {
        let p, g = /\r?\n|\r/g, y;
        for (; p = g.exec(u.text); )
          y || (y = new xe(le.from(t.schema.text(" ", t.allowedMarks(u.marks))), 0, 0)), o.push(new mn(a + p.index, a + p.index + p[0].length, y));
      }
    }
    a = f;
  }
  if (!r.validEnd) {
    let c = r.fillBefore(le.empty, !0);
    n.replace(a, a, new xe(c, 0, 0));
  }
  for (let c = o.length - 1; c >= 0; c--)
    n.step(o[c]);
}
function $6(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function ll(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth, i = 0, s = 0; ; --r) {
    let o = n.$from.node(r), a = n.$from.index(r) + i, c = n.$to.indexAfter(r) - s;
    if (r < n.depth && o.canReplace(a, c, t))
      return r;
    if (r == 0 || o.type.spec.isolating || !$6(o, a, c))
      break;
    a && (i = 1), c < o.childCount && (s = 1);
  }
  return null;
}
function G6(n, e, t) {
  let { $from: r, $to: i, depth: s } = e, o = r.before(s + 1), a = i.after(s + 1), c = o, u = a, f = le.empty, h = 0;
  for (let y = s, x = !1; y > t; y--)
    x || r.index(y) > 0 ? (x = !0, f = le.from(r.node(y).copy(f)), h++) : c--;
  let p = le.empty, g = 0;
  for (let y = s, x = !1; y > t; y--)
    x || i.after(y + 1) < i.end(y) ? (x = !0, p = le.from(i.node(y).copy(p)), g++) : u++;
  n.step(new bn(c, u, o, a, new xe(f.append(p), h, g), f.size - h, !0));
}
function Rv(n, e, t = null, r = n) {
  let i = Y6(n, e), s = i && q6(r, e);
  return s ? i.map(RE).concat({ type: e, attrs: t }).concat(s.map(RE)) : null;
}
function RE(n) {
  return { type: n, attrs: null };
}
function Y6(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.contentMatchAt(r).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return t.canReplaceWith(r, i, o) ? s : null;
}
function q6(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.child(r), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let c = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let u = r; c && u < i; u++)
    c = c.matchType(t.child(u).type);
  return !c || !c.validEnd ? null : o;
}
function K6(n, e, t) {
  let r = le.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (r.size) {
      let a = t[o].type.contentMatch.matchFragment(r);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = le.from(t[o].type.create(t[o].attrs, r));
  }
  let i = e.start, s = e.end;
  n.step(new bn(i, s, i, s, new xe(r, 0, 0), t.length, !0));
}
function J6(n, e, t, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = n.steps.length;
  n.doc.nodesBetween(e, t, (o, a) => {
    let c = typeof i == "function" ? i(o) : i;
    if (o.isTextblock && !o.hasMarkup(r, c) && Q6(n.doc, n.mapping.slice(s).map(a), r)) {
      let u = null;
      if (r.schema.linebreakReplacement) {
        let g = r.whitespace == "pre", y = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        g && !y ? u = !1 : !g && y && (u = !0);
      }
      u === !1 && HR(n, o, a, s), Dv(n, n.mapping.slice(s).map(a, 1), r, void 0, u === null);
      let f = n.mapping.slice(s), h = f.map(a, 1), p = f.map(a + o.nodeSize, 1);
      return n.step(new bn(h, p, h + 1, p - 1, new xe(le.from(r.create(c, null, o.marks)), 0, 0), 1, !0)), u === !0 && VR(n, o, a, s), !1;
    }
  });
}
function VR(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.isText) {
      let o, a = /\r?\n|\r/g;
      for (; o = a.exec(i.text); ) {
        let c = n.mapping.slice(r).map(t + 1 + s + o.index);
        n.replaceWith(c, c + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function HR(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let o = n.mapping.slice(r).map(t + 1 + s);
      n.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function Q6(n, e, t) {
  let r = n.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, t);
}
function Z6(n, e, t, r, i) {
  let s = n.doc.nodeAt(e);
  if (!s)
    throw new RangeError("No node at given position");
  t || (t = s.type);
  let o = t.create(r, null, i || s.marks);
  if (s.isLeaf)
    return n.replaceWith(e, e + s.nodeSize, o);
  if (!t.validContent(s.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new bn(e, e + s.nodeSize, e + 1, e + s.nodeSize - 1, new xe(le.from(o), 0, 0), 1, !0));
}
function rs(n, e, t = 1, r) {
  let i = n.resolve(e), s = i.depth - t, o = r && r[r.length - 1] || i.parent;
  if (s < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let u = i.depth - 1, f = t - 2; u > s; u--, f--) {
    let h = i.node(u), p = i.index(u);
    if (h.type.spec.isolating)
      return !1;
    let g = h.content.cutByIndex(p, h.childCount), y = r && r[f + 1];
    y && (g = g.replaceChild(0, y.type.create(y.attrs)));
    let x = r && r[f] || h;
    if (!h.canReplace(p + 1, h.childCount) || !x.type.validContent(g))
      return !1;
  }
  let a = i.indexAfter(s), c = r && r[0];
  return i.node(s).canReplaceWith(a, a, c ? c.type : i.node(s + 1).type);
}
function X6(n, e, t = 1, r) {
  let i = n.doc.resolve(e), s = le.empty, o = le.empty;
  for (let a = i.depth, c = i.depth - t, u = t - 1; a > c; a--, u--) {
    s = le.from(i.node(a).copy(s));
    let f = r && r[u];
    o = le.from(f ? f.type.create(f.attrs, o) : i.node(a).copy(o));
  }
  n.step(new mn(e, e, new xe(s.append(o), t, t), !0));
}
function io(n, e) {
  let t = n.resolve(e), r = t.index();
  return WR(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function eG(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: r } = n.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let s = e.child(i), o = s.type == r ? n.type.schema.nodes.text : s.type;
    if (t = t.matchType(o), !t || !n.type.allowsMarks(s.marks))
      return !1;
  }
  return t.validEnd;
}
function WR(n, e) {
  return !!(n && e && !n.isLeaf && eG(n, e));
}
function Xf(n, e, t = -1) {
  let r = n.resolve(e);
  for (let i = r.depth; ; i--) {
    let s, o, a = r.index(i);
    if (i == r.depth ? (s = r.nodeBefore, o = r.nodeAfter) : t > 0 ? (s = r.node(i + 1), a++, o = r.node(i).maybeChild(a)) : (s = r.node(i).maybeChild(a - 1), o = r.node(i + 1)), s && !s.isTextblock && WR(s, o) && r.node(i).canReplace(a, a + 1))
      return e;
    if (i == 0)
      break;
    e = t < 0 ? r.before(i) : r.after(i);
  }
}
function tG(n, e, t) {
  let r = null, { linebreakReplacement: i } = n.doc.type.schema, s = n.doc.resolve(e - t), o = s.node().type;
  if (i && o.inlineContent) {
    let f = o.whitespace == "pre", h = !!o.contentMatch.matchType(i);
    f && !h ? r = !1 : !f && h && (r = !0);
  }
  let a = n.steps.length;
  if (r === !1) {
    let f = n.doc.resolve(e + t);
    HR(n, f.node(), f.before(), a);
  }
  o.inlineContent && Dv(n, e + t - 1, o, s.node().contentMatchAt(s.index()), r == null);
  let c = n.mapping.slice(a), u = c.map(e - t);
  if (n.step(new mn(u, c.map(e + t, -1), xe.empty, !0)), r === !0) {
    let f = n.doc.resolve(u);
    VR(n, f.node(), f.before(), n.steps.length);
  }
  return n;
}
function nG(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.index(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.before(i + 1);
      if (s > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.indexAfter(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.after(i + 1);
      if (s < r.node(i).childCount)
        return null;
    }
  return null;
}
function UR(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let i = t.content;
  for (let s = 0; s < t.openStart; s++)
    i = i.firstChild.content;
  for (let s = 1; s <= (t.openStart == 0 && t.size ? 2 : 1); s++)
    for (let o = r.depth; o >= 0; o--) {
      let a = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, c = r.index(o) + (a > 0 ? 1 : 0), u = r.node(o), f = !1;
      if (s == 1)
        f = u.canReplace(c, c, i);
      else {
        let h = u.contentMatchAt(c).findWrapping(i.firstChild.type);
        f = h && u.canReplaceWith(c, c, h[0]);
      }
      if (f)
        return a == 0 ? r.pos : a < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function eh(n, e, t = e, r = xe.empty) {
  if (e == t && !r.size)
    return null;
  let i = n.resolve(e), s = n.resolve(t);
  return $R(i, s, r) ? new mn(e, t, r) : new rG(i, s, r).fit();
}
function $R(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class rG {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = le.empty;
    for (let i = 0; i <= e.depth; i++) {
      let s = e.node(i);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = le.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let u = this.findFittable();
      u ? this.placeNodes(u) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let s = this.placed, o = r.depth, a = i.depth;
    for (; o && a && s.childCount == 1; )
      s = s.firstChild.content, o--, a--;
    let c = new xe(s, o, a);
    return e > -1 ? new bn(r.pos, e, this.$to.pos, this.$to.end(), c, t) : c.size || r.pos != this.$to.pos ? new mn(r.pos, i.pos, c) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let s = t.firstChild;
      if (t.childCount > 1 && (i = 0), s.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      t = s.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, s = null;
        r ? (s = dm(this.unplaced.content, r - 1).firstChild, i = s.content) : i = this.unplaced.content;
        let o = i.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: c, match: u } = this.frontier[a], f, h = null;
          if (t == 1 && (o ? u.matchType(o.type) || (h = u.fillBefore(le.from(o), !1)) : s && c.compatibleContent(s.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, inject: h };
          if (t == 2 && o && (f = u.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, wrap: f };
          if (s && u.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = dm(e, t);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new xe(e, t + 1, Math.max(r, i.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = dm(e, t);
    if (i.childCount <= 1 && t > 0) {
      let s = e.size - t <= t + i.size;
      this.unplaced = new xe(Hl(e, t - 1, 1), t - 1, s ? t - 1 : r);
    } else
      this.unplaced = new xe(Hl(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: i, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let x = 0; x < s.length; x++)
        this.openFrontierNode(s[x]);
    let o = this.unplaced, a = r ? r.content : o.content, c = o.openStart - e, u = 0, f = [], { match: h, type: p } = this.frontier[t];
    if (i) {
      for (let x = 0; x < i.childCount; x++)
        f.push(i.child(x));
      h = h.matchFragment(i);
    }
    let g = a.size + e - (o.content.size - o.openEnd);
    for (; u < a.childCount; ) {
      let x = a.child(u), S = h.matchType(x.type);
      if (!S)
        break;
      u++, (u > 1 || c == 0 || x.content.size) && (h = S, f.push(GR(x.mark(p.allowedMarks(x.marks)), u == 1 ? c : 0, u == a.childCount ? g : -1)));
    }
    let y = u == a.childCount;
    y || (g = -1), this.placed = Wl(this.placed, t, le.from(f)), this.frontier[t].match = h, y && g < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let x = 0, S = a; x < g; x++) {
      let w = S.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), S = w.content;
    }
    this.unplaced = y ? e == 0 ? xe.empty : new xe(Hl(o.content, e - 1, 1), e - 1, g < 0 ? o.openEnd : e - 1) : new xe(Hl(o.content, e, u), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !fm(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: r, type: i } = this.frontier[t], s = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = fm(e, t, i, r, s);
      if (o) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: c, type: u } = this.frontier[a], f = fm(e, a, u, c, !0);
          if (!f || f.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: s ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Wl(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), s = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Wl(this.placed, this.depth, le.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(le.empty, !0);
    t.childCount && (this.placed = Wl(this.placed, this.frontier.length, t));
  }
}
function Hl(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Hl(n.firstChild.content, e - 1, t)));
}
function Wl(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Wl(n.lastChild.content, e - 1, t)));
}
function dm(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function GR(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, GR(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(le.empty, !0)))), n.copy(r);
}
function fm(n, e, t, r, i) {
  let s = n.node(e), o = i ? n.indexAfter(e) : n.index(e);
  if (o == s.childCount && !t.compatibleContent(s.type))
    return null;
  let a = r.fillBefore(s.content, !0, o);
  return a && !iG(t, s.content, o) ? a : null;
}
function iG(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function sG(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function oG(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let i = n.doc.resolve(e), s = n.doc.resolve(t);
  if ($R(i, s, r))
    return n.step(new mn(e, t, r));
  let o = qR(i, s);
  o[o.length - 1] == 0 && o.pop();
  let a = -(i.depth + 1);
  o.unshift(a);
  for (let p = i.depth, g = i.pos - 1; p > 0; p--, g--) {
    let y = i.node(p).type.spec;
    if (y.defining || y.definingAsContext || y.isolating)
      break;
    o.indexOf(p) > -1 ? a = p : i.before(p) == g && o.splice(1, 0, -p);
  }
  let c = o.indexOf(a), u = [], f = r.openStart;
  for (let p = r.content, g = 0; ; g++) {
    let y = p.firstChild;
    if (u.push(y), g == r.openStart)
      break;
    p = y.content;
  }
  for (let p = f - 1; p >= 0; p--) {
    let g = u[p], y = sG(g.type);
    if (y && !g.sameMarkup(i.node(Math.abs(a) - 1)))
      f = p;
    else if (y || !g.type.isTextblock)
      break;
  }
  for (let p = r.openStart; p >= 0; p--) {
    let g = (p + f + 1) % (r.openStart + 1), y = u[g];
    if (y)
      for (let x = 0; x < o.length; x++) {
        let S = o[(x + c) % o.length], w = !0;
        S < 0 && (w = !1, S = -S);
        let C = i.node(S - 1), T = i.index(S - 1);
        if (C.canReplaceWith(T, T, y.type, y.marks))
          return n.replace(i.before(S), w ? s.after(S) : t, new xe(YR(r.content, 0, r.openStart, g), g, r.openEnd));
      }
  }
  let h = n.steps.length;
  for (let p = o.length - 1; p >= 0 && (n.replace(e, t, r), !(n.steps.length > h)); p--) {
    let g = o[p];
    g < 0 || (e = i.before(g), t = s.after(g));
  }
}
function YR(n, e, t, r, i) {
  if (e < t) {
    let s = n.firstChild;
    n = n.replaceChild(0, s.copy(YR(s.content, e + 1, t, r, s)));
  }
  if (e > r) {
    let s = i.contentMatchAt(0), o = s.fillBefore(n).append(n);
    n = o.append(s.matchFragment(o).fillBefore(le.empty, !0));
  }
  return n;
}
function aG(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let i = nG(n.doc, e, r.type);
    i != null && (e = t = i);
  }
  n.replaceRange(e, t, new xe(le.from(r), 0, 0));
}
function lG(n, e, t) {
  let r = n.doc.resolve(e), i = n.doc.resolve(t), s = qR(r, i);
  for (let o = 0; o < s.length; o++) {
    let a = s[o], c = o == s.length - 1;
    if (c && a == 0 || r.node(a).type.contentMatch.validEnd)
      return n.delete(r.start(a), i.end(a));
    if (a > 0 && (c || r.node(a - 1).canReplace(r.index(a - 1), i.indexAfter(a - 1))))
      return n.delete(r.before(a), i.after(a));
  }
  for (let o = 1; o <= r.depth && o <= i.depth; o++)
    if (e - r.start(o) == r.depth - o && t > r.end(o) && i.end(o) - t != i.depth - o && r.start(o - 1) == i.start(o - 1) && r.node(o - 1).canReplace(r.index(o - 1), i.index(o - 1)))
      return n.delete(r.before(o), t);
  n.delete(e, t);
}
function qR(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let s = n.start(i);
    if (s < n.pos - (n.depth - i) || e.end(i) > e.pos + (e.depth - i) || n.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (s == e.start(i) || i == n.depth && i == e.depth && n.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == s - 1) && t.push(i);
  }
  return t;
}
class $a extends Un {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return an.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      r[s] = t.attrs[s];
    r[this.attr] = this.value;
    let i = t.type.create(r, null, t.marks);
    return an.fromReplace(e, this.pos, this.pos + 1, new xe(le.from(i), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return Cr.empty;
  }
  invert(e) {
    return new $a(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new $a(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new $a(t.pos, t.attr, t.value);
  }
}
Un.jsonID("attr", $a);
class Dc extends Un {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      t[i] = e.attrs[i];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return an.ok(r);
  }
  getMap() {
    return Cr.empty;
  }
  invert(e) {
    return new Dc(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Dc(t.attr, t.value);
  }
}
Un.jsonID("docAttr", Dc);
let Za = class extends Error {
};
Za = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
Za.prototype = Object.create(Error.prototype);
Za.prototype.constructor = Za;
Za.prototype.name = "TransformError";
class KR {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new Cc();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new Za(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let e = 1e9, t = -1e9;
    for (let r = 0; r < this.mapping.maps.length; r++) {
      let i = this.mapping.maps[r];
      r && (e = i.map(e, 1), t = i.map(t, -1)), i.forEach((s, o, a, c) => {
        e = Math.min(e, a), t = Math.max(t, c);
      });
    }
    return e == 1e9 ? null : { from: e, to: t };
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = xe.empty) {
    let i = eh(this.doc, e, t, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new xe(le.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, xe.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return oG(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return aG(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return lG(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return G6(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return tG(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return K6(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, i = null) {
    return J6(this, e, t, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, i) {
    return Z6(this, e, t, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new $a(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new Dc(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Hs(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (t instanceof xt)
      t.isInSet(r.marks) && this.step(new Yo(e, t));
    else {
      let i = r.marks, s, o = [];
      for (; s = t.isInSet(i); )
        o.push(new Yo(e, s)), i = s.removeFromSet(i);
      for (let a = o.length - 1; a >= 0; a--)
        this.step(o[a]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, r) {
    return X6(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return W6(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return U6(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return Dv(this, e, t, r), this;
  }
}
const hm = /* @__PURE__ */ Object.create(null);
class Qe {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new cG(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = xe.empty) {
    let r = t.content.lastChild, i = null;
    for (let a = 0; a < t.openEnd; a++)
      i = r, r = r.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: c, $to: u } = o[a], f = e.mapping.slice(s);
      e.replaceRange(f.map(c.pos), f.map(u.pos), a ? xe.empty : t), a == 0 && _E(e, s, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let r = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      let { $from: o, $to: a } = i[s], c = e.mapping.slice(r), u = c.map(o.pos), f = c.map(a.pos);
      s ? e.deleteRange(u, f) : (e.replaceRangeWith(u, f, t), _E(e, r, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, r = !1) {
    let i = e.parent.inlineContent ? new ze(e) : Ma(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (i)
      return i;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = t < 0 ? Ma(e.node(0), e.node(s), e.before(s + 1), e.index(s), t, r) : Ma(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, t, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new kr(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Ma(e, e, 0, 0, 1) || new kr(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Ma(e, e, e.content.size, e.childCount, -1) || new kr(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = hm[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in hm)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return hm[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return ze.between(this.$anchor, this.$head).getBookmark();
  }
}
Qe.prototype.visible = !0;
class cG {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let kE = !1;
function ME(n) {
  !kE && !n.parent.inlineContent && (kE = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class ze extends Qe {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    ME(e), ME(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return Qe.near(r);
    let i = e.resolve(t.map(this.anchor));
    return new ze(i.parent.inlineContent ? i : r, r);
  }
  replace(e, t = xe.empty) {
    if (super.replace(e, t), t == xe.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof ze && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new th(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new ze(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, r = t) {
    let i = e.resolve(t);
    return new this(i, r == t ? i : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, r) {
    let i = e.pos - t.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = Qe.findFrom(t, r, !0) || Qe.findFrom(t, -r, !0);
      if (s)
        t = s.$head;
      else
        return Qe.near(t, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = t : (e = (Qe.findFrom(e, -r, !0) || Qe.findFrom(e, r, !0)).$anchor, e.pos < t.pos != i < 0 && (e = t))), new ze(e, t);
  }
}
Qe.jsonID("text", ze);
class th {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new th(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return ze.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class Me extends Qe {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: i } = t.mapResult(this.anchor), s = e.resolve(i);
    return r ? Qe.near(s) : new Me(s);
  }
  content() {
    return new xe(le.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof Me && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new kv(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Me(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new Me(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
Me.prototype.visible = !1;
Qe.jsonID("node", Me);
class kv {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new th(r, r) : new kv(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && Me.isSelectable(r) ? new Me(t) : Qe.near(t);
  }
}
class kr extends Qe {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = xe.empty) {
    if (t == xe.empty) {
      e.delete(0, e.doc.content.size);
      let r = Qe.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new kr(e);
  }
  map(e) {
    return new kr(e);
  }
  eq(e) {
    return e instanceof kr;
  }
  getBookmark() {
    return uG;
  }
}
Qe.jsonID("all", kr);
const uG = {
  map() {
    return this;
  },
  resolve(n) {
    return new kr(n);
  }
};
function Ma(n, e, t, r, i, s = !1) {
  if (e.inlineContent)
    return ze.create(n, t);
  for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < e.childCount : o >= 0; o += i) {
    let a = e.child(o);
    if (a.isAtom) {
      if (!s && Me.isSelectable(a))
        return Me.create(n, t - (i < 0 ? a.nodeSize : 0));
    } else {
      let c = Ma(n, a, t + i, i < 0 ? a.childCount : 0, i, s);
      if (c)
        return c;
    }
    t += a.nodeSize * i;
  }
  return null;
}
function _E(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let i = n.steps[r];
  if (!(i instanceof mn || i instanceof bn))
    return;
  let s = n.mapping.maps[r], o;
  s.forEach((a, c, u, f) => {
    o == null && (o = f);
  }), n.setSelection(Qe.near(n.doc.resolve(o), t));
}
const OE = 1, td = 2, IE = 4;
class dG extends KR {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | OE) & ~td, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & OE) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= td, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return xt.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & td) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~td, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || xt.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, r) {
    let i = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), !e)
        return this.deleteRange(t, r);
      let s = this.storedMarks;
      if (!s) {
        let o = this.doc.resolve(t);
        s = r == t ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, i.text(e, s)), !this.selection.empty && this.selection.to == t + e.length && this.setSelection(Qe.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= IE, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & IE) > 0;
  }
}
function NE(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Ul {
  constructor(e, t, r) {
    this.name = e, this.init = NE(t.init, r), this.apply = NE(t.apply, r);
  }
}
const fG = [
  new Ul("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Ul("selection", {
    init(n, e) {
      return n.selection || Qe.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Ul("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Ul("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class pm {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = fG.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Ul(r.key, r.spec.state, r));
    });
  }
}
class Fa {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let s = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let a = this.config.plugins[o];
        if (a.spec.appendTransaction) {
          let c = i ? i[o].n : 0, u = i ? i[o].state : this, f = c < t.length && a.spec.appendTransaction.call(a, c ? t.slice(c) : t, u, r);
          if (f && r.filterTransaction(f, o)) {
            if (f.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let h = 0; h < this.config.plugins.length; h++)
                i.push(h < o ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(f), r = r.applyInner(f), s = !0;
          }
          i && (i[o] = { state: r, n: t.length });
        }
      }
      if (!s)
        return { state: r, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Fa(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let s = r[i];
      t[s.name] = s.apply(e, this[s.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new dG(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new pm(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new Fa(t);
    for (let i = 0; i < t.fields.length; i++)
      r[t.fields[i].name] = t.fields[i].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new pm(this.schema, e.plugins), r = t.fields, i = new Fa(t);
    for (let s = 0; s < r.length; s++) {
      let o = r[s].name;
      i[o] = this.hasOwnProperty(o) ? this[o] : r[s].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], s = i.spec.state;
        s && s.toJSON && (t[r] = s.toJSON.call(i, this[i.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new pm(e.schema, e.plugins), s = new Fa(i);
    return i.fields.forEach((o) => {
      if (o.name == "doc")
        s.doc = Gs.fromJSON(e.schema, t.doc);
      else if (o.name == "selection")
        s.selection = Qe.fromJSON(s.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (s.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let a in r) {
            let c = r[a], u = c.spec.state;
            if (c.key == o.name && u && u.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              s[o.name] = u.fromJSON.call(c, e, t[a], s);
              return;
            }
          }
        s[o.name] = o.init(e, s);
      }
    }), s;
  }
}
function JR(n, e, t) {
  for (let r in n) {
    let i = n[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = JR(i, e, {})), t[r] = i;
  }
  return t;
}
class En {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && JR(e.props, this, this.props), this.key = e.key ? e.key.key : QR("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const mm = /* @__PURE__ */ Object.create(null);
function QR(n) {
  return n in mm ? n + "$" + ++mm[n] : (mm[n] = 0, n + "$");
}
class yr {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = QR(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const _n = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, Xa = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Bg = null;
const Zi = function(n, e, t) {
  let r = Bg || (Bg = document.createRange());
  return r.setEnd(n, t ?? n.nodeValue.length), r.setStart(n, e || 0), r;
}, hG = function() {
  Bg = null;
}, qo = function(n, e, t, r) {
  return t && (PE(n, e, t, r, -1) || PE(n, e, t, r, 1));
}, pG = /^(img|br|input|textarea|hr)$/i;
function PE(n, e, t, r, i) {
  for (var s; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (i < 0 ? 0 : Yr(n))) {
      let o = n.parentNode;
      if (!o || o.nodeType != 1 || Yc(n) || pG.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = _n(n) + (i < 0 ? 0 : 1), n = o;
    } else if (n.nodeType == 1) {
      let o = n.childNodes[e + (i < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((s = o.pmViewDesc) === null || s === void 0) && s.ignoreForSelection)
          e += i;
        else
          return !1;
      else
        n = o, e = i < 0 ? Yr(n) : 0;
    } else
      return !1;
  }
}
function Yr(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function mG(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = Yr(n);
    } else if (n.parentNode && !Yc(n))
      e = _n(n), n = n.parentNode;
    else
      return null;
  }
}
function gG(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !Yc(n))
      e = _n(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function yG(n, e, t) {
  for (let r = e == 0, i = e == Yr(n); r || i; ) {
    if (n == t)
      return !0;
    let s = _n(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && s == 0, i = i && s == Yr(n);
  }
}
function Yc(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const nh = function(n) {
  return n.focusNode && qo(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Ro(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function vG(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function bG(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Yr(r.offsetNode), r.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: Math.min(Yr(r.startContainer), r.startOffset) };
  }
}
const Ii = typeof navigator < "u" ? navigator : null, LE = typeof document < "u" ? document : null, so = Ii && Ii.userAgent || "", jg = /Edge\/(\d+)/.exec(so), ZR = /MSIE \d/.exec(so), Fg = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(so), mr = !!(ZR || Fg || jg), qs = ZR ? document.documentMode : Fg ? +Fg[1] : jg ? +jg[1] : 0, Qr = !mr && /gecko\/(\d+)/i.test(so);
Qr && +(/Firefox\/(\d+)/.exec(so) || [0, 0])[1];
const zg = !mr && /Chrome\/(\d+)/.exec(so), yn = !!zg, XR = zg ? +zg[1] : 0, Nn = !mr && !!Ii && /Apple Computer/.test(Ii.vendor), el = Nn && (/Mobile\/\w+/.test(so) || !!Ii && Ii.maxTouchPoints > 2), Gr = el || (Ii ? /Mac/.test(Ii.platform) : !1), ek = Ii ? /Win/.test(Ii.platform) : !1, ts = /Android \d/.test(so), qc = !!LE && "webkitFontSmoothing" in LE.documentElement.style, xG = qc ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function SG(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function qi(n, e) {
  return typeof n == "number" ? n : n[e];
}
function wG(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function BE(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, i = n.someProp("scrollMargin") || 5, s = n.dom.ownerDocument;
  for (let o = t || n.dom; o; ) {
    if (o.nodeType != 1) {
      o = Xa(o);
      continue;
    }
    let a = o, c = a == s.body, u = c ? SG(s) : wG(a), f = 0, h = 0;
    if (e.top < u.top + qi(r, "top") ? h = -(u.top - e.top + qi(i, "top")) : e.bottom > u.bottom - qi(r, "bottom") && (h = e.bottom - e.top > u.bottom - u.top ? e.top + qi(i, "top") - u.top : e.bottom - u.bottom + qi(i, "bottom")), e.left < u.left + qi(r, "left") ? f = -(u.left - e.left + qi(i, "left")) : e.right > u.right - qi(r, "right") && (f = e.right - u.right + qi(i, "right")), f || h)
      if (c)
        s.defaultView.scrollBy(f, h);
      else {
        let g = a.scrollLeft, y = a.scrollTop;
        h && (a.scrollTop += h), f && (a.scrollLeft += f);
        let x = a.scrollLeft - g, S = a.scrollTop - y;
        e = { left: e.left - x, top: e.top - S, right: e.right - x, bottom: e.bottom - S };
      }
    let p = c ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(p))
      break;
    o = p == "absolute" ? o.offsetParent : Xa(o);
  }
}
function EG(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, i;
  for (let s = (e.left + e.right) / 2, o = t + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let a = n.root.elementFromPoint(s, o);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let c = a.getBoundingClientRect();
    if (c.top >= t - 20) {
      r = a, i = c.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: tk(n.dom) };
}
function tk(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = Xa(r))
    ;
  return e;
}
function AG({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  nk(t, r == 0 ? 0 : r - e);
}
function nk(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: i, left: s } = n[t];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != s && (r.scrollLeft = s);
  }
}
let Sa = null;
function TG(n) {
  if (n.setActive)
    return n.setActive();
  if (Sa)
    return n.focus(Sa);
  let e = tk(n);
  n.focus(Sa == null ? {
    get preventScroll() {
      return Sa = { preventScroll: !0 }, !0;
    }
  } : void 0), Sa || (Sa = !1, nk(e, 0));
}
function rk(n, e) {
  let t, r = 2e8, i, s = 0, o = e.top, a = e.top, c, u;
  for (let f = n.firstChild, h = 0; f; f = f.nextSibling, h++) {
    let p;
    if (f.nodeType == 1)
      p = f.getClientRects();
    else if (f.nodeType == 3)
      p = Zi(f).getClientRects();
    else
      continue;
    for (let g = 0; g < p.length; g++) {
      let y = p[g];
      if (y.top <= o && y.bottom >= a) {
        o = Math.max(y.bottom, o), a = Math.min(y.top, a);
        let x = y.left > e.left ? y.left - e.left : y.right < e.left ? e.left - y.right : 0;
        if (x < r) {
          t = f, r = x, i = x && t.nodeType == 3 ? {
            left: y.right < e.left ? y.right : y.left,
            top: e.top
          } : e, f.nodeType == 1 && x && (s = h + (e.left >= (y.left + y.right) / 2 ? 1 : 0));
          continue;
        }
      } else y.top > e.top && !c && y.left <= e.left && y.right >= e.left && (c = f, u = { left: Math.max(y.left, Math.min(y.right, e.left)), top: y.top });
      !t && (e.left >= y.right && e.top >= y.top || e.left >= y.left && e.top >= y.bottom) && (s = h + 1);
    }
  }
  return !t && c && (t = c, i = u, r = 0), t && t.nodeType == 3 ? CG(t, i) : !t || r && t.nodeType == 1 ? { node: n, offset: s } : rk(t, i);
}
function CG(n, e) {
  let t = n.nodeValue.length, r = document.createRange(), i;
  for (let s = 0; s < t; s++) {
    r.setEnd(n, s + 1), r.setStart(n, s);
    let o = _s(r, 1);
    if (o.top != o.bottom && Mv(e, o)) {
      i = { node: n, offset: s + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return r.detach(), i || { node: n, offset: 0 };
}
function Mv(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function DG(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function RG(n, e, t) {
  let { node: r, offset: i } = rk(e, t), s = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    s = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, i, s);
}
function kG(n, e, t, r) {
  let i = -1;
  for (let s = e, o = !1; s != n.dom; ) {
    let a = n.docView.nearestDesc(s, !0), c;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((c = a.dom.getBoundingClientRect()).width || c.height) && (a.node.isBlock && a.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(a.dom.nodeName) && (!o && c.left > r.left || c.top > r.top ? i = a.posBefore : (!o && c.right < r.left || c.bottom < r.top) && (i = a.posAfter), o = !0), !a.contentDOM && i < 0 && !a.node.isText))
      return (a.node.isBlock ? r.top < (c.top + c.bottom) / 2 : r.left < (c.left + c.right) / 2) ? a.posBefore : a.posAfter;
    s = a.dom.parentNode;
  }
  return i > -1 ? i : n.docView.posFromDOM(e, t, -1);
}
function ik(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), s = i; ; ) {
      let o = n.childNodes[s];
      if (o.nodeType == 1) {
        let a = o.getClientRects();
        for (let c = 0; c < a.length; c++) {
          let u = a[c];
          if (Mv(e, u))
            return ik(o, e, u);
        }
      }
      if ((s = (s + 1) % r) == i)
        break;
    }
  return n;
}
function MG(n, e) {
  let t = n.dom.ownerDocument, r, i = 0, s = bG(t, e.left, e.top);
  s && ({ node: r, offset: i } = s);
  let o = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!o || !n.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let u = n.dom.getBoundingClientRect();
    if (!Mv(e, u) || (o = ik(n.dom, e, u), !o))
      return null;
  }
  if (Nn)
    for (let u = o; r && u; u = Xa(u))
      u.draggable && (r = void 0);
  if (o = DG(o, e), r) {
    if (Qr && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let f = r.childNodes[i], h;
      f.nodeName == "IMG" && (h = f.getBoundingClientRect()).right <= e.left && h.bottom > e.top && i++;
    }
    let u;
    qc && i && r.nodeType == 1 && (u = r.childNodes[i - 1]).nodeType == 1 && u.contentEditable == "false" && u.getBoundingClientRect().top >= e.top && i--, r == n.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (a = kG(n, r, i, e));
  }
  a == null && (a = RG(n, o, e));
  let c = n.docView.nearestDesc(o, !0);
  return { pos: a, inside: c ? c.posAtStart - c.border : -1 };
}
function jE(n) {
  return n.top < n.bottom || n.left < n.right;
}
function _s(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (jE(r))
      return r;
  }
  return Array.prototype.find.call(t, jE) || n.getBoundingClientRect();
}
const _G = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function sk(n, e, t) {
  let { node: r, offset: i, atom: s } = n.docView.domFromPos(e, t < 0 ? -1 : 1), o = qc || Qr;
  if (r.nodeType == 3)
    if (o && (_G.test(r.nodeValue) || (t < 0 ? !i : i == r.nodeValue.length))) {
      let c = _s(Zi(r, i, i), t);
      if (Qr && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let u = _s(Zi(r, i - 1, i - 1), -1);
        if (u.top == c.top) {
          let f = _s(Zi(r, i, i + 1), -1);
          if (f.top != c.top)
            return Nl(f, f.left < u.left);
        }
      }
      return c;
    } else {
      let c = i, u = i, f = t < 0 ? 1 : -1;
      return t < 0 && !i ? (u++, f = -1) : t >= 0 && i == r.nodeValue.length ? (c--, f = 1) : t < 0 ? c-- : u++, Nl(_s(Zi(r, c, u), f), f < 0);
    }
  if (!n.state.doc.resolve(e - (s || 0)).parent.inlineContent) {
    if (s == null && i && (t < 0 || i == Yr(r))) {
      let c = r.childNodes[i - 1];
      if (c.nodeType == 1)
        return gm(c.getBoundingClientRect(), !1);
    }
    if (s == null && i < Yr(r)) {
      let c = r.childNodes[i];
      if (c.nodeType == 1)
        return gm(c.getBoundingClientRect(), !0);
    }
    return gm(r.getBoundingClientRect(), t >= 0);
  }
  if (s == null && i && (t < 0 || i == Yr(r))) {
    let c = r.childNodes[i - 1], u = c.nodeType == 3 ? Zi(c, Yr(c) - (o ? 0 : 1)) : c.nodeType == 1 && (c.nodeName != "BR" || !c.nextSibling) ? c : null;
    if (u)
      return Nl(_s(u, 1), !1);
  }
  if (s == null && i < Yr(r)) {
    let c = r.childNodes[i];
    for (; c.pmViewDesc && c.pmViewDesc.ignoreForCoords; )
      c = c.nextSibling;
    let u = c ? c.nodeType == 3 ? Zi(c, 0, o ? 0 : 1) : c.nodeType == 1 ? c : null : null;
    if (u)
      return Nl(_s(u, -1), !0);
  }
  return Nl(_s(r.nodeType == 3 ? Zi(r) : r, -t), t >= 0);
}
function Nl(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function gm(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function ok(n, e, t) {
  let r = n.state, i = n.root.activeElement;
  r != e && n.updateState(e), i != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), i != n.dom && i && i.focus();
  }
}
function OG(n, e, t) {
  let r = e.selection, i = t == "up" ? r.$from : r.$to;
  return ok(n, e, () => {
    let { node: s } = n.docView.domFromPos(i.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(s, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        s = a.contentDOM || a.dom;
        break;
      }
      s = a.dom.parentNode;
    }
    let o = sk(n, i.pos, 1);
    for (let a = s.firstChild; a; a = a.nextSibling) {
      let c;
      if (a.nodeType == 1)
        c = a.getClientRects();
      else if (a.nodeType == 3)
        c = Zi(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let u = 0; u < c.length; u++) {
        let f = c[u];
        if (f.bottom > f.top + 1 && (t == "up" ? o.top - f.top > (f.bottom - o.top) * 2 : f.bottom - o.bottom > (o.bottom - f.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const IG = /[\u0590-\u08ac]/;
function NG(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, s = !i, o = i == r.parent.content.size, a = n.domSelection();
  return a ? !IG.test(r.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? s : o : ok(n, e, () => {
    let { focusNode: c, focusOffset: u, anchorNode: f, anchorOffset: h } = n.domSelectionRange(), p = a.caretBidiLevel;
    a.modify("move", t, "character");
    let g = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: y, focusOffset: x } = n.domSelectionRange(), S = y && !g.contains(y.nodeType == 1 ? y : y.parentNode) || c == y && u == x;
    try {
      a.collapse(f, h), c && (c != f || u != h) && a.extend && a.extend(c, u);
    } catch {
    }
    return p != null && (a.caretBidiLevel = p), S;
  }) : r.pos == r.start() || r.pos == r.end();
}
let FE = null, zE = null, VE = !1;
function PG(n, e, t) {
  return FE == e && zE == t ? VE : (FE = e, zE = t, VE = t == "up" || t == "down" ? OG(n, e, t) : NG(n, e, t));
}
const Zr = 0, HE = 1, Oo = 2, Ni = 3;
class Kc {
  constructor(e, t, r, i) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = i, this.dirty = Zr, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let i = this.children[t];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.previousSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.nextSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = t > _n(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (i == null && t == e.childNodes.length)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let s = this.getDesc(i), o;
      if (s && (!t || s.node))
        if (r && (o = s.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return s;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let i = e; i; i = i.parentNode) {
      let s = this.getDesc(i);
      if (s)
        return s.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let i = this.children[t], s = r + i.size;
      if (r == e && s != r) {
        for (; !i.border && i.children.length; )
          for (let o = 0; o < i.children.length; o++) {
            let a = i.children[o];
            if (a.size) {
              i = a;
              break;
            }
          }
        return i;
      }
      if (e < s)
        return i.descAt(e - r - i.border);
      r = s;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let s = 0; r < this.children.length; r++) {
      let o = this.children[r], a = s + o.size;
      if (a > e || o instanceof lk) {
        i = e - s;
        break;
      }
      s = a;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, t);
    for (let s; r && !(s = this.children[r - 1]).size && s instanceof ak && s.side >= 0; r--)
      ;
    if (t <= 0) {
      let s, o = !0;
      for (; s = r ? this.children[r - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return s && t && o && !s.border && !s.domAtom ? s.domFromPos(s.size, t) : { node: this.contentDOM, offset: s ? _n(s.dom) + 1 : 0 };
    } else {
      let s, o = !0;
      for (; s = r < this.children.length ? this.children[r] : null, !(!s || s.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return s && o && !s.border && !s.domAtom ? s.domFromPos(0, t) : { node: this.contentDOM, offset: s ? _n(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, s = -1;
    for (let o = r, a = 0; ; a++) {
      let c = this.children[a], u = o + c.size;
      if (i == -1 && e <= u) {
        let f = o + c.border;
        if (e >= f && t <= u - c.border && c.node && c.contentDOM && this.contentDOM.contains(c.contentDOM))
          return c.parseRange(e, t, f);
        e = o;
        for (let h = a; h > 0; h--) {
          let p = this.children[h - 1];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(1)) {
            i = _n(p.dom) + 1;
            break;
          }
          e -= p.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (u > t || a == this.children.length - 1)) {
        t = u;
        for (let f = a + 1; f < this.children.length; f++) {
          let h = this.children[f];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(-1)) {
            s = _n(h.dom);
            break;
          }
          t += h.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      o = u;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: i, toOffset: s };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, r, i = !1) {
    let s = Math.min(e, t), o = Math.max(e, t);
    for (let g = 0, y = 0; g < this.children.length; g++) {
      let x = this.children[g], S = y + x.size;
      if (s > y && o < S)
        return x.setSelection(e - y - x.border, t - y - x.border, r, i);
      y = S;
    }
    let a = this.domFromPos(e, e ? -1 : 1), c = t == e ? a : this.domFromPos(t, t ? -1 : 1), u = r.root.getSelection(), f = r.domSelectionRange(), h = !1;
    if ((Qr || Nn) && e == t) {
      let { node: g, offset: y } = a;
      if (g.nodeType == 3) {
        if (h = !!(y && g.nodeValue[y - 1] == `
`), h && y == g.nodeValue.length)
          for (let x = g, S; x; x = x.parentNode) {
            if (S = x.nextSibling) {
              S.nodeName == "BR" && (a = c = { node: S.parentNode, offset: _n(S) + 1 });
              break;
            }
            let w = x.pmViewDesc;
            if (w && w.node && w.node.isBlock)
              break;
          }
      } else {
        let x = g.childNodes[y - 1];
        h = x && (x.nodeName == "BR" || x.contentEditable == "false");
      }
    }
    if (Qr && f.focusNode && f.focusNode != c.node && f.focusNode.nodeType == 1) {
      let g = f.focusNode.childNodes[f.focusOffset];
      g && g.contentEditable == "false" && (i = !0);
    }
    if (!(i || h && Nn) && qo(a.node, a.offset, f.anchorNode, f.anchorOffset) && qo(c.node, c.offset, f.focusNode, f.focusOffset))
      return;
    let p = !1;
    if ((u.extend || e == t) && !(h && Qr)) {
      u.collapse(a.node, a.offset);
      try {
        e != t && u.extend(c.node, c.offset), p = !0;
      } catch {
      }
    }
    if (!p) {
      if (e > t) {
        let y = a;
        a = c, c = y;
      }
      let g = document.createRange();
      g.setEnd(c.node, c.offset), g.setStart(a.node, a.offset), u.removeAllRanges(), u.addRange(g);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let s = this.children[i], o = r + s.size;
      if (r == o ? e <= o && t >= r : e < o && t > r) {
        let a = r + s.border, c = o - s.border;
        if (e >= a && t <= c) {
          this.dirty = e == r || t == o ? Oo : HE, e == a && t == c && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = Ni : s.markDirty(e - a, t - a);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? Oo : Ni;
      }
      r = o;
    }
    this.dirty = Oo;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? Oo : HE;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class ak extends Kc {
  constructor(e, t, r, i) {
    let s, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!s)
        return i;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(o), o = a;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = t, this.widget = t, s = this;
  }
  matchesWidget(e) {
    return this.dirty == Zr && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class LG extends Kc {
  constructor(e, t, r, i) {
    super(e, [], t, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Ko extends Kc {
  constructor(e, t, r, i, s) {
    super(e, [], r, i), this.mark = t, this.spec = s;
  }
  static create(e, t, r, i) {
    let s = i.nodeViews[t.type.name], o = s && s(t, i, r);
    return (!o || !o.dom) && (o = ea.renderSpec(document, t.type.spec.toDOM(t, r), null, t.attrs)), new Ko(e, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & Ni || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Ni && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != Zr) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Zr;
    }
  }
  slice(e, t, r) {
    let i = Ko.create(this.parent, this.mark, !0, r), s = this.children, o = this.size;
    t < o && (s = Hg(s, t, o, r)), e > 0 && (s = Hg(s, 0, e, r));
    for (let a = 0; a < s.length; a++)
      s[a].parent = i;
    return i.children = s, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Ks extends Kc {
  constructor(e, t, r, i, s, o, a, c, u) {
    super(e, [], s, o), this.node = t, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, r, i, s, o) {
    let a = s.nodeViews[t.type.name], c, u = a && a(t, s, () => {
      if (!c)
        return o;
      if (c.parent)
        return c.parent.posBeforeChild(c);
    }, r, i), f = u && u.dom, h = u && u.contentDOM;
    if (t.isText) {
      if (!f)
        f = document.createTextNode(t.text);
      else if (f.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else f || ({ dom: f, contentDOM: h } = ea.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !h && !t.isText && f.nodeName != "BR" && (f.hasAttribute("contenteditable") || (f.contentEditable = "false"), t.type.spec.draggable && (f.draggable = !0));
    let p = f;
    return f = dk(f, r, t), u ? c = new BG(e, t, r, i, f, h || null, p, u, s, o + 1) : t.isText ? new rh(e, t, r, i, f, p, s) : new Ks(e, t, r, i, f, h || null, p, s, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => le.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == Zr && e.eq(this.node) && nf(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let r = this.node.inlineContent, i = t, s = e.composing ? this.localCompositionInfo(e, t) : null, o = s && s.pos > -1 ? s : null, a = s && s.pos < 0, c = new FG(this, o && o.node, e);
    HG(this.node, this.innerDeco, (u, f, h) => {
      u.spec.marks ? c.syncToMarks(u.spec.marks, r, e, f) : u.type.side >= 0 && !h && c.syncToMarks(f == this.node.childCount ? xt.none : this.node.child(f).marks, r, e, f), c.placeWidget(u, e, i);
    }, (u, f, h, p) => {
      c.syncToMarks(u.marks, r, e, p);
      let g;
      c.findNodeMatch(u, f, h, p) || a && e.state.selection.from > i && e.state.selection.to < i + u.nodeSize && (g = c.findIndexWithChild(s.node)) > -1 && c.updateNodeAt(u, f, h, g, e) || c.updateNextNode(u, f, h, e, p, i) || c.addNode(u, f, h, e, i), i += u.nodeSize;
    }), c.syncToMarks([], r, e, 0), this.node.isTextblock && c.addTextblockHacks(), c.destroyRest(), (c.changed || this.dirty == Oo) && (o && this.protectLocalComposition(e, o), ck(this.contentDOM, this.children, e), el && WG(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof ze) || r < t || i > t + this.node.content.size)
      return null;
    let s = e.input.compositionNode;
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = s.nodeValue, a = UG(this.node.content, o, r - t, i - t);
      return a < 0 ? null : { node: s, pos: a, text: o };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: i }) {
    if (this.getDesc(t))
      return;
    let s = t;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let o = new LG(this, s, t, i);
    e.input.compositionNodes.push(o), this.children = Hg(this.children, r, r + i.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, r, i) {
    return this.dirty == Ni || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, i), !0);
  }
  updateInner(e, t, r, i) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Zr;
  }
  updateOuterDeco(e) {
    if (nf(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = uk(this.dom, this.nodeDOM, Vg(this.outerDeco, this.node, t), Vg(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function WE(n, e, t, r, i) {
  dk(r, e, n);
  let s = new Ks(void 0, n, e, t, r, r, r, i, 0);
  return s.contentDOM && s.updateChildren(i, 0), s;
}
class rh extends Ks {
  constructor(e, t, r, i, s, o, a) {
    super(e, t, r, i, s, null, o, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, i) {
    return this.dirty == Ni || this.dirty != Zr && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Zr || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Zr, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let i = this.node.cut(e, t), s = document.createTextNode(i.text);
    return new rh(this.parent, i, this.outerDeco, this.innerDeco, s, s, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Ni);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class lk extends Kc {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Zr && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class BG extends Ks {
  constructor(e, t, r, i, s, o, a, c, u, f) {
    super(e, t, r, i, s, o, a, u, f), this.spec = c;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, r, i) {
    if (this.dirty == Ni)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let s = this.spec.update(e, t, r);
      return s && this.updateInner(e, t, r, i), s;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r.root) : super.setSelection(e, t, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function ck(n, e, t) {
  let r = n.firstChild, i = !1;
  for (let s = 0; s < e.length; s++) {
    let o = e[s], a = o.dom;
    if (a.parentNode == n) {
      for (; a != r; )
        r = UE(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, n.insertBefore(a, r);
    if (o instanceof Ko) {
      let c = r ? r.previousSibling : n.lastChild;
      ck(o.contentDOM, o.children, t), r = c ? c.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = UE(r), i = !0;
  i && t.trackWrites == n && (t.trackWrites = null);
}
const ic = function(n) {
  n && (this.nodeName = n);
};
ic.prototype = /* @__PURE__ */ Object.create(null);
const Io = [new ic()];
function Vg(n, e, t) {
  if (n.length == 0)
    return Io;
  let r = t ? Io[0] : new ic(), i = [r];
  for (let s = 0; s < n.length; s++) {
    let o = n[s].type.attrs;
    if (o) {
      o.nodeName && i.push(r = new ic(o.nodeName));
      for (let a in o) {
        let c = o[a];
        c != null && (t && i.length == 1 && i.push(r = new ic(e.isInline ? "span" : "div")), a == "class" ? r.class = (r.class ? r.class + " " : "") + c : a == "style" ? r.style = (r.style ? r.style + ";" : "") + c : a != "nodeName" && (r[a] = c));
      }
    }
  }
  return i;
}
function uk(n, e, t, r) {
  if (t == Io && r == Io)
    return e;
  let i = e;
  for (let s = 0; s < r.length; s++) {
    let o = r[s], a = t[s];
    if (s) {
      let c;
      a && a.nodeName == o.nodeName && i != n && (c = i.parentNode) && c.nodeName.toLowerCase() == o.nodeName || (c = document.createElement(o.nodeName), c.pmIsDeco = !0, c.appendChild(i), a = Io[0]), i = c;
    }
    jG(i, a || Io[0], o);
  }
  return i;
}
function jG(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < r.length; s++)
      i.indexOf(r[s]) == -1 && n.classList.remove(r[s]);
    for (let s = 0; s < i.length; s++)
      r.indexOf(i[s]) == -1 && n.classList.add(i[s]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        n.style.removeProperty(i[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function dk(n, e, t) {
  return uk(n, n, Io, Vg(e, t, n.nodeType != 1));
}
function nf(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function UE(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class FG {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = zG(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, r, i) {
    let s = 0, o = this.stack.length >> 1, a = Math.min(o, e.length);
    for (; s < a && (s == o - 1 ? this.top : this.stack[s + 1 << 1]).matchesMark(e[s]) && e[s].type.spec.spanning !== !1; )
      s++;
    for (; s < o; )
      this.destroyRest(), this.top.dirty = Zr, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let c = -1, u = this.top.children.length;
      i < this.preMatch.index && (u = Math.min(this.index + 3, u));
      for (let f = this.index; f < u; f++) {
        let h = this.top.children[f];
        if (h.matchesMark(e[o]) && !this.isLocked(h.dom)) {
          c = f;
          break;
        }
      }
      if (c > -1)
        c > this.index && (this.changed = !0, this.destroyBetween(this.index, c)), this.top = this.top.children[this.index];
      else {
        let f = Ko.create(this.top, e[o], t, r);
        this.top.children.splice(this.index, 0, f), this.top = f, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, r, i) {
    let s = -1, o;
    if (i >= this.preMatch.index && (o = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, r))
      s = this.top.children.indexOf(o, this.index);
    else
      for (let a = this.index, c = Math.min(this.top.children.length, a + 5); a < c; a++) {
        let u = this.top.children[a];
        if (u.matchesNode(e, t, r) && !this.preMatch.matched.has(u)) {
          s = a;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(e, t, r, i, s) {
    let o = this.top.children[i];
    return o.dirty == Ni && o.dom == o.contentDOM && (o.dirty = Oo), o.update(e, t, r, s) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, r, i, s, o) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let c = this.top.children[a];
      if (c instanceof Ks) {
        let u = this.preMatch.matched.get(c);
        if (u != null && u != s)
          return !1;
        let f = c.dom, h, p = this.isLocked(f) && !(e.isText && c.node && c.node.isText && c.nodeDOM.nodeValue == e.text && c.dirty != Ni && nf(t, c.outerDeco));
        if (!p && c.update(e, t, r, i))
          return this.destroyBetween(this.index, a), c.dom != f && (this.changed = !0), this.index++, !0;
        if (!p && (h = this.recreateWrapper(c, e, t, r, i, o)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = h, h.contentDOM && (h.dirty = Oo, h.updateChildren(i, o + 1), h.dirty = Zr), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, r, i, s, o) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !nf(r, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let a = Ks.create(this.top, t, r, i, s, o);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let c of a.children)
        c.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, r, i, s) {
    let o = Ks.create(this.top, e, t, r, i, s);
    o.contentDOM && o.updateChildren(i, s + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new ak(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof Ko; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof rh) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Nn || yn) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new lk(this.top, [], r, null);
      t != this.top ? t.children.push(i) : t.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function zG(n, e) {
  let t = e, r = t.children.length, i = n.childCount, s = /* @__PURE__ */ new Map(), o = [];
  e: for (; i > 0; ) {
    let a;
    for (; ; )
      if (r) {
        let u = t.children[r - 1];
        if (u instanceof Ko)
          t = u, r = u.children.length;
        else {
          a = u, r--;
          break;
        }
      } else {
        if (t == e)
          break e;
        r = t.parent.children.indexOf(t), t = t.parent;
      }
    let c = a.node;
    if (c) {
      if (c != n.child(i - 1))
        break;
      --i, s.set(a, i), o.push(a);
    }
  }
  return { index: i, matched: s, matches: o.reverse() };
}
function VG(n, e) {
  return n.type.side - e.type.side;
}
function HG(n, e, t, r) {
  let i = e.locals(n), s = 0;
  if (i.length == 0) {
    for (let u = 0; u < n.childCount; u++) {
      let f = n.child(u);
      r(f, i, e.forChild(s, f), u), s += f.nodeSize;
    }
    return;
  }
  let o = 0, a = [], c = null;
  for (let u = 0; ; ) {
    let f, h;
    for (; o < i.length && i[o].to == s; ) {
      let S = i[o++];
      S.widget && (f ? (h || (h = [f])).push(S) : f = S);
    }
    if (f)
      if (h) {
        h.sort(VG);
        for (let S = 0; S < h.length; S++)
          t(h[S], u, !!c);
      } else
        t(f, u, !!c);
    let p, g;
    if (c)
      g = -1, p = c, c = null;
    else if (u < n.childCount)
      g = u, p = n.child(u++);
    else
      break;
    for (let S = 0; S < a.length; S++)
      a[S].to <= s && a.splice(S--, 1);
    for (; o < i.length && i[o].from <= s && i[o].to > s; )
      a.push(i[o++]);
    let y = s + p.nodeSize;
    if (p.isText) {
      let S = y;
      o < i.length && i[o].from < S && (S = i[o].from);
      for (let w = 0; w < a.length; w++)
        a[w].to < S && (S = a[w].to);
      S < y && (c = p.cut(S - s), p = p.cut(0, S - s), y = S, g = -1);
    } else
      for (; o < i.length && i[o].to < y; )
        o++;
    let x = p.isInline && !p.isLeaf ? a.filter((S) => !S.inline) : a.slice();
    r(p, x, e.forChild(s, p), g), s = y;
  }
}
function WG(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function UG(n, e, t, r) {
  for (let i = 0, s = 0; i < n.childCount && s <= r; ) {
    let o = n.child(i++), a = s;
    if (s += o.nodeSize, !o.isText)
      continue;
    let c = o.text;
    for (; i < n.childCount; ) {
      let u = n.child(i++);
      if (s += u.nodeSize, !u.isText)
        break;
      c += u.text;
    }
    if (s >= t) {
      if (s >= r && c.slice(r - e.length - a, r - a) == e)
        return r - e.length;
      let u = a < r ? c.lastIndexOf(e, r - a - 1) : -1;
      if (u >= 0 && u + e.length + a >= t)
        return a + u;
      if (t == r && c.length >= r + e.length - a && c.slice(r - a, r - a + e.length) == e)
        return r;
    }
  }
  return -1;
}
function Hg(n, e, t, r, i) {
  let s = [];
  for (let o = 0, a = 0; o < n.length; o++) {
    let c = n[o], u = a, f = a += c.size;
    u >= t || f <= e ? s.push(c) : (u < e && s.push(c.slice(0, e - u, r)), i && (s.push(i), i = void 0), f > t && s.push(c.slice(t - u, c.size, r)));
  }
  return s;
}
function _v(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let i = n.docView.nearestDesc(t.focusNode), s = i && i.size == 0, o = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let a = r.resolve(o), c, u;
  if (nh(t)) {
    for (c = o; i && !i.node; )
      i = i.parent;
    let h = i.node;
    if (i && h.isAtom && Me.isSelectable(h) && i.parent && !(h.isInline && yG(t.focusNode, t.focusOffset, i.dom))) {
      let p = i.posBefore;
      u = new Me(o == p ? a : r.resolve(p));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let h = o, p = o;
      for (let g = 0; g < t.rangeCount; g++) {
        let y = t.getRangeAt(g);
        h = Math.min(h, n.docView.posFromDOM(y.startContainer, y.startOffset, 1)), p = Math.max(p, n.docView.posFromDOM(y.endContainer, y.endOffset, -1));
      }
      if (h < 0)
        return null;
      [c, o] = p == n.state.selection.anchor ? [p, h] : [h, p], a = r.resolve(o);
    } else
      c = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (c < 0)
      return null;
  }
  let f = r.resolve(c);
  if (!u) {
    let h = e == "pointer" || n.state.selection.head < a.pos && !s ? 1 : -1;
    u = Ov(n, f, a, h);
  }
  return u;
}
function fk(n) {
  return n.editable ? n.hasFocus() : pk(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function is(n, e = !1) {
  let t = n.state.selection;
  if (hk(n, t), !!fk(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && yn) {
      let r = n.domSelectionRange(), i = n.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && qo(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      GG(n);
    else {
      let { anchor: r, head: i } = t, s, o;
      $E && !(t instanceof ze) && (t.$from.parent.inlineContent || (s = GE(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = GE(n, t.to))), n.docView.setSelection(r, i, n, e), $E && (s && YE(s), o && YE(o)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && $G(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const $E = Nn || yn && XR < 63;
function GE(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), i = r < t.childNodes.length ? t.childNodes[r] : null, s = r ? t.childNodes[r - 1] : null;
  if (Nn && i && i.contentEditable == "false")
    return ym(i);
  if ((!i || i.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (i)
      return ym(i);
    if (s)
      return ym(s);
  }
}
function ym(n) {
  return n.contentEditable = "true", Nn && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function YE(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function $G(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, i = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != i) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!fk(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function GG(n) {
  let e = n.domSelection();
  if (!e)
    return;
  let t = n.cursorWrapper.dom, r = t.nodeName == "IMG";
  r ? e.collapse(t.parentNode, _n(t) + 1) : e.collapse(t, 0), !r && !n.state.selection.visible && mr && qs <= 11 && (t.disabled = !0, t.disabled = !1);
}
function hk(n, e) {
  if (e instanceof Me) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (qE(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    qE(n);
}
function qE(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function Ov(n, e, t, r) {
  return n.someProp("createSelectionBetween", (i) => i(n, e, t)) || ze.between(e, t, r);
}
function KE(n) {
  return n.editable && !n.hasFocus() ? !1 : pk(n);
}
function pk(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function YG(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return qo(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function Wg(n, e) {
  let { $anchor: t, $head: r } = n.selection, i = e > 0 ? t.max(r) : t.min(r), s = i.parent.inlineContent ? i.depth ? n.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return s && Qe.findFrom(s, e);
}
function Os(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function JE(n, e, t) {
  let r = n.state.selection;
  if (r instanceof ze)
    if (t.indexOf("s") > -1) {
      let { $head: i } = r, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let o = n.state.doc.resolve(i.pos + s.nodeSize * (e < 0 ? -1 : 1));
      return Os(n, new ze(r.$anchor, o));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = Wg(n.state, e);
        return i && i instanceof Me ? Os(n, i) : !1;
      } else if (!(Gr && t.indexOf("m") > -1)) {
        let i = r.$head, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, o;
        if (!s || s.isText)
          return !1;
        let a = e < 0 ? i.pos - s.nodeSize : i.pos;
        return s.isAtom || (o = n.docView.descAt(a)) && !o.contentDOM ? Me.isSelectable(s) ? Os(n, new Me(e < 0 ? n.state.doc.resolve(i.pos - s.nodeSize) : i)) : qc ? Os(n, new ze(n.state.doc.resolve(e < 0 ? a : a + s.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof Me && r.node.isInline)
      return Os(n, new ze(e > 0 ? r.$to : r.$from));
    {
      let i = Wg(n.state, e);
      return i ? Os(n, i) : !1;
    }
  }
}
function rf(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function sc(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function wa(n, e) {
  return e < 0 ? qG(n) : KG(n);
}
function qG(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i, s, o = !1;
  for (Qr && t.nodeType == 1 && r < rf(t) && sc(t.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[r - 1];
        if (sc(a, -1))
          i = t, s = --r;
        else if (a.nodeType == 3)
          t = a, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (mk(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && sc(a, -1); )
          i = t.parentNode, s = _n(a), a = a.previousSibling;
        if (a)
          t = a, r = rf(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  o ? Ug(n, t, r) : i && Ug(n, i, s);
}
function KG(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i = rf(t), s, o;
  for (; ; )
    if (r < i) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[r];
      if (sc(a, 1))
        s = t, o = ++r;
      else
        break;
    } else {
      if (mk(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && sc(a, 1); )
          s = a.parentNode, o = _n(a) + 1, a = a.nextSibling;
        if (a)
          t = a, r = 0, i = rf(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = i = 0;
        }
      }
    }
  s && Ug(n, s, o);
}
function mk(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function JG(n, e) {
  for (; n && e == n.childNodes.length && !Yc(n); )
    e = _n(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function QG(n, e) {
  for (; n && !e && !Yc(n); )
    e = _n(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function Ug(n, e, t) {
  if (e.nodeType != 3) {
    let s, o;
    (o = JG(e, t)) ? (e = o, t = 0) : (s = QG(e, t)) && (e = s, t = s.nodeValue.length);
  }
  let r = n.domSelection();
  if (!r)
    return;
  if (nh(r)) {
    let s = document.createRange();
    s.setEnd(e, t), s.setStart(e, t), r.removeAllRanges(), r.addRange(s);
  } else r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: i } = n;
  setTimeout(() => {
    n.state == i && is(n);
  }, 50);
}
function QE(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(yn || ek) && t.parent.inlineContent) {
    let i = n.coordsAtPos(e);
    if (e > t.start()) {
      let s = n.coordsAtPos(e - 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left < i.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let s = n.coordsAtPos(e + 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function ZE(n, e, t) {
  let r = n.state.selection;
  if (r instanceof ze && !r.empty || t.indexOf("s") > -1 || Gr && t.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: s } = r;
  if (!i.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = Wg(n.state, e);
    if (o && o instanceof Me)
      return Os(n, o);
  }
  if (!i.parent.inlineContent) {
    let o = e < 0 ? i : s, a = r instanceof kr ? Qe.near(o, e) : Qe.findFrom(o, e);
    return a ? Os(n, a) : !1;
  }
  return !1;
}
function XE(n, e) {
  if (!(n.state.selection instanceof ze))
    return !0;
  let { $head: t, $anchor: r, empty: i } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let s = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (s && !s.isText) {
    let o = n.state.tr;
    return e < 0 ? o.delete(t.pos - s.nodeSize, t.pos) : o.delete(t.pos, t.pos + s.nodeSize), n.dispatch(o), !0;
  }
  return !1;
}
function eA(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function ZG(n) {
  if (!Nn || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    eA(n, r, "true"), setTimeout(() => eA(n, r, "false"), 20);
  }
  return !1;
}
function XG(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function eY(n, e) {
  let t = e.keyCode, r = XG(e);
  if (t == 8 || Gr && t == 72 && r == "c")
    return XE(n, -1) || wa(n, -1);
  if (t == 46 && !e.shiftKey || Gr && t == 68 && r == "c")
    return XE(n, 1) || wa(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || Gr && t == 66 && r == "c") {
    let i = t == 37 ? QE(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return JE(n, i, r) || wa(n, i);
  } else if (t == 39 || Gr && t == 70 && r == "c") {
    let i = t == 39 ? QE(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return JE(n, i, r) || wa(n, i);
  } else {
    if (t == 38 || Gr && t == 80 && r == "c")
      return ZE(n, -1, r) || wa(n, -1);
    if (t == 40 || Gr && t == 78 && r == "c")
      return ZG(n) || ZE(n, 1, r) || wa(n, 1);
    if (r == (Gr ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function Iv(n, e) {
  n.someProp("transformCopied", (g) => {
    e = g(e, n);
  });
  let t = [], { content: r, openStart: i, openEnd: s } = e;
  for (; i > 1 && s > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, s--;
    let g = r.firstChild;
    t.push(g.type.name, g.attrs != g.type.defaultAttrs ? g.attrs : null), r = g.content;
  }
  let o = n.someProp("clipboardSerializer") || ea.fromSchema(n.state.schema), a = Sk(), c = a.createElement("div");
  c.appendChild(o.serializeFragment(r, { document: a }));
  let u = c.firstChild, f, h = 0;
  for (; u && u.nodeType == 1 && (f = xk[u.nodeName.toLowerCase()]); ) {
    for (let g = f.length - 1; g >= 0; g--) {
      let y = a.createElement(f[g]);
      for (; c.firstChild; )
        y.appendChild(c.firstChild);
      c.appendChild(y), h++;
    }
    u = c.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", `${i} ${s}${h ? ` -${h}` : ""} ${JSON.stringify(t)}`);
  let p = n.someProp("clipboardTextSerializer", (g) => g(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: c, text: p, slice: e };
}
function gk(n, e, t, r, i) {
  let s = i.parent.type.spec.code, o, a;
  if (!t && !e)
    return null;
  let c = !!e && (r || s || !t);
  if (c) {
    if (n.someProp("transformPastedText", (p) => {
      e = p(e, s || r, n);
    }), s)
      return a = new xe(le.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), n.someProp("transformPasted", (p) => {
        a = p(a, n, !0);
      }), a;
    let h = n.someProp("clipboardTextParser", (p) => p(e, i, r, n));
    if (h)
      a = h;
    else {
      let p = i.marks(), { schema: g } = n.state, y = ea.fromSchema(g);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((x) => {
        let S = o.appendChild(document.createElement("p"));
        x && S.appendChild(y.serializeNode(g.text(x, p)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (h) => {
      t = h(t, n);
    }), o = iY(t), qc && sY(o);
  let u = o && o.querySelector("[data-pm-slice]"), f = u && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(u.getAttribute("data-pm-slice") || "");
  if (f && f[3])
    for (let h = +f[3]; h > 0; h--) {
      let p = o.firstChild;
      for (; p && p.nodeType != 1; )
        p = p.nextSibling;
      if (!p)
        break;
      o = p;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || Ys.fromSchema(n.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(c || f),
    context: i,
    ruleFromNode(p) {
      return p.nodeName == "BR" && !p.nextSibling && p.parentNode && !tY.test(p.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), f)
    a = oY(tA(a, +f[1], +f[2]), f[4]);
  else if (a = xe.maxOpen(nY(a.content, i), !0), a.openStart || a.openEnd) {
    let h = 0, p = 0;
    for (let g = a.content.firstChild; h < a.openStart && !g.type.spec.isolating; h++, g = g.firstChild)
      ;
    for (let g = a.content.lastChild; p < a.openEnd && !g.type.spec.isolating; p++, g = g.lastChild)
      ;
    a = tA(a, h, p);
  }
  return n.someProp("transformPasted", (h) => {
    a = h(a, n, c);
  }), a;
}
const tY = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function nY(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let i = e.node(t).contentMatchAt(e.index(t)), s, o = [];
    if (n.forEach((a) => {
      if (!o)
        return;
      let c = i.findWrapping(a.type), u;
      if (!c)
        return o = null;
      if (u = o.length && s.length && vk(c, s, a, o[o.length - 1], 0))
        o[o.length - 1] = u;
      else {
        o.length && (o[o.length - 1] = bk(o[o.length - 1], s.length));
        let f = yk(a, c);
        o.push(f), i = i.matchType(f.type), s = c;
      }
    }), o)
      return le.from(o);
  }
  return n;
}
function yk(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, le.from(n));
  return n;
}
function vk(n, e, t, r, i) {
  if (i < n.length && i < e.length && n[i] == e[i]) {
    let s = vk(n, e, t, r.lastChild, i + 1);
    if (s)
      return r.copy(r.content.replaceChild(r.childCount - 1, s));
    if (r.contentMatchAt(r.childCount).matchType(i == n.length - 1 ? t.type : n[i + 1]))
      return r.copy(r.content.append(le.from(yk(t, n, i + 1))));
  }
}
function bk(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, bk(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(le.empty, !0);
  return n.copy(t.append(r));
}
function $g(n, e, t, r, i, s) {
  let o = e < 0 ? n.firstChild : n.lastChild, a = o.content;
  return n.childCount > 1 && (s = 0), i < r - 1 && (a = $g(a, e, t, r, i + 1, s)), i >= t && (a = e < 0 ? o.contentMatchAt(0).fillBefore(a, s <= i).append(a) : a.append(o.contentMatchAt(o.childCount).fillBefore(le.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, o.copy(a));
}
function tA(n, e, t) {
  return e < n.openStart && (n = new xe($g(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new xe($g(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const xk = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let nA = null;
function Sk() {
  return nA || (nA = document.implementation.createHTMLDocument("title"));
}
let vm = null;
function rY(n) {
  let e = window.trustedTypes;
  return e ? (vm || (vm = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), vm.createHTML(n)) : n;
}
function iY(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = Sk().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), i;
  if ((i = r && xk[r[1].toLowerCase()]) && (n = i.map((s) => "<" + s + ">").join("") + n + i.map((s) => "</" + s + ">").reverse().join("")), t.innerHTML = rY(n), i)
    for (let s = 0; s < i.length; s++)
      t = t.querySelector(i[s]) || t;
  return t;
}
function sY(n) {
  let e = n.querySelectorAll(yn ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function oY(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: i, openStart: s, openEnd: o } = n;
  for (let a = r.length - 2; a >= 0; a -= 2) {
    let c = t.nodes[r[a]];
    if (!c || c.hasRequiredAttrs())
      break;
    i = le.from(c.create(r[a + 1], i)), s++, o++;
  }
  return new xe(i, s, o);
}
const tr = {}, nr = {}, aY = { touchstart: !0, touchmove: !0 };
class lY {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function cY(n) {
  for (let e in tr) {
    let t = tr[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      dY(n, r) && !Nv(n, r) && (n.editable || !(r.type in nr)) && t(n, r);
    }, aY[e] ? { passive: !0 } : void 0);
  }
  Nn && n.dom.addEventListener("input", () => null), Gg(n);
}
function Ws(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function uY(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function Gg(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => Nv(n, r));
  });
}
function Nv(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function dY(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function fY(n, e) {
  !Nv(n, e) && tr[e.type] && (n.editable || !(e.type in nr)) && tr[e.type](n, e);
}
nr.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Ek(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(ts && yn && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), el && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (i) => i(n, Ro(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (r) => r(n, t)) || eY(n, t) ? t.preventDefault() : Ws(n, "key");
};
nr.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
nr.keypress = (n, e) => {
  let t = e;
  if (Ek(n, t) || !t.charCode || t.ctrlKey && !t.altKey || Gr && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (i) => i(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof ze) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(t.charCode), s = () => n.state.tr.insertText(i).scrollIntoView();
    !/[\r\n]/.test(i) && !n.someProp("handleTextInput", (o) => o(n, r.$from.pos, r.$to.pos, i, s)) && n.dispatch(s()), t.preventDefault();
  }
};
function ih(n) {
  return { left: n.clientX, top: n.clientY };
}
function hY(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function Pv(n, e, t, r, i) {
  if (r == -1)
    return !1;
  let s = n.state.doc.resolve(r);
  for (let o = s.depth + 1; o > 0; o--)
    if (n.someProp(e, (a) => o > s.depth ? a(n, t, s.nodeAfter, s.before(o), i, !0) : a(n, t, s.node(o), s.before(o), i, !1)))
      return !0;
  return !1;
}
function Ga(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let r = n.state.tr.setSelection(e);
  r.setMeta("pointer", !0), n.dispatch(r);
}
function pY(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && Me.isSelectable(r) ? (Ga(n, new Me(t)), !0) : !1;
}
function mY(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, i;
  t instanceof Me && (r = t.node);
  let s = n.state.doc.resolve(e);
  for (let o = s.depth + 1; o > 0; o--) {
    let a = o > s.depth ? s.nodeAfter : s.node(o);
    if (Me.isSelectable(a)) {
      r && t.$from.depth > 0 && o >= t.$from.depth && s.before(t.$from.depth + 1) == t.$from.pos ? i = s.before(t.$from.depth) : i = s.before(o);
      break;
    }
  }
  return i != null ? (Ga(n, Me.create(n.state.doc, i)), !0) : !1;
}
function gY(n, e, t, r, i) {
  return Pv(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (s) => s(n, e, r)) || (i ? mY(n, t) : pY(n, t));
}
function yY(n, e, t, r) {
  return Pv(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (i) => i(n, e, r));
}
function vY(n, e, t, r) {
  return Pv(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (i) => i(n, e, r)) || bY(n, t, r);
}
function bY(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (Ga(n, ze.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let o = s > i.depth ? i.nodeAfter : i.node(s), a = i.before(s);
    if (o.inlineContent)
      Ga(n, ze.create(r, a + 1, a + 1 + o.content.size));
    else if (Me.isSelectable(o))
      Ga(n, Me.create(r, a));
    else
      continue;
    return !0;
  }
}
function Lv(n) {
  return sf(n);
}
const wk = Gr ? "metaKey" : "ctrlKey";
tr.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = Lv(n), i = Date.now(), s = "singleClick";
  i - n.input.lastClick.time < 500 && hY(t, n.input.lastClick) && !t[wk] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? s = "doubleClick" : n.input.lastClick.type == "doubleClick" && (s = "tripleClick")), n.input.lastClick = { time: i, x: t.clientX, y: t.clientY, type: s, button: t.button };
  let o = n.posAtCoords(ih(t));
  o && (s == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new xY(n, o, t, !!r)) : (s == "doubleClick" ? yY : vY)(n, o.pos, o.inside, t) ? t.preventDefault() : Ws(n, "pointer"));
};
class xY {
  constructor(e, t, r, i) {
    this.view = e, this.pos = t, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[wk], this.allowDefault = r.shiftKey;
    let s, o;
    if (t.inside > -1)
      s = e.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let f = e.state.doc.resolve(t.pos);
      s = f.parent, o = f.depth ? f.before() : 0;
    }
    const a = i ? null : r.target, c = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = c && c.nodeDOM.nodeType == 1 ? c.nodeDOM : null;
    let { selection: u } = e.state;
    (r.button == 0 && s.type.spec.draggable && s.type.spec.selectable !== !1 || u instanceof Me && u.from <= o && u.to > o) && (this.mightDrag = {
      node: s,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Qr && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Ws(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => is(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(ih(e))), this.updateAllowDefault(e), this.allowDefault || !t ? Ws(this.view, "pointer") : gY(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Nn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    yn && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Ga(this.view, Qe.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : Ws(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Ws(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
tr.touchstart = (n) => {
  n.input.lastTouch = Date.now(), Lv(n), Ws(n, "pointer");
};
tr.touchmove = (n) => {
  n.input.lastTouch = Date.now(), Ws(n, "pointer");
};
tr.contextmenu = (n) => Lv(n);
function Ek(n, e) {
  return n.composing ? !0 : Nn && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const SY = ts ? 5e3 : -1;
nr.compositionstart = nr.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof ze && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1) || yn && ek && wY(n)))
      n.markCursor = n.state.storedMarks || t.marks(), sf(n, !0), n.markCursor = null;
    else if (sf(n, !e.selection.empty), Qr && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let i = r.focusNode, s = r.focusOffset; i && i.nodeType == 1 && s != 0; ) {
        let o = s < 0 ? i.lastChild : i.childNodes[s - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(o, o.nodeValue.length);
          break;
        } else
          i = o, s = -1;
      }
    }
    n.input.composing = !0;
  }
  Ak(n, SY);
};
function wY(n) {
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (!e || e.nodeType != 1 || t >= e.childNodes.length)
    return !1;
  let r = e.childNodes[t];
  return r.nodeType == 1 && r.contentEditable == "false";
}
nr.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.badSafariComposition ? n.domObserver.forceFlush() : n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, Ak(n, 20));
};
function Ak(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => sf(n), e));
}
function Tk(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = AY()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function EY(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = mG(e.focusNode, e.focusOffset), r = gG(e.focusNode, e.focusOffset);
  if (t && r && t != r) {
    let i = r.pmViewDesc, s = n.domObserver.lastChangedTextNode;
    if (t == s || r == s)
      return s;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (n.input.compositionNode == r) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return r;
    }
  }
  return t || r;
}
function AY() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function sf(n, e = !1) {
  if (!(ts && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), Tk(n), e || n.docView && n.docView.dirty) {
      let t = _v(n), r = n.state.selection;
      return t && !t.eq(r) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function TY(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const Rc = mr && qs < 15 || el && xG < 604;
tr.copy = nr.cut = (n, e) => {
  let t = e, r = n.state.selection, i = t.type == "cut";
  if (r.empty)
    return;
  let s = Rc ? null : t.clipboardData, o = r.content(), { dom: a, text: c } = Iv(n, o);
  s ? (t.preventDefault(), s.clearData(), s.setData("text/html", a.innerHTML), s.setData("text/plain", c)) : TY(n, a), i && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function CY(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function DY(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? kc(n, r.value, null, i, e) : kc(n, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function kc(n, e, t, r, i) {
  let s = gk(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (c) => c(n, i, s || xe.empty)))
    return !0;
  if (!s)
    return !1;
  let o = CY(s), a = o ? n.state.tr.replaceSelectionWith(o, r) : n.state.tr.replaceSelection(s);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Ck(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
nr.paste = (n, e) => {
  let t = e;
  if (n.composing && !ts)
    return;
  let r = Rc ? null : t.clipboardData, i = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && kc(n, Ck(r), r.getData("text/html"), i, t) ? t.preventDefault() : DY(n, t);
};
class Dk {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const RY = Gr ? "altKey" : "ctrlKey";
function Rk(n, e) {
  let t = n.someProp("dragCopies", (r) => !r(e));
  return t ?? !e[RY];
}
tr.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let i = n.state.selection, s = i.empty ? null : n.posAtCoords(ih(t)), o;
  if (!(s && s.pos >= i.from && s.pos <= (i instanceof Me ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      o = Me.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let h = n.docView.nearestDesc(t.target, !0);
      h && h.node.type.spec.draggable && h != n.docView && (o = Me.create(n.state.doc, h.posBefore));
    }
  }
  let a = (o || n.state.selection).content(), { dom: c, text: u, slice: f } = Iv(n, a);
  (!t.dataTransfer.files.length || !yn || XR > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(Rc ? "Text" : "text/html", c.innerHTML), t.dataTransfer.effectAllowed = "copyMove", Rc || t.dataTransfer.setData("text/plain", u), n.dragging = new Dk(f, Rk(n, t), o);
};
tr.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
nr.dragover = nr.dragenter = (n, e) => e.preventDefault();
nr.drop = (n, e) => {
  try {
    kY(n, e, n.dragging);
  } finally {
    n.dragging = null;
  }
};
function kY(n, e, t) {
  if (!e.dataTransfer)
    return;
  let r = n.posAtCoords(ih(e));
  if (!r)
    return;
  let i = n.state.doc.resolve(r.pos), s = t && t.slice;
  s ? n.someProp("transformPasted", (g) => {
    s = g(s, n, !1);
  }) : s = gk(n, Ck(e.dataTransfer), Rc ? null : e.dataTransfer.getData("text/html"), !1, i);
  let o = !!(t && Rk(n, e));
  if (n.someProp("handleDrop", (g) => g(n, e, s || xe.empty, o))) {
    e.preventDefault();
    return;
  }
  if (!s)
    return;
  e.preventDefault();
  let a = s ? UR(n.state.doc, i.pos, s) : i.pos;
  a == null && (a = i.pos);
  let c = n.state.tr;
  if (o) {
    let { node: g } = t;
    g ? g.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(a), f = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, h = c.doc;
  if (f ? c.replaceRangeWith(u, u, s.content.firstChild) : c.replaceRange(u, u, s), c.doc.eq(h))
    return;
  let p = c.doc.resolve(u);
  if (f && Me.isSelectable(s.content.firstChild) && p.nodeAfter && p.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new Me(p));
  else {
    let g = c.mapping.map(a);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((y, x, S, w) => g = w), c.setSelection(Ov(n, p, c.doc.resolve(g)));
  }
  n.focus(), n.dispatch(c.setMeta("uiEvent", "drop"));
}
tr.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && is(n);
  }, 20));
};
tr.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
tr.beforeinput = (n, e) => {
  if (yn && ts && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (s) => s(n, Ro(8, "Backspace")))))
        return;
      let { $cursor: i } = n.state.selection;
      i && i.pos > 0 && n.dispatch(n.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in nr)
  tr[n] = nr[n];
function Mc(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class of {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || zo, this.side = this.spec.side || 0;
  }
  map(e, t, r, i) {
    let { pos: s, deleted: o } = e.mapResult(t.from + i, this.side < 0 ? -1 : 1);
    return o ? null : new Dr(s - r, s - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof of && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Mc(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Js {
  constructor(e, t) {
    this.attrs = e, this.spec = t || zo;
  }
  map(e, t, r, i) {
    let s = e.map(t.from + i, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(t.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return s >= o ? null : new Dr(s, o, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof Js && Mc(this.attrs, e.attrs) && Mc(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Js;
  }
  destroy() {
  }
}
class Bv {
  constructor(e, t) {
    this.attrs = e, this.spec = t || zo;
  }
  map(e, t, r, i) {
    let s = e.mapResult(t.from + i, 1);
    if (s.deleted)
      return null;
    let o = e.mapResult(t.to + i, -1);
    return o.deleted || o.pos <= s.pos ? null : new Dr(s.pos - r, o.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: i } = e.content.findIndex(t.from), s;
    return i == t.from && !(s = e.child(r)).isText && i + s.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof Bv && Mc(this.attrs, e.attrs) && Mc(this.spec, e.spec);
  }
  destroy() {
  }
}
class Dr {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new Dr(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, r) {
    return new Dr(e, e, new of(t, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, r, i) {
    return new Dr(e, t, new Js(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, r, i) {
    return new Dr(e, t, new Bv(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Js;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof of;
  }
}
const _a = [], zo = {};
class sn {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : _a, this.children = t.length ? t : _a;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? af(t, e, 0, zo) : Vn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, r) {
    let i = [];
    return this.findInner(e ?? 0, t ?? 1e9, i, 0, r), i;
  }
  findInner(e, t, r, i, s) {
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o];
      a.from <= t && a.to >= e && (!s || s(a.spec)) && r.push(a.copy(a.from + i, a.to + i));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > e) {
        let a = this.children[o] + 1;
        this.children[o + 2].findInner(e - a, t - a, r, i + a, s);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, r) {
    return this == Vn || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || zo);
  }
  /**
  @internal
  */
  mapInner(e, t, r, i, s) {
    let o;
    for (let a = 0; a < this.local.length; a++) {
      let c = this.local[a].map(e, r, i);
      c && c.type.valid(t, c) ? (o || (o = [])).push(c) : s.onRemove && s.onRemove(this.local[a].spec);
    }
    return this.children.length ? MY(this.children, o || [], e, t, r, i, s) : o ? new sn(o.sort(Vo), _a) : Vn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == Vn ? sn.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let i, s = 0;
    e.forEach((a, c) => {
      let u = c + r, f;
      if (f = Mk(t, a, u)) {
        for (i || (i = this.children.slice()); s < i.length && i[s] < c; )
          s += 3;
        i[s] == c ? i[s + 2] = i[s + 2].addInner(a, f, u + 1) : i.splice(s, 0, c, c + a.nodeSize, af(f, a, u + 1, zo)), s += 3;
      }
    });
    let o = kk(s ? _k(t) : t, -r);
    for (let a = 0; a < o.length; a++)
      o[a].type.valid(e, o[a]) || o.splice(a--, 1);
    return new sn(o.length ? this.local.concat(o).sort(Vo) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Vn ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, i = this.local;
    for (let s = 0; s < r.length; s += 3) {
      let o, a = r[s] + t, c = r[s + 1] + t;
      for (let f = 0, h; f < e.length; f++)
        (h = e[f]) && h.from > a && h.to < c && (e[f] = null, (o || (o = [])).push(h));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let u = r[s + 2].removeInner(o, a + 1);
      u != Vn ? r[s + 2] = u : (r.splice(s, 3), s -= 3);
    }
    if (i.length) {
      for (let s = 0, o; s < e.length; s++)
        if (o = e[s])
          for (let a = 0; a < i.length; a++)
            i[a].eq(o, t) && (i == this.local && (i = this.local.slice()), i.splice(a--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new sn(i, r) : Vn;
  }
  forChild(e, t) {
    if (this == Vn)
      return this;
    if (t.isLeaf)
      return sn.empty;
    let r, i;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (r = this.children[a + 2]);
        break;
      }
    let s = e + 1, o = s + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let c = this.local[a];
      if (c.from < o && c.to > s && c.type instanceof Js) {
        let u = Math.max(s, c.from) - s, f = Math.min(o, c.to) - s;
        u < f && (i || (i = [])).push(c.copy(u, f));
      }
    }
    if (i) {
      let a = new sn(i.sort(Vo), _a);
      return r ? new Ps([a, r]) : a;
    }
    return r || Vn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof sn) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return jv(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Vn)
      return _a;
    if (e.inlineContent || !this.local.some(Js.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Js || t.push(this.local[r]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
sn.empty = new sn([], []);
sn.removeOverlap = jv;
const Vn = sn.empty;
class Ps {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((i) => i.map(e, t, zo));
    return Ps.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return sn.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].forChild(e, t);
      s != Vn && (s instanceof Ps ? r = r.concat(s.members) : r.push(s));
    }
    return Ps.from(r);
  }
  eq(e) {
    if (!(e instanceof Ps) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].localsInner(e);
      if (s.length)
        if (!t)
          t = s;
        else {
          r && (t = t.slice(), r = !1);
          for (let o = 0; o < s.length; o++)
            t.push(s[o]);
        }
    }
    return t ? jv(r ? t : t.sort(Vo)) : _a;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Vn;
      case 1:
        return e[0];
      default:
        return new Ps(e.every((t) => t instanceof sn) ? e : e.reduce((t, r) => t.concat(r instanceof sn ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function MY(n, e, t, r, i, s, o) {
  let a = n.slice();
  for (let u = 0, f = s; u < t.maps.length; u++) {
    let h = 0;
    t.maps[u].forEach((p, g, y, x) => {
      let S = x - y - (g - p);
      for (let w = 0; w < a.length; w += 3) {
        let C = a[w + 1];
        if (C < 0 || p > C + f - h)
          continue;
        let T = a[w] + f - h;
        g >= T ? a[w + 1] = p <= T ? -2 : -1 : p >= f && S && (a[w] += S, a[w + 1] += S);
      }
      h += S;
    }), f = t.maps[u].map(f, -1);
  }
  let c = !1;
  for (let u = 0; u < a.length; u += 3)
    if (a[u + 1] < 0) {
      if (a[u + 1] == -2) {
        c = !0, a[u + 1] = -1;
        continue;
      }
      let f = t.map(n[u] + s), h = f - i;
      if (h < 0 || h >= r.content.size) {
        c = !0;
        continue;
      }
      let p = t.map(n[u + 1] + s, -1), g = p - i, { index: y, offset: x } = r.content.findIndex(h), S = r.maybeChild(y);
      if (S && x == h && x + S.nodeSize == g) {
        let w = a[u + 2].mapInner(t, S, f + 1, n[u] + s + 1, o);
        w != Vn ? (a[u] = h, a[u + 1] = g, a[u + 2] = w) : (a[u + 1] = -2, c = !0);
      } else
        c = !0;
    }
  if (c) {
    let u = _Y(a, n, e, t, i, s, o), f = af(u, r, 0, o);
    e = f.local;
    for (let h = 0; h < a.length; h += 3)
      a[h + 1] < 0 && (a.splice(h, 3), h -= 3);
    for (let h = 0, p = 0; h < f.children.length; h += 3) {
      let g = f.children[h];
      for (; p < a.length && a[p] < g; )
        p += 3;
      a.splice(p, 0, f.children[h], f.children[h + 1], f.children[h + 2]);
    }
  }
  return new sn(e.sort(Vo), a);
}
function kk(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let i = n[r];
    t.push(new Dr(i.from + e, i.to + e, i.type));
  }
  return t;
}
function _Y(n, e, t, r, i, s, o) {
  function a(c, u) {
    for (let f = 0; f < c.local.length; f++) {
      let h = c.local[f].map(r, i, u);
      h ? t.push(h) : o.onRemove && o.onRemove(c.local[f].spec);
    }
    for (let f = 0; f < c.children.length; f += 3)
      a(c.children[f + 2], c.children[f] + u + 1);
  }
  for (let c = 0; c < n.length; c += 3)
    n[c + 1] == -1 && a(n[c + 2], e[c] + s + 1);
  return t;
}
function Mk(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, i = null;
  for (let s = 0, o; s < n.length; s++)
    (o = n[s]) && o.from > t && o.to < r && ((i || (i = [])).push(o), n[s] = null);
  return i;
}
function _k(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function af(n, e, t, r) {
  let i = [], s = !1;
  e.forEach((a, c) => {
    let u = Mk(n, a, c + t);
    if (u) {
      s = !0;
      let f = af(u, a, t + c + 1, r);
      f != Vn && i.push(c, c + a.nodeSize, f);
    }
  });
  let o = kk(s ? _k(n) : n, -t).sort(Vo);
  for (let a = 0; a < o.length; a++)
    o[a].type.valid(e, o[a]) || (r.onRemove && r.onRemove(o[a].spec), o.splice(a--, 1));
  return o.length || i.length ? new sn(o, i) : Vn;
}
function Vo(n, e) {
  return n.from - e.from || n.to - e.to;
}
function jv(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let i = t + 1; i < e.length; i++) {
        let s = e[i];
        if (s.from == r.from) {
          s.to != r.to && (e == n && (e = n.slice()), e[i] = s.copy(s.from, r.to), rA(e, i + 1, s.copy(r.to, s.to)));
          continue;
        } else {
          s.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, s.from), rA(e, i, r.copy(s.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function rA(n, e, t) {
  for (; e < n.length && Vo(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function bm(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != Vn && e.push(r);
  }), n.cursorWrapper && e.push(sn.create(n.state.doc, [n.cursorWrapper.deco])), Ps.from(e);
}
const OY = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, IY = mr && qs <= 11;
class NY {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class PY {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new NY(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      mr && qs <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : Nn && e.composing && r.some((i) => i.type == "childList" && i.target.nodeName == "TR") ? (e.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), IY && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, OY)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (KE(this.view)) {
      if (this.suppressingSelectionUpdates)
        return is(this.view);
      if (mr && qs <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && qo(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let s = e.focusNode; s; s = Xa(s))
      t.add(s);
    for (let s = e.anchorNode; s; s = Xa(s))
      if (t.has(s)) {
        r = s;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && KE(e) && !this.ignoreSelectionChange(r), s = -1, o = -1, a = !1, c = [];
    if (e.editable)
      for (let f = 0; f < t.length; f++) {
        let h = this.registerMutation(t[f], c);
        h && (s = s < 0 ? h.from : Math.min(h.from, s), o = o < 0 ? h.to : Math.max(h.to, o), h.typeOver && (a = !0));
      }
    if (Qr && c.length) {
      let f = c.filter((h) => h.nodeName == "BR");
      if (f.length == 2) {
        let [h, p] = f;
        h.parentNode && h.parentNode.parentNode == p.parentNode ? p.remove() : h.remove();
      } else {
        let { focusNode: h } = this.currentSelection;
        for (let p of f) {
          let g = p.parentNode;
          g && g.nodeName == "LI" && (!h || jY(e, h) != g) && p.remove();
        }
      }
    } else if ((yn || Nn) && c.some((f) => f.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46)) {
      for (let f of c)
        if (f.nodeName == "BR" && f.parentNode) {
          let h = f.nextSibling;
          h && h.nodeType == 1 && h.contentEditable == "false" && f.parentNode.removeChild(f);
        }
    }
    let u = null;
    s < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && nh(r) && (u = _v(e)) && u.eq(Qe.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, is(e), this.currentSelection.set(r), e.scrollToSelection()) : (s > -1 || i) && (s > -1 && (e.docView.markDirty(s, o), LY(e)), e.input.badSafariComposition && (e.input.badSafariComposition = !1, FY(e, c)), this.handleDOMChange(s, o, a, c), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || is(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let f = 0; f < e.addedNodes.length; f++) {
        let h = e.addedNodes[f];
        t.push(h), h.nodeType == 3 && (this.lastChangedTextNode = h);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, s = e.nextSibling;
      if (mr && qs <= 11 && e.addedNodes.length)
        for (let f = 0; f < e.addedNodes.length; f++) {
          let { previousSibling: h, nextSibling: p } = e.addedNodes[f];
          (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (i = h), (!p || Array.prototype.indexOf.call(e.addedNodes, p) < 0) && (s = p);
        }
      let o = i && i.parentNode == e.target ? _n(i) + 1 : 0, a = r.localPosFromDOM(e.target, o, -1), c = s && s.parentNode == e.target ? _n(s) : e.target.childNodes.length, u = r.localPosFromDOM(e.target, c, 1);
      return { from: a, to: u };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let iA = /* @__PURE__ */ new WeakMap(), sA = !1;
function LY(n) {
  if (!iA.has(n) && (iA.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = Qr, sA)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), sA = !0;
  }
}
function oA(n, e) {
  let t = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = n.domAtPos(n.state.selection.anchor);
  return qo(o.node, o.offset, i, s) && ([t, r, i, s] = [i, s, t, r]), { anchorNode: t, anchorOffset: r, focusNode: i, focusOffset: s };
}
function BY(n, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(n.root)[0];
    if (i)
      return oA(n, i);
  }
  let t;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), t = i.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", r, !0), t ? oA(n, t) : null;
}
function jY(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let r = n.docView.nearestDesc(t, !0);
    if (r && r.node.isBlock)
      return t;
  }
  return null;
}
function FY(n, e) {
  var t;
  let { focusNode: r, focusOffset: i } = n.domSelectionRange();
  for (let s of e)
    if (((t = s.parentNode) === null || t === void 0 ? void 0 : t.nodeName) == "TR") {
      let o = s.nextSibling;
      for (; o && o.nodeName != "TD" && o.nodeName != "TH"; )
        o = o.nextSibling;
      if (o) {
        let a = o;
        for (; ; ) {
          let c = a.firstChild;
          if (!c || c.nodeType != 1 || c.contentEditable == "false" || /^(BR|IMG)$/.test(c.nodeName))
            break;
          a = c;
        }
        a.insertBefore(s, a.firstChild), r == s && n.domSelection().collapse(s, i);
      } else
        s.parentNode.removeChild(s);
    }
}
function zY(n, e, t) {
  let { node: r, fromOffset: i, toOffset: s, from: o, to: a } = n.docView.parseRange(e, t), c = n.domSelectionRange(), u, f = c.anchorNode;
  if (f && n.dom.contains(f.nodeType == 1 ? f : f.parentNode) && (u = [{ node: f, offset: c.anchorOffset }], nh(c) || u.push({ node: c.focusNode, offset: c.focusOffset })), yn && n.input.lastKeyCode === 8)
    for (let S = s; S > i; S--) {
      let w = r.childNodes[S - 1], C = w.pmViewDesc;
      if (w.nodeName == "BR" && !C) {
        s = S;
        break;
      }
      if (!C || C.size)
        break;
    }
  let h = n.state.doc, p = n.someProp("domParser") || Ys.fromSchema(n.state.schema), g = h.resolve(o), y = null, x = p.parse(r, {
    topNode: g.parent,
    topMatch: g.parent.contentMatchAt(g.index()),
    topOpen: !0,
    from: i,
    to: s,
    preserveWhitespace: g.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: u,
    ruleFromNode: VY,
    context: g
  });
  if (u && u[0].pos != null) {
    let S = u[0].pos, w = u[1] && u[1].pos;
    w == null && (w = S), y = { anchor: S + o, head: w + o };
  }
  return { doc: x, sel: y, from: o, to: a };
}
function VY(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (Nn && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || Nn && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const HY = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function WY(n, e, t, r, i) {
  let s = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let L = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, B = _v(n, L);
    if (B && !n.state.selection.eq(B)) {
      if (yn && ts && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (X) => X(n, Ro(13, "Enter"))))
        return;
      let W = n.state.tr.setSelection(B);
      L == "pointer" ? W.setMeta("pointer", !0) : L == "key" && W.scrollIntoView(), s && W.setMeta("composition", s), n.dispatch(W);
    }
    return;
  }
  let o = n.state.doc.resolve(e), a = o.sharedDepth(t);
  e = o.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let c = n.state.selection, u = zY(n, e, t), f = n.state.doc, h = f.slice(u.from, u.to), p, g;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (p = n.state.selection.to, g = "end") : (p = n.state.selection.from, g = "start"), n.input.lastKeyCode = null;
  let y = GY(h.content, u.doc.content, u.from, p, g);
  if (y && n.input.domChangeCount++, (el && n.input.lastIOSEnter > Date.now() - 225 || ts) && i.some((L) => L.nodeType == 1 && !HY.test(L.nodeName)) && (!y || y.endA >= y.endB) && n.someProp("handleKeyDown", (L) => L(n, Ro(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!y)
    if (r && c instanceof ze && !c.empty && c.$head.sameParent(c.$anchor) && !n.composing && !(u.sel && u.sel.anchor != u.sel.head))
      y = { start: c.from, endA: c.to, endB: c.to };
    else {
      if (u.sel) {
        let L = aA(n, n.state.doc, u.sel);
        if (L && !L.eq(n.state.selection)) {
          let B = n.state.tr.setSelection(L);
          s && B.setMeta("composition", s), n.dispatch(B);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && y.start == y.endB && n.state.selection instanceof ze && (y.start > n.state.selection.from && y.start <= n.state.selection.from + 2 && n.state.selection.from >= u.from ? y.start = n.state.selection.from : y.endA < n.state.selection.to && y.endA >= n.state.selection.to - 2 && n.state.selection.to <= u.to && (y.endB += n.state.selection.to - y.endA, y.endA = n.state.selection.to)), mr && qs <= 11 && y.endB == y.start + 1 && y.endA == y.start && y.start > u.from && u.doc.textBetween(y.start - u.from - 1, y.start - u.from + 1) == "  " && (y.start--, y.endA--, y.endB--);
  let x = u.doc.resolveNoCache(y.start - u.from), S = u.doc.resolveNoCache(y.endB - u.from), w = f.resolve(y.start), C = x.sameParent(S) && x.parent.inlineContent && w.end() >= y.endA;
  if ((el && n.input.lastIOSEnter > Date.now() - 225 && (!C || i.some((L) => L.nodeName == "DIV" || L.nodeName == "P")) || !C && x.pos < u.doc.content.size && (!x.sameParent(S) || !x.parent.inlineContent) && x.pos < S.pos && !/\S/.test(u.doc.textBetween(x.pos, S.pos, "", ""))) && n.someProp("handleKeyDown", (L) => L(n, Ro(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > y.start && $Y(f, y.start, y.endA, x, S) && n.someProp("handleKeyDown", (L) => L(n, Ro(8, "Backspace")))) {
    ts && yn && n.domObserver.suppressSelectionUpdates();
    return;
  }
  yn && y.endB == y.start && (n.input.lastChromeDelete = Date.now()), ts && !C && x.start() != S.start() && S.parentOffset == 0 && x.depth == S.depth && u.sel && u.sel.anchor == u.sel.head && u.sel.head == y.endA && (y.endB -= 2, S = u.doc.resolveNoCache(y.endB - u.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(L) {
      return L(n, Ro(13, "Enter"));
    });
  }, 20));
  let T = y.start, k = y.endA, R = (L) => {
    let B = L || n.state.tr.replace(T, k, u.doc.slice(y.start - u.from, y.endB - u.from));
    if (u.sel) {
      let W = aA(n, B.doc, u.sel);
      W && !(yn && n.composing && W.empty && (y.start != y.endB || n.input.lastChromeDelete < Date.now() - 100) && (W.head == T || W.head == B.mapping.map(k) - 1) || mr && W.empty && W.head == T) && B.setSelection(W);
    }
    return s && B.setMeta("composition", s), B.scrollIntoView();
  }, P;
  if (C)
    if (x.pos == S.pos) {
      mr && qs <= 11 && x.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => is(n), 20));
      let L = R(n.state.tr.delete(T, k)), B = f.resolve(y.start).marksAcross(f.resolve(y.endA));
      B && L.ensureMarks(B), n.dispatch(L);
    } else if (
      // Adding or removing a mark
      y.endA == y.endB && (P = UY(x.parent.content.cut(x.parentOffset, S.parentOffset), w.parent.content.cut(w.parentOffset, y.endA - w.start())))
    ) {
      let L = R(n.state.tr);
      P.type == "add" ? L.addMark(T, k, P.mark) : L.removeMark(T, k, P.mark), n.dispatch(L);
    } else if (x.parent.child(x.index()).isText && x.index() == S.index() - (S.textOffset ? 0 : 1)) {
      let L = x.parent.textBetween(x.parentOffset, S.parentOffset), B = () => R(n.state.tr.insertText(L, T, k));
      n.someProp("handleTextInput", (W) => W(n, T, k, L, B)) || n.dispatch(B());
    } else
      n.dispatch(R());
  else
    n.dispatch(R());
}
function aA(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : Ov(n, e.resolve(t.anchor), e.resolve(t.head));
}
function UY(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, i = t, s = r, o, a, c;
  for (let f = 0; f < r.length; f++)
    i = r[f].removeFromSet(i);
  for (let f = 0; f < t.length; f++)
    s = t[f].removeFromSet(s);
  if (i.length == 1 && s.length == 0)
    a = i[0], o = "add", c = (f) => f.mark(a.addToSet(f.marks));
  else if (i.length == 0 && s.length == 1)
    a = s[0], o = "remove", c = (f) => f.mark(a.removeFromSet(f.marks));
  else
    return null;
  let u = [];
  for (let f = 0; f < e.childCount; f++)
    u.push(c(e.child(f)));
  if (le.from(u).eq(n))
    return { mark: a, type: o };
}
function $Y(n, e, t, r, i) {
  if (
    // The content must have shrunk
    t - e <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    xm(r, !0, !1) < i.pos
  )
    return !1;
  let s = n.resolve(e);
  if (!r.parent.isTextblock) {
    let a = s.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let o = n.resolve(xm(s, !0, !0));
  return !o.parent.isTextblock || o.pos > t || xm(o, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function xm(n, e, t) {
  let r = n.depth, i = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, i++, e = !1;
  if (t) {
    let s = n.node(r).maybeChild(n.indexAfter(r));
    for (; s && !s.isLeaf; )
      s = s.firstChild, i++;
  }
  return i;
}
function GY(n, e, t, r, i) {
  let s = n.findDiffStart(e, t);
  if (s == null)
    return null;
  let { a: o, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (i == "end") {
    let c = Math.max(0, s - Math.min(o, a));
    r -= o + c - s;
  }
  if (o < s && n.size < e.size) {
    let c = r <= s && r >= o ? s - r : 0;
    s -= c, s && s < e.size && lA(e.textBetween(s - 1, s + 1)) && (s += c ? 1 : -1), a = s + (a - o), o = s;
  } else if (a < s) {
    let c = r <= s && r >= a ? s - r : 0;
    s -= c, s && s < n.size && lA(n.textBetween(s - 1, s + 1)) && (s += c ? 1 : -1), o = s + (o - a), a = s;
  }
  return { start: s, endA: o, endB: a };
}
function lA(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class Ok {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new lY(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(hA), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = dA(this), uA(this), this.nodeViews = fA(this), this.docView = WE(this.state.doc, cA(this), bm(this), this.dom, this), this.domObserver = new PY(this, (r, i, s, o) => WY(this, r, i, s, o)), this.domObserver.start(), cY(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Gg(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(hA), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let i = this.state, s = !1, o = !1;
    e.storedMarks && this.composing && (Tk(this), o = !0), this.state = e;
    let a = i.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let g = fA(this);
      qY(g, this.nodeViews) && (this.nodeViews = g, s = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && Gg(this), this.editable = dA(this), uA(this);
    let c = bm(this), u = cA(this), f = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", h = s || !this.docView.matchesNode(e.doc, u, c);
    (h || !e.selection.eq(i.selection)) && (o = !0);
    let p = f == "preserve" && o && this.dom.style.overflowAnchor == null && EG(this);
    if (o) {
      this.domObserver.stop();
      let g = h && (mr || yn) && !this.composing && !i.selection.empty && !e.selection.empty && YY(i.selection, e.selection);
      if (h) {
        let y = yn ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = EY(this)), (s || !this.docView.update(e.doc, u, c, this)) && (this.docView.updateOuterDeco(u), this.docView.destroy(), this.docView = WE(e.doc, u, c, this.dom, this)), y && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (g = !0);
      }
      g || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && YG(this)) ? is(this, g) : (hk(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), f == "reset" ? this.dom.scrollTop = 0 : f == "to selection" ? this.scrollToSelection() : p && AG(p);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof Me) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && BE(this, t.getBoundingClientRect(), e);
      } else
        BE(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let s = r.from + (this.state.doc.content.size - t.doc.content.size);
      (s > 0 && this.state.doc.nodeAt(s)) == r.node && (i = s);
    }
    this.dragging = new Dk(e.slice, e.move, i < 0 ? void 0 : Me.create(this.state.doc, i));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = t ? t(r) : r))
      return i;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let a = this.directPlugins[o].props[e];
      if (a != null && (i = t ? t(a) : a))
        return i;
    }
    let s = this.state.plugins;
    if (s)
      for (let o = 0; o < s.length; o++) {
        let a = s[o].props[e];
        if (a != null && (i = t ? t(a) : a))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (mr) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && TG(this.dom), is(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return MG(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return sk(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, r = -1) {
    let i = this.docView.posFromDOM(e, t, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return PG(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return kc(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return kc(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return Iv(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (uY(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], bm(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, hG());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return fY(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Nn && this.root.nodeType === 11 && vG(this.dom.ownerDocument) == this.dom && BY(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
Ok.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function cA(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [Dr.node(0, n.state.doc.content.size, e)];
}
function uA(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: Dr.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function dA(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function YY(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function fA(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function qY(n, e) {
  let t = 0, r = 0;
  for (let i in n) {
    if (n[i] != e[i])
      return !0;
    t++;
  }
  for (let i in e)
    r++;
  return t != r;
}
function hA(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var eo = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, lf = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, KY = typeof navigator < "u" && /Mac/.test(navigator.platform), JY = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var On = 0; On < 10; On++) eo[48 + On] = eo[96 + On] = String(On);
for (var On = 1; On <= 24; On++) eo[On + 111] = "F" + On;
for (var On = 65; On <= 90; On++)
  eo[On] = String.fromCharCode(On + 32), lf[On] = String.fromCharCode(On);
for (var Sm in eo) lf.hasOwnProperty(Sm) || (lf[Sm] = eo[Sm]);
function QY(n) {
  var e = KY && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || JY && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? lf : eo)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const ZY = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), XY = typeof navigator < "u" && /Win/.test(navigator.platform);
function eq(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a++) {
    let c = e[a];
    if (/^(cmd|meta|m)$/i.test(c))
      o = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      i = !0;
    else if (/^s(hift)?$/i.test(c))
      s = !0;
    else if (/^mod$/i.test(c))
      ZY ? o = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return r && (t = "Alt-" + t), i && (t = "Ctrl-" + t), o && (t = "Meta-" + t), s && (t = "Shift-" + t), t;
}
function tq(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[eq(t)] = n[t];
  return e;
}
function wm(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function nq(n) {
  return new En({ props: { handleKeyDown: Ik(n) } });
}
function Ik(n) {
  let e = tq(n);
  return function(t, r) {
    let i = QY(r), s, o = e[wm(i, r)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let a = e[wm(i, r, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(XY && r.ctrlKey && r.altKey) && (s = eo[r.keyCode]) && s != i) {
        let a = e[wm(s, r)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const Fv = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function Nk(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const Pk = (n, e, t) => {
  let r = Nk(n, t);
  if (!r)
    return !1;
  let i = zv(r);
  if (!i) {
    let o = r.blockRange(), a = o && ll(o);
    return a == null ? !1 : (e && e(n.tr.lift(o, a).scrollIntoView()), !0);
  }
  let s = i.nodeBefore;
  if (Uk(n, i, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (tl(s, "end") || Me.isSelectable(s)))
    for (let o = r.depth; ; o--) {
      let a = eh(n.doc, r.before(o), r.after(o), xe.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let c = n.tr.step(a);
          c.setSelection(tl(s, "end") ? Qe.findFrom(c.doc.resolve(c.mapping.map(i.pos, -1)), -1) : Me.create(c.doc, i.pos - s.nodeSize)), e(c.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos - s.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, rq = (n, e, t) => {
  let r = Nk(n, t);
  if (!r)
    return !1;
  let i = zv(r);
  return i ? Lk(n, i, e) : !1;
}, iq = (n, e, t) => {
  let r = jk(n, t);
  if (!r)
    return !1;
  let i = Vv(r);
  return i ? Lk(n, i, e) : !1;
};
function Lk(n, e, t) {
  let r = e.nodeBefore, i = r, s = e.pos - 1;
  for (; !i.isTextblock; s--) {
    if (i.type.spec.isolating)
      return !1;
    let f = i.lastChild;
    if (!f)
      return !1;
    i = f;
  }
  let o = e.nodeAfter, a = o, c = e.pos + 1;
  for (; !a.isTextblock; c++) {
    if (a.type.spec.isolating)
      return !1;
    let f = a.firstChild;
    if (!f)
      return !1;
    a = f;
  }
  let u = eh(n.doc, s, c, xe.empty);
  if (!u || u.from != s || u instanceof mn && u.slice.size >= c - s)
    return !1;
  if (t) {
    let f = n.tr.step(u);
    f.setSelection(ze.create(f.doc, s)), t(f.scrollIntoView());
  }
  return !0;
}
function tl(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const Bk = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    s = zv(r);
  }
  let o = s && s.nodeBefore;
  return !o || !Me.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(Me.create(n.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function zv(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function jk(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const Fk = (n, e, t) => {
  let r = jk(n, t);
  if (!r)
    return !1;
  let i = Vv(r);
  if (!i)
    return !1;
  let s = i.nodeAfter;
  if (Uk(n, i, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (tl(s, "start") || Me.isSelectable(s))) {
    let o = eh(n.doc, r.before(), r.after(), xe.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = n.tr.step(o);
        a.setSelection(tl(s, "start") ? Qe.findFrom(a.doc.resolve(a.mapping.map(i.pos)), 1) : Me.create(a.doc, a.mapping.map(i.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos, i.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, zk = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    s = Vv(r);
  }
  let o = s && s.nodeAfter;
  return !o || !Me.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(Me.create(n.doc, s.pos)).scrollIntoView()), !0);
};
function Vv(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const sq = (n, e) => {
  let t = n.selection, r = t instanceof Me, i;
  if (r) {
    if (t.node.isTextblock || !io(n.doc, t.from))
      return !1;
    i = t.from;
  } else if (i = Xf(n.doc, t.from, -1), i == null)
    return !1;
  if (e) {
    let s = n.tr.join(i);
    r && s.setSelection(Me.create(s.doc, i - n.doc.resolve(i).nodeBefore.nodeSize)), e(s.scrollIntoView());
  }
  return !0;
}, oq = (n, e) => {
  let t = n.selection, r;
  if (t instanceof Me) {
    if (t.node.isTextblock || !io(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = Xf(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, aq = (n, e) => {
  let { $from: t, $to: r } = n.selection, i = t.blockRange(r), s = i && ll(i);
  return s == null ? !1 : (e && e(n.tr.lift(i, s).scrollIntoView()), !0);
}, Vk = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function Hv(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const lq = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let i = t.node(-1), s = t.indexAfter(-1), o = Hv(i.contentMatchAt(s));
  if (!o || !i.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let a = t.after(), c = n.tr.replaceWith(a, a, o.createAndFill());
    c.setSelection(Qe.near(c.doc.resolve(a), 1)), e(c.scrollIntoView());
  }
  return !0;
}, Hk = (n, e) => {
  let t = n.selection, { $from: r, $to: i } = t;
  if (t instanceof kr || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let s = Hv(i.parent.contentMatchAt(i.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, a = n.tr.insert(o, s.createAndFill());
    a.setSelection(ze.create(a.doc, o + 1)), e(a.scrollIntoView());
  }
  return !0;
}, Wk = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (rs(n.doc, s))
      return e && e(n.tr.split(s).scrollIntoView()), !0;
  }
  let r = t.blockRange(), i = r && ll(r);
  return i == null ? !1 : (e && e(n.tr.lift(r, i).scrollIntoView()), !0);
};
function cq(n) {
  return (e, t) => {
    let { $from: r, $to: i } = e.selection;
    if (e.selection instanceof Me && e.selection.node.isBlock)
      return !r.parentOffset || !rs(e.doc, r.pos) ? !1 : (t && t(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let s = [], o, a, c = !1, u = !1;
    for (let g = r.depth; ; g--)
      if (r.node(g).isBlock) {
        c = r.end(g) == r.pos + (r.depth - g), u = r.start(g) == r.pos - (r.depth - g), a = Hv(r.node(g - 1).contentMatchAt(r.indexAfter(g - 1))), s.unshift(c && a ? { type: a } : null), o = g;
        break;
      } else {
        if (g == 1)
          return !1;
        s.unshift(null);
      }
    let f = e.tr;
    (e.selection instanceof ze || e.selection instanceof kr) && f.deleteSelection();
    let h = f.mapping.map(r.pos), p = rs(f.doc, h, s.length, s);
    if (p || (s[0] = a ? { type: a } : null, p = rs(f.doc, h, s.length, s)), !p)
      return !1;
    if (f.split(h, s.length, s), !c && u && r.node(o).type != a) {
      let g = f.mapping.map(r.before(o)), y = f.doc.resolve(g);
      a && r.node(o - 1).canReplaceWith(y.index(), y.index() + 1, a) && f.setNodeMarkup(f.mapping.map(r.before(o)), a);
    }
    return t && t(f.scrollIntoView()), !0;
  };
}
const uq = cq(), dq = (n, e) => {
  let { $from: t, to: r } = n.selection, i, s = t.sharedDepth(r);
  return s == 0 ? !1 : (i = t.before(s), e && e(n.tr.setSelection(Me.create(n.doc, i))), !0);
};
function fq(n, e, t) {
  let r = e.nodeBefore, i = e.nodeAfter, s = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(s - 1, s) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(i.isTextblock || io(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function Uk(n, e, t, r) {
  let i = e.nodeBefore, s = e.nodeAfter, o, a, c = i.type.spec.isolating || s.type.spec.isolating;
  if (!c && fq(n, e, t))
    return !0;
  let u = !c && e.parent.canReplace(e.index(), e.index() + 1);
  if (u && (o = (a = i.contentMatchAt(i.childCount)).findWrapping(s.type)) && a.matchType(o[0] || s.type).validEnd) {
    if (t) {
      let g = e.pos + s.nodeSize, y = le.empty;
      for (let w = o.length - 1; w >= 0; w--)
        y = le.from(o[w].create(null, y));
      y = le.from(i.copy(y));
      let x = n.tr.step(new bn(e.pos - 1, g, e.pos, g, new xe(y, 1, 0), o.length, !0)), S = x.doc.resolve(g + 2 * o.length);
      S.nodeAfter && S.nodeAfter.type == i.type && io(x.doc, S.pos) && x.join(S.pos), t(x.scrollIntoView());
    }
    return !0;
  }
  let f = s.type.spec.isolating || r > 0 && c ? null : Qe.findFrom(e, 1), h = f && f.$from.blockRange(f.$to), p = h && ll(h);
  if (p != null && p >= e.depth)
    return t && t(n.tr.lift(h, p).scrollIntoView()), !0;
  if (u && tl(s, "start", !0) && tl(i, "end")) {
    let g = i, y = [];
    for (; y.push(g), !g.isTextblock; )
      g = g.lastChild;
    let x = s, S = 1;
    for (; !x.isTextblock; x = x.firstChild)
      S++;
    if (g.canReplace(g.childCount, g.childCount, x.content)) {
      if (t) {
        let w = le.empty;
        for (let T = y.length - 1; T >= 0; T--)
          w = le.from(y[T].copy(w));
        let C = n.tr.step(new bn(e.pos - y.length, e.pos + s.nodeSize, e.pos + S, e.pos + s.nodeSize - S, new xe(w, y.length, 0), 0, !0));
        t(C.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function $k(n) {
  return function(e, t) {
    let r = e.selection, i = n < 0 ? r.$from : r.$to, s = i.depth;
    for (; i.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return i.node(s).isTextblock ? (t && t(e.tr.setSelection(ze.create(e.doc, n < 0 ? i.start(s) : i.end(s)))), !0) : !1;
  };
}
const hq = $k(-1), pq = $k(1);
function mq(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s), a = o && Rv(o, n, e);
    return a ? (r && r(t.tr.wrap(o, a).scrollIntoView()), !0) : !1;
  };
}
function pA(n, e = null) {
  return function(t, r) {
    let i = !1;
    for (let s = 0; s < t.selection.ranges.length && !i; s++) {
      let { $from: { pos: o }, $to: { pos: a } } = t.selection.ranges[s];
      t.doc.nodesBetween(o, a, (c, u) => {
        if (i)
          return !1;
        if (!(!c.isTextblock || c.hasMarkup(n, e)))
          if (c.type == n)
            i = !0;
          else {
            let f = t.doc.resolve(u), h = f.index();
            i = f.parent.canReplaceWith(h, h + 1, n);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let s = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: a }, $to: { pos: c } } = t.selection.ranges[o];
        s.setBlockType(a, c, n, e);
      }
      r(s.scrollIntoView());
    }
    return !0;
  };
}
function Wv(...n) {
  return function(e, t, r) {
    for (let i = 0; i < n.length; i++)
      if (n[i](e, t, r))
        return !0;
    return !1;
  };
}
Wv(Fv, Pk, Bk);
Wv(Fv, Fk, zk);
Wv(Vk, Hk, Wk, uq);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function gq(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s);
    if (!o)
      return !1;
    let a = r ? t.tr : null;
    return yq(a, o, n, e) ? (r && r(a.scrollIntoView()), !0) : !1;
  };
}
function yq(n, e, t, r = null) {
  let i = !1, s = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let c = o.resolve(e.start - 2);
    s = new ef(c, c, e.depth), e.endIndex < e.parent.childCount && (e = new ef(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let a = Rv(s, t, r, e);
  return a ? (n && vq(n, e, a, i, t), !0) : !1;
}
function vq(n, e, t, r, i) {
  let s = le.empty;
  for (let f = t.length - 1; f >= 0; f--)
    s = le.from(t[f].type.create(t[f].attrs, s));
  n.step(new bn(e.start - (r ? 2 : 0), e.end, e.start, e.end, new xe(s, 0, 0), t.length, !0));
  let o = 0;
  for (let f = 0; f < t.length; f++)
    t[f].type == i && (o = f + 1);
  let a = t.length - o, c = e.start + t.length - (r ? 2 : 0), u = e.parent;
  for (let f = e.startIndex, h = e.endIndex, p = !0; f < h; f++, p = !1)
    !p && rs(n.doc, c, a) && (n.split(c, a), c += 2 * a), c += u.child(f).nodeSize;
  return n;
}
function bq(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (o) => o.childCount > 0 && o.firstChild.type == n);
    return s ? t ? r.node(s.depth - 1).type == n ? xq(e, t, n, s) : Sq(e, t, s) : !0 : !1;
  };
}
function xq(n, e, t, r) {
  let i = n.tr, s = r.end, o = r.$to.end(r.depth);
  s < o && (i.step(new bn(s - 1, o, s, o, new xe(le.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new ef(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
  const a = ll(r);
  if (a == null)
    return !1;
  i.lift(r, a);
  let c = i.doc.resolve(i.mapping.map(s, -1) - 1);
  return io(i.doc, c.pos) && c.nodeBefore.type == c.nodeAfter.type && i.join(c.pos), e(i.scrollIntoView()), !0;
}
function Sq(n, e, t) {
  let r = n.tr, i = t.parent;
  for (let g = t.end, y = t.endIndex - 1, x = t.startIndex; y > x; y--)
    g -= i.child(y).nodeSize, r.delete(g - 1, g + 1);
  let s = r.doc.resolve(t.start), o = s.nodeAfter;
  if (r.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, c = t.endIndex == i.childCount, u = s.node(-1), f = s.index(-1);
  if (!u.canReplace(f + (a ? 0 : 1), f + 1, o.content.append(c ? le.empty : le.from(i))))
    return !1;
  let h = s.pos, p = h + o.nodeSize;
  return r.step(new bn(h - (a ? 1 : 0), p + (c ? 1 : 0), h + 1, p - 1, new xe((a ? le.empty : le.from(i.copy(le.empty))).append(c ? le.empty : le.from(i.copy(le.empty))), a ? 0 : 1, c ? 0 : 1), a ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function wq(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (u) => u.childCount > 0 && u.firstChild.type == n);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let a = s.parent, c = a.child(o - 1);
    if (c.type != n)
      return !1;
    if (t) {
      let u = c.lastChild && c.lastChild.type == a.type, f = le.from(u ? n.create() : null), h = new xe(le.from(n.create(null, le.from(a.type.create(null, f)))), u ? 3 : 1, 0), p = s.start, g = s.end;
      t(e.tr.step(new bn(p - (u ? 3 : 1), g, p, g, h, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function sh(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: i } = t, { storedMarks: s } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = t.selection, i = t.doc, s = t.storedMarks, t;
    }
  };
}
class oh {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: r } = this, { view: i } = t, { tr: s } = r, o = this.buildProps(s);
    return Object.fromEntries(Object.entries(e).map(([a, c]) => [a, (...f) => {
      const h = c(...f)(o);
      return !s.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(s), h;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = [], c = !!e, u = e || s.tr, f = () => (!c && t && !u.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(u), a.every((p) => p === !0)), h = {
      ...Object.fromEntries(Object.entries(r).map(([p, g]) => [p, (...x) => {
        const S = this.buildProps(u, t), w = g(...x)(S);
        return a.push(w), h;
      }])),
      run: f
    };
    return h;
  }
  createCan(e) {
    const { rawCommands: t, state: r } = this, i = !1, s = e || r.tr, o = this.buildProps(s, i);
    return {
      ...Object.fromEntries(Object.entries(t).map(([c, u]) => [c, (...f) => u(...f)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(s, i)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: r, editor: i, state: s } = this, { view: o } = i, a = {
      tr: e,
      editor: i,
      view: o,
      state: sh({
        state: s,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([c, u]) => [c, (...f) => u(...f)(a)]));
      }
    };
    return a;
  }
}
class Eq {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const r = this.callbacks[e];
    return r && r.forEach((i) => i.apply(this, t)), this;
  }
  off(e, t) {
    const r = this.callbacks[e];
    return r && (t ? this.callbacks[e] = r.filter((i) => i !== t) : delete this.callbacks[e]), this;
  }
  once(e, t) {
    const r = (...i) => {
      this.off(e, r), t.apply(this, i);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Te(n, e, t) {
  return n.config[e] === void 0 && n.parent ? Te(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? Te(n.parent, e, t) : null
  }) : n.config[e];
}
function ah(n) {
  const e = n.filter((i) => i.type === "extension"), t = n.filter((i) => i.type === "node"), r = n.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function Gk(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = ah(n), i = [...t, ...r], s = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: i
    }, c = Te(o, "addGlobalAttributes", a);
    if (!c)
      return;
    c().forEach((f) => {
      f.types.forEach((h) => {
        Object.entries(f.attributes).forEach(([p, g]) => {
          e.push({
            type: h,
            name: p,
            attribute: {
              ...s,
              ...g
            }
          });
        });
      });
    });
  }), i.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, c = Te(o, "addAttributes", a);
    if (!c)
      return;
    const u = c();
    Object.entries(u).forEach(([f, h]) => {
      const p = {
        ...s,
        ...h
      };
      typeof (p == null ? void 0 : p.default) == "function" && (p.default = p.default()), p != null && p.isRequired && (p == null ? void 0 : p.default) === void 0 && delete p.default, e.push({
        type: o.name,
        name: f,
        attribute: p
      });
    });
  }), e;
}
function Sn(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function wn(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([i, s]) => {
      if (!r[i]) {
        r[i] = s;
        return;
      }
      if (i === "class") {
        const a = s ? String(s).split(" ") : [], c = r[i] ? r[i].split(" ") : [], u = a.filter((f) => !c.includes(f));
        r[i] = [...c, ...u].join(" ");
      } else if (i === "style") {
        const a = s ? s.split(";").map((f) => f.trim()).filter(Boolean) : [], c = r[i] ? r[i].split(";").map((f) => f.trim()).filter(Boolean) : [], u = /* @__PURE__ */ new Map();
        c.forEach((f) => {
          const [h, p] = f.split(":").map((g) => g.trim());
          u.set(h, p);
        }), a.forEach((f) => {
          const [h, p] = f.split(":").map((g) => g.trim());
          u.set(h, p);
        }), r[i] = Array.from(u.entries()).map(([f, h]) => `${f}: ${h}`).join("; ");
      } else
        r[i] = s;
    }), r;
  }, {});
}
function Yg(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => wn(t, r), {});
}
function Yk(n) {
  return typeof n == "function";
}
function Xe(n, e = void 0, ...t) {
  return Yk(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function Aq(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function Tq(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function mA(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((s, o) => {
        const a = o.attribute.parseHTML ? o.attribute.parseHTML(t) : Tq(t.getAttribute(o.name));
        return a == null ? s : {
          ...s,
          [o.name]: a
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function gA(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && Aq(t) ? !1 : t != null)
  );
}
function Cq(n, e) {
  var t;
  const r = Gk(n), { nodeExtensions: i, markExtensions: s } = ah(n), o = (t = i.find((u) => Te(u, "topNode"))) === null || t === void 0 ? void 0 : t.name, a = Object.fromEntries(i.map((u) => {
    const f = r.filter((w) => w.type === u.name), h = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, p = n.reduce((w, C) => {
      const T = Te(C, "extendNodeSchema", h);
      return {
        ...w,
        ...T ? T(u) : {}
      };
    }, {}), g = gA({
      ...p,
      content: Xe(Te(u, "content", h)),
      marks: Xe(Te(u, "marks", h)),
      group: Xe(Te(u, "group", h)),
      inline: Xe(Te(u, "inline", h)),
      atom: Xe(Te(u, "atom", h)),
      selectable: Xe(Te(u, "selectable", h)),
      draggable: Xe(Te(u, "draggable", h)),
      code: Xe(Te(u, "code", h)),
      whitespace: Xe(Te(u, "whitespace", h)),
      linebreakReplacement: Xe(Te(u, "linebreakReplacement", h)),
      defining: Xe(Te(u, "defining", h)),
      isolating: Xe(Te(u, "isolating", h)),
      attrs: Object.fromEntries(f.map((w) => {
        var C;
        return [w.name, { default: (C = w == null ? void 0 : w.attribute) === null || C === void 0 ? void 0 : C.default }];
      }))
    }), y = Xe(Te(u, "parseHTML", h));
    y && (g.parseDOM = y.map((w) => mA(w, f)));
    const x = Te(u, "renderHTML", h);
    x && (g.toDOM = (w) => x({
      node: w,
      HTMLAttributes: Yg(w, f)
    }));
    const S = Te(u, "renderText", h);
    return S && (g.toText = S), [u.name, g];
  })), c = Object.fromEntries(s.map((u) => {
    const f = r.filter((S) => S.type === u.name), h = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: e
    }, p = n.reduce((S, w) => {
      const C = Te(w, "extendMarkSchema", h);
      return {
        ...S,
        ...C ? C(u) : {}
      };
    }, {}), g = gA({
      ...p,
      inclusive: Xe(Te(u, "inclusive", h)),
      excludes: Xe(Te(u, "excludes", h)),
      group: Xe(Te(u, "group", h)),
      spanning: Xe(Te(u, "spanning", h)),
      code: Xe(Te(u, "code", h)),
      attrs: Object.fromEntries(f.map((S) => {
        var w;
        return [S.name, { default: (w = S == null ? void 0 : S.attribute) === null || w === void 0 ? void 0 : w.default }];
      }))
    }), y = Xe(Te(u, "parseHTML", h));
    y && (g.parseDOM = y.map((S) => mA(S, f)));
    const x = Te(u, "renderHTML", h);
    return x && (g.toDOM = (S) => x({
      mark: S,
      HTMLAttributes: Yg(S, f)
    })), [u.name, g];
  }));
  return new IR({
    topNode: o,
    nodes: a,
    marks: c
  });
}
function Em(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function yA(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function Uv(n, e) {
  const t = ea.fromSchema(e).serializeFragment(n), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(t), i.innerHTML;
}
const Dq = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (i, s, o, a) => {
    var c, u;
    const f = ((u = (c = i.type.spec).toText) === null || u === void 0 ? void 0 : u.call(c, {
      node: i,
      pos: s,
      parent: o,
      index: a
    })) || i.textContent || "%leaf%";
    t += i.isAtom && !i.isText ? f : f.slice(0, Math.max(0, r - s));
  }), t;
};
function $v(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class lh {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const Rq = (n, e) => {
  if ($v(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function nd(n) {
  var e;
  const { editor: t, from: r, to: i, text: s, rules: o, plugin: a } = n, { view: c } = t;
  if (c.composing)
    return !1;
  const u = c.state.doc.resolve(r);
  if (
    // check for code node
    u.parent.type.spec.code || !((e = u.nodeBefore || u.nodeAfter) === null || e === void 0) && e.marks.find((p) => p.type.spec.code)
  )
    return !1;
  let f = !1;
  const h = Dq(u) + s;
  return o.forEach((p) => {
    if (f)
      return;
    const g = Rq(h, p.find);
    if (!g)
      return;
    const y = c.state.tr, x = sh({
      state: c.state,
      transaction: y
    }), S = {
      from: r - (g[0].length - s.length),
      to: i
    }, { commands: w, chain: C, can: T } = new oh({
      editor: t,
      state: x
    });
    p.handler({
      state: x,
      range: S,
      match: g,
      commands: w,
      chain: C,
      can: T
    }) === null || !y.steps.length || (y.setMeta(a, {
      transform: y,
      from: r,
      to: i,
      text: s
    }), c.dispatch(y), f = !0);
  }), f;
}
function kq(n) {
  const { editor: e, rules: t } = n, r = new En({
    state: {
      init() {
        return null;
      },
      apply(i, s, o) {
        const a = i.getMeta(r);
        if (a)
          return a;
        const c = i.getMeta("applyInputRules");
        return !!c && setTimeout(() => {
          let { text: f } = c;
          typeof f == "string" ? f = f : f = Uv(le.from(f), o.schema);
          const { from: h } = c, p = h + f.length;
          nd({
            editor: e,
            from: h,
            to: p,
            text: f,
            rules: t,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : s;
      }
    },
    props: {
      handleTextInput(i, s, o, a) {
        return nd({
          editor: e,
          from: s,
          to: o,
          text: a,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: s } = i.state.selection;
          s && nd({
            editor: e,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: o } = i.state.selection;
        return o ? nd({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function Mq(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function rd(n) {
  return Mq(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function ch(n, e) {
  const t = { ...n };
  return rd(n) && rd(e) && Object.keys(e).forEach((r) => {
    rd(e[r]) && rd(n[r]) ? t[r] = ch(n[r], e[r]) : t[r] = e[r];
  }), t;
}
class Pi {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Xe(Te(this, "addOptions", {
      name: this.name
    }))), this.storage = Xe(Te(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Pi(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => ch(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Pi(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Xe(Te(t, "addOptions", {
      name: t.name
    })), t.storage = Xe(Te(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const o = i.marks();
      if (!!!o.find((u) => (u == null ? void 0 : u.type.name) === t.name))
        return !1;
      const c = o.find((u) => (u == null ? void 0 : u.type.name) === t.name);
      return c && r.removeStoredMark(c), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function _q(n) {
  return typeof n == "number";
}
class Oq {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const Iq = (n, e, t) => {
  if ($v(e))
    return [...n.matchAll(e)];
  const r = e(n, t);
  return r ? r.map((i) => {
    const s = [i.text];
    return s.index = i.index, s.input = n, s.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), s.push(i.replaceWith)), s;
  }) : [];
};
function Nq(n) {
  const { editor: e, state: t, from: r, to: i, rule: s, pasteEvent: o, dropEvent: a } = n, { commands: c, chain: u, can: f } = new oh({
    editor: e,
    state: t
  }), h = [];
  return t.doc.nodesBetween(r, i, (g, y) => {
    if (!g.isTextblock || g.type.spec.code)
      return;
    const x = Math.max(r, y), S = Math.min(i, y + g.content.size), w = g.textBetween(x - y, S - y, void 0, "￼");
    Iq(w, s.find, o).forEach((T) => {
      if (T.index === void 0)
        return;
      const k = x + T.index + 1, R = k + T[0].length, P = {
        from: t.tr.mapping.map(k),
        to: t.tr.mapping.map(R)
      }, L = s.handler({
        state: t,
        range: P,
        match: T,
        commands: c,
        chain: u,
        can: f,
        pasteEvent: o,
        dropEvent: a
      });
      h.push(L);
    });
  }), h.every((g) => g !== null);
}
let id = null;
const Pq = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) === null || e === void 0 || e.setData("text/html", n), t;
};
function Lq(n) {
  const { editor: e, rules: t } = n;
  let r = null, i = !1, s = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const c = ({ state: f, from: h, to: p, rule: g, pasteEvt: y }) => {
    const x = f.tr, S = sh({
      state: f,
      transaction: x
    });
    if (!(!Nq({
      editor: e,
      state: S,
      from: Math.max(h - 1, 0),
      to: p.b - 1,
      rule: g,
      pasteEvent: y,
      dropEvent: a
    }) || !x.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, x;
    }
  };
  return t.map((f) => new En({
    // we register a global drag handler to track the current drag source element
    view(h) {
      const p = (y) => {
        var x;
        r = !((x = h.dom.parentElement) === null || x === void 0) && x.contains(y.target) ? h.dom.parentElement : null, r && (id = e);
      }, g = () => {
        id && (id = null);
      };
      return window.addEventListener("dragstart", p), window.addEventListener("dragend", g), {
        destroy() {
          window.removeEventListener("dragstart", p), window.removeEventListener("dragend", g);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (h, p) => {
          if (s = r === h.dom.parentElement, a = p, !s) {
            const g = id;
            g != null && g.isEditable && setTimeout(() => {
              const y = g.state.selection;
              y && g.commands.deleteRange({ from: y.from, to: y.to });
            }, 10);
          }
          return !1;
        },
        paste: (h, p) => {
          var g;
          const y = (g = p.clipboardData) === null || g === void 0 ? void 0 : g.getData("text/html");
          return o = p, i = !!(y != null && y.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (h, p, g) => {
      const y = h[0], x = y.getMeta("uiEvent") === "paste" && !i, S = y.getMeta("uiEvent") === "drop" && !s, w = y.getMeta("applyPasteRules"), C = !!w;
      if (!x && !S && !C)
        return;
      if (C) {
        let { text: R } = w;
        typeof R == "string" ? R = R : R = Uv(le.from(R), g.schema);
        const { from: P } = w, L = P + R.length, B = Pq(R);
        return c({
          rule: f,
          state: g,
          from: P,
          to: { b: L },
          pasteEvt: B
        });
      }
      const T = p.doc.content.findDiffStart(g.doc.content), k = p.doc.content.findDiffEnd(g.doc.content);
      if (!(!_q(T) || !k || T === k.b))
        return c({
          rule: f,
          state: g,
          from: T,
          to: k,
          pasteEvt: o
        });
    }
  }));
}
function Bq(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return Array.from(new Set(e));
}
class za {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = za.resolve(e), this.schema = Cq(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const t = za.sort(za.flatten(e)), r = Bq(t.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, i = Te(t, "addExtensions", r);
      return i ? [t, ...this.flatten(i())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, i) => {
      const s = Te(r, "priority") || 100, o = Te(i, "priority") || 100;
      return s > o ? -1 : s < o ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: Em(t.name, this.schema)
      }, i = Te(t, "addCommands", r);
      return i ? {
        ...e,
        ...i()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, t = za.sort([...this.extensions].reverse()), r = [], i = [], s = t.map((o) => {
      const a = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: e,
        type: Em(o.name, this.schema)
      }, c = [], u = Te(o, "addKeyboardShortcuts", a);
      let f = {};
      if (o.type === "mark" && Te(o, "exitable", a) && (f.ArrowRight = () => Pi.handleExit({ editor: e, mark: o })), u) {
        const x = Object.fromEntries(Object.entries(u()).map(([S, w]) => [S, () => w({ editor: e })]));
        f = { ...f, ...x };
      }
      const h = nq(f);
      c.push(h);
      const p = Te(o, "addInputRules", a);
      yA(o, e.options.enableInputRules) && p && r.push(...p());
      const g = Te(o, "addPasteRules", a);
      yA(o, e.options.enablePasteRules) && g && i.push(...g());
      const y = Te(o, "addProseMirrorPlugins", a);
      if (y) {
        const x = y();
        c.push(...x);
      }
      return c;
    }).flat();
    return [
      kq({
        editor: e,
        rules: r
      }),
      ...Lq({
        editor: e,
        rules: i
      }),
      ...s
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Gk(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = ah(this.extensions);
    return Object.fromEntries(t.filter((r) => !!Te(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((c) => c.type === r.name), s = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: Sn(r.name, this.schema)
      }, o = Te(r, "addNodeView", s);
      if (!o)
        return [];
      const a = (c, u, f, h, p) => {
        const g = Yg(c, i);
        return o()({
          // pass-through
          node: c,
          view: u,
          getPos: f,
          decorations: h,
          innerDecorations: p,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: g
        });
      };
      return [r.name, a];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Em(e.name, this.schema)
      };
      e.type === "mark" && (!((t = Xe(Te(e, "keepOnSplit", r))) !== null && t !== void 0) || t) && this.splittableMarks.push(e.name);
      const i = Te(e, "onBeforeCreate", r), s = Te(e, "onCreate", r), o = Te(e, "onUpdate", r), a = Te(e, "onSelectionUpdate", r), c = Te(e, "onTransaction", r), u = Te(e, "onFocus", r), f = Te(e, "onBlur", r), h = Te(e, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), s && this.editor.on("create", s), o && this.editor.on("update", o), a && this.editor.on("selectionUpdate", a), c && this.editor.on("transaction", c), u && this.editor.on("focus", u), f && this.editor.on("blur", f), h && this.editor.on("destroy", h);
    });
  }
}
class Hn {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Xe(Te(this, "addOptions", {
      name: this.name
    }))), this.storage = Xe(Te(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Hn(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => ch(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Hn({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Xe(Te(t, "addOptions", {
      name: t.name
    })), t.storage = Xe(Te(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function qk(n, e, t) {
  const { from: r, to: i } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = t || {};
  let a = "";
  return n.nodesBetween(r, i, (c, u, f, h) => {
    var p;
    c.isBlock && u > r && (a += s);
    const g = o == null ? void 0 : o[c.type.name];
    if (g)
      return f && (a += g({
        node: c,
        pos: u,
        parent: f,
        index: h,
        range: e
      })), !1;
    c.isText && (a += (p = c == null ? void 0 : c.text) === null || p === void 0 ? void 0 : p.slice(Math.max(r, u) - u, i - u));
  }), a;
}
function Kk(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const jq = Hn.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new En({
        key: new yr("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: i } = e, { ranges: s } = i, o = Math.min(...s.map((f) => f.$from.pos)), a = Math.max(...s.map((f) => f.$to.pos)), c = Kk(t);
            return qk(r, { from: o, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: c
            });
          }
        }
      })
    ];
  }
}), Fq = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), zq = (n = !1) => ({ commands: e }) => e.setContent("", n), Vq = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: i } = r;
  return t && i.forEach(({ $from: s, $to: o }) => {
    n.doc.nodesBetween(s.pos, o.pos, (a, c) => {
      if (a.type.isText)
        return;
      const { doc: u, mapping: f } = e, h = u.resolve(f.map(c)), p = u.resolve(f.map(c + a.nodeSize)), g = h.blockRange(p);
      if (!g)
        return;
      const y = ll(g);
      if (a.type.isTextblock) {
        const { defaultType: x } = h.parent.contentMatchAt(h.index());
        e.setNodeMarkup(g.start, x);
      }
      (y || y === 0) && e.lift(g, y);
    });
  }), !0;
}, Hq = (n) => (e) => n(e), Wq = () => ({ state: n, dispatch: e }) => Hk(n, e), Uq = (n, e) => ({ editor: t, tr: r }) => {
  const { state: i } = t, s = i.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const o = r.mapping.map(e);
  return r.insert(o, s.content), r.setSelection(new ze(r.doc.resolve(Math.max(o - 1, 0)))), !0;
}, $q = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = n.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === r.type) {
      if (e) {
        const a = i.before(s), c = i.after(s);
        n.delete(a, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Gq = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const i = Sn(n, t.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === i) {
      if (r) {
        const c = s.before(o), u = s.after(o);
        e.delete(c, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Yq = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: i } = n;
  return t && e.delete(r, i), !0;
}, qq = () => ({ state: n, dispatch: e }) => Fv(n, e), Kq = () => ({ commands: n }) => n.keyboardShortcut("Enter"), Jq = () => ({ state: n, dispatch: e }) => lq(n, e);
function cf(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => t.strict ? e[i] === n[i] : $v(e[i]) ? e[i].test(n[i]) : e[i] === n[i]) : !0;
}
function Jk(n, e, t = {}) {
  return n.find((r) => r.type === e && cf(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((i) => [i, r.attrs[i]])),
    t
  ));
}
function vA(n, e, t = {}) {
  return !!Jk(n, e, t);
}
function Gv(n, e, t) {
  var r;
  if (!n || !e)
    return;
  let i = n.parent.childAfter(n.parentOffset);
  if ((!i.node || !i.node.marks.some((f) => f.type === e)) && (i = n.parent.childBefore(n.parentOffset)), !i.node || !i.node.marks.some((f) => f.type === e) || (t = t || ((r = i.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !Jk([...i.node.marks], e, t)))
    return;
  let o = i.index, a = n.start() + i.offset, c = o + 1, u = a + i.node.nodeSize;
  for (; o > 0 && vA([...n.parent.child(o - 1).marks], e, t); )
    o -= 1, a -= n.parent.child(o).nodeSize;
  for (; c < n.parent.childCount && vA([...n.parent.child(c).marks], e, t); )
    u += n.parent.child(c).nodeSize, c += 1;
  return {
    from: a,
    to: u
  };
}
function oo(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const Qq = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const s = oo(n, r.schema), { doc: o, selection: a } = t, { $from: c, from: u, to: f } = a;
  if (i) {
    const h = Gv(c, s, e);
    if (h && h.from <= u && h.to >= f) {
      const p = ze.create(o, h.from, h.to);
      t.setSelection(p);
    }
  }
  return !0;
}, Zq = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function Qk(n) {
  return n instanceof ze;
}
function No(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function Zk(n, e = null) {
  if (!e)
    return null;
  const t = Qe.atStart(n), r = Qe.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const i = t.from, s = r.to;
  return e === "all" ? ze.create(n, No(0, i, s), No(n.content.size, i, s)) : ze.create(n, No(e, i, s), No(e, i, s));
}
function bA() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function uf() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function Xq() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
const e8 = (n = null, e = {}) => ({ editor: t, view: r, tr: i, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (uf() || bA()) && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), Xq() && !uf() && !bA() && r.dom.focus({ preventScroll: !0 }));
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (s && n === null && !Qk(t.state.selection))
    return o(), !0;
  const a = Zk(i.doc, n) || t.state.selection, c = t.state.selection.eq(a);
  return s && (c || i.setSelection(a), c && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, t8 = (n, e) => (t) => n.every((r, i) => e(r, { ...t, index: i })), n8 = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), Xk = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const r = e[t];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? n.removeChild(r) : r.nodeType === 1 && Xk(r);
  }
  return n;
};
function sd(n) {
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return Xk(t);
}
function _c(n, e, t) {
  if (n instanceof Gs || n instanceof le)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const r = typeof n == "object" && n !== null, i = typeof n == "string";
  if (r)
    try {
      if (Array.isArray(n) && n.length > 0)
        return le.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const o = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (s) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: s });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", s), _c("", e, t);
    }
  if (i) {
    if (t.errorOnInvalidContent) {
      let o = !1, a = "";
      const c = new IR({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (u) => (o = !0, a = typeof u == "string" ? u : u.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? Ys.fromSchema(c).parseSlice(sd(n), t.parseOptions) : Ys.fromSchema(c).parse(sd(n), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${a}`) });
    }
    const s = Ys.fromSchema(e);
    return t.slice ? s.parseSlice(sd(n), t.parseOptions).content : s.parse(sd(n), t.parseOptions);
  }
  return _c("", e, t);
}
function r8(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const i = n.steps[r];
  if (!(i instanceof mn || i instanceof bn))
    return;
  const s = n.mapping.maps[r];
  let o = 0;
  s.forEach((a, c, u, f) => {
    o === 0 && (o = f);
  }), n.setSelection(Qe.near(n.doc.resolve(o), t));
}
const i8 = (n) => !("type" in n), s8 = (n, e, t) => ({ tr: r, dispatch: i, editor: s }) => {
  var o;
  if (i) {
    t = {
      parseOptions: s.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    const c = (S) => {
      s.emit("contentError", {
        editor: s,
        error: S,
        disableCollaboration: () => {
          s.storage.collaboration && (s.storage.collaboration.isDisabled = !0);
        }
      });
    }, u = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !s.options.enableContentCheck && s.options.emitContentError)
      try {
        _c(e, s.schema, {
          parseOptions: u,
          errorOnInvalidContent: !0
        });
      } catch (S) {
        c(S);
      }
    try {
      a = _c(e, s.schema, {
        parseOptions: u,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) !== null && o !== void 0 ? o : s.options.enableContentCheck
      });
    } catch (S) {
      return c(S), !1;
    }
    let { from: f, to: h } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, p = !0, g = !0;
    if ((i8(a) ? a : [a]).forEach((S) => {
      S.check(), p = p ? S.isText && S.marks.length === 0 : !1, g = g ? S.isBlock : !1;
    }), f === h && g) {
      const { parent: S } = r.doc.resolve(f);
      S.isTextblock && !S.type.spec.code && !S.childCount && (f -= 1, h += 1);
    }
    let x;
    if (p) {
      if (Array.isArray(e))
        x = e.map((S) => S.text || "").join("");
      else if (e instanceof le) {
        let S = "";
        e.forEach((w) => {
          w.text && (S += w.text);
        }), x = S;
      } else typeof e == "object" && e && e.text ? x = e.text : x = e;
      r.insertText(x, f, h);
    } else
      x = a, r.replaceWith(f, h, x);
    t.updateSelection && r8(r, r.steps.length - 1, -1), t.applyInputRules && r.setMeta("applyInputRules", { from: f, text: x }), t.applyPasteRules && r.setMeta("applyPasteRules", { from: f, text: x });
  }
  return !0;
}, o8 = () => ({ state: n, dispatch: e }) => sq(n, e), a8 = () => ({ state: n, dispatch: e }) => oq(n, e), l8 = () => ({ state: n, dispatch: e }) => Pk(n, e), c8 = () => ({ state: n, dispatch: e }) => Fk(n, e), u8 = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = Xf(n.doc, n.selection.$from.pos, -1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, d8 = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = Xf(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, f8 = () => ({ state: n, dispatch: e }) => rq(n, e), h8 = () => ({ state: n, dispatch: e }) => iq(n, e);
function eM() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function p8(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a += 1) {
    const c = e[a];
    if (/^(cmd|meta|m)$/i.test(c))
      o = !0;
    else if (/^a(lt)?$/i.test(c))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      i = !0;
    else if (/^s(hift)?$/i.test(c))
      s = !0;
    else if (/^mod$/i.test(c))
      uf() || eM() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${c}`);
  }
  return r && (t = `Alt-${t}`), i && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
const m8 = (n) => ({ editor: e, view: t, tr: r, dispatch: i }) => {
  const s = p8(n).split(/-(?!$)/), o = s.find((u) => !["Alt", "Ctrl", "Meta", "Shift"].includes(u)), a = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), c = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (u) => u(t, a));
  });
  return c == null || c.steps.forEach((u) => {
    const f = u.map(r.mapping);
    f && i && r.maybeStep(f);
  }), !0;
};
function Oc(n, e, t = {}) {
  const { from: r, to: i, empty: s } = n.selection, o = e ? Sn(e, n.schema) : null, a = [];
  n.doc.nodesBetween(r, i, (h, p) => {
    if (h.isText)
      return;
    const g = Math.max(r, p), y = Math.min(i, p + h.nodeSize);
    a.push({
      node: h,
      from: g,
      to: y
    });
  });
  const c = i - r, u = a.filter((h) => o ? o.name === h.node.type.name : !0).filter((h) => cf(h.node.attrs, t, { strict: !1 }));
  return s ? !!u.length : u.reduce((h, p) => h + p.to - p.from, 0) >= c;
}
const g8 = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Sn(n, t.schema);
  return Oc(t, i, e) ? aq(t, r) : !1;
}, y8 = () => ({ state: n, dispatch: e }) => Wk(n, e), v8 = (n) => ({ state: e, dispatch: t }) => {
  const r = Sn(n, e.schema);
  return bq(r)(e, t);
}, b8 = () => ({ state: n, dispatch: e }) => Vk(n, e);
function uh(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function xA(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, i) => (t.includes(i) || (r[i] = n[i]), r), {});
}
const x8 = (n, e) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = uh(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = Sn(n, r.schema)), a === "mark" && (o = oo(n, r.schema)), i && t.selection.ranges.forEach((c) => {
    r.doc.nodesBetween(c.$from.pos, c.$to.pos, (u, f) => {
      s && s === u.type && t.setNodeMarkup(f, void 0, xA(u.attrs, e)), o && u.marks.length && u.marks.forEach((h) => {
        o === h.type && t.addMark(f, f + u.nodeSize, o.create(xA(h.attrs, e)));
      });
    });
  }), !0) : !1;
}, S8 = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), w8 = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new kr(n.doc);
    n.setSelection(t);
  }
  return !0;
}, E8 = () => ({ state: n, dispatch: e }) => Bk(n, e), A8 = () => ({ state: n, dispatch: e }) => zk(n, e), T8 = () => ({ state: n, dispatch: e }) => dq(n, e), C8 = () => ({ state: n, dispatch: e }) => pq(n, e), D8 = () => ({ state: n, dispatch: e }) => hq(n, e);
function qg(n, e, t = {}, r = {}) {
  return _c(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const R8 = (n, e = !1, t = {}, r = {}) => ({ editor: i, tr: s, dispatch: o, commands: a }) => {
  var c, u;
  const { doc: f } = s;
  if (t.preserveWhitespace !== "full") {
    const h = qg(n, i.schema, t, {
      errorOnInvalidContent: (c = r.errorOnInvalidContent) !== null && c !== void 0 ? c : i.options.enableContentCheck
    });
    return o && s.replaceWith(0, f.content.size, h).setMeta("preventUpdate", !e), !0;
  }
  return o && s.setMeta("preventUpdate", !e), a.insertContentAt({ from: 0, to: f.content.size }, n, {
    parseOptions: t,
    errorOnInvalidContent: (u = r.errorOnInvalidContent) !== null && u !== void 0 ? u : i.options.enableContentCheck
  });
};
function tM(n, e) {
  const t = oo(e, n.schema), { from: r, to: i, empty: s } = n.selection, o = [];
  s ? (n.storedMarks && o.push(...n.storedMarks), o.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, i, (c) => {
    o.push(...c.marks);
  });
  const a = o.find((c) => c.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function k8(n, e) {
  const t = new KR(n);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      t.step(i);
    });
  }), t;
}
function M8(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function _8(n, e, t) {
  const r = [];
  return n.nodesBetween(e.from, e.to, (i, s) => {
    t(i) && r.push({
      node: i,
      pos: s
    });
  }), r;
}
function O8(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function Yv(n) {
  return (e) => O8(e.$from, n);
}
function I8(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return qk(n, t, e);
}
function N8(n, e) {
  const t = Sn(e, n.schema), { from: r, to: i } = n.selection, s = [];
  n.doc.nodesBetween(r, i, (a) => {
    s.push(a);
  });
  const o = s.reverse().find((a) => a.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function nM(n, e) {
  const t = uh(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? N8(n, e) : t === "mark" ? tM(n, e) : {};
}
function P8(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(t, i) ? !1 : t[i] = !0;
  });
}
function L8(n) {
  const e = P8(n);
  return e.length === 1 ? e : e.filter((t, r) => !e.filter((s, o) => o !== r).some((s) => t.oldRange.from >= s.oldRange.from && t.oldRange.to <= s.oldRange.to && t.newRange.from >= s.newRange.from && t.newRange.to <= s.newRange.to));
}
function B8(n) {
  const { mapping: e, steps: t } = n, r = [];
  return e.maps.forEach((i, s) => {
    const o = [];
    if (i.ranges.length)
      i.forEach((a, c) => {
        o.push({ from: a, to: c });
      });
    else {
      const { from: a, to: c } = t[s];
      if (a === void 0 || c === void 0)
        return;
      o.push({ from: a, to: c });
    }
    o.forEach(({ from: a, to: c }) => {
      const u = e.slice(s).map(a, -1), f = e.slice(s).map(c), h = e.invert().map(u, -1), p = e.invert().map(f);
      r.push({
        oldRange: {
          from: h,
          to: p
        },
        newRange: {
          from: u,
          to: f
        }
      });
    });
  }), L8(r);
}
function qv(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((i) => {
    const s = t.resolve(n), o = Gv(s, i.type);
    o && r.push({
      mark: i,
      ...o
    });
  }) : t.nodesBetween(n, e, (i, s) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(...i.marks.map((o) => ({
      from: s,
      to: s + i.nodeSize,
      mark: o
    })));
  }), r;
}
function Td(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([r]) => {
    const i = n.find((s) => s.type === e && s.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function Kg(n, e, t = {}) {
  const { empty: r, ranges: i } = n.selection, s = e ? oo(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((h) => s ? s.name === h.type.name : !0).find((h) => cf(h.attrs, t, { strict: !1 }));
  let o = 0;
  const a = [];
  if (i.forEach(({ $from: h, $to: p }) => {
    const g = h.pos, y = p.pos;
    n.doc.nodesBetween(g, y, (x, S) => {
      if (!x.isText && !x.marks.length)
        return;
      const w = Math.max(g, S), C = Math.min(y, S + x.nodeSize), T = C - w;
      o += T, a.push(...x.marks.map((k) => ({
        mark: k,
        from: w,
        to: C
      })));
    });
  }), o === 0)
    return !1;
  const c = a.filter((h) => s ? s.name === h.mark.type.name : !0).filter((h) => cf(h.mark.attrs, t, { strict: !1 })).reduce((h, p) => h + p.to - p.from, 0), u = a.filter((h) => s ? h.mark.type !== s && h.mark.type.excludes(s) : !0).reduce((h, p) => h + p.to - p.from, 0);
  return (c > 0 ? c + u : c) >= o;
}
function j8(n, e, t = {}) {
  if (!e)
    return Oc(n, null, t) || Kg(n, null, t);
  const r = uh(e, n.schema);
  return r === "node" ? Oc(n, e, t) : r === "mark" ? Kg(n, e, t) : !1;
}
function SA(n, e) {
  const { nodeExtensions: t } = ah(e), r = t.find((o) => o.name === n);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, s = Xe(Te(r, "group", i));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function dh(n, { checkChildren: e = !0, ignoreWhitespace: t = !1 } = {}) {
  var r;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((r = n.text) !== null && r !== void 0 ? r : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return n.content.forEach((s) => {
      i !== !1 && (dh(s, { ignoreWhitespace: t, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function F8(n) {
  return n instanceof Me;
}
function z8(n, e, t) {
  var r;
  const { selection: i } = e;
  let s = null;
  if (Qk(i) && (s = i.$cursor), s) {
    const a = (r = n.storedMarks) !== null && r !== void 0 ? r : s.marks();
    return !!t.isInSet(a) || !a.some((c) => c.type.excludes(t));
  }
  const { ranges: o } = i;
  return o.some(({ $from: a, $to: c }) => {
    let u = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, c.pos, (f, h, p) => {
      if (u)
        return !1;
      if (f.isInline) {
        const g = !p || p.type.allowsMarkType(t), y = !!t.isInSet(f.marks) || !f.marks.some((x) => x.type.excludes(t));
        u = g && y;
      }
      return !u;
    }), u;
  });
}
const V8 = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const { selection: s } = t, { empty: o, ranges: a } = s, c = oo(n, r.schema);
  if (i)
    if (o) {
      const u = tM(r, c);
      t.addStoredMark(c.create({
        ...u,
        ...e
      }));
    } else
      a.forEach((u) => {
        const f = u.$from.pos, h = u.$to.pos;
        r.doc.nodesBetween(f, h, (p, g) => {
          const y = Math.max(g, f), x = Math.min(g + p.nodeSize, h);
          p.marks.find((w) => w.type === c) ? p.marks.forEach((w) => {
            c === w.type && t.addMark(y, x, c.create({
              ...w.attrs,
              ...e
            }));
          }) : t.addMark(y, x, c.create(e));
        });
      });
  return z8(r, t, c);
}, H8 = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), W8 = (n, e = {}) => ({ state: t, dispatch: r, chain: i }) => {
  const s = Sn(n, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), s.isTextblock ? i().command(({ commands: a }) => pA(s, { ...o, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => pA(s, { ...o, ...e })(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, U8 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, i = No(n, 0, r.content.size), s = Me.create(r, i);
    e.setSelection(s);
  }
  return !0;
}, $8 = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: i, to: s } = typeof n == "number" ? { from: n, to: n } : n, o = ze.atStart(r).from, a = ze.atEnd(r).to, c = No(i, o, a), u = No(s, o, a), f = ze.create(r, c, u);
    e.setSelection(f);
  }
  return !0;
}, G8 = (n) => ({ state: e, dispatch: t }) => {
  const r = Sn(n, e.schema);
  return wq(r)(e, t);
};
function wA(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((i) => e == null ? void 0 : e.includes(i.type.name));
    n.tr.ensureMarks(r);
  }
}
const Y8 = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: i }) => {
  const { selection: s, doc: o } = e, { $from: a, $to: c } = s, u = i.extensionManager.attributes, f = Td(u, a.node().type.name, a.node().attrs);
  if (s instanceof Me && s.node.isBlock)
    return !a.parentOffset || !rs(o, a.pos) ? !1 : (r && (n && wA(t, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const h = c.parentOffset === c.parent.content.size, p = a.depth === 0 ? void 0 : M8(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let g = h && p ? [
    {
      type: p,
      attrs: f
    }
  ] : void 0, y = rs(e.doc, e.mapping.map(a.pos), 1, g);
  if (!g && !y && rs(e.doc, e.mapping.map(a.pos), 1, p ? [{ type: p }] : void 0) && (y = !0, g = p ? [
    {
      type: p,
      attrs: f
    }
  ] : void 0), r) {
    if (y && (s instanceof ze && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, g), p && !h && !a.parentOffset && a.parent.type !== p)) {
      const x = e.mapping.map(a.before()), S = e.doc.resolve(x);
      a.node(-1).canReplaceWith(S.index(), S.index() + 1, p) && e.setNodeMarkup(e.mapping.map(a.before()), p);
    }
    n && wA(t, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return y;
}, q8 = (n, e = {}) => ({ tr: t, state: r, dispatch: i, editor: s }) => {
  var o;
  const a = Sn(n, r.schema), { $from: c, $to: u } = r.selection, f = r.selection.node;
  if (f && f.isBlock || c.depth < 2 || !c.sameParent(u))
    return !1;
  const h = c.node(-1);
  if (h.type !== a)
    return !1;
  const p = s.extensionManager.attributes;
  if (c.parent.content.size === 0 && c.node(-1).childCount === c.indexAfter(-1)) {
    if (c.depth === 2 || c.node(-3).type !== a || c.index(-2) !== c.node(-2).childCount - 1)
      return !1;
    if (i) {
      let w = le.empty;
      const C = c.index(-1) ? 1 : c.index(-2) ? 2 : 3;
      for (let B = c.depth - C; B >= c.depth - 3; B -= 1)
        w = le.from(c.node(B).copy(w));
      const T = c.indexAfter(-1) < c.node(-2).childCount ? 1 : c.indexAfter(-2) < c.node(-3).childCount ? 2 : 3, k = {
        ...Td(p, c.node().type.name, c.node().attrs),
        ...e
      }, R = ((o = a.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(k)) || void 0;
      w = w.append(le.from(a.createAndFill(null, R) || void 0));
      const P = c.before(c.depth - (C - 1));
      t.replace(P, c.after(-T), new xe(w, 4 - C, 0));
      let L = -1;
      t.doc.nodesBetween(P, t.doc.content.size, (B, W) => {
        if (L > -1)
          return !1;
        B.isTextblock && B.content.size === 0 && (L = W + 1);
      }), L > -1 && t.setSelection(ze.near(t.doc.resolve(L))), t.scrollIntoView();
    }
    return !0;
  }
  const g = u.pos === c.end() ? h.contentMatchAt(0).defaultType : null, y = {
    ...Td(p, h.type.name, h.attrs),
    ...e
  }, x = {
    ...Td(p, c.node().type.name, c.node().attrs),
    ...e
  };
  t.delete(c.pos, u.pos);
  const S = g ? [
    { type: a, attrs: y },
    { type: g, attrs: x }
  ] : [{ type: a, attrs: y }];
  if (!rs(t.doc, c.pos, 2))
    return !1;
  if (i) {
    const { selection: w, storedMarks: C } = r, { splittableMarks: T } = s.extensionManager, k = C || w.$to.parentOffset && w.$from.marks();
    if (t.split(c.pos, 2, S).scrollIntoView(), !k || !i)
      return !0;
    const R = k.filter((P) => T.includes(P.type.name));
    t.ensureMarks(R);
  }
  return !0;
}, Am = (n, e) => {
  const t = Yv((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && io(n.doc, t.pos) && n.join(t.pos), !0;
}, Tm = (n, e) => {
  const t = Yv((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === (i == null ? void 0 : i.type) && io(n.doc, r) && n.join(r), !0;
}, K8 = (n, e, t, r = {}) => ({ editor: i, tr: s, state: o, dispatch: a, chain: c, commands: u, can: f }) => {
  const { extensions: h, splittableMarks: p } = i.extensionManager, g = Sn(n, o.schema), y = Sn(e, o.schema), { selection: x, storedMarks: S } = o, { $from: w, $to: C } = x, T = w.blockRange(C), k = S || x.$to.parentOffset && x.$from.marks();
  if (!T)
    return !1;
  const R = Yv((P) => SA(P.type.name, h))(x);
  if (T.depth >= 1 && R && T.depth - R.depth <= 1) {
    if (R.node.type === g)
      return u.liftListItem(y);
    if (SA(R.node.type.name, h) && g.validContent(R.node.content) && a)
      return c().command(() => (s.setNodeMarkup(R.pos, g), !0)).command(() => Am(s, g)).command(() => Tm(s, g)).run();
  }
  return !t || !k || !a ? c().command(() => f().wrapInList(g, r) ? !0 : u.clearNodes()).wrapInList(g, r).command(() => Am(s, g)).command(() => Tm(s, g)).run() : c().command(() => {
    const P = f().wrapInList(g, r), L = k.filter((B) => p.includes(B.type.name));
    return s.ensureMarks(L), P ? !0 : u.clearNodes();
  }).wrapInList(g, r).command(() => Am(s, g)).command(() => Tm(s, g)).run();
}, J8 = (n, e = {}, t = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: s = !1 } = t, o = oo(n, r.schema);
  return Kg(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: s }) : i.setMark(o, e);
}, Q8 = (n, e, t = {}) => ({ state: r, commands: i }) => {
  const s = Sn(n, r.schema), o = Sn(e, r.schema), a = Oc(r, s, t);
  let c;
  return r.selection.$anchor.sameParent(r.selection.$head) && (c = r.selection.$anchor.parent.attrs), a ? i.setNode(o, c) : i.setNode(s, { ...c, ...t });
}, Z8 = (n, e = {}) => ({ state: t, commands: r }) => {
  const i = Sn(n, t.schema);
  return Oc(t, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, X8 = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const i = t[r];
    let s;
    if (i.spec.isInputRules && (s = i.getState(n))) {
      if (e) {
        const o = n.tr, a = s.transform;
        for (let c = a.steps.length - 1; c >= 0; c -= 1)
          o.step(a.steps[c].invert(a.docs[c]));
        if (s.text) {
          const c = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, n.schema.text(s.text, c));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, e9 = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: i } = t;
  return r || e && i.forEach((s) => {
    n.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, t9 = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: a } = t, c = oo(n, r.schema), { $from: u, empty: f, ranges: h } = a;
  if (!i)
    return !0;
  if (f && o) {
    let { from: p, to: g } = a;
    const y = (s = u.marks().find((S) => S.type === c)) === null || s === void 0 ? void 0 : s.attrs, x = Gv(u, c, y);
    x && (p = x.from, g = x.to), t.removeMark(p, g, c);
  } else
    h.forEach((p) => {
      t.removeMark(p.$from.pos, p.$to.pos, c);
    });
  return t.removeStoredMark(c), !0;
}, n9 = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = uh(typeof n == "string" ? n : n.name, r.schema);
  return a ? (a === "node" && (s = Sn(n, r.schema)), a === "mark" && (o = oo(n, r.schema)), i && t.selection.ranges.forEach((c) => {
    const u = c.$from.pos, f = c.$to.pos;
    let h, p, g, y;
    t.selection.empty ? r.doc.nodesBetween(u, f, (x, S) => {
      s && s === x.type && (g = Math.max(S, u), y = Math.min(S + x.nodeSize, f), h = S, p = x);
    }) : r.doc.nodesBetween(u, f, (x, S) => {
      S < u && s && s === x.type && (g = Math.max(S, u), y = Math.min(S + x.nodeSize, f), h = S, p = x), S >= u && S <= f && (s && s === x.type && t.setNodeMarkup(S, void 0, {
        ...x.attrs,
        ...e
      }), o && x.marks.length && x.marks.forEach((w) => {
        if (o === w.type) {
          const C = Math.max(S, u), T = Math.min(S + x.nodeSize, f);
          t.addMark(C, T, o.create({
            ...w.attrs,
            ...e
          }));
        }
      }));
    }), p && (h !== void 0 && t.setNodeMarkup(h, void 0, {
      ...p.attrs,
      ...e
    }), o && p.marks.length && p.marks.forEach((x) => {
      o === x.type && t.addMark(g, y, o.create({
        ...x.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, r9 = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Sn(n, t.schema);
  return mq(i, e)(t, r);
}, i9 = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = Sn(n, t.schema);
  return gq(i, e)(t, r);
};
var s9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: Fq,
  clearContent: zq,
  clearNodes: Vq,
  command: Hq,
  createParagraphNear: Wq,
  cut: Uq,
  deleteCurrentNode: $q,
  deleteNode: Gq,
  deleteRange: Yq,
  deleteSelection: qq,
  enter: Kq,
  exitCode: Jq,
  extendMarkRange: Qq,
  first: Zq,
  focus: e8,
  forEach: t8,
  insertContent: n8,
  insertContentAt: s8,
  joinBackward: l8,
  joinDown: a8,
  joinForward: c8,
  joinItemBackward: u8,
  joinItemForward: d8,
  joinTextblockBackward: f8,
  joinTextblockForward: h8,
  joinUp: o8,
  keyboardShortcut: m8,
  lift: g8,
  liftEmptyBlock: y8,
  liftListItem: v8,
  newlineInCode: b8,
  resetAttributes: x8,
  scrollIntoView: S8,
  selectAll: w8,
  selectNodeBackward: E8,
  selectNodeForward: A8,
  selectParentNode: T8,
  selectTextblockEnd: C8,
  selectTextblockStart: D8,
  setContent: R8,
  setMark: V8,
  setMeta: H8,
  setNode: W8,
  setNodeSelection: U8,
  setTextSelection: $8,
  sinkListItem: G8,
  splitBlock: Y8,
  splitListItem: q8,
  toggleList: K8,
  toggleMark: J8,
  toggleNode: Q8,
  toggleWrap: Z8,
  undoInputRule: X8,
  unsetAllMarks: e9,
  unsetMark: t9,
  updateAttributes: n9,
  wrapIn: r9,
  wrapInList: i9
});
const o9 = Hn.create({
  name: "commands",
  addCommands() {
    return {
      ...s9
    };
  }
}), a9 = Hn.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new En({
        key: new yr("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: r
            });
          }
        }
      })
    ];
  }
}), l9 = Hn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new En({
        key: new yr("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), c9 = new yr("focusEvents"), u9 = Hn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new En({
        key: c9,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), d9 = Hn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: a }) => {
        const { selection: c, doc: u } = a, { empty: f, $anchor: h } = c, { pos: p, parent: g } = h, y = h.parent.isTextblock && p > 0 ? a.doc.resolve(p - 1) : h, x = y.parent.type.spec.isolating, S = h.pos - h.parentOffset, w = x && y.parent.childCount === 1 ? S === h.pos : Qe.atStart(u).from === p;
        return !f || !g.type.isTextblock || g.textContent.length || !w || w && h.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, s = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return uf() || eM() ? s : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new En({
        key: new yr("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((x) => x.getMeta("composition")))
            return;
          const r = n.some((x) => x.docChanged) && !e.doc.eq(t.doc), i = n.some((x) => x.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: s, from: o, to: a } = e.selection, c = Qe.atStart(e.doc).from, u = Qe.atEnd(e.doc).to;
          if (s || !(o === c && a === u) || !dh(t.doc))
            return;
          const p = t.tr, g = sh({
            state: t,
            transaction: p
          }), { commands: y } = new oh({
            editor: this.editor,
            state: g
          });
          if (y.clearNodes(), !!p.steps.length)
            return p;
        }
      })
    ];
  }
}), f9 = Hn.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new En({
        key: new yr("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), h9 = Hn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new En({
        key: new yr("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class ko {
  get name() {
    return this.node.type.name;
  }
  constructor(e, t, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = t, this.currentNode = i;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new ko(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new ko(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new ko(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, r) => {
      const i = t.isBlock && !t.isTextblock, s = t.isAtom && !t.isText, o = this.pos + r + (s ? 0 : 1);
      if (o < 0 || o > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(o);
      if (!i && a.depth <= this.depth)
        return;
      const c = new ko(a, this.editor, i, i ? t : null);
      i && (c.actualDepth = this.depth + 1), e.push(new ko(a, this.editor, i, i ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const s = i.node.attrs, o = Object.keys(t);
          for (let a = 0; a < o.length; a += 1) {
            const c = o[a];
            if (s[c] !== t[c])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const s = Object.keys(t);
    return this.children.forEach((o) => {
      r && i.length > 0 || (o.node.type.name === e && s.every((c) => t[c] === o.node.attrs[c]) && i.push(o), !(r && i.length > 0) && (i = i.concat(o.querySelectorAll(e, t, r))));
    }), i;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}
const p9 = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function m9(n, e, t) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(i), i;
}
class g9 extends Eq {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: t }) => {
        throw t;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: t, slice: r, moved: i }) => this.options.onDrop(t, r, i)), this.on("paste", ({ event: t, slice: r }) => this.options.onPaste(t, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = m9(p9, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const r = Yk(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], i = this.state.reconfigure({ plugins: r });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let r = t;
    if ([].concat(e).forEach((s) => {
      const o = typeof s == "string" ? `${s}$` : s.key;
      r = r.filter((a) => !a.key.startsWith(o));
    }), t.length === r.length)
      return;
    const i = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const i = [...this.options.enableCoreExtensions ? [
      l9,
      jq.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      o9,
      u9,
      d9,
      h9,
      a9,
      f9
    ].filter((s) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[s.name] !== !1 : !0) : [], ...this.options.extensions].filter((s) => ["extension", "node", "mark"].includes(s == null ? void 0 : s.type));
    this.extensionManager = new za(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new oh({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let t;
    try {
      t = qg(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (o) {
      if (!(o instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(o.message))
        throw o;
      this.emit("contentError", {
        editor: this,
        error: o,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = qg(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = Zk(t, this.options.autofocus);
    this.view = new Ok(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: Fa.create({
        doc: t,
        selection: r || void 0
      })
    });
    const i = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(i), this.createNodeViews(), this.prependClass();
    const s = this.view.dom;
    s.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((o) => {
        var a;
        return (a = this.capturedTransaction) === null || a === void 0 ? void 0 : a.step(o);
      });
      return;
    }
    const t = this.state.apply(e), r = !this.state.selection.eq(t.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const i = e.getMeta("focus"), s = e.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: e
    }), s && this.emit("blur", {
      editor: this,
      event: s.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return nM(this.state, e);
  }
  isActive(e, t) {
    const r = typeof e == "string" ? e : null, i = typeof e == "string" ? t : e;
    return j8(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Uv(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: r = {} } = e || {};
    return I8(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...Kk(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return dh(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new ko(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function nl(n) {
  return new lh({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = Xe(n.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = e, o = r[r.length - 1], a = r[0];
      if (o) {
        const c = a.search(/\S/), u = t.from + a.indexOf(o), f = u + o.length;
        if (qv(t.from, t.to, e.doc).filter((g) => g.mark.type.excluded.find((x) => x === n.type && x !== g.mark.type)).filter((g) => g.to > u).length)
          return null;
        f < t.to && s.delete(f, t.to), u > t.from && s.delete(t.from + c, u);
        const p = t.from + c + o.length;
        s.addMark(t.from + c, p, n.type.create(i || {})), s.removeStoredMark(n.type);
      }
    }
  });
}
function y9(n) {
  return new lh({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = Xe(n.getAttributes, void 0, r) || {}, { tr: s } = e, o = t.from;
      let a = t.to;
      const c = n.type.create(i);
      if (r[1]) {
        const u = r[0].lastIndexOf(r[1]);
        let f = o + u;
        f > a ? f = a : a = f + r[1].length;
        const h = r[0][r[0].length - 1];
        s.insertText(h, o + r[0].length - 1), s.replaceWith(f, a, c);
      } else if (r[0]) {
        const u = n.type.isInline ? o : o - 1;
        s.insert(u, n.type.create(i)).delete(s.mapping.map(o), s.mapping.map(a));
      }
      s.scrollIntoView();
    }
  });
}
function Jg(n) {
  return new lh({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = e.doc.resolve(t.from), s = Xe(n.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, s);
    }
  });
}
function Ic(n) {
  return new lh({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: i }) => {
      const s = Xe(n.getAttributes, void 0, r) || {}, o = e.tr.delete(t.from, t.to), c = o.doc.resolve(t.from).blockRange(), u = c && Rv(c, n.type, s);
      if (!u)
        return null;
      if (o.wrap(c, u), n.keepMarks && n.editor) {
        const { selection: h, storedMarks: p } = e, { splittableMarks: g } = n.editor.extensionManager, y = p || h.$to.parentOffset && h.$from.marks();
        if (y) {
          const x = y.filter((S) => g.includes(S.type.name));
          o.ensureMarks(x);
        }
      }
      if (n.keepAttributes) {
        const h = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(h, s).run();
      }
      const f = o.doc.resolve(t.from - 1).nodeBefore;
      f && f.type === n.type && io(o.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, f)) && o.join(t.from - 1);
    }
  });
}
class gr {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Xe(Te(this, "addOptions", {
      name: this.name
    }))), this.storage = Xe(Te(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new gr(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => ch(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new gr(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Xe(Te(t, "addOptions", {
      name: t.name
    })), t.storage = Xe(Te(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function Jo(n) {
  return new Oq({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: i }) => {
      const s = Xe(n.getAttributes, void 0, r, i);
      if (s === !1 || s === null)
        return null;
      const { tr: o } = e, a = r[r.length - 1], c = r[0];
      let u = t.to;
      if (a) {
        const f = c.search(/\S/), h = t.from + c.indexOf(a), p = h + a.length;
        if (qv(t.from, t.to, e.doc).filter((y) => y.mark.type.excluded.find((S) => S === n.type && S !== y.mark.type)).filter((y) => y.to > h).length)
          return null;
        p < t.to && o.delete(p, t.to), h > t.from && o.delete(t.from + f, h), u = t.from + f + a.length, o.addMark(t.from + f, u, n.type.create(s || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
function v9(n, e) {
  const { selection: t } = n, { $from: r } = t;
  if (t instanceof Me) {
    const s = r.index();
    return r.parent.canReplaceWith(s, s + 1, e);
  }
  let i = r.depth;
  for (; i >= 0; ) {
    const s = r.index(i);
    if (r.node(i).contentMatchAt(s).matchType(e))
      return !0;
    i -= 1;
  }
  return !1;
}
const b9 = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", x9 = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Qg = "numeric", Zg = "ascii", Xg = "alpha", oc = "asciinumeric", $l = "alphanumeric", ey = "domain", rM = "emoji", S9 = "scheme", w9 = "slashscheme", Cm = "whitespace";
function E9(n, e) {
  return n in e || (e[n] = []), e[n];
}
function Po(n, e, t) {
  e[Qg] && (e[oc] = !0, e[$l] = !0), e[Zg] && (e[oc] = !0, e[Xg] = !0), e[oc] && (e[$l] = !0), e[Xg] && (e[$l] = !0), e[$l] && (e[ey] = !0), e[rM] && (e[ey] = !0);
  for (const r in e) {
    const i = E9(r, t);
    i.indexOf(n) < 0 && i.push(n);
  }
}
function A9(n, e) {
  const t = {};
  for (const r in e)
    e[r].indexOf(n) >= 0 && (t[r] = !0);
  return t;
}
function hr(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
hr.groups = {};
hr.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], s = e.jr[r][1];
      if (s && i.test(n))
        return s;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, r) {
    for (let i = 0; i < n.length; i++)
      this.tt(n[i], e, t, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, r) {
    r = r || hr.groups;
    let i;
    return e && e.j ? i = e : (i = new hr(e), t && r && Po(e, t, r)), this.jr.push([n, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, r) {
    let i = this;
    const s = n.length;
    if (!s)
      return i;
    for (let o = 0; o < s - 1; o++)
      i = i.tt(n[o]);
    return i.tt(n[s - 1], e, t, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, r) {
    r = r || hr.groups;
    const i = this;
    if (e && e.j)
      return i.j[n] = e, e;
    const s = e;
    let o, a = i.go(n);
    if (a ? (o = new hr(), Object.assign(o.j, a.j), o.jr.push.apply(o.jr, a.jr), o.jd = a.jd, o.t = a.t) : o = new hr(), s) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const c = Object.assign(A9(o.t, r), t);
          Po(s, c, r);
        } else t && Po(s, t, r);
      o.t = s;
    }
    return i.j[n] = o, o;
  }
};
const Ke = (n, e, t, r, i) => n.ta(e, t, r, i), Gt = (n, e, t, r, i) => n.tr(e, t, r, i), EA = (n, e, t, r, i) => n.ts(e, t, r, i), fe = (n, e, t, r, i) => n.tt(e, t, r, i), Qi = "WORD", ty = "UWORD", iM = "ASCIINUMERICAL", sM = "ALPHANUMERICAL", Nc = "LOCALHOST", ny = "TLD", ry = "UTLD", Cd = "SCHEME", Oa = "SLASH_SCHEME", Kv = "NUM", iy = "WS", Jv = "NL", ac = "OPENBRACE", lc = "CLOSEBRACE", df = "OPENBRACKET", ff = "CLOSEBRACKET", hf = "OPENPAREN", pf = "CLOSEPAREN", mf = "OPENANGLEBRACKET", gf = "CLOSEANGLEBRACKET", yf = "FULLWIDTHLEFTPAREN", vf = "FULLWIDTHRIGHTPAREN", bf = "LEFTCORNERBRACKET", xf = "RIGHTCORNERBRACKET", Sf = "LEFTWHITECORNERBRACKET", wf = "RIGHTWHITECORNERBRACKET", Ef = "FULLWIDTHLESSTHAN", Af = "FULLWIDTHGREATERTHAN", Tf = "AMPERSAND", Cf = "APOSTROPHE", Df = "ASTERISK", Is = "AT", Rf = "BACKSLASH", kf = "BACKTICK", Mf = "CARET", Ls = "COLON", Qv = "COMMA", _f = "DOLLAR", Ai = "DOT", Of = "EQUALS", Zv = "EXCLAMATION", Ur = "HYPHEN", cc = "PERCENT", If = "PIPE", Nf = "PLUS", Pf = "POUND", uc = "QUERY", Xv = "QUOTE", oM = "FULLWIDTHMIDDLEDOT", e0 = "SEMI", Ti = "SLASH", dc = "TILDE", Lf = "UNDERSCORE", aM = "EMOJI", Bf = "SYM";
var lM = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: sM,
  AMPERSAND: Tf,
  APOSTROPHE: Cf,
  ASCIINUMERICAL: iM,
  ASTERISK: Df,
  AT: Is,
  BACKSLASH: Rf,
  BACKTICK: kf,
  CARET: Mf,
  CLOSEANGLEBRACKET: gf,
  CLOSEBRACE: lc,
  CLOSEBRACKET: ff,
  CLOSEPAREN: pf,
  COLON: Ls,
  COMMA: Qv,
  DOLLAR: _f,
  DOT: Ai,
  EMOJI: aM,
  EQUALS: Of,
  EXCLAMATION: Zv,
  FULLWIDTHGREATERTHAN: Af,
  FULLWIDTHLEFTPAREN: yf,
  FULLWIDTHLESSTHAN: Ef,
  FULLWIDTHMIDDLEDOT: oM,
  FULLWIDTHRIGHTPAREN: vf,
  HYPHEN: Ur,
  LEFTCORNERBRACKET: bf,
  LEFTWHITECORNERBRACKET: Sf,
  LOCALHOST: Nc,
  NL: Jv,
  NUM: Kv,
  OPENANGLEBRACKET: mf,
  OPENBRACE: ac,
  OPENBRACKET: df,
  OPENPAREN: hf,
  PERCENT: cc,
  PIPE: If,
  PLUS: Nf,
  POUND: Pf,
  QUERY: uc,
  QUOTE: Xv,
  RIGHTCORNERBRACKET: xf,
  RIGHTWHITECORNERBRACKET: wf,
  SCHEME: Cd,
  SEMI: e0,
  SLASH: Ti,
  SLASH_SCHEME: Oa,
  SYM: Bf,
  TILDE: dc,
  TLD: ny,
  UNDERSCORE: Lf,
  UTLD: ry,
  UWORD: ty,
  WORD: Qi,
  WS: iy
});
const Ki = /[a-z]/, Pl = new RegExp("\\p{L}", "u"), Dm = new RegExp("\\p{Emoji}", "u"), Ji = /\d/, Rm = /\s/, AA = "\r", km = `
`, T9 = "️", C9 = "‍", Mm = "￼";
let od = null, ad = null;
function D9(n = []) {
  const e = {};
  hr.groups = e;
  const t = new hr();
  od == null && (od = TA(b9)), ad == null && (ad = TA(x9)), fe(t, "'", Cf), fe(t, "{", ac), fe(t, "}", lc), fe(t, "[", df), fe(t, "]", ff), fe(t, "(", hf), fe(t, ")", pf), fe(t, "<", mf), fe(t, ">", gf), fe(t, "（", yf), fe(t, "）", vf), fe(t, "「", bf), fe(t, "」", xf), fe(t, "『", Sf), fe(t, "』", wf), fe(t, "＜", Ef), fe(t, "＞", Af), fe(t, "&", Tf), fe(t, "*", Df), fe(t, "@", Is), fe(t, "`", kf), fe(t, "^", Mf), fe(t, ":", Ls), fe(t, ",", Qv), fe(t, "$", _f), fe(t, ".", Ai), fe(t, "=", Of), fe(t, "!", Zv), fe(t, "-", Ur), fe(t, "%", cc), fe(t, "|", If), fe(t, "+", Nf), fe(t, "#", Pf), fe(t, "?", uc), fe(t, '"', Xv), fe(t, "/", Ti), fe(t, ";", e0), fe(t, "~", dc), fe(t, "_", Lf), fe(t, "\\", Rf), fe(t, "・", oM);
  const r = Gt(t, Ji, Kv, {
    [Qg]: !0
  });
  Gt(r, Ji, r);
  const i = Gt(r, Ki, iM, {
    [oc]: !0
  }), s = Gt(r, Pl, sM, {
    [$l]: !0
  }), o = Gt(t, Ki, Qi, {
    [Zg]: !0
  });
  Gt(o, Ji, i), Gt(o, Ki, o), Gt(i, Ji, i), Gt(i, Ki, i);
  const a = Gt(t, Pl, ty, {
    [Xg]: !0
  });
  Gt(a, Ki), Gt(a, Ji, s), Gt(a, Pl, a), Gt(s, Ji, s), Gt(s, Ki), Gt(s, Pl, s);
  const c = fe(t, km, Jv, {
    [Cm]: !0
  }), u = fe(t, AA, iy, {
    [Cm]: !0
  }), f = Gt(t, Rm, iy, {
    [Cm]: !0
  });
  fe(t, Mm, f), fe(u, km, c), fe(u, Mm, f), Gt(u, Rm, f), fe(f, AA), fe(f, km), Gt(f, Rm, f), fe(f, Mm, f);
  const h = Gt(t, Dm, aM, {
    [rM]: !0
  });
  fe(h, "#"), Gt(h, Dm, h), fe(h, T9, h);
  const p = fe(h, C9);
  fe(p, "#"), Gt(p, Dm, h);
  const g = [[Ki, o], [Ji, i]], y = [[Ki, null], [Pl, a], [Ji, s]];
  for (let x = 0; x < od.length; x++)
    ks(t, od[x], ny, Qi, g);
  for (let x = 0; x < ad.length; x++)
    ks(t, ad[x], ry, ty, y);
  Po(ny, {
    tld: !0,
    ascii: !0
  }, e), Po(ry, {
    utld: !0,
    alpha: !0
  }, e), ks(t, "file", Cd, Qi, g), ks(t, "mailto", Cd, Qi, g), ks(t, "http", Oa, Qi, g), ks(t, "https", Oa, Qi, g), ks(t, "ftp", Oa, Qi, g), ks(t, "ftps", Oa, Qi, g), Po(Cd, {
    scheme: !0,
    ascii: !0
  }, e), Po(Oa, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((x, S) => x[0] > S[0] ? 1 : -1);
  for (let x = 0; x < n.length; x++) {
    const S = n[x][0], C = n[x][1] ? {
      [S9]: !0
    } : {
      [w9]: !0
    };
    S.indexOf("-") >= 0 ? C[ey] = !0 : Ki.test(S) ? Ji.test(S) ? C[oc] = !0 : C[Zg] = !0 : C[Qg] = !0, EA(t, S, S, C);
  }
  return EA(t, "localhost", Nc, {
    ascii: !0
  }), t.jd = new hr(Bf), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, lM)
  };
}
function cM(n, e) {
  const t = R9(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), r = t.length, i = [];
  let s = 0, o = 0;
  for (; o < r; ) {
    let a = n, c = null, u = 0, f = null, h = -1, p = -1;
    for (; o < r && (c = a.go(t[o])); )
      a = c, a.accepts() ? (h = 0, p = 0, f = a) : h >= 0 && (h += t[o].length, p++), u += t[o].length, s += t[o].length, o++;
    s -= h, o -= p, u -= h, i.push({
      t: f.t,
      // token type/name
      v: e.slice(s - u, s),
      // string value
      s: s - u,
      // start index
      e: s
      // end index (excluding)
    });
  }
  return i;
}
function R9(n) {
  const e = [], t = n.length;
  let r = 0;
  for (; r < t; ) {
    let i = n.charCodeAt(r), s, o = i < 55296 || i > 56319 || r + 1 === t || (s = n.charCodeAt(r + 1)) < 56320 || s > 57343 ? n[r] : n.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function ks(n, e, t, r, i) {
  let s;
  const o = e.length;
  for (let a = 0; a < o - 1; a++) {
    const c = e[a];
    n.j[c] ? s = n.j[c] : (s = new hr(r), s.jr = i.slice(), n.j[c] = s), n = s;
  }
  return s = new hr(t), s.jr = i.slice(), n.j[e[o - 1]] = s, s;
}
function TA(n) {
  const e = [], t = [];
  let r = 0, i = "0123456789";
  for (; r < n.length; ) {
    let s = 0;
    for (; i.indexOf(n[r + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(t.join(""));
      for (let o = parseInt(n.substring(r, r + s), 10); o > 0; o--)
        t.pop();
      r += s;
    } else
      t.push(n[r]), r++;
  }
  return e;
}
const Pc = {
  defaultProtocol: "http",
  events: null,
  format: CA,
  formatHref: CA,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function t0(n, e = null) {
  let t = Object.assign({}, Pc);
  n && (t = Object.assign(t, n instanceof t0 ? n.o : n));
  const r = t.ignoreTags, i = [];
  for (let s = 0; s < r.length; s++)
    i.push(r[s].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = i;
}
t0.prototype = {
  o: Pc,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const r = e != null;
    let i = this.o[n];
    return i && (typeof i == "object" ? (i = t.t in i ? i[t.t] : Pc[n], typeof i == "function" && r && (i = i(e, t))) : typeof i == "function" && r && (i = i(e, t.t, t)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let r = this.o[n];
    return typeof r == "function" && e != null && (r = r(e, t.t, t)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function CA(n) {
  return n;
}
function uM(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
uM.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), r = n.get("format", e, this);
    return t && r.length > t ? r.substring(0, t) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = Pc.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), r = n.get("formatHref", t, this), i = n.get("tagName", t, e), s = this.toFormattedString(n), o = {}, a = n.get("className", t, e), c = n.get("target", t, e), u = n.get("rel", t, e), f = n.getObj("attributes", t, e), h = n.getObj("events", t, e);
    return o.href = r, a && (o.class = a), c && (o.target = c), u && (o.rel = u), f && Object.assign(o, f), {
      tagName: i,
      attributes: o,
      content: s,
      eventListeners: h
    };
  }
};
function fh(n, e) {
  class t extends uM {
    constructor(i, s) {
      super(i, s), this.t = n;
    }
  }
  for (const r in e)
    t.prototype[r] = e[r];
  return t.t = n, t;
}
const DA = fh("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), RA = fh("text"), k9 = fh("nl"), ld = fh("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = Pc.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Nc && n[1].t === Ls;
  }
}), Hr = (n) => new hr(n);
function M9({
  groups: n
}) {
  const e = n.domain.concat([Tf, Df, Is, Rf, kf, Mf, _f, Of, Ur, Kv, cc, If, Nf, Pf, Ti, Bf, dc, Lf]), t = [Cf, Ls, Qv, Ai, Zv, cc, uc, Xv, e0, mf, gf, ac, lc, ff, df, hf, pf, yf, vf, bf, xf, Sf, wf, Ef, Af], r = [Tf, Cf, Df, Rf, kf, Mf, _f, Of, Ur, ac, lc, cc, If, Nf, Pf, uc, Ti, Bf, dc, Lf], i = Hr(), s = fe(i, dc);
  Ke(s, r, s), Ke(s, n.domain, s);
  const o = Hr(), a = Hr(), c = Hr();
  Ke(i, n.domain, o), Ke(i, n.scheme, a), Ke(i, n.slashscheme, c), Ke(o, r, s), Ke(o, n.domain, o);
  const u = fe(o, Is);
  fe(s, Is, u), fe(a, Is, u), fe(c, Is, u);
  const f = fe(s, Ai);
  Ke(f, r, s), Ke(f, n.domain, s);
  const h = Hr();
  Ke(u, n.domain, h), Ke(h, n.domain, h);
  const p = fe(h, Ai);
  Ke(p, n.domain, h);
  const g = Hr(DA);
  Ke(p, n.tld, g), Ke(p, n.utld, g), fe(u, Nc, g);
  const y = fe(h, Ur);
  fe(y, Ur, y), Ke(y, n.domain, h), Ke(g, n.domain, h), fe(g, Ai, p), fe(g, Ur, y);
  const x = fe(g, Ls);
  Ke(x, n.numeric, DA);
  const S = fe(o, Ur), w = fe(o, Ai);
  fe(S, Ur, S), Ke(S, n.domain, o), Ke(w, r, s), Ke(w, n.domain, o);
  const C = Hr(ld);
  Ke(w, n.tld, C), Ke(w, n.utld, C), Ke(C, n.domain, o), Ke(C, r, s), fe(C, Ai, w), fe(C, Ur, S), fe(C, Is, u);
  const T = fe(C, Ls), k = Hr(ld);
  Ke(T, n.numeric, k);
  const R = Hr(ld), P = Hr();
  Ke(R, e, R), Ke(R, t, P), Ke(P, e, R), Ke(P, t, P), fe(C, Ti, R), fe(k, Ti, R);
  const L = fe(a, Ls), B = fe(c, Ls), W = fe(B, Ti), X = fe(W, Ti);
  Ke(a, n.domain, o), fe(a, Ai, w), fe(a, Ur, S), Ke(c, n.domain, o), fe(c, Ai, w), fe(c, Ur, S), Ke(L, n.domain, R), fe(L, Ti, R), fe(L, uc, R), Ke(X, n.domain, R), Ke(X, e, R), fe(X, Ti, R);
  const ce = [
    [ac, lc],
    // {}
    [df, ff],
    // []
    [hf, pf],
    // ()
    [mf, gf],
    // <>
    [yf, vf],
    // （）
    [bf, xf],
    // 「」
    [Sf, wf],
    // 『』
    [Ef, Af]
    // ＜＞
  ];
  for (let Re = 0; Re < ce.length; Re++) {
    const [ke, J] = ce[Re], re = fe(R, ke);
    fe(P, ke, re), fe(re, J, R);
    const G = Hr(ld);
    Ke(re, e, G);
    const $ = Hr();
    Ke(re, t), Ke(G, e, G), Ke(G, t, $), Ke($, e, G), Ke($, t, $), fe(G, J, R), fe($, J, R);
  }
  return fe(i, Nc, C), fe(i, Jv, k9), {
    start: i,
    tokens: lM
  };
}
function _9(n, e, t) {
  let r = t.length, i = 0, s = [], o = [];
  for (; i < r; ) {
    let a = n, c = null, u = null, f = 0, h = null, p = -1;
    for (; i < r && !(c = a.go(t[i].t)); )
      o.push(t[i++]);
    for (; i < r && (u = c || a.go(t[i].t)); )
      c = null, a = u, a.accepts() ? (p = 0, h = a) : p >= 0 && p++, i++, f++;
    if (p < 0)
      i -= f, i < r && (o.push(t[i]), i++);
    else {
      o.length > 0 && (s.push(_m(RA, e, o)), o = []), i -= p, f -= p;
      const g = h.t, y = t.slice(i - f, i);
      s.push(_m(g, e, y));
    }
  }
  return o.length > 0 && s.push(_m(RA, e, o)), s;
}
function _m(n, e, t) {
  const r = t[0].s, i = t[t.length - 1].e, s = e.slice(r, i);
  return new n(s, t);
}
const O9 = typeof console < "u" && console && console.warn || (() => {
}), I9 = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", kt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function N9() {
  return hr.groups = {}, kt.scanner = null, kt.parser = null, kt.tokenQueue = [], kt.pluginQueue = [], kt.customSchemes = [], kt.initialized = !1, kt;
}
function kA(n, e = !1) {
  if (kt.initialized && O9(`linkifyjs: already initialized - will not register custom scheme "${n}" ${I9}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  kt.customSchemes.push([n, e]);
}
function P9() {
  kt.scanner = D9(kt.customSchemes);
  for (let n = 0; n < kt.tokenQueue.length; n++)
    kt.tokenQueue[n][1]({
      scanner: kt.scanner
    });
  kt.parser = M9(kt.scanner.tokens);
  for (let n = 0; n < kt.pluginQueue.length; n++)
    kt.pluginQueue[n][1]({
      scanner: kt.scanner,
      parser: kt.parser
    });
  return kt.initialized = !0, kt;
}
function n0(n) {
  return kt.initialized || P9(), _9(kt.parser.start, n, cM(kt.scanner.start, n));
}
n0.scan = cM;
function dM(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const r = new t0(t), i = n0(n), s = [];
  for (let o = 0; o < i.length; o++) {
    const a = i[o];
    a.isLink && (!e || a.t === e) && r.check(a) && s.push(a.toFormattedObject(r));
  }
  return s;
}
const r0 = "[\0-   ᠎ -\u2029 　]", L9 = new RegExp(r0), B9 = new RegExp(`${r0}$`), j9 = new RegExp(r0, "g");
function F9(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function z9(n) {
  return new En({
    key: new yr("autolink"),
    appendTransaction: (e, t, r) => {
      const i = e.some((u) => u.docChanged) && !t.doc.eq(r.doc), s = e.some((u) => u.getMeta("preventAutolink"));
      if (!i || s)
        return;
      const { tr: o } = r, a = k8(t.doc, [...e]);
      if (B8(a).forEach(({ newRange: u }) => {
        const f = _8(r.doc, u, (g) => g.isTextblock);
        let h, p;
        if (f.length > 1)
          h = f[0], p = r.doc.textBetween(h.pos, h.pos + h.node.nodeSize, void 0, " ");
        else if (f.length) {
          const g = r.doc.textBetween(u.from, u.to, " ", " ");
          if (!B9.test(g))
            return;
          h = f[0], p = r.doc.textBetween(h.pos, u.to, void 0, " ");
        }
        if (h && p) {
          const g = p.split(L9).filter(Boolean);
          if (g.length <= 0)
            return !1;
          const y = g[g.length - 1], x = h.pos + p.lastIndexOf(y);
          if (!y)
            return !1;
          const S = n0(y).map((w) => w.toObject(n.defaultProtocol));
          if (!F9(S))
            return !1;
          S.filter((w) => w.isLink).map((w) => ({
            ...w,
            from: x + w.start + 1,
            to: x + w.end + 1
          })).filter((w) => r.schema.marks.code ? !r.doc.rangeHasMark(w.from, w.to, r.schema.marks.code) : !0).filter((w) => n.validate(w.value)).filter((w) => n.shouldAutoLink(w.value)).forEach((w) => {
            qv(w.from, w.to, r.doc).some((C) => C.mark.type === n.type) || o.addMark(w.from, w.to, n.type.create({
              href: w.href
            }));
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function V9(n) {
  return new En({
    key: new yr("handleClickLink"),
    props: {
      handleClick: (e, t, r) => {
        var i, s;
        if (r.button !== 0 || !e.editable)
          return !1;
        let o = r.target;
        const a = [];
        for (; o.nodeName !== "DIV"; )
          a.push(o), o = o.parentNode;
        if (!a.find((p) => p.nodeName === "A"))
          return !1;
        const c = nM(e.state, n.type.name), u = r.target, f = (i = u == null ? void 0 : u.href) !== null && i !== void 0 ? i : c.href, h = (s = u == null ? void 0 : u.target) !== null && s !== void 0 ? s : c.target;
        return u && f ? (window.open(f, h), !0) : !1;
      }
    }
  });
}
function H9(n) {
  return new En({
    key: new yr("handlePasteLink"),
    props: {
      handlePaste: (e, t, r) => {
        const { state: i } = e, { selection: s } = i, { empty: o } = s;
        if (o)
          return !1;
        let a = "";
        r.content.forEach((u) => {
          a += u.textContent;
        });
        const c = dM(a, { defaultProtocol: n.defaultProtocol }).find((u) => u.isLink && u.value === a);
        return !a || !c ? !1 : n.editor.commands.setMark(n.type, {
          href: c.href
        });
      }
    }
  });
}
function wo(n, e) {
  const t = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && t.push(i);
  }), !n || n.replace(j9, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const W9 = Pi.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        kA(n);
        return;
      }
      kA(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    N9();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!wo(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!wo(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!wo(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", wn(this.options.HTMLAttributes, n), 0] : [
      "a",
      wn(this.options.HTMLAttributes, { ...n, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!wo(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!wo(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Jo({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: r } = this.options, i = dM(n).filter((s) => s.isLink && this.options.isAllowedUri(s.value, {
              defaultValidate: (o) => !!wo(o, t),
              protocols: t,
              defaultProtocol: r
            }));
            i.length && i.forEach((s) => e.push({
              text: s.value,
              data: {
                href: s.href
              },
              index: s.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(z9({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (r) => this.options.isAllowedUri(r, {
        defaultValidate: (i) => !!wo(i, e),
        protocols: e,
        defaultProtocol: t
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && n.push(V9({
      type: this.type
    })), this.options.linkOnPaste && n.push(H9({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), n;
  }
}), U9 = Hn.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new En({
        key: new yr("placeholder"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const t = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = e, i = [];
            if (!t)
              return null;
            const s = this.editor.isEmpty;
            return n.descendants((o, a) => {
              const c = r >= a && r <= a + o.nodeSize, u = !o.isLeaf && dh(o);
              if ((c || !this.options.showOnlyCurrent) && u) {
                const f = [this.options.emptyNodeClass];
                s && f.push(this.options.emptyEditorClass);
                const h = Dr.node(a, a + o.nodeSize, {
                  class: f.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: a,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                i.push(h);
              }
              return this.options.includeChildren;
            }), sn.create(n, i);
          }
        }
      })
    ];
  }
}), $9 = Pi.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function G9(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var sy = { exports: {} }, Om = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MA;
function Y9() {
  if (MA) return Om;
  MA = 1;
  var n = Fe;
  function e(h, p) {
    return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
  }
  var t = typeof Object.is == "function" ? Object.is : e, r = n.useState, i = n.useEffect, s = n.useLayoutEffect, o = n.useDebugValue;
  function a(h, p) {
    var g = p(), y = r({ inst: { value: g, getSnapshot: p } }), x = y[0].inst, S = y[1];
    return s(function() {
      x.value = g, x.getSnapshot = p, c(x) && S({ inst: x });
    }, [h, g, p]), i(function() {
      return c(x) && S({ inst: x }), h(function() {
        c(x) && S({ inst: x });
      });
    }, [h]), o(g), g;
  }
  function c(h) {
    var p = h.getSnapshot;
    h = h.value;
    try {
      var g = p();
      return !t(h, g);
    } catch {
      return !0;
    }
  }
  function u(h, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : a;
  return Om.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : f, Om;
}
var Im = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _A;
function q9() {
  return _A || (_A = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = Fe, e = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(T) {
      {
        for (var k = arguments.length, R = new Array(k > 1 ? k - 1 : 0), P = 1; P < k; P++)
          R[P - 1] = arguments[P];
        r("error", T, R);
      }
    }
    function r(T, k, R) {
      {
        var P = e.ReactDebugCurrentFrame, L = P.getStackAddendum();
        L !== "" && (k += "%s", R = R.concat([L]));
        var B = R.map(function(W) {
          return String(W);
        });
        B.unshift("Warning: " + k), Function.prototype.apply.call(console[T], console, B);
      }
    }
    function i(T, k) {
      return T === k && (T !== 0 || 1 / T === 1 / k) || T !== T && k !== k;
    }
    var s = typeof Object.is == "function" ? Object.is : i, o = n.useState, a = n.useEffect, c = n.useLayoutEffect, u = n.useDebugValue, f = !1, h = !1;
    function p(T, k, R) {
      f || n.startTransition !== void 0 && (f = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var P = k();
      if (!h) {
        var L = k();
        s(P, L) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), h = !0);
      }
      var B = o({
        inst: {
          value: P,
          getSnapshot: k
        }
      }), W = B[0].inst, X = B[1];
      return c(function() {
        W.value = P, W.getSnapshot = k, g(W) && X({
          inst: W
        });
      }, [T, P, k]), a(function() {
        g(W) && X({
          inst: W
        });
        var ce = function() {
          g(W) && X({
            inst: W
          });
        };
        return T(ce);
      }, [T]), u(P), P;
    }
    function g(T) {
      var k = T.getSnapshot, R = T.value;
      try {
        var P = k();
        return !s(R, P);
      } catch {
        return !0;
      }
    }
    function y(T, k, R) {
      return k();
    }
    var x = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", S = !x, w = S ? y : p, C = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : w;
    Im.useSyncExternalStore = C, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Im;
}
process.env.NODE_ENV === "production" ? sy.exports = Y9() : sy.exports = q9();
var hh = sy.exports;
const K9 = (...n) => (e) => {
  n.forEach((t) => {
    typeof t == "function" ? t(e) : t && (t.current = e);
  });
}, J9 = ({ contentComponent: n }) => {
  const e = hh.useSyncExternalStore(n.subscribe, n.getSnapshot, n.getServerSnapshot);
  return Fe.createElement(Fe.Fragment, null, Object.values(e));
};
function Q9() {
  const n = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(t) {
      return n.add(t), () => {
        n.delete(t);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(t, r) {
      e = {
        ...e,
        [t]: oB.createPortal(r.reactElement, r.element, t)
      }, n.forEach((i) => i());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(t) {
      const r = { ...e };
      delete r[t], e = r, n.forEach((i) => i());
    }
  };
}
class Z9 extends Fe.Component {
  constructor(e) {
    var t;
    super(e), this.editorContentRef = Fe.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((t = e.editor) === null || t === void 0) && t.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const t = this.editorContentRef.current;
      t.append(...e.options.element.childNodes), e.setOptions({
        element: t
      }), e.contentComponent = Q9(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((r) => r.hasContentComponentInitialized ? r : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const t = document.createElement("div");
    t.append(...e.options.element.childNodes), e.setOptions({
      element: t
    });
  }
  render() {
    const { editor: e, innerRef: t, ...r } = this.props;
    return Fe.createElement(
      Fe.Fragment,
      null,
      Fe.createElement("div", { ref: K9(t, this.editorContentRef), ...r }),
      (e == null ? void 0 : e.contentComponent) && Fe.createElement(J9, { contentComponent: e.contentComponent })
    );
  }
}
const X9 = hs((n, e) => {
  const t = Fe.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [n.editor]);
  return Fe.createElement(Z9, {
    key: t,
    innerRef: e,
    ...n
  });
});
Fe.memo(X9);
var eK = function n(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var r, i, s;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (i = r; i-- !== 0; )
        if (!n(e[i], t[i])) return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (i of e.entries())
        if (!t.has(i[0])) return !1;
      for (i of e.entries())
        if (!n(i[1], t.get(i[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (i of e.entries())
        if (!t.has(i[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (r = e.length, r != t.length) return !1;
      for (i = r; i-- !== 0; )
        if (e[i] !== t[i]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (s = Object.keys(e), r = s.length, r !== Object.keys(t).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, s[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var o = s[i];
      if (!(o === "_owner" && e.$$typeof) && !n(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}, tK = /* @__PURE__ */ G9(eK), oy = { exports: {} }, Nm = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var OA;
function nK() {
  if (OA) return Nm;
  OA = 1;
  var n = Fe, e = hh;
  function t(u, f) {
    return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
  }
  var r = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, s = n.useRef, o = n.useEffect, a = n.useMemo, c = n.useDebugValue;
  return Nm.useSyncExternalStoreWithSelector = function(u, f, h, p, g) {
    var y = s(null);
    if (y.current === null) {
      var x = { hasValue: !1, value: null };
      y.current = x;
    } else x = y.current;
    y = a(function() {
      function w(P) {
        if (!C) {
          if (C = !0, T = P, P = p(P), g !== void 0 && x.hasValue) {
            var L = x.value;
            if (g(L, P)) return k = L;
          }
          return k = P;
        }
        if (L = k, r(T, P)) return L;
        var B = p(P);
        return g !== void 0 && g(L, B) ? L : (T = P, k = B);
      }
      var C = !1, T, k, R = h === void 0 ? null : h;
      return [function() {
        return w(f());
      }, R === null ? void 0 : function() {
        return w(R());
      }];
    }, [f, h, p, g]);
    var S = i(u, y[0], y[1]);
    return o(function() {
      x.hasValue = !0, x.value = S;
    }, [S]), c(S), S;
  }, Nm;
}
var Pm = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var IA;
function rK() {
  return IA || (IA = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var n = Fe, e = hh;
    function t(f, h) {
      return f === h && (f !== 0 || 1 / f === 1 / h) || f !== f && h !== h;
    }
    var r = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, s = n.useRef, o = n.useEffect, a = n.useMemo, c = n.useDebugValue;
    function u(f, h, p, g, y) {
      var x = s(null), S;
      x.current === null ? (S = {
        hasValue: !1,
        value: null
      }, x.current = S) : S = x.current;
      var w = a(function() {
        var R = !1, P, L, B = function(Re) {
          if (!R) {
            R = !0, P = Re;
            var ke = g(Re);
            if (y !== void 0 && S.hasValue) {
              var J = S.value;
              if (y(J, ke))
                return L = J, J;
            }
            return L = ke, ke;
          }
          var re = P, G = L;
          if (r(re, Re))
            return G;
          var $ = g(Re);
          return y !== void 0 && y(G, $) ? G : (P = Re, L = $, $);
        }, W = p === void 0 ? null : p, X = function() {
          return B(h());
        }, ce = W === null ? void 0 : function() {
          return B(W());
        };
        return [X, ce];
      }, [h, p, g, y]), C = w[0], T = w[1], k = i(f, C, T);
      return o(function() {
        S.hasValue = !0, S.value = k;
      }, [k]), c(k), k;
    }
    Pm.useSyncExternalStoreWithSelector = u, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Pm;
}
process.env.NODE_ENV === "production" ? oy.exports = nK() : oy.exports = rK();
var iK = oy.exports;
const sK = typeof window < "u" ? py : St;
class oK {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const t = () => {
        this.transactionNumber += 1, this.subscribers.forEach((i) => i());
      }, r = this.editor;
      return r.on("transaction", t), () => {
        r.off("transaction", t);
      };
    }
  }
}
function aK(n) {
  var e;
  const [t] = wt(() => new oK(n.editor)), r = iK.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getServerSnapshot, n.selector, (e = n.equalityFn) !== null && e !== void 0 ? e : tK);
  return sK(() => t.watch(n.editor), [n.editor, t]), y1(r), r;
}
const NA = process.env.NODE_ENV !== "production", ay = typeof window > "u", lK = ay || !!(typeof window < "u" && window.next);
class i0 {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((t) => t());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return ay || lK ? (NA && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && ay && NA)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBeforeCreate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onBlur: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBlur) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onCreate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onDestroy: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDestroy) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onFocus: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onFocus) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onSelectionUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onSelectionUpdate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onTransaction: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onTransaction) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onUpdate) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onContentError: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onContentError) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onDrop: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDrop) === null || s === void 0 ? void 0 : s.call(i, ...r);
      },
      onPaste: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onPaste) === null || s === void 0 ? void 0 : s.call(i, ...r);
      }
    };
    return new g9(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, t) {
    return Object.keys(e).every((r) => ["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(r) ? !0 : r === "extensions" && e.extensions && t.extensions ? e.extensions.length !== t.extensions.length ? !1 : e.extensions.every((i, s) => {
      var o;
      return i === ((o = t.extensions) === null || o === void 0 ? void 0 : o[s]);
    }) : e[r] === t[r]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? i0.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((r, i) => r === e[i]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, t = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        t && t.setOptions(this.options.current);
        return;
      }
      t && !t.isDestroyed && (t.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function cK(n = {}, e = []) {
  const t = vt(n);
  t.current = n;
  const [r] = wt(() => new i0(t)), i = hh.useSyncExternalStore(r.subscribe, r.getEditor, r.getServerSnapshot);
  return y1(i), St(r.onRender(e)), aK({
    editor: i,
    selector: ({ transactionNumber: s }) => n.shouldRerenderOnTransaction === !1 ? null : n.immediatelyRender && s === 0 ? 0 : s + 1
  }), i;
}
const uK = ps({
  editor: null
});
uK.Consumer;
const dK = ps({
  onDragStart: void 0
}), fK = () => In(dK);
Fe.forwardRef((n, e) => {
  const { onDragStart: t } = fK(), r = n.as || "div";
  return (
    // @ts-ignore
    Fe.createElement(r, { ...n, ref: e, "data-node-view-wrapper": "", onDragStart: t, style: {
      whiteSpace: "normal",
      ...n.style
    } })
  );
});
const hK = /^\s*>\s$/, pK = gr.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["blockquote", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Ic({
        find: hK,
        type: this.type
      })
    ];
  }
}), mK = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, gK = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, yK = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, vK = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, bK = Pi.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      nl({
        find: mK,
        type: this.type
      }),
      nl({
        find: yK,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Jo({
        find: gK,
        type: this.type
      }),
      Jo({
        find: vK,
        type: this.type
      })
    ];
  }
}), xK = "listItem", PA = "textStyle", LA = /^\s*([-+*])\s$/, SK = gr.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(xK, this.editor.getAttributes(PA)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Ic({
      find: LA,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Ic({
      find: LA,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(PA),
      editor: this.editor
    })), [
      n
    ];
  }
}), wK = /(^|[^`])`([^`]+)`(?!`)/, EK = /(^|[^`])`([^`]+)`(?!`)/g, AK = Pi.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      nl({
        find: wK,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Jo({
        find: EK,
        type: this.type
      })
    ];
  }
}), TK = /^```([a-z]+)?[\s\n]$/, CK = /^~~~([a-z]+)?[\s\n]$/, DK = gr.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options, s = [...((e = n.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return s || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      wn(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: i } = t;
        if (!i || r.parent.type !== this.type)
          return !1;
        const s = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !s || !o ? !1 : n.chain().command(({ tr: a }) => (a.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: i, empty: s } = t;
        if (!s || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const a = i.after();
        return a === void 0 ? !1 : r.nodeAt(a) ? n.commands.command(({ tr: u }) => (u.setSelection(Qe.near(r.resolve(a))), !0)) : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Jg({
        find: TK,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      Jg({
        find: CK,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new En({
        key: new yr("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, s = i == null ? void 0 : i.mode;
            if (!t || !s)
              return !1;
            const { tr: o, schema: a } = n.state, c = a.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: s }, c)), o.selection.$from.parent.type !== this.type && o.setSelection(ze.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), n.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), RK = gr.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function kK(n = {}) {
  return new En({
    view(e) {
      return new MK(e, n);
    }
  });
}
class MK {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let s = (o) => {
        this[i](o);
      };
      return e.dom.addEventListener(i, s), { name: i, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r, i = this.editorView.dom, s = i.getBoundingClientRect(), o = s.width / i.offsetWidth, a = s.height / i.offsetHeight;
    if (t) {
      let h = e.nodeBefore, p = e.nodeAfter;
      if (h || p) {
        let g = this.editorView.nodeDOM(this.cursorPos - (h ? h.nodeSize : 0));
        if (g) {
          let y = g.getBoundingClientRect(), x = h ? y.bottom : y.top;
          h && p && (x = (x + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let S = this.width / 2 * a;
          r = { left: y.left, right: y.right, top: x - S, bottom: x + S };
        }
      }
    }
    if (!r) {
      let h = this.editorView.coordsAtPos(this.cursorPos), p = this.width / 2 * o;
      r = { left: h.left - p, right: h.left + p, top: h.top, bottom: h.bottom };
    }
    let c = this.editorView.dom.offsetParent;
    this.element || (this.element = c.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let u, f;
    if (!c || c == document.body && getComputedStyle(c).position == "static")
      u = -pageXOffset, f = -pageYOffset;
    else {
      let h = c.getBoundingClientRect(), p = h.width / c.offsetWidth, g = h.height / c.offsetHeight;
      u = h.left - c.scrollLeft * p, f = h.top - c.scrollTop * g;
    }
    this.element.style.left = (r.left - u) / o + "px", this.element.style.top = (r.top - f) / a + "px", this.element.style.width = (r.right - r.left) / o + "px", this.element.style.height = (r.bottom - r.top) / a + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), i = r && r.type.spec.disableDropCursor, s = typeof i == "function" ? i(this.editorView, t, e) : i;
    if (t && !s) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = UR(this.editorView.state.doc, o, this.editorView.dragging.slice);
        a != null && (o = a);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const _K = Hn.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      kK(this.options)
    ];
  }
});
class qt extends Qe {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return qt.valid(r) ? new qt(r) : Qe.near(r);
  }
  content() {
    return xe.empty;
  }
  eq(e) {
    return e instanceof qt && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new qt(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new s0(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !OK(e) || !IK(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = t.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, r = !1) {
    e: for (; ; ) {
      if (!r && qt.valid(e))
        return e;
      let i = e.pos, s = null;
      for (let o = e.depth; ; o--) {
        let a = e.node(o);
        if (t > 0 ? e.indexAfter(o) < a.childCount : e.index(o) > 0) {
          s = a.child(t > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        i += t;
        let c = e.doc.resolve(i);
        if (qt.valid(c))
          return c;
      }
      for (; ; ) {
        let o = t > 0 ? s.firstChild : s.lastChild;
        if (!o) {
          if (s.isAtom && !s.isText && !Me.isSelectable(s)) {
            e = e.doc.resolve(i + s.nodeSize * t), r = !1;
            continue e;
          }
          break;
        }
        s = o, i += t;
        let a = e.doc.resolve(i);
        if (qt.valid(a))
          return a;
      }
      return null;
    }
  }
}
qt.prototype.visible = !1;
qt.findFrom = qt.findGapCursorFrom;
Qe.jsonID("gapcursor", qt);
class s0 {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new s0(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return qt.valid(t) ? new qt(t) : Qe.near(t);
  }
}
function fM(n) {
  return n.isAtom || n.spec.isolating || n.spec.createGapCursor;
}
function OK(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || fM(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function IK(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || fM(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function NK() {
  return new En({
    props: {
      decorations: jK,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && qt.valid(t) ? new qt(t) : null;
      },
      handleClick: LK,
      handleKeyDown: PK,
      handleDOMEvents: { beforeinput: BK }
    }
  });
}
const PK = Ik({
  ArrowLeft: cd("horiz", -1),
  ArrowRight: cd("horiz", 1),
  ArrowUp: cd("vert", -1),
  ArrowDown: cd("vert", 1)
});
function cd(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, s) {
    let o = r.selection, a = e > 0 ? o.$to : o.$from, c = o.empty;
    if (o instanceof ze) {
      if (!s.endOfTextblock(t) || a.depth == 0)
        return !1;
      c = !1, a = r.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let u = qt.findGapCursorFrom(a, e, c);
    return u ? (i && i(r.tr.setSelection(new qt(u))), !0) : !1;
  };
}
function LK(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!qt.valid(r))
    return !1;
  let i = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return i && i.inside > -1 && Me.isSelectable(n.state.doc.nodeAt(i.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new qt(r))), !0);
}
function BK(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof qt))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = le.empty;
  for (let o = r.length - 1; o >= 0; o--)
    i = le.from(r[o].createAndFill(null, i));
  let s = n.state.tr.replace(t.pos, t.pos, new xe(i, 0, 0));
  return s.setSelection(ze.near(s.doc.resolve(t.pos + 1))), n.dispatch(s), !1;
}
function jK(n) {
  if (!(n.selection instanceof qt))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", sn.create(n.doc, [Dr.widget(n.selection.head, e, { key: "gapcursor" })]);
}
const FK = Hn.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      NK()
    ];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = Xe(Te(n, "allowGapCursor", t))) !== null && e !== void 0 ? e : null
    };
  }
}), zK = gr.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", wn(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: i, storedMarks: s } = t;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: a } = r.extensionManager, c = s || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: u, dispatch: f }) => {
            if (f && c && o) {
              const h = c.filter((p) => a.includes(p.type.name));
              u.ensureMarks(h);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), VK = gr.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, wn(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => Jg({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var jf = 200, xn = function() {
};
xn.prototype.append = function(e) {
  return e.length ? (e = xn.from(e), !this.length && e || e.length < jf && this.leafAppend(e) || this.length < jf && e.leafPrepend(this) || this.appendInner(e)) : this;
};
xn.prototype.prepend = function(e) {
  return e.length ? xn.from(e).append(this) : this;
};
xn.prototype.appendInner = function(e) {
  return new HK(this, e);
};
xn.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? xn.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
xn.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
xn.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
xn.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(s, o) {
    return i.push(e(s, o));
  }, t, r), i;
};
xn.from = function(e) {
  return e instanceof xn ? e : e && e.length ? new hM(e) : xn.empty;
};
var hM = /* @__PURE__ */ function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, s) {
    return i == 0 && s == this.length ? this : new e(this.values.slice(i, s));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, s, o, a) {
    for (var c = s; c < o; c++)
      if (i(this.values[c], a + c) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, s, o, a) {
    for (var c = s - 1; c >= o; c--)
      if (i(this.values[c], a + c) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= jf)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= jf)
      return new e(i.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(xn);
xn.empty = new hM([]);
var HK = /* @__PURE__ */ function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i < a && this.left.forEachInner(r, i, Math.min(s, a), o) === !1 || s > a && this.right.forEachInner(r, Math.max(i - a, 0), Math.min(this.length, s) - a, o + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i > a && this.right.forEachInvertedInner(r, i - a, Math.max(s, a) - a, o + a) === !1 || s < a && this.left.forEachInvertedInner(r, Math.min(i, a), s, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var s = this.left.length;
    return i <= s ? this.left.slice(r, i) : r >= s ? this.right.slice(r - s, i - s) : this.left.slice(r, s).append(this.right.slice(0, i - s));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(xn);
const WK = 500;
class ui {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, s;
    t && (i = this.remapping(r, this.items.length), s = i.maps.length);
    let o = e.tr, a, c, u = [], f = [];
    return this.items.forEach((h, p) => {
      if (!h.step) {
        i || (i = this.remapping(r, p + 1), s = i.maps.length), s--, f.push(h);
        return;
      }
      if (i) {
        f.push(new Ci(h.map));
        let g = h.step.map(i.slice(s)), y;
        g && o.maybeStep(g).doc && (y = o.mapping.maps[o.mapping.maps.length - 1], u.push(new Ci(y, void 0, void 0, u.length + f.length))), s--, y && i.appendMap(y, s);
      } else
        o.maybeStep(h.step);
      if (h.selection)
        return a = i ? h.selection.map(i.slice(s)) : h.selection, c = new ui(this.items.slice(0, r).append(f.reverse().concat(u)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: c, transform: o, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, r, i) {
    let s = [], o = this.eventCount, a = this.items, c = !i && a.length ? a.get(a.length - 1) : null;
    for (let f = 0; f < e.steps.length; f++) {
      let h = e.steps[f].invert(e.docs[f]), p = new Ci(e.mapping.maps[f], h, t), g;
      (g = c && c.merge(p)) && (p = g, f ? s.pop() : a = a.slice(0, a.length - 1)), s.push(p), t && (o++, t = void 0), i || (c = p);
    }
    let u = o - r.depth;
    return u > $K && (a = UK(a, u), o -= u), new ui(a.append(s), o);
  }
  remapping(e, t) {
    let r = new Cc();
    return this.items.forEach((i, s) => {
      let o = i.mirrorOffset != null && s - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, o);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new ui(this.items.append(e.map((t) => new Ci(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - t), s = e.mapping, o = e.steps.length, a = this.eventCount;
    this.items.forEach((p) => {
      p.selection && a--;
    }, i);
    let c = t;
    this.items.forEach((p) => {
      let g = s.getMirror(--c);
      if (g == null)
        return;
      o = Math.min(o, g);
      let y = s.maps[g];
      if (p.step) {
        let x = e.steps[g].invert(e.docs[g]), S = p.selection && p.selection.map(s.slice(c + 1, g));
        S && a++, r.push(new Ci(y, x, S));
      } else
        r.push(new Ci(y));
    }, i);
    let u = [];
    for (let p = t; p < o; p++)
      u.push(new Ci(s.maps[p]));
    let f = this.items.slice(0, i).append(u).append(r), h = new ui(f, a);
    return h.emptyItemCount() > WK && (h = h.compress(this.items.length - r.length)), h;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, i = [], s = 0;
    return this.items.forEach((o, a) => {
      if (a >= e)
        i.push(o), o.selection && s++;
      else if (o.step) {
        let c = o.step.map(t.slice(r)), u = c && c.getMap();
        if (r--, u && t.appendMap(u, r), c) {
          let f = o.selection && o.selection.map(t.slice(r));
          f && s++;
          let h = new Ci(u.invert(), c, f), p, g = i.length - 1;
          (p = i.length && i[g].merge(h)) ? i[g] = p : i.push(h);
        }
      } else o.map && r--;
    }, this.items.length, 0), new ui(xn.from(i.reverse()), s);
  }
}
ui.empty = new ui(xn.empty, 0);
function UK(n, e) {
  let t;
  return n.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return t = i, !1;
  }), n.slice(t);
}
class Ci {
  constructor(e, t, r, i) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new Ci(t.getMap().invert(), t, this.selection);
    }
  }
}
class Ns {
  constructor(e, t, r, i, s) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = i, this.prevComposition = s;
  }
}
const $K = 20;
function GK(n, e, t, r) {
  let i = t.getMeta(Ho), s;
  if (i)
    return i.historyState;
  t.getMeta(KK) && (n = new Ns(n.done, n.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (o && o.getMeta(Ho))
    return o.getMeta(Ho).redo ? new Ns(n.done.addTransform(t, void 0, r, Dd(e)), n.undone, BA(t.mapping.maps), n.prevTime, n.prevComposition) : new Ns(n.done, n.undone.addTransform(t, void 0, r, Dd(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), c = n.prevTime == 0 || !o && n.prevComposition != a && (n.prevTime < (t.time || 0) - r.newGroupDelay || !YK(t, n.prevRanges)), u = o ? Lm(n.prevRanges, t.mapping) : BA(t.mapping.maps);
    return new Ns(n.done.addTransform(t, c ? e.selection.getBookmark() : void 0, r, Dd(e)), ui.empty, u, t.time, a ?? n.prevComposition);
  } else return (s = t.getMeta("rebased")) ? new Ns(n.done.rebased(t, s), n.undone.rebased(t, s), Lm(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new Ns(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Lm(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function YK(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, i) => {
    for (let s = 0; s < e.length; s += 2)
      r <= e[s + 1] && i >= e[s] && (t = !0);
  }), t;
}
function BA(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((r, i, s, o) => e.push(s, o));
  return e;
}
function Lm(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let i = e.map(n[r], 1), s = e.map(n[r + 1], -1);
    i <= s && t.push(i, s);
  }
  return t;
}
function qK(n, e, t) {
  let r = Dd(e), i = Ho.get(e).spec.config, s = (t ? n.undone : n.done).popEvent(e, r);
  if (!s)
    return null;
  let o = s.selection.resolve(s.transform.doc), a = (t ? n.done : n.undone).addTransform(s.transform, e.selection.getBookmark(), i, r), c = new Ns(t ? a : s.remaining, t ? s.remaining : a, null, 0, -1);
  return s.transform.setSelection(o).setMeta(Ho, { redo: t, historyState: c });
}
let Bm = !1, jA = null;
function Dd(n) {
  let e = n.plugins;
  if (jA != e) {
    Bm = !1, jA = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        Bm = !0;
        break;
      }
  }
  return Bm;
}
const Ho = new yr("history"), KK = new yr("closeHistory");
function JK(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new En({
    key: Ho,
    state: {
      init() {
        return new Ns(ui.empty, ui.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return GK(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, i = r == "historyUndo" ? mM : r == "historyRedo" ? gM : null;
          return !i || !e.editable ? !1 : (t.preventDefault(), i(e.state, e.dispatch));
        }
      }
    }
  });
}
function pM(n, e) {
  return (t, r) => {
    let i = Ho.getState(t);
    if (!i || (n ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let s = qK(i, t, n);
      s && r(e ? s.scrollIntoView() : s);
    }
    return !0;
  };
}
const mM = pM(!1, !0), gM = pM(!0, !0), QK = Hn.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => mM(n, e),
      redo: () => ({ state: n, dispatch: e }) => gM(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      JK(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), ZK = gr.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", wn(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        if (!v9(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: t } = e, { $from: r, $to: i } = t, s = n();
        return r.parentOffset === 0 ? s.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: i.pos
        }, {
          type: this.name
        }) : F8(t) ? s.insertContentAt(i.pos, {
          type: this.name
        }) : s.insertContent({ type: this.name }), s.command(({ tr: o, dispatch: a }) => {
          var c;
          if (a) {
            const { $to: u } = o.selection, f = u.end();
            if (u.nodeAfter)
              u.nodeAfter.isTextblock ? o.setSelection(ze.create(o.doc, u.pos + 1)) : u.nodeAfter.isBlock ? o.setSelection(Me.create(o.doc, u.pos)) : o.setSelection(ze.create(o.doc, u.pos));
            else {
              const h = (c = u.parent.type.contentMatch.defaultType) === null || c === void 0 ? void 0 : c.create();
              h && (o.insert(f, h), o.setSelection(ze.create(o.doc, f + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      y9({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), XK = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, e7 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, t7 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, n7 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, r7 = Pi.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      nl({
        find: XK,
        type: this.type
      }),
      nl({
        find: t7,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Jo({
        find: e7,
        type: this.type
      }),
      Jo({
        find: n7,
        type: this.type
      })
    ];
  }
}), i7 = gr.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", wn(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), s7 = "listItem", FA = "textStyle", zA = /^(\d+)\.\s$/, o7 = gr.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", wn(this.options.HTMLAttributes, t), 0] : ["ol", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(s7, this.editor.getAttributes(FA)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Ic({
      find: zA,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Ic({
      find: zA,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(FA) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), a7 = gr.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), l7 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, c7 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, u7 = Pi.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", wn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      nl({
        find: l7,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Jo({
        find: c7,
        type: this.type
      })
    ];
  }
}), d7 = gr.create({
  name: "text",
  group: "inline"
}), f7 = Hn.create({
  name: "starterKit",
  addExtensions() {
    const n = [];
    return this.options.bold !== !1 && n.push(bK.configure(this.options.bold)), this.options.blockquote !== !1 && n.push(pK.configure(this.options.blockquote)), this.options.bulletList !== !1 && n.push(SK.configure(this.options.bulletList)), this.options.code !== !1 && n.push(AK.configure(this.options.code)), this.options.codeBlock !== !1 && n.push(DK.configure(this.options.codeBlock)), this.options.document !== !1 && n.push(RK.configure(this.options.document)), this.options.dropcursor !== !1 && n.push(_K.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && n.push(FK.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && n.push(zK.configure(this.options.hardBreak)), this.options.heading !== !1 && n.push(VK.configure(this.options.heading)), this.options.history !== !1 && n.push(QK.configure(this.options.history)), this.options.horizontalRule !== !1 && n.push(ZK.configure(this.options.horizontalRule)), this.options.italic !== !1 && n.push(r7.configure(this.options.italic)), this.options.listItem !== !1 && n.push(i7.configure(this.options.listItem)), this.options.orderedList !== !1 && n.push(o7.configure(this.options.orderedList)), this.options.paragraph !== !1 && n.push(a7.configure(this.options.paragraph)), this.options.strike !== !1 && n.push(u7.configure(this.options.strike)), this.options.text !== !1 && n.push(d7.configure(this.options.text)), n;
  }
});
function sQ({
  value: n,
  onChange: e,
  placeholder: t = "",
  minHeight: r = 150,
  maxHeight: i,
  readOnly: s = !1,
  label: o,
  description: a,
  error: c,
  required: u,
  showInlineControls: f = !0,
  showListControls: h = !0,
  showLinkControls: p = !0,
  showHistoryControls: g = !0,
  showHeadingControls: y = !1,
  showClearFormatting: x = !0,
  sticky: S = !1,
  stickyOffset: w
}) {
  const C = cK({
    extensions: [
      f7,
      $9,
      W9,
      U9.configure({
        placeholder: t
      })
    ],
    content: n ?? "",
    editable: !s,
    onUpdate: ({ editor: T }) => {
      e == null || e(T.getHTML());
    }
  });
  return St(() => {
    if (!C) return;
    const T = C.getHTML();
    n !== T && !C.isFocused && C.commands.setContent(n ?? "");
  }, [n, C]), St(() => {
    C && C.setEditable(!s);
  }, [s, C]), /* @__PURE__ */ b.jsx(fc.Wrapper, { label: o, description: a, error: c, required: u, children: /* @__PURE__ */ b.jsxs(
    Pt,
    {
      editor: C,
      styles: {
        root: {
          borderColor: c ? "var(--mantine-color-red-filled)" : void 0,
          overflow: "hidden",
          transition: "border-color 0.2s ease, box-shadow 0.2s ease",
          "&:focus-within": {
            borderColor: c ? "var(--mantine-color-red-filled)" : "var(--mantine-color-blue-filled)",
            boxShadow: c ? "0 0 0 1px var(--mantine-color-red-filled)" : "0 0 0 1px var(--mantine-color-blue-filled)"
          }
        },
        content: {
          "& .ProseMirror": {
            minHeight: typeof r == "number" ? `${r}px` : r,
            maxHeight: typeof i == "number" ? `${i}px` : i,
            padding: "12px",
            outline: "none"
          },
          "& .ProseMirror p.is-editor-empty:first-of-type::before": {
            color: "var(--mantine-color-gray-4)",
            content: "attr(data-placeholder)",
            float: "left",
            height: 0,
            pointerEvents: "none"
          }
        }
      },
      children: [
        !s && /* @__PURE__ */ b.jsxs(Pt.Toolbar, { sticky: S, stickyOffset: w, children: [
          f && /* @__PURE__ */ b.jsxs(Pt.ControlsGroup, { children: [
            /* @__PURE__ */ b.jsx(Pt.Bold, {}),
            /* @__PURE__ */ b.jsx(Pt.Italic, {}),
            /* @__PURE__ */ b.jsx(Pt.Underline, {}),
            /* @__PURE__ */ b.jsx(Pt.Strikethrough, {})
          ] }),
          y && /* @__PURE__ */ b.jsxs(Pt.ControlsGroup, { children: [
            /* @__PURE__ */ b.jsx(Pt.H1, {}),
            /* @__PURE__ */ b.jsx(Pt.H2, {}),
            /* @__PURE__ */ b.jsx(Pt.H3, {}),
            /* @__PURE__ */ b.jsx(Pt.H4, {})
          ] }),
          h && /* @__PURE__ */ b.jsxs(Pt.ControlsGroup, { children: [
            /* @__PURE__ */ b.jsx(Pt.BulletList, {}),
            /* @__PURE__ */ b.jsx(Pt.OrderedList, {})
          ] }),
          p && /* @__PURE__ */ b.jsxs(Pt.ControlsGroup, { children: [
            /* @__PURE__ */ b.jsx(Pt.Link, {}),
            /* @__PURE__ */ b.jsx(Pt.Unlink, {})
          ] }),
          x && /* @__PURE__ */ b.jsx(Pt.ControlsGroup, { children: /* @__PURE__ */ b.jsx(Pt.ClearFormatting, {}) }),
          g && /* @__PURE__ */ b.jsxs(Pt.ControlsGroup, { children: [
            /* @__PURE__ */ b.jsx(Pt.Undo, {}),
            /* @__PURE__ */ b.jsx(Pt.Redo, {})
          ] })
        ] }),
        /* @__PURE__ */ b.jsx(Pt.Content, {})
      ]
    }
  ) });
}
/*! @license DOMPurify 3.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.5/LICENSE */
function VA(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function h7(n) {
  if (Array.isArray(n)) return n;
}
function p7(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], c = !0, u = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(c = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (u) throw i;
      }
    }
    return a;
  }
}
function m7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g7(n, e) {
  return h7(n) || p7(n, e) || y7(n, e) || m7();
}
function y7(n, e) {
  if (n) {
    if (typeof n == "string") return VA(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? VA(n, e) : void 0;
  }
}
const yM = Object.entries, HA = Object.setPrototypeOf, v7 = Object.isFrozen, b7 = Object.getPrototypeOf, x7 = Object.getOwnPropertyDescriptor;
let rr = Object.freeze, Xr = Object.seal, Ia = Object.create, vM = typeof Reflect < "u" && Reflect, ly = vM.apply, cy = vM.construct;
rr || (rr = function(e) {
  return e;
});
Xr || (Xr = function(e) {
  return e;
});
ly || (ly = function(e, t) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++)
    i[s - 2] = arguments[s];
  return e.apply(t, i);
});
cy || (cy = function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const Ea = ln(Array.prototype.forEach), S7 = ln(Array.prototype.lastIndexOf), WA = ln(Array.prototype.pop), Aa = ln(Array.prototype.push), w7 = ln(Array.prototype.splice), Jn = Array.isArray, Gl = ln(String.prototype.toLowerCase), jm = ln(String.prototype.toString), UA = ln(String.prototype.match), Ta = ln(String.prototype.replace), $A = ln(String.prototype.indexOf), E7 = ln(String.prototype.trim), A7 = ln(Number.prototype.toString), T7 = ln(Boolean.prototype.toString), GA = typeof BigInt > "u" ? null : ln(BigInt.prototype.toString), YA = typeof Symbol > "u" ? null : ln(Symbol.prototype.toString), Yt = ln(Object.prototype.hasOwnProperty), Ll = ln(Object.prototype.toString), Rn = ln(RegExp.prototype.test), ud = C7(TypeError);
function ln(n) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
      r[i - 1] = arguments[i];
    return ly(n, e, r);
  };
}
function C7(n) {
  return function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return cy(n, t);
  };
}
function $e(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Gl;
  if (HA && HA(n, null), !Jn(e))
    return n;
  let r = e.length;
  for (; r--; ) {
    let i = e[r];
    if (typeof i == "string") {
      const s = t(i);
      s !== i && (v7(e) || (e[r] = s), i = s);
    }
    n[i] = !0;
  }
  return n;
}
function D7(n) {
  for (let e = 0; e < n.length; e++)
    Yt(n, e) || (n[e] = null);
  return n;
}
function fr(n) {
  const e = Ia(null);
  for (const r of yM(n)) {
    var t = g7(r, 2);
    const i = t[0], s = t[1];
    Yt(n, i) && (Jn(s) ? e[i] = D7(s) : s && typeof s == "object" && s.constructor === Object ? e[i] = fr(s) : e[i] = s);
  }
  return e;
}
function R7(n) {
  switch (typeof n) {
    case "string":
      return n;
    case "number":
      return A7(n);
    case "boolean":
      return T7(n);
    case "bigint":
      return GA ? GA(n) : "0";
    case "symbol":
      return YA ? YA(n) : "Symbol()";
    case "undefined":
      return Ll(n);
    case "function":
    case "object": {
      if (n === null)
        return Ll(n);
      const e = n, t = Co(e, "toString");
      if (typeof t == "function") {
        const r = t(e);
        return typeof r == "string" ? r : Ll(r);
      }
      return Ll(n);
    }
    default:
      return Ll(n);
  }
}
function Co(n, e) {
  for (; n !== null; ) {
    const r = x7(n, e);
    if (r) {
      if (r.get)
        return ln(r.get);
      if (typeof r.value == "function")
        return ln(r.value);
    }
    n = b7(n);
  }
  function t() {
    return null;
  }
  return t;
}
function k7(n) {
  try {
    return Rn(n, ""), !0;
  } catch {
    return !1;
  }
}
const qA = rr(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Fm = rr(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), zm = rr(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), M7 = rr(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Vm = rr(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), _7 = rr(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), KA = rr(["#text"]), JA = rr(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Hm = rr(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), QA = rr(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), dd = rr(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), O7 = Xr(/{{[\w\W]*|^[\w\W]*}}/g), I7 = Xr(/<%[\w\W]*|^[\w\W]*%>/g), N7 = Xr(/\${[\w\W]*/g), P7 = Xr(/^data-[\-\w.\u00B7-\uFFFF]+$/), L7 = Xr(/^aria-[\-\w]+$/), ZA = Xr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), B7 = Xr(/^(?:\w+script|data):/i), j7 = Xr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), F7 = Xr(/^html$/i), z7 = Xr(/^[a-z][.\w]*(-[.\w]+)+$/i), Ca = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, V7 = function() {
  return typeof window > "u" ? null : window;
}, H7 = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  t && t.hasAttribute(i) && (r = t.getAttribute(i));
  const s = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(s, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
}, XA = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function bM() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : V7();
  const e = (Ce) => bM(Ce);
  if (e.version = "3.4.5", e.removed = [], !n || !n.document || n.document.nodeType !== Ca.document || !n.Element)
    return e.isSupported = !1, e;
  let t = n.document;
  const r = t, i = r.currentScript, s = n.DocumentFragment, o = n.HTMLTemplateElement, a = n.Node, c = n.Element, u = n.NodeFilter, f = n.NamedNodeMap, h = f === void 0 ? n.NamedNodeMap || n.MozNamedAttrMap : f, p = n.HTMLFormElement, g = n.DOMParser, y = n.trustedTypes, x = c.prototype, S = Co(x, "cloneNode"), w = Co(x, "remove"), C = Co(x, "nextSibling"), T = Co(x, "childNodes"), k = Co(x, "parentNode"), R = a && a.prototype ? Co(a.prototype, "nodeType") : null;
  if (typeof o == "function") {
    const Ce = t.createElement("template");
    Ce.content && Ce.content.ownerDocument && (t = Ce.content.ownerDocument);
  }
  let P, L = "";
  const B = t, W = B.implementation, X = B.createNodeIterator, ce = B.createDocumentFragment, Re = B.getElementsByTagName, ke = r.importNode;
  let J = XA();
  e.isSupported = typeof yM == "function" && typeof k == "function" && W && W.createHTMLDocument !== void 0;
  const re = O7, G = I7, $ = N7, K = P7, Se = L7, z = B7, Q = j7, ge = z7;
  let me = ZA, V = null;
  const ie = $e({}, [...qA, ...Fm, ...zm, ...Vm, ...KA]);
  let q = null;
  const de = $e({}, [...JA, ...Hm, ...QA, ...dd]);
  let ee = Object.seal(Ia(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), he = null, pe = null;
  const Ee = Object.seal(Ia(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let ue = !0, et = !0, mt = !1, Kt = !0, Wt = !1, en = !0, $n = !1, _r = !1, ir = !1, Jt = !1, Pn = !1, sr = !1, Ge = !0, lt = !1;
  const vr = "user-content-";
  let _t = !0, An = !1, Gn = {}, cn = null;
  const ei = $e({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let or = null;
  const Or = $e({}, ["audio", "video", "img", "source", "image", "track"]);
  let ti = null;
  const gs = $e({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), gi = "http://www.w3.org/1998/Math/MathML", yi = "http://www.w3.org/2000/svg", Ln = "http://www.w3.org/1999/xhtml";
  let ni = Ln, Ir = !1, vi = null;
  const ys = $e({}, [gi, yi, Ln], jm);
  let vs = $e({}, ["mi", "mo", "mn", "ms", "mtext"]), ao = $e({}, ["annotation-xml"]);
  const ta = $e({}, ["title", "style", "font", "a", "script"]);
  let Bi = null;
  const lo = ["application/xhtml+xml", "text/html"], na = "text/html";
  let Bt = null, bi = null;
  const bs = t.createElement("form"), co = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, ji = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (bi && bi === _)
      return;
    (!_ || typeof _ != "object") && (_ = {}), _ = fr(_), Bi = // eslint-disable-next-line unicorn/prefer-includes
    lo.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? na : _.PARSER_MEDIA_TYPE, Bt = Bi === "application/xhtml+xml" ? jm : Gl, V = Yt(_, "ALLOWED_TAGS") && Jn(_.ALLOWED_TAGS) ? $e({}, _.ALLOWED_TAGS, Bt) : ie, q = Yt(_, "ALLOWED_ATTR") && Jn(_.ALLOWED_ATTR) ? $e({}, _.ALLOWED_ATTR, Bt) : de, vi = Yt(_, "ALLOWED_NAMESPACES") && Jn(_.ALLOWED_NAMESPACES) ? $e({}, _.ALLOWED_NAMESPACES, jm) : ys, ti = Yt(_, "ADD_URI_SAFE_ATTR") && Jn(_.ADD_URI_SAFE_ATTR) ? $e(fr(gs), _.ADD_URI_SAFE_ATTR, Bt) : gs, or = Yt(_, "ADD_DATA_URI_TAGS") && Jn(_.ADD_DATA_URI_TAGS) ? $e(fr(Or), _.ADD_DATA_URI_TAGS, Bt) : Or, cn = Yt(_, "FORBID_CONTENTS") && Jn(_.FORBID_CONTENTS) ? $e({}, _.FORBID_CONTENTS, Bt) : ei, he = Yt(_, "FORBID_TAGS") && Jn(_.FORBID_TAGS) ? $e({}, _.FORBID_TAGS, Bt) : fr({}), pe = Yt(_, "FORBID_ATTR") && Jn(_.FORBID_ATTR) ? $e({}, _.FORBID_ATTR, Bt) : fr({}), Gn = Yt(_, "USE_PROFILES") ? _.USE_PROFILES && typeof _.USE_PROFILES == "object" ? fr(_.USE_PROFILES) : _.USE_PROFILES : !1, ue = _.ALLOW_ARIA_ATTR !== !1, et = _.ALLOW_DATA_ATTR !== !1, mt = _.ALLOW_UNKNOWN_PROTOCOLS || !1, Kt = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Wt = _.SAFE_FOR_TEMPLATES || !1, en = _.SAFE_FOR_XML !== !1, $n = _.WHOLE_DOCUMENT || !1, Jt = _.RETURN_DOM || !1, Pn = _.RETURN_DOM_FRAGMENT || !1, sr = _.RETURN_TRUSTED_TYPE || !1, ir = _.FORCE_BODY || !1, Ge = _.SANITIZE_DOM !== !1, lt = _.SANITIZE_NAMED_PROPS || !1, _t = _.KEEP_CONTENT !== !1, An = _.IN_PLACE || !1, me = k7(_.ALLOWED_URI_REGEXP) ? _.ALLOWED_URI_REGEXP : ZA, ni = typeof _.NAMESPACE == "string" ? _.NAMESPACE : Ln, vs = Yt(_, "MATHML_TEXT_INTEGRATION_POINTS") && _.MATHML_TEXT_INTEGRATION_POINTS && typeof _.MATHML_TEXT_INTEGRATION_POINTS == "object" ? fr(_.MATHML_TEXT_INTEGRATION_POINTS) : $e({}, ["mi", "mo", "mn", "ms", "mtext"]), ao = Yt(_, "HTML_INTEGRATION_POINTS") && _.HTML_INTEGRATION_POINTS && typeof _.HTML_INTEGRATION_POINTS == "object" ? fr(_.HTML_INTEGRATION_POINTS) : $e({}, ["annotation-xml"]);
    const ne = Yt(_, "CUSTOM_ELEMENT_HANDLING") && _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING == "object" ? fr(_.CUSTOM_ELEMENT_HANDLING) : Ia(null);
    if (ee = Ia(null), Yt(ne, "tagNameCheck") && co(ne.tagNameCheck) && (ee.tagNameCheck = ne.tagNameCheck), Yt(ne, "attributeNameCheck") && co(ne.attributeNameCheck) && (ee.attributeNameCheck = ne.attributeNameCheck), Yt(ne, "allowCustomizedBuiltInElements") && typeof ne.allowCustomizedBuiltInElements == "boolean" && (ee.allowCustomizedBuiltInElements = ne.allowCustomizedBuiltInElements), Wt && (et = !1), Pn && (Jt = !0), Gn && (V = $e({}, KA), q = Ia(null), Gn.html === !0 && ($e(V, qA), $e(q, JA)), Gn.svg === !0 && ($e(V, Fm), $e(q, Hm), $e(q, dd)), Gn.svgFilters === !0 && ($e(V, zm), $e(q, Hm), $e(q, dd)), Gn.mathMl === !0 && ($e(V, Vm), $e(q, QA), $e(q, dd))), Ee.tagCheck = null, Ee.attributeCheck = null, Yt(_, "ADD_TAGS") && (typeof _.ADD_TAGS == "function" ? Ee.tagCheck = _.ADD_TAGS : Jn(_.ADD_TAGS) && (V === ie && (V = fr(V)), $e(V, _.ADD_TAGS, Bt))), Yt(_, "ADD_ATTR") && (typeof _.ADD_ATTR == "function" ? Ee.attributeCheck = _.ADD_ATTR : Jn(_.ADD_ATTR) && (q === de && (q = fr(q)), $e(q, _.ADD_ATTR, Bt))), Yt(_, "ADD_URI_SAFE_ATTR") && Jn(_.ADD_URI_SAFE_ATTR) && $e(ti, _.ADD_URI_SAFE_ATTR, Bt), Yt(_, "FORBID_CONTENTS") && Jn(_.FORBID_CONTENTS) && (cn === ei && (cn = fr(cn)), $e(cn, _.FORBID_CONTENTS, Bt)), Yt(_, "ADD_FORBID_CONTENTS") && Jn(_.ADD_FORBID_CONTENTS) && (cn === ei && (cn = fr(cn)), $e(cn, _.ADD_FORBID_CONTENTS, Bt)), _t && (V["#text"] = !0), $n && $e(V, ["html", "head", "body"]), V.table && ($e(V, ["tbody"]), delete he.tbody), _.TRUSTED_TYPES_POLICY) {
      if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw ud('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw ud('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      P = _.TRUSTED_TYPES_POLICY, L = P.createHTML("");
    } else
      P === void 0 && (P = H7(y, i)), P !== null && typeof L == "string" && (L = P.createHTML(""));
    rr && rr(_), bi = _;
  }, ra = $e({}, [...Fm, ...zm, ...M7]), ia = $e({}, [...Vm, ..._7]), ul = function(_) {
    let ne = k(_);
    (!ne || !ne.tagName) && (ne = {
      namespaceURI: ni,
      tagName: "template"
    });
    const ve = Gl(_.tagName), Ye = Gl(ne.tagName);
    return vi[_.namespaceURI] ? _.namespaceURI === yi ? ne.namespaceURI === Ln ? ve === "svg" : ne.namespaceURI === gi ? ve === "svg" && (Ye === "annotation-xml" || vs[Ye]) : !!ra[ve] : _.namespaceURI === gi ? ne.namespaceURI === Ln ? ve === "math" : ne.namespaceURI === yi ? ve === "math" && ao[Ye] : !!ia[ve] : _.namespaceURI === Ln ? ne.namespaceURI === yi && !ao[Ye] || ne.namespaceURI === gi && !vs[Ye] ? !1 : !ia[ve] && (ta[ve] || !ra[ve]) : !!(Bi === "application/xhtml+xml" && vi[_.namespaceURI]) : !1;
  }, O = function(_) {
    Aa(e.removed, {
      element: _
    });
    try {
      k(_).removeChild(_);
    } catch {
      w(_);
    }
  }, se = function(_, ne) {
    try {
      Aa(e.removed, {
        attribute: ne.getAttributeNode(_),
        from: ne
      });
    } catch {
      Aa(e.removed, {
        attribute: null,
        from: ne
      });
    }
    if (ne.removeAttribute(_), _ === "is")
      if (Jt || Pn)
        try {
          O(ne);
        } catch {
        }
      else
        try {
          ne.setAttribute(_, "");
        } catch {
        }
  }, be = function(_) {
    let ne = null, ve = null;
    if (ir)
      _ = "<remove></remove>" + _;
    else {
      const Ut = UA(_, /^[\r\n\t ]+/);
      ve = Ut && Ut[0];
    }
    Bi === "application/xhtml+xml" && ni === Ln && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const Ye = P ? P.createHTML(_) : _;
    if (ni === Ln)
      try {
        ne = new g().parseFromString(Ye, Bi);
      } catch {
      }
    if (!ne || !ne.documentElement) {
      ne = W.createDocument(ni, "template", null);
      try {
        ne.documentElement.innerHTML = Ir ? L : Ye;
      } catch {
      }
    }
    const jt = ne.body || ne.documentElement;
    return _ && ve && jt.insertBefore(t.createTextNode(ve), jt.childNodes[0] || null), ni === Ln ? Re.call(ne, $n ? "html" : "body")[0] : $n ? ne.documentElement : jt;
  }, Oe = function(_) {
    return X.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, rt = function(_) {
    _.normalize();
    const ne = X.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      u.SHOW_TEXT | u.SHOW_COMMENT | u.SHOW_CDATA_SECTION | u.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let ve = ne.nextNode();
    for (; ve; ) {
      let Ye = ve.data;
      Ea([re, G, $], (jt) => {
        Ye = Ta(Ye, jt, " ");
      }), ve.data = Ye, ve = ne.nextNode();
    }
  }, st = function(_) {
    return _ instanceof p && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof h) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, We = function(_) {
    if (!R || typeof _ != "object" || _ === null)
      return !1;
    try {
      return typeof R(_) == "number";
    } catch {
      return !1;
    }
  };
  function Be(Ce, _, ne) {
    Ea(Ce, (ve) => {
      ve.call(e, _, ne, bi);
    });
  }
  const tn = function(_) {
    let ne = null;
    if (Be(J.beforeSanitizeElements, _, null), st(_))
      return O(_), !0;
    const ve = Bt(_.nodeName);
    if (Be(J.uponSanitizeElement, _, {
      tagName: ve,
      allowedTags: V
    }), en && _.hasChildNodes() && !We(_.firstElementChild) && Rn(/<[/\w!]/g, _.innerHTML) && Rn(/<[/\w!]/g, _.textContent) || en && _.namespaceURI === Ln && ve === "style" && We(_.firstElementChild) || _.nodeType === Ca.progressingInstruction || en && _.nodeType === Ca.comment && Rn(/<[/\w]/g, _.data))
      return O(_), !0;
    if (he[ve] || !(Ee.tagCheck instanceof Function && Ee.tagCheck(ve)) && !V[ve]) {
      if (!he[ve] && Tn(ve) && (ee.tagNameCheck instanceof RegExp && Rn(ee.tagNameCheck, ve) || ee.tagNameCheck instanceof Function && ee.tagNameCheck(ve)))
        return !1;
      if (_t && !cn[ve]) {
        const Ye = k(_) || _.parentNode, jt = T(_) || _.childNodes;
        if (jt && Ye) {
          const Ut = jt.length;
          for (let Bn = Ut - 1; Bn >= 0; --Bn) {
            const xi = S(jt[Bn], !0);
            Ye.insertBefore(xi, C(_));
          }
        }
      }
      return O(_), !0;
    }
    return _ instanceof c && !ul(_) || (ve === "noscript" || ve === "noembed" || ve === "noframes") && Rn(/<\/no(script|embed|frames)/i, _.innerHTML) ? (O(_), !0) : (Wt && _.nodeType === Ca.text && (ne = _.textContent, Ea([re, G, $], (Ye) => {
      ne = Ta(ne, Ye, " ");
    }), _.textContent !== ne && (Aa(e.removed, {
      element: _.cloneNode()
    }), _.textContent = ne)), Be(J.afterSanitizeElements, _, null), !1);
  }, Et = function(_, ne, ve) {
    if (pe[ne] || Ge && (ne === "id" || ne === "name") && (ve in t || ve in bs))
      return !1;
    const Ye = q[ne] || Ee.attributeCheck instanceof Function && Ee.attributeCheck(ne, _);
    if (!(et && !pe[ne] && Rn(K, ne))) {
      if (!(ue && Rn(Se, ne))) {
        if (!Ye || pe[ne]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Tn(_) && (ee.tagNameCheck instanceof RegExp && Rn(ee.tagNameCheck, _) || ee.tagNameCheck instanceof Function && ee.tagNameCheck(_)) && (ee.attributeNameCheck instanceof RegExp && Rn(ee.attributeNameCheck, ne) || ee.attributeNameCheck instanceof Function && ee.attributeNameCheck(ne, _)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            ne === "is" && ee.allowCustomizedBuiltInElements && (ee.tagNameCheck instanceof RegExp && Rn(ee.tagNameCheck, ve) || ee.tagNameCheck instanceof Function && ee.tagNameCheck(ve)))
          ) return !1;
        } else if (!ti[ne]) {
          if (!Rn(me, Ta(ve, Q, ""))) {
            if (!((ne === "src" || ne === "xlink:href" || ne === "href") && _ !== "script" && $A(ve, "data:") === 0 && or[_])) {
              if (!(mt && !Rn(z, Ta(ve, Q, "")))) {
                if (ve)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Ot = $e({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Tn = function(_) {
    return !Ot[Gl(_)] && Rn(ge, _);
  }, ar = function(_) {
    Be(J.beforeSanitizeAttributes, _, null);
    const ne = _.attributes;
    if (!ne || st(_))
      return;
    const ve = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: q,
      forceKeepAttr: void 0
    };
    let Ye = ne.length;
    for (; Ye--; ) {
      const jt = ne[Ye], Ut = jt.name, Bn = jt.namespaceURI, xi = jt.value, ri = Bt(Ut), sa = xi;
      let Qt = Ut === "value" ? sa : E7(sa);
      if (ve.attrName = ri, ve.attrValue = Qt, ve.keepAttr = !0, ve.forceKeepAttr = void 0, Be(J.uponSanitizeAttribute, _, ve), Qt = ve.attrValue, lt && (ri === "id" || ri === "name") && $A(Qt, vr) !== 0 && (se(Ut, _), Qt = vr + Qt), en && Rn(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Qt)) {
        se(Ut, _);
        continue;
      }
      if (ri === "attributename" && UA(Qt, "href")) {
        se(Ut, _);
        continue;
      }
      if (ve.forceKeepAttr)
        continue;
      if (!ve.keepAttr) {
        se(Ut, _);
        continue;
      }
      if (!Kt && Rn(/\/>/i, Qt)) {
        se(Ut, _);
        continue;
      }
      Wt && Ea([re, G, $], (oa) => {
        Qt = Ta(Qt, oa, " ");
      });
      const dl = Bt(_.nodeName);
      if (!Et(dl, ri, Qt)) {
        se(Ut, _);
        continue;
      }
      if (P && typeof y == "object" && typeof y.getAttributeType == "function" && !Bn)
        switch (y.getAttributeType(dl, ri)) {
          case "TrustedHTML": {
            Qt = P.createHTML(Qt);
            break;
          }
          case "TrustedScriptURL": {
            Qt = P.createScriptURL(Qt);
            break;
          }
        }
      if (Qt !== sa)
        try {
          Bn ? _.setAttributeNS(Bn, Ut, Qt) : _.setAttribute(Ut, Qt), st(_) ? O(_) : WA(e.removed);
        } catch {
          se(Ut, _);
        }
    }
    Be(J.afterSanitizeAttributes, _, null);
  }, br = function(_) {
    let ne = null;
    const ve = Oe(_);
    for (Be(J.beforeSanitizeShadowDOM, _, null); ne = ve.nextNode(); )
      Be(J.uponSanitizeShadowNode, ne, null), tn(ne), ar(ne), ne.content instanceof s && br(ne.content);
    Be(J.afterSanitizeShadowDOM, _, null);
  }, It = function(_) {
    if (_.nodeType === Ca.element && _.shadowRoot instanceof s) {
      const Ye = _.shadowRoot;
      It(Ye), br(Ye);
    }
    const ne = _.childNodes;
    if (!ne)
      return;
    const ve = [];
    Ea(ne, (Ye) => {
      Aa(ve, Ye);
    });
    for (const Ye of ve)
      It(Ye);
  };
  return e.sanitize = function(Ce) {
    let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ne = null, ve = null, Ye = null, jt = null;
    if (Ir = !Ce, Ir && (Ce = "<!-->"), typeof Ce != "string" && !We(Ce) && (Ce = R7(Ce), typeof Ce != "string"))
      throw ud("dirty is not a string, aborting");
    if (!e.isSupported)
      return Ce;
    if (_r || ji(_), e.removed = [], typeof Ce == "string" && (An = !1), An) {
      const xi = Ce.nodeName;
      if (typeof xi == "string") {
        const ri = Bt(xi);
        if (!V[ri] || he[ri])
          throw ud("root node is forbidden and cannot be sanitized in-place");
      }
      It(Ce);
    } else if (We(Ce))
      ne = be("<!---->"), ve = ne.ownerDocument.importNode(Ce, !0), ve.nodeType === Ca.element && ve.nodeName === "BODY" || ve.nodeName === "HTML" ? ne = ve : ne.appendChild(ve), It(ve);
    else {
      if (!Jt && !Wt && !$n && // eslint-disable-next-line unicorn/prefer-includes
      Ce.indexOf("<") === -1)
        return P && sr ? P.createHTML(Ce) : Ce;
      if (ne = be(Ce), !ne)
        return Jt ? null : sr ? L : "";
    }
    ne && ir && O(ne.firstChild);
    const Ut = Oe(An ? Ce : ne);
    for (; Ye = Ut.nextNode(); )
      tn(Ye), ar(Ye), Ye.content instanceof s && br(Ye.content);
    if (An)
      return Wt && rt(Ce), Ce;
    if (Jt) {
      if (Wt && rt(ne), Pn)
        for (jt = ce.call(ne.ownerDocument); ne.firstChild; )
          jt.appendChild(ne.firstChild);
      else
        jt = ne;
      return (q.shadowroot || q.shadowrootmode) && (jt = ke.call(r, jt, !0)), jt;
    }
    let Bn = $n ? ne.outerHTML : ne.innerHTML;
    return $n && V["!doctype"] && ne.ownerDocument && ne.ownerDocument.doctype && ne.ownerDocument.doctype.name && Rn(F7, ne.ownerDocument.doctype.name) && (Bn = "<!DOCTYPE " + ne.ownerDocument.doctype.name + `>
` + Bn), Wt && Ea([re, G, $], (xi) => {
      Bn = Ta(Bn, xi, " ");
    }), P && sr ? P.createHTML(Bn) : Bn;
  }, e.setConfig = function() {
    let Ce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ji(Ce), _r = !0;
  }, e.clearConfig = function() {
    bi = null, _r = !1;
  }, e.isValidAttribute = function(Ce, _, ne) {
    bi || ji({});
    const ve = Bt(Ce), Ye = Bt(_);
    return Et(ve, Ye, ne);
  }, e.addHook = function(Ce, _) {
    typeof _ == "function" && Aa(J[Ce], _);
  }, e.removeHook = function(Ce, _) {
    if (_ !== void 0) {
      const ne = S7(J[Ce], _);
      return ne === -1 ? void 0 : w7(J[Ce], ne, 1)[0];
    }
    return WA(J[Ce]);
  }, e.removeHooks = function(Ce) {
    J[Ce] = [];
  }, e.removeAllHooks = function() {
    J = XA();
  }, e;
}
var W7 = bM();
const U7 = {
  USE_PROFILES: { html: !0 },
  ALLOW_DATA_ATTR: !1,
  FORBID_TAGS: [
    "button",
    "embed",
    "form",
    "iframe",
    "img",
    "input",
    "link",
    "meta",
    "object",
    "script",
    "select",
    "style",
    "textarea"
  ],
  FORBID_ATTR: ["style", "srcset"]
};
function oQ({ html: n, emptyFallback: e = null, ...t }) {
  const r = Vt(() => W7.sanitize(n, U7), [n]);
  return r.trim() ? /* @__PURE__ */ b.jsx(
    "div",
    {
      ...t,
      dangerouslySetInnerHTML: { __html: r }
    }
  ) : /* @__PURE__ */ b.jsx("div", { ...t, children: e });
}
function aQ({
  children: n,
  minWidth: e = 800,
  page: t,
  onPageChange: r,
  limit: i,
  onLimitChange: s,
  total: o,
  limitOptions: a = [
    { label: "10개씩 보기", value: "10" },
    { label: "20개씩 보기", value: "20" },
    { label: "50개씩 보기", value: "50" }
  ]
}) {
  const c = Math.ceil(o / i);
  return /* @__PURE__ */ b.jsxs("div", { children: [
    /* @__PURE__ */ b.jsx(Je.ScrollContainer, { minWidth: e, children: n }),
    c > 0 && /* @__PURE__ */ b.jsxs(je, { justify: "space-between", mt: "lg", gap: "md", wrap: "wrap", children: [
      /* @__PURE__ */ b.jsx(
        fy,
        {
          value: String(i),
          onChange: (u) => {
            u && (s(Number(u)), r(1));
          },
          data: a,
          style: { width: 148 },
          allowDeselect: !1
        }
      ),
      /* @__PURE__ */ b.jsx(_2, { total: c, value: t, onChange: r })
    ] })
  ] });
}
function e1(n) {
  const e = (n == null ? void 0 : n.releasedAt) ?? (n == null ? void 0 : n.createdAt);
  if (!e) return (n == null ? void 0 : n.version) ?? "확인 중";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? (n == null ? void 0 : n.version) ?? "확인 중" : new Intl.DateTimeFormat("ko-KR", {
    year: "numeric",
    month: "long",
    day: "numeric"
  }).format(t);
}
function lQ({
  opened: n,
  loading: e,
  terms: t,
  termsLoading: r = !1,
  serviceTermsHref: i = "/terms/service",
  marketingTermsHref: s = "/terms/marketing-info",
  onCancel: o,
  onSubmit: a
}) {
  const [c, u] = wt(!1), [f, h] = wt(!1), p = t == null ? void 0 : t.service, g = t == null ? void 0 : t.marketing, y = !!(p && g), x = e || r;
  St(() => {
    n || (u(!1), h(!1));
  }, [n]);
  const S = c && f, w = (C) => {
    u(C), h(C);
  };
  return /* @__PURE__ */ b.jsx(
    f1,
    {
      opened: n,
      onClose: o,
      size: "md",
      centered: !0,
      closeOnClickOutside: !e,
      closeOnEscape: !e,
      withCloseButton: !e,
      styles: {
        header: {
          display: "none"
        },
        content: {
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)"
        },
        body: {
          padding: 0
        }
      },
      children: /* @__PURE__ */ b.jsxs(at, { gap: "xl", children: [
        /* @__PURE__ */ b.jsxs(gt, { ta: "center", pt: "md", children: [
          /* @__PURE__ */ b.jsx(
            d1,
            {
              size: 56,
              radius: "xl",
              variant: "gradient",
              gradient: { from: "blue.4", to: "blue.7", deg: 135 },
              mb: "md",
              children: /* @__PURE__ */ b.jsx(BW, { size: 32, stroke: 1.5 })
            }
          ),
          /* @__PURE__ */ b.jsx(ae, { size: "xl", fw: 700, c: "gray.9", mb: "xs", children: "약관에 동의해주세요" }),
          /* @__PURE__ */ b.jsx(ae, { size: "sm", c: "gray.5", style: { maxWidth: 300, margin: "0 auto" }, children: "DutyOn 서비스의 안전한 이용을 위해 필수 및 선택 약관에 대한 확인이 필요합니다." })
        ] }),
        /* @__PURE__ */ b.jsxs(at, { gap: "sm", children: [
          /* @__PURE__ */ b.jsx(
            er,
            {
              withBorder: !0,
              p: "md",
              radius: "md",
              style: {
                backgroundColor: S ? "#f1f3f5" : "#f8f9fa",
                borderColor: S ? "#339af0" : "#dee2e6",
                cursor: "pointer",
                transition: "all 0.2s ease"
              },
              onClick: () => w(!S),
              children: /* @__PURE__ */ b.jsx(je, { justify: "space-between", wrap: "nowrap", children: /* @__PURE__ */ b.jsxs(je, { gap: "sm", children: [
                /* @__PURE__ */ b.jsx(
                  Yl,
                  {
                    checked: S,
                    onChange: (C) => w(C.currentTarget.checked),
                    onClick: (C) => C.stopPropagation(),
                    styles: { input: { cursor: "pointer" } }
                  }
                ),
                /* @__PURE__ */ b.jsxs(gt, { children: [
                  /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 700, c: "gray.8", children: "약관 전체 동의" }),
                  /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "gray.5", children: "필수 이용약관 및 선택 마케팅 수신동의에 모두 동의합니다." })
                ] })
              ] }) })
            }
          ),
          /* @__PURE__ */ b.jsx(er, { withBorder: !0, p: "md", radius: "md", style: { borderColor: "#e9ecef" }, children: /* @__PURE__ */ b.jsxs(at, { gap: "md", children: [
            /* @__PURE__ */ b.jsxs(je, { justify: "space-between", wrap: "nowrap", align: "center", children: [
              /* @__PURE__ */ b.jsxs(je, { gap: "sm", style: { flex: 1 }, children: [
                /* @__PURE__ */ b.jsx(
                  Yl,
                  {
                    checked: c,
                    onChange: (C) => u(C.currentTarget.checked),
                    styles: { input: { cursor: "pointer" } }
                  }
                ),
                /* @__PURE__ */ b.jsxs(gt, { children: [
                  /* @__PURE__ */ b.jsxs(je, { gap: "xs", mb: 2, children: [
                    /* @__PURE__ */ b.jsx(on, { size: "xs", color: "blue", variant: "filled", children: "필수" }),
                    /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 600, c: "gray.8", children: (p == null ? void 0 : p.title) ?? "서비스 이용약관 동의" })
                  ] }),
                  /* @__PURE__ */ b.jsxs(ae, { size: "xs", c: "gray.5", children: [
                    "시행일자: ",
                    e1(p)
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ b.jsxs(
                Cx,
                {
                  href: i,
                  target: "_blank",
                  rel: "noreferrer",
                  c: "blue",
                  size: "xs",
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: 600
                  },
                  children: [
                    "전문보기",
                    /* @__PURE__ */ b.jsx(HS, { size: 14 })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ b.jsxs(je, { justify: "space-between", wrap: "nowrap", align: "center", children: [
              /* @__PURE__ */ b.jsxs(je, { gap: "sm", style: { flex: 1 }, children: [
                /* @__PURE__ */ b.jsx(
                  Yl,
                  {
                    checked: f,
                    onChange: (C) => h(C.currentTarget.checked),
                    styles: { input: { cursor: "pointer" } }
                  }
                ),
                /* @__PURE__ */ b.jsxs(gt, { children: [
                  /* @__PURE__ */ b.jsxs(je, { gap: "xs", mb: 2, children: [
                    /* @__PURE__ */ b.jsx(on, { size: "xs", color: "gray", variant: "outline", children: "선택" }),
                    /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 600, c: "gray.8", children: (g == null ? void 0 : g.title) ?? "마케팅 정보 수신 동의" })
                  ] }),
                  /* @__PURE__ */ b.jsxs(ae, { size: "xs", c: "gray.5", children: [
                    "시행일자: ",
                    e1(g)
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ b.jsxs(
                Cx,
                {
                  href: s,
                  target: "_blank",
                  rel: "noreferrer",
                  c: "blue",
                  size: "xs",
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: 600
                  },
                  children: [
                    "전문보기",
                    /* @__PURE__ */ b.jsx(HS, { size: 14 })
                  ]
                }
              )
            ] })
          ] }) })
        ] }),
        /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "gray.5", ta: "center", children: "마케팅 동의를 거부하셔도 서비스 이용이 가능하며, 마이페이지 설정에서 언제든 동의를 철회할 수 있습니다." }),
        /* @__PURE__ */ b.jsxs(je, { gap: "sm", grow: !0, children: [
          /* @__PURE__ */ b.jsx(hn, { variant: "default", onClick: o, disabled: e, radius: "md", size: "md", children: "취소" }),
          /* @__PURE__ */ b.jsx(
            hn,
            {
              onClick: () => {
                !p || !g || a({
                  serviceTermsAccepted: !0,
                  serviceTermsVersion: p.version,
                  marketingConsent: f,
                  marketingTermsVersion: g.version
                });
              },
              disabled: !c || !y,
              loading: x,
              radius: "md",
              size: "md",
              variant: "filled",
              children: "동의하고 계속"
            }
          )
        ] })
      ] })
    }
  );
}
function cQ({
  title: n,
  description: e,
  rightSection: t,
  children: r,
  fluid: i = !0,
  p: s = "md",
  pos: o = "relative",
  minHeight: a = "calc(100dvh - 160px)",
  style: c,
  ...u
}) {
  return /* @__PURE__ */ b.jsxs(
    uy,
    {
      fluid: i,
      p: s,
      pos: o,
      style: [
        {
          minHeight: a
        },
        c
      ],
      ...u,
      children: [
        /* @__PURE__ */ b.jsxs(je, { justify: "space-between", align: "flex-start", wrap: "wrap", gap: "md", mb: "lg", children: [
          /* @__PURE__ */ b.jsxs(gt, { style: { flex: "1 1 280px", minWidth: 0 }, children: [
            typeof n == "string" ? /* @__PURE__ */ b.jsx(Ya, { order: 2, style: { lineHeight: 1.2, wordBreak: "keep-all" }, children: n }) : n,
            e && (typeof e == "string" ? /* @__PURE__ */ b.jsx(ae, { size: "sm", c: "dimmed", mt: 4, children: e }) : e)
          ] }),
          t && /* @__PURE__ */ b.jsx(
            gt,
            {
              style: {
                display: "flex",
                flex: "0 1 auto",
                justifyContent: "flex-end",
                maxWidth: "100%",
                minWidth: 0
              },
              children: t
            }
          )
        ] }),
        r
      ]
    }
  );
}
const Wm = "dutyon-turnstile-api", $7 = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let Bl;
function G7() {
  return window.turnstile ? Promise.resolve(window.turnstile) : Bl || (Bl = new Promise((n, e) => {
    const t = document.getElementById(Wm), r = t instanceof HTMLScriptElement ? t : document.createElement("script"), i = () => {
      if (window.turnstile) {
        n(window.turnstile);
        return;
      }
      e(new Error("Turnstile API를 초기화하지 못했습니다."));
    }, s = () => e(new Error("Turnstile API를 불러오지 못했습니다."));
    r.addEventListener("load", i, { once: !0 }), r.addEventListener("error", s, { once: !0 }), t || (r.id = Wm, r.src = $7, r.async = !0, r.defer = !0, document.head.appendChild(r));
  }).catch((n) => {
    var e;
    throw Bl = void 0, (e = document.getElementById(Wm)) == null || e.remove(), n;
  }), Bl);
}
function uQ({
  siteKey: n,
  action: e,
  required: t,
  onTokenChange: r
}) {
  const i = vt(null), [s, o] = wt(null), [a, c] = wt(!1);
  return St(() => {
    if (!n) {
      r(null);
      return;
    }
    let u = !1, f;
    return o(null), c(!1), r(null), G7().then((h) => {
      u || !i.current || (f = h.render(i.current, {
        sitekey: n,
        action: e,
        language: "ko",
        theme: "auto",
        size: "flexible",
        callback: (p) => {
          u || (o(null), c(!0), r(p));
        },
        "error-callback": () => (u || (c(!1), o("자동화 방지 확인에 실패했습니다. 잠시 후 다시 시도해 주세요."), r(null)), !0),
        "expired-callback": () => {
          u || (c(!1), o("자동화 방지 확인 시간이 만료되었습니다. 다시 확인해 주세요."), r(null));
        },
        "timeout-callback": () => {
          u || (c(!1), o("자동화 방지 확인 시간이 초과되었습니다. 다시 시도해 주세요."), r(null));
        }
      }));
    }).catch(() => {
      u || (o("자동화 방지 화면을 불러오지 못했습니다. 네트워크를 확인해 주세요."), r(null));
    }), () => {
      u = !0, f && window.turnstile && window.turnstile.remove(f);
    };
  }, [e, r, n]), n ? /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
    /* @__PURE__ */ b.jsx("div", { ref: i }),
    !s && !a && /* @__PURE__ */ b.jsx(ae, { size: "sm", c: "dimmed", ta: "center", "aria-live": "polite", children: "자동화 방지 확인을 준비하고 있습니다." }),
    s && /* @__PURE__ */ b.jsx(Us, { color: "red", title: "자동화 방지 확인 실패", "aria-live": "assertive", children: s })
  ] }) : t ? /* @__PURE__ */ b.jsx(Us, { color: "red", title: "자동화 방지 설정 오류", children: "공개 신청을 사용할 수 없습니다. 관리자에게 문의해 주세요." }) : null;
}
var Ff = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Ff.exports;
(function(n, e) {
  (function() {
    var t, r = "4.17.23", i = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", a = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", u = 500, f = "__lodash_placeholder__", h = 1, p = 2, g = 4, y = 1, x = 2, S = 1, w = 2, C = 4, T = 8, k = 16, R = 32, P = 64, L = 128, B = 256, W = 512, X = 30, ce = "...", Re = 800, ke = 16, J = 1, re = 2, G = 3, $ = 1 / 0, K = 9007199254740991, Se = 17976931348623157e292, z = NaN, Q = 4294967295, ge = Q - 1, me = Q >>> 1, V = [
      ["ary", L],
      ["bind", S],
      ["bindKey", w],
      ["curry", T],
      ["curryRight", k],
      ["flip", W],
      ["partial", R],
      ["partialRight", P],
      ["rearg", B]
    ], ie = "[object Arguments]", q = "[object Array]", de = "[object AsyncFunction]", ee = "[object Boolean]", he = "[object Date]", pe = "[object DOMException]", Ee = "[object Error]", ue = "[object Function]", et = "[object GeneratorFunction]", mt = "[object Map]", Kt = "[object Number]", Wt = "[object Null]", en = "[object Object]", $n = "[object Promise]", _r = "[object Proxy]", ir = "[object RegExp]", Jt = "[object Set]", Pn = "[object String]", sr = "[object Symbol]", Ge = "[object Undefined]", lt = "[object WeakMap]", vr = "[object WeakSet]", _t = "[object ArrayBuffer]", An = "[object DataView]", Gn = "[object Float32Array]", cn = "[object Float64Array]", ei = "[object Int8Array]", or = "[object Int16Array]", Or = "[object Int32Array]", ti = "[object Uint8Array]", gs = "[object Uint8ClampedArray]", gi = "[object Uint16Array]", yi = "[object Uint32Array]", Ln = /\b__p \+= '';/g, ni = /\b(__p \+=) '' \+/g, Ir = /(__e\(.*?\)|\b__t\)) \+\n'';/g, vi = /&(?:amp|lt|gt|quot|#39);/g, ys = /[&<>"']/g, vs = RegExp(vi.source), ao = RegExp(ys.source), ta = /<%-([\s\S]+?)%>/g, Bi = /<%([\s\S]+?)%>/g, lo = /<%=([\s\S]+?)%>/g, na = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Bt = /^\w*$/, bi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, bs = /[\\^$.*+?()[\]{}|]/g, co = RegExp(bs.source), ji = /^\s+/, ra = /\s/, ia = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ul = /\{\n\/\* \[wrapped with (.+)\] \*/, O = /,? & /, se = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, be = /[()=,{}\[\]\/\s]/, Oe = /\\(\\)?/g, rt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, st = /\w*$/, We = /^[-+]0x[0-9a-f]+$/i, Be = /^0b[01]+$/i, tn = /^\[object .+?Constructor\]$/, Et = /^0o[0-7]+$/i, Ot = /^(?:0|[1-9]\d*)$/, Tn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ar = /($^)/, br = /['\n\r\u2028\u2029\\]/g, It = "\\ud800-\\udfff", Ce = "\\u0300-\\u036f", _ = "\\ufe20-\\ufe2f", ne = "\\u20d0-\\u20ff", ve = Ce + _ + ne, Ye = "\\u2700-\\u27bf", jt = "a-z\\xdf-\\xf6\\xf8-\\xff", Ut = "\\xac\\xb1\\xd7\\xf7", Bn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", xi = "\\u2000-\\u206f", ri = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", sa = "A-Z\\xc0-\\xd6\\xd8-\\xde", Qt = "\\ufe0e\\ufe0f", dl = Ut + Bn + xi + ri, oa = "['’]", DM = "[" + It + "]", o0 = "[" + dl + "]", Jc = "[" + ve + "]", a0 = "\\d+", RM = "[" + Ye + "]", l0 = "[" + jt + "]", c0 = "[^" + It + dl + a0 + Ye + jt + sa + "]", ph = "\\ud83c[\\udffb-\\udfff]", kM = "(?:" + Jc + "|" + ph + ")", u0 = "[^" + It + "]", mh = "(?:\\ud83c[\\udde6-\\uddff]){2}", gh = "[\\ud800-\\udbff][\\udc00-\\udfff]", aa = "[" + sa + "]", d0 = "\\u200d", f0 = "(?:" + l0 + "|" + c0 + ")", MM = "(?:" + aa + "|" + c0 + ")", h0 = "(?:" + oa + "(?:d|ll|m|re|s|t|ve))?", p0 = "(?:" + oa + "(?:D|LL|M|RE|S|T|VE))?", m0 = kM + "?", g0 = "[" + Qt + "]?", _M = "(?:" + d0 + "(?:" + [u0, mh, gh].join("|") + ")" + g0 + m0 + ")*", OM = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", IM = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", y0 = g0 + m0 + _M, NM = "(?:" + [RM, mh, gh].join("|") + ")" + y0, PM = "(?:" + [u0 + Jc + "?", Jc, mh, gh, DM].join("|") + ")", LM = RegExp(oa, "g"), BM = RegExp(Jc, "g"), yh = RegExp(ph + "(?=" + ph + ")|" + PM + y0, "g"), jM = RegExp([
      aa + "?" + l0 + "+" + h0 + "(?=" + [o0, aa, "$"].join("|") + ")",
      MM + "+" + p0 + "(?=" + [o0, aa + f0, "$"].join("|") + ")",
      aa + "?" + f0 + "+" + h0,
      aa + "+" + p0,
      IM,
      OM,
      a0,
      NM
    ].join("|"), "g"), FM = RegExp("[" + d0 + It + ve + Qt + "]"), zM = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, VM = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], HM = -1, Rt = {};
    Rt[Gn] = Rt[cn] = Rt[ei] = Rt[or] = Rt[Or] = Rt[ti] = Rt[gs] = Rt[gi] = Rt[yi] = !0, Rt[ie] = Rt[q] = Rt[_t] = Rt[ee] = Rt[An] = Rt[he] = Rt[Ee] = Rt[ue] = Rt[mt] = Rt[Kt] = Rt[en] = Rt[ir] = Rt[Jt] = Rt[Pn] = Rt[lt] = !1;
    var At = {};
    At[ie] = At[q] = At[_t] = At[An] = At[ee] = At[he] = At[Gn] = At[cn] = At[ei] = At[or] = At[Or] = At[mt] = At[Kt] = At[en] = At[ir] = At[Jt] = At[Pn] = At[sr] = At[ti] = At[gs] = At[gi] = At[yi] = !0, At[Ee] = At[ue] = At[lt] = !1;
    var WM = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, UM = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, $M = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, GM = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, YM = parseFloat, qM = parseInt, v0 = typeof Ra == "object" && Ra && Ra.Object === Object && Ra, KM = typeof self == "object" && self && self.Object === Object && self, Cn = v0 || KM || Function("return this")(), vh = e && !e.nodeType && e, uo = vh && !0 && n && !n.nodeType && n, b0 = uo && uo.exports === vh, bh = b0 && v0.process, Nr = function() {
      try {
        var j = uo && uo.require && uo.require("util").types;
        return j || bh && bh.binding && bh.binding("util");
      } catch {
      }
    }(), x0 = Nr && Nr.isArrayBuffer, S0 = Nr && Nr.isDate, w0 = Nr && Nr.isMap, E0 = Nr && Nr.isRegExp, A0 = Nr && Nr.isSet, T0 = Nr && Nr.isTypedArray;
    function xr(j, Y, H) {
      switch (H.length) {
        case 0:
          return j.call(Y);
        case 1:
          return j.call(Y, H[0]);
        case 2:
          return j.call(Y, H[0], H[1]);
        case 3:
          return j.call(Y, H[0], H[1], H[2]);
      }
      return j.apply(Y, H);
    }
    function JM(j, Y, H, we) {
      for (var Ve = -1, ct = j == null ? 0 : j.length; ++Ve < ct; ) {
        var un = j[Ve];
        Y(we, un, H(un), j);
      }
      return we;
    }
    function Pr(j, Y) {
      for (var H = -1, we = j == null ? 0 : j.length; ++H < we && Y(j[H], H, j) !== !1; )
        ;
      return j;
    }
    function QM(j, Y) {
      for (var H = j == null ? 0 : j.length; H-- && Y(j[H], H, j) !== !1; )
        ;
      return j;
    }
    function C0(j, Y) {
      for (var H = -1, we = j == null ? 0 : j.length; ++H < we; )
        if (!Y(j[H], H, j))
          return !1;
      return !0;
    }
    function xs(j, Y) {
      for (var H = -1, we = j == null ? 0 : j.length, Ve = 0, ct = []; ++H < we; ) {
        var un = j[H];
        Y(un, H, j) && (ct[Ve++] = un);
      }
      return ct;
    }
    function Qc(j, Y) {
      var H = j == null ? 0 : j.length;
      return !!H && la(j, Y, 0) > -1;
    }
    function xh(j, Y, H) {
      for (var we = -1, Ve = j == null ? 0 : j.length; ++we < Ve; )
        if (H(Y, j[we]))
          return !0;
      return !1;
    }
    function Nt(j, Y) {
      for (var H = -1, we = j == null ? 0 : j.length, Ve = Array(we); ++H < we; )
        Ve[H] = Y(j[H], H, j);
      return Ve;
    }
    function Ss(j, Y) {
      for (var H = -1, we = Y.length, Ve = j.length; ++H < we; )
        j[Ve + H] = Y[H];
      return j;
    }
    function Sh(j, Y, H, we) {
      var Ve = -1, ct = j == null ? 0 : j.length;
      for (we && ct && (H = j[++Ve]); ++Ve < ct; )
        H = Y(H, j[Ve], Ve, j);
      return H;
    }
    function ZM(j, Y, H, we) {
      var Ve = j == null ? 0 : j.length;
      for (we && Ve && (H = j[--Ve]); Ve--; )
        H = Y(H, j[Ve], Ve, j);
      return H;
    }
    function wh(j, Y) {
      for (var H = -1, we = j == null ? 0 : j.length; ++H < we; )
        if (Y(j[H], H, j))
          return !0;
      return !1;
    }
    var XM = Eh("length");
    function e_(j) {
      return j.split("");
    }
    function t_(j) {
      return j.match(se) || [];
    }
    function D0(j, Y, H) {
      var we;
      return H(j, function(Ve, ct, un) {
        if (Y(Ve, ct, un))
          return we = ct, !1;
      }), we;
    }
    function Zc(j, Y, H, we) {
      for (var Ve = j.length, ct = H + (we ? 1 : -1); we ? ct-- : ++ct < Ve; )
        if (Y(j[ct], ct, j))
          return ct;
      return -1;
    }
    function la(j, Y, H) {
      return Y === Y ? h_(j, Y, H) : Zc(j, R0, H);
    }
    function n_(j, Y, H, we) {
      for (var Ve = H - 1, ct = j.length; ++Ve < ct; )
        if (we(j[Ve], Y))
          return Ve;
      return -1;
    }
    function R0(j) {
      return j !== j;
    }
    function k0(j, Y) {
      var H = j == null ? 0 : j.length;
      return H ? Th(j, Y) / H : z;
    }
    function Eh(j) {
      return function(Y) {
        return Y == null ? t : Y[j];
      };
    }
    function Ah(j) {
      return function(Y) {
        return j == null ? t : j[Y];
      };
    }
    function M0(j, Y, H, we, Ve) {
      return Ve(j, function(ct, un, yt) {
        H = we ? (we = !1, ct) : Y(H, ct, un, yt);
      }), H;
    }
    function r_(j, Y) {
      var H = j.length;
      for (j.sort(Y); H--; )
        j[H] = j[H].value;
      return j;
    }
    function Th(j, Y) {
      for (var H, we = -1, Ve = j.length; ++we < Ve; ) {
        var ct = Y(j[we]);
        ct !== t && (H = H === t ? ct : H + ct);
      }
      return H;
    }
    function Ch(j, Y) {
      for (var H = -1, we = Array(j); ++H < j; )
        we[H] = Y(H);
      return we;
    }
    function i_(j, Y) {
      return Nt(Y, function(H) {
        return [H, j[H]];
      });
    }
    function _0(j) {
      return j && j.slice(0, P0(j) + 1).replace(ji, "");
    }
    function Sr(j) {
      return function(Y) {
        return j(Y);
      };
    }
    function Dh(j, Y) {
      return Nt(Y, function(H) {
        return j[H];
      });
    }
    function fl(j, Y) {
      return j.has(Y);
    }
    function O0(j, Y) {
      for (var H = -1, we = j.length; ++H < we && la(Y, j[H], 0) > -1; )
        ;
      return H;
    }
    function I0(j, Y) {
      for (var H = j.length; H-- && la(Y, j[H], 0) > -1; )
        ;
      return H;
    }
    function s_(j, Y) {
      for (var H = j.length, we = 0; H--; )
        j[H] === Y && ++we;
      return we;
    }
    var o_ = Ah(WM), a_ = Ah(UM);
    function l_(j) {
      return "\\" + GM[j];
    }
    function c_(j, Y) {
      return j == null ? t : j[Y];
    }
    function ca(j) {
      return FM.test(j);
    }
    function u_(j) {
      return zM.test(j);
    }
    function d_(j) {
      for (var Y, H = []; !(Y = j.next()).done; )
        H.push(Y.value);
      return H;
    }
    function Rh(j) {
      var Y = -1, H = Array(j.size);
      return j.forEach(function(we, Ve) {
        H[++Y] = [Ve, we];
      }), H;
    }
    function N0(j, Y) {
      return function(H) {
        return j(Y(H));
      };
    }
    function ws(j, Y) {
      for (var H = -1, we = j.length, Ve = 0, ct = []; ++H < we; ) {
        var un = j[H];
        (un === Y || un === f) && (j[H] = f, ct[Ve++] = H);
      }
      return ct;
    }
    function Xc(j) {
      var Y = -1, H = Array(j.size);
      return j.forEach(function(we) {
        H[++Y] = we;
      }), H;
    }
    function f_(j) {
      var Y = -1, H = Array(j.size);
      return j.forEach(function(we) {
        H[++Y] = [we, we];
      }), H;
    }
    function h_(j, Y, H) {
      for (var we = H - 1, Ve = j.length; ++we < Ve; )
        if (j[we] === Y)
          return we;
      return -1;
    }
    function p_(j, Y, H) {
      for (var we = H + 1; we--; )
        if (j[we] === Y)
          return we;
      return we;
    }
    function ua(j) {
      return ca(j) ? g_(j) : XM(j);
    }
    function ii(j) {
      return ca(j) ? y_(j) : e_(j);
    }
    function P0(j) {
      for (var Y = j.length; Y-- && ra.test(j.charAt(Y)); )
        ;
      return Y;
    }
    var m_ = Ah($M);
    function g_(j) {
      for (var Y = yh.lastIndex = 0; yh.test(j); )
        ++Y;
      return Y;
    }
    function y_(j) {
      return j.match(yh) || [];
    }
    function v_(j) {
      return j.match(jM) || [];
    }
    var b_ = function j(Y) {
      Y = Y == null ? Cn : da.defaults(Cn.Object(), Y, da.pick(Cn, VM));
      var H = Y.Array, we = Y.Date, Ve = Y.Error, ct = Y.Function, un = Y.Math, yt = Y.Object, kh = Y.RegExp, x_ = Y.String, Lr = Y.TypeError, eu = H.prototype, S_ = ct.prototype, fa = yt.prototype, tu = Y["__core-js_shared__"], nu = S_.toString, ut = fa.hasOwnProperty, w_ = 0, L0 = function() {
        var l = /[^.]+$/.exec(tu && tu.keys && tu.keys.IE_PROTO || "");
        return l ? "Symbol(src)_1." + l : "";
      }(), ru = fa.toString, E_ = nu.call(yt), A_ = Cn._, T_ = kh(
        "^" + nu.call(ut).replace(bs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), iu = b0 ? Y.Buffer : t, Es = Y.Symbol, su = Y.Uint8Array, B0 = iu ? iu.allocUnsafe : t, ou = N0(yt.getPrototypeOf, yt), j0 = yt.create, F0 = fa.propertyIsEnumerable, au = eu.splice, z0 = Es ? Es.isConcatSpreadable : t, hl = Es ? Es.iterator : t, fo = Es ? Es.toStringTag : t, lu = function() {
        try {
          var l = yo(yt, "defineProperty");
          return l({}, "", {}), l;
        } catch {
        }
      }(), C_ = Y.clearTimeout !== Cn.clearTimeout && Y.clearTimeout, D_ = we && we.now !== Cn.Date.now && we.now, R_ = Y.setTimeout !== Cn.setTimeout && Y.setTimeout, cu = un.ceil, uu = un.floor, Mh = yt.getOwnPropertySymbols, k_ = iu ? iu.isBuffer : t, V0 = Y.isFinite, M_ = eu.join, __ = N0(yt.keys, yt), dn = un.max, jn = un.min, O_ = we.now, I_ = Y.parseInt, H0 = un.random, N_ = eu.reverse, _h = yo(Y, "DataView"), pl = yo(Y, "Map"), Oh = yo(Y, "Promise"), ha = yo(Y, "Set"), ml = yo(Y, "WeakMap"), gl = yo(yt, "create"), du = ml && new ml(), pa = {}, P_ = vo(_h), L_ = vo(pl), B_ = vo(Oh), j_ = vo(ha), F_ = vo(ml), fu = Es ? Es.prototype : t, yl = fu ? fu.valueOf : t, W0 = fu ? fu.toString : t;
      function A(l) {
        if ($t(l) && !He(l) && !(l instanceof nt)) {
          if (l instanceof Br)
            return l;
          if (ut.call(l, "__wrapped__"))
            return Ub(l);
        }
        return new Br(l);
      }
      var ma = /* @__PURE__ */ function() {
        function l() {
        }
        return function(d) {
          if (!Ft(d))
            return {};
          if (j0)
            return j0(d);
          l.prototype = d;
          var m = new l();
          return l.prototype = t, m;
        };
      }();
      function hu() {
      }
      function Br(l, d) {
        this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = t;
      }
      A.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: ta,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Bi,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: lo,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: A
        }
      }, A.prototype = hu.prototype, A.prototype.constructor = A, Br.prototype = ma(hu.prototype), Br.prototype.constructor = Br;
      function nt(l) {
        this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function z_() {
        var l = new nt(this.__wrapped__);
        return l.__actions__ = lr(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = lr(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = lr(this.__views__), l;
      }
      function V_() {
        if (this.__filtered__) {
          var l = new nt(this);
          l.__dir__ = -1, l.__filtered__ = !0;
        } else
          l = this.clone(), l.__dir__ *= -1;
        return l;
      }
      function H_() {
        var l = this.__wrapped__.value(), d = this.__dir__, m = He(l), v = d < 0, E = m ? l.length : 0, D = eI(0, E, this.__views__), M = D.start, N = D.end, F = N - M, Z = v ? N : M - 1, te = this.__iteratees__, oe = te.length, ye = 0, De = jn(F, this.__takeCount__);
        if (!m || !v && E == F && De == F)
          return hb(l, this.__actions__);
        var Pe = [];
        e:
          for (; F-- && ye < De; ) {
            Z += d;
            for (var qe = -1, Le = l[Z]; ++qe < oe; ) {
              var tt = te[qe], it = tt.iteratee, Ar = tt.type, Kn = it(Le);
              if (Ar == re)
                Le = Kn;
              else if (!Kn) {
                if (Ar == J)
                  continue e;
                break e;
              }
            }
            Pe[ye++] = Le;
          }
        return Pe;
      }
      nt.prototype = ma(hu.prototype), nt.prototype.constructor = nt;
      function ho(l) {
        var d = -1, m = l == null ? 0 : l.length;
        for (this.clear(); ++d < m; ) {
          var v = l[d];
          this.set(v[0], v[1]);
        }
      }
      function W_() {
        this.__data__ = gl ? gl(null) : {}, this.size = 0;
      }
      function U_(l) {
        var d = this.has(l) && delete this.__data__[l];
        return this.size -= d ? 1 : 0, d;
      }
      function $_(l) {
        var d = this.__data__;
        if (gl) {
          var m = d[l];
          return m === c ? t : m;
        }
        return ut.call(d, l) ? d[l] : t;
      }
      function G_(l) {
        var d = this.__data__;
        return gl ? d[l] !== t : ut.call(d, l);
      }
      function Y_(l, d) {
        var m = this.__data__;
        return this.size += this.has(l) ? 0 : 1, m[l] = gl && d === t ? c : d, this;
      }
      ho.prototype.clear = W_, ho.prototype.delete = U_, ho.prototype.get = $_, ho.prototype.has = G_, ho.prototype.set = Y_;
      function Fi(l) {
        var d = -1, m = l == null ? 0 : l.length;
        for (this.clear(); ++d < m; ) {
          var v = l[d];
          this.set(v[0], v[1]);
        }
      }
      function q_() {
        this.__data__ = [], this.size = 0;
      }
      function K_(l) {
        var d = this.__data__, m = pu(d, l);
        if (m < 0)
          return !1;
        var v = d.length - 1;
        return m == v ? d.pop() : au.call(d, m, 1), --this.size, !0;
      }
      function J_(l) {
        var d = this.__data__, m = pu(d, l);
        return m < 0 ? t : d[m][1];
      }
      function Q_(l) {
        return pu(this.__data__, l) > -1;
      }
      function Z_(l, d) {
        var m = this.__data__, v = pu(m, l);
        return v < 0 ? (++this.size, m.push([l, d])) : m[v][1] = d, this;
      }
      Fi.prototype.clear = q_, Fi.prototype.delete = K_, Fi.prototype.get = J_, Fi.prototype.has = Q_, Fi.prototype.set = Z_;
      function zi(l) {
        var d = -1, m = l == null ? 0 : l.length;
        for (this.clear(); ++d < m; ) {
          var v = l[d];
          this.set(v[0], v[1]);
        }
      }
      function X_() {
        this.size = 0, this.__data__ = {
          hash: new ho(),
          map: new (pl || Fi)(),
          string: new ho()
        };
      }
      function eO(l) {
        var d = Cu(this, l).delete(l);
        return this.size -= d ? 1 : 0, d;
      }
      function tO(l) {
        return Cu(this, l).get(l);
      }
      function nO(l) {
        return Cu(this, l).has(l);
      }
      function rO(l, d) {
        var m = Cu(this, l), v = m.size;
        return m.set(l, d), this.size += m.size == v ? 0 : 1, this;
      }
      zi.prototype.clear = X_, zi.prototype.delete = eO, zi.prototype.get = tO, zi.prototype.has = nO, zi.prototype.set = rO;
      function po(l) {
        var d = -1, m = l == null ? 0 : l.length;
        for (this.__data__ = new zi(); ++d < m; )
          this.add(l[d]);
      }
      function iO(l) {
        return this.__data__.set(l, c), this;
      }
      function sO(l) {
        return this.__data__.has(l);
      }
      po.prototype.add = po.prototype.push = iO, po.prototype.has = sO;
      function si(l) {
        var d = this.__data__ = new Fi(l);
        this.size = d.size;
      }
      function oO() {
        this.__data__ = new Fi(), this.size = 0;
      }
      function aO(l) {
        var d = this.__data__, m = d.delete(l);
        return this.size = d.size, m;
      }
      function lO(l) {
        return this.__data__.get(l);
      }
      function cO(l) {
        return this.__data__.has(l);
      }
      function uO(l, d) {
        var m = this.__data__;
        if (m instanceof Fi) {
          var v = m.__data__;
          if (!pl || v.length < i - 1)
            return v.push([l, d]), this.size = ++m.size, this;
          m = this.__data__ = new zi(v);
        }
        return m.set(l, d), this.size = m.size, this;
      }
      si.prototype.clear = oO, si.prototype.delete = aO, si.prototype.get = lO, si.prototype.has = cO, si.prototype.set = uO;
      function U0(l, d) {
        var m = He(l), v = !m && bo(l), E = !m && !v && Rs(l), D = !m && !v && !E && ba(l), M = m || v || E || D, N = M ? Ch(l.length, x_) : [], F = N.length;
        for (var Z in l)
          (d || ut.call(l, Z)) && !(M && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Z == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          E && (Z == "offset" || Z == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          D && (Z == "buffer" || Z == "byteLength" || Z == "byteOffset") || // Skip index properties.
          Ui(Z, F))) && N.push(Z);
        return N;
      }
      function $0(l) {
        var d = l.length;
        return d ? l[Wh(0, d - 1)] : t;
      }
      function dO(l, d) {
        return Du(lr(l), mo(d, 0, l.length));
      }
      function fO(l) {
        return Du(lr(l));
      }
      function Ih(l, d, m) {
        (m !== t && !oi(l[d], m) || m === t && !(d in l)) && Vi(l, d, m);
      }
      function vl(l, d, m) {
        var v = l[d];
        (!(ut.call(l, d) && oi(v, m)) || m === t && !(d in l)) && Vi(l, d, m);
      }
      function pu(l, d) {
        for (var m = l.length; m--; )
          if (oi(l[m][0], d))
            return m;
        return -1;
      }
      function hO(l, d, m, v) {
        return As(l, function(E, D, M) {
          d(v, E, m(E), M);
        }), v;
      }
      function G0(l, d) {
        return l && wi(d, pn(d), l);
      }
      function pO(l, d) {
        return l && wi(d, ur(d), l);
      }
      function Vi(l, d, m) {
        d == "__proto__" && lu ? lu(l, d, {
          configurable: !0,
          enumerable: !0,
          value: m,
          writable: !0
        }) : l[d] = m;
      }
      function Nh(l, d) {
        for (var m = -1, v = d.length, E = H(v), D = l == null; ++m < v; )
          E[m] = D ? t : pp(l, d[m]);
        return E;
      }
      function mo(l, d, m) {
        return l === l && (m !== t && (l = l <= m ? l : m), d !== t && (l = l >= d ? l : d)), l;
      }
      function jr(l, d, m, v, E, D) {
        var M, N = d & h, F = d & p, Z = d & g;
        if (m && (M = E ? m(l, v, E, D) : m(l)), M !== t)
          return M;
        if (!Ft(l))
          return l;
        var te = He(l);
        if (te) {
          if (M = nI(l), !N)
            return lr(l, M);
        } else {
          var oe = Fn(l), ye = oe == ue || oe == et;
          if (Rs(l))
            return gb(l, N);
          if (oe == en || oe == ie || ye && !E) {
            if (M = F || ye ? {} : Pb(l), !N)
              return F ? $O(l, pO(M, l)) : UO(l, G0(M, l));
          } else {
            if (!At[oe])
              return E ? l : {};
            M = rI(l, oe, N);
          }
        }
        D || (D = new si());
        var De = D.get(l);
        if (De)
          return De;
        D.set(l, M), ux(l) ? l.forEach(function(Le) {
          M.add(jr(Le, d, m, Le, l, D));
        }) : lx(l) && l.forEach(function(Le, tt) {
          M.set(tt, jr(Le, d, m, tt, l, D));
        });
        var Pe = Z ? F ? ep : Xh : F ? ur : pn, qe = te ? t : Pe(l);
        return Pr(qe || l, function(Le, tt) {
          qe && (tt = Le, Le = l[tt]), vl(M, tt, jr(Le, d, m, tt, l, D));
        }), M;
      }
      function mO(l) {
        var d = pn(l);
        return function(m) {
          return Y0(m, l, d);
        };
      }
      function Y0(l, d, m) {
        var v = m.length;
        if (l == null)
          return !v;
        for (l = yt(l); v--; ) {
          var E = m[v], D = d[E], M = l[E];
          if (M === t && !(E in l) || !D(M))
            return !1;
        }
        return !0;
      }
      function q0(l, d, m) {
        if (typeof l != "function")
          throw new Lr(o);
        return Tl(function() {
          l.apply(t, m);
        }, d);
      }
      function bl(l, d, m, v) {
        var E = -1, D = Qc, M = !0, N = l.length, F = [], Z = d.length;
        if (!N)
          return F;
        m && (d = Nt(d, Sr(m))), v ? (D = xh, M = !1) : d.length >= i && (D = fl, M = !1, d = new po(d));
        e:
          for (; ++E < N; ) {
            var te = l[E], oe = m == null ? te : m(te);
            if (te = v || te !== 0 ? te : 0, M && oe === oe) {
              for (var ye = Z; ye--; )
                if (d[ye] === oe)
                  continue e;
              F.push(te);
            } else D(d, oe, v) || F.push(te);
          }
        return F;
      }
      var As = Sb(Si), K0 = Sb(Lh, !0);
      function gO(l, d) {
        var m = !0;
        return As(l, function(v, E, D) {
          return m = !!d(v, E, D), m;
        }), m;
      }
      function mu(l, d, m) {
        for (var v = -1, E = l.length; ++v < E; ) {
          var D = l[v], M = d(D);
          if (M != null && (N === t ? M === M && !Er(M) : m(M, N)))
            var N = M, F = D;
        }
        return F;
      }
      function yO(l, d, m, v) {
        var E = l.length;
        for (m = Ue(m), m < 0 && (m = -m > E ? 0 : E + m), v = v === t || v > E ? E : Ue(v), v < 0 && (v += E), v = m > v ? 0 : fx(v); m < v; )
          l[m++] = d;
        return l;
      }
      function J0(l, d) {
        var m = [];
        return As(l, function(v, E, D) {
          d(v, E, D) && m.push(v);
        }), m;
      }
      function Dn(l, d, m, v, E) {
        var D = -1, M = l.length;
        for (m || (m = sI), E || (E = []); ++D < M; ) {
          var N = l[D];
          d > 0 && m(N) ? d > 1 ? Dn(N, d - 1, m, v, E) : Ss(E, N) : v || (E[E.length] = N);
        }
        return E;
      }
      var Ph = wb(), Q0 = wb(!0);
      function Si(l, d) {
        return l && Ph(l, d, pn);
      }
      function Lh(l, d) {
        return l && Q0(l, d, pn);
      }
      function gu(l, d) {
        return xs(d, function(m) {
          return $i(l[m]);
        });
      }
      function go(l, d) {
        d = Cs(d, l);
        for (var m = 0, v = d.length; l != null && m < v; )
          l = l[Ei(d[m++])];
        return m && m == v ? l : t;
      }
      function Z0(l, d, m) {
        var v = d(l);
        return He(l) ? v : Ss(v, m(l));
      }
      function Yn(l) {
        return l == null ? l === t ? Ge : Wt : fo && fo in yt(l) ? XO(l) : fI(l);
      }
      function Bh(l, d) {
        return l > d;
      }
      function vO(l, d) {
        return l != null && ut.call(l, d);
      }
      function bO(l, d) {
        return l != null && d in yt(l);
      }
      function xO(l, d, m) {
        return l >= jn(d, m) && l < dn(d, m);
      }
      function jh(l, d, m) {
        for (var v = m ? xh : Qc, E = l[0].length, D = l.length, M = D, N = H(D), F = 1 / 0, Z = []; M--; ) {
          var te = l[M];
          M && d && (te = Nt(te, Sr(d))), F = jn(te.length, F), N[M] = !m && (d || E >= 120 && te.length >= 120) ? new po(M && te) : t;
        }
        te = l[0];
        var oe = -1, ye = N[0];
        e:
          for (; ++oe < E && Z.length < F; ) {
            var De = te[oe], Pe = d ? d(De) : De;
            if (De = m || De !== 0 ? De : 0, !(ye ? fl(ye, Pe) : v(Z, Pe, m))) {
              for (M = D; --M; ) {
                var qe = N[M];
                if (!(qe ? fl(qe, Pe) : v(l[M], Pe, m)))
                  continue e;
              }
              ye && ye.push(Pe), Z.push(De);
            }
          }
        return Z;
      }
      function SO(l, d, m, v) {
        return Si(l, function(E, D, M) {
          d(v, m(E), D, M);
        }), v;
      }
      function xl(l, d, m) {
        d = Cs(d, l), l = Fb(l, d);
        var v = l == null ? l : l[Ei(zr(d))];
        return v == null ? t : xr(v, l, m);
      }
      function X0(l) {
        return $t(l) && Yn(l) == ie;
      }
      function wO(l) {
        return $t(l) && Yn(l) == _t;
      }
      function EO(l) {
        return $t(l) && Yn(l) == he;
      }
      function Sl(l, d, m, v, E) {
        return l === d ? !0 : l == null || d == null || !$t(l) && !$t(d) ? l !== l && d !== d : AO(l, d, m, v, Sl, E);
      }
      function AO(l, d, m, v, E, D) {
        var M = He(l), N = He(d), F = M ? q : Fn(l), Z = N ? q : Fn(d);
        F = F == ie ? en : F, Z = Z == ie ? en : Z;
        var te = F == en, oe = Z == en, ye = F == Z;
        if (ye && Rs(l)) {
          if (!Rs(d))
            return !1;
          M = !0, te = !1;
        }
        if (ye && !te)
          return D || (D = new si()), M || ba(l) ? Ob(l, d, m, v, E, D) : QO(l, d, F, m, v, E, D);
        if (!(m & y)) {
          var De = te && ut.call(l, "__wrapped__"), Pe = oe && ut.call(d, "__wrapped__");
          if (De || Pe) {
            var qe = De ? l.value() : l, Le = Pe ? d.value() : d;
            return D || (D = new si()), E(qe, Le, m, v, D);
          }
        }
        return ye ? (D || (D = new si()), ZO(l, d, m, v, E, D)) : !1;
      }
      function TO(l) {
        return $t(l) && Fn(l) == mt;
      }
      function Fh(l, d, m, v) {
        var E = m.length, D = E, M = !v;
        if (l == null)
          return !D;
        for (l = yt(l); E--; ) {
          var N = m[E];
          if (M && N[2] ? N[1] !== l[N[0]] : !(N[0] in l))
            return !1;
        }
        for (; ++E < D; ) {
          N = m[E];
          var F = N[0], Z = l[F], te = N[1];
          if (M && N[2]) {
            if (Z === t && !(F in l))
              return !1;
          } else {
            var oe = new si();
            if (v)
              var ye = v(Z, te, F, l, d, oe);
            if (!(ye === t ? Sl(te, Z, y | x, v, oe) : ye))
              return !1;
          }
        }
        return !0;
      }
      function eb(l) {
        if (!Ft(l) || aI(l))
          return !1;
        var d = $i(l) ? T_ : tn;
        return d.test(vo(l));
      }
      function CO(l) {
        return $t(l) && Yn(l) == ir;
      }
      function DO(l) {
        return $t(l) && Fn(l) == Jt;
      }
      function RO(l) {
        return $t(l) && Iu(l.length) && !!Rt[Yn(l)];
      }
      function tb(l) {
        return typeof l == "function" ? l : l == null ? dr : typeof l == "object" ? He(l) ? ib(l[0], l[1]) : rb(l) : Ex(l);
      }
      function zh(l) {
        if (!Al(l))
          return __(l);
        var d = [];
        for (var m in yt(l))
          ut.call(l, m) && m != "constructor" && d.push(m);
        return d;
      }
      function kO(l) {
        if (!Ft(l))
          return dI(l);
        var d = Al(l), m = [];
        for (var v in l)
          v == "constructor" && (d || !ut.call(l, v)) || m.push(v);
        return m;
      }
      function Vh(l, d) {
        return l < d;
      }
      function nb(l, d) {
        var m = -1, v = cr(l) ? H(l.length) : [];
        return As(l, function(E, D, M) {
          v[++m] = d(E, D, M);
        }), v;
      }
      function rb(l) {
        var d = np(l);
        return d.length == 1 && d[0][2] ? Bb(d[0][0], d[0][1]) : function(m) {
          return m === l || Fh(m, l, d);
        };
      }
      function ib(l, d) {
        return ip(l) && Lb(d) ? Bb(Ei(l), d) : function(m) {
          var v = pp(m, l);
          return v === t && v === d ? mp(m, l) : Sl(d, v, y | x);
        };
      }
      function yu(l, d, m, v, E) {
        l !== d && Ph(d, function(D, M) {
          if (E || (E = new si()), Ft(D))
            MO(l, d, M, m, yu, v, E);
          else {
            var N = v ? v(op(l, M), D, M + "", l, d, E) : t;
            N === t && (N = D), Ih(l, M, N);
          }
        }, ur);
      }
      function MO(l, d, m, v, E, D, M) {
        var N = op(l, m), F = op(d, m), Z = M.get(F);
        if (Z) {
          Ih(l, m, Z);
          return;
        }
        var te = D ? D(N, F, m + "", l, d, M) : t, oe = te === t;
        if (oe) {
          var ye = He(F), De = !ye && Rs(F), Pe = !ye && !De && ba(F);
          te = F, ye || De || Pe ? He(N) ? te = N : Zt(N) ? te = lr(N) : De ? (oe = !1, te = gb(F, !0)) : Pe ? (oe = !1, te = yb(F, !0)) : te = [] : Cl(F) || bo(F) ? (te = N, bo(N) ? te = hx(N) : (!Ft(N) || $i(N)) && (te = Pb(F))) : oe = !1;
        }
        oe && (M.set(F, te), E(te, F, v, D, M), M.delete(F)), Ih(l, m, te);
      }
      function sb(l, d) {
        var m = l.length;
        if (m)
          return d += d < 0 ? m : 0, Ui(d, m) ? l[d] : t;
      }
      function ob(l, d, m) {
        d.length ? d = Nt(d, function(D) {
          return He(D) ? function(M) {
            return go(M, D.length === 1 ? D[0] : D);
          } : D;
        }) : d = [dr];
        var v = -1;
        d = Nt(d, Sr(Ie()));
        var E = nb(l, function(D, M, N) {
          var F = Nt(d, function(Z) {
            return Z(D);
          });
          return { criteria: F, index: ++v, value: D };
        });
        return r_(E, function(D, M) {
          return WO(D, M, m);
        });
      }
      function _O(l, d) {
        return ab(l, d, function(m, v) {
          return mp(l, v);
        });
      }
      function ab(l, d, m) {
        for (var v = -1, E = d.length, D = {}; ++v < E; ) {
          var M = d[v], N = go(l, M);
          m(N, M) && wl(D, Cs(M, l), N);
        }
        return D;
      }
      function OO(l) {
        return function(d) {
          return go(d, l);
        };
      }
      function Hh(l, d, m, v) {
        var E = v ? n_ : la, D = -1, M = d.length, N = l;
        for (l === d && (d = lr(d)), m && (N = Nt(l, Sr(m))); ++D < M; )
          for (var F = 0, Z = d[D], te = m ? m(Z) : Z; (F = E(N, te, F, v)) > -1; )
            N !== l && au.call(N, F, 1), au.call(l, F, 1);
        return l;
      }
      function lb(l, d) {
        for (var m = l ? d.length : 0, v = m - 1; m--; ) {
          var E = d[m];
          if (m == v || E !== D) {
            var D = E;
            Ui(E) ? au.call(l, E, 1) : Gh(l, E);
          }
        }
        return l;
      }
      function Wh(l, d) {
        return l + uu(H0() * (d - l + 1));
      }
      function IO(l, d, m, v) {
        for (var E = -1, D = dn(cu((d - l) / (m || 1)), 0), M = H(D); D--; )
          M[v ? D : ++E] = l, l += m;
        return M;
      }
      function Uh(l, d) {
        var m = "";
        if (!l || d < 1 || d > K)
          return m;
        do
          d % 2 && (m += l), d = uu(d / 2), d && (l += l);
        while (d);
        return m;
      }
      function Ze(l, d) {
        return ap(jb(l, d, dr), l + "");
      }
      function NO(l) {
        return $0(xa(l));
      }
      function PO(l, d) {
        var m = xa(l);
        return Du(m, mo(d, 0, m.length));
      }
      function wl(l, d, m, v) {
        if (!Ft(l))
          return l;
        d = Cs(d, l);
        for (var E = -1, D = d.length, M = D - 1, N = l; N != null && ++E < D; ) {
          var F = Ei(d[E]), Z = m;
          if (F === "__proto__" || F === "constructor" || F === "prototype")
            return l;
          if (E != M) {
            var te = N[F];
            Z = v ? v(te, F, N) : t, Z === t && (Z = Ft(te) ? te : Ui(d[E + 1]) ? [] : {});
          }
          vl(N, F, Z), N = N[F];
        }
        return l;
      }
      var cb = du ? function(l, d) {
        return du.set(l, d), l;
      } : dr, LO = lu ? function(l, d) {
        return lu(l, "toString", {
          configurable: !0,
          enumerable: !1,
          value: yp(d),
          writable: !0
        });
      } : dr;
      function BO(l) {
        return Du(xa(l));
      }
      function Fr(l, d, m) {
        var v = -1, E = l.length;
        d < 0 && (d = -d > E ? 0 : E + d), m = m > E ? E : m, m < 0 && (m += E), E = d > m ? 0 : m - d >>> 0, d >>>= 0;
        for (var D = H(E); ++v < E; )
          D[v] = l[v + d];
        return D;
      }
      function jO(l, d) {
        var m;
        return As(l, function(v, E, D) {
          return m = d(v, E, D), !m;
        }), !!m;
      }
      function vu(l, d, m) {
        var v = 0, E = l == null ? v : l.length;
        if (typeof d == "number" && d === d && E <= me) {
          for (; v < E; ) {
            var D = v + E >>> 1, M = l[D];
            M !== null && !Er(M) && (m ? M <= d : M < d) ? v = D + 1 : E = D;
          }
          return E;
        }
        return $h(l, d, dr, m);
      }
      function $h(l, d, m, v) {
        var E = 0, D = l == null ? 0 : l.length;
        if (D === 0)
          return 0;
        d = m(d);
        for (var M = d !== d, N = d === null, F = Er(d), Z = d === t; E < D; ) {
          var te = uu((E + D) / 2), oe = m(l[te]), ye = oe !== t, De = oe === null, Pe = oe === oe, qe = Er(oe);
          if (M)
            var Le = v || Pe;
          else Z ? Le = Pe && (v || ye) : N ? Le = Pe && ye && (v || !De) : F ? Le = Pe && ye && !De && (v || !qe) : De || qe ? Le = !1 : Le = v ? oe <= d : oe < d;
          Le ? E = te + 1 : D = te;
        }
        return jn(D, ge);
      }
      function ub(l, d) {
        for (var m = -1, v = l.length, E = 0, D = []; ++m < v; ) {
          var M = l[m], N = d ? d(M) : M;
          if (!m || !oi(N, F)) {
            var F = N;
            D[E++] = M === 0 ? 0 : M;
          }
        }
        return D;
      }
      function db(l) {
        return typeof l == "number" ? l : Er(l) ? z : +l;
      }
      function wr(l) {
        if (typeof l == "string")
          return l;
        if (He(l))
          return Nt(l, wr) + "";
        if (Er(l))
          return W0 ? W0.call(l) : "";
        var d = l + "";
        return d == "0" && 1 / l == -$ ? "-0" : d;
      }
      function Ts(l, d, m) {
        var v = -1, E = Qc, D = l.length, M = !0, N = [], F = N;
        if (m)
          M = !1, E = xh;
        else if (D >= i) {
          var Z = d ? null : KO(l);
          if (Z)
            return Xc(Z);
          M = !1, E = fl, F = new po();
        } else
          F = d ? [] : N;
        e:
          for (; ++v < D; ) {
            var te = l[v], oe = d ? d(te) : te;
            if (te = m || te !== 0 ? te : 0, M && oe === oe) {
              for (var ye = F.length; ye--; )
                if (F[ye] === oe)
                  continue e;
              d && F.push(oe), N.push(te);
            } else E(F, oe, m) || (F !== N && F.push(oe), N.push(te));
          }
        return N;
      }
      function Gh(l, d) {
        d = Cs(d, l);
        var m = -1, v = d.length;
        if (!v)
          return !0;
        for (var E = l == null || typeof l != "object" && typeof l != "function"; ++m < v; ) {
          var D = d[m];
          if (typeof D == "string") {
            if (D === "__proto__" && !ut.call(l, "__proto__"))
              return !1;
            if (D === "constructor" && m + 1 < v && typeof d[m + 1] == "string" && d[m + 1] === "prototype") {
              if (E && m === 0)
                continue;
              return !1;
            }
          }
        }
        var M = Fb(l, d);
        return M == null || delete M[Ei(zr(d))];
      }
      function fb(l, d, m, v) {
        return wl(l, d, m(go(l, d)), v);
      }
      function bu(l, d, m, v) {
        for (var E = l.length, D = v ? E : -1; (v ? D-- : ++D < E) && d(l[D], D, l); )
          ;
        return m ? Fr(l, v ? 0 : D, v ? D + 1 : E) : Fr(l, v ? D + 1 : 0, v ? E : D);
      }
      function hb(l, d) {
        var m = l;
        return m instanceof nt && (m = m.value()), Sh(d, function(v, E) {
          return E.func.apply(E.thisArg, Ss([v], E.args));
        }, m);
      }
      function Yh(l, d, m) {
        var v = l.length;
        if (v < 2)
          return v ? Ts(l[0]) : [];
        for (var E = -1, D = H(v); ++E < v; )
          for (var M = l[E], N = -1; ++N < v; )
            N != E && (D[E] = bl(D[E] || M, l[N], d, m));
        return Ts(Dn(D, 1), d, m);
      }
      function pb(l, d, m) {
        for (var v = -1, E = l.length, D = d.length, M = {}; ++v < E; ) {
          var N = v < D ? d[v] : t;
          m(M, l[v], N);
        }
        return M;
      }
      function qh(l) {
        return Zt(l) ? l : [];
      }
      function Kh(l) {
        return typeof l == "function" ? l : dr;
      }
      function Cs(l, d) {
        return He(l) ? l : ip(l, d) ? [l] : Wb(dt(l));
      }
      var FO = Ze;
      function Ds(l, d, m) {
        var v = l.length;
        return m = m === t ? v : m, !d && m >= v ? l : Fr(l, d, m);
      }
      var mb = C_ || function(l) {
        return Cn.clearTimeout(l);
      };
      function gb(l, d) {
        if (d)
          return l.slice();
        var m = l.length, v = B0 ? B0(m) : new l.constructor(m);
        return l.copy(v), v;
      }
      function Jh(l) {
        var d = new l.constructor(l.byteLength);
        return new su(d).set(new su(l)), d;
      }
      function zO(l, d) {
        var m = d ? Jh(l.buffer) : l.buffer;
        return new l.constructor(m, l.byteOffset, l.byteLength);
      }
      function VO(l) {
        var d = new l.constructor(l.source, st.exec(l));
        return d.lastIndex = l.lastIndex, d;
      }
      function HO(l) {
        return yl ? yt(yl.call(l)) : {};
      }
      function yb(l, d) {
        var m = d ? Jh(l.buffer) : l.buffer;
        return new l.constructor(m, l.byteOffset, l.length);
      }
      function vb(l, d) {
        if (l !== d) {
          var m = l !== t, v = l === null, E = l === l, D = Er(l), M = d !== t, N = d === null, F = d === d, Z = Er(d);
          if (!N && !Z && !D && l > d || D && M && F && !N && !Z || v && M && F || !m && F || !E)
            return 1;
          if (!v && !D && !Z && l < d || Z && m && E && !v && !D || N && m && E || !M && E || !F)
            return -1;
        }
        return 0;
      }
      function WO(l, d, m) {
        for (var v = -1, E = l.criteria, D = d.criteria, M = E.length, N = m.length; ++v < M; ) {
          var F = vb(E[v], D[v]);
          if (F) {
            if (v >= N)
              return F;
            var Z = m[v];
            return F * (Z == "desc" ? -1 : 1);
          }
        }
        return l.index - d.index;
      }
      function bb(l, d, m, v) {
        for (var E = -1, D = l.length, M = m.length, N = -1, F = d.length, Z = dn(D - M, 0), te = H(F + Z), oe = !v; ++N < F; )
          te[N] = d[N];
        for (; ++E < M; )
          (oe || E < D) && (te[m[E]] = l[E]);
        for (; Z--; )
          te[N++] = l[E++];
        return te;
      }
      function xb(l, d, m, v) {
        for (var E = -1, D = l.length, M = -1, N = m.length, F = -1, Z = d.length, te = dn(D - N, 0), oe = H(te + Z), ye = !v; ++E < te; )
          oe[E] = l[E];
        for (var De = E; ++F < Z; )
          oe[De + F] = d[F];
        for (; ++M < N; )
          (ye || E < D) && (oe[De + m[M]] = l[E++]);
        return oe;
      }
      function lr(l, d) {
        var m = -1, v = l.length;
        for (d || (d = H(v)); ++m < v; )
          d[m] = l[m];
        return d;
      }
      function wi(l, d, m, v) {
        var E = !m;
        m || (m = {});
        for (var D = -1, M = d.length; ++D < M; ) {
          var N = d[D], F = v ? v(m[N], l[N], N, m, l) : t;
          F === t && (F = l[N]), E ? Vi(m, N, F) : vl(m, N, F);
        }
        return m;
      }
      function UO(l, d) {
        return wi(l, rp(l), d);
      }
      function $O(l, d) {
        return wi(l, Ib(l), d);
      }
      function xu(l, d) {
        return function(m, v) {
          var E = He(m) ? JM : hO, D = d ? d() : {};
          return E(m, l, Ie(v, 2), D);
        };
      }
      function ga(l) {
        return Ze(function(d, m) {
          var v = -1, E = m.length, D = E > 1 ? m[E - 1] : t, M = E > 2 ? m[2] : t;
          for (D = l.length > 3 && typeof D == "function" ? (E--, D) : t, M && qn(m[0], m[1], M) && (D = E < 3 ? t : D, E = 1), d = yt(d); ++v < E; ) {
            var N = m[v];
            N && l(d, N, v, D);
          }
          return d;
        });
      }
      function Sb(l, d) {
        return function(m, v) {
          if (m == null)
            return m;
          if (!cr(m))
            return l(m, v);
          for (var E = m.length, D = d ? E : -1, M = yt(m); (d ? D-- : ++D < E) && v(M[D], D, M) !== !1; )
            ;
          return m;
        };
      }
      function wb(l) {
        return function(d, m, v) {
          for (var E = -1, D = yt(d), M = v(d), N = M.length; N--; ) {
            var F = M[l ? N : ++E];
            if (m(D[F], F, D) === !1)
              break;
          }
          return d;
        };
      }
      function GO(l, d, m) {
        var v = d & S, E = El(l);
        function D() {
          var M = this && this !== Cn && this instanceof D ? E : l;
          return M.apply(v ? m : this, arguments);
        }
        return D;
      }
      function Eb(l) {
        return function(d) {
          d = dt(d);
          var m = ca(d) ? ii(d) : t, v = m ? m[0] : d.charAt(0), E = m ? Ds(m, 1).join("") : d.slice(1);
          return v[l]() + E;
        };
      }
      function ya(l) {
        return function(d) {
          return Sh(Sx(xx(d).replace(LM, "")), l, "");
        };
      }
      function El(l) {
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return new l();
            case 1:
              return new l(d[0]);
            case 2:
              return new l(d[0], d[1]);
            case 3:
              return new l(d[0], d[1], d[2]);
            case 4:
              return new l(d[0], d[1], d[2], d[3]);
            case 5:
              return new l(d[0], d[1], d[2], d[3], d[4]);
            case 6:
              return new l(d[0], d[1], d[2], d[3], d[4], d[5]);
            case 7:
              return new l(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
          }
          var m = ma(l.prototype), v = l.apply(m, d);
          return Ft(v) ? v : m;
        };
      }
      function YO(l, d, m) {
        var v = El(l);
        function E() {
          for (var D = arguments.length, M = H(D), N = D, F = va(E); N--; )
            M[N] = arguments[N];
          var Z = D < 3 && M[0] !== F && M[D - 1] !== F ? [] : ws(M, F);
          if (D -= Z.length, D < m)
            return Rb(
              l,
              d,
              Su,
              E.placeholder,
              t,
              M,
              Z,
              t,
              t,
              m - D
            );
          var te = this && this !== Cn && this instanceof E ? v : l;
          return xr(te, this, M);
        }
        return E;
      }
      function Ab(l) {
        return function(d, m, v) {
          var E = yt(d);
          if (!cr(d)) {
            var D = Ie(m, 3);
            d = pn(d), m = function(N) {
              return D(E[N], N, E);
            };
          }
          var M = l(d, m, v);
          return M > -1 ? E[D ? d[M] : M] : t;
        };
      }
      function Tb(l) {
        return Wi(function(d) {
          var m = d.length, v = m, E = Br.prototype.thru;
          for (l && d.reverse(); v--; ) {
            var D = d[v];
            if (typeof D != "function")
              throw new Lr(o);
            if (E && !M && Tu(D) == "wrapper")
              var M = new Br([], !0);
          }
          for (v = M ? v : m; ++v < m; ) {
            D = d[v];
            var N = Tu(D), F = N == "wrapper" ? tp(D) : t;
            F && sp(F[0]) && F[1] == (L | T | R | B) && !F[4].length && F[9] == 1 ? M = M[Tu(F[0])].apply(M, F[3]) : M = D.length == 1 && sp(D) ? M[N]() : M.thru(D);
          }
          return function() {
            var Z = arguments, te = Z[0];
            if (M && Z.length == 1 && He(te))
              return M.plant(te).value();
            for (var oe = 0, ye = m ? d[oe].apply(this, Z) : te; ++oe < m; )
              ye = d[oe].call(this, ye);
            return ye;
          };
        });
      }
      function Su(l, d, m, v, E, D, M, N, F, Z) {
        var te = d & L, oe = d & S, ye = d & w, De = d & (T | k), Pe = d & W, qe = ye ? t : El(l);
        function Le() {
          for (var tt = arguments.length, it = H(tt), Ar = tt; Ar--; )
            it[Ar] = arguments[Ar];
          if (De)
            var Kn = va(Le), Tr = s_(it, Kn);
          if (v && (it = bb(it, v, E, De)), D && (it = xb(it, D, M, De)), tt -= Tr, De && tt < Z) {
            var Xt = ws(it, Kn);
            return Rb(
              l,
              d,
              Su,
              Le.placeholder,
              m,
              it,
              Xt,
              N,
              F,
              Z - tt
            );
          }
          var ai = oe ? m : this, Yi = ye ? ai[l] : l;
          return tt = it.length, N ? it = hI(it, N) : Pe && tt > 1 && it.reverse(), te && F < tt && (it.length = F), this && this !== Cn && this instanceof Le && (Yi = qe || El(Yi)), Yi.apply(ai, it);
        }
        return Le;
      }
      function Cb(l, d) {
        return function(m, v) {
          return SO(m, l, d(v), {});
        };
      }
      function wu(l, d) {
        return function(m, v) {
          var E;
          if (m === t && v === t)
            return d;
          if (m !== t && (E = m), v !== t) {
            if (E === t)
              return v;
            typeof m == "string" || typeof v == "string" ? (m = wr(m), v = wr(v)) : (m = db(m), v = db(v)), E = l(m, v);
          }
          return E;
        };
      }
      function Qh(l) {
        return Wi(function(d) {
          return d = Nt(d, Sr(Ie())), Ze(function(m) {
            var v = this;
            return l(d, function(E) {
              return xr(E, v, m);
            });
          });
        });
      }
      function Eu(l, d) {
        d = d === t ? " " : wr(d);
        var m = d.length;
        if (m < 2)
          return m ? Uh(d, l) : d;
        var v = Uh(d, cu(l / ua(d)));
        return ca(d) ? Ds(ii(v), 0, l).join("") : v.slice(0, l);
      }
      function qO(l, d, m, v) {
        var E = d & S, D = El(l);
        function M() {
          for (var N = -1, F = arguments.length, Z = -1, te = v.length, oe = H(te + F), ye = this && this !== Cn && this instanceof M ? D : l; ++Z < te; )
            oe[Z] = v[Z];
          for (; F--; )
            oe[Z++] = arguments[++N];
          return xr(ye, E ? m : this, oe);
        }
        return M;
      }
      function Db(l) {
        return function(d, m, v) {
          return v && typeof v != "number" && qn(d, m, v) && (m = v = t), d = Gi(d), m === t ? (m = d, d = 0) : m = Gi(m), v = v === t ? d < m ? 1 : -1 : Gi(v), IO(d, m, v, l);
        };
      }
      function Au(l) {
        return function(d, m) {
          return typeof d == "string" && typeof m == "string" || (d = Vr(d), m = Vr(m)), l(d, m);
        };
      }
      function Rb(l, d, m, v, E, D, M, N, F, Z) {
        var te = d & T, oe = te ? M : t, ye = te ? t : M, De = te ? D : t, Pe = te ? t : D;
        d |= te ? R : P, d &= ~(te ? P : R), d & C || (d &= -4);
        var qe = [
          l,
          d,
          E,
          De,
          oe,
          Pe,
          ye,
          N,
          F,
          Z
        ], Le = m.apply(t, qe);
        return sp(l) && zb(Le, qe), Le.placeholder = v, Vb(Le, l, d);
      }
      function Zh(l) {
        var d = un[l];
        return function(m, v) {
          if (m = Vr(m), v = v == null ? 0 : jn(Ue(v), 292), v && V0(m)) {
            var E = (dt(m) + "e").split("e"), D = d(E[0] + "e" + (+E[1] + v));
            return E = (dt(D) + "e").split("e"), +(E[0] + "e" + (+E[1] - v));
          }
          return d(m);
        };
      }
      var KO = ha && 1 / Xc(new ha([, -0]))[1] == $ ? function(l) {
        return new ha(l);
      } : xp;
      function kb(l) {
        return function(d) {
          var m = Fn(d);
          return m == mt ? Rh(d) : m == Jt ? f_(d) : i_(d, l(d));
        };
      }
      function Hi(l, d, m, v, E, D, M, N) {
        var F = d & w;
        if (!F && typeof l != "function")
          throw new Lr(o);
        var Z = v ? v.length : 0;
        if (Z || (d &= -97, v = E = t), M = M === t ? M : dn(Ue(M), 0), N = N === t ? N : Ue(N), Z -= E ? E.length : 0, d & P) {
          var te = v, oe = E;
          v = E = t;
        }
        var ye = F ? t : tp(l), De = [
          l,
          d,
          m,
          v,
          E,
          te,
          oe,
          D,
          M,
          N
        ];
        if (ye && uI(De, ye), l = De[0], d = De[1], m = De[2], v = De[3], E = De[4], N = De[9] = De[9] === t ? F ? 0 : l.length : dn(De[9] - Z, 0), !N && d & (T | k) && (d &= -25), !d || d == S)
          var Pe = GO(l, d, m);
        else d == T || d == k ? Pe = YO(l, d, N) : (d == R || d == (S | R)) && !E.length ? Pe = qO(l, d, m, v) : Pe = Su.apply(t, De);
        var qe = ye ? cb : zb;
        return Vb(qe(Pe, De), l, d);
      }
      function Mb(l, d, m, v) {
        return l === t || oi(l, fa[m]) && !ut.call(v, m) ? d : l;
      }
      function _b(l, d, m, v, E, D) {
        return Ft(l) && Ft(d) && (D.set(d, l), yu(l, d, t, _b, D), D.delete(d)), l;
      }
      function JO(l) {
        return Cl(l) ? t : l;
      }
      function Ob(l, d, m, v, E, D) {
        var M = m & y, N = l.length, F = d.length;
        if (N != F && !(M && F > N))
          return !1;
        var Z = D.get(l), te = D.get(d);
        if (Z && te)
          return Z == d && te == l;
        var oe = -1, ye = !0, De = m & x ? new po() : t;
        for (D.set(l, d), D.set(d, l); ++oe < N; ) {
          var Pe = l[oe], qe = d[oe];
          if (v)
            var Le = M ? v(qe, Pe, oe, d, l, D) : v(Pe, qe, oe, l, d, D);
          if (Le !== t) {
            if (Le)
              continue;
            ye = !1;
            break;
          }
          if (De) {
            if (!wh(d, function(tt, it) {
              if (!fl(De, it) && (Pe === tt || E(Pe, tt, m, v, D)))
                return De.push(it);
            })) {
              ye = !1;
              break;
            }
          } else if (!(Pe === qe || E(Pe, qe, m, v, D))) {
            ye = !1;
            break;
          }
        }
        return D.delete(l), D.delete(d), ye;
      }
      function QO(l, d, m, v, E, D, M) {
        switch (m) {
          case An:
            if (l.byteLength != d.byteLength || l.byteOffset != d.byteOffset)
              return !1;
            l = l.buffer, d = d.buffer;
          case _t:
            return !(l.byteLength != d.byteLength || !D(new su(l), new su(d)));
          case ee:
          case he:
          case Kt:
            return oi(+l, +d);
          case Ee:
            return l.name == d.name && l.message == d.message;
          case ir:
          case Pn:
            return l == d + "";
          case mt:
            var N = Rh;
          case Jt:
            var F = v & y;
            if (N || (N = Xc), l.size != d.size && !F)
              return !1;
            var Z = M.get(l);
            if (Z)
              return Z == d;
            v |= x, M.set(l, d);
            var te = Ob(N(l), N(d), v, E, D, M);
            return M.delete(l), te;
          case sr:
            if (yl)
              return yl.call(l) == yl.call(d);
        }
        return !1;
      }
      function ZO(l, d, m, v, E, D) {
        var M = m & y, N = Xh(l), F = N.length, Z = Xh(d), te = Z.length;
        if (F != te && !M)
          return !1;
        for (var oe = F; oe--; ) {
          var ye = N[oe];
          if (!(M ? ye in d : ut.call(d, ye)))
            return !1;
        }
        var De = D.get(l), Pe = D.get(d);
        if (De && Pe)
          return De == d && Pe == l;
        var qe = !0;
        D.set(l, d), D.set(d, l);
        for (var Le = M; ++oe < F; ) {
          ye = N[oe];
          var tt = l[ye], it = d[ye];
          if (v)
            var Ar = M ? v(it, tt, ye, d, l, D) : v(tt, it, ye, l, d, D);
          if (!(Ar === t ? tt === it || E(tt, it, m, v, D) : Ar)) {
            qe = !1;
            break;
          }
          Le || (Le = ye == "constructor");
        }
        if (qe && !Le) {
          var Kn = l.constructor, Tr = d.constructor;
          Kn != Tr && "constructor" in l && "constructor" in d && !(typeof Kn == "function" && Kn instanceof Kn && typeof Tr == "function" && Tr instanceof Tr) && (qe = !1);
        }
        return D.delete(l), D.delete(d), qe;
      }
      function Wi(l) {
        return ap(jb(l, t, Yb), l + "");
      }
      function Xh(l) {
        return Z0(l, pn, rp);
      }
      function ep(l) {
        return Z0(l, ur, Ib);
      }
      var tp = du ? function(l) {
        return du.get(l);
      } : xp;
      function Tu(l) {
        for (var d = l.name + "", m = pa[d], v = ut.call(pa, d) ? m.length : 0; v--; ) {
          var E = m[v], D = E.func;
          if (D == null || D == l)
            return E.name;
        }
        return d;
      }
      function va(l) {
        var d = ut.call(A, "placeholder") ? A : l;
        return d.placeholder;
      }
      function Ie() {
        var l = A.iteratee || vp;
        return l = l === vp ? tb : l, arguments.length ? l(arguments[0], arguments[1]) : l;
      }
      function Cu(l, d) {
        var m = l.__data__;
        return oI(d) ? m[typeof d == "string" ? "string" : "hash"] : m.map;
      }
      function np(l) {
        for (var d = pn(l), m = d.length; m--; ) {
          var v = d[m], E = l[v];
          d[m] = [v, E, Lb(E)];
        }
        return d;
      }
      function yo(l, d) {
        var m = c_(l, d);
        return eb(m) ? m : t;
      }
      function XO(l) {
        var d = ut.call(l, fo), m = l[fo];
        try {
          l[fo] = t;
          var v = !0;
        } catch {
        }
        var E = ru.call(l);
        return v && (d ? l[fo] = m : delete l[fo]), E;
      }
      var rp = Mh ? function(l) {
        return l == null ? [] : (l = yt(l), xs(Mh(l), function(d) {
          return F0.call(l, d);
        }));
      } : Sp, Ib = Mh ? function(l) {
        for (var d = []; l; )
          Ss(d, rp(l)), l = ou(l);
        return d;
      } : Sp, Fn = Yn;
      (_h && Fn(new _h(new ArrayBuffer(1))) != An || pl && Fn(new pl()) != mt || Oh && Fn(Oh.resolve()) != $n || ha && Fn(new ha()) != Jt || ml && Fn(new ml()) != lt) && (Fn = function(l) {
        var d = Yn(l), m = d == en ? l.constructor : t, v = m ? vo(m) : "";
        if (v)
          switch (v) {
            case P_:
              return An;
            case L_:
              return mt;
            case B_:
              return $n;
            case j_:
              return Jt;
            case F_:
              return lt;
          }
        return d;
      });
      function eI(l, d, m) {
        for (var v = -1, E = m.length; ++v < E; ) {
          var D = m[v], M = D.size;
          switch (D.type) {
            case "drop":
              l += M;
              break;
            case "dropRight":
              d -= M;
              break;
            case "take":
              d = jn(d, l + M);
              break;
            case "takeRight":
              l = dn(l, d - M);
              break;
          }
        }
        return { start: l, end: d };
      }
      function tI(l) {
        var d = l.match(ul);
        return d ? d[1].split(O) : [];
      }
      function Nb(l, d, m) {
        d = Cs(d, l);
        for (var v = -1, E = d.length, D = !1; ++v < E; ) {
          var M = Ei(d[v]);
          if (!(D = l != null && m(l, M)))
            break;
          l = l[M];
        }
        return D || ++v != E ? D : (E = l == null ? 0 : l.length, !!E && Iu(E) && Ui(M, E) && (He(l) || bo(l)));
      }
      function nI(l) {
        var d = l.length, m = new l.constructor(d);
        return d && typeof l[0] == "string" && ut.call(l, "index") && (m.index = l.index, m.input = l.input), m;
      }
      function Pb(l) {
        return typeof l.constructor == "function" && !Al(l) ? ma(ou(l)) : {};
      }
      function rI(l, d, m) {
        var v = l.constructor;
        switch (d) {
          case _t:
            return Jh(l);
          case ee:
          case he:
            return new v(+l);
          case An:
            return zO(l, m);
          case Gn:
          case cn:
          case ei:
          case or:
          case Or:
          case ti:
          case gs:
          case gi:
          case yi:
            return yb(l, m);
          case mt:
            return new v();
          case Kt:
          case Pn:
            return new v(l);
          case ir:
            return VO(l);
          case Jt:
            return new v();
          case sr:
            return HO(l);
        }
      }
      function iI(l, d) {
        var m = d.length;
        if (!m)
          return l;
        var v = m - 1;
        return d[v] = (m > 1 ? "& " : "") + d[v], d = d.join(m > 2 ? ", " : " "), l.replace(ia, `{
/* [wrapped with ` + d + `] */
`);
      }
      function sI(l) {
        return He(l) || bo(l) || !!(z0 && l && l[z0]);
      }
      function Ui(l, d) {
        var m = typeof l;
        return d = d ?? K, !!d && (m == "number" || m != "symbol" && Ot.test(l)) && l > -1 && l % 1 == 0 && l < d;
      }
      function qn(l, d, m) {
        if (!Ft(m))
          return !1;
        var v = typeof d;
        return (v == "number" ? cr(m) && Ui(d, m.length) : v == "string" && d in m) ? oi(m[d], l) : !1;
      }
      function ip(l, d) {
        if (He(l))
          return !1;
        var m = typeof l;
        return m == "number" || m == "symbol" || m == "boolean" || l == null || Er(l) ? !0 : Bt.test(l) || !na.test(l) || d != null && l in yt(d);
      }
      function oI(l) {
        var d = typeof l;
        return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? l !== "__proto__" : l === null;
      }
      function sp(l) {
        var d = Tu(l), m = A[d];
        if (typeof m != "function" || !(d in nt.prototype))
          return !1;
        if (l === m)
          return !0;
        var v = tp(m);
        return !!v && l === v[0];
      }
      function aI(l) {
        return !!L0 && L0 in l;
      }
      var lI = tu ? $i : wp;
      function Al(l) {
        var d = l && l.constructor, m = typeof d == "function" && d.prototype || fa;
        return l === m;
      }
      function Lb(l) {
        return l === l && !Ft(l);
      }
      function Bb(l, d) {
        return function(m) {
          return m == null ? !1 : m[l] === d && (d !== t || l in yt(m));
        };
      }
      function cI(l) {
        var d = _u(l, function(v) {
          return m.size === u && m.clear(), v;
        }), m = d.cache;
        return d;
      }
      function uI(l, d) {
        var m = l[1], v = d[1], E = m | v, D = E < (S | w | L), M = v == L && m == T || v == L && m == B && l[7].length <= d[8] || v == (L | B) && d[7].length <= d[8] && m == T;
        if (!(D || M))
          return l;
        v & S && (l[2] = d[2], E |= m & S ? 0 : C);
        var N = d[3];
        if (N) {
          var F = l[3];
          l[3] = F ? bb(F, N, d[4]) : N, l[4] = F ? ws(l[3], f) : d[4];
        }
        return N = d[5], N && (F = l[5], l[5] = F ? xb(F, N, d[6]) : N, l[6] = F ? ws(l[5], f) : d[6]), N = d[7], N && (l[7] = N), v & L && (l[8] = l[8] == null ? d[8] : jn(l[8], d[8])), l[9] == null && (l[9] = d[9]), l[0] = d[0], l[1] = E, l;
      }
      function dI(l) {
        var d = [];
        if (l != null)
          for (var m in yt(l))
            d.push(m);
        return d;
      }
      function fI(l) {
        return ru.call(l);
      }
      function jb(l, d, m) {
        return d = dn(d === t ? l.length - 1 : d, 0), function() {
          for (var v = arguments, E = -1, D = dn(v.length - d, 0), M = H(D); ++E < D; )
            M[E] = v[d + E];
          E = -1;
          for (var N = H(d + 1); ++E < d; )
            N[E] = v[E];
          return N[d] = m(M), xr(l, this, N);
        };
      }
      function Fb(l, d) {
        return d.length < 2 ? l : go(l, Fr(d, 0, -1));
      }
      function hI(l, d) {
        for (var m = l.length, v = jn(d.length, m), E = lr(l); v--; ) {
          var D = d[v];
          l[v] = Ui(D, m) ? E[D] : t;
        }
        return l;
      }
      function op(l, d) {
        if (!(d === "constructor" && typeof l[d] == "function") && d != "__proto__")
          return l[d];
      }
      var zb = Hb(cb), Tl = R_ || function(l, d) {
        return Cn.setTimeout(l, d);
      }, ap = Hb(LO);
      function Vb(l, d, m) {
        var v = d + "";
        return ap(l, iI(v, pI(tI(v), m)));
      }
      function Hb(l) {
        var d = 0, m = 0;
        return function() {
          var v = O_(), E = ke - (v - m);
          if (m = v, E > 0) {
            if (++d >= Re)
              return arguments[0];
          } else
            d = 0;
          return l.apply(t, arguments);
        };
      }
      function Du(l, d) {
        var m = -1, v = l.length, E = v - 1;
        for (d = d === t ? v : d; ++m < d; ) {
          var D = Wh(m, E), M = l[D];
          l[D] = l[m], l[m] = M;
        }
        return l.length = d, l;
      }
      var Wb = cI(function(l) {
        var d = [];
        return l.charCodeAt(0) === 46 && d.push(""), l.replace(bi, function(m, v, E, D) {
          d.push(E ? D.replace(Oe, "$1") : v || m);
        }), d;
      });
      function Ei(l) {
        if (typeof l == "string" || Er(l))
          return l;
        var d = l + "";
        return d == "0" && 1 / l == -$ ? "-0" : d;
      }
      function vo(l) {
        if (l != null) {
          try {
            return nu.call(l);
          } catch {
          }
          try {
            return l + "";
          } catch {
          }
        }
        return "";
      }
      function pI(l, d) {
        return Pr(V, function(m) {
          var v = "_." + m[0];
          d & m[1] && !Qc(l, v) && l.push(v);
        }), l.sort();
      }
      function Ub(l) {
        if (l instanceof nt)
          return l.clone();
        var d = new Br(l.__wrapped__, l.__chain__);
        return d.__actions__ = lr(l.__actions__), d.__index__ = l.__index__, d.__values__ = l.__values__, d;
      }
      function mI(l, d, m) {
        (m ? qn(l, d, m) : d === t) ? d = 1 : d = dn(Ue(d), 0);
        var v = l == null ? 0 : l.length;
        if (!v || d < 1)
          return [];
        for (var E = 0, D = 0, M = H(cu(v / d)); E < v; )
          M[D++] = Fr(l, E, E += d);
        return M;
      }
      function gI(l) {
        for (var d = -1, m = l == null ? 0 : l.length, v = 0, E = []; ++d < m; ) {
          var D = l[d];
          D && (E[v++] = D);
        }
        return E;
      }
      function yI() {
        var l = arguments.length;
        if (!l)
          return [];
        for (var d = H(l - 1), m = arguments[0], v = l; v--; )
          d[v - 1] = arguments[v];
        return Ss(He(m) ? lr(m) : [m], Dn(d, 1));
      }
      var vI = Ze(function(l, d) {
        return Zt(l) ? bl(l, Dn(d, 1, Zt, !0)) : [];
      }), bI = Ze(function(l, d) {
        var m = zr(d);
        return Zt(m) && (m = t), Zt(l) ? bl(l, Dn(d, 1, Zt, !0), Ie(m, 2)) : [];
      }), xI = Ze(function(l, d) {
        var m = zr(d);
        return Zt(m) && (m = t), Zt(l) ? bl(l, Dn(d, 1, Zt, !0), t, m) : [];
      });
      function SI(l, d, m) {
        var v = l == null ? 0 : l.length;
        return v ? (d = m || d === t ? 1 : Ue(d), Fr(l, d < 0 ? 0 : d, v)) : [];
      }
      function wI(l, d, m) {
        var v = l == null ? 0 : l.length;
        return v ? (d = m || d === t ? 1 : Ue(d), d = v - d, Fr(l, 0, d < 0 ? 0 : d)) : [];
      }
      function EI(l, d) {
        return l && l.length ? bu(l, Ie(d, 3), !0, !0) : [];
      }
      function AI(l, d) {
        return l && l.length ? bu(l, Ie(d, 3), !0) : [];
      }
      function TI(l, d, m, v) {
        var E = l == null ? 0 : l.length;
        return E ? (m && typeof m != "number" && qn(l, d, m) && (m = 0, v = E), yO(l, d, m, v)) : [];
      }
      function $b(l, d, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = m == null ? 0 : Ue(m);
        return E < 0 && (E = dn(v + E, 0)), Zc(l, Ie(d, 3), E);
      }
      function Gb(l, d, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = v - 1;
        return m !== t && (E = Ue(m), E = m < 0 ? dn(v + E, 0) : jn(E, v - 1)), Zc(l, Ie(d, 3), E, !0);
      }
      function Yb(l) {
        var d = l == null ? 0 : l.length;
        return d ? Dn(l, 1) : [];
      }
      function CI(l) {
        var d = l == null ? 0 : l.length;
        return d ? Dn(l, $) : [];
      }
      function DI(l, d) {
        var m = l == null ? 0 : l.length;
        return m ? (d = d === t ? 1 : Ue(d), Dn(l, d)) : [];
      }
      function RI(l) {
        for (var d = -1, m = l == null ? 0 : l.length, v = {}; ++d < m; ) {
          var E = l[d];
          v[E[0]] = E[1];
        }
        return v;
      }
      function qb(l) {
        return l && l.length ? l[0] : t;
      }
      function kI(l, d, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = m == null ? 0 : Ue(m);
        return E < 0 && (E = dn(v + E, 0)), la(l, d, E);
      }
      function MI(l) {
        var d = l == null ? 0 : l.length;
        return d ? Fr(l, 0, -1) : [];
      }
      var _I = Ze(function(l) {
        var d = Nt(l, qh);
        return d.length && d[0] === l[0] ? jh(d) : [];
      }), OI = Ze(function(l) {
        var d = zr(l), m = Nt(l, qh);
        return d === zr(m) ? d = t : m.pop(), m.length && m[0] === l[0] ? jh(m, Ie(d, 2)) : [];
      }), II = Ze(function(l) {
        var d = zr(l), m = Nt(l, qh);
        return d = typeof d == "function" ? d : t, d && m.pop(), m.length && m[0] === l[0] ? jh(m, t, d) : [];
      });
      function NI(l, d) {
        return l == null ? "" : M_.call(l, d);
      }
      function zr(l) {
        var d = l == null ? 0 : l.length;
        return d ? l[d - 1] : t;
      }
      function PI(l, d, m) {
        var v = l == null ? 0 : l.length;
        if (!v)
          return -1;
        var E = v;
        return m !== t && (E = Ue(m), E = E < 0 ? dn(v + E, 0) : jn(E, v - 1)), d === d ? p_(l, d, E) : Zc(l, R0, E, !0);
      }
      function LI(l, d) {
        return l && l.length ? sb(l, Ue(d)) : t;
      }
      var BI = Ze(Kb);
      function Kb(l, d) {
        return l && l.length && d && d.length ? Hh(l, d) : l;
      }
      function jI(l, d, m) {
        return l && l.length && d && d.length ? Hh(l, d, Ie(m, 2)) : l;
      }
      function FI(l, d, m) {
        return l && l.length && d && d.length ? Hh(l, d, t, m) : l;
      }
      var zI = Wi(function(l, d) {
        var m = l == null ? 0 : l.length, v = Nh(l, d);
        return lb(l, Nt(d, function(E) {
          return Ui(E, m) ? +E : E;
        }).sort(vb)), v;
      });
      function VI(l, d) {
        var m = [];
        if (!(l && l.length))
          return m;
        var v = -1, E = [], D = l.length;
        for (d = Ie(d, 3); ++v < D; ) {
          var M = l[v];
          d(M, v, l) && (m.push(M), E.push(v));
        }
        return lb(l, E), m;
      }
      function lp(l) {
        return l == null ? l : N_.call(l);
      }
      function HI(l, d, m) {
        var v = l == null ? 0 : l.length;
        return v ? (m && typeof m != "number" && qn(l, d, m) ? (d = 0, m = v) : (d = d == null ? 0 : Ue(d), m = m === t ? v : Ue(m)), Fr(l, d, m)) : [];
      }
      function WI(l, d) {
        return vu(l, d);
      }
      function UI(l, d, m) {
        return $h(l, d, Ie(m, 2));
      }
      function $I(l, d) {
        var m = l == null ? 0 : l.length;
        if (m) {
          var v = vu(l, d);
          if (v < m && oi(l[v], d))
            return v;
        }
        return -1;
      }
      function GI(l, d) {
        return vu(l, d, !0);
      }
      function YI(l, d, m) {
        return $h(l, d, Ie(m, 2), !0);
      }
      function qI(l, d) {
        var m = l == null ? 0 : l.length;
        if (m) {
          var v = vu(l, d, !0) - 1;
          if (oi(l[v], d))
            return v;
        }
        return -1;
      }
      function KI(l) {
        return l && l.length ? ub(l) : [];
      }
      function JI(l, d) {
        return l && l.length ? ub(l, Ie(d, 2)) : [];
      }
      function QI(l) {
        var d = l == null ? 0 : l.length;
        return d ? Fr(l, 1, d) : [];
      }
      function ZI(l, d, m) {
        return l && l.length ? (d = m || d === t ? 1 : Ue(d), Fr(l, 0, d < 0 ? 0 : d)) : [];
      }
      function XI(l, d, m) {
        var v = l == null ? 0 : l.length;
        return v ? (d = m || d === t ? 1 : Ue(d), d = v - d, Fr(l, d < 0 ? 0 : d, v)) : [];
      }
      function eN(l, d) {
        return l && l.length ? bu(l, Ie(d, 3), !1, !0) : [];
      }
      function tN(l, d) {
        return l && l.length ? bu(l, Ie(d, 3)) : [];
      }
      var nN = Ze(function(l) {
        return Ts(Dn(l, 1, Zt, !0));
      }), rN = Ze(function(l) {
        var d = zr(l);
        return Zt(d) && (d = t), Ts(Dn(l, 1, Zt, !0), Ie(d, 2));
      }), iN = Ze(function(l) {
        var d = zr(l);
        return d = typeof d == "function" ? d : t, Ts(Dn(l, 1, Zt, !0), t, d);
      });
      function sN(l) {
        return l && l.length ? Ts(l) : [];
      }
      function oN(l, d) {
        return l && l.length ? Ts(l, Ie(d, 2)) : [];
      }
      function aN(l, d) {
        return d = typeof d == "function" ? d : t, l && l.length ? Ts(l, t, d) : [];
      }
      function cp(l) {
        if (!(l && l.length))
          return [];
        var d = 0;
        return l = xs(l, function(m) {
          if (Zt(m))
            return d = dn(m.length, d), !0;
        }), Ch(d, function(m) {
          return Nt(l, Eh(m));
        });
      }
      function Jb(l, d) {
        if (!(l && l.length))
          return [];
        var m = cp(l);
        return d == null ? m : Nt(m, function(v) {
          return xr(d, t, v);
        });
      }
      var lN = Ze(function(l, d) {
        return Zt(l) ? bl(l, d) : [];
      }), cN = Ze(function(l) {
        return Yh(xs(l, Zt));
      }), uN = Ze(function(l) {
        var d = zr(l);
        return Zt(d) && (d = t), Yh(xs(l, Zt), Ie(d, 2));
      }), dN = Ze(function(l) {
        var d = zr(l);
        return d = typeof d == "function" ? d : t, Yh(xs(l, Zt), t, d);
      }), fN = Ze(cp);
      function hN(l, d) {
        return pb(l || [], d || [], vl);
      }
      function pN(l, d) {
        return pb(l || [], d || [], wl);
      }
      var mN = Ze(function(l) {
        var d = l.length, m = d > 1 ? l[d - 1] : t;
        return m = typeof m == "function" ? (l.pop(), m) : t, Jb(l, m);
      });
      function Qb(l) {
        var d = A(l);
        return d.__chain__ = !0, d;
      }
      function gN(l, d) {
        return d(l), l;
      }
      function Ru(l, d) {
        return d(l);
      }
      var yN = Wi(function(l) {
        var d = l.length, m = d ? l[0] : 0, v = this.__wrapped__, E = function(D) {
          return Nh(D, l);
        };
        return d > 1 || this.__actions__.length || !(v instanceof nt) || !Ui(m) ? this.thru(E) : (v = v.slice(m, +m + (d ? 1 : 0)), v.__actions__.push({
          func: Ru,
          args: [E],
          thisArg: t
        }), new Br(v, this.__chain__).thru(function(D) {
          return d && !D.length && D.push(t), D;
        }));
      });
      function vN() {
        return Qb(this);
      }
      function bN() {
        return new Br(this.value(), this.__chain__);
      }
      function xN() {
        this.__values__ === t && (this.__values__ = dx(this.value()));
        var l = this.__index__ >= this.__values__.length, d = l ? t : this.__values__[this.__index__++];
        return { done: l, value: d };
      }
      function SN() {
        return this;
      }
      function wN(l) {
        for (var d, m = this; m instanceof hu; ) {
          var v = Ub(m);
          v.__index__ = 0, v.__values__ = t, d ? E.__wrapped__ = v : d = v;
          var E = v;
          m = m.__wrapped__;
        }
        return E.__wrapped__ = l, d;
      }
      function EN() {
        var l = this.__wrapped__;
        if (l instanceof nt) {
          var d = l;
          return this.__actions__.length && (d = new nt(this)), d = d.reverse(), d.__actions__.push({
            func: Ru,
            args: [lp],
            thisArg: t
          }), new Br(d, this.__chain__);
        }
        return this.thru(lp);
      }
      function AN() {
        return hb(this.__wrapped__, this.__actions__);
      }
      var TN = xu(function(l, d, m) {
        ut.call(l, m) ? ++l[m] : Vi(l, m, 1);
      });
      function CN(l, d, m) {
        var v = He(l) ? C0 : gO;
        return m && qn(l, d, m) && (d = t), v(l, Ie(d, 3));
      }
      function DN(l, d) {
        var m = He(l) ? xs : J0;
        return m(l, Ie(d, 3));
      }
      var RN = Ab($b), kN = Ab(Gb);
      function MN(l, d) {
        return Dn(ku(l, d), 1);
      }
      function _N(l, d) {
        return Dn(ku(l, d), $);
      }
      function ON(l, d, m) {
        return m = m === t ? 1 : Ue(m), Dn(ku(l, d), m);
      }
      function Zb(l, d) {
        var m = He(l) ? Pr : As;
        return m(l, Ie(d, 3));
      }
      function Xb(l, d) {
        var m = He(l) ? QM : K0;
        return m(l, Ie(d, 3));
      }
      var IN = xu(function(l, d, m) {
        ut.call(l, m) ? l[m].push(d) : Vi(l, m, [d]);
      });
      function NN(l, d, m, v) {
        l = cr(l) ? l : xa(l), m = m && !v ? Ue(m) : 0;
        var E = l.length;
        return m < 0 && (m = dn(E + m, 0)), Nu(l) ? m <= E && l.indexOf(d, m) > -1 : !!E && la(l, d, m) > -1;
      }
      var PN = Ze(function(l, d, m) {
        var v = -1, E = typeof d == "function", D = cr(l) ? H(l.length) : [];
        return As(l, function(M) {
          D[++v] = E ? xr(d, M, m) : xl(M, d, m);
        }), D;
      }), LN = xu(function(l, d, m) {
        Vi(l, m, d);
      });
      function ku(l, d) {
        var m = He(l) ? Nt : nb;
        return m(l, Ie(d, 3));
      }
      function BN(l, d, m, v) {
        return l == null ? [] : (He(d) || (d = d == null ? [] : [d]), m = v ? t : m, He(m) || (m = m == null ? [] : [m]), ob(l, d, m));
      }
      var jN = xu(function(l, d, m) {
        l[m ? 0 : 1].push(d);
      }, function() {
        return [[], []];
      });
      function FN(l, d, m) {
        var v = He(l) ? Sh : M0, E = arguments.length < 3;
        return v(l, Ie(d, 4), m, E, As);
      }
      function zN(l, d, m) {
        var v = He(l) ? ZM : M0, E = arguments.length < 3;
        return v(l, Ie(d, 4), m, E, K0);
      }
      function VN(l, d) {
        var m = He(l) ? xs : J0;
        return m(l, Ou(Ie(d, 3)));
      }
      function HN(l) {
        var d = He(l) ? $0 : NO;
        return d(l);
      }
      function WN(l, d, m) {
        (m ? qn(l, d, m) : d === t) ? d = 1 : d = Ue(d);
        var v = He(l) ? dO : PO;
        return v(l, d);
      }
      function UN(l) {
        var d = He(l) ? fO : BO;
        return d(l);
      }
      function $N(l) {
        if (l == null)
          return 0;
        if (cr(l))
          return Nu(l) ? ua(l) : l.length;
        var d = Fn(l);
        return d == mt || d == Jt ? l.size : zh(l).length;
      }
      function GN(l, d, m) {
        var v = He(l) ? wh : jO;
        return m && qn(l, d, m) && (d = t), v(l, Ie(d, 3));
      }
      var YN = Ze(function(l, d) {
        if (l == null)
          return [];
        var m = d.length;
        return m > 1 && qn(l, d[0], d[1]) ? d = [] : m > 2 && qn(d[0], d[1], d[2]) && (d = [d[0]]), ob(l, Dn(d, 1), []);
      }), Mu = D_ || function() {
        return Cn.Date.now();
      };
      function qN(l, d) {
        if (typeof d != "function")
          throw new Lr(o);
        return l = Ue(l), function() {
          if (--l < 1)
            return d.apply(this, arguments);
        };
      }
      function ex(l, d, m) {
        return d = m ? t : d, d = l && d == null ? l.length : d, Hi(l, L, t, t, t, t, d);
      }
      function tx(l, d) {
        var m;
        if (typeof d != "function")
          throw new Lr(o);
        return l = Ue(l), function() {
          return --l > 0 && (m = d.apply(this, arguments)), l <= 1 && (d = t), m;
        };
      }
      var up = Ze(function(l, d, m) {
        var v = S;
        if (m.length) {
          var E = ws(m, va(up));
          v |= R;
        }
        return Hi(l, v, d, m, E);
      }), nx = Ze(function(l, d, m) {
        var v = S | w;
        if (m.length) {
          var E = ws(m, va(nx));
          v |= R;
        }
        return Hi(d, v, l, m, E);
      });
      function rx(l, d, m) {
        d = m ? t : d;
        var v = Hi(l, T, t, t, t, t, t, d);
        return v.placeholder = rx.placeholder, v;
      }
      function ix(l, d, m) {
        d = m ? t : d;
        var v = Hi(l, k, t, t, t, t, t, d);
        return v.placeholder = ix.placeholder, v;
      }
      function sx(l, d, m) {
        var v, E, D, M, N, F, Z = 0, te = !1, oe = !1, ye = !0;
        if (typeof l != "function")
          throw new Lr(o);
        d = Vr(d) || 0, Ft(m) && (te = !!m.leading, oe = "maxWait" in m, D = oe ? dn(Vr(m.maxWait) || 0, d) : D, ye = "trailing" in m ? !!m.trailing : ye);
        function De(Xt) {
          var ai = v, Yi = E;
          return v = E = t, Z = Xt, M = l.apply(Yi, ai), M;
        }
        function Pe(Xt) {
          return Z = Xt, N = Tl(tt, d), te ? De(Xt) : M;
        }
        function qe(Xt) {
          var ai = Xt - F, Yi = Xt - Z, Ax = d - ai;
          return oe ? jn(Ax, D - Yi) : Ax;
        }
        function Le(Xt) {
          var ai = Xt - F, Yi = Xt - Z;
          return F === t || ai >= d || ai < 0 || oe && Yi >= D;
        }
        function tt() {
          var Xt = Mu();
          if (Le(Xt))
            return it(Xt);
          N = Tl(tt, qe(Xt));
        }
        function it(Xt) {
          return N = t, ye && v ? De(Xt) : (v = E = t, M);
        }
        function Ar() {
          N !== t && mb(N), Z = 0, v = F = E = N = t;
        }
        function Kn() {
          return N === t ? M : it(Mu());
        }
        function Tr() {
          var Xt = Mu(), ai = Le(Xt);
          if (v = arguments, E = this, F = Xt, ai) {
            if (N === t)
              return Pe(F);
            if (oe)
              return mb(N), N = Tl(tt, d), De(F);
          }
          return N === t && (N = Tl(tt, d)), M;
        }
        return Tr.cancel = Ar, Tr.flush = Kn, Tr;
      }
      var KN = Ze(function(l, d) {
        return q0(l, 1, d);
      }), JN = Ze(function(l, d, m) {
        return q0(l, Vr(d) || 0, m);
      });
      function QN(l) {
        return Hi(l, W);
      }
      function _u(l, d) {
        if (typeof l != "function" || d != null && typeof d != "function")
          throw new Lr(o);
        var m = function() {
          var v = arguments, E = d ? d.apply(this, v) : v[0], D = m.cache;
          if (D.has(E))
            return D.get(E);
          var M = l.apply(this, v);
          return m.cache = D.set(E, M) || D, M;
        };
        return m.cache = new (_u.Cache || zi)(), m;
      }
      _u.Cache = zi;
      function Ou(l) {
        if (typeof l != "function")
          throw new Lr(o);
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return !l.call(this);
            case 1:
              return !l.call(this, d[0]);
            case 2:
              return !l.call(this, d[0], d[1]);
            case 3:
              return !l.call(this, d[0], d[1], d[2]);
          }
          return !l.apply(this, d);
        };
      }
      function ZN(l) {
        return tx(2, l);
      }
      var XN = FO(function(l, d) {
        d = d.length == 1 && He(d[0]) ? Nt(d[0], Sr(Ie())) : Nt(Dn(d, 1), Sr(Ie()));
        var m = d.length;
        return Ze(function(v) {
          for (var E = -1, D = jn(v.length, m); ++E < D; )
            v[E] = d[E].call(this, v[E]);
          return xr(l, this, v);
        });
      }), dp = Ze(function(l, d) {
        var m = ws(d, va(dp));
        return Hi(l, R, t, d, m);
      }), ox = Ze(function(l, d) {
        var m = ws(d, va(ox));
        return Hi(l, P, t, d, m);
      }), eP = Wi(function(l, d) {
        return Hi(l, B, t, t, t, d);
      });
      function tP(l, d) {
        if (typeof l != "function")
          throw new Lr(o);
        return d = d === t ? d : Ue(d), Ze(l, d);
      }
      function nP(l, d) {
        if (typeof l != "function")
          throw new Lr(o);
        return d = d == null ? 0 : dn(Ue(d), 0), Ze(function(m) {
          var v = m[d], E = Ds(m, 0, d);
          return v && Ss(E, v), xr(l, this, E);
        });
      }
      function rP(l, d, m) {
        var v = !0, E = !0;
        if (typeof l != "function")
          throw new Lr(o);
        return Ft(m) && (v = "leading" in m ? !!m.leading : v, E = "trailing" in m ? !!m.trailing : E), sx(l, d, {
          leading: v,
          maxWait: d,
          trailing: E
        });
      }
      function iP(l) {
        return ex(l, 1);
      }
      function sP(l, d) {
        return dp(Kh(d), l);
      }
      function oP() {
        if (!arguments.length)
          return [];
        var l = arguments[0];
        return He(l) ? l : [l];
      }
      function aP(l) {
        return jr(l, g);
      }
      function lP(l, d) {
        return d = typeof d == "function" ? d : t, jr(l, g, d);
      }
      function cP(l) {
        return jr(l, h | g);
      }
      function uP(l, d) {
        return d = typeof d == "function" ? d : t, jr(l, h | g, d);
      }
      function dP(l, d) {
        return d == null || Y0(l, d, pn(d));
      }
      function oi(l, d) {
        return l === d || l !== l && d !== d;
      }
      var fP = Au(Bh), hP = Au(function(l, d) {
        return l >= d;
      }), bo = X0(/* @__PURE__ */ function() {
        return arguments;
      }()) ? X0 : function(l) {
        return $t(l) && ut.call(l, "callee") && !F0.call(l, "callee");
      }, He = H.isArray, pP = x0 ? Sr(x0) : wO;
      function cr(l) {
        return l != null && Iu(l.length) && !$i(l);
      }
      function Zt(l) {
        return $t(l) && cr(l);
      }
      function mP(l) {
        return l === !0 || l === !1 || $t(l) && Yn(l) == ee;
      }
      var Rs = k_ || wp, gP = S0 ? Sr(S0) : EO;
      function yP(l) {
        return $t(l) && l.nodeType === 1 && !Cl(l);
      }
      function vP(l) {
        if (l == null)
          return !0;
        if (cr(l) && (He(l) || typeof l == "string" || typeof l.splice == "function" || Rs(l) || ba(l) || bo(l)))
          return !l.length;
        var d = Fn(l);
        if (d == mt || d == Jt)
          return !l.size;
        if (Al(l))
          return !zh(l).length;
        for (var m in l)
          if (ut.call(l, m))
            return !1;
        return !0;
      }
      function bP(l, d) {
        return Sl(l, d);
      }
      function xP(l, d, m) {
        m = typeof m == "function" ? m : t;
        var v = m ? m(l, d) : t;
        return v === t ? Sl(l, d, t, m) : !!v;
      }
      function fp(l) {
        if (!$t(l))
          return !1;
        var d = Yn(l);
        return d == Ee || d == pe || typeof l.message == "string" && typeof l.name == "string" && !Cl(l);
      }
      function SP(l) {
        return typeof l == "number" && V0(l);
      }
      function $i(l) {
        if (!Ft(l))
          return !1;
        var d = Yn(l);
        return d == ue || d == et || d == de || d == _r;
      }
      function ax(l) {
        return typeof l == "number" && l == Ue(l);
      }
      function Iu(l) {
        return typeof l == "number" && l > -1 && l % 1 == 0 && l <= K;
      }
      function Ft(l) {
        var d = typeof l;
        return l != null && (d == "object" || d == "function");
      }
      function $t(l) {
        return l != null && typeof l == "object";
      }
      var lx = w0 ? Sr(w0) : TO;
      function wP(l, d) {
        return l === d || Fh(l, d, np(d));
      }
      function EP(l, d, m) {
        return m = typeof m == "function" ? m : t, Fh(l, d, np(d), m);
      }
      function AP(l) {
        return cx(l) && l != +l;
      }
      function TP(l) {
        if (lI(l))
          throw new Ve(s);
        return eb(l);
      }
      function CP(l) {
        return l === null;
      }
      function DP(l) {
        return l == null;
      }
      function cx(l) {
        return typeof l == "number" || $t(l) && Yn(l) == Kt;
      }
      function Cl(l) {
        if (!$t(l) || Yn(l) != en)
          return !1;
        var d = ou(l);
        if (d === null)
          return !0;
        var m = ut.call(d, "constructor") && d.constructor;
        return typeof m == "function" && m instanceof m && nu.call(m) == E_;
      }
      var hp = E0 ? Sr(E0) : CO;
      function RP(l) {
        return ax(l) && l >= -K && l <= K;
      }
      var ux = A0 ? Sr(A0) : DO;
      function Nu(l) {
        return typeof l == "string" || !He(l) && $t(l) && Yn(l) == Pn;
      }
      function Er(l) {
        return typeof l == "symbol" || $t(l) && Yn(l) == sr;
      }
      var ba = T0 ? Sr(T0) : RO;
      function kP(l) {
        return l === t;
      }
      function MP(l) {
        return $t(l) && Fn(l) == lt;
      }
      function _P(l) {
        return $t(l) && Yn(l) == vr;
      }
      var OP = Au(Vh), IP = Au(function(l, d) {
        return l <= d;
      });
      function dx(l) {
        if (!l)
          return [];
        if (cr(l))
          return Nu(l) ? ii(l) : lr(l);
        if (hl && l[hl])
          return d_(l[hl]());
        var d = Fn(l), m = d == mt ? Rh : d == Jt ? Xc : xa;
        return m(l);
      }
      function Gi(l) {
        if (!l)
          return l === 0 ? l : 0;
        if (l = Vr(l), l === $ || l === -$) {
          var d = l < 0 ? -1 : 1;
          return d * Se;
        }
        return l === l ? l : 0;
      }
      function Ue(l) {
        var d = Gi(l), m = d % 1;
        return d === d ? m ? d - m : d : 0;
      }
      function fx(l) {
        return l ? mo(Ue(l), 0, Q) : 0;
      }
      function Vr(l) {
        if (typeof l == "number")
          return l;
        if (Er(l))
          return z;
        if (Ft(l)) {
          var d = typeof l.valueOf == "function" ? l.valueOf() : l;
          l = Ft(d) ? d + "" : d;
        }
        if (typeof l != "string")
          return l === 0 ? l : +l;
        l = _0(l);
        var m = Be.test(l);
        return m || Et.test(l) ? qM(l.slice(2), m ? 2 : 8) : We.test(l) ? z : +l;
      }
      function hx(l) {
        return wi(l, ur(l));
      }
      function NP(l) {
        return l ? mo(Ue(l), -K, K) : l === 0 ? l : 0;
      }
      function dt(l) {
        return l == null ? "" : wr(l);
      }
      var PP = ga(function(l, d) {
        if (Al(d) || cr(d)) {
          wi(d, pn(d), l);
          return;
        }
        for (var m in d)
          ut.call(d, m) && vl(l, m, d[m]);
      }), px = ga(function(l, d) {
        wi(d, ur(d), l);
      }), Pu = ga(function(l, d, m, v) {
        wi(d, ur(d), l, v);
      }), LP = ga(function(l, d, m, v) {
        wi(d, pn(d), l, v);
      }), BP = Wi(Nh);
      function jP(l, d) {
        var m = ma(l);
        return d == null ? m : G0(m, d);
      }
      var FP = Ze(function(l, d) {
        l = yt(l);
        var m = -1, v = d.length, E = v > 2 ? d[2] : t;
        for (E && qn(d[0], d[1], E) && (v = 1); ++m < v; )
          for (var D = d[m], M = ur(D), N = -1, F = M.length; ++N < F; ) {
            var Z = M[N], te = l[Z];
            (te === t || oi(te, fa[Z]) && !ut.call(l, Z)) && (l[Z] = D[Z]);
          }
        return l;
      }), zP = Ze(function(l) {
        return l.push(t, _b), xr(mx, t, l);
      });
      function VP(l, d) {
        return D0(l, Ie(d, 3), Si);
      }
      function HP(l, d) {
        return D0(l, Ie(d, 3), Lh);
      }
      function WP(l, d) {
        return l == null ? l : Ph(l, Ie(d, 3), ur);
      }
      function UP(l, d) {
        return l == null ? l : Q0(l, Ie(d, 3), ur);
      }
      function $P(l, d) {
        return l && Si(l, Ie(d, 3));
      }
      function GP(l, d) {
        return l && Lh(l, Ie(d, 3));
      }
      function YP(l) {
        return l == null ? [] : gu(l, pn(l));
      }
      function qP(l) {
        return l == null ? [] : gu(l, ur(l));
      }
      function pp(l, d, m) {
        var v = l == null ? t : go(l, d);
        return v === t ? m : v;
      }
      function KP(l, d) {
        return l != null && Nb(l, d, vO);
      }
      function mp(l, d) {
        return l != null && Nb(l, d, bO);
      }
      var JP = Cb(function(l, d, m) {
        d != null && typeof d.toString != "function" && (d = ru.call(d)), l[d] = m;
      }, yp(dr)), QP = Cb(function(l, d, m) {
        d != null && typeof d.toString != "function" && (d = ru.call(d)), ut.call(l, d) ? l[d].push(m) : l[d] = [m];
      }, Ie), ZP = Ze(xl);
      function pn(l) {
        return cr(l) ? U0(l) : zh(l);
      }
      function ur(l) {
        return cr(l) ? U0(l, !0) : kO(l);
      }
      function XP(l, d) {
        var m = {};
        return d = Ie(d, 3), Si(l, function(v, E, D) {
          Vi(m, d(v, E, D), v);
        }), m;
      }
      function eL(l, d) {
        var m = {};
        return d = Ie(d, 3), Si(l, function(v, E, D) {
          Vi(m, E, d(v, E, D));
        }), m;
      }
      var tL = ga(function(l, d, m) {
        yu(l, d, m);
      }), mx = ga(function(l, d, m, v) {
        yu(l, d, m, v);
      }), nL = Wi(function(l, d) {
        var m = {};
        if (l == null)
          return m;
        var v = !1;
        d = Nt(d, function(D) {
          return D = Cs(D, l), v || (v = D.length > 1), D;
        }), wi(l, ep(l), m), v && (m = jr(m, h | p | g, JO));
        for (var E = d.length; E--; )
          Gh(m, d[E]);
        return m;
      });
      function rL(l, d) {
        return gx(l, Ou(Ie(d)));
      }
      var iL = Wi(function(l, d) {
        return l == null ? {} : _O(l, d);
      });
      function gx(l, d) {
        if (l == null)
          return {};
        var m = Nt(ep(l), function(v) {
          return [v];
        });
        return d = Ie(d), ab(l, m, function(v, E) {
          return d(v, E[0]);
        });
      }
      function sL(l, d, m) {
        d = Cs(d, l);
        var v = -1, E = d.length;
        for (E || (E = 1, l = t); ++v < E; ) {
          var D = l == null ? t : l[Ei(d[v])];
          D === t && (v = E, D = m), l = $i(D) ? D.call(l) : D;
        }
        return l;
      }
      function oL(l, d, m) {
        return l == null ? l : wl(l, d, m);
      }
      function aL(l, d, m, v) {
        return v = typeof v == "function" ? v : t, l == null ? l : wl(l, d, m, v);
      }
      var yx = kb(pn), vx = kb(ur);
      function lL(l, d, m) {
        var v = He(l), E = v || Rs(l) || ba(l);
        if (d = Ie(d, 4), m == null) {
          var D = l && l.constructor;
          E ? m = v ? new D() : [] : Ft(l) ? m = $i(D) ? ma(ou(l)) : {} : m = {};
        }
        return (E ? Pr : Si)(l, function(M, N, F) {
          return d(m, M, N, F);
        }), m;
      }
      function cL(l, d) {
        return l == null ? !0 : Gh(l, d);
      }
      function uL(l, d, m) {
        return l == null ? l : fb(l, d, Kh(m));
      }
      function dL(l, d, m, v) {
        return v = typeof v == "function" ? v : t, l == null ? l : fb(l, d, Kh(m), v);
      }
      function xa(l) {
        return l == null ? [] : Dh(l, pn(l));
      }
      function fL(l) {
        return l == null ? [] : Dh(l, ur(l));
      }
      function hL(l, d, m) {
        return m === t && (m = d, d = t), m !== t && (m = Vr(m), m = m === m ? m : 0), d !== t && (d = Vr(d), d = d === d ? d : 0), mo(Vr(l), d, m);
      }
      function pL(l, d, m) {
        return d = Gi(d), m === t ? (m = d, d = 0) : m = Gi(m), l = Vr(l), xO(l, d, m);
      }
      function mL(l, d, m) {
        if (m && typeof m != "boolean" && qn(l, d, m) && (d = m = t), m === t && (typeof d == "boolean" ? (m = d, d = t) : typeof l == "boolean" && (m = l, l = t)), l === t && d === t ? (l = 0, d = 1) : (l = Gi(l), d === t ? (d = l, l = 0) : d = Gi(d)), l > d) {
          var v = l;
          l = d, d = v;
        }
        if (m || l % 1 || d % 1) {
          var E = H0();
          return jn(l + E * (d - l + YM("1e-" + ((E + "").length - 1))), d);
        }
        return Wh(l, d);
      }
      var gL = ya(function(l, d, m) {
        return d = d.toLowerCase(), l + (m ? bx(d) : d);
      });
      function bx(l) {
        return gp(dt(l).toLowerCase());
      }
      function xx(l) {
        return l = dt(l), l && l.replace(Tn, o_).replace(BM, "");
      }
      function yL(l, d, m) {
        l = dt(l), d = wr(d);
        var v = l.length;
        m = m === t ? v : mo(Ue(m), 0, v);
        var E = m;
        return m -= d.length, m >= 0 && l.slice(m, E) == d;
      }
      function vL(l) {
        return l = dt(l), l && ao.test(l) ? l.replace(ys, a_) : l;
      }
      function bL(l) {
        return l = dt(l), l && co.test(l) ? l.replace(bs, "\\$&") : l;
      }
      var xL = ya(function(l, d, m) {
        return l + (m ? "-" : "") + d.toLowerCase();
      }), SL = ya(function(l, d, m) {
        return l + (m ? " " : "") + d.toLowerCase();
      }), wL = Eb("toLowerCase");
      function EL(l, d, m) {
        l = dt(l), d = Ue(d);
        var v = d ? ua(l) : 0;
        if (!d || v >= d)
          return l;
        var E = (d - v) / 2;
        return Eu(uu(E), m) + l + Eu(cu(E), m);
      }
      function AL(l, d, m) {
        l = dt(l), d = Ue(d);
        var v = d ? ua(l) : 0;
        return d && v < d ? l + Eu(d - v, m) : l;
      }
      function TL(l, d, m) {
        l = dt(l), d = Ue(d);
        var v = d ? ua(l) : 0;
        return d && v < d ? Eu(d - v, m) + l : l;
      }
      function CL(l, d, m) {
        return m || d == null ? d = 0 : d && (d = +d), I_(dt(l).replace(ji, ""), d || 0);
      }
      function DL(l, d, m) {
        return (m ? qn(l, d, m) : d === t) ? d = 1 : d = Ue(d), Uh(dt(l), d);
      }
      function RL() {
        var l = arguments, d = dt(l[0]);
        return l.length < 3 ? d : d.replace(l[1], l[2]);
      }
      var kL = ya(function(l, d, m) {
        return l + (m ? "_" : "") + d.toLowerCase();
      });
      function ML(l, d, m) {
        return m && typeof m != "number" && qn(l, d, m) && (d = m = t), m = m === t ? Q : m >>> 0, m ? (l = dt(l), l && (typeof d == "string" || d != null && !hp(d)) && (d = wr(d), !d && ca(l)) ? Ds(ii(l), 0, m) : l.split(d, m)) : [];
      }
      var _L = ya(function(l, d, m) {
        return l + (m ? " " : "") + gp(d);
      });
      function OL(l, d, m) {
        return l = dt(l), m = m == null ? 0 : mo(Ue(m), 0, l.length), d = wr(d), l.slice(m, m + d.length) == d;
      }
      function IL(l, d, m) {
        var v = A.templateSettings;
        m && qn(l, d, m) && (d = t), l = dt(l), d = Pu({}, d, v, Mb);
        var E = Pu({}, d.imports, v.imports, Mb), D = pn(E), M = Dh(E, D), N, F, Z = 0, te = d.interpolate || ar, oe = "__p += '", ye = kh(
          (d.escape || ar).source + "|" + te.source + "|" + (te === lo ? rt : ar).source + "|" + (d.evaluate || ar).source + "|$",
          "g"
        ), De = "//# sourceURL=" + (ut.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++HM + "]") + `
`;
        l.replace(ye, function(Le, tt, it, Ar, Kn, Tr) {
          return it || (it = Ar), oe += l.slice(Z, Tr).replace(br, l_), tt && (N = !0, oe += `' +
__e(` + tt + `) +
'`), Kn && (F = !0, oe += `';
` + Kn + `;
__p += '`), it && (oe += `' +
((__t = (` + it + `)) == null ? '' : __t) +
'`), Z = Tr + Le.length, Le;
        }), oe += `';
`;
        var Pe = ut.call(d, "variable") && d.variable;
        if (!Pe)
          oe = `with (obj) {
` + oe + `
}
`;
        else if (be.test(Pe))
          throw new Ve(a);
        oe = (F ? oe.replace(Ln, "") : oe).replace(ni, "$1").replace(Ir, "$1;"), oe = "function(" + (Pe || "obj") + `) {
` + (Pe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (N ? ", __e = _.escape" : "") + (F ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + oe + `return __p
}`;
        var qe = wx(function() {
          return ct(D, De + "return " + oe).apply(t, M);
        });
        if (qe.source = oe, fp(qe))
          throw qe;
        return qe;
      }
      function NL(l) {
        return dt(l).toLowerCase();
      }
      function PL(l) {
        return dt(l).toUpperCase();
      }
      function LL(l, d, m) {
        if (l = dt(l), l && (m || d === t))
          return _0(l);
        if (!l || !(d = wr(d)))
          return l;
        var v = ii(l), E = ii(d), D = O0(v, E), M = I0(v, E) + 1;
        return Ds(v, D, M).join("");
      }
      function BL(l, d, m) {
        if (l = dt(l), l && (m || d === t))
          return l.slice(0, P0(l) + 1);
        if (!l || !(d = wr(d)))
          return l;
        var v = ii(l), E = I0(v, ii(d)) + 1;
        return Ds(v, 0, E).join("");
      }
      function jL(l, d, m) {
        if (l = dt(l), l && (m || d === t))
          return l.replace(ji, "");
        if (!l || !(d = wr(d)))
          return l;
        var v = ii(l), E = O0(v, ii(d));
        return Ds(v, E).join("");
      }
      function FL(l, d) {
        var m = X, v = ce;
        if (Ft(d)) {
          var E = "separator" in d ? d.separator : E;
          m = "length" in d ? Ue(d.length) : m, v = "omission" in d ? wr(d.omission) : v;
        }
        l = dt(l);
        var D = l.length;
        if (ca(l)) {
          var M = ii(l);
          D = M.length;
        }
        if (m >= D)
          return l;
        var N = m - ua(v);
        if (N < 1)
          return v;
        var F = M ? Ds(M, 0, N).join("") : l.slice(0, N);
        if (E === t)
          return F + v;
        if (M && (N += F.length - N), hp(E)) {
          if (l.slice(N).search(E)) {
            var Z, te = F;
            for (E.global || (E = kh(E.source, dt(st.exec(E)) + "g")), E.lastIndex = 0; Z = E.exec(te); )
              var oe = Z.index;
            F = F.slice(0, oe === t ? N : oe);
          }
        } else if (l.indexOf(wr(E), N) != N) {
          var ye = F.lastIndexOf(E);
          ye > -1 && (F = F.slice(0, ye));
        }
        return F + v;
      }
      function zL(l) {
        return l = dt(l), l && vs.test(l) ? l.replace(vi, m_) : l;
      }
      var VL = ya(function(l, d, m) {
        return l + (m ? " " : "") + d.toUpperCase();
      }), gp = Eb("toUpperCase");
      function Sx(l, d, m) {
        return l = dt(l), d = m ? t : d, d === t ? u_(l) ? v_(l) : t_(l) : l.match(d) || [];
      }
      var wx = Ze(function(l, d) {
        try {
          return xr(l, t, d);
        } catch (m) {
          return fp(m) ? m : new Ve(m);
        }
      }), HL = Wi(function(l, d) {
        return Pr(d, function(m) {
          m = Ei(m), Vi(l, m, up(l[m], l));
        }), l;
      });
      function WL(l) {
        var d = l == null ? 0 : l.length, m = Ie();
        return l = d ? Nt(l, function(v) {
          if (typeof v[1] != "function")
            throw new Lr(o);
          return [m(v[0]), v[1]];
        }) : [], Ze(function(v) {
          for (var E = -1; ++E < d; ) {
            var D = l[E];
            if (xr(D[0], this, v))
              return xr(D[1], this, v);
          }
        });
      }
      function UL(l) {
        return mO(jr(l, h));
      }
      function yp(l) {
        return function() {
          return l;
        };
      }
      function $L(l, d) {
        return l == null || l !== l ? d : l;
      }
      var GL = Tb(), YL = Tb(!0);
      function dr(l) {
        return l;
      }
      function vp(l) {
        return tb(typeof l == "function" ? l : jr(l, h));
      }
      function qL(l) {
        return rb(jr(l, h));
      }
      function KL(l, d) {
        return ib(l, jr(d, h));
      }
      var JL = Ze(function(l, d) {
        return function(m) {
          return xl(m, l, d);
        };
      }), QL = Ze(function(l, d) {
        return function(m) {
          return xl(l, m, d);
        };
      });
      function bp(l, d, m) {
        var v = pn(d), E = gu(d, v);
        m == null && !(Ft(d) && (E.length || !v.length)) && (m = d, d = l, l = this, E = gu(d, pn(d)));
        var D = !(Ft(m) && "chain" in m) || !!m.chain, M = $i(l);
        return Pr(E, function(N) {
          var F = d[N];
          l[N] = F, M && (l.prototype[N] = function() {
            var Z = this.__chain__;
            if (D || Z) {
              var te = l(this.__wrapped__), oe = te.__actions__ = lr(this.__actions__);
              return oe.push({ func: F, args: arguments, thisArg: l }), te.__chain__ = Z, te;
            }
            return F.apply(l, Ss([this.value()], arguments));
          });
        }), l;
      }
      function ZL() {
        return Cn._ === this && (Cn._ = A_), this;
      }
      function xp() {
      }
      function XL(l) {
        return l = Ue(l), Ze(function(d) {
          return sb(d, l);
        });
      }
      var e2 = Qh(Nt), t2 = Qh(C0), n2 = Qh(wh);
      function Ex(l) {
        return ip(l) ? Eh(Ei(l)) : OO(l);
      }
      function r2(l) {
        return function(d) {
          return l == null ? t : go(l, d);
        };
      }
      var i2 = Db(), s2 = Db(!0);
      function Sp() {
        return [];
      }
      function wp() {
        return !1;
      }
      function o2() {
        return {};
      }
      function a2() {
        return "";
      }
      function l2() {
        return !0;
      }
      function c2(l, d) {
        if (l = Ue(l), l < 1 || l > K)
          return [];
        var m = Q, v = jn(l, Q);
        d = Ie(d), l -= Q;
        for (var E = Ch(v, d); ++m < l; )
          d(m);
        return E;
      }
      function u2(l) {
        return He(l) ? Nt(l, Ei) : Er(l) ? [l] : lr(Wb(dt(l)));
      }
      function d2(l) {
        var d = ++w_;
        return dt(l) + d;
      }
      var f2 = wu(function(l, d) {
        return l + d;
      }, 0), h2 = Zh("ceil"), p2 = wu(function(l, d) {
        return l / d;
      }, 1), m2 = Zh("floor");
      function g2(l) {
        return l && l.length ? mu(l, dr, Bh) : t;
      }
      function y2(l, d) {
        return l && l.length ? mu(l, Ie(d, 2), Bh) : t;
      }
      function v2(l) {
        return k0(l, dr);
      }
      function b2(l, d) {
        return k0(l, Ie(d, 2));
      }
      function x2(l) {
        return l && l.length ? mu(l, dr, Vh) : t;
      }
      function S2(l, d) {
        return l && l.length ? mu(l, Ie(d, 2), Vh) : t;
      }
      var w2 = wu(function(l, d) {
        return l * d;
      }, 1), E2 = Zh("round"), A2 = wu(function(l, d) {
        return l - d;
      }, 0);
      function T2(l) {
        return l && l.length ? Th(l, dr) : 0;
      }
      function C2(l, d) {
        return l && l.length ? Th(l, Ie(d, 2)) : 0;
      }
      return A.after = qN, A.ary = ex, A.assign = PP, A.assignIn = px, A.assignInWith = Pu, A.assignWith = LP, A.at = BP, A.before = tx, A.bind = up, A.bindAll = HL, A.bindKey = nx, A.castArray = oP, A.chain = Qb, A.chunk = mI, A.compact = gI, A.concat = yI, A.cond = WL, A.conforms = UL, A.constant = yp, A.countBy = TN, A.create = jP, A.curry = rx, A.curryRight = ix, A.debounce = sx, A.defaults = FP, A.defaultsDeep = zP, A.defer = KN, A.delay = JN, A.difference = vI, A.differenceBy = bI, A.differenceWith = xI, A.drop = SI, A.dropRight = wI, A.dropRightWhile = EI, A.dropWhile = AI, A.fill = TI, A.filter = DN, A.flatMap = MN, A.flatMapDeep = _N, A.flatMapDepth = ON, A.flatten = Yb, A.flattenDeep = CI, A.flattenDepth = DI, A.flip = QN, A.flow = GL, A.flowRight = YL, A.fromPairs = RI, A.functions = YP, A.functionsIn = qP, A.groupBy = IN, A.initial = MI, A.intersection = _I, A.intersectionBy = OI, A.intersectionWith = II, A.invert = JP, A.invertBy = QP, A.invokeMap = PN, A.iteratee = vp, A.keyBy = LN, A.keys = pn, A.keysIn = ur, A.map = ku, A.mapKeys = XP, A.mapValues = eL, A.matches = qL, A.matchesProperty = KL, A.memoize = _u, A.merge = tL, A.mergeWith = mx, A.method = JL, A.methodOf = QL, A.mixin = bp, A.negate = Ou, A.nthArg = XL, A.omit = nL, A.omitBy = rL, A.once = ZN, A.orderBy = BN, A.over = e2, A.overArgs = XN, A.overEvery = t2, A.overSome = n2, A.partial = dp, A.partialRight = ox, A.partition = jN, A.pick = iL, A.pickBy = gx, A.property = Ex, A.propertyOf = r2, A.pull = BI, A.pullAll = Kb, A.pullAllBy = jI, A.pullAllWith = FI, A.pullAt = zI, A.range = i2, A.rangeRight = s2, A.rearg = eP, A.reject = VN, A.remove = VI, A.rest = tP, A.reverse = lp, A.sampleSize = WN, A.set = oL, A.setWith = aL, A.shuffle = UN, A.slice = HI, A.sortBy = YN, A.sortedUniq = KI, A.sortedUniqBy = JI, A.split = ML, A.spread = nP, A.tail = QI, A.take = ZI, A.takeRight = XI, A.takeRightWhile = eN, A.takeWhile = tN, A.tap = gN, A.throttle = rP, A.thru = Ru, A.toArray = dx, A.toPairs = yx, A.toPairsIn = vx, A.toPath = u2, A.toPlainObject = hx, A.transform = lL, A.unary = iP, A.union = nN, A.unionBy = rN, A.unionWith = iN, A.uniq = sN, A.uniqBy = oN, A.uniqWith = aN, A.unset = cL, A.unzip = cp, A.unzipWith = Jb, A.update = uL, A.updateWith = dL, A.values = xa, A.valuesIn = fL, A.without = lN, A.words = Sx, A.wrap = sP, A.xor = cN, A.xorBy = uN, A.xorWith = dN, A.zip = fN, A.zipObject = hN, A.zipObjectDeep = pN, A.zipWith = mN, A.entries = yx, A.entriesIn = vx, A.extend = px, A.extendWith = Pu, bp(A, A), A.add = f2, A.attempt = wx, A.camelCase = gL, A.capitalize = bx, A.ceil = h2, A.clamp = hL, A.clone = aP, A.cloneDeep = cP, A.cloneDeepWith = uP, A.cloneWith = lP, A.conformsTo = dP, A.deburr = xx, A.defaultTo = $L, A.divide = p2, A.endsWith = yL, A.eq = oi, A.escape = vL, A.escapeRegExp = bL, A.every = CN, A.find = RN, A.findIndex = $b, A.findKey = VP, A.findLast = kN, A.findLastIndex = Gb, A.findLastKey = HP, A.floor = m2, A.forEach = Zb, A.forEachRight = Xb, A.forIn = WP, A.forInRight = UP, A.forOwn = $P, A.forOwnRight = GP, A.get = pp, A.gt = fP, A.gte = hP, A.has = KP, A.hasIn = mp, A.head = qb, A.identity = dr, A.includes = NN, A.indexOf = kI, A.inRange = pL, A.invoke = ZP, A.isArguments = bo, A.isArray = He, A.isArrayBuffer = pP, A.isArrayLike = cr, A.isArrayLikeObject = Zt, A.isBoolean = mP, A.isBuffer = Rs, A.isDate = gP, A.isElement = yP, A.isEmpty = vP, A.isEqual = bP, A.isEqualWith = xP, A.isError = fp, A.isFinite = SP, A.isFunction = $i, A.isInteger = ax, A.isLength = Iu, A.isMap = lx, A.isMatch = wP, A.isMatchWith = EP, A.isNaN = AP, A.isNative = TP, A.isNil = DP, A.isNull = CP, A.isNumber = cx, A.isObject = Ft, A.isObjectLike = $t, A.isPlainObject = Cl, A.isRegExp = hp, A.isSafeInteger = RP, A.isSet = ux, A.isString = Nu, A.isSymbol = Er, A.isTypedArray = ba, A.isUndefined = kP, A.isWeakMap = MP, A.isWeakSet = _P, A.join = NI, A.kebabCase = xL, A.last = zr, A.lastIndexOf = PI, A.lowerCase = SL, A.lowerFirst = wL, A.lt = OP, A.lte = IP, A.max = g2, A.maxBy = y2, A.mean = v2, A.meanBy = b2, A.min = x2, A.minBy = S2, A.stubArray = Sp, A.stubFalse = wp, A.stubObject = o2, A.stubString = a2, A.stubTrue = l2, A.multiply = w2, A.nth = LI, A.noConflict = ZL, A.noop = xp, A.now = Mu, A.pad = EL, A.padEnd = AL, A.padStart = TL, A.parseInt = CL, A.random = mL, A.reduce = FN, A.reduceRight = zN, A.repeat = DL, A.replace = RL, A.result = sL, A.round = E2, A.runInContext = j, A.sample = HN, A.size = $N, A.snakeCase = kL, A.some = GN, A.sortedIndex = WI, A.sortedIndexBy = UI, A.sortedIndexOf = $I, A.sortedLastIndex = GI, A.sortedLastIndexBy = YI, A.sortedLastIndexOf = qI, A.startCase = _L, A.startsWith = OL, A.subtract = A2, A.sum = T2, A.sumBy = C2, A.template = IL, A.times = c2, A.toFinite = Gi, A.toInteger = Ue, A.toLength = fx, A.toLower = NL, A.toNumber = Vr, A.toSafeInteger = NP, A.toString = dt, A.toUpper = PL, A.trim = LL, A.trimEnd = BL, A.trimStart = jL, A.truncate = FL, A.unescape = zL, A.uniqueId = d2, A.upperCase = VL, A.upperFirst = gp, A.each = Zb, A.eachRight = Xb, A.first = qb, bp(A, function() {
        var l = {};
        return Si(A, function(d, m) {
          ut.call(A.prototype, m) || (l[m] = d);
        }), l;
      }(), { chain: !1 }), A.VERSION = r, Pr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
        A[l].placeholder = A;
      }), Pr(["drop", "take"], function(l, d) {
        nt.prototype[l] = function(m) {
          m = m === t ? 1 : dn(Ue(m), 0);
          var v = this.__filtered__ && !d ? new nt(this) : this.clone();
          return v.__filtered__ ? v.__takeCount__ = jn(m, v.__takeCount__) : v.__views__.push({
            size: jn(m, Q),
            type: l + (v.__dir__ < 0 ? "Right" : "")
          }), v;
        }, nt.prototype[l + "Right"] = function(m) {
          return this.reverse()[l](m).reverse();
        };
      }), Pr(["filter", "map", "takeWhile"], function(l, d) {
        var m = d + 1, v = m == J || m == G;
        nt.prototype[l] = function(E) {
          var D = this.clone();
          return D.__iteratees__.push({
            iteratee: Ie(E, 3),
            type: m
          }), D.__filtered__ = D.__filtered__ || v, D;
        };
      }), Pr(["head", "last"], function(l, d) {
        var m = "take" + (d ? "Right" : "");
        nt.prototype[l] = function() {
          return this[m](1).value()[0];
        };
      }), Pr(["initial", "tail"], function(l, d) {
        var m = "drop" + (d ? "" : "Right");
        nt.prototype[l] = function() {
          return this.__filtered__ ? new nt(this) : this[m](1);
        };
      }), nt.prototype.compact = function() {
        return this.filter(dr);
      }, nt.prototype.find = function(l) {
        return this.filter(l).head();
      }, nt.prototype.findLast = function(l) {
        return this.reverse().find(l);
      }, nt.prototype.invokeMap = Ze(function(l, d) {
        return typeof l == "function" ? new nt(this) : this.map(function(m) {
          return xl(m, l, d);
        });
      }), nt.prototype.reject = function(l) {
        return this.filter(Ou(Ie(l)));
      }, nt.prototype.slice = function(l, d) {
        l = Ue(l);
        var m = this;
        return m.__filtered__ && (l > 0 || d < 0) ? new nt(m) : (l < 0 ? m = m.takeRight(-l) : l && (m = m.drop(l)), d !== t && (d = Ue(d), m = d < 0 ? m.dropRight(-d) : m.take(d - l)), m);
      }, nt.prototype.takeRightWhile = function(l) {
        return this.reverse().takeWhile(l).reverse();
      }, nt.prototype.toArray = function() {
        return this.take(Q);
      }, Si(nt.prototype, function(l, d) {
        var m = /^(?:filter|find|map|reject)|While$/.test(d), v = /^(?:head|last)$/.test(d), E = A[v ? "take" + (d == "last" ? "Right" : "") : d], D = v || /^find/.test(d);
        E && (A.prototype[d] = function() {
          var M = this.__wrapped__, N = v ? [1] : arguments, F = M instanceof nt, Z = N[0], te = F || He(M), oe = function(tt) {
            var it = E.apply(A, Ss([tt], N));
            return v && ye ? it[0] : it;
          };
          te && m && typeof Z == "function" && Z.length != 1 && (F = te = !1);
          var ye = this.__chain__, De = !!this.__actions__.length, Pe = D && !ye, qe = F && !De;
          if (!D && te) {
            M = qe ? M : new nt(this);
            var Le = l.apply(M, N);
            return Le.__actions__.push({ func: Ru, args: [oe], thisArg: t }), new Br(Le, ye);
          }
          return Pe && qe ? l.apply(this, N) : (Le = this.thru(oe), Pe ? v ? Le.value()[0] : Le.value() : Le);
        });
      }), Pr(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
        var d = eu[l], m = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", v = /^(?:pop|shift)$/.test(l);
        A.prototype[l] = function() {
          var E = arguments;
          if (v && !this.__chain__) {
            var D = this.value();
            return d.apply(He(D) ? D : [], E);
          }
          return this[m](function(M) {
            return d.apply(He(M) ? M : [], E);
          });
        };
      }), Si(nt.prototype, function(l, d) {
        var m = A[d];
        if (m) {
          var v = m.name + "";
          ut.call(pa, v) || (pa[v] = []), pa[v].push({ name: d, func: m });
        }
      }), pa[Su(t, w).name] = [{
        name: "wrapper",
        func: t
      }], nt.prototype.clone = z_, nt.prototype.reverse = V_, nt.prototype.value = H_, A.prototype.at = yN, A.prototype.chain = vN, A.prototype.commit = bN, A.prototype.next = xN, A.prototype.plant = wN, A.prototype.reverse = EN, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = AN, A.prototype.first = A.prototype.head, hl && (A.prototype[hl] = SN), A;
    }, da = b_();
    uo ? ((uo.exports = da)._ = da, vh._ = da) : Cn._ = da;
  }).call(Ra);
})(Ff, Ff.exports);
var Y7 = Ff.exports;
const t1 = (n) => {
  let e;
  const t = /* @__PURE__ */ new Set(), r = (u, f) => {
    const h = typeof u == "function" ? u(e) : u;
    if (!Object.is(h, e)) {
      const p = e;
      e = f ?? (typeof h != "object" || h === null) ? h : Object.assign({}, e, h), t.forEach((g) => g(e, p));
    }
  }, i = () => e, a = { setState: r, getState: i, getInitialState: () => c, subscribe: (u) => (t.add(u), () => t.delete(u)) }, c = e = n(r, i, a);
  return a;
}, q7 = (n) => n ? t1(n) : t1, K7 = (n) => n;
function J7(n, e = K7) {
  const t = Fe.useSyncExternalStore(
    n.subscribe,
    Fe.useCallback(() => e(n.getState()), [n, e]),
    Fe.useCallback(() => e(n.getInitialState()), [n, e])
  );
  return Fe.useDebugValue(t), t;
}
const n1 = (n) => {
  const e = q7(n), t = (r) => J7(e, r);
  return Object.assign(t, e), t;
}, Q7 = (n) => n ? n1(n) : n1, xM = Q7((n) => ({
  visible: {},
  setVisible: (e, t) => {
    n((r) => ({ visible: { ...r.visible, [e]: t } }));
  },
  clear: () => n({ visible: {} })
})), dQ = (n, e) => {
  const { setVisible: t } = xM();
  St(() => (t(n, e), () => {
    t(n, !1);
  }), [e, n, t]);
}, Z7 = (n) => {
  const { children: e } = n, { visible: t } = xM(), r = Vt(() => Y7.pickBy(t, (o) => o), [t]), i = Vt(() => Object.values(t).some((o) => o), [t]), s = Vt(() => Object.keys(r), [r]);
  return St(() => {
    document.body.style.overflow = i ? "hidden" : "inherit";
  }, [i]), /* @__PURE__ */ b.jsxs(gt, { className: "loading-overlay-provider", children: [
    /* @__PURE__ */ b.jsx(
      Wf,
      {
        className: s.map((o) => `loading-${o}`).join(" "),
        visible: !!i
      }
    ),
    e
  ] });
}, r1 = {
  border: "1px solid rgba(203, 213, 225, 0.95)",
  borderRadius: 16,
  background: "rgba(255, 255, 255, 0.86)",
  color: "#111827",
  fontSize: 15,
  fontWeight: 500,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
  transition: "border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease"
}, i1 = O2({
  primaryColor: "blue",
  primaryShade: { light: 6, dark: 7 },
  defaultRadius: "md",
  radius: {
    xs: "4px",
    sm: "6px",
    md: "8px",
    lg: "14px",
    xl: "18px"
  },
  defaultGradient: {
    from: "#1c7ed6",
    to: "#1564bf",
    deg: 135
  },
  cursorType: "pointer",
  components: {
    Input: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        input: {
          ...r1,
          minHeight: 54
        },
        section: {
          color: "#6b7280"
        }
      }
    },
    InputWrapper: {
      defaultProps: {
        size: "md"
      },
      styles: {
        label: {
          color: "#374151",
          fontSize: 13,
          fontWeight: 700,
          marginBottom: 8
        },
        description: {
          color: "#6b7280",
          fontSize: 12,
          marginTop: 4
        },
        error: {
          color: "#e03131",
          fontSize: 12,
          fontWeight: 600,
          marginTop: 7
        }
      }
    },
    TextInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    PasswordInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        innerInput: {
          fontSize: 15,
          fontWeight: 500
        },
        visibilityToggle: {
          borderRadius: 12,
          color: "#6b7280"
        }
      }
    },
    Textarea: {
      defaultProps: {
        size: "md",
        radius: "lg",
        minRows: 4
      },
      styles: {
        input: {
          ...r1
        }
      }
    },
    Select: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        dropdown: {
          border: "1px solid rgba(203, 213, 225, 0.95)",
          borderRadius: 14,
          boxShadow: "0 18px 40px rgba(15, 23, 42, 0.12)"
        },
        option: {
          borderRadius: 10,
          fontWeight: 500
        }
      }
    },
    NumberInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    DateInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    DatePickerInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    TimeInput: {
      defaultProps: {
        size: "md",
        radius: "lg"
      }
    },
    Checkbox: {
      defaultProps: {
        size: "md",
        radius: "sm"
      },
      styles: {
        input: {
          borderColor: "#cbd5e1"
        },
        label: {
          color: "#4b5563",
          lineHeight: 1.5
        },
        error: {
          color: "#e03131",
          fontSize: 12,
          fontWeight: 600,
          marginTop: 6
        }
      }
    },
    Switch: {
      defaultProps: {
        size: "md",
        radius: "xl",
        color: "blue"
      },
      styles: {
        label: {
          color: "#4b5563",
          lineHeight: 1.5
        },
        track: {
          borderColor: "#cbd5e1"
        }
      }
    },
    Button: {
      defaultProps: {
        size: "md",
        radius: "lg"
      },
      styles: {
        root: {
          minHeight: 44,
          fontWeight: 700,
          transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease"
        },
        label: {
          minWidth: 0
        }
      }
    },
    ActionIcon: {
      defaultProps: {
        radius: "lg",
        variant: "subtle"
      },
      styles: {
        root: {
          transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease"
        }
      }
    },
    ThemeIcon: {
      defaultProps: {
        radius: "lg"
      }
    },
    Card: {
      defaultProps: {
        radius: "md",
        withBorder: !0,
        padding: "lg"
      },
      styles: {
        root: {
          borderColor: "rgba(229, 231, 235, 0.9)",
          boxShadow: "0 12px 30px rgba(15, 23, 42, 0.06)"
        }
      }
    },
    Paper: {
      defaultProps: {
        radius: "md",
        withBorder: !0
      },
      styles: {
        root: {
          borderColor: "rgba(229, 231, 235, 0.9)",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.05)"
        }
      }
    },
    Alert: {
      defaultProps: {
        radius: "lg"
      },
      styles: {
        root: {
          borderColor: "rgba(203, 213, 225, 0.9)"
        },
        title: {
          fontWeight: 700
        }
      }
    },
    Modal: {
      defaultProps: {
        radius: "xl",
        centered: !0
      },
      styles: {
        content: {
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.18)"
        },
        title: {
          fontWeight: 800
        }
      }
    }
  }
});
function fQ({ children: n, theme: e }) {
  const [t] = wt(
    () => new aB({
      defaultOptions: {
        queries: {
          staleTime: 6e4
        }
      }
    })
  );
  return /* @__PURE__ */ b.jsxs(I2, { theme: e ? N2(i1, e) : i1, children: [
    /* @__PURE__ */ b.jsx(V2, {}),
    /* @__PURE__ */ b.jsx(Z7, { children: /* @__PURE__ */ b.jsx(lB, { client: t, children: /* @__PURE__ */ b.jsx(z2, { children: n }) }) })
  ] });
}
function hQ({
  name: n,
  symbol: e,
  color: t = "gray",
  size: r = "lg",
  radius: i = "sm",
  variant: s = "filled",
  ...o
}) {
  return /* @__PURE__ */ b.jsxs(on, { variant: s, color: t, size: r, radius: i, ...o, children: [
    n,
    " (",
    e,
    ")"
  ] });
}
function pQ({ workShift: n, onClick: e, size: t = 32 }) {
  const r = e ? Lc : gt, i = (n == null ? void 0 : n.symbol) || "O", s = (n == null ? void 0 : n.color) || "#ced4da";
  return /* @__PURE__ */ b.jsx(
    r,
    {
      onClick: e,
      style: {
        width: t,
        height: t,
        borderRadius: "50%",
        backgroundColor: s,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: e ? "pointer" : "default",
        border: "1px solid rgba(0, 0, 0, 0.05)",
        flexShrink: 0
      },
      children: /* @__PURE__ */ b.jsx(
        ae,
        {
          c: "white",
          fw: 700,
          size: "sm",
          style: {
            lineHeight: 1,
            textShadow: "0px 0px 2px rgba(0,0,0,0.3)"
            // Slight shadow for visibility on light colors
          },
          children: i
        }
      )
    }
  );
}
function SM(n, e) {
  var t;
  return !((t = n.availableWorkShifts) != null && t.length) || n.availableWorkShifts.some((r) => r.id === e);
}
const X7 = (n) => /* @__PURE__ */ b.jsx(
  gt,
  {
    py: "xs",
    style: {
      backgroundColor: "var(--mantine-color-gray-1)",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      opacity: 0.65,
      cursor: "not-allowed"
    },
    children: /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "dimmed", fw: 500, style: { zIndex: 1, whiteSpace: "nowrap" }, children: n || "근무불가" })
  }
), eJ = ({
  shift: n,
  isPlaceholder: e,
  isFixed: t,
  wanted: r,
  wantedWorkShift: i,
  highlightBorder: s,
  highlightColor: o
}) => /* @__PURE__ */ b.jsxs(
  gt,
  {
    py: "xs",
    style: {
      backgroundColor: n != null && n.color ? e ? `${n.color}10` : `${n.color}20` : void 0,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      border: t ? `2px solid ${(n == null ? void 0 : n.color) || "gray"}` : void 0,
      opacity: e ? 0.6 : 1,
      boxShadow: s ? `inset 0 0 0 ${s}px ${o || "var(--mantine-color-red-6)"}` : void 0
    },
    children: [
      t && /* @__PURE__ */ b.jsx(
        gt,
        {
          style: {
            position: "absolute",
            top: 2,
            right: 2,
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: "var(--mantine-color-red-6)"
          }
        }
      ),
      r && /* @__PURE__ */ b.jsx(
        gt,
        {
          style: {
            position: "absolute",
            bottom: 0,
            right: 0,
            fontSize: 8,
            lineHeight: 1,
            padding: "1px 2px",
            borderTopLeftRadius: 4,
            backgroundColor: (i == null ? void 0 : i.color) || "var(--mantine-color-violet-1)",
            color: i != null && i.color ? "white" : "var(--mantine-color-violet-9)"
          },
          children: (i == null ? void 0 : i.symbol) || "O"
        }
      ),
      /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: n ? 700 : 400, c: (n == null ? void 0 : n.color) || "dimmed", style: { zIndex: 1 }, children: n ? n.symbol : "-" })
    ]
  }
), tJ = jc(function({
  nurse: e,
  dateStr: t,
  entry: r,
  wanted: i,
  workShifts: s,
  onSelect: o,
  highlights: a,
  readOnly: c = !1,
  disabled: u = !1,
  disabledReason: f
}) {
  var W;
  const h = r == null ? void 0 : r.workShiftId, p = i == null ? void 0 : i.workShiftId, g = s.find((X) => X.isOff), y = i ? p ? s.find((X) => X.id === p) : g : void 0, x = h || (y == null ? void 0 : y.id), S = s.find((X) => X.id === x), w = r == null ? void 0 : r.isFixed, C = !h && !!i, T = (a == null ? void 0 : a.map((X) => X.label).filter(Boolean)) || [], k = (W = a == null ? void 0 : a[0]) == null ? void 0 : W.color, R = a ? Math.max(...a.map((X) => X.borderSize ?? 2)) : 0, P = u ? X7(f) : eJ({
    shift: S,
    isPlaceholder: C,
    isFixed: w,
    wanted: i,
    wantedWorkShift: y,
    highlightBorder: R,
    highlightColor: k
  }), L = c || u ? P : /* @__PURE__ */ b.jsxs(Tt, { shadow: "md", width: 200, withinPortal: !0, children: [
    /* @__PURE__ */ b.jsx(Tt.Target, { children: P }),
    /* @__PURE__ */ b.jsxs(Tt.Dropdown, { children: [
      /* @__PURE__ */ b.jsx(Tt.Label, { children: "근무 선택" }),
      s.map((X) => {
        const ce = SM(e, X.id);
        return /* @__PURE__ */ b.jsx(
          Tt.Item,
          {
            onClick: () => o(e.id, t, X.id),
            color: X.color || "",
            disabled: !ce,
            style: {
              backgroundColor: ce ? void 0 : "var(--mantine-color-gray-2)"
            },
            children: /* @__PURE__ */ b.jsxs(je, { justify: "space-between", children: [
              /* @__PURE__ */ b.jsx(ae, { children: X.name }),
              /* @__PURE__ */ b.jsx(ae, { fw: 700, children: X.symbol })
            ] })
          },
          X.id
        );
      }),
      /* @__PURE__ */ b.jsx(Tt.Divider, {}),
      /* @__PURE__ */ b.jsx(Tt.Item, { color: "red", onClick: () => o(e.id, t, void 0), children: "삭제" })
    ] })
  ] }), B = i && !u ? /* @__PURE__ */ b.jsxs(Tt, { shadow: "md", width: 220, trigger: "hover", openDelay: 100, closeDelay: 400, withinPortal: !0, children: [
    /* @__PURE__ */ b.jsx(Tt.Target, { children: /* @__PURE__ */ b.jsx("div", { style: { height: "100%" }, children: L }) }),
    /* @__PURE__ */ b.jsxs(Tt.Dropdown, { children: [
      /* @__PURE__ */ b.jsx(Tt.Label, { children: "원티드(희망근무) 정보" }),
      /* @__PURE__ */ b.jsxs(at, { gap: "xs", p: "xs", children: [
        /* @__PURE__ */ b.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ b.jsx("strong", { children: "신청자:" }),
          " ",
          e.user.name
        ] }),
        /* @__PURE__ */ b.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ b.jsx("strong", { children: "희망일:" }),
          " ",
          bt(i.targetDate).format("YYYY-MM-DD")
        ] }),
        /* @__PURE__ */ b.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ b.jsx("strong", { children: "신청일:" }),
          " ",
          bt(i.createdAt).format("YYYY-MM-DD")
        ] }),
        /* @__PURE__ */ b.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ b.jsx("strong", { children: "희망근무:" }),
          " ",
          (y == null ? void 0 : y.name) || "오프(Off)"
        ] }),
        /* @__PURE__ */ b.jsxs(ae, { size: "xs", children: [
          /* @__PURE__ */ b.jsx("strong", { children: "사유:" }),
          " ",
          i.reason || "없음"
        ] })
      ] })
    ] })
  ] }) : L;
  return /* @__PURE__ */ b.jsx(Je.Td, { p: 0, className: "duty-cell", children: /* @__PURE__ */ b.jsx(
    ss,
    {
      label: /* @__PURE__ */ b.jsx(at, { gap: 2, children: T.map((X) => /* @__PURE__ */ b.jsx(ae, { size: "xs", children: X }, X)) }),
      disabled: T.length === 0,
      withArrow: !0,
      withinPortal: !0,
      multiline: !0,
      children: /* @__PURE__ */ b.jsx("div", { style: { height: "100%" }, children: B })
    }
  ) });
}), wM = jc(
  ({
    nurseId: n,
    onSetWeeklyD: e,
    onSetAllOff: t,
    onClearSchedule: r,
    nurses: i = [],
    onCopySchedule: s
  }) => {
    const o = i.find((u) => u.id === n), c = (o == null ? void 0 : o.preceptorType) === "PRECEPEE" ? i.filter((u) => u.preceptorType === "PRECEPTOR") : [];
    return /* @__PURE__ */ b.jsxs(Tt, { shadow: "md", width: 220, position: "bottom-end", children: [
      /* @__PURE__ */ b.jsx(Tt.Target, { children: /* @__PURE__ */ b.jsx(hi, { variant: "subtle", color: "gray", size: "sm", children: /* @__PURE__ */ b.jsx(IW, { size: 16 }) }) }),
      /* @__PURE__ */ b.jsxs(Tt.Dropdown, { children: [
        /* @__PURE__ */ b.jsx(Tt.Item, { onClick: () => e(n), children: "주간 D 근무 설정" }),
        /* @__PURE__ */ b.jsx(Tt.Item, { onClick: () => t(n), children: "모든 날짜 Off 설정" }),
        /* @__PURE__ */ b.jsx(Tt.Divider, {}),
        /* @__PURE__ */ b.jsx(Tt.Item, { color: "red", onClick: () => r(n), children: "일정 초기화" }),
        c.length > 0 && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
          /* @__PURE__ */ b.jsx(Tt.Divider, {}),
          /* @__PURE__ */ b.jsx(Tt.Label, { children: "프리셉터 듀티 복사" }),
          c.map((u) => /* @__PURE__ */ b.jsxs(
            Tt.Item,
            {
              leftSection: /* @__PURE__ */ b.jsx(dC, { size: 14 }),
              onClick: () => s == null ? void 0 : s(u.id),
              children: [
                u.user.name,
                "의 듀티 복사"
              ]
            },
            u.id
          ))
        ] })
      ] })
    ] });
  }
);
wM.displayName = "NurseActionMenu";
const EM = jc(
  ({
    nurse: n,
    days: e,
    workShifts: t,
    dutyData: r = {},
    wantedMap: i = {},
    highlightMap: s = {},
    userCounts: o,
    disabledDates: a = {},
    readOnly: c = !1,
    nameColWidth: u,
    summaryColWidth: f,
    onShiftSelect: h,
    onSetWeeklyD: p,
    onSetAllOff: g,
    onClearSchedule: y,
    nurses: x = [],
    onCopySchedule: S
  }) => {
    const w = n.preceptorType === "PRECEPEE";
    return /* @__PURE__ */ b.jsxs(
      Je.Tr,
      {
        style: w ? {
          opacity: 0.6,
          backgroundColor: "var(--mantine-color-gray-1)"
        } : void 0,
        children: [
          /* @__PURE__ */ b.jsx(
            Je.Td,
            {
              style: {
                position: "sticky",
                left: 0,
                zIndex: 15,
                backgroundColor: w ? "var(--mantine-color-gray-1)" : "var(--mantine-color-body)",
                borderRight: "1px solid var(--mantine-color-gray-3)",
                minWidth: u,
                width: u
              },
              children: /* @__PURE__ */ b.jsxs(je, { justify: "space-between", align: "center", wrap: "nowrap", gap: "xs", children: [
                /* @__PURE__ */ b.jsxs(gt, { style: { flex: 1 }, children: [
                  /* @__PURE__ */ b.jsxs(je, { gap: 6, align: "center", wrap: "nowrap", children: [
                    /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 500, children: n.user.name }),
                    n.preceptorType === "PRECEPTOR" && /* @__PURE__ */ b.jsx(on, { size: "xs", color: "blue", variant: "light", children: "프리셉터" }),
                    n.preceptorType === "PRECEPEE" && /* @__PURE__ */ b.jsx(on, { size: "xs", color: "teal", variant: "light", children: "프리셉티" })
                  ] }),
                  n.position && /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "dimmed", children: n.position.name })
                ] }),
                !c && /* @__PURE__ */ b.jsx(
                  wM,
                  {
                    nurseId: n.id,
                    onSetWeeklyD: p,
                    onSetAllOff: g,
                    onClearSchedule: y,
                    nurses: x,
                    onCopySchedule: S ? (C) => S(C, n.id) : void 0
                  }
                )
              ] })
            }
          ),
          e.map((C) => {
            const T = C.format("YYYY-MM-DD"), k = a[T];
            return /* @__PURE__ */ b.jsx(
              tJ,
              {
                nurse: n,
                dateStr: T,
                entry: r[T],
                wanted: i[T],
                workShifts: t,
                onSelect: h,
                highlights: s[T],
                readOnly: c,
                disabled: !!k,
                disabledReason: k
              },
              T
            );
          }),
          t.map((C) => /* @__PURE__ */ b.jsx(
            Je.Td,
            {
              style: {
                textAlign: "center",
                backgroundColor: "#fff8db",
                minWidth: f,
                width: f
              },
              children: /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 500, c: C.color || void 0, children: o[C.id] || 0 })
            },
            C.id
          ))
        ]
      }
    );
  }
);
EM.displayName = "DutyEditorRow";
function nJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    let a = [], c = null;
    const u = (f, h) => {
      const p = f.length;
      if (p === 0 || !h) return;
      const g = r.find((w) => w.id === h), y = g ? g.name : "";
      let x, S;
      p >= 7 ? (x = "var(--mantine-color-red-9)", S = `⛔ 동일 근무(${y}) 연속 ${p}일 (불가)`) : p === 6 ? (x = "var(--mantine-color-red-6)", S = `⚠️ 동일 근무(${y}) 연속 6일 (경고)`) : p === 5 && (x = "var(--mantine-color-orange-6)", S = `💡 동일 근무(${y}) 연속 5일 (주의)`), x && f.forEach((w) => {
        i.push({
          nurseIndex: o,
          dayIndex: w,
          color: x,
          label: S
        });
      });
    };
    t.forEach((f, h) => {
      var S;
      const p = f.format("YYYY-MM-DD"), g = (S = n[s.id]) == null ? void 0 : S[p], y = g == null ? void 0 : g.workShiftId, x = y ? r.find((w) => w.id === y) : null;
      x && !x.isOff ? c === y ? a.push(h) : (u(a, c), a = [h], c = y) : (u(a, c), a = [], c = null);
    }), u(a, c);
  }), i;
}
function rJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    var a, c, u, f;
    for (let h = 0; h < t.length - 1; h++) {
      const p = (c = (a = n[s.id]) == null ? void 0 : a[t[h].format("YYYY-MM-DD")]) == null ? void 0 : c.workShiftId, g = (f = (u = n[s.id]) == null ? void 0 : u[t[h + 1].format("YYYY-MM-DD")]) == null ? void 0 : f.workShiftId;
      if (!p || !g) continue;
      const y = r.find((C) => C.id === p), x = r.find((C) => C.id === g);
      if (!y || !x) continue;
      const S = y.symbol, w = x.symbol;
      if (S === "N" && w === "E" || S === "E" && w === "D" || S === "N" && w === "D") {
        const C = `🚫 금지 패턴 (${S}→${w})`;
        i.push({
          nurseIndex: o,
          dayIndex: h,
          color: "var(--mantine-color-red-6)",
          label: C
        }), i.push({
          nurseIndex: o,
          dayIndex: h + 1,
          color: "var(--mantine-color-red-6)",
          label: C
        });
      }
    }
  }), i;
}
function iJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    for (let a = 0; a < t.length; a++) {
      const c = (p) => {
        var x, S, w;
        const g = t[a + p];
        if (!g) return null;
        const y = (S = (x = n[s.id]) == null ? void 0 : x[g.format("YYYY-MM-DD")]) == null ? void 0 : S.workShiftId;
        return ((w = r.find((C) => C.id === y)) == null ? void 0 : w.symbol) || null;
      }, u = c(0), f = c(1), h = c(2);
      if (u === "N" && f === "N" && h === "N" && [a, a + 1, a + 2].forEach((p) => {
        i.push({
          nurseIndex: o,
          dayIndex: p,
          color: "var(--mantine-color-red-4)",
          borderSize: 1,
          label: "⚠️ 기피 패턴 (NNN)"
        });
      }), u === "N" && f === "O" && (h === "D" || h === "E")) {
        const p = `NO${h}`;
        [a, a + 1, a + 2].forEach((g) => {
          i.push({
            nurseIndex: o,
            dayIndex: g,
            color: "var(--mantine-color-red-4)",
            borderSize: 1,
            label: `⚠️ 기피 패턴 (${p})`
          });
        });
      }
    }
  }), i;
}
function sJ({
  value: n,
  nurses: e,
  days: t,
  workShifts: r
}) {
  const i = [];
  return e.forEach((s, o) => {
    for (let a = 0; a < t.length - 3; a++) {
      const c = (g) => {
        var S, w, C;
        const y = t[a + g];
        if (!y) return null;
        const x = (w = (S = n[s.id]) == null ? void 0 : S[y.format("YYYY-MM-DD")]) == null ? void 0 : w.workShiftId;
        return ((C = r.find((T) => T.id === x)) == null ? void 0 : C.symbol) || null;
      }, u = c(0), f = c(1), h = c(2), p = c(3);
      u === "N" && f === "O" && h === "N" && p === "O" && [a, a + 1, a + 2, a + 3].forEach((g) => {
        i.push({
          nurseIndex: o,
          dayIndex: g,
          color: "var(--mantine-color-orange-6)",
          label: "💡 퐁당퐁당 패턴 (NONO)"
        });
      });
    }
  }), i;
}
function oJ(n) {
  const { options: e, value: t, nurses: r, days: i, workShifts: s } = n;
  let o = [];
  return e.showFiveDayConsecutive && (o = o.concat(
    nJ({ value: t, nurses: r, days: i, workShifts: s })
  )), e.showConsecutiveDuty && (o = o.concat(
    rJ({ value: t, nurses: r, days: i, workShifts: s })
  )), e.showAvoidanceDuty && (o = o.concat(
    iJ({ value: t, nurses: r, days: i, workShifts: s })
  )), e.showPongDangPongDang && (o = o.concat(
    sJ({ value: t, nurses: r, days: i, workShifts: s })
  )), o;
}
function aJ(n, e, t, r) {
  const i = Vt(() => {
    const o = {};
    return n.forEach((a) => {
      o[a.id] = {}, e.forEach((u) => {
        o[a.id][u.id] = 0;
      });
      const c = t[a.id] || {};
      Object.values(c).forEach((u) => {
        u != null && u.workShiftId && o[a.id][u.workShiftId] !== void 0 && o[a.id][u.workShiftId]++;
      });
    }), o;
  }, [n, e, t]), s = Vt(() => {
    const o = {};
    return r.forEach((a) => {
      const c = a.format("YYYY-MM-DD");
      o[c] = {}, e.forEach((u) => {
        o[c][u.id] = 0;
      }), n.forEach((u) => {
        var h;
        const f = (h = t[u.id]) == null ? void 0 : h[c];
        f != null && f.workShiftId && o[c][f.workShiftId] !== void 0 && o[c][f.workShiftId]++;
      });
    }), o;
  }, [r, n, e, t]);
  return { userCounts: i, dailyCounts: s };
}
const lJ = (n, e) => {
  const t = bt(n), r = bt(e), i = [];
  let s = t;
  for (; s.isBefore(r) || s.isSame(r, "day"); )
    i.push(s), s = s.add(1, "day");
  return i;
}, cJ = (n) => {
  const e = {};
  return n.forEach((t) => {
    const r = bt(t.targetDate).format("YYYY-MM-DD"), i = t.nurseId;
    e[i] || (e[i] = {}), e[i][r] = t;
  }), e;
}, uJ = (n, e) => {
  const t = n.day();
  if (t === 0 || e) return "red";
  if (t === 6) return "blue";
}, dJ = (n, e) => {
  const t = bt(n), r = bt(e);
  return t.isSame(r, "month") ? t.format("YYYY년 MM월 근무") : `${t.format("YYYY-MM-DD")} ~ ${r.format("YYYY-MM-DD")} 근무`;
}, jl = 180, Da = 60, Fl = 60, mQ = jc(
  ({
    nurses: n,
    workShifts: e,
    wanteds: t = [],
    requirements: r,
    holidays: i = [],
    startDate: s,
    endDate: o,
    value: a = {},
    defaultIsFixed: c = !1,
    actions: u,
    showTooltip: f = !1,
    validationOptions: h,
    onChange: p,
    readOnly: g = !1,
    disabledDates: y = {}
  }) => {
    const x = Vt(() => [...e].sort((V, ie) => {
      if (V.isOff && !ie.isOff) return 1;
      if (!V.isOff && ie.isOff) return -1;
      if (V.isOff && ie.isOff) return 0;
      const q = new Date(V.startTime).getTime(), de = new Date(ie.startTime).getTime();
      return q - de;
    }), [e]), S = Vt(() => lJ(s, o), [s, o]), w = Vt(() => {
      const V = {};
      return i.forEach((ie) => {
        const q = bt(ie.date).format("YYYY-MM-DD");
        V[q] = ie;
      }), V;
    }, [i]), C = Vt(() => cJ(t), [t]), T = Vt(() => [...n].sort((V, ie) => {
      var pe, Ee;
      const q = ((pe = V.position) == null ? void 0 : pe.order) ?? 999, de = ((Ee = ie.position) == null ? void 0 : Ee.order) ?? 999;
      if (q !== de) return q - de;
      const ee = V.createdAt ? new Date(V.createdAt).getTime() : 0, he = ie.createdAt ? new Date(ie.createdAt).getTime() : 0;
      return ee - he;
    }), [n]), { userCounts: k, dailyCounts: R } = aJ(T, x, a, S), P = Vt(() => {
      const ie = oJ({
        options: h || {
          showFiveDayConsecutive: f
        },
        value: a,
        nurses: T,
        days: S,
        workShifts: x
      }), q = {};
      return ie.forEach((de) => {
        var pe, Ee;
        const ee = (pe = T[de.nurseIndex]) == null ? void 0 : pe.id, he = (Ee = S[de.dayIndex]) == null ? void 0 : Ee.format("YYYY-MM-DD");
        !ee || !he || (q[ee] || (q[ee] = {}), q[ee][he] || (q[ee][he] = []), q[ee][he].push(de));
      }), q;
    }, [a, T, S, x, f, h]), [L, B] = wt(0), W = vt(T);
    W.current = T;
    const X = vt(g);
    X.current = g;
    const ce = vt(p);
    ce.current = p;
    const Re = vt(a);
    Re.current = a;
    const ke = vt(y);
    ke.current = y;
    const J = vt(c);
    J.current = c;
    const re = vt(x);
    re.current = x;
    const G = vt(S);
    G.current = S;
    const $ = vt(w);
    $.current = w;
    const K = fn((V, ie) => {
      const q = W.current.find((de) => de.id === V);
      return !!q && re.current.some((de) => de.id === ie) && SM(q, ie);
    }, []), Se = fn(
      (V, ie, q) => {
        var ee, he, pe;
        if (X.current || (he = (ee = ke.current) == null ? void 0 : ee[V]) != null && he[ie] || q && !K(V, q)) return;
        B(0);
        const de = { ...Re.current[V] || {} };
        q ? de[ie] = {
          workShiftId: q,
          isFixed: J.current
        } : delete de[ie], (pe = ce.current) == null || pe.call(ce, {
          ...Re.current,
          [V]: de
        });
      },
      [K]
    ), z = fn(
      (V) => {
        var he;
        if (X.current) return;
        B(0);
        const ie = re.current.find((pe) => pe.symbol === "D"), q = re.current.find((pe) => pe.isOff);
        if (!ie || !q) return;
        const de = { ...Re.current[V] || {} };
        let ee = 0;
        G.current.forEach((pe) => {
          var Kt, Wt;
          const Ee = pe.format("YYYY-MM-DD");
          if ((Wt = (Kt = ke.current) == null ? void 0 : Kt[V]) != null && Wt[Ee]) return;
          const ue = pe.day() === 0 || pe.day() === 6, et = !!$.current[Ee], mt = ue || et ? q.id : ie.id;
          if (!K(V, mt)) {
            ee++;
            return;
          }
          de[Ee] = {
            workShiftId: mt,
            isFixed: J.current
          };
        }), B(ee), (he = ce.current) == null || he.call(ce, {
          ...Re.current,
          [V]: de
        });
      },
      [K]
    ), Q = fn(
      (V) => {
        var ee;
        if (X.current) return;
        B(0);
        const ie = re.current.find((he) => he.isOff) || re.current.find((he) => he.symbol === "Off") || re.current.find((he) => he.symbol === "O") || re.current[0];
        if (!ie) return;
        const q = { ...Re.current[V] || {} };
        let de = 0;
        G.current.forEach((he) => {
          var Ee, ue;
          const pe = he.format("YYYY-MM-DD");
          if (!((ue = (Ee = ke.current) == null ? void 0 : Ee[V]) != null && ue[pe])) {
            if (!K(V, ie.id)) {
              de++;
              return;
            }
            q[pe] = {
              workShiftId: ie.id,
              isFixed: J.current
            };
          }
        }), B(de), (ee = ce.current) == null || ee.call(ce, {
          ...Re.current,
          [V]: q
        });
      },
      [K]
    ), ge = fn((V) => {
      var q;
      if (X.current) return;
      B(0);
      const ie = { ...Re.current[V] || {} };
      G.current.forEach((de) => {
        var he, pe;
        const ee = de.format("YYYY-MM-DD");
        (pe = (he = ke.current) == null ? void 0 : he[V]) != null && pe[ee] || delete ie[ee];
      }), (q = ce.current) == null || q.call(ce, {
        ...Re.current,
        [V]: ie
      });
    }, []), me = fn(
      (V, ie) => {
        var he;
        if (X.current) return;
        let q = 0;
        const de = Re.current[V] || {}, ee = { ...Re.current[ie] || {} };
        G.current.forEach((pe) => {
          var ue, et;
          const Ee = pe.format("YYYY-MM-DD");
          if (!((et = (ue = ke.current) == null ? void 0 : ue[ie]) != null && et[Ee]))
            if (de[Ee]) {
              if (!K(ie, de[Ee].workShiftId)) {
                q++;
                return;
              }
              ee[Ee] = { ...de[Ee] };
            } else
              delete ee[Ee];
        }), B(q), (he = ce.current) == null || he.call(ce, {
          ...Re.current,
          [ie]: ee
        });
      },
      [K]
    );
    return /* @__PURE__ */ b.jsxs(at, { gap: "md", children: [
      !g && L > 0 && /* @__PURE__ */ b.jsxs(Us, { color: "yellow", role: "status", title: "일부 근무를 적용하지 않았습니다", children: [
        "가능 근무타입에 없는 근무 ",
        L,
        "건을 건너뛰고 기존 일정을 유지했습니다."
      ] }),
      /* @__PURE__ */ b.jsx("style", { children: `
        .duty-cell {
          cursor: ${g ? "default" : "pointer"};
          text-align: center;
          transition: background-color 0.2s;
          min-width: ${Da}px;
          width: ${Da}px;
        }
        ${g ? "" : `
        .duty-cell:hover {
          background-color: var(--mantine-color-gray-1);
        }
        `}
      ` }),
      /* @__PURE__ */ b.jsxs(Um, { justify: "space-between", align: "center", children: [
        /* @__PURE__ */ b.jsxs(gt, { children: [
          /* @__PURE__ */ b.jsx(ae, { size: "xl", fw: 700, children: dJ(s, o) }),
          /* @__PURE__ */ b.jsx(ae, { size: "sm", c: "dimmed", children: g ? "기존 요청된 근무표 내역입니다." : "셀을 클릭하여 수동으로 근무타입을 설정하세요. 자동 생성 시 이 설정은 보존됩니다." })
        ] }),
        u
      ] }),
      /* @__PURE__ */ b.jsx(er, { withBorder: !0, shadow: "sm", radius: "md", p: 0, style: { overflow: "hidden" }, children: /* @__PURE__ */ b.jsx(Bc, { children: /* @__PURE__ */ b.jsxs(Je, { withTableBorder: !0, withColumnBorders: !0, verticalSpacing: "xs", horizontalSpacing: "xs", children: [
        /* @__PURE__ */ b.jsx(
          Je.Thead,
          {
            style: {
              position: "sticky",
              top: 0,
              zIndex: 20,
              backgroundColor: "var(--mantine-color-body)"
            },
            children: /* @__PURE__ */ b.jsxs(Je.Tr, { children: [
              /* @__PURE__ */ b.jsx(
                Je.Th,
                {
                  style: {
                    minWidth: jl,
                    width: jl,
                    position: "sticky",
                    top: 0,
                    left: 0,
                    zIndex: 30,
                    backgroundColor: "var(--mantine-color-body)",
                    borderRight: "1px solid var(--mantine-color-gray-3)"
                  },
                  children: "이름"
                }
              ),
              S.map((V) => {
                const ie = V.format("YYYY-MM-DD"), q = w[ie], de = uJ(V, !!q), ee = /* @__PURE__ */ b.jsxs(at, { gap: 0, align: "center", children: [
                  /* @__PURE__ */ b.jsx(ae, { size: "xs", fw: 700, c: de, children: V.date() }),
                  /* @__PURE__ */ b.jsx(ae, { size: "xs", c: de, children: V.format("dd") })
                ] });
                return /* @__PURE__ */ b.jsx(
                  Je.Th,
                  {
                    style: {
                      minWidth: Da,
                      width: Da,
                      textAlign: "center"
                    },
                    children: q ? /* @__PURE__ */ b.jsx(ss, { label: q.name, withArrow: !0, children: /* @__PURE__ */ b.jsx(gt, { style: { cursor: "default" }, children: ee }) }) : ee
                  },
                  V.toString()
                );
              }),
              x.map((V) => /* @__PURE__ */ b.jsx(
                Je.Th,
                {
                  style: {
                    backgroundColor: V.color || "gray",
                    textAlign: "center",
                    color: "white",
                    minWidth: Fl,
                    width: Fl
                  },
                  children: V.symbol
                },
                V.id
              ))
            ] })
          }
        ),
        /* @__PURE__ */ b.jsx(Je.Tbody, { children: T.map((V) => /* @__PURE__ */ b.jsx(
          EM,
          {
            nurse: V,
            days: S,
            workShifts: x,
            dutyData: a[V.id],
            wantedMap: C[V.id],
            highlightMap: P[V.id],
            userCounts: k[V.id],
            disabledDates: y[V.id],
            readOnly: g,
            nameColWidth: jl,
            summaryColWidth: Fl,
            onShiftSelect: Se,
            onSetWeeklyD: z,
            onSetAllOff: Q,
            onClearSchedule: ge,
            nurses: T,
            onCopySchedule: me
          },
          V.id
        )) }),
        /* @__PURE__ */ b.jsx(Je.Tfoot, { children: x.map((V) => /* @__PURE__ */ b.jsxs(Je.Tr, { children: [
          /* @__PURE__ */ b.jsx(
            Je.Th,
            {
              style: {
                backgroundColor: V.color || "#333",
                color: "white",
                position: "sticky",
                left: 0,
                zIndex: 15,
                minWidth: jl,
                width: jl
              },
              children: /* @__PURE__ */ b.jsx(je, { justify: "center", children: /* @__PURE__ */ b.jsx(ae, { size: "sm", children: V.symbol }) })
            }
          ),
          S.map((ie) => {
            var pe, Ee, ue;
            const q = ie.format("YYYY-MM-DD"), de = R[q][V.id] || 0;
            let ee = "dimmed", he = "normal";
            if (r && ((pe = r[q]) == null ? void 0 : pe[V.id]) !== void 0) {
              const et = (Ee = r[q]) == null ? void 0 : Ee[V.id];
              et !== void 0 && (de === et ? (ee = "blue.6", he = 700) : de > et && (ee = "red.6", he = 700));
            }
            return /* @__PURE__ */ b.jsx(
              Je.Td,
              {
                style: {
                  textAlign: "center",
                  backgroundColor: "var(--mantine-color-gray-0)",
                  minWidth: Da,
                  width: Da
                },
                children: /* @__PURE__ */ b.jsx(
                  fJ,
                  {
                    label: (ue = w[q]) == null ? void 0 : ue.name,
                    disabled: !w[q],
                    children: /* @__PURE__ */ b.jsx(ae, { size: "xs", c: ee, fw: he, children: de })
                  }
                )
              },
              q
            );
          }),
          x.map((ie) => /* @__PURE__ */ b.jsx(
            Je.Td,
            {
              style: {
                backgroundColor: "#f1f3f5",
                minWidth: Fl,
                width: Fl
              },
              children: /* @__PURE__ */ b.jsx(ae, { size: "xs", ta: "center", children: "-" })
            },
            `footer-empty-${V.id}-${ie.id}`
          ))
        ] }, `footer-${V.id}`)) })
      ] }) }) })
    ] });
  }
), fJ = ({
  children: n,
  label: e,
  disabled: t
}) => t || !e ? /* @__PURE__ */ b.jsx(b.Fragment, { children: n }) : /* @__PURE__ */ b.jsx(ss, { label: e, withArrow: !0, children: /* @__PURE__ */ b.jsx(gt, { children: n }) }), hJ = jc(function({
  ws: e,
  days: t,
  nurses: r,
  data: i,
  dailyErrors: s,
  workShifts: o,
  readOnly: a,
  disabled: c,
  holidayMap: u,
  onBatchUpdate: f,
  onInputChange: h
}) {
  const p = t.every((g) => {
    var k;
    const y = g.format("YYYY-MM-DD"), x = ((k = i[y]) == null ? void 0 : k[e.id]) ?? 0, S = r.filter((R) => {
      const P = R.statusPeriods || [];
      return Ri(P, g.toDate()) === "ACTIVE";
    }).length, w = o.filter((R) => !R.isOff && R.id !== e.id).reduce((R, P) => {
      var L;
      return R + (((L = i[y]) == null ? void 0 : L[P.id]) ?? 0);
    }, 0), C = r.filter((R) => {
      const P = R.statusPeriods || [];
      return Ri(P, g.toDate()) !== "ACTIVE" ? !1 : !R.availableWorkShifts || R.availableWorkShifts.length === 0 || R.availableWorkShifts.some((L) => L.id === e.id);
    }).length, T = Math.min(C, Math.max(0, S - w));
    return x >= T;
  });
  return /* @__PURE__ */ b.jsxs(Je.Tr, { children: [
    /* @__PURE__ */ b.jsx(Je.Td, { children: /* @__PURE__ */ b.jsxs(je, { gap: "xs", justify: "space-between", wrap: "nowrap", children: [
      /* @__PURE__ */ b.jsxs(je, { gap: 6, wrap: "nowrap", children: [
        /* @__PURE__ */ b.jsx(
          on,
          {
            circle: !0,
            size: "sm",
            color: e.color || "gray",
            styles: { root: { width: 10, height: 10, minWidth: 10 } }
          }
        ),
        /* @__PURE__ */ b.jsx(ae, { fw: 700, size: "sm", children: e.symbol })
      ] }),
      !e.isOff && /* @__PURE__ */ b.jsxs(je, { gap: 2, wrap: "nowrap", children: [
        /* @__PURE__ */ b.jsx(
          ss,
          {
            label: "모든 날짜의 필요 인원이 이미 최대 배치 가능 인원에 도달했습니다.",
            disabled: !p,
            withArrow: !0,
            children: /* @__PURE__ */ b.jsx(gt, { style: { display: "inline-block" }, children: /* @__PURE__ */ b.jsx(
              hi,
              {
                size: "xs",
                variant: "subtle",
                color: "gray",
                onClick: () => f(e.id, 1),
                disabled: p,
                children: /* @__PURE__ */ b.jsx(uC, { size: 12 })
              }
            ) })
          }
        ),
        /* @__PURE__ */ b.jsx(
          hi,
          {
            size: "xs",
            variant: "subtle",
            color: "gray",
            onClick: () => f(e.id, -1),
            children: /* @__PURE__ */ b.jsx(Wy, { size: 12 })
          }
        )
      ] })
    ] }) }),
    t.map((g) => {
      var P;
      const y = g.format("YYYY-MM-DD"), x = !!u[y], S = AM(g, x), w = s[y], C = r.filter((L) => {
        const B = L.statusPeriods || [];
        return Ri(B, g.toDate()) === "ACTIVE";
      }).length;
      if (e.isOff) {
        const L = o.filter((W) => !W.isOff).reduce((W, X) => {
          var ce;
          return W + (((ce = i[y]) == null ? void 0 : ce[X.id]) ?? 0);
        }, 0), B = Math.max(0, C - L);
        return /* @__PURE__ */ b.jsx(
          Je.Td,
          {
            style: {
              padding: 0,
              backgroundColor: w ? "#fff0f0" : S.cellBg,
              boxShadow: w ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red" : void 0
            },
            children: /* @__PURE__ */ b.jsx(
              ae,
              {
                size: "sm",
                fw: 500,
                ta: "center",
                style: { height: "40px", lineHeight: "40px", margin: 0 },
                c: "dimmed",
                children: B
              }
            )
          },
          y
        );
      }
      const T = o.filter((L) => !L.isOff && L.id !== e.id).reduce((L, B) => {
        var W;
        return L + (((W = i[y]) == null ? void 0 : W[B.id]) ?? 0);
      }, 0), k = r.filter((L) => {
        const B = L.statusPeriods || [];
        return Ri(B, g.toDate()) !== "ACTIVE" ? !1 : !L.availableWorkShifts || L.availableWorkShifts.length === 0 || L.availableWorkShifts.some((W) => W.id === e.id);
      }).length, R = Math.min(
        k,
        Math.max(0, C - T)
      );
      return /* @__PURE__ */ b.jsx(
        Je.Td,
        {
          style: {
            padding: 0,
            backgroundColor: w ? "#fff0f0" : S.cellBg,
            boxShadow: w ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red" : void 0
          },
          children: /* @__PURE__ */ b.jsx(
            h1,
            {
              variant: "unstyled",
              size: "sm",
              min: 0,
              max: R,
              value: ((P = i[y]) == null ? void 0 : P[e.id]) ?? 0,
              onChange: (L) => h(y, e.id, Number(L)),
              disabled: a || c,
              styles: {
                input: {
                  textAlign: "center",
                  padding: 0,
                  height: "40px",
                  fontSize: "14px",
                  opacity: a || c ? 0.7 : 1,
                  cursor: a || c ? "not-allowed" : "default"
                }
              },
              hideControls: !0
            }
          )
        },
        y
      );
    })
  ] });
}), AM = (n, e) => {
  const t = n.day(), r = t === 0 || e, i = t === 6;
  return r ? {
    headerBg: "#ffe3e3",
    cellBg: "#fff0f0",
    color: "red"
  } : i ? {
    headerBg: "#e7f5ff",
    cellBg: "#f0f8ff",
    color: "blue"
  } : {
    headerBg: void 0,
    cellBg: void 0,
    color: void 0
  };
}, Ri = (n, e) => {
  const t = bt(e), r = n.find((i) => {
    const s = bt(i.startDate), o = bt(i.endDate);
    return (t.isAfter(s) || t.isSame(s, "day")) && (t.isBefore(o) || t.isSame(o, "day"));
  });
  return (r == null ? void 0 : r.status) ?? "ACTIVE";
};
function gQ({
  nurses: n,
  startDate: e,
  endDate: t,
  workShifts: r,
  value: i,
  onChange: s,
  readOnly: o = !1,
  disabled: a = !1,
  holidays: c = []
}) {
  const u = Vt(() => [...r].sort((T, k) => {
    if (T.isOff && !k.isOff) return 1;
    if (!T.isOff && k.isOff) return -1;
    if (T.isOff && k.isOff) return 0;
    const R = new Date(T.startTime).getTime();
    return new Date(k.startTime).getTime() - R;
  }), [r]), [f, h] = wt(i || {});
  St(() => {
    i && h(i);
  }, [i]);
  const p = Vt(() => {
    const T = {};
    return c.forEach((k) => {
      const R = bt(k.date).format("YYYY-MM-DD");
      T[R] = k;
    }), T;
  }, [c]), g = Vt(() => {
    if (!e || !t) return [];
    const T = [];
    let k = bt(e);
    const R = bt(t);
    for (; k.isBefore(R) || k.isSame(R, "day"); )
      T.push(k), k = k.add(1, "day");
    return T;
  }, [e, t]), y = Vt(() => {
    const T = {};
    return g.length && g.forEach((k) => {
      const R = k.format("YYYY-MM-DD"), P = u.filter((B) => !B.isOff).reduce((B, W) => {
        var X;
        return B + (((X = f[R]) == null ? void 0 : X[W.id]) ?? 0);
      }, 0), L = n.filter((B) => {
        const W = B.statusPeriods || [];
        return Ri(W, k.toDate()) === "ACTIVE";
      }).length;
      P > L && (T[R] = !0);
    }), T;
  }, [g, u, f, n]), x = Object.keys(y).length > 0, S = fn(
    (T, k, R) => {
      if (o || a) return;
      const P = bt(T), L = n.filter((W) => {
        const X = W.statusPeriods || [];
        return Ri(X, P.toDate()) === "ACTIVE";
      }).length, B = n.filter((W) => {
        const X = W.statusPeriods || [];
        return Ri(X, P.toDate()) !== "ACTIVE" ? !1 : !W.availableWorkShifts || W.availableWorkShifts.length === 0 || W.availableWorkShifts.some((ce) => ce.id === k);
      }).length;
      h((W) => {
        const X = u.filter((J) => !J.isOff && J.id !== k).reduce((J, re) => {
          var G;
          return J + (((G = W[T]) == null ? void 0 : G[re.id]) ?? 0);
        }, 0), ce = Math.min(
          B,
          Math.max(0, L - X)
        ), Re = Math.min(ce, Math.max(0, R)), ke = { ...W };
        return ke[T] || (ke[T] = {}), ke[T][k] = Re, s == null || s(ke), ke;
      });
    },
    [o, a, n, u, s]
  ), w = fn(
    (T, k) => {
      o || a || h((R) => {
        const P = { ...R };
        return g.forEach((L) => {
          const B = L.format("YYYY-MM-DD");
          P[B] || (P[B] = {});
          const W = P[B][T] ?? 0, X = n.filter((J) => {
            const re = J.statusPeriods || [];
            return Ri(re, L.toDate()) === "ACTIVE";
          }).length, ce = u.filter((J) => !J.isOff && J.id !== T).reduce((J, re) => {
            var G;
            return J + (((G = P[B]) == null ? void 0 : G[re.id]) ?? 0);
          }, 0), Re = n.filter((J) => {
            const re = J.statusPeriods || [];
            return Ri(re, L.toDate()) !== "ACTIVE" ? !1 : !J.availableWorkShifts || J.availableWorkShifts.length === 0 || J.availableWorkShifts.some((G) => G.id === T);
          }).length, ke = Math.min(
            Re,
            Math.max(0, X - ce)
          );
          P[B][T] = Math.min(ke, Math.max(0, W + k));
        }), s == null || s(P), P;
      });
    },
    [o, a, g, n, u, s]
  ), C = Vt(() => e ? bt(e).format("YYYY년 MM월 근무 인원수 설정") : "", [e]);
  return !e || !t ? /* @__PURE__ */ b.jsx(ae, { c: "dimmed", children: "날짜를 먼저 선택해주세요." }) : /* @__PURE__ */ b.jsxs(er, { withBorder: !0, shadow: "sm", radius: "md", p: "md", children: [
    /* @__PURE__ */ b.jsx(ae, { size: "lg", fw: 700, mb: "md", children: C }),
    x && /* @__PURE__ */ b.jsx(
      Us,
      {
        icon: /* @__PURE__ */ b.jsx(RW, { size: "1rem" }),
        title: "인원 초과",
        color: "red",
        mb: "md",
        variant: "light",
        children: "일부 날짜의 투입 인원이 전체 간호사 수를 초과했습니다. 빨간색으로 표시된 날짜를 확인해주세요."
      }
    ),
    /* @__PURE__ */ b.jsx(Bc, { children: /* @__PURE__ */ b.jsxs(Je, { withTableBorder: !0, withColumnBorders: !0, children: [
      /* @__PURE__ */ b.jsx(Je.Thead, { children: /* @__PURE__ */ b.jsxs(Je.Tr, { children: [
        /* @__PURE__ */ b.jsx(Je.Th, { style: { minWidth: 120 }, children: "근무" }),
        g.map((T) => {
          const k = T.format("YYYY-MM-DD"), R = p[k], P = AM(T, !!R), L = y[k], B = /* @__PURE__ */ b.jsxs(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: R ? "default" : void 0
              },
              children: [
                /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 700, c: L ? "red" : P.color, children: T.date() }),
                /* @__PURE__ */ b.jsx(ae, { size: "xs", c: L ? "red" : P.color, children: T.format("dd") })
              ]
            }
          );
          return /* @__PURE__ */ b.jsx(
            Je.Th,
            {
              style: {
                minWidth: 50,
                textAlign: "center",
                backgroundColor: L ? "#ffe3e3" : P.headerBg,
                boxShadow: L ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red, inset 0 2px 0 0 red" : void 0
              },
              children: R ? /* @__PURE__ */ b.jsx(ss, { label: R.name, withArrow: !0, children: /* @__PURE__ */ b.jsx("div", { children: B }) }) : B
            },
            k
          );
        })
      ] }) }),
      /* @__PURE__ */ b.jsx(Je.Tbody, { children: u.map((T) => /* @__PURE__ */ b.jsx(
        hJ,
        {
          ws: T,
          days: g,
          nurses: n,
          data: f,
          dailyErrors: y,
          workShifts: u,
          readOnly: o,
          disabled: a,
          holidayMap: p,
          onBatchUpdate: w,
          onInputChange: S
        },
        T.id
      )) }),
      /* @__PURE__ */ b.jsx(Je.Tfoot, { children: /* @__PURE__ */ b.jsxs(Je.Tr, { children: [
        /* @__PURE__ */ b.jsx(Je.Th, { children: /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 700, ta: "center", children: "합계" }) }),
        g.map((T) => {
          const k = T.format("YYYY-MM-DD"), R = y[k], P = n.filter((B) => {
            const W = B.statusPeriods || [];
            return Ri(W, T.toDate()) === "ACTIVE";
          }).length, L = u.reduce((B, W) => {
            var X;
            if (W.isOff) {
              const ce = u.filter((Re) => !Re.isOff).reduce((Re, ke) => {
                var J;
                return Re + (((J = f[k]) == null ? void 0 : J[ke.id]) ?? 0);
              }, 0);
              return B + Math.max(0, P - ce);
            }
            return B + (((X = f[k]) == null ? void 0 : X[W.id]) ?? 0);
          }, 0);
          return /* @__PURE__ */ b.jsx(
            Je.Th,
            {
              style: {
                textAlign: "center",
                backgroundColor: R ? "#ffe3e3" : "#f8f9fa",
                boxShadow: R ? "inset 2px 0 0 0 red, inset -2px 0 0 0 red, inset 0 -2px 0 0 red" : void 0
              },
              children: /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 700, c: R ? "red" : void 0, children: L })
            },
            k
          );
        })
      ] }) })
    ] }) }),
    /* @__PURE__ */ b.jsxs(je, { justify: "space-between", mt: "xs", children: [
      /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "dimmed", children: "사용법: ↑↓ 전체 조정, 각 셀 직접 입력 가능" }),
      /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "dimmed", children: "주말: 파란색/빨간색 배경" })
    ] })
  ] });
}
function s1({
  initialValue: n = "",
  placeholder: e = "댓글을 입력하세요...",
  onSubmit: t,
  onCancel: r,
  submitLabel: i = "등록",
  cancelLabel: s = "취소",
  loading: o = !1,
  autoFocus: a = !1
}) {
  const [c, u] = wt(n), f = async (p) => {
    if (p.preventDefault(), !!c.trim())
      try {
        await t(c), u("");
      } catch (g) {
        console.error(g);
      }
  }, h = !c.trim() || o;
  return /* @__PURE__ */ b.jsx("form", { onSubmit: f, style: { width: "100%" }, children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
    /* @__PURE__ */ b.jsx(
      P2,
      {
        placeholder: e,
        value: c,
        onChange: (p) => u(p.currentTarget.value),
        minRows: 4,
        maxLength: 5e3,
        autosize: !0,
        autoFocus: a,
        disabled: o,
        styles: {
          input: {
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            borderRadius: "var(--mantine-radius-md)",
            "&:focus": {
              borderColor: "var(--mantine-color-blue-filled)",
              boxShadow: "0 0 0 2px rgba(34, 139, 230, 0.15)"
            }
          }
        }
      }
    ),
    /* @__PURE__ */ b.jsxs(je, { justify: "flex-end", gap: "xs", children: [
      r && /* @__PURE__ */ b.jsx(
        hn,
        {
          type: "button",
          variant: "subtle",
          color: "gray",
          size: "xs",
          onClick: r,
          disabled: o,
          style: { borderRadius: "var(--mantine-radius-md)" },
          children: s
        }
      ),
      /* @__PURE__ */ b.jsx(
        hn,
        {
          type: "submit",
          size: "xs",
          disabled: h,
          loading: o,
          style: { borderRadius: "var(--mantine-radius-md)" },
          children: i
        }
      )
    ] })
  ] }) });
}
var TM = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, o1 = Fe.createContext && /* @__PURE__ */ Fe.createContext(TM), pJ = ["attr", "size", "title"];
function mJ(n, e) {
  if (n == null) return {};
  var t = gJ(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function gJ(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function zf() {
  return zf = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, zf.apply(this, arguments);
}
function a1(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Vf(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? a1(Object(t), !0).forEach(function(r) {
      yJ(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : a1(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function yJ(n, e, t) {
  return e = vJ(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function vJ(n) {
  var e = bJ(n, "string");
  return typeof e == "symbol" ? e : e + "";
}
function bJ(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function CM(n) {
  return n && n.map((e, t) => /* @__PURE__ */ Fe.createElement(e.tag, Vf({
    key: t
  }, e.attr), CM(e.child)));
}
function cl(n) {
  return (e) => /* @__PURE__ */ Fe.createElement(xJ, zf({
    attr: Vf({}, n.attr)
  }, e), CM(n.child));
}
function xJ(n) {
  var e = (t) => {
    var {
      attr: r,
      size: i,
      title: s
    } = n, o = mJ(n, pJ), a = i || t.size || "1em", c;
    return t.className && (c = t.className), n.className && (c = (c ? c + " " : "") + n.className), /* @__PURE__ */ Fe.createElement("svg", zf({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, r, o, {
      className: c,
      style: Vf(Vf({
        color: n.color || t.color
      }, t.style), n.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), s && /* @__PURE__ */ Fe.createElement("title", null, s), n.children);
  };
  return o1 !== void 0 ? /* @__PURE__ */ Fe.createElement(o1.Consumer, null, (t) => e(t)) : e(TM);
}
function SJ(n) {
  return cl({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" }, child: [] }] })(n);
}
function wJ(n) {
  return cl({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" }, child: [] }] })(n);
}
function EJ(n) {
  return cl({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" }, child: [] }] })(n);
}
function AJ(n) {
  return cl({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m7 10 5 5 5-5z" }, child: [] }] })(n);
}
function TJ(n) {
  return cl({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m7 14 5-5 5 5z" }, child: [] }] })(n);
}
function CJ(n) {
  return cl({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }, child: [] }] })(n);
}
function yQ({
  comments: n,
  currentUserId: e,
  onCreateComment: t,
  onUpdateComment: r,
  onDeleteComment: i,
  loading: s = !1
}) {
  const [o, a] = wt(null), [c, u] = wt(null), [f, h] = wt(null);
  St(() => {
    if (n.length === 0) return;
    const w = decodeURIComponent(window.location.hash.slice(1));
    w.startsWith("comment-") && requestAnimationFrame(() => {
      var C;
      (C = document.getElementById(w)) == null || C.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }, [n.length]);
  const p = async (w, C) => {
    h(`reply-${w}`);
    try {
      await t(C, w), a(null);
    } finally {
      h(null);
    }
  }, g = async (w, C) => {
    h(`edit-${w}`);
    try {
      await r(w, C), u(null);
    } finally {
      h(null);
    }
  }, y = async (w) => {
    if (window.confirm("정말 삭제하시겠습니까?")) {
      h(`delete-${w}`);
      try {
        await i(w);
      } finally {
        h(null);
      }
    }
  }, x = (w) => {
    const C = new Date(w);
    return `${C.toLocaleDateString("ko-KR")} ${C.toLocaleTimeString("ko-KR", {
      hour: "2-digit",
      minute: "2-digit"
    })}`;
  }, S = (w, C = !1) => {
    const T = e && w.user.id === e, k = c === w.id, R = o === w.id, P = f == null ? void 0 : f.includes(w.id);
    return /* @__PURE__ */ b.jsxs(
      at,
      {
        id: `comment-${w.id}`,
        gap: "xs",
        style: { width: "100%", scrollMarginTop: "96px" },
        children: [
          /* @__PURE__ */ b.jsxs(je, { justify: "space-between", align: "flex-start", wrap: "nowrap", children: [
            /* @__PURE__ */ b.jsxs(je, { gap: "sm", align: "center", wrap: "nowrap", children: [
              /* @__PURE__ */ b.jsx(
                dy,
                {
                  src: w.user.profileImage,
                  alt: w.user.name,
                  radius: "xl",
                  size: C ? "sm" : "md",
                  color: "blue",
                  children: w.user.name.slice(0, 2)
                }
              ),
              /* @__PURE__ */ b.jsxs("div", { children: [
                /* @__PURE__ */ b.jsxs(je, { gap: "xs", align: "center", children: [
                  /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 600, children: w.user.name }),
                  T && /* @__PURE__ */ b.jsx(
                    ae,
                    {
                      size: "10px",
                      bg: "blue.1",
                      c: "blue.7",
                      px: "xs",
                      style: { borderRadius: "10px", fontWeight: 700 },
                      children: "작성자"
                    }
                  )
                ] }),
                /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "dimmed", children: x(w.createdAt) })
              ] })
            ] }),
            !w.isDeleted && T && !k && /* @__PURE__ */ b.jsxs(Tt, { shadow: "md", width: 110, position: "bottom-end", children: [
              /* @__PURE__ */ b.jsx(Tt.Target, { children: /* @__PURE__ */ b.jsx(hi, { variant: "subtle", color: "gray", size: "sm", loading: P, children: /* @__PURE__ */ b.jsx(CJ, { size: 16 }) }) }),
              /* @__PURE__ */ b.jsxs(Tt.Dropdown, { children: [
                /* @__PURE__ */ b.jsx(
                  Tt.Item,
                  {
                    leftSection: /* @__PURE__ */ b.jsx(EJ, { size: 14 }),
                    onClick: () => u(w.id),
                    children: "수정"
                  }
                ),
                /* @__PURE__ */ b.jsx(
                  Tt.Item,
                  {
                    leftSection: /* @__PURE__ */ b.jsx(SJ, { size: 14 }),
                    color: "red",
                    onClick: () => y(w.id),
                    children: "삭제"
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ b.jsx(gt, { pl: C ? "38px" : "46px", pr: "xs", children: k ? /* @__PURE__ */ b.jsx(
            s1,
            {
              initialValue: w.content,
              onSubmit: (L) => g(w.id, L),
              onCancel: () => u(null),
              loading: P,
              autoFocus: !0
            }
          ) : w.isDeleted ? /* @__PURE__ */ b.jsx(ae, { size: "sm", c: "dimmed", fs: "italic", children: "삭제된 댓글입니다." }) : /* @__PURE__ */ b.jsx(ae, { size: "sm", style: { whiteSpace: "pre-wrap", wordBreak: "break-all" }, children: w.content }) }),
          !C && !w.isDeleted && !k && /* @__PURE__ */ b.jsx(je, { gap: "xs", pl: "46px", children: /* @__PURE__ */ b.jsx(
            hn,
            {
              variant: "subtle",
              color: "blue",
              size: "xs",
              leftSection: /* @__PURE__ */ b.jsx(wJ, { size: 14 }),
              onClick: () => a(w.id),
              style: { height: "auto", padding: "4px 8px" },
              children: "답글 달기"
            }
          ) }),
          R && /* @__PURE__ */ b.jsx(gt, { pl: "46px", pr: "xs", mt: "xs", children: /* @__PURE__ */ b.jsx(
            s1,
            {
              placeholder: "답글을 남겨주세요...",
              onSubmit: (L) => p(w.id, L),
              onCancel: () => a(null),
              loading: P,
              autoFocus: !0
            }
          ) })
        ]
      },
      w.id
    );
  };
  return /* @__PURE__ */ b.jsxs(at, { gap: "lg", style: { width: "100%" }, children: [
    n.map((w) => /* @__PURE__ */ b.jsx(er, { withBorder: !1, bg: "transparent", style: { width: "100%" }, children: /* @__PURE__ */ b.jsxs(at, { gap: "md", children: [
      S(w),
      w.replies && w.replies.length > 0 && /* @__PURE__ */ b.jsxs(gt, { style: { paddingLeft: "24px", position: "relative" }, children: [
        /* @__PURE__ */ b.jsx(
          "div",
          {
            style: {
              position: "absolute",
              left: "12px",
              top: "0px",
              bottom: "20px",
              width: "2px",
              backgroundColor: "var(--mantine-color-gray-2)",
              borderRadius: "2px"
            }
          }
        ),
        /* @__PURE__ */ b.jsx(at, { gap: "md", mt: "sm", children: w.replies.map((C) => S(C, !0)) })
      ] }),
      /* @__PURE__ */ b.jsx(L2, { color: "gray.1" })
    ] }) }, w.id)),
    n.length === 0 && !s && /* @__PURE__ */ b.jsx(er, { withBorder: !0, p: "xl", radius: "md", style: { textAlign: "center" }, children: /* @__PURE__ */ b.jsx(ae, { size: "sm", c: "dimmed", children: "등록된 댓글이 없습니다. 첫 번째 댓글을 남겨보세요!" }) })
  ] });
}
const DJ = "_scroll_dji5w_1", RJ = "_table_dji5w_10", Hf = {
  scroll: DJ,
  table: RJ
}, kJ = {
  QUEUED: "접수됨",
  RUNNING: "생성 중",
  SUCCEEDED: "생성 결과 확정",
  FAILED: "생성 실패",
  CANCELLED: "생성 취소",
  TIMED_OUT: "생성 만료"
}, MJ = new Map(
  Object.entries({
    ORGANIZATION_GPU_TIMEOUT: "작업 제한 시간이 지났습니다.",
    ORGANIZATION_GPU_CANCELLED: "생성 요청을 취소했습니다.",
    ORGANIZATION_GPU_INTERRUPTED: "GPU 작업이 중단되었습니다.",
    ORGANIZATION_GPU_EXECUTION_FAILED: "GPU가 최종 실행 실패를 반환했습니다."
  })
), l1 = (n) => !n || !Number.isFinite(Date.parse(n)) ? "미확인" : `${new Intl.DateTimeFormat("ko-KR", { timeZone: "Asia/Seoul", dateStyle: "medium", timeStyle: "medium" }).format(new Date(n))} KST`;
function vQ({
  app: n,
  state: e,
  job: t,
  refreshing: r,
  onRefresh: i
}) {
  var u;
  const s = e === "ready" && (t == null ? void 0 : t.app) === n ? t : void 0, o = s ? Array.from(
    { length: s.input.duration },
    (f, h) => new Date(Date.parse(`${s.input.startDayString}T00:00:00Z`) + h * 864e5).toISOString().slice(0, 10)
  ) : [], a = new Map((u = s == null ? void 0 : s.workShiftLabels) == null ? void 0 : u.map((f) => [f.id, f.symbol])), c = new Map(
    s == null ? void 0 : s.input.workShiftIds.map((f, h) => [
      f,
      a.get(f) || `근무 타입 ${h + 1}`
    ])
  );
  return /* @__PURE__ */ b.jsx(uy, { size: "xl", py: "xl", children: /* @__PURE__ */ b.jsxs(at, { children: [
    /* @__PURE__ */ b.jsx(Ya, { order: 1, children: "생성 작업 상세" }),
    /* @__PURE__ */ b.jsx(ae, { children: "이 작업의 생성 상태와 확정된 결과를 확인합니다. 이 화면에서 표를 수정하거나 새로 생성하지 않습니다." }),
    /* @__PURE__ */ b.jsxs(je, { children: [
      /* @__PURE__ */ b.jsx(hn, { component: "a", href: n === "dashboard" ? "/" : "/home", variant: "subtle", children: "홈으로" }),
      i && e !== "invalid" && /* @__PURE__ */ b.jsx(hn, { variant: "light", loading: r, onClick: i, children: "작업 다시 조회" })
    ] }),
    e === "invalid" ? /* @__PURE__ */ b.jsx(Us, { color: "red", title: "작업 주소를 확인해 주세요", children: "올바르지 않은 생성 작업 주소입니다." }) : e === "error" ? /* @__PURE__ */ b.jsx(Us, { color: "red", title: "작업을 불러오지 못했습니다", children: "요청한 계정인지 확인해 주세요. 권한이 없거나 보관 기간이 지난 작업은 표시하지 않습니다. 연결 문제라면 같은 작업을 다시 조회해 주세요." }) : s ? /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
      /* @__PURE__ */ b.jsx(er, { withBorder: !0, p: "md", children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
        /* @__PURE__ */ b.jsx(on, { children: kJ[s.status] }),
        /* @__PURE__ */ b.jsxs(ae, { children: [
          "작업 번호: ",
          s.id
        ] }),
        /* @__PURE__ */ b.jsxs(ae, { children: [
          "접수: ",
          l1(s.createdAt)
        ] }),
        /* @__PURE__ */ b.jsxs(ae, { children: [
          "최종 처리: ",
          l1(s.finishedAt)
        ] }),
        /* @__PURE__ */ b.jsxs(ae, { children: [
          "대상: ",
          s.input.startDayString,
          "부터 ",
          s.input.duration,
          "일 ·",
          " ",
          s.input.nurseIds.length,
          "명"
        ] }),
        /* @__PURE__ */ b.jsx(ae, { children: "대상 번호는 신청 당시 선택한 순서입니다. 신청 당시 이름을 저장하지 않아 이름을 추정하지 않습니다." }),
        s.status === "SUCCEEDED" ? /* @__PURE__ */ b.jsx(ae, { children: "생성 결과가 확정되었습니다. 표 저장·적용과 수동 요청 최종 승인은 별도입니다." }) : s.errorCode && /* @__PURE__ */ b.jsx(ae, { children: MJ.get(s.errorCode) ?? "원인 확인이 필요합니다. 작업 번호와 함께 문의해 주세요." }),
        s.input.sourceRequestId && n === "backoffice" && /* @__PURE__ */ b.jsx(
          hn,
          {
            component: "a",
            variant: "light",
            href: `/duty-requests/${encodeURIComponent(s.input.sourceRequestId)}#duty-response-${encodeURIComponent(s.input.sourceResponseId ?? "")}`,
            children: "원본 수동 요청 보기"
          }
        )
      ] }) }),
      s.status === "SUCCEEDED" && s.result && /* @__PURE__ */ b.jsxs(b.Fragment, { children: [
        /* @__PURE__ */ b.jsx(Ya, { order: 2, children: "이 작업의 생성 결과" }),
        /* @__PURE__ */ b.jsxs(ae, { children: [
          "검토 경고 ",
          s.result.warningCount,
          "건",
          s.result.warningsTruncated ? " · 일부 경고만 표시됩니다." : ""
        ] }),
        s.result.history && /* @__PURE__ */ b.jsxs(ae, { children: [
          "이전 근무 ",
          s.result.history.dayCount,
          "일 참조 ·",
          " ",
          s.result.history.complete ? "이력 확인됨" : `이력 ${s.result.history.missingAssignments}칸 미확인`,
          ". 점수는 이전 이력을 포함한 전체 기간 기준입니다."
        ] }),
        /* @__PURE__ */ b.jsx("section", { className: Hf.scroll, "aria-label": "생성 결과 가로 스크롤", tabIndex: 0, children: /* @__PURE__ */ b.jsxs("table", { className: Hf.table, children: [
          /* @__PURE__ */ b.jsx("caption", { children: "신청 당시 대상 순서로 표시한 생성 결과" }),
          /* @__PURE__ */ b.jsx("thead", { children: /* @__PURE__ */ b.jsxs("tr", { children: [
            /* @__PURE__ */ b.jsx("th", { scope: "col", children: "대상" }),
            o.map((f) => /* @__PURE__ */ b.jsx("th", { scope: "col", children: f }, f))
          ] }) }),
          /* @__PURE__ */ b.jsx("tbody", { children: s.input.nurseIds.map((f, h) => /* @__PURE__ */ b.jsxs("tr", { children: [
            /* @__PURE__ */ b.jsxs("th", { scope: "row", children: [
              "대상 ",
              h + 1
            ] }),
            o.map((p) => {
              var y;
              const g = Object.entries(((y = s.result) == null ? void 0 : y.schedule[p]) ?? {}).filter(([, x]) => x.includes(f)).map(([x]) => c.get(x) ?? "근무 타입 미확인");
              return /* @__PURE__ */ b.jsx("td", { children: g.length ? g.join(" / ") : "미배정" }, p);
            })
          ] }, f)) })
        ] }) }),
        !s.workShiftLabels && /* @__PURE__ */ b.jsx(Us, { color: "orange", children: "신청 당시 근무 기호를 확인할 수 없어 선택 순서의 번호로 표시합니다." }),
        /* @__PURE__ */ b.jsxs("details", { children: [
          /* @__PURE__ */ b.jsx("summary", { children: "대상 식별번호 보기" }),
          s.input.nurseIds.map((f, h) => /* @__PURE__ */ b.jsxs(ae, { size: "sm", children: [
            "대상 ",
            h + 1,
            ": ",
            f
          ] }, f))
        ] }),
        s.result.warnings.map((f, h) => /* @__PURE__ */ b.jsxs(ae, { size: "sm", children: [
          f.dayString,
          ":",
          " ",
          f.code === "staffing" ? "필요 인원 검토" : "근무 조건 검토",
          f.nurseId ? ` · 대상 ${s.input.nurseIds.indexOf(f.nurseId) + 1}` : ""
        ] }, `${f.code}:${h}`))
      ] })
    ] }) : /* @__PURE__ */ b.jsx(ae, { role: "status", children: "생성 작업을 불러오고 있습니다." })
  ] }) });
}
function bQ({
  summary: n
}) {
  if (!(n != null && n.entries.length)) return null;
  const e = n.entries.some((r) => r.status !== "complete"), t = n.entries.some(
    (r) => r.status === "complete" || r.status === "incomplete"
  );
  return /* @__PURE__ */ b.jsx(Us, { title: "이전 근무 이력 안내", color: e ? "orange" : "blue", children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
    n.entries.some((r) => r.status !== "unavailable") && /* @__PURE__ */ b.jsx(ae, { size: "sm", children: "새 근무표는 정상적으로 생성되었습니다. 아래 안내는 생성 시작일 이전의 근무 기록에 관한 내용이며, 생성 실패나 새 근무표의 누락을 의미하지 않습니다." }),
    n.entries.slice(0, 10).map((r, i) => {
      var s;
      return /* @__PURE__ */ b.jsxs(ae, { size: "sm", children: [
        r.startDayString,
        "부터 ",
        r.duration,
        "일:",
        " ",
        r.status === "complete" ? `시작 전 ${r.historyDays}일의 이전 근무 이력을 반영했습니다.` : r.status === "incomplete" ? `시작 전 ${r.historyDays}일의 이전 근무 기록 중 ${(s = r.missingAssignments) == null ? void 0 : s.toLocaleString("ko-KR")}칸이 없어, 확인 가능한 기록만 반영했습니다. 이전 기간과 이어지는 연속 근무 등은 완전히 검사할 수 없습니다.` : r.status === "independent" ? "생성 시작 전 이전 근무 이력은 계산에 포함되지 않았습니다. 이전 기간과의 연결을 별도로 확인해 주세요." : "이전 근무 반영 여부와 점수 범위를 확인할 수 없습니다. 결과 적용 전 다시 확인해 주세요."
      ] }, `${r.startDayString}:${i}`);
    }),
    n.entries.length > 10 && /* @__PURE__ */ b.jsxs(ae, { size: "xs", children: [
      "나머지 ",
      n.entries.length - 10,
      "개 기간의 안내는 생략했습니다."
    ] }),
    t && /* @__PURE__ */ b.jsx(ae, { size: "sm", children: "점수는 확인 가능한 이전 근무 기록과 새로 생성한 기간을 함께 평가한 값입니다. 이전 기록의 반영 범위가 다른 결과끼리는 점수를 직접 비교하지 마세요." })
  ] }) });
}
function xQ({
  failureId: n,
  onRetry: e,
  retryDisabled: t = !1,
  preservationMessage: r = "입력한 명단과 근무 조건을 보존했습니다."
}) {
  const [i, s] = wt(null);
  return /* @__PURE__ */ b.jsx(
    f1,
    {
      opened: n !== null && n !== i,
      onClose: () => s(n),
      title: "근무표 생성 실패",
      centered: !0,
      children: /* @__PURE__ */ b.jsxs(at, { children: [
        /* @__PURE__ */ b.jsx(ae, { role: "alert", children: "작업을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요." }),
        /* @__PURE__ */ b.jsx(ae, { size: "sm", children: r }),
        /* @__PURE__ */ b.jsxs(je, { justify: "flex-end", children: [
          /* @__PURE__ */ b.jsx(hn, { variant: "default", onClick: () => s(n), children: "닫기" }),
          /* @__PURE__ */ b.jsx(
            hn,
            {
              disabled: t,
              onClick: () => {
                t || (s(n), e());
              },
              children: "같은 조건으로 다시 시도"
            }
          )
        ] })
      ] })
    }
  );
}
function SQ(n) {
  const e = n.version ?? n.generation, t = e ? Array.from(
    {
      length: new Date(
        Date.UTC(
          Number(e.input.month.slice(0, 4)),
          Number(e.input.month.slice(5, 7)),
          0
        )
      ).getUTCDate()
    },
    (a, c) => `${e.input.month}-${String(c + 1).padStart(2, "0")}`
  ) : [], r = new Map(e == null ? void 0 : e.cells.map((a) => [`${a.nurseId}:${a.date}`, a])), i = new Map(e == null ? void 0 : e.input.workShifts.map((a) => [a.id, a])), s = (e == null ? void 0 : e.issues.filter((a) => a.severity === "ERROR")) ?? [], o = (e == null ? void 0 : e.issues.filter((a) => a.severity === "WARNING")) ?? [];
  return /* @__PURE__ */ b.jsxs(at, { children: [
    /* @__PURE__ */ b.jsxs(ae, { children: [
      n.version ? `내용 버전 ${n.version.revision} · ${n.version.completedAt ? "완료본" : "미완료 초안"}` : "검증된 생성 결과 · 읽기 전용",
      " ",
      "· 미배정 ",
      e.cells.filter((a) => !a.workShiftId).length,
      "개"
    ] }),
    /* @__PURE__ */ b.jsx(er, { withBorder: !0, p: "md", children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
      /* @__PURE__ */ b.jsx(Ya, { order: 2, children: "저장된 근무타입" }),
      /* @__PURE__ */ b.jsx(je, { children: e.input.workShifts.map((a) => /* @__PURE__ */ b.jsxs(
        ae,
        {
          style: { borderLeft: `4px solid ${a.color}`, paddingLeft: 8 },
          children: [
            a.name,
            " (",
            a.symbol,
            ")",
            a.kind !== "OFF" && ` · ${String(Math.floor((a.startMinute ?? 0) / 60)).padStart(2, "0")}:${String((a.startMinute ?? 0) % 60).padStart(2, "0")}~${a.endsNextDay ? "다음 날 " : ""}${String(Math.floor((a.endMinute ?? 0) / 60)).padStart(2, "0")}:${String((a.endMinute ?? 0) % 60).padStart(2, "0")}`
          ]
        },
        a.id
      )) })
    ] }) }),
    /* @__PURE__ */ b.jsx("section", { className: Hf.scroll, "aria-label": "월간 근무표 가로 스크롤", tabIndex: 0, children: /* @__PURE__ */ b.jsxs("table", { className: Hf.table, children: [
      /* @__PURE__ */ b.jsxs("caption", { children: [
        e.input.month,
        " ",
        n.version ? "저장된 근무표" : "생성 결과 근무표"
      ] }),
      /* @__PURE__ */ b.jsx("thead", { children: /* @__PURE__ */ b.jsxs("tr", { children: [
        /* @__PURE__ */ b.jsx("th", { scope: "col", children: "가상 간호사" }),
        t.map((a) => /* @__PURE__ */ b.jsxs("th", { scope: "col", children: [
          Number(a.slice(-2)),
          "일"
        ] }, a))
      ] }) }),
      /* @__PURE__ */ b.jsx("tbody", { children: e.input.nurses.map((a) => {
        var c;
        return /* @__PURE__ */ b.jsxs("tr", { children: [
          /* @__PURE__ */ b.jsxs("th", { scope: "row", children: [
            a.name,
            /* @__PURE__ */ b.jsxs("small", { children: [
              ((c = a.position) == null ? void 0 : c.name) ?? "직급 없음",
              " · 경력 ",
              a.careerMonthsAtMonth,
              "개월"
            ] })
          ] }),
          t.map((u) => {
            const f = r.get(`${a.id}:${u}`), h = f != null && f.workShiftId ? i.get(f.workShiftId) : void 0;
            return /* @__PURE__ */ b.jsxs("td", { children: [
              /* @__PURE__ */ b.jsx("span", { children: (h == null ? void 0 : h.symbol) ?? "미배정" }),
              (f == null ? void 0 : f.fixed) && /* @__PURE__ */ b.jsx("small", { children: "고정" })
            ] }, u);
          })
        ] }, a.id);
      }) })
    ] }) }),
    /* @__PURE__ */ b.jsx(er, { withBorder: !0, p: "md", children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
      /* @__PURE__ */ b.jsx(Ya, { order: 2, children: "검토 결과" }),
      /* @__PURE__ */ b.jsxs(ae, { children: [
        "구조 오류 ",
        s.length,
        "개 · 경고 ",
        o.length,
        "개"
      ] }),
      /* @__PURE__ */ b.jsx(ae, { size: "sm", children: "근무 규칙이나 인원 경고는 사용자 배정을 자동으로 바꾸지 않습니다." }),
      e.issues.map((a, c) => {
        var u;
        return /* @__PURE__ */ b.jsxs(ae, { size: "sm", children: [
          a.severity === "ERROR" ? "오류" : "경고",
          ": ",
          a.message,
          (u = a.dates) != null && u.length ? ` (${a.dates.join(", ")})` : ""
        ] }, `${a.code}:${c}`);
      })
    ] }) })
  ] });
}
const c1 = {
  APPROVED: { color: "green", label: "승인됨" },
  REJECTED: { color: "red", label: "반려됨" },
  PENDING: { color: "yellow", label: "대기중" },
  CANCELED: { color: "gray", label: "취소됨" }
};
function wQ({ status: n }) {
  const e = c1[n] || c1.PENDING;
  return /* @__PURE__ */ b.jsx(on, { color: e.color, children: e.label });
}
const _J = (n) => n ? typeof n == "object" ? n.name || "-" : n : "-", EQ = (n, e) => n ? bt(n).format(e || "YYYY-MM-DD") : "-";
function AQ({ position: n, ...e }) {
  const t = _J(n);
  if (t === "-")
    return /* @__PURE__ */ b.jsx("span", { style: { color: "var(--mantine-color-gray-5)" }, children: "-" });
  const r = ["blue", "teal", "violet", "indigo", "cyan", "grape", "orange", "pink"];
  let i = 0;
  for (let o = 0; o < t.length; o++)
    i = t.charCodeAt(o) + ((i << 5) - i);
  const s = r[Math.abs(i) % r.length];
  return /* @__PURE__ */ b.jsx(on, { color: s, variant: "light", ...e, children: t });
}
function TQ({ companyId: n, ...e }) {
  const { data: t = [], isLoading: r } = x1({
    queryKey: eB.jobPositions.byCompany(n),
    queryFn: () => {
      if (!n) throw new Error("병원 ID가 필요합니다.");
      return X2({ companyId: n });
    },
    enabled: !!n
  }), i = t.map((s) => ({
    value: s.id,
    label: s.name
  }));
  return /* @__PURE__ */ b.jsx(
    fy,
    {
      label: "직책",
      placeholder: r ? "로딩 중..." : "직책 선택",
      disabled: r || !n,
      data: i,
      ...e
    }
  );
}
function CQ({
  nurses: n,
  selectedIds: e,
  isFetching: t,
  onChange: r,
  error: i
}) {
  const s = n.length > 0 && e.length === n.length, o = Vt(() => {
    const f = bt().startOf("day"), h = {};
    for (const p of n) {
      const y = (p.statusPeriods || []).find((S) => {
        const w = bt(S.startDate).startOf("day"), C = bt(S.endDate).startOf("day");
        return (f.isAfter(w) || f.isSame(w, "day")) && (f.isBefore(C) || f.isSame(C, "day"));
      }), x = (y == null ? void 0 : y.status) ?? "ACTIVE";
      if (x !== "ACTIVE") {
        const S = {
          PRE_JOIN: "입사 예정",
          LEAVE: "휴직 중",
          RESIGNED: "퇴사 완료"
        }, w = {
          PRE_JOIN: "blue",
          LEAVE: "yellow",
          RESIGNED: "orange"
        };
        h[p.id] = {
          label: S[x] || "근무 불가",
          color: w[x] || "gray"
        };
      }
    }
    return h;
  }, [n]), a = () => {
    r(n.map((f) => f.id));
  }, c = () => {
    r([]);
  }, u = (f) => {
    e.includes(f) ? r(e.filter((h) => h !== f)) : r([...e, f]);
  };
  return /* @__PURE__ */ b.jsxs(at, { gap: "xs", children: [
    /* @__PURE__ */ b.jsxs(je, { justify: "space-between", align: "center", children: [
      /* @__PURE__ */ b.jsxs(ae, { size: "sm", fw: 500, children: [
        "대상 간호사 (",
        e.length,
        "/",
        n.length,
        ")"
      ] }),
      /* @__PURE__ */ b.jsxs(je, { gap: "xs", children: [
        /* @__PURE__ */ b.jsx(
          hn,
          {
            variant: "light",
            size: "xs",
            onClick: a,
            disabled: s || n.length === 0,
            children: "전체 선택"
          }
        ),
        /* @__PURE__ */ b.jsx(
          hn,
          {
            variant: "subtle",
            color: "gray",
            size: "xs",
            onClick: c,
            disabled: e.length === 0,
            children: "선택 해제"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ b.jsxs(er, { withBorder: !0, radius: "md", children: [
      /* @__PURE__ */ b.jsx(Bc, { h: 300, offsetScrollbars: !0, children: /* @__PURE__ */ b.jsxs(at, { gap: 0, children: [
        n.map((f, h) => {
          var g;
          const p = e.includes(f.id);
          return /* @__PURE__ */ b.jsx(
            Lc,
            {
              type: "button",
              "aria-pressed": p,
              onClick: () => u(f.id),
              style: (y) => ({
                padding: y.spacing.sm,
                cursor: "pointer",
                borderBottom: h !== n.length - 1 ? `${zn(1)} solid ${y.colors.gray[2]}` : void 0,
                backgroundColor: p ? y.colors.blue[0] : "transparent",
                transition: "background-color 0.2s ease",
                width: "100%"
              }),
              children: /* @__PURE__ */ b.jsxs(je, { wrap: "nowrap", children: [
                /* @__PURE__ */ b.jsx(
                  Yl,
                  {
                    checked: p,
                    onChange: () => {
                    },
                    "aria-hidden": "true",
                    tabIndex: -1,
                    style: { pointerEvents: "none" }
                  }
                ),
                /* @__PURE__ */ b.jsx(dy, { radius: "xl", color: "blue", src: null, alt: f.user.name, children: f.user.name.slice(0, 1) }),
                /* @__PURE__ */ b.jsxs("div", { style: { flex: 1 }, children: [
                  /* @__PURE__ */ b.jsxs(je, { gap: "xs", align: "center", children: [
                    /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 500, children: f.user.name }),
                    (o == null ? void 0 : o[f.id]) && /* @__PURE__ */ b.jsx(on, { size: "xs", color: o[f.id].color, variant: "light", children: o[f.id].label }),
                    f.preceptorType === "PRECEPTOR" && /* @__PURE__ */ b.jsx(on, { size: "xs", color: "blue", variant: "light", children: "프리셉터" }),
                    f.preceptorType === "PRECEPEE" && /* @__PURE__ */ b.jsx(on, { size: "xs", color: "teal", variant: "light", children: "프리셉티" })
                  ] }),
                  /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "dimmed", children: ((g = f.position) == null ? void 0 : g.name) || "-" })
                ] })
              ] })
            },
            f.id
          );
        }),
        n.length === 0 && /* @__PURE__ */ b.jsx(gt, { p: "xl", ta: "center", children: /* @__PURE__ */ b.jsx(ae, { c: "dimmed", size: "sm", children: "표시할 간호사가 없습니다." }) })
      ] }) }),
      /* @__PURE__ */ b.jsx(Wf, { visible: t })
    ] }),
    i && /* @__PURE__ */ b.jsx(ae, { c: "red", size: "xs", children: i })
  ] });
}
function DQ({ value: n, onChange: e, ...t }) {
  return /* @__PURE__ */ b.jsx(
    fy,
    {
      value: n || "NONE",
      onChange: (r) => e == null ? void 0 : e(r),
      data: [
        { value: "NONE", label: "일반" },
        { value: "PRECEPTOR", label: "프리셉터" },
        { value: "PRECEPEE", label: "프리셉티" }
      ],
      ...t
    }
  );
}
function RQ({ role: n, ...e }) {
  let t = "gray", r = n;
  return n === "SUPER_ADMIN" ? (t = "red", r = "최고 관리자") : n === "HOSPITAL_ADMIN" ? (t = "blue", r = "병원 관리자") : n === "TEAM_ADMIN" ? (t = "cyan", r = "팀 관리자") : n === "NORMAL_USER" && (t = "gray", r = "일반 사용자"), /* @__PURE__ */ b.jsx(on, { color: t, variant: "light", ...e, children: r });
}
const OJ = "_bounce_1296f_1", IJ = {
  bounce: OJ
}, kQ = (n) => {
  const { workShift: e, isSelected: t, disabled: r, onClick: i } = n;
  return /* @__PURE__ */ b.jsx(ss, { label: (e == null ? void 0 : e.name) || "", disabled: !e, withArrow: !0, hidden: r, children: /* @__PURE__ */ b.jsx(
    gt,
    {
      className: t ? IJ.bounce : void 0,
      w: 22,
      h: 22,
      mx: "auto",
      onClick: r ? void 0 : i,
      style: {
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: (e == null ? void 0 : e.color) || void 0,
        color: "white",
        textShadow: "0 1px 1px rgba(0,0,0,0.3)",
        border: "1px solid var(--mantine-color-gray-3)",
        transition: "transform 0.1s",
        opacity: r ? 0.4 : 1,
        cursor: r ? "not-allowed" : i ? "pointer" : "default",
        zIndex: r ? void 0 : 2
      },
      children: /* @__PURE__ */ b.jsx(ae, { size: "xs", span: !0, children: (e == null ? void 0 : e.symbol.charAt(0)) || "-" })
    }
  ) });
}, NJ = ["일", "월", "화", "수", "목", "금", "토"], MQ = "duty-requirements-table", _Q = ({
  tableRef: n,
  workShifts: e,
  startDate: t,
  endDate: r,
  requirements: i,
  onRequirementsChange: s
}) => {
  const o = bt(t).startOf("month"), a = bt(r).endOf("month"), c = Array.from({ length: a.diff(o, "day") + 1 }, () => 0);
  return /* @__PURE__ */ b.jsxs(er, { shadow: "sm", radius: "md", withBorder: !0, bg: "white", children: [
    /* @__PURE__ */ b.jsx(
      gt,
      {
        px: "md",
        py: "sm",
        bg: "gray.0",
        style: {
          borderBottom: "1px solid var(--mantine-color-gray-3)",
          borderTopLeftRadius: "var(--mantine-radius-md)",
          borderTopRightRadius: "var(--mantine-radius-md)"
        },
        children: /* @__PURE__ */ b.jsxs(ae, { size: "sm", fw: 600, c: "gray.9", children: [
          o.format("YYYY년 MM월"),
          " 근무 인원수 설정"
        ] })
      }
    ),
    /* @__PURE__ */ b.jsx(Bc, { children: /* @__PURE__ */ b.jsxs(
      Je,
      {
        className: ["duty-requirements-table"].join(" "),
        ref: n,
        withTableBorder: !0,
        withColumnBorders: !0,
        style: { borderTop: "none", borderBottom: "none" },
        children: [
          /* @__PURE__ */ b.jsx(Je.Thead, { bg: "gray.0", children: /* @__PURE__ */ b.jsxs(Je.Tr, { children: [
            /* @__PURE__ */ b.jsx(
              Je.Th,
              {
                w: 100,
                style: {
                  position: "sticky",
                  left: 0,
                  zIndex: 1,
                  backgroundColor: "var(--mantine-color-gray-0)",
                  boxShadow: "2px 0 4px rgba(0,0,0,0.05)"
                },
                children: /* @__PURE__ */ b.jsx(ae, { size: "xs", fw: 500, c: "gray.7", children: "근무" })
              }
            ),
            c.map((u, f) => {
              const h = o.add(f, "day"), p = h.day() === 0 ? "sun" : h.day() === 6 ? "sat" : null, g = p ? p === "sat" ? "var(--mantine-color-blue-0)" : "var(--mantine-color-red-1)" : "transparent", y = p ? p === "sat" ? "var(--mantine-color-blue-7)" : "var(--mantine-color-red-8)" : "var(--mantine-color-gray-7)";
              return /* @__PURE__ */ b.jsx(
                Je.Th,
                {
                  p: 4,
                  bg: g,
                  style: {
                    textAlign: "center",
                    minWidth: zn(40)
                  },
                  children: /* @__PURE__ */ b.jsxs(at, { gap: 0, align: "center", children: [
                    /* @__PURE__ */ b.jsx(ae, { size: "xs", fw: 700, c: y, children: h.date() }),
                    /* @__PURE__ */ b.jsx(ae, { size: zn(9), c: y, fw: "normal", children: NJ[h.day()] })
                  ] })
                },
                h.toISOString()
              );
            })
          ] }) }),
          /* @__PURE__ */ b.jsx(Je.Tbody, { bg: "white", children: e.map((u) => /* @__PURE__ */ b.jsxs(Je.Tr, { children: [
            /* @__PURE__ */ b.jsx(
              Je.Td,
              {
                p: zn(8),
                style: {
                  position: "sticky",
                  left: 0,
                  zIndex: 1,
                  backgroundColor: "white",
                  boxShadow: "2px 0 4px rgba(0,0,0,0.05)",
                  borderRight: "1px solid var(--mantine-color-gray-3)"
                },
                children: /* @__PURE__ */ b.jsxs(je, { justify: "space-between", gap: "xs", wrap: "nowrap", children: [
                  /* @__PURE__ */ b.jsxs(Um, { gap: 6, align: "center", children: [
                    /* @__PURE__ */ b.jsx(B2, { color: u.color || "#FFF", size: 10, withShadow: !1 }),
                    /* @__PURE__ */ b.jsx(ae, { size: "xs", fw: 700, children: u.symbol })
                  ] }),
                  /* @__PURE__ */ b.jsxs(Um, { gap: 2, align: "center", children: [
                    /* @__PURE__ */ b.jsx(ss, { label: "전체 +1", openDelay: 500, children: /* @__PURE__ */ b.jsx(
                      hi,
                      {
                        size: "xs",
                        variant: "subtle",
                        color: "gray",
                        onClick: () => {
                          var f;
                          s({
                            ...i,
                            [u.id]: {
                              dailyRequirements: [
                                ...((f = i[u.id]) == null ? void 0 : f.dailyRequirements) || []
                              ].map((h) => h + 1)
                            }
                          });
                        },
                        children: /* @__PURE__ */ b.jsx(TJ, { size: 12 })
                      }
                    ) }),
                    /* @__PURE__ */ b.jsx(ss, { label: "전체 -1", openDelay: 500, children: /* @__PURE__ */ b.jsx(
                      hi,
                      {
                        size: "xs",
                        variant: "subtle",
                        color: "gray",
                        onClick: () => {
                          var f;
                          s({
                            ...i,
                            [u.id]: {
                              dailyRequirements: [
                                ...((f = i[u.id]) == null ? void 0 : f.dailyRequirements) || []
                              ].map((h) => Math.max(0, h - 1))
                            }
                          });
                        },
                        children: /* @__PURE__ */ b.jsx(AJ, { size: 12 })
                      }
                    ) })
                  ] })
                ] })
              }
            ),
            c.map((f, h) => {
              var w;
              const p = ((w = i[u.id]) == null ? void 0 : w.dailyRequirements[h]) || 0, g = o.add(h, "day"), y = g.day() === 0 ? "sun" : g.day() === 6 ? "sat" : null, x = y ? y === "sat" ? "var(--mantine-color-blue-0)" : "var(--mantine-color-red-1)" : "transparent", S = y ? y === "sat" ? "var(--mantine-color-blue-7)" : "var(--mantine-color-red-8)" : "var(--mantine-color-gray-7)";
              return /* @__PURE__ */ b.jsx(Je.Td, { p: 2, bg: x, children: /* @__PURE__ */ b.jsx(
                h1,
                {
                  value: p,
                  onChange: (C) => {
                    var T;
                    s({
                      ...i,
                      [u.id]: {
                        dailyRequirements: [
                          ...((T = i[u.id]) == null ? void 0 : T.dailyRequirements) || []
                        ]
                      }
                    });
                  },
                  min: 0,
                  c: S,
                  allowNegative: !1,
                  hideControls: !0,
                  variant: "unstyled",
                  styles: {
                    input: {
                      textAlign: "center",
                      fontSize: "0.75rem",
                      // text-xs
                      height: zn(24),
                      minHeight: zn(24),
                      padding: 0,
                      backgroundColor: "transparent",
                      border: "1px solid transparent",
                      borderRadius: "4px",
                      transition: "border-color 0.2s, background-color 0.2s"
                    }
                  }
                }
              ) }, g.toISOString());
            })
          ] }, u.id)) })
        ]
      }
    ) }),
    /* @__PURE__ */ b.jsx(
      gt,
      {
        px: "md",
        py: "xs",
        bg: "gray.0",
        style: {
          borderTop: "1px solid var(--mantine-color-gray-3)",
          borderBottomLeftRadius: "var(--mantine-radius-md)",
          borderBottomRightRadius: "var(--mantine-radius-md)"
        },
        children: /* @__PURE__ */ b.jsxs(je, { justify: "space-between", children: [
          /* @__PURE__ */ b.jsxs(ae, { size: "xs", c: "gray.6", children: [
            /* @__PURE__ */ b.jsx(ae, { span: !0, fw: 600, children: "사용법:" }),
            " ",
            "↑↓ 전체 조정, 각 셀 직접 입력 가능"
          ] }),
          /* @__PURE__ */ b.jsx(ae, { size: "xs", c: "gray.5", children: "주말: 파란색 배경" })
        ] })
      }
    )
  ] });
};
function OQ({ status: n, ...e }) {
  switch (n) {
    case "APPROVED":
      return /* @__PURE__ */ b.jsx(on, { color: "green", ...e, children: "승인" });
    case "REJECTED":
      return /* @__PURE__ */ b.jsx(on, { color: "red", ...e, children: "거절" });
    case "PENDING":
      return /* @__PURE__ */ b.jsx(on, { color: "gray", ...e, children: "미확인" });
    case "CANCELED":
      return /* @__PURE__ */ b.jsx(on, { color: "gray", variant: "outline", ...e, children: "취소" });
    default:
      return /* @__PURE__ */ b.jsx(on, { color: "gray", ...e, children: n });
  }
}
function IQ({
  workShifts: n,
  value: e = [],
  onChange: t,
  label: r = "근무 가능 타입 선택",
  description: i,
  error: s
}) {
  const o = (a) => {
    t && (e.includes(a) ? t(e.filter((c) => c !== a)) : t([...e, a]));
  };
  return /* @__PURE__ */ b.jsx(fc.Wrapper, { label: r, description: i, error: s, children: /* @__PURE__ */ b.jsx(j2, { cols: { base: 1, xs: 2, sm: 3 }, spacing: "sm", mt: "xs", children: n.map((a) => {
    const c = e.includes(a.id), u = a.color || "#bfbfbf";
    return /* @__PURE__ */ b.jsx(
      er,
      {
        withBorder: !0,
        p: "sm",
        radius: "md",
        onClick: () => o(a.id),
        style: {
          cursor: "pointer",
          transition: "all 0.2s ease",
          borderColor: c ? u : "var(--mantine-color-gray-3)",
          borderWidth: c ? "2px" : "1px",
          padding: c ? "11px" : "12px",
          // maintain same outer size
          backgroundColor: c ? `${u}08` : "white",
          // Soft color background
          boxShadow: c ? `0 0 0 1px ${u}` : "none"
        },
        onMouseEnter: (f) => {
          f.currentTarget.style.transform = "translateY(-2px)", f.currentTarget.style.boxShadow = "var(--mantine-shadow-xs)";
        },
        onMouseLeave: (f) => {
          f.currentTarget.style.transform = "none", f.currentTarget.style.boxShadow = c ? `0 0 0 1px ${u}` : "none";
        },
        children: /* @__PURE__ */ b.jsxs(je, { justify: "space-between", wrap: "nowrap", children: [
          /* @__PURE__ */ b.jsxs(je, { gap: "xs", wrap: "nowrap", children: [
            /* @__PURE__ */ b.jsx(
              "div",
              {
                style: {
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: u,
                  flexShrink: 0
                }
              }
            ),
            /* @__PURE__ */ b.jsx(
              "div",
              {
                style: {
                  backgroundColor: c ? u : "var(--mantine-color-gray-1)",
                  color: c ? "white" : "var(--mantine-color-gray-7)",
                  width: 24,
                  height: 24,
                  borderRadius: 6,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: 700,
                  flexShrink: 0,
                  transition: "all 0.2s ease"
                },
                children: a.symbol
              }
            ),
            /* @__PURE__ */ b.jsx(at, { gap: 0, children: /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 600, style: { lineHeight: 1.2 }, children: a.name }) })
          ] }),
          /* @__PURE__ */ b.jsx(
            "div",
            {
              style: {
                width: 20,
                height: 20,
                borderRadius: "50%",
                border: `1.5px solid ${c ? u : "var(--mantine-color-gray-4)"}`,
                backgroundColor: c ? u : "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                transition: "all 0.15s ease"
              },
              children: c && /* @__PURE__ */ b.jsx(Hy, { size: 12, strokeWidth: 3 })
            }
          )
        ] })
      },
      a.id
    );
  }) }) });
}
function PJ({
  value: n,
  onChange: e,
  teamId: t,
  label: r = "근무 가능한 근무 유형",
  description: i = "선택된 근무 유형만 근무표 생성 시 배정됩니다.",
  error: s,
  disabled: o = !1,
  style: a,
  className: c,
  loading: u
}) {
  const {
    data: f = [],
    isLoading: h,
    isFetching: p
  } = x1({
    queryKey: ["workShifts", t],
    queryFn: () => tB({ teamId: t }),
    enabled: !!t
  }), g = p, y = u !== void 0 ? u : h, x = n || [], S = f.length > 0 && x.length === f.length, w = (k) => {
    e && (x.includes(k) ? e(x.filter((R) => R !== k)) : e([...x, k]));
  }, C = () => {
    e && e(f.map((k) => k.id));
  }, T = () => {
    e && e([]);
  };
  return /* @__PURE__ */ b.jsx(
    fc.Wrapper,
    {
      label: r,
      description: i,
      error: s,
      style: a,
      className: c,
      children: /* @__PURE__ */ b.jsxs(at, { gap: "xs", mt: "xs", children: [
        /* @__PURE__ */ b.jsxs(je, { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ b.jsxs(ae, { size: "xs", c: "dimmed", children: [
            "선택됨: ",
            x.length,
            "개 / 전체: ",
            f.length,
            "개"
          ] }),
          /* @__PURE__ */ b.jsxs(je, { gap: "xs", children: [
            /* @__PURE__ */ b.jsx(
              hn,
              {
                variant: "light",
                size: "xs",
                styles: {
                  root: {
                    height: zn(24),
                    paddingLeft: zn(8),
                    paddingRight: zn(8),
                    fontSize: zn(11)
                  }
                },
                onClick: C,
                disabled: S || f.length === 0 || o,
                children: "전체 선택"
              }
            ),
            /* @__PURE__ */ b.jsx(
              hn,
              {
                variant: "subtle",
                color: "gray",
                size: "xs",
                styles: {
                  root: {
                    height: zn(24),
                    paddingLeft: zn(8),
                    paddingRight: zn(8),
                    fontSize: zn(11)
                  }
                },
                onClick: T,
                disabled: x.length === 0 || o,
                children: "선택 해제"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ b.jsxs(er, { withBorder: !0, radius: "md", style: { position: "relative", overflow: "hidden" }, children: [
          /* @__PURE__ */ b.jsx(Bc, { h: 200, offsetScrollbars: !0, p: 0, children: /* @__PURE__ */ b.jsxs(at, { gap: 0, children: [
            f.map((k, R) => {
              const P = x.includes(k.id);
              return /* @__PURE__ */ b.jsx(
                gt,
                {
                  onClick: () => !o && w(k.id),
                  style: (L) => ({
                    padding: L.spacing.sm,
                    cursor: o ? "not-allowed" : "pointer",
                    borderBottom: R !== f.length - 1 ? `${zn(1)} solid ${L.colors.gray[2]}` : void 0,
                    backgroundColor: P ? L.colors.blue[0] : "transparent",
                    opacity: o ? 0.6 : 1,
                    transition: "background-color 0.2s ease"
                  }),
                  children: /* @__PURE__ */ b.jsxs(je, { wrap: "nowrap", children: [
                    /* @__PURE__ */ b.jsx(
                      Yl,
                      {
                        checked: P,
                        onChange: () => {
                        },
                        tabIndex: -1,
                        disabled: o,
                        style: { pointerEvents: "none" }
                      }
                    ),
                    /* @__PURE__ */ b.jsxs(je, { gap: "xs", style: { flex: 1 }, children: [
                      /* @__PURE__ */ b.jsx(
                        on,
                        {
                          color: k.color ?? "gray",
                          variant: "light",
                          style: { minWidth: zn(48) },
                          children: k.symbol
                        }
                      ),
                      /* @__PURE__ */ b.jsx(ae, { size: "sm", fw: 500, children: k.name }),
                      k.isOff && /* @__PURE__ */ b.jsx(on, { size: "xs", color: "gray", variant: "outline", children: "휴무" })
                    ] })
                  ] })
                },
                k.id
              );
            }),
            f.length === 0 && !y && /* @__PURE__ */ b.jsx(gt, { p: "xl", ta: "center", children: /* @__PURE__ */ b.jsx(ae, { c: "dimmed", size: "sm", children: "표시할 근무 형태가 없습니다." }) })
          ] }) }),
          /* @__PURE__ */ b.jsx(Wf, { visible: y || g, overlayProps: { blur: 1 } })
        ] })
      ] })
    }
  );
}
PJ.displayName = "WorkShiftSelect";
function NQ() {
  const n = fn((r) => {
    const i = r.modalId || `modal-${Math.random().toString(36).substring(2, 9)}`;
    return Ep.open({
      modalId: i,
      centered: !0,
      closeOnClickOutside: !1,
      closeOnEscape: !1,
      ...r
    }), i;
  }, []), e = fn((r) => {
    Ep.close(r);
  }, []), t = fn(() => {
    Ep.closeAll();
  }, []);
  return {
    open: n,
    close: e,
    closeAll: t
  };
}
function PQ(n) {
  return /* @__PURE__ */ b.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 16 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ b.jsx("path", { d: "M12.8228 9.99849C12.8624 11.7589 14.4069 12.9272 14.4663 12.9668C14.4465 13.0658 14.2089 13.9767 13.6347 14.8282C13.1396 15.5411 12.605 16.2737 11.7535 16.2935C10.902 16.3133 10.6248 15.7787 9.65451 15.7787C8.66444 15.7787 8.36742 16.2737 7.55557 16.3133C6.70411 16.3331 6.09026 15.6203 5.59523 14.8876C4.58536 13.3826 3.8131 11.0857 4.88237 9.18664C5.417 8.23618 6.36748 7.64214 7.43676 7.62234C8.24861 7.60254 9.02087 8.19658 9.5357 8.19658C9.99113 8.19658 10.9614 7.50353 11.9515 7.58274C12.3674 7.60254 13.5158 7.74115 14.3673 9.02823C14.2881 9.06783 12.7832 10.0579 12.8228 9.99849Z" }),
        /* @__PURE__ */ b.jsx("path", { d: "M10.7436 5.8601C11.199 5.26606 11.4961 4.49381 11.3971 3.66216C10.6842 3.68196 9.81295 4.15719 9.31792 4.77103C8.88229 5.30566 8.52587 6.13732 8.64468 6.90956C9.43674 6.96896 10.2882 6.45414 10.7436 5.8601Z" })
      ]
    }
  );
}
function LQ(n) {
  return /* @__PURE__ */ b.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z",
            fill: "#4285F4"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z",
            fill: "#34A853"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z",
            fill: "#FBBC05"
          }
        ),
        /* @__PURE__ */ b.jsx(
          "path",
          {
            d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z",
            fill: "#EA4335"
          }
        )
      ]
    }
  );
}
const BQ = (n) => {
  const e = bt(n), t = bt(), r = t.diff(e, "hour"), i = t.diff(e, "minute");
  return r >= 0 && r < 24 ? r > 0 ? `${r}시간 전` : i > 0 ? `${i}분 전` : "방금 전" : e.format("YYYY-MM-DD HH:mm:ss");
}, LJ = new TextEncoder();
function jQ(n) {
  return String(n ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function FQ(n) {
  if (!n) return "FFFFFFFF";
  const e = n.trim().replace(/^#/, "");
  return /^[0-9a-f]{3}$/i.test(e) ? `FF${e.split("").map((t) => t + t).join("").toUpperCase()}` : /^[0-9a-f]{6}$/i.test(e) ? `FF${e.toUpperCase()}` : /^[0-9a-f]{8}$/i.test(e) ? e.toUpperCase() : "FFFFFFFF";
}
function zQ(n) {
  let e = "", t = n;
  for (; t > 0; ) {
    const r = (t - 1) % 26;
    e = String.fromCharCode(65 + r) + e, t = Math.floor((t - 1) / 26);
  }
  return e;
}
const BJ = (() => {
  const n = new Uint32Array(256);
  for (let e = 0; e < 256; e += 1) {
    let t = e;
    for (let r = 0; r < 8; r += 1)
      t = t & 1 ? 3988292384 ^ t >>> 1 : t >>> 1;
    n[e] = t >>> 0;
  }
  return n;
})();
function jJ(n) {
  let e = 4294967295;
  for (const t of n)
    e = BJ[(e ^ t) & 255] ^ e >>> 8;
  return (e ^ 4294967295) >>> 0;
}
function VQ(n) {
  const e = [], t = [];
  let r = 0;
  for (const f of n) {
    const h = LJ.encode(f.name), p = jJ(f.data), g = new Uint8Array(30 + h.length), y = new DataView(g.buffer);
    y.setUint32(0, 67324752, !0), y.setUint16(4, 20, !0), y.setUint16(6, 2048, !0), y.setUint16(8, 0, !0), y.setUint32(14, p, !0), y.setUint32(18, f.data.length, !0), y.setUint32(22, f.data.length, !0), y.setUint16(26, h.length, !0), g.set(h, 30), e.push(g, f.data);
    const x = new Uint8Array(46 + h.length), S = new DataView(x.buffer);
    S.setUint32(0, 33639248, !0), S.setUint16(4, 20, !0), S.setUint16(6, 20, !0), S.setUint16(8, 2048, !0), S.setUint16(10, 0, !0), S.setUint32(16, p, !0), S.setUint32(20, f.data.length, !0), S.setUint32(24, f.data.length, !0), S.setUint16(28, h.length, !0), S.setUint32(42, r, !0), x.set(h, 46), t.push(x), r += g.length + f.data.length;
  }
  const i = t.reduce((f, h) => f + h.length, 0), s = new Uint8Array(22), o = new DataView(s.buffer);
  o.setUint32(0, 101010256, !0), o.setUint16(8, n.length, !0), o.setUint16(10, n.length, !0), o.setUint32(12, i, !0), o.setUint32(16, r, !0);
  const a = e.reduce((f, h) => f + h.length, 0) + i + s.length, c = new Uint8Array(a);
  let u = 0;
  for (const f of [...e, ...t, s])
    c.set(f, u), u += f.length;
  return c;
}
export {
  XJ as AnalyticsTracker,
  PQ as AppleIcon,
  eQ as AuthGuard,
  IQ as AvailableWorkShiftSelector,
  $Q as Button,
  y6 as DtSelect,
  mQ as DutyEditor,
  kQ as DutyIndicator,
  wQ as DutyRequestBadge,
  _Q as DutyRequirementsCalendar,
  gQ as DutyRequirementsEditor,
  MQ as DutyRequirementsTableId,
  s1 as DutyResponseCommentEditor,
  yQ as DutyResponseCommentList,
  JJ as DutyScheduleCalendar,
  nQ as ErrorBoundary,
  yR as ErrorPage,
  xQ as GenerationFailureNotice,
  LQ as GoogleIcon,
  Z7 as LoadingOverlayProvider,
  qQ as MonthPickerInput,
  AQ as NursePositionBadge,
  TQ as NursePositionSelect,
  CQ as NurseSelect,
  vQ as OrganizationGenerationJobDetails,
  bQ as OrganizationGpuHistoryNotice,
  DQ as PreceptorTypeSelect,
  SQ as ProScheduleSnapshot,
  iQ as ProfileImageEdit,
  sQ as RichEditor,
  RQ as RoleBadge,
  rQ as RouteErrorBoundary,
  oQ as SafeHtml,
  aQ as TableContainer,
  lQ as TermsConsentModal,
  KQ as TimeInput,
  cQ as TitleContainer,
  uQ as TurnstileWidget,
  fQ as UikitProvider,
  OQ as WantedStatusBadge,
  hQ as WorkShiftBadge,
  PJ as WorkShiftSelect,
  pQ as WorkShiftSymbol,
  VQ as createZip,
  i1 as dutyonTheme,
  jQ as escapeXml,
  EQ as formatDate,
  zQ as getColumnName,
  AM as getDayStyles,
  Ri as getNurseStatusOnDate,
  _J as getPositionName,
  BQ as getRelativeOrFormattedDate,
  QJ as initGA,
  FQ as normalizeArgbColor,
  ZJ as trackDutyAutoGeneration,
  HW as trackEvent,
  WW as trackPageView,
  dQ as useLoader,
  xM as useLoaderState,
  NQ as useModal
};
//# sourceMappingURL=index.es.js.map
